webpackJsonp([0,9],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);




var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_accounting__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__js_common_rb_timer__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(0);










/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['betLang', 'sportTableLang', 'sportAllBetLang', 'account', 'highlightedCell', 'parlaySelected', 'showFavEvents'])),
  data: function data() {
    return {
      allDate: '99',
      todayDate: '0',
      teamA: 'oddsa',
      teamB: 'oddsb',
      teamHome: 'h',
      teamAway: 'a',
      teamDraw: 'd',
      ftPlyType: '1',
      firstHtPlyType: '2',
      setHandicapPlyType: '3',
      pointHdpPlyType: '4',
      iotPlyType: '5',
      gameHdpPlyType: '6',
      firstSetPlyType: '7',
      secondSetPlyType: '8',
      thirdSetPlyType: '9',
      fourthSetPlyType: '10',
      fifthSetPlyType: '11',
      sixthSetPlyType: '12',
      game1PlyType: '14',
      game2PlyType: '15',
      game3PlyType: '16',
      game4PlyType: '17',
      game5PlyType: '18',
      SecondHtPlyType: '19',
      first5InningsPlayType: '13',
      first3InningsPlayType: '20',
      firstInningsPlayType: '21',
      secondInningsPlayType: '22',
      thirdInningsPlayType: '23',
      fourthInningsPlayType: '24',
      fifthInningsPlayType: '25',
      sixthInningsPlayType: '26',
      seventhInningsPlayType: '27',
      eightthInningsPlayType: '28',
      nineInningsPlayType: '29',
      OTPlayType: '30',
      hdpBetType: '1',
      ouBetType: '2',
      oeBetType: '3',
      onex2BetType: '4',
      tgBetType: '5',
      htftBetType: '6',
      csBetType: '7',
      rhdpBetType: '8',
      rouBetType: '9',
      roeBetType: '10',
      ronex2BetType: '11',
      mlBetType: '12',
      rmlBetType: '13',
      otrBetType: '14',
      mulpBetType: '15',
      rcsBetType: '16',
      rhtftBetType: '17',
      rtgBetType: '18',
      dbchBetType: '19',
      rdbchBetType: '20',
      parlayBetType: '5',
      rbettype: ['8', '9', '10', '11', '13', '16', '17', '18', '20', '27', '29', '31', '33', '35', '37', '39', '41', '43', '45', '47', '49', '51', '55', '56', '58', '61', '64', '66', '69', '71', '73', '78', '79', '81', '83'],
      oddTypeBettype: ['1', '2', '3', '8', '9', '10', '46', '47', '48', '49', '80', '81', '82', '83'],
      osCommon: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      portBettypeList: window.sportBettypeList,
      h1x2BetType: '21',
      wdBetType: '25',
      rh1x2BetType: '27',
      hmgBetType: '28',
      rhmgBetType: '29',
      hmg1x2BetType: '30',
      rhmg1x2BetType: '31',
      bttsBetType: '32',
      rbttsBetType: '33',
      cshBetType: '34',
      rcshBetType: '35',
      twnBetType: '36',
      rtwnBetType: '37',
      twfbBetType: '38',
      rtwfbBetType: '39',
      twehBetType: '40',
      rtwehBetType: '41',
      twbhBetType: '42',
      rtwbhBetType: '43',
      tsbhBetType: '44',
      rtsbhBetType: '45',
      htgBetType: '46',
      rhtgBetType: '47',
      atgBetType: '48',
      ratgBetType: '49',
      wmBetType: '50',
      rwmBetType: '51',
      flgBetType: '52',
      hldsBetType: '53',
      aldsBetType: '54',
      rhldsBetType: '55',
      raldsBetType: '56',
      moreRBBetTab: ['16', '66', '70'],
      moreBetTab: ['7', '65', '71', '74'],
      subMatchHeight: 70,
      commonMatchHeight: 105,
      moreBetHeight: 32,
      betComboMax: window.betComboMax,
      allowComboBet: window.allowComboBet,
      allBetComboAmount: '',
      rbBetTypeList: ['8', '9', '10', '11', '13', '16', '17', '18', '20', '27', '29', '31', '33', '35', '37', '39', '41', '43', '45', '47', '49', '51', '55', '56', '58', '61', '64', '66', '69', '71', '73', '78', '79', '81', '83'],
      pendingTimerId: null,
      wgSuccess: ['0', '2'],
      wgNotsuccessreject: ['0', '-1', '2'],
      wgSts: ['0', '1', '2'],
      keyboardAllow: {
        min: true,
        med: true,
        big: true,
        big2: true,
        big3: true
      },
      nogBetType: '57',
      rnogBetType: '58',
      ouoeBetType: '59',
      oubttsBetType: '60',
      roubttsBetType: '61',
      ouftsBetType: '62',
      onex2ouBetType: '63',
      ronex2ouBetType: '64',
      onex2bttsBetType: '65',
      ronex2bttsBetType: '66',
      onex2ftsBetType: '67',
      dbchouBetType: '68',
      rdbchouBetType: '69',
      dbchbttsBetType: '70',
      rdbchbttsBetType: '71',
      dbchftsBetType: '72',
      rouoeBetType: '73',
      edgBetType: '74',
      exiBetType: '76',
      wmrBetType: '77',
      rwmrBetType: '78',
      rexiBetType: '79',
      htrBetType: '80',
      rhtrBetType: '81',
      atrBetType: '82',
      ratrBetType: '83'
    };
  },

  methods: {
    setbetComboKeyboard: function setbetComboKeyboard(key) {
      if (parseInt(this.$store.getters.account.currCL) < parseInt(this.$store.getters.betComboAmount[key].value.replace(",", ""))) {
        var xarr = {
          index: key,
          amount: __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(this.$store.getters.account.currCL, 0),
          clear: false
        };
        this.betComboAmount = xarr;
      }

      if (this.betFormList.length == 1 && this.$store.getters.account.rememberStake) {
        var a = parseInt(this.$store.getters.betComboAmount[0].value.replace(",", ""));
        this.usualStakeAmount = a;
      }

      var remainingBal = this.$store.getters.account.currCL - parseInt(this.$store.getters.betComboAmount[key].value.replace(",", ""));
      this.setKeyboardSettings(key, remainingBal);
    },
    setKeyboardSettings: function setKeyboardSettings(key, remainingBal) {
      var betAmtOpt = this.$store.getters.betting.betAmountOption;
      var karr = { index: key, settings: { min: true, med: true, big: true, big2: true, big3: true } };
      var arr = key == '-1' ? this.keyboardAllow : karr.settings;

      this.$set(arr, 'big3', remainingBal < betAmtOpt.big3 ? false : true);
      this.$set(arr, 'big2', remainingBal < betAmtOpt.big2 ? false : true);
      this.$set(arr, 'big', remainingBal < betAmtOpt.big ? false : true);
      this.$set(arr, 'med', remainingBal < betAmtOpt.med ? false : true);
      this.$set(arr, 'min', remainingBal < betAmtOpt.min ? false : true);

      if (this.$store.getters.isBetCombo) {
        this.betComboKeyboardAllow = karr;
      }
    },
    setALLbetComboAmount: function setALLbetComboAmount() {
      var VUE = this;
      var fixedAccountingNumber = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(VUE.allBetComboAmount, 0);
      var res = VUE.allBetComboAmount == 0 ? "" : this.commasAmount(fixedAccountingNumber);

      $.each(VUE.betFormList, function (id, data) {
        var arr = {
          index: id,
          amount: __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(VUE.allBetComboAmount, 0),
          clear: false
        };
        VUE.betComboAmount = arr;

        var remainingBal = VUE.$store.getters.account.currCL - parseInt(VUE.$store.getters.betComboAmount[id].value.replace(",", ""));
        VUE.setKeyboardSettings(id, remainingBal);
      });

      VUE.allBetComboAmount = res;

      var remainingBalALL = this.$store.getters.account.currCL - parseInt(res.replace(",", ""));
      this.setKeyboardSettings('-1', remainingBalALL);
    },
    setbetComboAmount: function setbetComboAmount(comboAmount, key) {
      var arr = {
        index: key,
        amount: __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(comboAmount[key], 0)
      };
    },
    clearALLbetComboAmount: function clearALLbetComboAmount() {
      var VUE = this;
      VUE.allBetComboAmount = '';
    },
    checkAllowKeyboard: function checkAllowKeyboard(data, keyAllow, key, obj) {
      var r = false;
      var errCodeAllowKeyboard = ['4003-N', '4010-N'];

      if (this.$store.getters.isBetCombo) {
        if (key != 'all' && this.$store.getters.betComboAmount[key].value != '' && (!_.isUndefined(data.error) || !this.$store.getters.betComboKeyboardAllow[key][obj])) {
          if (!_.isUndefined(data.error) && !_.isUndefined(data.error.code) && errCodeAllowKeyboard.indexOf(data.error.code) !== -1) {
            r = false;
          } else {
            r = true;
          }
        } else if (key == 'all' && !keyAllow) {
          r = true;
        }
      } else if (!this.$store.getters.isBetCombo && !keyAllow) {
        r = true;
      }
      return r;
    },
    betPossiblePayout: function betPossiblePayout() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var oddValue = '';
      var amount = 0;

      if (key != null && this.$store.getters.betComboAmount[key] && this.$store.getters.betComboAmount.length != 0) {
        var betOdd = parseFloat(this.$store.getters.betForm[key].odd);
        var amt = this.$store.getters.betComboAmount[key].value;

        oddValue = betOdd < 0 && (this.$store.getters.account.oddsType == 'my' || this.$store.getters.account.oddsType == 'in') ? 1 : this.validateOddBetType(this.$store.getters.betForm[key].betType, this.$store.getters.betForm[key].odd);
        amount += Number(amt) * oddValue;
      } else {
        var amt = 0;

        if (this.$store.getters.betComboAmount.length != 0) {
          for (var index = 0; index < this.betFormList.length; index++) {
            var _betOdd = this.betFormList[index].odd;
            if (this.$store.getters.betComboAmount[index]) {
              amt = this.$store.getters.betComboAmount[index].value.replace(",", "");
            }

            oddValue = _betOdd < 0 && (this.$store.getters.account.oddsType == 'my' || this.$store.getters.account.oddsType == 'in') ? 1 : this.validateOddBetType(this.$store.getters.betForm[index].betType, this.$store.getters.betForm[index].odd);
            amount += Number(amt) * oddValue;
          }
        }
      }
      return amount;
    },
    betFormHeight: function betFormHeight() {
      var bb = 0;

      if (this.$store.getters.selectedBettype.betTypId == "5") {
        var parent = document.querySelectorAll('#cbetmixinfo > .bet-mix-item-card');
        parent.forEach(function (child, index) {
          bb += child.offsetHeight;
        });

        var heightx = bb + 187;
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.betForm).length >= this.$store.getters.betting.minMax.minCombo) {
          heightx += document.getElementById('bet_input_defaut_one').offsetHeight;
        }
        if (document.getElementById('betmixcard') != null) {
          heightx += document.getElementById('betmixcard').offsetHeight;
        }
      } else {
        var _parent = document.querySelectorAll('#singleContainer > .bet-single-item-card');
        var success = [];
        if (this.$store.getters.betting.betcombosuccess) {
          _parent = document.querySelectorAll('#singleContainer > .bet-single-record');
          success = document.querySelectorAll('.bet-success-order');
        }

        _parent.forEach(function (child, index) {
          bb += child.offsetHeight;
        });
        if (_parent.length > 5) {
          bb += 30;
        }

        if (document.getElementById('betModeZone') != null) {
          bb += document.getElementById('betModeZone').offsetHeight;
        }
        if (document.getElementById('betMultiple') != null) {
          bb += document.getElementById('betMultiple').offsetHeight;
        }
        if (success.length > 0) {
          bb += success[0].offsetHeight;
        }
        if (document.getElementById('scrollFooter') != null) {
          bb += document.getElementById('scrollFooter').offsetHeight;
        }
        var heightx = bb;
      }

      if (document.getElementById('betviewScroll') != null) {
        document.getElementById('betviewScroll').style.height = heightx + 'px';
      }
    },
    updateHightlightOdds: function updateHightlightOdds() {
      var vue = this;
      var bet_form = this.$store.getters.betForm;
      $('div.c-bet-item').removeClass('active');
      bet_form.forEach(function (bet_data, id) {
        var MID = bet_data.uniqueId ? bet_data.uniqueId : '';
        if (MID != '') {
          vue.oddSelectHighlight(MID, bet_data);
        }
      });
    },
    oddSelectHighlight: function oddSelectHighlight(windowEve, bet_form) {
      var MID = (typeof windowEve === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(windowEve)) == 'object' ? $(windowEve.target).closest('div[id]')[0].id : windowEve;
      if (!this.$store.getters.isBetParlay && !this.$store.getters.isBetCombo) {
        $('div.c-bet-item').removeClass('active');
      } else if (this.$store.getters.selectedBettype.betTypId == '5' || this.$store.getters.isBetParlay) {
        var _parent2 = document.querySelectorAll('#cmatch' + bet_form.eveid);
        _parent2.forEach(function (child, index) {
          var chk = child.querySelector('.c-bet-item.active');
          if (chk != null) {
            chk.classList.remove("active");
          }
        });
        $("[id=" + MID + "]").closest('.c-bet-item.active').removeClass('active');

        var allBetArr = ['ab', 'firstEvent'];
        allBetArr.forEach(function (arrData, id) {
          var allBetparent = document.querySelectorAll('#' + arrData + 'allBetGroup' + bet_form.eveid);
          allBetparent.forEach(function (childAllBet, indexAb) {
            var allBetchk = childAllBet.querySelector('.c-bet-item.active');
            if (allBetchk != null) {
              allBetchk.classList.remove("active");
            }
          });
        });

        if (this.$store.getters.open_RBMarket) {
          var eveIds = _.map(this.$store.getters.betForm, 'eveid');
          if (!(eveIds.indexOf(bet_form.eveid) !== -1)) {
            eveIds.push(bet_form.eveid);
          }
          var activeEl = document.querySelectorAll('.c-match-handicap .c-bet-item.active');
          activeEl.forEach(function (el) {
            var parent = el.closest('[id*="cmatch"]');
            if (parent) {
              var eid = parent.id.replace('cmatch', '');
              if (!(eveIds.indexOf(Number(eid)) !== -1)) {
                var rmtargets = document.querySelectorAll('#' + parent.id + ' .c-bet-item.active');
                rmtargets.forEach(function (rmtarget) {
                  rmtarget.classList.remove("active");
                });

                allBetArr.forEach(function (arrData, id) {
                  var allBetrmtargets = document.querySelectorAll('#' + arrData + 'allBetGroup' + eid + ' .c-bet-item.active');
                  allBetrmtargets.forEach(function (allBetrmtarget) {
                    allBetrmtarget.classList.remove("active");
                  });
                });
              }
            }
          });
        }
      } else if (this.$store.getters.isBetCombo) {
        if (this.$store.getters.betting.betcombosuccess) {
          $('div.c-bet-item.yb-family-odds').removeClass('active');
        }
        var index = _.findIndex(this.$store.getters.betForm, {
          'eveid': bet_form.eveid,
          'plyType': bet_form.plyType,
          'betType': bet_form.betType,
          'dual': bet_form.dual
        });
        if (index >= 0) {
          var rmItemID = '';


          var _parent3 = document.querySelectorAll('#handicapCol' + bet_form.eveid + bet_form.betType + bet_form.plyType + bet_form.dual);
          _parent3.forEach(function (child, index) {
            var chk = child.querySelector('.c-bet-item.active');
            if (chk != null) {
              chk.classList.remove("active");
              rmItemID = chk.querySelector('.odds').id;
            }
          });

          var btTemp = [this.csBetType, this.rcsBetType, this.onex2bttsBetType, this.ronex2bttsBetType, this.dbchbttsBetType, this.rdbchbttsBetType];
          if (btTemp.indexOf(bet_form.betType) !== -1) {
            var parentClass = 'morebetcs';
            var betClass = '.bet-cs-' + bet_form.plyType;
            if ([this.onex2bttsBetType, this.ronex2bttsBetType, this.dbchbttsBetType, this.rdbchbttsBetType].indexOf(bet_form.betType) !== -1) {
              parentClass = 'morebetdual';
              betClass = '.bet-1x2btts';
              if ([this.dbchbttsBetType, this.rdbchbttsBetType].indexOf(bet_form.betType) !== -1) {
                betClass = '.bet-dbchbtts';
              }
            }
            var parentCs = document.querySelectorAll('#cmatch' + bet_form.eveid + '.' + parentClass);
            parentCs.forEach(function (child, index) {
              var chk = child.querySelector('.c-bet-item' + betClass + '.active');
              if (chk != null) {
                chk.classList.remove("active");
                rmItemID = chk.querySelector('.odds').id;
              }
            });
          }

          var allBetTarget = $('#aballBetGroup' + bet_form.eveid + ' #' + bet_form.uniqueId);
          if (allBetTarget.length > 0) {
            var _parent3 = '.handicap';
            if (bet_form.betType == this.edgBetType) {
              _parent3 = '.body_EG_' + bet_form.eveid;
            } else if (bet_form.betType == this.wdBetType) {
              _parent3 = '.main-handicap';
            }
            var allBetParent = allBetTarget.closest(_parent3);
            if (allBetParent.length > 0) {
              var allBetRmTarget = allBetParent[0].querySelector('.c-bet-item.active');
              if (allBetRmTarget != null) {
                allBetRmTarget.classList.remove("active");
                rmItemID = allBetRmTarget.querySelector('.odds').id;
              }
            }
          }

          if (rmItemID == '') {
            rmItemID = bet_form.uniqueId;
          }

          if (rmItemID != '') {
            var firstEventParent = $('#firstEventallBetGroup' + bet_form.eveid + ' #' + rmItemID);
            if (firstEventParent.length > 0) {
              if ([this.csBetType, this.rcsBetType].indexOf(bet_form.betType) !== -1) {
                var firstEventParent1 = firstEventParent.closest('.handicap-sub-title').parent();
              } else if (bet_form.betType == this.edgBetType) {
                var firstEventParent1 = firstEventParent.closest('.body_EG_' + bet_form.eveid);
              } else if (bet_form.betType == this.wdBetType) {
                var firstEventParent1 = firstEventParent.closest('.main-handicap');
              } else {
                var firstEventParent1 = firstEventParent.closest('.handicap');
              }
              if (firstEventParent1.length > 0) {
                var firstEventTarget = firstEventParent1[0].querySelector('.c-bet-item.active');
                if (firstEventTarget != null) {
                  firstEventTarget.classList.remove("active");
                }
              }
            }
          }

          var indvBt = [this.csBetType, this.rcsBetType, this.tgBetType, this.rtgBetType, this.htftBetType, this.rhtftBetType];
          if (indvBt.indexOf(bet_form.betType) !== -1) {
            var betClass = '.bet-cs-' + bet_form.plyType;
            if ([this.tgBetType, this.rtgBetType, this.htftBetType, this.rhtftBetType].indexOf(bet_form.betType) !== -1) {
              betClass = '.bet-tg-' + bet_form.plyType;
              if ([this.htftBetType, this.rhtftBetType].indexOf(bet_form.betType) !== -1) {
                betClass = '.bet-htft-' + bet_form.plyType;
              }
            }
            var _parentCs = document.querySelectorAll('#cmatch' + bet_form.eveid);
            _parentCs.forEach(function (child, index) {
              var chk = child.querySelector('.c-bet-item' + betClass + '.active');
              if (chk != null) {
                chk.classList.remove("active");
                rmItemID = chk.querySelector('.odds').id;
              }
            });
          }
        }
      }

      $("[id=" + MID + "]").closest('.c-bet-item').addClass('active');
    },
    checkBetComboMax: function checkBetComboMax(bet_form) {
      var index = _.findIndex(this.$store.getters.betForm, {
        'eveid': bet_form.eveid,
        'plyType': bet_form.plyType,
        'betType': bet_form.betType,
        'dual': bet_form.matchId
      });
      if (index < 0) {
        var VUE = this;
        VUE.$store.commit('COMBOBET_EXCEEDLIMIT', true);

        setTimeout(function () {
          VUE.$store.commit('COMBOBET_EXCEEDLIMIT', false);
        }, 5000);
        return true;
      }
    },
    showHideAllBet: function showHideAllBet(key) {
      var expanded = $('#triggertoggle').hasClass('icon-open');

      if (expanded) {
        $('#triggertoggle').removeClass('icon-open');
        $('#triggertoggle').addClass('icon-close');
        $(key).css("display", "none");
      } else {
        $('#triggertoggle').addClass('icon-open');
        $('#triggertoggle').removeClass('icon-close');
        $(key).css("display", "");
      }
    },
    checkMiniBetUnique: function checkMiniBetUnique(event, oddUniqueId) {
      if (this.$store.getters.betForm.length > 0) {
        var plyTyp = this.$store.getters.betForm[0].plyType;
        if (this.$store.getters.betForm[0].uniqueId == oddUniqueId && this.checkEventPlyTypExist(event, plyTyp)) {
          return true;
        }
      }

      return false;
    },
    checkOTRMiniBetUnique: function checkOTRMiniBetUnique(event, oddUniqueId) {
      if (this.$store.getters.betForm.length > 0) {
        var plyTyp = this.$store.getters.betForm[0].plyType;
        if (this.$store.getters.betForm[0].uniqueId == oddUniqueId) {
          return true;
        }
      }

      return false;
    },
    selectCell: function selectCell(event, team) {
      if (this.highlightedCell != this.$refs[team][0]["_uid"]) {
        $('td').removeClass('bg_yellow');
      }
      this.$store.commit('HIGHLIGHT_CELL', this.$refs[team][0]["_uid"]);
      this.$refs[team][0].onClickOdd();
      this.$forceUpdate();
      return;
    },
    highlight: function highlight(team) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$refs).length > 0) {
        if (this.$refs[team].length > 0) {
          if (this.$refs[team][0]["_uid"] == this.highlightedCell) {
            return 'bg_yellow';
          }
        }
        return 'bg_white';
      }
      return 'bg_white';
    },
    isPrior: function isPrior() {
      if (this.event && this.plytyp) {
        if (!_.isUndefined(this.event.prior)) {
          if (this.$store.getters.selectedBettype.sprtId == 'G2') {
            return false;
          } else if (this.event.prior.indexOf(parseInt(this.plytyp)) >= 0) {
            return true;
          }
          return false;
        }
      }
    },
    getplytype: function getplytype(eventOD) {

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(eventOD)[0];
    },
    getFullTime: function getFullTime(eveod) {
      var pt = this.ftPlyType;
      var arr_pt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(eveod);

      if (arr_pt.length > 0 && $.inArray(this.ftPlyType, arr_pt) > -1) {
        pt = this.ftPlyType;
      } else if (arr_pt.length > 0 && $.inArray(this.setHandicapPlyType, arr_pt) > -1) {
        pt = this.setHandicapPlyType;
      }

      return pt;
    },
    getSubMatchCount: function getSubMatchCount(plyType) {
      var count = 0;

      var noSubMatchBettyp = [this.onex2BetType, this.ronex2BetType, this.mlBetType, this.rmlBetType, this.edgBetType];
      _.forEach(plyType, function (value, bettype) {
        if (noSubMatchBettyp.indexOf(bettype) == -1) {
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(value).length >= count) {
            count = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(value).length;
          }
        } else if (noSubMatchBettyp.indexOf(bettype) >= 0 && count == 0) {
          count = 1;
        }
      });

      return count > 0 ? count : 1;
    },
    getSubMatchCountRow: function getSubMatchCountRow(plyType, sprt) {
      var count = 0;

      var subMatchBettyp = [this.ouBetType, this.rouBetType, this.hdpBetType, this.rhdpBetType];
      _.forEach(plyType, function (btdata, ptid) {
        if (sprt == 1 || sprt > 1 && (ptid == 1 || ptid == 3)) {

          _.forEach(btdata, function (val, btid) {
            if (subMatchBettyp.indexOf(btid) != -1) {
              var b = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(val).length + ' ' + count;
              if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(val).length >= count) {
                count = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(val).length;
              }
            } else if (subMatchBettyp.indexOf(btid) >= 0 && count == 0) {
              count = 1;
            }
          });
        }
      });

      return count;
    },
    checkEventPlyTypExist: function checkEventPlyTypExist(event, plytyp) {
      var isExist = false;
      if (typeof event.od != 'undefined') {
        if (typeof event.od[plytyp] != 'undefined') {
          isExist = true;
        }
      }
      return isExist;
    },
    checkEventPlyTypExist2: function checkEventPlyTypExist2(event) {
      var isExist = false;
      if (typeof event.od != 'undefined') {
        _.forEach(this.osCommon, function (plytype, index) {
          if (typeof event.od[plytype] != 'undefined') {
            isExist = true;
            return false;
          }
        });
        return isExist;
      }
    },
    checkEventPlyTypIndex: function checkEventPlyTypIndex(event, plytyp) {
      var firstindex = false;
      if (typeof event.od != 'undefined') {
        if (typeof event.od[plytyp] != 'undefined') {
          var index = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od).indexOf(plytyp);
          if (index == 0) {
            firstindex = true;
          }
        }
      }
      return firstindex;
    },
    getDecimalDisplay: function getDecimalDisplay(value) {
      if (this.$store.getters.account.oddsType == 'am' && !this.$store.getters.specialEvent) {
        return parseFloat(value).toFixed(0);
      }
      return parseFloat(value).toFixed(2);
    },
    checkOddValidation: function checkOddValidation(value) {
      if (this.$store.getters.account.oddsType == 'am') {
        var pass_value = parseFloat(value);
        if (pass_value < 0) {
          pass_value = Math.abs(100 / pass_value);
        } else {
          pass_value = pass_value / 100;
        }
        pass_value = pass_value.toFixed(3);
        if (pass_value <= 0) {
          return false;
        }
      } else {
        if (parseFloat(value) < 1) {
          return false;
        }
      }

      return true;
    },
    validateOddHdp: function validateOddHdp(args) {
      var ahou = [1, 8, 2, 9, 46, 47, 48, 49, 80, 81, 82, 83];
      var rahrou = [2, 9, 46, 47, 48, 49, 80, 81, 82, 83];
      var oeroe = [3, 10];
      var oddtype1 = ['my', 'in'];
      var oddtype2 = ['hk', 'in', 'eu'];
      if (args.odds == 0) {
        return false;
      }
      if (oddtype1.indexOf(args.oddstype) == -1) {
        if (ahou.indexOf(args.bettype) != -1) {
          if (args.oddstype == 'eu') {
            if (args.odds <= 1) {
              return false;
            }
          } else if (args.oddstype == 'hk') {
            if (args.odds <= 0) {
              return false;
            }
          }
          if (rahrou.indexOf(args.bettype, [2, 9, 46, 47, 48, 49, 80, 81, 82, 83]) != -1) {
            if (args.hdp) {
              if (Math.abs(args.hdp) == 0) {
                return false;
              }
            }
          }
        } else if (oeroe.indexOf(args.bettype) != -1) {
            if (oddtype2.indexOf(args.oddstype) != -1 && args.odds <= 1) {
              return false;
            }
          } else {
            if (args.odds <= 1 && args.oddstype != "am") {
              return false;
            }
          }
      }
      return true;
    },
    validateOddBetType: function validateOddBetType(betTyp, odd) {

      if (this.$store.getters.account.oddsType == 'am') {
        if (odd < 0) {
          odd = Math.abs(100 / odd);
        } else {
          odd = odd / 100;
        }
        odd = odd.toFixed(3);
      } else if ((betTyp == this.ronex2BetType || betTyp == this.onex2BetType || betTyp == this.mlBetType || betTyp == this.rmlBetType || betTyp == this.oeBetType || betTyp == this.roeBetType || betTyp == this.tgBetType || betTyp == this.htftBetType || betTyp == this.csBetType || betTyp == this.otrBetType || betTyp == this.rcsBetType || betTyp == this.rhtftBetType || betTyp == this.rtgBetType || betTyp == this.dbchBetType || betTyp == this.rdbchBetType || betTyp == this.h1x2BetType || betTyp == this.wdBetType || betTyp == this.rh1x2BetType || betTyp == this.hmgBetType || betTyp == this.rhmgBetType || betTyp == this.hmg1x2BetType || betTyp == this.rhmg1x2BetType || betTyp == this.bttsBetType || betTyp == this.rbttsBetType || betTyp == this.cshBetType || betTyp == this.rcshBetType || betTyp == this.twnBetType || betTyp == this.rtwnBetType || betTyp == this.twfbBetType || betTyp == this.rtwfbBetType || betTyp == this.twehBetType || betTyp == this.rtwehBetType || betTyp == this.twbhBetType || betTyp == this.rtwbhBetType || betTyp == this.tsbhBetType || betTyp == this.rtsbhBetType || betTyp == this.wmBetType || betTyp == this.rwmBetType || betTyp == this.flgBetType || betTyp == this.hldsBetType || betTyp == this.aldsBetType || betTyp == this.rhldsBetType || betTyp == this.raldsBetType || betTyp == this.nogBetType || betTyp == this.rnogBetType || betTyp == this.ouoeBetType || betTyp == this.rouoeBetType || betTyp == this.oubttsBetType || betTyp == this.roubttsBetType || betTyp == this.ouftsBetType || betTyp == this.onex2ouBetType || betTyp == this.ronex2ouBetType || betTyp == this.onex2bttsBetType || betTyp == this.ronex2bttsBetType || betTyp == this.onex2ftsBetType || betTyp == this.dcouBetType || betTyp == this.rdcouBetType || betTyp == this.dcbttsBetType || betTyp == this.rdcbttsBetType || betTyp == this.dcftsBetType || betTyp == this.edgBetType || betTyp == this.rwmrBetType || betTyp == this.wmrBetType || betTyp == this.rexiBetType || betTyp == this.exiBetType) && odd > 1) {
        if (betTyp == this.oeBetType || betTyp == this.roeBetType) {
          odd = !this.$store.getters.oddTypesList.IN || this.$store.getters.account.oddsType != this.$store.getters.oddTypesList.IN.key ? odd - 1 : odd;
        } else {
          odd -= 1;
        }
      } else if (this.$store.getters.account.oddsType == this.$store.getters.oddTypesList.EU.key && odd > 1) {
        odd -= 1;
      }
      return odd;
    },
    jsMinMaxValidation: function jsMinMaxValidation(betAmount) {
      var isMulp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var selectedBetAllup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (parseInt(betAmount) > parseFloat(this.account.currCL)) {
        return { errorId: 1, error: true, msg: this.betLang['BETTING.LBL_NO_CREDIT'] };
      } else if (parseInt(betAmount) != 0 && parseInt(betAmount) < this.betting.minMax.min) {
        return { errorId: 2, error: true, msg: this.betLang['BETTING.LBL_WRONG_MIN'] + ' ' + this.betting.minMax.min };
      } else if (parseInt(betAmount) > this.betting.minMax.max) {
        return { errorId: 3, error: true, msg: this.betLang['BETTING.LBL_WRONG_MAX'] + ' ' + this.betting.minMax.max };
      } else if (parseInt(betAmount) == 0) {
        return { errorId: 4, error: true, msg: this.betLang['BETTING.PLEASE_ENTER_STAKE'] };
      }

      if (isMulp && selectedBetAllup != null) {
        var wager = selectedBetAllup.split('x');

        if (parseInt(betAmount) * parseInt(wager[1]) > parseFloat(this.account.currCL)) {
          return { errorId: 4, error: true, msg: this.betLang['BETTING.LBL_NO_CREDIT'] };
        } else if (this.betForm.length < this.betting.minMax.minCombo) {
          var minCombo = this.betLang['BETTING.LBL_WRONG_MIN_COMBO'];
          minCombo = minCombo.replace('{minCombo}', this.betting.minMax.minCombo);
          return { errorId: 5, error: true, msg: minCombo };
        } else if (this.betForm.length > this.betting.minMax.maxCombo) {
          var maxCombo = this.betLang['BETTING.LBL_WRONG_MAX_COMBO'];
          maxCombo = maxCombo.replace('{maxCombo}', this.betting.minMax.maxCombo);
          return { errorId: 6, error: true, msg: maxCombo };
        }
      }
      return { error: false };
    },
    commasAmount: function commasAmount(amount) {
      amount += '';
      var x = amount.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    },
    checkInPly: function checkInPly() {
      if (!this.showFavEvents && this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key || this.$store.getters.selectedMatchAllBet && this.$store.getters.firstEvent && this.$store.getters.firstEvent.rb && this.$store.getters.firstEvent.rbstatus || this.$store.getters.open_RBMarket) {
        this.hdpBetType = _.cloneDeep(this.rhdpBetType);
        this.ouBetType = _.cloneDeep(this.rouBetType);
        this.oeBetType = _.cloneDeep(this.roeBetType);
        this.onex2BetType = _.cloneDeep(this.ronex2BetType);
        this.mlBetType = _.cloneDeep(this.rmlBetType);
        this.htgBetType = _.cloneDeep(this.rhtgBetType);
        this.atgBetType = _.cloneDeep(this.ratgBetType);
        this.bttsBetType = _.cloneDeep(this.rbttsBetType);
        this.wmBetType = _.cloneDeep(this.rwmBetType);
        this.twnBetType = _.cloneDeep(this.rtwnBetType);
        this.twfbBetType = _.cloneDeep(this.rtwfbBetType);
        this.twehBetType = _.cloneDeep(this.rtwehBetType);
        this.twbhBetType = _.cloneDeep(this.rtwbhBetType);
        this.tsbhBetType = _.cloneDeep(this.rtsbhBetType);
        this.cshBetType = _.cloneDeep(this.rcshBetType);
        this.h1x2BetType = _.cloneDeep(this.rh1x2BetType);
        this.hmgBetType = _.cloneDeep(this.rhmgBetType);
        this.hmg1x2BetType = _.cloneDeep(this.rhmg1x2BetType);
        this.hldsBetType = _.cloneDeep(this.rhldsBetType);
        this.aldsBetType = _.cloneDeep(this.raldsBetType);
        this.nogBetType = _.cloneDeep(this.rnogBetType);
        this.oubttsBetType = _.cloneDeep(this.roubttsBetType);
        this.onex2ouBetType = _.cloneDeep(this.ronex2ouBetType);
        this.onex2bttsBetType = _.cloneDeep(this.ronex2bttsBetType);
        this.ouoeBetType = _.cloneDeep(this.rouoeBetType);
        this.dbchouBetType = _.cloneDeep(this.rdbchouBetType);
        this.dbchbttsBetType = _.cloneDeep(this.rdbchbttsBetType);
        this.wmrBetType = _.cloneDeep(this.rwmrBetType);
        this.exiBetType = _.cloneDeep(this.rexiBetType);
        this.htrBetType = _.cloneDeep(this.rhtrBetType);
        this.atrBetType = _.cloneDeep(this.ratrBetType);
      } else {
        this.hdpBetType = '1';
        this.ouBetType = '2';
        this.oeBetType = '3';
        this.onex2BetType = '4';
        this.mlBetType = '12';
        this.htgBetType = '46';
        this.atgBetType = '48';
        this.bttsBetType = '32';
        this.wmBetType = '50';
        this.twnBetType = '36';
        this.twfbBetType = '38';
        this.twehBetType = '40';
        this.twbhBetType = '42';
        this.tsbhBetType = '44';
        this.cshBetType = '34';
        this.h1x2BetType = '21';
        this.hmgBetType = '28';
        this.hmg1x2BetType = '30';
        this.hldsBetType = '53';
        this.aldsBetType = '54';
        this.nogBetType = '57';
        this.ouoeBetType = '59';
        this.oubttsBetType = '60';
        this.onex2ouBetType = '63';
        this.onex2bttsBetType = '65';
        this.dbchouBetType = '68';
        this.dbchbttsBetType = '70';
        this.exiBetType = '76', this.wmrBetType = '77', this.htrBetType = '80', this.atrBetType = '82';
      }
    },
    checkPlayType: function checkPlayType() {
      if (this.$store.getters.selectedBettype.sprtId == 'G1') {
        this.plytyp = this.ftPlyType;
      } else if (this.$store.getters.selectedBettype.sprtId == 'G2') {
        this.plytyp = this.ftPlyType;
      } else if (this.$store.getters.selectedBettype.sprtId == 'N15') {
        this.plytyp = this.ftPlyType;
      } else {
        this.plytyp = this.setHandicapPlyType;
      }
    },
    cancelMiniBet: function cancelMiniBet() {
      var sportMiniBet = this.$store.getters.sportMiniBet;
      sportMiniBet.toggle = false;
      this.$store.commit('SPORT_MINIBET', sportMiniBet);
    },
    showMiniBet: function showMiniBet(windowEvent) {
      var quickbet = ['1', '2', '3', '4', '6', '7', '8'];

      if (!this.$store.getters.selectedAllBet) {
        var tmpltId = this.$store.getters.selectedBettype.tmpltId;

        if (this.$store.getters.sportMiniBet.allow && quickbet.indexOf(tmpltId) !== -1 && this.$store.getters.selectedBettype.betTypId != '5') {
          if (this.checkEventExist() || !this.$store.getters.sportMiniBet.toggle) {
            this.$store.commit('SPORT_MINIBET_TOGGLE', true);
            this.$store.commit('SPORT_MINIBET_WINDOWEVENT', windowEvent);
            __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('SHOW_MINIBET');

            var w = $('#mainArea').width();
            var el = $(windowEvent.target.parentElement).position();
            var p = (w - el.left) / w * 100;
            if (23 > p) {
              this.$store.commit('SPORT_MINIBET_RIGHTSIDE', true);
            } else {
              this.$store.commit('SPORT_MINIBET_RIGHTSIDE', false);
            }
          } else {}
        } else {
          if (this.$store.getters.sportMiniBet.allow) {
            this.$store.commit('SPORT_MINIBET_TOGGLE', true);
            this.$store.commit('SPORT_MINIBET_WINDOWEVENT', windowEvent);
            __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('SHOW_MINIBET');
          }
        }
      }
    },
    showSubMatch: function showSubMatch(subMatchKey, event, smkey) {
      var isRB = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var showSubMatch = false;
      var maxSubMatchOdd = 1;
      if (typeof event.od != 'undefined') {
        if (this.$store.getters.selectedBettype.sprtId != 'N1') {
          showSubMatch = true;
        } else {
          for (var plytyp = 0; plytyp < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od).length; plytyp++) {
            var plytypKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od)[plytyp];
            for (var bettyp = 0; bettyp < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od[plytypKey]).length; bettyp++) {
              var bettypKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od[plytypKey])[bettyp];
              if (bettypKey == this.rhdpBetType || bettypKey == this.hdpBetType || bettypKey == this.rouBetType || bettypKey == this.ouBetType || bettypKey == this.roeBetType || bettypKey == this.oeBetType) {
                var bettypeOddLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od[plytypKey][bettypKey]).length;
                if (bettypeOddLength >= maxSubMatchOdd) {
                  maxSubMatchOdd = bettypeOddLength;
                }
              }
            }
          }
          if (maxSubMatchOdd >= subMatchKey) {
            showSubMatch = true;
          }
        }
      }
      if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key && subMatchKey == 1) {
        showSubMatch = true;
      }

      if (this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key && subMatchKey == 1 && (isRB || isRB == null)) {
        showSubMatch = true;
      }

      return showSubMatch;
    },
    checkEventExist: function checkEventExist() {
      var isExist = false;
      if (this.$store.getters.betForm.length > 0) {
        var events = this.$store.getters.eventList;
        for (var lgIndex = 0; lgIndex < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(events).length; lgIndex++) {
          var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(events)[lgIndex];
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(events[key]) == 'object') {
            for (var eventIndex = 0; eventIndex < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(events[key]).length; eventIndex++) {
              var event = events[key];
              var betFormData = this.$store.getters.betForm[0];
              if (betFormData.eveid == event.eveid) {
                isExist = true;
              }
            }
          } else {
            for (var _eventIndex = 0; _eventIndex < events[key].length; _eventIndex++) {
              var event = events[key][_eventIndex];
              var betFormData = this.$store.getters.betForm[0];
              if (betFormData.eveid == event.eveid) {
                isExist = true;
              }
            }
          }
        }
      }
      return isExist;
    },
    openTv: function openTv(match) {
      var eveid = match.eveid;
      var sprtid = this.$store.getters.selectedBettype.sprtId;
      var lang = window._langid;
      var spread = this.$store.getters.account.spread;
      var odd = this.$store.getters.account.oddsType;
      var schedule = this.$store.getters.selectedMarket;
      var plytypgrp = 1;
      var sptid = match.sptid;
      var chid = match.ch;
      var lgecapt = match.lgecapt;
      var tacapt = match.tacapt;
      var tbcapt = match.tbcapt;
      var date = 0;

      if (sprtid.indexOf('G') >= 0) {
        sprtid = 'N' + match.sptid;
      }

      var url = 'livetv?action=allBet';
      url += '&eveid=' + eveid;
      url += '&sprtid=' + sprtid;
      url += '&lang=' + lang;
      url += '&spread=' + spread;
      url += '&odd=' + odd;
      url += '&schedule=' + schedule;
      url += '&date=' + date;
      url += '&sptid=' + sptid;
      url += '&chid=' + chid;
      url += '&lgecapt=' + lgecapt;
      url += '&tacapt=' + tacapt;
      url += '&tbcapt=' + tbcapt;

      window.windowTv = window.open(url, 'MsgWindow', 'width=1050, height=700');
    },
    validateRBTimer: function validateRBTimer(event) {
      if (event.rbinfo.tlsec == -1) {
        return false;
      }
      var timerMin = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').minutes();
      var timerHour = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').hours();
      if (Object(__WEBPACK_IMPORTED_MODULE_6__js_common_rb_timer__["a" /* validateSpecialRBTimer */])(event, timerHour, timerMin)) {
        return '2';
      } else if (event.rbinfo.htst == '1') {
        return '1';
      } else if (event.rbinfo.htst == '2') {
        return '2';
      }

      return false;
    },
    specialLeagueCaption: function specialLeagueCaption(event, bettype) {
      var retCapt = '';

      if (event.spcapt) {
        retCapt = event.spcapt;
      }


      return retCapt;
    },
    chgBettype: function chgBettype() {
      var selBetType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (selBetType == null) {
        if (this.selectedBettype.sprtId == 'N1') {
          selBetType = '1';
        } else if (this.selectedBettype.sprtId == 'G1') {
          selBetType = '7';
        }
      }
      var bettype = {};
      for (var i = 0; i < this.portBettypeList.length; i += 1) {
        if (this.portBettypeList[i]['sprtId'] === this.selectedBettype.sprtId) {
          if (this.portBettypeList[i]['betTypId'] === selBetType) {
            bettype = this.portBettypeList[i];
          }
        }
      }

      if (this.$store.getters.selectedMarket == '1') {
        this.$store.commit('SELECTEDEARLYPARLAYDATE', this.todayDate);
      } else {
        this.$store.commit('SELECTEDEARLYPARLAYDATE', this.allDate);
      }
      this.$store.commit("GAMEBANNER_SELECTED", false);
      this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
      this.$store.commit('SELECTED_ALLBET', false);
      this.$store.commit('SELECTED_MATCHALLBET', false);
      this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);

      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
      if (bettype) {
        if (bettype.betTypId == '5' && this.$store.getters.sportPrevIsMulp) {
          this.$store.commit('SPORT_PREVIOUS_IS_MULP', true);
        } else {
          this.$store.commit('PARLAY_SELECTED', { update: false });
          this.$store.commit('SPORT_PREVIOUS_IS_MULP', false);
        }
        this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(bettype));
      } else {
        var temp = this.$store.getters.selectedBettype;
        temp.betTypId = null;
        temp.tmpltId = null;
        this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp));
      }
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('sportChange', this.$store.getters.selectedBettype);
    },
    selectWDCell: function selectWDCell(event, team) {
      if (this.highlightedCell != this.$refs[team][0]["_uid"]) {
        $('div').removeClass('bg_yellow');
      }
      this.$store.commit('HIGHLIGHT_CELL', this.$refs[team][0]["_uid"]);
      this.$refs[team][0].onClickOdd();
      this.$forceUpdate();
      return;
    },
    chkMoreBetExist: function chkMoreBetExist(event, isRB) {
      var vue = this;
      var exist = false;
      var arr = isRB ? this.moreRBBetTab : this.moreBetTab;

      _.forEach(event.od, function (ptydata, key) {
        _.forEach(ptydata, function (val, k) {
          if ($.inArray(k, arr) > -1) {
            exist = true;
          }
        });
      });

      if (event.sp) {
        _.forEach(event.sp, function (val, key) {
          if ($.inArray(val.r, ["b", "c"]) > -1) {
            exist = true;
          }
        });
      }

      if (this.$store.getters.simpleSport != null) {
        exist = true;
      }

      return exist;
    },
    eventHeight: function eventHeight(eveData, eCard) {
      var isRB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var subH = 0;
      var subM = 0;
      var card = eCard == 'ecw' ? 5 : 2;
      var exist = this.chkMoreBetExist(eveData, isRB);
      var morebet = exist ? this.moreBetHeight : 0;
      var OSsub = eveData.sub;
      var countSub = this.getSubMatchCountRow(eveData['od'], eveData['sptid']);

      OSsub = countSub - 1;

      if (OSsub > 0 && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(eveData.od).length > 0) {
        subM = OSsub * this.subMatchHeight;
      }
      subH = this.commonMatchHeight + subM + card + morebet;
      if (this.$store.getters.simpleSport != null || this.$store.getters.specialEvent) {
        subH -= subM;
        subH -= 55;
      }

      return 'height: ' + subH + 'px';
    },
    backtoTop: function backtoTop() {
      $('.scroll-inner-wrap').animate({
        scrollTop: $('.wrap-scroll').position().top
      }, 400);
    },
    isUsingPhone: function isUsingPhone() {
      return (/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ? 1 : 0
      );
    },
    setbetMulpKeyboard: function setbetMulpKeyboard(key) {
      var betMulpAmtArr = this.$store.getters.betMulpAmount[key];
      var amount = betMulpAmtArr.value == '' ? 0 : betMulpAmtArr.value.replaceAll(",", "");
      var arr = {
        index: key,
        allUp: betMulpAmtArr.allUp,
        amount: betMulpAmtArr.value == '' ? '' : amount
      };
      this.betMulpAmount = arr;
    },
    totalBet1: function totalBet1(key) {
      var tb = key.split('x');
      return tb.length > 1 ? tb[1] : '0';
    },
    mulpPossiblePayout: function mulpPossiblePayout(arr) {
      var id = arr.index;
      var allUp = arr.allUp;
      var amt = arr.amount;
      var ret = {
        index: id,
        allUp: allUp,
        amount: '',
        stake: '',
        possiblePayout: '',
        maxPay: this.$store.getters.betMulpAmount[id].maxPay
      };
      if (this.isMulp && !_.isUndefined(this.betting.allUpList[id]) && this.betting.allUpList[id].key == allUp && id >= 0 && amt != '' && amt >= 0) {
        ret.amount = amt;
        var allUpKey = this.betting.allUpList[id].key;
        var totalBetSlip = allUpKey.split('x');
        ret.stake = Number(amt) * parseInt(totalBetSlip[1]);

        var retpossiblePayout = 0;
        var oddValue = "";
        var mulpParser = this.betting.allUpList[id].parser.split("#");
        for (var index = 0; index < mulpParser.length; index++) {
          var commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (var comma = 0; comma < commaList.length; comma++) {
            var betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if (this.$store.getters.account.oddsType == 'am') {
              if (betOdd < 0) {
                betOdd = Math.abs(100 / betOdd) + 1;
              } else {
                betOdd = betOdd / 100 + 1;
              }

              betOdd = betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          retpossiblePayout += Number(amt) * oddValue;
        }
        ret.possiblePayout = retpossiblePayout;
      }
      return ret;
    },
    displayMulpPossiblePayout: function displayMulpPossiblePayout(index) {
      return this.betMulpAmount[index].possiblePayout == '' ? 0 : this.betMulpAmount[index].possiblePayout.replaceAll(",", "");
    },
    countMaxOdds: function countMaxOdds(id) {
      var oddValue = "";
      var retpossiblePayout = 0;
      var mulpParser = this.betting.allUpList[id].parser.split("#");
      var oddslist = {};
      for (var index = 0; index < mulpParser.length; index++) {
        var commaList = mulpParser[index].split(",");
        var ttlOdds = 1;
        oddValue = "";
        for (var comma = 0; comma < commaList.length; comma++) {
          var betData = this.$store.getters.betForm[commaList[comma]];
          var betOdd = parseFloat(betData.odd);
          if (this.$store.getters.account.oddsType == 'am') {
            if (betOdd < 0) {
              betOdd = Math.abs(100 / betOdd) + 1;
            } else {
              betOdd = betOdd / 100 + 1;
            }
            betOdd = betOdd.toFixed(3);
          }
          ttlOdds *= betOdd;
        }
        oddValue = ttlOdds - 1;

        if (oddValue > this.betting.minMax.maxOdds) {
          return false;
        }
      }
      return true;
    },
    countTotalStakePayout: function countTotalStakePayout(type) {
      var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var sum = 0;
      if (success) {
        if (this.$store.getters.betting.pending) {
          var dt = this.$store.getters.betting.pending.data && this.$store.getters.betting.pending.data.mulpRes ? this.$store.getters.betting.pending.data.mulpRes : false;
        } else {
          var dt = this.$store.getters.betting.success.data && this.$store.getters.betting.success.data.mulpRes ? this.$store.getters.betting.success.data.mulpRes : false;
        }
        var betMulpAmount = this.$store.getters.betMulpAmtFiltered;
        if (dt != false) {
          $.each(dt, function (id, data) {
            if (data.WagerID != undefined) {
              if (type == 'possiblePayout') {
                var value = betMulpAmount[id].possiblePayout.replaceAll(",", "");
                sum += value == '' ? 0 : Number(value);
              } else if (type == 'totalStake') {
                var value = data.amount ? data.amount : betMulpAmount[id].stake.replaceAll(",", "");
                sum += value == '' ? 0 : Number(value);
              } else if (type == 'totalBet') {
                sum++;
              }
            }
          });
        }
      } else {
        $.each(this.$store.getters.betMulpAmount, function (id, data) {
          if (type == 'possiblePayout') {
            var value = data.possiblePayout.replaceAll(",", "");
            sum += value == '' ? 0 : Number(value);
          } else if (type == 'totalStake') {
            var value = data.stake.replaceAll(",", "");
            sum += value == '' ? 0 : Number(value);
          } else if (type == 'totalBet') {
            var value = data.value.replaceAll(",", "");
            if (value != '' && Number(value) != 0) {
              sum++;
            }
          }
        });
      }
      if (type == 'totalBet' && sum <= 0) {
        sum = '';
      }
      return sum;
    },
    multipleBetClick: function multipleBetClick() {
      this.multipleBetToggle = !this.multipleBetToggle;
    },
    getMULPOdds: function getMULPOdds() {
      var odds = 0;
      var vue = this;
      if (this.betFormList) {
        _.forEach(this.betFormList, function (data, key) {
          var pass_value = parseFloat(data.odd);
          if (vue.$store.getters.account.oddsType == 'am') {
            if (pass_value < 0) {
              pass_value = Math.abs(100 / pass_value) + 1;
            } else {
              pass_value = pass_value / 100 + 1;
            }
            pass_value = pass_value.toFixed(2);
          }
          if (odds == 0) {
            odds = parseFloat(pass_value);
          } else {
            odds = parseFloat(odds) * parseFloat(pass_value);
          }
        });
      }

      if (this.betting && this.betting.minMax) {
        if (this.betting.minMax.maxOdds) {
          if (odds > parseFloat(this.betting.minMax.maxOdds)) {
            if (this.mulpOdds != odds) {
              this.mulpOdds = odds;
              var message = this.betLang['BETTING.EXCEED_MAX_ODDS'] + ' ' + this.betting.minMax.maxOdds;
              this.$store.commit('JS_ERR', { error: true, msg: message });
              this.$store.commit('DISABLE_BET', true);
              this.$store.commit('DIALOG_TOGGLE', {
                show: true,
                msg: message
              });
              setTimeout(function () {
                vue.$store.commit('DIALOG_TOGGLE', { reset: true });
              }, 5000);
            }
          } else {
            this.mulpOdds = odds;
            this.$store.commit('DISABLE_BET', false);
            this.$store.commit('JS_ERR', { error: false });
          }
        }
      }

      if (this.$store.getters.account.oddsType == 'am') {
        if (odds > 1) {
          if (odds >= 2) {
            odds = 100 * (odds - 1);
          } else {
            odds = -100 / (odds - 1);
          }
        } else {
          odds = 0;
        }
        if (odds > 0) {
          odds = Math.floor(odds);
        } else {
          odds = parseFloat(odds).toFixed(0);
        }
      } else {
        odds = Math.floor(odds * 100) / 100;
      }
      return odds;
    },
    showKeyboard: function showKeyboard(key, index) {
      this.$store.commit('SELECTED_MULP_BOX', index);
      if (this.$store.getters.betMulpAmount && this.$store.getters.betMulpAmount.length > 1) {
        $('.mulp_keyboard').hide();
        $('.mulp_keyboard.' + key).show();
      }
    },
    betMinMaxMulp: function betMinMaxMulp(index) {
      return this.sportAllBetLang['ALL_BET.LIMITS'] + ' ' + this.commasAmount(this.$store.getters.betting.minMax.min) + ' ~ ' + this.commasAmount(this.$store.getters.betMulpAmount[index].maxPay);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.checkInPly();
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on(['marketChange', 'sportChange', 'pageChange'], function (params) {
      _this.checkInPly();
    }.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.pendingTimerId);
  }
});

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return REQUEST_ALLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return GAME_BANNER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return MOREBETLOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return MOREBETTOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return RESIZE_WHEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return SELECTED_ODD; });
/* unused harmony export TIME_ZONE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCOUNT_FAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return EVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return RBEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return FAVRBEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return EVENT_ALLBET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return MAINMARKET_BET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return MATCH_ALLBET; });
/* unused harmony export SHOWHIDE_EVENTLIST */
/* unused harmony export SHOWHIDE_RBEVENTLIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return SHOW_LEAGUETEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return SORTEDEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return SORTEDRBEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return OTRSPORTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return SORTEDFAVRBEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return SORTEDMATCHEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return FIRSTEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return TESTSHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return SHOWRIGHTBANNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return FAVOURITEEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return FAVOURITEEVENT_FIRSTLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return FAVOURITEOTREVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return FAVOURITEOTREVENTCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return FAVOURITEEVENTCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return FAVOURITERBEVENTCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return FAVOURITELGEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return FAVOURITELGEVENT_FIRSTLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return TOTALPAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return SPORTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ASPORTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return BETTYPELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return SPORTBETTYPELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return ODDTYPESLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return EARLYPARLAYDATELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return SELECTEDEARLYPARLAYDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return TOTALLEAGUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return SELECTEDLEAGUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return SELECTED_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return SELECTED_PER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return SELECTED_MATCHALLBET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return SELECTED_ALLBET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return SELECTED_ALLBETNEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return SELECTED_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return SELECTED_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return SELECTED_SPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return SELECTED_BETTYPE; });
/* unused harmony export SELECTED_PLYTYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return SELECTED_MARKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CHANGE_ODDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return SPORTTABLELANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return SPORTALLBETLANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return SPORT_LEAGUE_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return SPORT_FULLHALF_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return SPORT_INPLAY_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return SPORT_ALL_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return SPORT_SHOW_FAV_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return SPORT_PREVIOUS_IS_MULP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return SPORT_MAPPING_BETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return GAMEBANNER_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return SPORTLEAGUE_WINDOWEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return OPEN_RBMARKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return SELECTED_INPLAYSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALLBET_RELOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return R_ALLBET_RELOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return EARLYCOUNT_BYDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return UNFOLD_ALLSC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return SHOW_UNFOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return SHOW_FOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return SELECTED_ALLBETTAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return FOLDOPEN_FIRSTEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return SHOW_RBLGEEVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return SHOW_LGEEVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return IS_CHANGE_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return SELECTED_EVEID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return IS_PARLAY_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return PREV_BETTYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return GAME_BANNER_SPORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return GAME_BANNER_SPORT_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return RIGHT_BOARD_CHG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return SIMPLE_SPORT; });
/* unused harmony export STATE_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return HOT_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return HOT_SPORTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return BETLANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return BETTYPELANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return LEAGUELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return MERGE_LEAGUELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return ODD_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return BET_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return SELECTED_LEAGUELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return REMOVE_MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return BETTING_CHIP_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return BETTING_BETAMOUNT_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return BETTING_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return BETTING_ALLUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return BETTING_DELAY_TIMERID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return HIGHLIGHT_CELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return PARLAY_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return OPEN_BETFORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return BET_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return SHOW_BETFORM_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BETFORM_HDPCHG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return BETFORM_ODDCHG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return IS_BETCOMBO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return COMBOBET_EXCEEDLIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BETCOMBO_AMOUNT; });
/* unused harmony export BETCOMBO_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BETCOMBO_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BETCOMBO_KEYBOARDALLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CLEAR_BET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return REMOVE_ALLBUTLAST; });
/* unused harmony export RESET_BET_COMBO_ARRAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return SET_MATCH_INDEX_NO_ERR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALLOW_ERR_BET_AGAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return BETMULP_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return BETMULP_AMOUNT_FILTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DISABLE_BET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DIALOG_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return SELECTED_MULP_BOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return SPORTRESULT_LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return SPORTRESULT_DATELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return SPORTFORECAST_LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return SPORTFORECAST_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return SPORTFORECAST_SELECTEDEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return SPORTFORECAST_WINDOWEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return SPORTFORECAST_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return SPORTFORECAST_WAITINGLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return SPORT_MINIBET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return SPORT_MINIBET_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return SPORT_MINIBET_WINDOWEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return SPORT_MINIBET_BETAMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return SPORT_MINIBET_RIGHTSIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return STATEMENT_DATELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return STATEMENT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return STATEMENT_WAGERLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return STATEMENT_LAST10_WAGERLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return STATEMENT_SELECTED_SPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return STATEMENT_SELECTED_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return STATEMENT_SELECTED_WAGER_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return STATEMENT_SELECTED_WAGER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return STATEMENT_SHOW_WAGERDETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return STATEMENT_WAGER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return STATEMENT_SHOW_STATEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return SELECTED_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return SATEMENT_IS_CANCELWAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return STATEMENT_DATE_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return STATEMENT_API_DATELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return STATEMENT_SELECTED_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return STATEMENT_SHOW_LEDGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return STATEMENT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_WAGER_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return COOKIE_LEAGUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return SELECT_ALL_LEAGUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return SEARCH_LEAGUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return SHOW_LEAGUESEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return LIVE_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return LIVE_SELECTED_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return LIVE_SPORT_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return LIVE_SCHECULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return LIVE_ALLBET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return LIVE_MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return IS_OPEN_TV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ALLSPORTCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return BET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return PROCESS_BET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CHECKED_BALANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return FOLDOPEN_ALLBET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return IS_TODAYRB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return PLACED_BET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return PENDING_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return IS_REFUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return JS_ERR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BETCOMBO_JS_ERR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return BETLIST_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return SHOWRES_BOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return SELECTED_BETTAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return LIVETV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return MINI_NORMAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return FRAME_WH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return FRAME_RESIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return COOKIE_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return SEARCH_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return HIST_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return FILTER_EVENT; });
/* unused harmony export PROMO_JOINED_FLAG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return PROMO_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return PROMO_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return PROMO_SHOW_JOIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return PROMO_BET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return PROMO_BET_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return PROMO_BET_WITHOUT_JOIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return STATEMENT_SHOW_PROMOTIONDETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return PROMO_WAGER_DETAIL; });
/* unused harmony export PROMO_PROMPT_CONFIRM */

var REQUEST_ALLOW = 'REQUEST_ALLOW';
var GAME_BANNER_ID = 'GAME_BANNER_ID';
var MOREBETLOADING = 'MOREBETLOADING';
var MOREBETTOGGLE = 'MOREBETTOGGLE';
var RESIZE_WHEIGHT = 'RESIZE_WHEIGHT';

var ACCOUNT = 'ACCOUNT';
var SELECTED_ODD = 'SELECTED_ODD';
var TIME_ZONE = 'TIME_ZONE';
var ACCOUNT_FAV = 'ACCOUNT_FAV';

var EVENTLIST = 'EVENTLIST';
var RBEVENTLIST = 'RBEVENTLIST';
var FAVRBEVENTLIST = 'FAVRBEVENTLIST';
var EVENT_ALLBET = 'EVENT_ALLBET';
var MAINMARKET_BET = 'MAINMARKET_BET';
var MATCH_ALLBET = 'MATCH_ALLBET';
var SHOWHIDE_EVENTLIST = 'SHOWHIDE_EVENTLIST';
var SHOWHIDE_RBEVENTLIST = 'SHOWHIDE_RBEVENTLIST';
var SHOW_LEAGUETEAM = 'SHOW_LEAGUETEAM';
var SORTEDEVENTLIST = 'SORTEDEVENTLIST';
var SORTEDRBEVENTLIST = 'SORTEDRBEVENTLIST';
var OTRSPORTLIST = 'OTRSPORTLIST';
var SORTEDFAVRBEVENTLIST = 'SORTEDFAVRBEVENTLIST';
var SORTEDMATCHEVENTLIST = 'SORTEDMATCHEVENTLIST';
var FIRSTEVENT = 'FIRSTEVENT';
var TESTSHOW = 'TESTSHOW';
var SHOWRIGHTBANNER = 'SHOWRIGHTBANNER';
var FAVOURITEEVENT = 'FAVOURITEEVENT';
var FAVOURITEEVENT_FIRSTLOAD = 'FAVOURITEEVENT_FIRSTLOAD';
var FAVOURITEOTREVENT = 'FAVOURITEOTREVENT';
var FAVOURITEOTREVENTCOUNT = 'FAVOURITEOTREVENTCOUNT';
var FAVOURITEEVENTCOUNT = 'FAVOURITEEVENTCOUNT';
var FAVOURITERBEVENTCOUNT = 'FAVOURITERBEVENTCOUNT';
var FAVOURITELGEVENT = 'FAVOURITELGEVENT';
var FAVOURITELGEVENT_FIRSTLOAD = 'FAVOURITELGEVENT_FIRSTLOAD';
var TOTALPAGE = 'TOTALPAGE';
var SPORTLIST = 'SPORTLIST';
var ASPORTLIST = 'ASPORTLIST';
var BETTYPELIST = 'BETTYPELIST';
var SPORTBETTYPELIST = 'SPORTBETTYPELIST';
var ODDTYPESLIST = 'ODDTYPESLIST';
var EARLYPARLAYDATELIST = 'EARLYPARLAYDATELIST';
var SELECTEDEARLYPARLAYDATE = 'SELECTEDEARLYPARLAYDATE';
var TOTALLEAGUES = 'TOTALLEAGUES';
var SELECTEDLEAGUES = 'SELECTEDLEAGUES';
var SELECTED_PAGE = 'SELECTED_PAGE';
var SELECTED_PER_PAGE = 'SELECTED_PER_PAGE';
var SELECTED_MATCHALLBET = 'SELECTED_MATCHALLBET';
var SELECTED_ALLBET = 'SELECTED_ALLBET';
var SELECTED_ALLBETNEW = 'SELECTED_ALLBETNEW';
var SELECTED_SORT = 'SELECTED_SORT';
var SELECTED_SHOW = 'SELECTED_SHOW';
var SELECTED_SPORT = 'SELECTED_SPORT';
var SELECTED_BETTYPE = 'SELECTED_BETTYPE';
var SELECTED_PLYTYPE = 'SELECTED_PLYTYPE';
var SELECTED_MARKET = 'SELECTED_MARKET';
var CHANGE_ODDS = 'CHANGE_ODDS';
var SPORTTABLELANG = 'SPORTTABLELANG';
var SPORTALLBETLANG = 'SPORTALLBETLANG';
var SPORT_LEAGUE_TOGGLE = 'SPORT_LEAGUE_TOGGLE';
var SPORT_FULLHALF_TIME = 'SPORT_FULLHALF_TIME';
var SPORT_INPLAY_EVENTS = 'SPORT_INPLAY_EVENTS';
var SPORT_ALL_EVENTS = 'SPORT_ALL_EVENTS';
var SPORT_SHOW_FAV_EVENTS = 'SPORT_SHOW_FAV_EVENTS';
var SPORT_PREVIOUS_IS_MULP = 'SPORT_PREVIOUS_IS_MULP';
var SPORT_MAPPING_BETTING = 'SPORT_MAPPING_BETTING';
var GAMEBANNER_SELECTED = 'GAMEBANNER_SELECTED';
var SPORTLEAGUE_WINDOWEVENT = 'SPORTLEAGUE_WINDOWEVENT';
var OPEN_RBMARKET = 'OPEN_RBMARKET';
var SELECTED_INPLAYSPORT = 'SELECTED_INPLAYSPORT';
var ALLBET_RELOADING = 'ALLBET_RELOADING';
var R_ALLBET_RELOADING = 'R_ALLBET_RELOADING';
var EARLYCOUNT_BYDATE = 'EARLYCOUNT_BYDATE';
var UNFOLD_ALLSC = 'UNFOLD_ALLSC';
var SHOW_UNFOLD = 'SHOW_UNFOLD';
var SHOW_FOLD = 'SHOW_FOLD';
var SELECTED_ALLBETTAB = 'SELECTED_ALLBETTAB';
var FOLDOPEN_FIRSTEVENT = 'FOLDOPEN_FIRSTEVENT';
var SHOW_RBLGEEVE = 'SHOW_RBLGEEVE';
var SHOW_LGEEVE = 'SHOW_LGEEVE';
var IS_CHANGE_TEMPLATE = 'IS_CHANGE_TEMPLATE';
var SELECTED_EVEID = 'SELECTED_EVEID';
var IS_PARLAY_TAB = 'IS_PARLAY_TAB';
var PREV_BETTYPE = 'PREV_BETTYPE';
var GAME_BANNER_SPORT_ID = 'GAME_BANNER_SPORT_ID';
var GAME_BANNER_SPORT_COUNT = 'GAME_BANNER_SPORT_COUNT';
var RIGHT_BOARD_CHG = 'RIGHT_BOARD_CHG';
var SIMPLE_SPORT = 'SIMPLE_SPORT';
var STATE_LIST = 'STATE_LIST';
var HOT_SCHEDULE = 'HOT_SCHEDULE';
var HOT_SPORTLIST = 'HOT_SPORTLIST';

var BETLANG = 'BETLANG';
var BETTYPELANG = 'BETTYPELANG';
var LEAGUELIST = 'LEAGUELIST';
var MERGE_LEAGUELIST = 'MERGE_LEAGUELIST';
var ODD_SELECTED = 'ODD_SELECTED';
var BET_FORM = 'BET_FORM';
var SELECTED_LEAGUELIST = 'SELECTED_LEAGUELIST';
var REMOVE_MATCH = 'REMOVE_MATCH';
var BETTING_CHIP_OPTION = 'BETTING_CHIP_OPTION';
var BETTING_BETAMOUNT_OPTION = 'BETTING_BETAMOUNT_OPTION';
var BETTING_MESSAGE = 'BETTING_MESSAGE';
var BETTING_ALLUP = 'BETTING_ALLUP';
var BETTING_DELAY_TIMERID = 'BETTING_DELAY_TIMERID';
var HIGHLIGHT_CELL = 'HIGHLIGHT_CELL';
var PARLAY_SELECTED = 'PARLAY_SELECTED';
var OPEN_BETFORM = 'OPEN_BETFORM';
var BET_AMOUNT = 'BET_AMOUNT';
var SHOW_BETFORM_MENU = 'SHOW_BETFORM_MENU';
var BETFORM_HDPCHG = 'BETFORM_HDPCHG';
var BETFORM_ODDCHG = 'BETFORM_ODDCHG';
var IS_BETCOMBO = 'IS_BETCOMBO';
var COMBOBET_EXCEEDLIMIT = 'COMBOBET_EXCEEDLIMIT';
var BETCOMBO_AMOUNT = 'BETCOMBO_AMOUNT';
var BETCOMBO_ERROR = 'BETCOMBO_ERROR';
var BETCOMBO_MESSAGE = 'BETCOMBO_MESSAGE';
var BETCOMBO_KEYBOARDALLOW = 'BETCOMBO_KEYBOARDALLOW';
var CLEAR_BET_SUCCESS = 'CLEAR_BET_SUCCESS';
var REMOVE_ALLBUTLAST = 'REMOVE_ALLBUTLAST';
var RESET_BET_COMBO_ARRAY = 'RESET_BET_COMBO_ARRAY';
var SET_MATCH_INDEX_NO_ERR = 'SET_MATCH_INDEX_NO_ERR';
var ALLOW_ERR_BET_AGAIN = 'ALLOW_ERR_BET_AGAIN';
var BETMULP_AMOUNT = 'BETMULP_AMOUNT';
var BETMULP_AMOUNT_FILTERED = 'BETMULP_AMOUNT_FILTERED';
var DISABLE_BET = 'DISABLE_BET';
var DIALOG_TOGGLE = 'DIALOG_TOGGLE';
var SELECTED_MULP_BOX = 'SELECTED_MULP_BOX';

var SPORTRESULT_LANG = 'SPORTRESULT_LANG';
var SPORTRESULT_DATELIST = 'SPORTRESULT_DATELIST';

var SPORTFORECAST_LANG = 'SPORTFORECAST_LANG';
var SPORTFORECAST_TOGGLE = 'SPORTFORECAST_TOGGLE';
var SPORTFORECAST_SELECTEDEVENT = 'SPORTFORECAST_SELECTEDEVENT';
var SPORTFORECAST_WINDOWEVENT = 'SPORTFORECAST_WINDOWEVENT';
var SPORTFORECAST_LIST = 'SPORTFORECAST_LIST';
var SPORTFORECAST_WAITINGLIST = 'SPORTFORECAST_WAITINGLIST';

var SPORT_MINIBET = 'SPORT_MINIBET';
var SPORT_MINIBET_TOGGLE = 'SPORT_MINIBET_TOGGLE';
var SPORT_MINIBET_WINDOWEVENT = 'SPORT_MINIBET_WINDOWEVENT';
var SPORT_MINIBET_BETAMOUNT = 'SPORT_MINIBET_BETAMOUNT';
var SPORT_MINIBET_RIGHTSIDE = 'SPORT_MINIBET_RIGHTSIDE';

var STATEMENT_DATELIST = 'STATEMENT_DATELIST';
var STATEMENT_LIST = 'STATEMENT_LIST';
var STATEMENT_WAGERLIST = 'STATEMENT_WAGERLIST';
var STATEMENT_LAST10_WAGERLIST = 'STATEMENT_LAST10_WAGERLIST';
var STATEMENT_SELECTED_SPORT = 'STATEMENT_SELECTED_SPORT';
var STATEMENT_SELECTED_DATE = 'STATEMENT_SELECTED_DATE';
var STATEMENT_SELECTED_WAGER_DATE = 'STATEMENT_SELECTED_WAGER_DATE';
var STATEMENT_SELECTED_WAGER_PAGE = 'STATEMENT_SELECTED_WAGER_PAGE';
var STATEMENT_SHOW_WAGERDETAIL = 'STATEMENT_SHOW_WAGERDETAIL';
var STATEMENT_WAGER_TYPE = 'STATEMENT_WAGER_TYPE';
var STATEMENT_SHOW_STATEMENT = 'STATEMENT_SHOW_STATEMENT';
var SELECTED_TAB = 'SELECTED_TAB';
var SATEMENT_IS_CANCELWAGER = 'SATEMENT_IS_CANCELWAGER';
var STATEMENT_DATE_RANGE = 'STATEMENT_DATE_RANGE';
var STATEMENT_API_DATELIST = 'STATEMENT_API_DATELIST';
var STATEMENT_SELECTED_WEEK = 'STATEMENT_SELECTED_WEEK';
var STATEMENT_SHOW_LEDGER = 'STATEMENT_SHOW_LEDGER';
var STATEMENT_DETAIL = 'STATEMENT_DETAIL';
var API_WAGER_DETAIL = 'API_WAGER_DETAIL';

var COOKIE_LEAGUE = 'COOKIE_LEAGUE';
var SELECT_ALL_LEAGUE = 'SELECT_ALL_LEAGUE';
var SEARCH_LEAGUE = 'SEARCH_LEAGUE';
var SHOW_LEAGUESEARCH = 'SHOW_LEAGUESEARCH';

var LIVE_EVENT = 'LIVE_EVENT';
var LIVE_SELECTED_EVENT = 'LIVE_SELECTED_EVENT';
var LIVE_SPORT_TITLE = 'LIVE_SPORT_TITLE';
var LIVE_SCHECULE = 'LIVE_SCHECULE';
var LIVE_ALLBET = 'LIVE_ALLBET';
var LIVE_MATCH = 'LIVE_MATCH';
var IS_OPEN_TV = 'IS_OPEN_TV';

var ALLSPORTCOUNT = 'ALLSPORTCOUNT';
var BET_SUCCESS = 'BET_SUCCESS';
var PROCESS_BET = 'PROCESS_BET';
var CHECKED_BALANCE = 'CHECKED_BALANCE';
var FOLDOPEN_ALLBET = 'FOLDOPEN_ALLBET';
var IS_TODAYRB = 'IS_TODAYRB';
var PLACED_BET = 'PLACED_BET';
var PENDING_FLAG = 'PENDING_FLAG';
var IS_REFUND = 'IS_REFUND';
var JS_ERR = 'JS_ERR';
var BETCOMBO_JS_ERR = 'BETCOMBO_JS_ERR';
var BETLIST_TYPE = 'BETLIST_TYPE';
var SHOWRES_BOX = 'SHOWRES_BOX';
var SELECTED_BETTAB = 'SELECTED_BETTAB';
var LIVETV = 'LIVETV';

var MINI_NORMAL = 'MINI_NORMAL';
var FRAME_WH = 'FRAME_WH';
var FRAME_RESIZE = 'FRAME_RESIZE';

var COOKIE_HISTORY = 'COOKIE_HISTORY';
var SEARCH_LOADING = 'SEARCH_LOADING';
var HIST_LIST = 'HIST_LIST';
var FILTER_EVENT = 'FILTER_EVENT';

var PROMO_JOINED_FLAG = 'PROMO_JOINED_FLAG';
var PROMO_FLAG = 'PROMO_FLAG';
var PROMO_DETAILS = 'PROMO_DETAILS';
var PROMO_SHOW_JOIN_SUCCESS = 'PROMO_SHOW_JOIN_SUCCESS';
var PROMO_BET_STATUS = 'PROMO_BET_STATUS';
var PROMO_BET_INDEX = 'PROMO_BET_INDEX';
var PROMO_BET_WITHOUT_JOIN = 'PROMO_BET_WITHOUT_JOIN';
var STATEMENT_SHOW_PROMOTIONDETAIL = 'STATEMENT_SHOW_PROMOTIONDETAIL';
var PROMO_WAGER_DETAIL = 'PROMO_WAGER_DETAIL';
var PROMO_PROMPT_CONFIRM = 'PROMO_PROMPT_CONFIRM';

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_common_rb_timer__ = __webpack_require__(22);







var merdianFn = function merdianFn(hour, minute, isLowercase) {
  if (hour < 12) {
    return "AM";
  } else {
    return 'PM';
  }
};
switch (__WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get(compcode + '_lang')) {
  case 'zh_CN':
    __webpack_require__(21);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('zh-cn');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('zh-cn', {
      longDateFormat: {
        MM: 'xx'
      },
      meridiem: merdianFn
    });
    break;
  case 'zh_TW':
    __webpack_require__(52);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('zh-tw');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('zh-tw', {
      meridiem: merdianFn
    });
    break;
  case 'th_TH':
    __webpack_require__(53);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('th');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('th', {
      meridiem: merdianFn
    });
    break;
  case 'vn_VN':
    __webpack_require__(54);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('vi');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('vi', {
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      meridiem: merdianFn
    });
    break;
  case 'id_ID':
    __webpack_require__(55);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('id');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('id', {
      meridiem: merdianFn
    });
    break;
  case 'es_MX':
    __webpack_require__(56);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('es');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('es', {
      meridiem: merdianFn
    });
    break;
  case 'pt_PT':
    __webpack_require__(57);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('pt');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('pt', {
      meridiem: merdianFn
    });
    break;
  case 'fa_IR':
    __webpack_require__(58);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fa');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('fa', {
      meridiem: merdianFn
    });
    break;
  case 'ja_JP':
    __webpack_require__(59);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('ja');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('ja', {
      meridiem: merdianFn
    });
    break;
  case 'ko_KR':
    __webpack_require__(60);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('ko');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('ko', {
      meridiem: merdianFn
    });
    break;
  default:
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('en_US', {
      meridiem: merdianFn
    });
}
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', function (value, format) {
  var paramDate = new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(value);
  return paramDate.format(format);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('rb-timer', function (event, format) {
  var timer = '';

  if (event.sptid == '1') {
    var timerSec = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').seconds();
    var timerMin = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').minutes();
    var timerHour = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').hours();

    if (timerSec.toString().length == 1) {
      timerSec = '0' + timerSec;
    }

    timer = timerMin;
    if (event.rbinfo.htst == '2') {
      if (event.extraflag) {
        timer = timerMin >= 15 ? timerMin - 15 : timerMin;
      } else {
        timer = timerHour * 60 - 45 + timerMin;
      }
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__js_common_rb_timer__["a" /* validateSpecialRBTimer */])(event, timerHour, timerMin)) {
      timer = timerHour * 60 - 45 + timerMin;
    }

    if (timer.toString().length == 1) {
      timer = '0' + timer;
    }

    if (format == 'mm:ss') {
      timer += ':' + timerSec;
    } else if (format == 'mm') {
      timer = timer;
    } else {
      timer = timer;
    }
  } else if (event.sptid == '2') {
    var timerMin = event.rbinfo.evetm;

    if (timerMin.toString().length == 1) {
      timerMin = '0' + timerMin;
    }

    timer = timerMin;

    if (format == 'mm:ss') {
      timer += ':00';
    } else if (format == 'mm') {
      timer = timer;
    } else {
      timer += ':00';
    }
  }

  return timer;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('checkTimer', function (event, format) {
  var timer = '';

  if (event.sptid == '1') {
    var timerSec = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').seconds();
    var timerMin = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').minutes();
    var timerHour = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').hours();

    if (timerSec.toString().length == 1) {
      timerSec = '0' + timerSec;
    }

    timer = timerMin;
    if (event.rbinfo.htst == '2') {
      if (event.extraflag) {
        timer = timerMin >= 15 ? timerMin - 15 : timerMin;
      } else {
        timer = timerHour * 60 - 45 + timerMin;
      }
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__js_common_rb_timer__["a" /* validateSpecialRBTimer */])(event, timerHour, timerMin)) {
      timer = timerHour * 60 - 45 + timerMin;
    }

    if (timer.toString().length == 1) {
      timer = '0' + timer;
    }

    if (timer < 0) {
      timer = '';
    } else {
      if (format == 'mm:ss') {
        timer += ':' + timerSec;
      } else if (format == 'mm') {
        timer = timer;
      } else {
        timer = timer;
      }
    }
  } else if (event.sptid == '2') {
    var timerMin = event.rbinfo.evetm;

    if (timerMin) {
      if (timerMin.toString().length == 1) {
        timerMin = '0' + timerMin;
      }
    } else {
      timerMin = -1;
    }

    timer = timerMin;

    if (timer < 0) {
      timer = '';
    } else {
      if (format == 'mm:ss') {
        timer += ':00';
      } else if (format == 'mm') {
        timer = timer;
      } else {
        timer += ':00';
      }
    }
  }

  return timer;
});

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_components_mini_bet__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);












__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('odd', {
  components: {
    minibet: __WEBPACK_IMPORTED_MODULE_4__vue_components_mini_bet__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__["a" /* default */]],
  name: 'odd',
  template: ' \n    <div :id="getOddUniqueId(event)" class="odds" :class="[getOdCls(mode,betType,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);" >\n    <div  v-if="mode==\'ab\' && checkTitleBt()" :style="(betType == \'8\' || betType == \'1\')? \'padding:17px 50%;\':\'padding:17px 43%;\'" :title="getTitle()"></div>\n      <template v-if="event.od">\n        <template v-if="event.od[plyType]">\n          <template v-if="event.od[plyType][betType]">\n            <template v-if="event.od[plyType][betType][matchId]">\n              <template v-if="oddValidation(event)">\n                <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">\n                  <span>{{ getDecimalDisplay(betForm.odd) }}</span>\n                </template>\n                <template v-else>\n                  <template v-if="mode==\'ab\'">\n                    <div class="">\n                      <span class="yb-family-odds yb-number-bold match_details"> <!-- up/down : odds updown-->\n                      {{ getDecimalDisplay(event.od[plyType][betType][matchId][team]) }}\n                      </span>\n                    </div>\n                  </template>\n                  <template v-else>\n                    <span>\n                      {{ getDecimalDisplay(event.od[plyType][betType][matchId][team]) }}\n                    </span>\n                  </template>\n                </template>\n                \n                <div class="odds-arrows-wrap" v-if="mode!=\'ab\'">\n                  <div class="odds-icon odds-up"></div>\n                  <div class="odds-icon odds-down"></div>\n                </div>\n              </template>\n              <template v-else>\n                <div class="lock m-icon"></div>\n              </template>\n            </template>\n            <template v-else>\n              <div class="lock m-icon" style="margin: auto;"></div>\n            </template>\n          </template>\n          <template v-else>\n            <div class="lock m-icon" style="margin: auto;"></div>\n          </template>\n        </template>\n        <template v-else>\n          <div class="lock m-icon" style="margin: auto;"></div>\n        </template>\n      </template>\n      <template v-else>\n        <div class="lock m-icon" style="margin: auto;"></div>\n      </template> \n    </div>\n  ',


  props: {
    event: null,
    team: null,
    plyType: null,
    teamaname: null,
    teambname: null,
    betType: null,
    match: null,
    lang: null,
    mode: null,
    wdth: null
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['sportMiniBet', 'changeOdds', 'isChangeTemplate', 'isParlayTab', 'specialEvent', 'ShowUpDown']), {
    betForm: function betForm() {
      return this.$store.getters.betForm[0];
    }
  }),
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (this.match == 0 || this.match == 'a') this.matchId = 'a';else if (this.match == 1 || this.match == 'b') this.matchId = 'b';else if (this.match == 2 || this.match == 'c') this.matchId = 'c';else this.matchId = 'd';
        if (this.isDefinedOdds(val)) {
          this.classNegative(val.od[this.plyType][this.betType][this.matchId][this.team]);
          if (oldVal && !this.isChangeTemplate) {
            this.refreshOdd = false;
            if (this.isDefinedOdds(oldVal)) {
              this.diffOddsUpDown(val.od[this.plyType][this.betType][this.matchId][this.team], oldVal.od[this.plyType][this.betType][this.matchId][this.team]);
              this.diffOdds(val.od[this.plyType][this.betType][this.matchId][this.team], oldVal.od[this.plyType][this.betType][this.matchId][this.team]);
            }
          } else if (this.refreshOdd) {
            this.refreshOdd = false;
            this.isDiff = false;
          } else if (!oldVal) {
            this.refreshOdd = true;
          }
        } else {
          this.isClosePause = true;
        }
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      isNegative: false,
      isDiff: false,
      isUp: false,
      isClosePause: false,
      matchId: null,
      refreshOdd: false
    };
  },

  methods: {
    getOdCls: function getOdCls(mode, bt, event) {
      var a = ' odds-default';
      if (mode == 'ab') {
        a += ' yb-number-font';
        if (jQuery.inArray(bt, ['1', '8']) != '-1') {
          a += ' odds-hdp ' + a;
        } else if (bt == '2') {
          a += ' odds-ou ' + a;
        }
        if (jQuery.inArray(bt, ['1', '3', '8', '10', '59', '60', '61', '62', '63', '64', '73']) == '-1') {
          a += ' c-center';
        } else {
          a += ' c-right';
        }
      } else {
        a += ' c-right';
      }

      return a;
    },
    getClass: function getClass(event, isNeg, isDif, isUp, isClosePause) {
      var classStr = '';
      var classMini = '';

      if (this.changeOdds && false) {
        if (!this.refreshOdd && isDif && this.ShowUpDown == true) {
          classStr = 'indicator';
        }
      } else if (isClosePause) {
        classStr = '';
      } else {
        if (!this.isChangeTemplate && isDif && this.ShowUpDown == true) {
          if (isUp) {
            classStr = 'up';
          } else {
            classStr = 'down';
          }
        }
      }

      return classStr + classMini;
    },
    checkTitleBt: function checkTitleBt() {
      if (['1', '8', '62', '63', '64'].indexOf(this.betType.toString()) !== -1) {
        return true;
      }
      return false;
    },
    getTitle: function getTitle() {
      var parser = new DOMParser();

      if (this.betType == '8' || this.betType == '1') {
        return this.team == 'oddsb' ? parser.parseFromString(this.event.tbcapt, "text/html").body.textContent : parser.parseFromString(this.event.tacapt, "text/html").body.textContent;
      }

      if (this.betType == '63' || this.betType == '64') {
        if (this.team == 'oddsha') {
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
        } else if (this.team == 'oddshb') {
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
        } else if (this.team == 'oddsda') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
        } else if (this.team == 'oddsdb') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
        } else if (this.team == 'oddsaa') {
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
        } else {
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
        }
      }

      if (this.betType == this.ouftsBetType) {
        if (this.team == 'oddsha') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
        } else if (this.team == 'oddshb') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
        } else if (this.team == 'oddsaa') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
        } else {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
        }
      }
    },
    getOddUniqueClass: function getOddUniqueClass(event) {
      var classStr = '';
      if (this.plyType == '2') {
        classStr += 'ht ';
      }
      classStr += this.getOddUniqueId(event);
      return classStr;
    },
    getOddUniqueId: function getOddUniqueId(event) {
      return event.eveid + this.plyType + this.betType + this.matchId + this.team;
    },
    oddValidation: function oddValidation(event) {
      var param = {};
      param.odds = parseFloat(event.od[this.plyType][this.betType][this.matchId][this.team]);
      param.hdp = event.od[this.plyType][this.betType][this.matchId]['hdp'];
      param.bettype = parseInt(this.betType);
      param.oddstype = this.$store.getters.selectedBettype.betTypId == 5 && this.isParlayTab && this.$store.getters.account.oddsType != 'am' ? this.$store.getters.oddTypesList.EU.key : this.$store.getters.account.oddstype;
      if (event.sptid == 255) {
        param.oddstype = this.betType == 12 ? this.$store.getters.oddTypesList.EU.key : this.$store.getters.oddTypesList.HK.key;
      }
      return this.validateOddHdp(param);
    },
    onClickOdd: function onClickOdd() {
      var _this = this;

      var windowEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$emit('returnBetTab');
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return;
      }
      if (this.event.od[this.plyType][this.betType] == undefined || this.$store.getters.account.oddsType != 'in' && this.$store.getters.account.oddsType != 'my' && this.$store.getters.account.oddsType != 'am' && this.event.od[this.plyType][this.betType][this.matchId][this.team] <= 0) {
        return;
      }
      if (!this.oddValidation(this.event)) {
        return;
      }
      if (!this.account.previewFlag) {
        var teamBet = this.team[this.team.length - 1];
        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          eveid: this.event.eveid,
          plyType: this.plyType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          betType: this.betType,
          tbetcapt: this.event['t' + teamBet + 'capt'],
          tbetid: this.event['t' + teamBet + 'id'],
          rbscoa: 0,
          rbscob: 0,
          dual: this.matchId,
          fav: '0',
          ha: this.event.ha,
          odd: this.event.od[this.plyType][this.betType][this.matchId][this.team],
          uniqueId: this.event.eveid + this.plyType + this.betType + this.matchId + this.team,

          eventObj: this.event
        };

        if (this.event.rb) {
          if (this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa;
            betForm.rbscob = this.event.rbinfo.scob;
          }
        }

        var hdp = this.event.od[this.plyType][this.betType][this.matchId]['hdp'].split('/', 2);
        if (hdp.length > 1) {
          var hdp0 = parseFloat(hdp[0]);
          var hdp1 = parseFloat(hdp[1]);
          betForm.hdp = (hdp0 + hdp1) / 2;
        } else {
          var hdp0 = parseFloat(hdp[0]);
          betForm.hdp = hdp0;
        }

        var fav = this.event.od[this.plyType][this.betType][this.matchId].fav;
        switch (this.betType.toString()) {
          case this.hdpBetType:
          case this.rhdpBetType:
            betForm.tbet = teamBet == 'a' ? 'a' : 'b';
            betForm.hdp = teamBet == 'a' && fav == 'a' || teamBet == 'b' && fav == 'b' ? betForm.hdp * -1 : betForm.hdp;
            betForm.fav = fav;
            betForm.colorDis = 0;
            if (this.event.od[1] && this.event.od[1][this.betType] && this.event.od[1][this.betType]['a'] && this.event.od[1][this.betType]['a'].hdp != 0 && this.event.od[1][this.betType]['a'].fav == teamBet) {
              betForm.colorDis = 1;
            } else if (this.event.od[3] && this.event.od[3][this.betType] && this.event.od[3][this.betType]['a'] && this.event.od[3][this.betType]['a'].hdp != 0 && this.event.od[3][this.betType]['a'].fav == teamBet) {
              betForm.colorDis = 1;
            }
            break;
          case this.ouBetType:
          case this.rouBetType:
          case this.htgBetType:
          case this.rhtgBetType:
          case this.atgBetType:
          case this.ratgBetType:
          case this.htrBetType:
          case this.rhtrBetType:
          case this.atrBetType:
          case this.ratrBetType:
            betForm.tbet = teamBet == 'a' ? 'a' : 'b';
            var capt = betForm.tbet == 'a' ? 'ALL_BET.LBL_OVER' : 'ALL_BET.LBL_UNDER';
            betForm.tbetcapt = this.$store.getters.sportAllBetLang[capt] + ' ' + betForm.hdp;
            betForm.fav = fav;
            break;
          case this.oeBetType:
          case this.roeBetType:
            betForm.tbet = teamBet == 'a' ? 'a' : 'b';
            var capt = betForm.tbet == 'a' ? 'ALL_BET.LBL_ODD' : 'ALL_BET.LBL_EVEN';
            betForm.tbetcapt = this.$store.getters.sportAllBetLang[capt];
            betForm.fav = fav;
            break;
          case this.bttsBetType:
          case this.rbttsBetType:
            betForm.tbet = teamBet == 'a' ? 'a' : 'b';
            var capt = betForm.tbet == 'a' ? 'ALL_BET.LBL_YES' : 'ALL_BET.LBL_NO';
            betForm.tbetcapt = this.$store.getters.sportAllBetLang[capt];
            betForm.fav = fav;
            break;
          case this.onex2ouBetType:
          case this.ronex2ouBetType:
            if (this.team == 'oddsha') {
              betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
              betForm.tbetid = 'ha';
              betForm.tbet = 'ha';
              teamBet = 'ha';
            } else if (this.team == 'oddshb') {
              betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
              betForm.tbetid = 'hb';
              betForm.tbet = 'hb';
              teamBet = 'hb';
            } else if (this.team == 'oddsda') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
              betForm.tbetid = 'da';
              betForm.tbet = 'da';
              teamBet = 'da';
            } else if (this.team == 'oddsdb') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
              betForm.tbetid = 'db';
              betForm.tbet = 'db';
              teamBet = 'db';
            } else if (this.team == 'oddsaa') {
              betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
              betForm.tbetid = 'aa';
              betForm.tbet = 'aa';
              teamBet = 'aa';
            } else {
              betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
              betForm.tbetid = 'ab';
              betForm.tbet = 'ab';
              teamBet = 'ab';
            }
            break;
          case this.ouoeBetType:
          case this.rouoeBetType:
            if (this.team == 'oddsha') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.betType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_ODD'];
              betForm.tbetid = 'ha';
              betForm.tbet = 'ha';
              teamBet = 'ha';
            } else if (this.team == 'oddshb') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.betType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_EVEN'];
              betForm.tbetid = 'hb';
              betForm.tbet = 'hb';
              teamBet = 'hb';
            } else if (this.team == 'oddsaa') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.betType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_ODD'];
              betForm.tbetid = 'aa';
              betForm.tbet = 'aa';
              teamBet = 'aa';
            } else {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.betType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_EVEN'];
              betForm.tbetid = 'ab';
              betForm.tbet = 'ab';
              teamBet = 'ab';
            }
            break;
          case this.oubttsBetType:
          case this.roubttsBetType:
            if (this.team == 'oddsha') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
              betForm.tbetid = 'ha';
              betForm.tbet = 'ha';
              teamBet = 'ha';
            } else if (this.team == 'oddshb') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
              betForm.tbetid = 'hb';
              betForm.tbet = 'hb';
              teamBet = 'hb';
            } else if (this.team == 'oddsaa') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
              betForm.tbetid = 'aa';
              betForm.tbet = 'aa';
              teamBet = 'aa';
            } else {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
              betForm.tbetid = 'ab';
              betForm.tbet = 'ab';
              teamBet = 'ab';
            }
            break;
          case this.ouftsBetType:
            if (this.team == 'oddsha') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
              betForm.tbetid = 'ha';
              betForm.tbet = 'ha';
              teamBet = 'ha';
            } else if (this.team == 'oddshb') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
              betForm.tbetid = 'hb';
              betForm.tbet = 'hb';
              teamBet = 'hb';
            } else if (this.team == 'oddsaa') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
              betForm.tbetid = 'aa';
              betForm.tbet = 'aa';
              teamBet = 'aa';
            } else {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
              betForm.tbetid = 'ab';
              betForm.tbet = 'ab';
              teamBet = 'ab';
            }
            break;
          case this.mlBetType:
            if (this.specialEvent) {
              betForm.tbet = teamBet == 'a' ? 'a' : 'b';
            }
            break;
          default:
        }

        if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket;
          betForm.plytypcapt = '(' + market.betLang + ') ' + this.plyType;
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {}

        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,
          'dual': this.matchId,
          'tbet': teamBet
        });

        if (indexx > -1) {
          var obj = { eveid: this.event.eveid };
          if (this.$store.getters.isBetCombo) {
            obj = { clearType: '3', index: indexx };
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            data: obj,
            callback: function () {
              _this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: _this.event.eveid
              });
              var MID = $(windowEvent.target).closest('div[id]')[0].id;

              $("[id=" + MID + "]").closest('.c-bet-item.active').removeClass('active');

              if (_this.$store.getters.betForm.length <= 0) {
                _this.$store.commit("OPEN_BETFORM", false);
                _this.$store.commit('ODD_SELECTED', false);
                _this.$store.commit("SHOW_BETFORM_MENU", false);
                _this.$store.commit('SELECTED_TAB', 'betTab');
                return;
              } else {
                _this.$store.commit('OPEN_BETFORM', true);
              }
              _this.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this.$store.getters.betForm
                  });
                }.bind(_this)
              });
            }.bind(this)
          });
        } else {
          if (this.$store.getters.isBetCombo && this.$store.getters.betForm.length == this.betComboMax) {
            var chkRes = this.checkBetComboMax(betForm);
            if (chkRes) {
              return;
            }
          }

          if (this.$store.getters.selectedBettype.betTypId == '5' && this.$store.getters.betting.minMax != undefined && this.$store.getters.betting.minMax.maxCombo != undefined) {
            if (this.$store.getters.betForm.length == this.$store.getters.betting.minMax.maxCombo) {
              var vue = this;
              var maxMulpComboMsg = this.$store.getters.betLang['BETTING.HIT_MAX_COMBO'];
              this.$store.commit('DIALOG_TOGGLE', {
                show: true,
                msg: maxMulpComboMsg
              });

              setTimeout(function () {
                vue.$store.commit('DIALOG_TOGGLE', { reset: true });
              }, 5000);
              return;
            }
          }

          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: function (res) {
              _this.$store.commit('CLEAR_BET_SUCCESS');
              _this.$store.commit('OPEN_BETFORM', true);
              _this.oddSelectHighlight(windowEvent, betForm);

              if (res.SYSTEM_DATA.status != 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                  if (_this.$store.getters.sportMiniBet.toggle) {
                    __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$emit('expandMini');
                  }
                }
                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                  __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }

                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                });

                if (_this.$store.getters.isBetCombo && _this.$store.getters.betForm.length > 1) {
                  __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$emit('clearAllBetComboAmount');
                  __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }
                if (windowEvent) {
                  _this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: _this.event.eveid
                  });
                }
              } else if (res.SYSTEM_DATA.status == 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                }

                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                }
                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                });
                if (windowEvent) {
                  _this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: _this.event.eveid
                  });
                }
              }
            }.bind(this)
          });
        }
      }
    },
    classNegative: function classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false;
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    diffOddsUpDown: function diffOddsUpDown(val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false;
    },
    isDefinedOdds: function isDefinedOdds(val) {
      var isDefinedOdds = false;
      if (typeof val.od != 'undefined') {
        if (typeof val.od[this.plyType] != 'undefined') {
          if (typeof val.od[this.plyType][this.betType] != 'undefined') {
            if (typeof val.od[this.plyType][this.betType][this.matchId] != 'undefined') {
              isDefinedOdds = true;
            }
          }
        }
      }
      return isDefinedOdds;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$on(['refreshOdd'], function (params) {
      if (params == false) {
        _this2.refreshOdd = false;
      } else {
        _this2.refreshOdd = true;
      }
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$on(['diffOdd'], function (params) {
      if (typeof _this2.event.all == 'undefined') {
        if (_this2.isDefinedOdds(_this2.event) && _this2.isDefinedOdds(params)) {
          if (params.sp) {
            var eveid = _this2.event.eveid;

            if (params.sp[eveid]) {
              if (_this2.isDefinedOdds(_this2.event) && _this2.isDefinedOdds(params.sp[eveid])) {
                _this2.diffOddsUpDown(params.sp[eveid].od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team], _this2.event.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team]);
                _this2.diffOdds(params.sp[eveid].od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team], _this2.event.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team]);
              }
            } else {
              _this2.diffOddsUpDown(params.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team], _this2.event.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team]);
              _this2.diffOdds(params.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team], _this2.event.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team]);
            }
          } else {
            _this2.diffOddsUpDown(params.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team], _this2.event.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team]);
            _this2.diffOdds(params.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team], _this2.event.od[_this2.plyType][_this2.betType][_this2.matchId][_this2.team]);
          }
          _this2.$forceUpdate();
        }
      }
    }.bind(this));
  },
  mounted: function mounted() {
    this.$store.getters.betForm.forEach(function (value) {
      var MID = value.uniqueId;
      $("[id=" + MID + "]").closest('.c-bet-item').addClass('active');
    });
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('number', function (value, decimalParam) {
  var accounting = __webpack_require__(12);
  var decimal = typeof decimalParam !== 'undefined' ? decimalParam : 2;
  decimal = value == 0 ? 0 : decimal;
  if (value == '-') {
    return value;
  }

  return accounting.formatNumber(parseFloat(value), decimal, ',');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('odd', function (value, decimalParam) {
  return parseFloat(value).toFixed(2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('ccl', function (value, decimalParam) {
  var accounting = __webpack_require__(12);
  if (value) {
    var decimal = typeof decimalParam !== 'undefined' ? decimalParam : 2;
    if (window.account._showDecimals) {
      if (typeof value === "string") {
        value = parseFloat(value.split(',').join(''));
      }
    } else {
      if (typeof value == "string") {
        value = Math.floor(parseFloat(value.split(',').join('')));
      } else if (typeof value === "number") {
        value = Math.floor(value);
      }
    }
    decimal = value == 0 ? 0 : decimal;
    if (value == '-') {
      return value;
    }
  }
  return accounting.formatNumber(Math.floor((value * 100).toFixed(2)) / 100, decimal, ',');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('roundUpNumber', function (value, isRoundUp) {
  if (value == '-') {
    return value;
  }

  var accounting = __webpack_require__(12);
  var decimal = 0;

  isRoundUp = typeof isRoundUp === 'undefined' ? true : isRoundUp;

  value = isRoundUp ? Math.ceil(parseFloat(value)) : Math.floor(parseFloat(value));

  return accounting.formatNumber(value, decimal, ',');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('kSeperator', function (value) {
  if (value == '-' || value == 0) {
    return '-';
  }
  value = value.toString();
  if (value.length > 3) {
    return value.substr(0, value.length - 3) + 'k';
  } else {
    return value;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('decimal', function (value, decimalParam) {
  var accounting = __webpack_require__(12);
  var decimal = typeof decimalParam !== 'undefined' ? decimalParam : 2;

  if (value == '-') {
    return value;
  }

  return accounting.formatNumber(parseFloat(value), decimal, ',');
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_mixins_allBet__ = __webpack_require__(4);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('handicap', {
  name: 'handicap',
  template: '\n    <span class="txt">\n      <template v-if="event.od">\n        <template v-if="event.od[plyType]">\n          <template v-if="event.od[plyType][betType]">\n            <template v-if="event.od[plyType][betType][matchId]">\n              <template v-if="event.od[plyType][betType][matchId].fav == favTeam">\n                <template v-if="(betType==1 || betType==8) && hdp!=\'0\'">\n                  -{{ hdp }}\n                </template>\n                <template v-else>\n                  {{ hdp }}\n                </template>\n              </template>\n              <template v-else>\n                <template v-if="(betType==1 || betType==8) && hdp!=\'0\'">\n                  +{{ hdp }}\n                </template>\n                <template v-else-if="(betType==1 || betType==8)" >\n                  {{ hdp }}\n                </template>\n              </template>\n            </template>\n          </template>\n        </template>\n      </template>\n    </span>\n  ',
  props: {
    event: null,
    plyType: null,
    betType: null,
    match: null,
    favTeam: {
      type: String,
      default: 'a' },
    showType: null
  },
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (this.match == 0 || this.match == 'a') this.matchId = 'a';else if (this.match == 1 || this.match == 'b') this.matchId = 'b';else if (this.match == 2 || this.match == 'c') this.matchId = 'c';else this.matchId = 'd';
      },

      deep: true,
      immediate: true
    }
  },
  computed: {
    hdp: function hdp(val) {
      var split = val.event.od[val.plyType][val.betType][val.matchId].hdp.split('/', 2);
      var returnValue = '';
      if (split.length > 1) {
        return split[0] + '/' + split[1];
      } else {
        return split[0];
      }
    }
  },
  data: function data() {
    return {
      matchId: null
    };
  },

  method: {}
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax_http_interceptor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_apps_core_core_vue__ = __webpack_require__(25);


__webpack_require__(38).polyfill();







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
	data: function data() {
		return {
			_: _,
			langSelected: window._cookie
		};
	}
});


/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	components: { Core: __WEBPACK_IMPORTED_MODULE_4__vue_apps_core_core_vue__["a" /* default */] }
}));

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    teamMouseOver: function teamMouseOver(event) {
      if (event) {
        var elem = $('.sportTable').find('#' + event.eveid);
        if (elem.length > 0) {
          elem.css("display", "block");
        }
      }
    },
    teamMouseLeave: function teamMouseLeave(event) {
      if (event) {
        var elem = $('.sportTable').find('#' + event.eveid);
        if (elem.length > 0) {
          elem.css("display", "");
        }
      }
    },
    favourite: function favourite(event, isrb) {
      this.$store.commit('FAVOURITEEVENT', { event: event, isrb: isrb });
      if (this.$store.getters.showFavEvents) {
        this.$store.dispatch('getSportOdds', {
          showfavorite: true,
          callback: function (res) {
            __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
          }.bind(this)
        });
      }

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.favouriteEvents).length <= 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.favouriteLgeEvents).length <= 0 && this.$store.getters.showFavEvents == true) {
        __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('changemain', true);
      }
    },
    favouritelgeve: function favouritelgeve(lgeid, wevent, isrb, eventObj) {
      wevent.preventDefault();
      wevent.stopPropagation();
      var lgChk = $(wevent.target).hasClass('added');
      this.$store.commit('FAVOURITELGEVENT', { lgeid: lgeid, lgeChk: lgChk, isrb: isrb, eventObj: eventObj });

      if (this.$store.getters.showFavEvents) {
        this.$store.dispatch('getSportOdds', {
          showfavorite: true,
          callback: function (res) {
            __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
          }.bind(this)
        });
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.favouriteEvents).length <= 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.favouriteLgeEvents).length <= 0 && this.$store.getters.showFavEvents == true) {
        __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('changemain', true);
      }
    },
    lgFavorite: function lgFavorite(lgId, btPage, favouriteLgeEvents) {
      var lgeFav = false;
      if (favouriteLgeEvents != undefined && favouriteLgeEvents[btPage] != undefined) {
        if (favouriteLgeEvents[btPage].indexOf(lgId) !== -1) {
          lgeFav = true;
        }
      }
      return lgeFav;
    },
    favouriteOtr: function favouriteOtr(event, sportId, wevent) {
      wevent.preventDefault();
      wevent.stopPropagation();
      this.$store.commit('FAVOURITEOTREVENT', { eveId: event, selectedSport: sportId });

      __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('sportSelectedAllBetChange', true);
      this.$store.dispatch('getSportOutrightOdds', {
        callback: function (res) {
          __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
        }.bind(this)
      });
    },
    otrFavorite: function otrFavorite(eId, btPage, favouriteOTREvents) {
      var lgeFav = false;
      if (favouriteOTREvents != undefined && favouriteOTREvents[btPage] != undefined) {
        if (favouriteOTREvents[btPage].indexOf(eId) !== -1) {
          lgeFav = true;
        }
      }
      return lgeFav;
    },
    lgAllBetFavorite: function lgAllBetFavorite(lgMatches) {
      var lgeFav = true;
      if (lgMatches.isFavourite == undefined || !lgMatches.isFavourite) {
        lgeFav = false;
      }
      return lgeFav;
    },
    showForecast: function showForecast(event, windowEvent) {
      this.$store.commit('SPORTFORECAST_TOGGLE', true);
      this.$store.commit('SPORTFORECAST_SELECTEDEVENT', event);
      this.$store.commit('SPORTFORECAST_WINDOWEVENT', windowEvent);
      __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('SHOW_FORECAST', event);

      if (this.$store.getters.betForm.length > 0 && !this.$store.getters.betting.success) {
        __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('FORECAST_GETWAITINGLIST', event);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('FORECAST_GETWAITINGLIST', null);
      }
    }
  }
});

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateSpecialRBTimer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




var validateSpecialRBTimer = function validateSpecialRBTimer(event, timerHour, timerMin) {
    if (event.lgeflag == '1' && event.rbinfo.htst == '1' && (timerHour >= 1 || timerMin >= 50)) {
        return true;
    }

    return false;
};



/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);




$.ajaxSetup({
  beforeSend: function beforeSend(xhr, settings) {
    var index = '';
    var token_val = '';
    var valid = '';
    if (settings.data) {
      var url = settings.data;
    } else if (settings.type == 'GET') {
      var url = settings.url;
    }

    if (url) {
      var valid = url.indexOf("&");
      if (valid >= 0) {
        var suburl = url.split('&');
        var delimiter = '&';
      } else {
        var suburl = url.split('?');
        var delimiter = '?';
      }

      suburl.forEach(function (value, i) {
        if (value.substring(0, 6) == 'token=') {
          index = i;
          token_val = value.split('=');
          if (settings.data) {
            settings.data = url.replace(delimiter + suburl[index], "");
          } else if (settings.type == 'GET') {
            settings.url = url.replace(delimiter + suburl[index], "");
          }
          xhr.setRequestHeader('TOKEN', decodeURIComponent(token_val[1]));
        }
      });
    }

    if ($.inArray(settings.type, ['POST', 'PUT', 'DELETE', 'PATCH']) > -1) {
      if (!_.isUndefined(settings.data)) {
        var csrf = {
          'csrf_name': function () {
            return $('meta[name="csrf_name"]').attr('content');
          }(),
          'csrf_value': function () {
            return $('meta[name="csrf_value"]').attr('content');
          }()
        };
        settings.data += '&' + $.param(csrf);
      }
      return true;
    }
  }
});

$(document).ajaxSuccess(function (event, xhr, options) {
  if (!_.isUndefined(xhr.responseJSON)) {
    if (xhr.responseJSON.redirect) {
      window.location.href = xhr.responseJSON.redirect;
    }
  }
});

$(document).ajaxComplete(function (event, xhr, options) {
  if (xhr.getResponseHeader('X-Auth') == '0') {
    window.location = 'login';
  }

  if (xhr.getResponseHeader('X-Csrf-Name') && xhr.getResponseHeader('X-Csrf-Value')) {
    var csrf = {
      'csrf_name': xhr.getResponseHeader('X-Csrf-Name'),
      'csrf_value': xhr.getResponseHeader('X-Csrf-Value')
    };

    $.each(csrf, function (k, v) {
      $('meta[name="' + k + '"]').attr('content', v);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$ajax = $.ajax;

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportTeamColumn_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f593429_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportTeamColumn_vue__ = __webpack_require__(425);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportTeamColumn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f593429_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportTeamColumn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportTimeColumn_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988561d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportTimeColumn_vue__ = __webpack_require__(424);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportTimeColumn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988561d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportTimeColumn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mini_bet_vue__ = __webpack_require__(165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6299c0e0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mini_bet_vue__ = __webpack_require__(344);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6299c0e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mini_bet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6299c0e0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mini_bet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);












__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('odd1x2', {
  components: {
    minibet: __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['sportMiniBet', 'changeOdds', 'isChangeTemplate', 'ShowUpDown']), {
    betForm: function betForm() {
      return this.$store.getters.betForm[0];
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__["a" /* default */]],
  name: 'odd1x2',
  template: '\n    <div :id="getOddUniqueId(event)" class="odds od2" :class="[getOdCls(mode,betType,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);">\n      <div  v-if="mode==\'ab\'||mode==\'simple\'" :style="(betType >= 59 && betType <= 73) ? \'padding: 17px 45%;\' : (mode==\'ab\')? \'padding:45%;\' : \'padding:50%;\'" :title=" getTitle(event.tacapt, event.tbcapt, team) "></div>\n        <template v-if="event.od[plyType]">\n          <template v-if="event.od[plyType][betType]">\n            <template v-if="event.od[plyType][betType][\'odds\'+team]">\n              <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">\n                <span>{{ getDecimalDisplay(betForm.odd) }}</span>\n              </template>\n              <template v-else>\n                <template v-if="mode==\'ab\'">\n                  <div class="">\n                    <span class="yb-family-odds yb-number-bold match_details"> <!-- up/down : odds updown-->\n                    {{ getDecimalDisplay(event.od[plyType][betType][\'odds\'+team]) }}\n                    </span>\n                  </div>\n                </template>\n                <template v-else>\n                  <span>{{ getDecimalDisplay(event.od[plyType][betType][\'odds\'+team]) }}</span>\n                  <div class="odds-arrows-wrap">\n                    <div class="odds-icon odds-up"></div>\n                    <div class="odds-icon odds-down"></div>\n                  </div>\n                </template>\n              </template>\n            </template>\n            <template v-else-if="event.od[plyType][betType][\'a\']">\n              <template v-if="event.od[plyType][betType][\'a\'][\'odds\'+team]">\n                <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">\n                  <span>{{ getDecimalDisplay(betForm.odd) }}</span>\n                </template>\n                <template v-else>\n                  <template v-if="mode==\'ab\'">\n                    <div class="">\n                      <span class="yb-family-odds yb-number-bold match_details"> <!-- up/down : odds updown-->\n                        {{ getDecimalDisplay(event.od[plyType][betType][\'a\'][\'odds\'+team]) }}\n                      </span>\n                    </div>\n                  </template>\n                  <template v-else>\n                    <span>{{ getDecimalDisplay(event.od[plyType][betType][\'a\'][\'odds\'+team]) }}</span>\n                    <div class="odds-arrows-wrap">\n                      <div class="odds-icon odds-up"></div>\n                      <div class="odds-icon odds-down"></div>\n                    </div>\n                  </template>\n                </template>\n              </template>\n              <template v-else>\n                <div class="lock m-icon"></div>\n              </template>\n            </template>\n            <template v-else>\n              <div class="lock m-icon" style="margin: auto;"></div>\n            </template>\n          </template>\n          <template v-else>\n            <div class="lock m-icon"  style="margin: auto;"></div>\n          </template>\n        </template>\n        <template v-else>\n          <div class="lock m-icon"  style="margin: auto;"></div>\n        </template>\n      </template>\n    </div>\n  ',

  props: {
    event: null,
    team: null,
    plyType: null,
    betType: null,
    mode: null
  },
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (this.isDefinedOdds(val)) {
          if (this.betType >= 59 && this.betType <= 73) {
            this.classNegative(val.od[this.plyType][this.betType]['a']['odds' + this.team]);
          } else {
            this.classNegative(val.od[this.plyType][this.betType]['odds' + this.team]);
          }

          if (oldVal && !this.isChangeTemplate) {
            this.refreshOdd = false;
            if (this.isDefinedOdds(oldVal)) {
              if (this.betType >= 59 && this.betType <= 73) {
                this.diffOddsUpDown(val.od[this.plyType][this.betType]['a']['odds' + this.team], oldVal.od[this.plyType][this.betType]['a']['odds' + this.team]);
                this.diffOdds(val.od[this.plyType][this.betType]['a']['odds' + this.team], oldVal.od[this.plyType][this.betType]['a']['odds' + this.team]);
              } else {
                this.diffOddsUpDown(val.od[this.plyType][this.betType]['odds' + this.team], oldVal.od[this.plyType][this.betType]['odds' + this.team]);
                this.diffOdds(val.od[this.plyType][this.betType]['odds' + this.team], oldVal.od[this.plyType][this.betType]['odds' + this.team]);
              }
            }
          } else if (this.refreshOdd) {
            this.refreshOdd = false;
            this.isDiff = false;
          } else if (!oldVal) {
            this.refreshOdd = true;
          }
        } else {
          this.isClosePause = true;
        }
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      isNegative: false,
      isDiff: false,
      isUp: false,
      isClosePause: false,
      matchId: null,
      refreshOdd: false
    };
  },

  methods: {
    getOdCls: function getOdCls(mode, bt, event) {
      var a = ' odds-default';
      if (mode == 'ab') {
        a += ' odds-ou yb-number-font';
        a += ' odds-sc';
        if (bt == '4' || bt == '11' || bt == '12' || bt == '13') {
          a += ' ab-right';
        }
      } else {
        if (jQuery.inArray(bt, ['4', '11', '3', '9', '7', '16', '46', '47', '48', '49', '32', '33', '38', '39', '34', '35', '30', '31']) != '-1') {
          a += ' c-right';
        } else if (bt == '12' || bt == '13') {
          a += ' c-center';
        }
      }

      return a;
    },
    getTitle: function getTitle(Ta, Tb, team) {
      if (this.betType == '65' || this.betType == '66') {
        if (this.team == 'ha') {
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
        } else if (this.team == 'hb') {
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
        } else if (this.team == 'da') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
        } else if (this.team == 'db') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
        } else if (this.team == 'aa') {
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
        } else {
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
        }
      } else if (this.betType == '67' || this.betType == '68') {
        if (this.team == 'ha') {
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
        } else if (this.team == 'hb') {
          return this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
        } else if (this.team == 'da') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
        } else if (this.team == 'db') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
        } else if (this.team == 'aa') {
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
        } else {
          return this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
        }
      } else if (this.betType == this.h1x2BetType || this.betType == this.rh1x2BetType) {
        if (team == 'h') {
          return Ta;
        } else if (team == 'a') {
          return Tb;
        } else {
          var hdp = this.event.od[this.plyType][this.betType]['hdp'];
          if (hdp > 0) {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'];
          } else {
            var newHdp = parseInt(hdp) * -1;
            var awayHdp = '';

            if (newHdp > 0) {
              awayHdp = '+' + newHdp;
            } else if (newHdp < 0) {
              awayHdp = newHdp;
            }
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' ' + awayHdp;
          }
        }
      }

      var title = '';
      if (team == 'h') {
        title = Ta;
      } else if (team == 'a') {
        title = Tb;
      }
      var parser = new DOMParser();
      return parser.parseFromString(title, "text/html").body.textContent;
    },
    getClass: function getClass(event, isNeg, isDif, isUp, isClosePause) {
      var classStr = '';
      var classMini = '';

      if (this.changeOdds && this.ShowUpDown == true) {
        if (this.refreshOdd && isDif) {
          classStr = 'indicator';
        }
      } else if (isClosePause) {
        classStr = '';
      } else {
        if (!this.isChangeTemplate && isDif && this.ShowUpDown == true) {
          if (isUp) {
            classStr = 'up';
          } else {
            classStr = 'down';
          }
        }
      }

      return classStr + classMini;
    },
    getOddUniqueClass: function getOddUniqueClass(event) {
      var classStr = '';

      if (this.isNegative) {
        classStr += 'ngve ';
      }

      if (this.isDiff) {
        classStr += 'diff ';
      }

      classStr += this.getOddUniqueId(event);
      return classStr;
    },
    getUniqueMID: function getUniqueMID(event) {
      return event.eveid + this.plyType + this.betType + this.team;
    },
    getOddUniqueId: function getOddUniqueId(event) {
      return event.eveid + this.plyType + this.betType + this.team;
    },
    onClickOdd: function onClickOdd(windowEvent) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('returnBetTab');
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return;
      }
      if (this.event.od[this.plyType][this.betType] == undefined) {
        return;
      } else if (this.betType >= 59 && this.betType <= 73 && this.event.od[this.plyType][this.betType]['a']['odds' + this.team] <= 0) {
        return;
      } else if (this.$store.getters.account.oddsType != 'in' && this.$store.getters.account.oddsType != 'my' && this.$store.getters.account.oddsType != 'am' && this.event.od[this.plyType][this.betType]['odds' + this.team] <= 0) {
        return;
      }

      if (!this.account.previewFlag) {
        var _hdp = '0';
        if (this.betType == '21' || this.betType == '27') {
          _hdp = this.event.od[this.plyType][this.betType]['hdp'];
        }
        var od = '';

        if (this.betType == '65' || this.betType == '66') {
          od = this.event.od[this.plyType][this.betType]['a']['odds' + this.team];
        } else {
          od = this.event.od[this.plyType][this.betType]['odds' + this.team];
        }

        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang,
          eveid: this.event.eveid,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          plyType: this.plyType,
          betType: this.betType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          odd: od,
          rbscoa: 0,
          rbscob: 0,
          hdp: _hdp,

          dual: 'a',
          fav: '0',
          uniqueId: this.event.eveid + this.plyType + this.betType + this.team,
          eventObj: this.event
        };

        if (this.event.rb) {
          if (this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa;
            betForm.rbscob = this.event.rbinfo.scob;
          }
        }

        if (this.betType == '65' || this.betType == '66') {
          if (this.team == 'ha') {
            betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
            betForm.tbetid = 'ha';
            betForm.tbet = 'ha';
          } else if (this.team == 'hb') {
            betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
            betForm.tbetid = 'hb';
            betForm.tbet = 'hb';
          } else if (this.team == 'da') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
            betForm.tbetid = 'da';
            betForm.tbet = 'da';
          } else if (this.team == 'db') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
            betForm.tbetid = 'db';
            betForm.tbet = 'db';
          } else if (this.team == 'aa') {
            betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
            betForm.tbetid = 'aa';
            betForm.tbet = 'aa';
          } else {
            betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
            betForm.tbetid = 'ab';
            betForm.tbet = 'ab';
          }
        } else if (this.betType == '67' || this.betType == '68') {
          if (this.team == 'ha') {
            betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
            betForm.tbetid = 'ha';
            betForm.tbet = 'ha';
          } else if (this.team == 'hb') {
            betForm.tbetcapt = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
            betForm.tbetid = 'hb';
            betForm.tbet = 'hb';
          } else if (this.team == 'da') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
            betForm.tbetid = 'da';
            betForm.tbet = 'da';
          } else if (this.team == 'db') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
            betForm.tbetid = 'db';
            betForm.tbet = 'db';
          } else if (this.team == 'aa') {
            betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
            betForm.tbetid = 'aa';
            betForm.tbet = 'aa';
          } else {
            betForm.tbetcapt = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
            betForm.tbetid = 'ab';
            betForm.tbet = 'ab';
          }
        } else {
          if (this.team == 'd') {
            betForm.tbetcapt = this.$store.getters.sportTableLang.table['SPORT_TABLE.DRAW'];
            betForm.tbetid = 'x';
            betForm.tbet = 'x';
          } else if (this.team == 'h') {
            betForm.tbetcapt = this.event.tacapt;
            betForm.tbetid = this.event['taid'];
            betForm.tbet = 'a';
          } else {
            betForm.tbetcapt = this.event.tbcapt;
            betForm.tbetid = this.event['tbid'];
            betForm.tbet = 'b';
          }
        }

        if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket;
          betForm.plytypcapt = '(' + market.betLang + ') ' + this.plyType;
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {}

        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,
          'tbet': betForm.tbet
        });
        if (indexx > -1) {
          var obj = { eveid: this.event.eveid };
          if (this.$store.getters.isBetCombo) {
            obj = { clearType: '3', index: indexx };
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            data: obj,
            callback: function () {
              _this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: _this.event.eveid
              });
              var MID = $(windowEvent.target).closest('div[id]')[0].id;

              $("[id=" + MID + "]").closest('.c-bet-item.active').removeClass('active');
              if (_this.$store.getters.betForm.length <= 0) {

                _this.$store.commit("OPEN_BETFORM", false);
                _this.$store.commit('ODD_SELECTED', false);
                _this.$store.commit("SHOW_BETFORM_MENU", false);
                _this.$store.commit('SELECTED_TAB', 'betTab');
                return;
              } else {
                _this.$store.commit('OPEN_BETFORM', true);
              }
              _this.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this.$store.getters.betForm
                  });
                }.bind(_this)
              });
            }.bind(this)
          });
        } else {
          if (this.$store.getters.isBetCombo && this.$store.getters.betForm.length == this.betComboMax) {
            var chkRes = this.checkBetComboMax(betForm);
            if (chkRes) {
              return;
            }
          }

          if (this.$store.getters.selectedBettype.betTypId == '5' && this.$store.getters.betting.minMax != undefined && this.$store.getters.betting.minMax.maxCombo != undefined) {
            if (this.$store.getters.betForm.length == this.$store.getters.betting.minMax.maxCombo) {
              var vue = this;
              var maxMulpComboMsg = this.$store.getters.betLang['BETTING.HIT_MAX_COMBO'];
              this.$store.commit('DIALOG_TOGGLE', {
                show: true,
                msg: maxMulpComboMsg
              });

              setTimeout(function () {
                vue.$store.commit('DIALOG_TOGGLE', { reset: true });
              }, 5000);
              return;
            }
          }

          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: function (res) {
              _this.$store.commit('OPEN_BETFORM', true);
              _this.oddSelectHighlight(windowEvent, betForm);

              if (res.SYSTEM_DATA.status != 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                  if (_this.$store.getters.sportMiniBet.toggle) {
                    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('expandMini');
                  }
                }
                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                  __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }
                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                });

                if (_this.$store.getters.isBetCombo && _this.$store.getters.betForm.length > 1) {
                  __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('clearAllBetComboAmount');
                  __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }
                if (windowEvent) {
                  _this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_cen'),
                    eveid: _this.event.eveid
                  });
                }
              } else if (res.SYSTEM_DATA.status == 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                }

                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                }
                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                });
                if (windowEvent) {
                  _this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: _this.event.eveid
                  });
                }
              }
            }.bind(this)
          });
        }
      }
    },
    classNegative: function classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false;
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    diffOddsUpDown: function diffOddsUpDown(val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false;
    },
    isDefinedOdds: function isDefinedOdds(val) {
      var isDefinedOdds = false;
      if (typeof val.od != 'undefined') {
        if (typeof val.od[this.plyType] != 'undefined') {
          if (this.betType >= 59 && this.betType <= 73) {
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType]['a']['odds' + this.team] != 'undefined') {
                isDefinedOdds = true;
              }
            }
          } else {
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType]['odds' + this.team] != 'undefined') {
                isDefinedOdds = true;
              }
            }
          }
        }
      }
      return isDefinedOdds;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on(['refreshOdd'], function (params) {
      if (params == false) {
        _this2.refreshOdd = false;
      } else {
        _this2.refreshOdd = true;
      }
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on(['diffOdd'], function (params) {
      if (typeof _this2.event.all == 'undefined') {
        if (_this2.isDefinedOdds(_this2.event) && _this2.isDefinedOdds(params)) {
          _this2.diffOddsUpDown(params.od[_this2.plyType][_this2.betType]['odds' + _this2.team], _this2.event.od[_this2.plyType][_this2.betType]['odds' + _this2.team]);
          _this2.diffOdds(params.od[_this2.plyType][_this2.betType]['odds' + _this2.team], _this2.event.od[_this2.plyType][_this2.betType]['odds' + _this2.team]);
          _this2.$forceUpdate();
        }
      }
    }.bind(this));
  },
  mounted: function mounted() {
    this.$store.getters.betForm.forEach(function (value) {
      var MID = value.uniqueId;
      $("[id=" + MID + "]").closest('.c-bet-item').addClass('active');
    });
  }
});

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    sportMatchCount: function sportMatchCount(sprtId, market) {
      var sprtEvents = market == this.$store.getters.market.inPlayMarket.key ? this.$store.getters.sportInPlayEvents : this.$store.getters.sportAllEvents;
      if (sprtEvents) {
        if (sprtId.indexOf('G') >= 0) {
          if (sprtId == 'G1') {
            var bk = sprtEvents[2] ? sprtEvents[2] : 0;
            var amft = sprtEvents[13] ? sprtEvents[13] : 0;
            return bk + amft;
          } else if (sprtId == 'G2') {
            var crk = sprtEvents[7] ? sprtEvents[7] : 0;
            var ichk = sprtEvents[14] ? sprtEvents[14] : 0;
            var hb = sprtEvents[19] ? sprtEvents[19] : 0;
            var esp = sprtEvents[20] ? sprtEvents[20] : 0;
            return crk + ichk + hb + esp;
          } else {
            return 0;
          }
        } else {
          return sprtEvents[sprtId.slice(1)] ? sprtEvents[sprtId.slice(1)] : 0;
        }
      } else {
        return 0;
      }
    },
    resetSportBettype: function resetSportBettype() {
      this.$store.commit('BETTYPELIST', _.filter(this.$store.getters.sportBettypeList, {
        'sprtId': this.$store.getters.selectedSport.sprtId
      }));
      this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.$store.getters.bettypeList[0]));
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todayHeader_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ec2ba5f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todayHeader_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todayHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ec2ba5f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todayHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_mixins_allBet__ = __webpack_require__(4);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('over-under', {
  mixins: [__WEBPACK_IMPORTED_MODULE_1__vue_mixins_allBet__["a" /* default */]],
  name: 'over-under',
  template: '\n    <span class="txt">\n      <template v-if="event.od">\n        <template v-if="event.od[plyType]">\n          <template v-if="event.od[plyType][betType]">\n            <template v-if="event.od[plyType][betType][matchId]">\n              <template v-if="oddValidation(event)">\n                {{ ou }}\n              </template>\n            </template>\n          </template>\n        </template>\n      </template>\n    </span>\n  ',
  props: {
    event: null,
    plyType: null,
    betType: null,
    match: null,
    lang: null,
    ouType: null
  },
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (this.match == 0 || this.match == 'a') this.matchId = 'a';else if (this.match == 1 || this.match == 'b') this.matchId = 'b';else if (this.match == 2 || this.match == 'c') this.matchId = 'c';else this.matchId = 'd';
      },

      deep: true,
      immediate: true
    }
  },
  computed: {
    ou: function ou(val) {
      var split = val.event.od[val.plyType][val.betType][val.matchId].hdp.split('/', 2);
      var returnValue = '';
      if (split.length > 1) {
        returnValue = split[0] + '/' + split[1];
      } else {
        returnValue = split[0];
      }

      return val.lang ? val.lang : returnValue;
    }
  },
  data: function data() {
    return {
      matchId: null
    };
  },

  methods: {
    oddValidation: function oddValidation(event) {
      var param = {};
      param.odds = parseFloat(event.od[this.plyType][this.betType][this.matchId][this.team]);
      param.hdp = event.od[this.plyType][this.betType][this.matchId]['hdp'];
      param.bettype = parseInt(this.betType);
      param.oddstype = this.$store.getters.selectedBettype.betTypId == 5 ? this.$store.getters.oddTypesList.EU.key : this.$store.getters.account.oddsType;
      return this.validateOddHdp(param);
    }
  }
});

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    computedBetType: function computedBetType(wager, args) {
      var display = wager.betTypCap;
      if (wager.betTypId == this.otrBetType) {
        return wager.otrCap;
      }

      if (wager.plyTypId != '1' && wager.betTypId != this.mulpBetType) {
        display += ' -' + wager.plyTypCap;
      }
      if (args) {
        if (args.isBetslip) {
          return display;
        }
      }
      return '[' + display + ']';
    },
    computedTeamBet: function computedTeamBet(wager) {
      var display = wager.tbetCap;

      if (wager.betTypId == this.htftBetType) {
        var htft = wager.tbet.split("");
        if (htft[0] === 'h' && htft[1] === 'h') {
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'];
        } else if (htft[0] === 'h' && htft[1] === 'd') {
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'];
        } else if (htft[0] === 'h' && htft[1] === 'a') {
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'];
        } else if (htft[0] === 'd' && htft[1] === 'h') {
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'];
        } else if (htft[0] === 'd' && htft[1] === 'd') {
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'];
        } else if (htft[0] === 'd' && htft[1] === 'a') {
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'];
        } else if (htft[0] === 'a' && htft[1] === 'h') {
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'];
        } else if (htft[0] === 'a' && htft[1] === 'd') {
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'];
        } else if (htft[0] === 'a' && htft[1] === 'a') {
          display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'];
        }
        return display;
      }
      return display;
    },
    computedHdp: function computedHdp(wager) {
      var hdp = wager.hdp;

      if (wager.betTypId == '1' || wager.betTypId == '8') {
        return hdp;
      } else {
        return '';
      }
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b067774_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_vue__ = __webpack_require__(411);
function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b067774_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerAllCommon_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44094270_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerAllCommon_vue__ = __webpack_require__(427);
function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerAllCommon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44094270_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerAllCommon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_more_bet_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7101f5c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_more_bet_vue__ = __webpack_require__(440);
function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_more_bet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7101f5c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_more_bet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gameBanner_vue__ = __webpack_require__(144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643d0220_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gameBanner_vue__ = __webpack_require__(305);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gameBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643d0220_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gameBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);













__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('oddDbch', {
  components: {
    minibet: __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['sportMiniBet']), {
    betForm: function betForm() {
      return this.$store.getters.betForm[0];
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__["a" /* default */]],
  name: 'oddDbch',
  template: '\n    <div :id="getOddUniqueId(event)" class="odds od2" :class="[getOdCls(mode,betType,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);">\n      <div v-if="checkTitleBt()" style="padding: 17px 45%;" :title="getTitle()"></div>\n      <template v-if="event.od"> \n        <template v-if="event.od[plyType]">\n          <template v-if="event.od[plyType][betType]">\n            <template v-if="event.od[plyType][betType][matchId]">\n              <template v-if="checkOddValidation(event.od[plyType][betType][matchId][team])">\n                <span class="yb-family-odds yb-number-bold match_details">\n                  {{ getDecimalDisplay(event.od[plyType][betType][matchId][team]) }}\n                </span>\n              </template>\n              <template v-else>\n                <div class="lock m-icon"  style=""></div>\n              </template>\n            </template>\n            <template v-else>\n              <template v-if="event.od[plyType][betType][team+\'od\']">\n                <template v-if="checkOddValidation(event.od[plyType][betType][team+\'od\'])">\n                  <!-- <div class="oddsBet abcs" :class="getClass(event, isNegative, isDiff, isUp)" @click="onClickOdd($event);"> -->\n                    <span class="yb-family-odds yb-number-bold match_details">\n                      {{ getDecimalDisplay(event.od[plyType][betType][team+\'od\']) }}\n                    </span>\n                  <!-- </div> -->\n                </template>\n                <template v-else>\n                  <div class="lock m-icon"  style="margin: auto;"></div>\n                </template>\n              </template>\n              <template v-else>\n                <div class="lock m-icon"  style="margin: auto;"></div>\n              </template>\n            </template>\n          </template>\n          <template v-else>\n            <div class="lock m-icon"  style="margin: auto;"></div>\n          </template>\n        </template>\n        <template v-else>\n          <div class="lock m-icon"  style="margin: auto;"></div>\n        </template>\n      </template>\n    </div>\n  ',
  props: {
    event: null,
    team: null,
    plyType: null,
    betType: null,
    mode: null,
    match: null
  },
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (this.match == 0 || this.match == 'a') this.matchId = 'a';else if (this.match == 1 || this.match == 'b') this.matchId = 'b';else if (this.match == 2 || this.match == 'c') this.matchId = 'c';else this.matchId = 'd';

        if ([this.dbchBetType, this.rdbchBetType].indexOf(this.betType.toString()) !== -1) {
          this.matchId = 'a';
        }

        if (this.isDefinedOdds(val)) {
          if (this.betType >= 59 && this.betType <= 73) {
            this.classNegative(val.od[this.plyType][this.betType][this.matchId][this.team]);
          } else {
            this.classNegative(val.od[this.plyType][this.betType][this.team + 'od']);
          }

          if (oldVal && !this.refreshOdd) {
            this.refreshOdd = false;
            if (this.isDefinedOdds(oldVal)) {
              if (this.betType >= 59 && this.betType <= 73) {
                this.diffOddsUpDown(val.od[this.plyType][this.betType][this.matchId][this.team], oldVal.od[this.plyType][this.betType][this.matchId][this.team]);
                this.diffOdds(val.od[this.plyType][this.betType][this.matchId][this.team], oldVal.od[this.plyType][this.betType][this.matchId][this.team]);
              } else {
                this.diffOddsUpDown(val.od[this.plyType][this.betType][this.team + 'od'], oldVal.od[this.plyType][this.betType][this.team + 'od']);
                this.diffOdds(val.od[this.plyType][this.betType][this.team + 'od'], oldVal.od[this.plyType][this.betType][this.team + 'od']);
              }
            }
          } else if (this.refreshOdd) {
            this.refreshOdd = false;
            this.isDiff = false;
          } else if (!oldVal) {
            this.refreshOdd = true;
          }
        } else {
          this.isClosePause = true;
        }
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      isNegative: false,
      isDiff: false,
      isUp: false,
      isClosePause: false,
      matchId: null,
      refreshOdd: false
    };
  },

  methods: {
    getOdCls: function getOdCls(mode, bt, event) {
      var a = ' odds-default';
      if (mode == 'ab') {
        a += ' odds-ou yb-number-font';
        a += ' odds-sc';
        if (bt == '4' || bt == '11' || bt == '12' || bt == '13') {
          a += ' ab-right';
        }
      } else {
        if (jQuery.inArray(bt, ['4', '11', '3', '9', '7', '16', '46', '47', '48', '49', '32', '33', '38', '39', '34', '35', '30', '31']) != '-1') {
          a += ' c-right';
        } else if (bt == '12' || bt == '13') {
          a += ' c-center';
        }
      }

      return a;
    },
    getClass: function getClass(windowEvent, isNeg, isDif, isUp, isClosePause) {
      var classStr = '';
      var classMini = '';

      if (this.changeOdds) {
        if (!this.refreshOdd && isDif) {
          classStr = 'indicator';
        }
      } else if (isClosePause) {
        classStr = '';
      } else {
        if (!this.refreshOdd && isDif) {
          if (isUp) {
            classStr = 'up';
          } else {
            classStr = 'down';
          }
        }
      }
      return classStr + classMini;
    },
    getOddUniqueClass: function getOddUniqueClass(event) {
      var classStr = '';

      if (this.isNegative) {
        classStr += 'ngve ';
      }

      if (this.isDiff) {
        classStr += 'diff ';
      }

      classStr += this.getOddUniqueId(event);
      return classStr;
    },
    getOddUniqueId: function getOddUniqueId(event) {
      if (jQuery.inArray(this.betType, ['59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73']) != '-1') {
        return event.eveid + this.plyType + this.betType + this.team + this.matchId;
      } else {
        return event.eveid + this.plyType + this.betType + this.team;
      }
    },
    getDecimalDisplay: function getDecimalDisplay(value) {
      if (this.$store.getters.account.oddsType == 'am') {
        return parseFloat(value).toFixed(0);
      }
      return parseFloat(value).toFixed(2);
    },
    onClickOdd: function onClickOdd(windowEvent) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('returnBetTab');
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return;
      }
      if (this.event.od[this.plyType][this.betType] == undefined) {
        return;
      } else if (this.betType >= 59 && this.betType <= 73 && this.event.od[this.plyType][this.betType][this.matchId][this.team] <= 0) {
        return;
      } else if (this.$store.getters.account.oddsType != 'in' && this.$store.getters.account.oddsType != 'my' && this.$store.getters.account.oddsType != 'am' && this.event.od[this.plyType][this.betType][this.team] <= 0) {
        return;
      }
      if (!this.account.previewFlag) {
        var od = '';
        var uid = '';
        if (jQuery.inArray(this.betType, ['59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73']) != '-1') {
          od = this.event.od[this.plyType][this.betType][this.matchId][this.team];
          uid = this.event.eveid + this.plyType + this.betType + this.team + this.matchId;
        } else {
          od = this.event.od[this.plyType][this.betType][this.team + 'od'];
          uid = this.event.eveid + this.plyType + this.betType + this.team;
        }

        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang,
          eveid: this.event.eveid,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          plyType: this.plyType,
          betType: this.betType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          odd: od,
          rbscoa: 0,
          rbscob: 0,
          hdp: '0',
          dual: this.matchId != null ? this.matchId : 'a',
          fav: '0',
          uniqueId: uid,
          eventObj: this.event
        };

        if (this.event.rb) {
          if (this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa;
            betForm.rbscob = this.event.rbinfo.scob;
          }
        }

        var or = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OR'];

        if (this.betType == '68' || this.betType == '69') {
          if (this.team == 'oddsha') {
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
            betForm.tbetid = 'ha';
            betForm.tbet = 'ha';
          } else if (this.team == 'oddshb') {
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
            betForm.tbetid = 'hb';
            betForm.tbet = 'hb';
          } else if (this.team == 'oddsda') {
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
            betForm.tbetid = 'da';
            betForm.tbet = 'da';
          } else if (this.team == 'oddsdb') {
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
            betForm.tbetid = 'db';
            betForm.tbet = 'db';
          } else if (this.team == 'oddsaa') {
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
            betForm.tbetid = 'aa';
            betForm.tbet = 'aa';
          } else {
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
            betForm.tbetid = 'ab';
            betForm.tbet = 'ab';
          }
        } else if (this.betType == '70' || this.betType == '71') {
          if (this.team == 'oddsha') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
            betForm.tbetid = 'ha';
            betForm.tbet = 'ha';
          } else if (this.team == 'oddshb') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
            betForm.tbetid = 'hb';
            betForm.tbet = 'hb';
          } else if (this.team == 'oddsda') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
            betForm.tbetid = 'da';
            betForm.tbet = 'da';
          } else if (this.team == 'oddsdb') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
            betForm.tbetid = 'db';
            betForm.tbet = 'db';
          } else if (this.team == 'oddsaa') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
            betForm.tbetid = 'aa';
            betForm.tbet = 'aa';
          } else {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
            betForm.tbetid = 'ab';
            betForm.tbet = 'ab';
          }
        } else if (this.betType == '72') {
          if (this.team == 'oddsha') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
            betForm.tbetid = 'ha';
            betForm.tbet = 'ha';
          } else if (this.team == 'oddshb') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
            betForm.tbetid = 'hb';
            betForm.tbet = 'hb';
          } else if (this.team == 'oddsda') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
            betForm.tbetid = 'da';
            betForm.tbet = 'da';
          } else if (this.team == 'oddsdb') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
            betForm.tbetid = 'db';
            betForm.tbet = 'db';
          } else if (this.team == 'oddsaa') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
            betForm.tbetid = 'aa';
            betForm.tbet = 'aa';
          } else {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
            betForm.tbetid = 'ab';
            betForm.tbet = 'ab';
          }
        } else {
          if (this.team == 'ha') {
            betForm.tbetcapt = this.event.tacapt + or + this.event.tbcapt;

            betForm.tbetid = 'ha';
            betForm.tbet = 'ha';
          } else if (this.team == 'hd') {
            betForm.tbetcapt = this.event.tacapt + or + this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'];

            betForm.tbetid = 'hd';
            betForm.tbet = 'hd';
          } else {
            betForm.tbetcapt = this.event.tbcapt + or + this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'];

            betForm.tbetid = 'ad';
            betForm.tbet = 'ad';
          }
        }

        if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket;
          betForm.plytypcapt = '(' + market.betLang + ') ' + this.plyType;
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {}

        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,
          'tbet': betForm.tbet
        });
        if (indexx > -1) {
          var obj = { eveid: this.event.eveid };
          if (this.$store.getters.isBetCombo) {
            obj = { clearType: '3', index: indexx };
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            data: obj,
            callback: function () {
              _this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: _this.event.eveid
              });
              var MID = $(windowEvent.target).closest('div[id]')[0].id;

              $("[id=" + MID + "]").closest('.c-bet-item.active').removeClass('active');
              if (_this.$store.getters.betForm.length <= 0) {

                _this.$store.commit("OPEN_BETFORM", false);
                _this.$store.commit('ODD_SELECTED', false);
                _this.$store.commit("SHOW_BETFORM_MENU", false);
                _this.$store.commit('SELECTED_TAB', 'betTab');
                return;
              } else {
                _this.$store.commit('OPEN_BETFORM', true);
              }
              _this.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this.$store.getters.betForm
                  });
                }.bind(_this)
              });
            }.bind(this)
          });
        } else {
          if (this.$store.getters.isBetCombo && this.$store.getters.betForm.length == this.betComboMax) {
            var chkRes = this.checkBetComboMax(betForm);
            if (chkRes) {
              return;
            }
          }

          if (this.$store.getters.selectedBettype.betTypId == '5' && this.$store.getters.betting.minMax != undefined && this.$store.getters.betting.minMax.maxCombo != undefined) {
            if (this.$store.getters.betForm.length == this.$store.getters.betting.minMax.maxCombo) {
              var vue = this;
              var maxMulpComboMsg = this.$store.getters.betLang['BETTING.HIT_MAX_COMBO'];
              this.$store.commit('DIALOG_TOGGLE', {
                show: true,
                msg: maxMulpComboMsg
              });

              setTimeout(function () {
                vue.$store.commit('DIALOG_TOGGLE', { reset: true });
              }, 5000);
              return;
            }
          }

          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: function (res) {
              _this.$store.commit('OPEN_BETFORM', true);
              _this.oddSelectHighlight(windowEvent, betForm);

              if (res.SYSTEM_DATA.status != 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                  if (_this.$store.getters.sportMiniBet.toggle) {
                    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('expandMini');
                  }
                }
                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                  __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }

                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm

                });

                if (_this.$store.getters.isBetCombo && _this.$store.getters.betForm.length > 1) {
                  __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('clearAllBetComboAmount');
                  __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }
                if (windowEvent) {
                  _this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_cen'),
                    eveid: _this.event.eveid
                  });
                }
                if (windowEvent) {
                  _this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_cen'),
                    eveid: _this.event.eveid
                  });
                }
              } else if (res.SYSTEM_DATA.status == 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                }

                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                }
                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                });
                if (windowEvent) {
                  _this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: _this.event.eveid
                  });
                }
              }
            }.bind(this)
          });
        }
      }
    },
    classNegative: function classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false;
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    diffOddsUpDown: function diffOddsUpDown(val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false;
    },
    isDefinedOdds: function isDefinedOdds(val) {
      var isDefinedOdds = false;
      if (typeof val.od != 'undefined') {
        if (typeof val.od[this.plyType] != 'undefined') {
          if (this.betType >= 59 && this.betType <= 73) {
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType][this.matchId][this.team] != 'undefined') {
                isDefinedOdds = true;
              }
            }
          } else {
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType][this.team + 'od'] != 'undefined') {
                isDefinedOdds = true;
              }
            }
          }
        }
      }
      return isDefinedOdds;
    },
    checkTitleBt: function checkTitleBt() {
      if ([this.dbchBetType, this.rdbchBetType, this.dbchftsBetType, this.dbchouBetType, this.rdbchouBetType, this.dbchbttsBetType, this.rdbchbttsBetType].indexOf(this.betType.toString()) !== -1) {
        return true;
      }
      return false;
    },
    getTitle: function getTitle() {
      if (this.betType == this.dbchftsBetType) {
        if (this.team == 'oddsha') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
        } else if (this.team == 'oddshb') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
        } else if (this.team == 'oddsda') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
        } else if (this.team == 'oddsdb') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
        } else if (this.team == 'oddsaa') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt;
        } else {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt;
        }
      } else if (this.betType == this.dbchouBetType || this.betType == this.rdbchouBetType) {
          if (this.team == 'oddsha') {
            return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
          } else if (this.team == 'oddshb') {
            return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
          } else if (this.team == 'oddsda') {
            return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
          } else if (this.team == 'oddsdb') {
            return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
          } else if (this.team == 'oddsaa') {
            return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'];
          } else {
            return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'];
          }
        } else if (this.betType == this.dbchbttsBetType || this.betType == this.rdbchbttsBetType) {
          if (this.team == 'oddsha') {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
          } else if (this.team == 'oddshb') {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
          } else if (this.team == 'oddsda') {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
          } else if (this.team == 'oddsdb') {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
          } else if (this.team == 'oddsaa') {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
          } else {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
          }
        } else if (this.betType == this.dbchBetType || this.betType == this.rdbchBetType) {
          if (this.team == 'ha') {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'];
          } else if (this.team == 'hd') {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'];
          } else {
            return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'];
          }
        }
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on(['refreshOdd'], function (params) {
      if (params == false) {
        _this2.refreshOdd = false;
      } else {
        _this2.refreshOdd = true;
      }
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on(['diffOdd'], function (params) {
      if (typeof _this2.event.all == 'undefined') {
        if (_this2.isDefinedOdds(_this2.event) && _this2.isDefinedOdds(params)) {
          _this2.diffOddsUpDown(params.od[_this2.plyType][_this2.betType][_this2.team + 'od'], _this2.event.od[_this2.plyType][_this2.betType][_this2.team + 'od']);
          _this2.diffOdds(params.od[_this2.plyType][_this2.betType][_this2.team + 'od'], _this2.event.od[_this2.plyType][_this2.betType][_this2.team + 'od']);
          _this2.$forceUpdate();
        }
      }
    }.bind(this));
  },
  mounted: function mounted() {
    this.$store.getters.betForm.forEach(function (value) {
      var MID = value.uniqueId;
      $("[id=" + MID + "]").closest('.c-bet-item').addClass('active');
    });
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('cstgftht', {
  components: {
    minibet: __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__["a" /* default */]],
  name: 'cstgftht',
  template: '\n    <div :id="getOddUniqueId(event)" class="odds" :class="[getOdCls(mode,betType,score,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);" > \n      <template v-if="event.od">\n        <template v-if="event.od[plyType]">\n          <template v-if="event.od[plyType][betType]">\n            <template v-if="event.od[plyType][betType][score]">\n              <span  :title="getTitle()" :class="{ \'yb-family-odds yb-number-bold match_details\': (mode==\'ab\' || bk.includes(betType)) }">\n                <template v-if="checkOddValidation(event.od[plyType][betType][score])">\n                  <template v-if="betType == 7 || betType == 16">\n                    <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">\n                      {{ betForm.odd }}\n                    </template>\n                    <template v-else>\n                      {{ new Number(parseFloat(event.od[plyType][betType][score])) }}\n                    </template>\n                  </template>\n                  <template v-else>\n                    <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">\n                      {{ getDecimalDisplay(betForm.odd) }}\n                    </template>\n                    <template v-else>\n                      {{ getDecimalDisplay(event.od[plyType][betType][score]) }}\n                    </template>\n                  </template> \n                </template>\n                <template v-else>\n                  <div class="icon-lock"></div>\n                </template>\n              </span>\n              <div class="odds-arrows-wrap" v-if="mode!=\'ab\'">\n                <div class="odds-icon odds-up"></div>\n                <div class="odds-icon odds-down"></div>\n              </div>\n            </template>\n            <template v-else>\n              <div class="icon-lock"></div>\n            </template>\n          </template>\n          <template v-else>\n            <div class="icon-lock"></div>\n          </template>\n        </template>\n        <template v-else>\n          <div class="icon-lock"></div>\n        </template>\n      </template>\n    </div>\n  ',

  props: {
    event: null,
    score: null,
    plyType: null,
    betType: null,
    decimalNumber: null,
    mode: null },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['sportMiniBet']), {
    betForm: function betForm() {
      return this.$store.getters.betForm[0];
    }
  }),
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (typeof val.od != 'undefined') {
          if (typeof val.od[this.plyType] != 'undefined') {
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType][this.score] != 'undefined') {
                this.classNegative(val.od[this.plyType][this.betType][this.score]);

                if (oldVal && !this.refreshOdd) {
                  this.refreshOdd = false;
                  if (typeof oldVal.od[this.plyType] != 'undefined') {
                    if (typeof oldVal.od[this.plyType][this.betType] != 'undefined') {
                      if (typeof oldVal.od[this.plyType][this.betType][this.score] != 'undefined') {
                        this.diffOddsUpDown(val.od[this.plyType][this.betType][this.score], oldVal.od[this.plyType][this.betType][this.score]);
                        this.diffOdds(val.od[this.plyType][this.betType][this.score], oldVal.od[this.plyType][this.betType][this.score]);
                      }
                    }
                  }
                } else if (this.refreshOdd) {
                  this.refreshOdd = false;
                  this.isDiff = false;
                } else if (!oldVal) {
                  this.refreshOdd = true;
                }
              } else {
                this.isClosePause = true;
              }
            }
          }
        }
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      isNegative: false,
      isDiff: false,
      isClosePause: false,
      refreshOdd: false,
      isUp: false,
      bk: ['6', '25', '53', '54', '55', '56']
    };
  },

  methods: {
    getOdCls: function getOdCls(mode, bt, score, event) {
      var a = ' odds-default';
      if (mode == 'ab') {
        a = 'yb-number-font';
        if (score == 'aos') {
          a = a + ' aosnoflex ab-right';
        }
        a = a + ' odds-default';
        if (event.sprtid == '1') {
          a = a + ' odds-sc';
        } else {
          a = a + ' odds-os';
        }
      } else {
        if (jQuery.inArray(bt, ['25']) != '-1') {
          a += ' c-center';
        } else {
          a += ' c-right';
        }
      }

      return a;
    },
    getClass: function getClass(windowEvent, isNeg, isDif, isUp, isClosePause) {
      var classStr = '';
      var classMini = '';

      if (this.changeOdds) {
        if (!this.refreshOdd && isDif) {
          classStr = 'indicator';
        }
      } else if (isClosePause) {
        classStr = '';
      } else {
        if (!this.refreshOdd && isDif) {
          if (isUp) {
            classStr = 'up';
          } else {
            classStr = 'down';
          }
        }
      }
      return classStr + classMini;
    },
    onClickOdd: function onClickOdd() {
      var _this = this;

      var windowEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('returnBetTab');
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return;
      }
      if (!this.account.previewFlag) {
        if (!this.checkOddValidation(this.event.od[this.plyType][this.betType][this.score])) {
          return;
        }
        var tg = {
          "1": {
            "tg01": this.$store.getters.sportAllBetLang['ALL_BET.LBL_01'],
            "tg23": this.$store.getters.sportAllBetLang['ALL_BET.LBL_23'],
            "tg456": this.$store.getters.sportAllBetLang['ALL_BET.LBL_46'],
            "tg7": this.$store.getters.sportAllBetLang['ALL_BET.LBL_7more']
          },
          "2": {
            "tg01": this.$store.getters.sportAllBetLang['ALL_BET.LBL_0'],
            "tg23": this.$store.getters.sportAllBetLang['ALL_BET.LBL_1'],
            "tg456": this.$store.getters.sportAllBetLang['ALL_BET.LBL_2'],
            "tg7": this.$store.getters.sportAllBetLang['ALL_BET.LBL_3more']
          }
        };

        var correct_score = this.score.split("");
        var display = "";

        if (correct_score[0] === 'o' || this.score == 'aos') {
          if (this.score == 'aos') display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AOS'];else display = correct_score[2] + " - " + correct_score[3];
        } else if (correct_score[0] === 't') {
          display = tg[this.plyType][this.score];
        } else {
          if (correct_score[0] === 'h' && correct_score[1] === 'h') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'];
          } else if (correct_score[0] === 'h' && correct_score[1] === 'd') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'];
          } else if (correct_score[0] === 'h' && correct_score[1] === 'a') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'];
          } else if (correct_score[0] === 'd' && correct_score[1] === 'h') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'];
          } else if (correct_score[0] === 'd' && correct_score[1] === 'd') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'];
          } else if (correct_score[0] === 'd' && correct_score[1] === 'a') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'];
          } else if (correct_score[0] === 'a' && correct_score[1] === 'h') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'];
          } else if (correct_score[0] === 'a' && correct_score[1] === 'd') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'];
          } else if (correct_score[0] === 'a' && correct_score[1] === 'a') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'];
          }
        }

        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang,
          eveid: this.event.eveid,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          plyType: this.plyType,
          betType: this.betType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          tbet: this.score,
          tbetcapt: display,
          odd: this.event.od[this.plyType][this.betType][this.score],
          rbscoa: 0,
          rbscob: 0,
          dual: 'a',
          fav: '0',
          hdp: '0',
          uniqueId: this.event.eveid + this.plyType + this.betType + this.score,
          eventObj: this.event
        };

        if (this.event.rb) {
          if (this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa;
            betForm.rbscob = this.event.rbinfo.scob;
          }
        }

        if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket;
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {}

        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,

          'tbet': this.score
        });
        if (indexx > -1) {
          var obj = { eveid: this.event.eveid };
          if (this.$store.getters.isBetCombo) {
            obj = { clearType: '3', index: indexx };
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            data: obj,
            callback: function () {
              _this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: _this.event.eveid
              });
              var MID = $(windowEvent.target).closest('div[id]')[0].id;
              $("[id=" + MID + "]").closest('.c-bet-item.active').removeClass('active');
              if (_this.$store.getters.betForm.length <= 0) {
                _this.$store.commit("OPEN_BETFORM", false);
                _this.$store.commit('ODD_SELECTED', false);
                _this.$store.commit("SHOW_BETFORM_MENU", false);
                _this.$store.commit('SELECTED_TAB', 'betTab');
                return;
              } else {
                _this.$store.commit('OPEN_BETFORM', true);
              }
              _this.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this.$store.getters.betForm
                  });
                }.bind(_this)
              });
            }.bind(this)
          });
        } else {
          if (this.$store.getters.isBetCombo && this.$store.getters.betForm.length == this.betComboMax) {
            var chkRes = this.checkBetComboMax(betForm);
            if (chkRes) {
              return;
            }
          }

          if (this.$store.getters.selectedBettype.betTypId == '5' && this.$store.getters.betting.minMax != undefined && this.$store.getters.betting.minMax.maxCombo != undefined) {
            if (this.$store.getters.betForm.length == this.$store.getters.betting.minMax.maxCombo) {
              var vue = this;
              var maxMulpComboMsg = this.$store.getters.betLang['BETTING.HIT_MAX_COMBO'];
              this.$store.commit('DIALOG_TOGGLE', {
                show: true,
                msg: maxMulpComboMsg
              });

              setTimeout(function () {
                vue.$store.commit('DIALOG_TOGGLE', { reset: true });
              }, 5000);
              return;
            }
          }

          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: function (res) {
              _this.$store.commit('CLEAR_BET_SUCCESS');
              _this.$store.commit('OPEN_BETFORM', true);
              _this.oddSelectHighlight(windowEvent, betForm);

              if (res.SYSTEM_DATA.status != 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                  if (_this.$store.getters.sportMiniBet.toggle) {
                    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('expandMini');
                  }
                }
                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                  __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }

                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                });

                if (_this.$store.getters.isBetCombo && _this.$store.getters.betForm.length > 1) {
                  __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('clearAllBetComboAmount');
                  __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }
                if (windowEvent) {
                  _this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: _this.event.eveid
                  });
                }
              } else if (res.SYSTEM_DATA.status == 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                }

                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                }
                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                });
                if (windowEvent) {
                  _this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: _this.event.eveid
                  });
                }
              }
            }.bind(this)
          });
        }
      }
    },
    classNegative: function classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false;
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    diffOddsUpDown: function diffOddsUpDown(val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false;
    },
    getOddUniqueClass: function getOddUniqueClass(event) {
      var classStr = '';
      if (this.plyType == '2') {
        classStr += 'ht ';
      }
      classStr += this.getOddUniqueId(event);
      return classStr;
    },
    getOddUniqueId: function getOddUniqueId(event) {
      return event.eveid + this.plyType + this.betType + this.score;
    },
    checkTitleBt: function checkTitleBt() {
      if ([this.htftBetType, this.rhtftBetType, this.wmBetType, this.rwmBetType, this.flgBetType].indexOf(this.betType.toString()) !== -1) {
        return true;
      }
      return false;
    },
    getTitle: function getTitle() {
      if (this.betType == this.htftBetType || this.betType == this.rhtftBetType) {
        if (this.score == 'hh') {
          return this.event.tacapt + '/' + this.event.tacapt;
        } else if (this.score == 'hd') {
          return this.event.tacapt + '/' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'];
        } else if (this.score == 'ha') {
          return this.event.tacapt + '/' + this.event.tbcapt;
        } else if (this.score == 'dh') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + '/' + this.event.tacapt;
        } else if (this.score == 'dd') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + '/' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'];
        } else if (this.score == 'da') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] + '/' + this.event.tbcapt;
        } else if (this.score == 'ah') {
          return this.event.tbcapt + '/' + this.event.tacapt;
        } else if (this.score == 'ad') {
          return this.event.tbcapt + '/' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'];
        } else if (this.score == 'aa') {
          return this.event.tbcapt + '/' + this.event.tbcapt;
        }
      }

      if (this.betType == this.wmBetType || this.betType == this.rwmBetType) {
        if (this.score == 'h1') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HWB1'];
        } else if (this.score == 'a1') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWB1'];
        } else if (this.score == 'h2') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HWB2'];
        } else if (this.score == 'a2') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWB2'];
        } else if (this.score == 'h3') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HWB3'];
        } else if (this.score == 'a3') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWB3'];
        } else if (this.score == 'h4') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HWB4M'];
        } else if (this.score == 'a4') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWB4M'];
        } else if (this.score == 'sd') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AS'];
        } else if (this.score == 'ng') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_NG'];
        }
      }

      if (this.betType == this.flgBetType) {
        if (this.score == 'hf') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HFG'];
        } else if (this.score == 'af') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AFG'];
        } else if (this.score == 'hl') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HLG'];
        } else if (this.score == 'al') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_ALG'];
        } else if (this.score == 'ng') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_NG'];
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on(['refreshOdd'], function (params) {
      if (params == false) {
        _this2.refreshOdd = false;
      } else {
        _this2.refreshOdd = true;
      }
    }.bind(this));
  },
  mounted: function mounted() {
    this.$store.getters.betForm.forEach(function (value) {
      var MID = value.uniqueId;
      $("[id=" + MID + "]").closest('.c-bet-item').addClass('active');
    });
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simpleSoccer_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d950d41e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleSoccer_vue__ = __webpack_require__(442);
function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simpleSoccer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d950d41e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleSoccer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bettingFormFooter_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26a0985a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bettingFormFooter_vue__ = __webpack_require__(317);
function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26a0985a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bettingFormFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26a0985a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bettingFormFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_system__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_account__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_sport__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_sport_result__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_sport_outright__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_bet__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_forecast__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_sport_minibet__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_sport_league__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_statement__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_live_channel__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_promotion__ = __webpack_require__(118);



__webpack_require__(38).polyfill();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);















/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  modules: [__WEBPACK_IMPORTED_MODULE_3__modules_system__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modules_account__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modules_sport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modules_sport_result__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modules_sport_outright__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__modules_bet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__modules_forecast__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__modules_sport_minibet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__modules_statement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__modules_sport_league__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__modules_live_channel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__modules_promotion__["a" /* default */]]
}));

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(10);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(10);


var _mutations;



var state = {
  langList: window.lang,
  requestAllow: true,
  currentTemplate: window._currentTemplate,
  customTemplate: window._customTemplate,
  tvIconFlag: window.tvIconFlag,
  gameBannerId: null
};

var getters = {
  langList: function langList(state) {
    return state.langList;
  },
  requestAllow: function requestAllow(state) {
    return state.requestAllow;
  },
  customTemplate: function customTemplate(state) {
    return state.customTemplate;
  },
  currentTemplate: function currentTemplate(state) {
    return state.currentTemplate;
  },
  tvIconFlag: function tvIconFlag(state) {
    return state.tvIconFlag;
  },
  gameBannerId: function gameBannerId(state) {
    return state.gameBannerId;
  }

};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_51" /* REQUEST_ALLOW */], function (state, payload) {
  state.requestAllow = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_3" /* GAME_BANNER_ID */], function (state, payload) {
  state.gameBannerId = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);



var _mutations;




var state = {
  account: null,
  timeZone: window._timeZone
};

var getters = {
  account: function account(state) {
    return state.account;
  },
  timeZone: function timeZone(state) {
    return state.timeZone;
  }
};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ACCOUNT */], function (state, payload) {
  payload.selectedMarket = null;
  state.account = payload;
  if (__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_acc')) {
    var accCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_acc'));
    state.account.oddsType = accCookie.oddsType;
  }
  var account = _.cloneDeep(state.account);
  _.unset(account, 'gmSttng');

  if (!__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_acc') || !__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_token') || state.account.currCL != '-' && state.account.currCL != JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_acc')).currCL || state.account.oddsType != JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_acc')).oddsType || btoa(account.acccode) != __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_token')) {
    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      async: false,
      data: {
        com_code: window.compcode,
        acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(account),
        tkn: btoa(account.acccode)
      }
    }).done(function (res) {});
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_71" /* SELECTED_ODD */], function (state, payload) {
  var accCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_acc'));
  accCookie.oddsType = payload;
  state.account = accCookie;
  var account = _.cloneDeep(state.account);
  _.unset(account, 'gmSttng');


  $.ajax({
    method: 'post',
    url: _baseUrl + '/callCookies',
    async: false,
    data: {
      com_code: window.compcode,
      acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(account)
    }
  }).done(function (res) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'TIME_ZONE', function TIME_ZONE(state, payload) {
  state.timeZone.default = payload;
  var stkset = {
    default: payload,
    timeS: state.timeZone.list[payload][0],
    timeA: state.timeZone.list[payload][1],
    format: state.timeZone.format
  };
  $.ajax({
    method: 'post',
    url: _baseUrl + '/callCookies',
    async: false,
    data: {
      action: 'timeZone',
      timeZoneSet: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(stkset),
      acc_code: state.account.acccode
    }
  }).done(function (res) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ACCOUNT_FAV */], function (state, payload) {

  $.ajax({
    method: 'post',
    url: _baseUrl + '/callCookies',
    async: false,
    data: {
      action: payload.isFavLeague == '1' ? 'favLeagueEvent' : 'favEvent',
      fav: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload.favdt),
      acc_code: this.getters.account.acccode
    }
  }).done(function (res) {});
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_core_core__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutation_types__ = __webpack_require__(10);





var _mutations;










var state = {
  eventList: [],
  otrSportList: [],
  rbeventList: [],
  favrbeventList: [],
  eventAllBet: null,
  mainMarketBet: null,
  sortedEventList: [],
  sortedRBEventList: [],
  sortedFavRbEventList: [],
  sortedMatchEventList: [],
  firstEvent: [],
  testshow: false,
  showRightBanner: true,
  totalPage: 1,
  sportList: null,
  hot_sportList: null,
  bettypeList: null,
  sportBettypeList: null,
  oddTypesList: null,
  earlyParlayDateList: null,
  selectedEarlyParlayDate: 99,
  selectedSport: null,
  selectedBettype: null,
  selectedPlytype: null,
  selectedMarket: '1',
  prevMarket: '1',
  selectedSort: '2',
  selectedShow: '2',
  selectedPage: 1,
  selectedMatchAllBet: false,
  hotSchedule: false,
  selectedAllBet: false,
  matchAllBet: false,
  selectedAllBetNew: false,
  sportTableLang: null,
  sportAllBetLang: null,
  int_fullHalfTime: 1,
  arr_leagueList: null,
  merge_leagueList: null,
  changeOdds: false,
  market: {
    inPlayMarket: {
      key: '3',
      lang: window.lang.welcomeInPlay,
      betLang: window.lang.betInPlay
    },
    tdyMarket: {
      key: '1',
      lang: window.lang.welcomeTdyMarket,
      betLang: window.lang.betTdyMarket
    },
    earlyMarket: {
      key: '2',
      lang: window.lang.welcomeEarlyMarket,
      betLang: window.lang.betEarlyMarket
    },
    hotSportMarket: {
      key: '5',
      lang: window.lang.hotSport,
      betLang: window.lang.hotSport
    },
    favMarket: {
      key: '99',
      lang: window.lang.myFav,
      betLang: window.lang.myFav
    }
  },
  sortTypes: {
    competition: {
      key: '2',
      lang: 'SPORT_TABLE.SUBHEADER_SORTBY_COMPETITION'
    },
    time: {
      key: '1',
      lang: 'SPORT_TABLE.SUBHEADER_SORTBY_TIME'
    }
  },
  sortShowTypes: {
    singleLine: {
      key: '1',
      lang: 'SPORT_TABLE.SUBHEADER_SINGLELINE'
    },
    doubleLine: {
      key: '2',
      lang: 'SPORT_TABLE.SUBHEADER_DOUBLELINE'
    },
    fullTime: {
      key: '3',
      lang: 'SPORT_TABLE.FULL_TIME'
    },
    halfTime: {
      key: '4',
      lang: 'SPORT_TABLE.HALF_TIME'
    }
  },
  marketType: {
    allMarket: {
      key: '1',
      lang: 'SPORT_TABLE.ALL_MARKET'
    },
    mainMarket: {
      key: '2',
      lang: 'SPORT_TABLE.MAIN_MARKET'
    },
    otherMarket: {
      key: '3',
      lang: 'SPORT_TABLE.OTHER_MARKET'
    }
  },
  arr_selectedLeagueList: [],
  favouriteEvents: {},
  favouriteOTREvents: {},
  favouriteOTREventsCount: 0,
  favouriteEventsCount: 0,
  favouriteRBEventsCount: 0,
  favouriteLgeEvents: {},
  sportInPlayEvents: null,
  sportAllEvents: {},
  bool_leagueToggle: false,
  showFavEvents: false,
  sportPrevIsMulp: false,
  highlightedCell: null,
  parlaySelected: null,
  isGameBannerSelected: false,
  selectedLeagues: 0,
  totalLeagues: 0,
  sportLeagueWindowEvent: null,
  moreBetLoading: false,
  moreBetToggle: [],
  allSportCount: {},
  checked: true,
  foldopenAllBet: true,
  foldopenFirstEvent: true,
  showLeagueTeam: false,
  showLeagueSearch: false,
  istodayRB: false,
  open_RBMarket: false,
  selectedInPlaySport: false,
  allBetReloading: false,
  right_allBetReloading: false,
  arr_earlyEventCountByDate: {},
  show_Unfold: false,
  show_Fold: false,
  selected_AllBetTab: {
    'ab': 'all',
    'firstEvent': 'all' },

  unfold_AllSc: {
    'N1': {
      '1': false
    }
  },
  miniNormal: window.innerWidth >= 1440 ? false : true,
  frameWidthHeight: {
    width: {
      minFull: 1440,
      currentWidth: window.innerWidth,
      LeftPage_normal: 234,
      LeftPage_mini: 69,
      LeftPage_current: window.innerWidth >= 1440 ? 234 : 69,
      CenterPage_min: 775,
      CenterPage_current: 775,
      RightPage_min: 432,
      RightPage_max: 570,
      RightPage_current: 430 },
    height: {
      header: 96,
      currentHeight: window.innerHeight
    },
    leagueTeam: {
      betBoxWidthMin: 85,
      betBoxWidthMax: 118,
      leagueBoxWidthMin: 238,
      timeColumn: 77,
      favColumn: 39,
      columnCountBet: 6,
      columnCountBetShow: 13
    }
  },
  livetv: {
    eveid: null,
    link: null
  },
  filterEventArr: null,
  showRBLgeEve: [],
  showLgeEve: {},
  sportIdArr: {
    "1": "N1",
    "2": "N2",
    "3": "N3",
    "21": "N21",
    "12": "N12",
    "7": "N7",
    "13": "N13",
    "14": "N14",
    "15": "N15",
    "19": "N19",
    "20": "N20",
    "23": "N23"
  },
  otrBetType: {
    betTypId: "6",
    betTypLang: 'CONFIG_LANG.LBL_GAME_OUTRIGHT',
    sprtId: "G98",
    tmpltId: "11"
  },
  isChangeTemplate: true,
  selectedEventId: null,
  isParlayTab: false,
  previousBettype: null,
  gameBannerSportCount: [],
  gameBannerSportId: null,
  rightBoardChange: null,
  simpleSport: null,
  updateRightBoardToggle: false,
  previousLeftEvent: [],
  bettypeFeature: window.bettype_feature,
  specialEvent: false,
  specialEventList: {
    'id': '',
    'sprtId': ''
  },
  refreshToggle: false,
  ShowUpDown: true,
  isLiveOn: window._isLiveOn
};

var getters = {
  eventList: function eventList(state) {
    return state.eventList;
  },
  rbeventList: function rbeventList(state) {
    return state.rbeventList;
  },
  favrbeventList: function favrbeventList(state) {
    return state.favrbeventList;
  },
  eventAllBet: function eventAllBet(state) {
    return state.eventAllBet;
  },
  mainMarketBet: function mainMarketBet(state) {
    return state.mainMarketBet;
  },
  sortedEventList: function sortedEventList(state) {
    return state.sortedEventList;
  },
  sortedRBEventList: function sortedRBEventList(state) {
    return state.sortedRBEventList;
  },
  sortedFavRbEventList: function sortedFavRbEventList(state) {
    return state.sortedFavRbEventList;
  },
  sortedMatchEventList: function sortedMatchEventList(state) {
    return state.sortedMatchEventList;
  },
  firstEvent: function firstEvent(state) {
    return state.firstEvent;
  },
  testshow: function testshow(state) {
    return state.testshow;
  },
  showRightBanner: function showRightBanner(state) {
    return state.showRightBanner;
  },
  totalPage: function totalPage(state) {
    return state.totalPage;
  },
  sportList: function sportList(state) {
    return state.sportList;
  },
  hot_sportList: function hot_sportList(state) {
    return state.hot_sportList;
  },
  bettypeList: function bettypeList(state) {
    return state.bettypeList;
  },
  sportBettypeList: function sportBettypeList(state) {
    return state.sportBettypeList;
  },
  oddTypesList: function oddTypesList(state) {
    return state.oddTypesList;
  },
  earlyParlayDateList: function earlyParlayDateList(state) {
    return state.earlyParlayDateList;
  },
  selectedEarlyParlayDate: function selectedEarlyParlayDate(state) {
    return state.selectedEarlyParlayDate;
  },
  selectedSort: function selectedSort(state) {
    return state.selectedSort;
  },
  selectedShow: function selectedShow(state) {
    return state.selectedShow;
  },
  selectedSport: function selectedSport(state) {
    return state.selectedSport;
  },
  selectedBettype: function selectedBettype(state) {
    return state.selectedBettype;
  },
  selectedMarket: function selectedMarket(state) {
    return state.selectedMarket;
  },
  prevMarket: function prevMarket(state) {
    return state.prevMarket;
  },
  selectedPage: function selectedPage(state) {
    return state.selectedPage;
  },
  selectedMatchAllBet: function selectedMatchAllBet(state) {
    return state.selectedMatchAllBet;
  },
  hotSchedule: function hotSchedule(state) {
    return state.hotSchedule;
  },
  selectedAllBet: function selectedAllBet(state) {
    return state.selectedAllBet;
  },
  matchAllBet: function matchAllBet(state) {
    return state.matchAllBet;
  },
  selectedAllBetNew: function selectedAllBetNew(state) {
    return state.selectedAllBetNew;
  },
  sportTableLang: function sportTableLang(state) {
    return state.sportTableLang;
  },
  sportAllBetLang: function sportAllBetLang(state) {
    return state.sportAllBetLang;
  },
  market: function market(state) {
    return state.market;
  },
  sortTypes: function sortTypes(state) {
    return state.sortTypes;
  },
  sortShowTypes: function sortShowTypes(state) {
    return state.sortShowTypes;
  },
  marketType: function marketType(state) {
    return state.marketType;
  },
  bool_leagueToggle: function bool_leagueToggle(state) {
    return state.bool_leagueToggle;
  },
  int_fullHalfTime: function int_fullHalfTime(state) {
    return state.int_fullHalfTime;
  },
  arr_leagueList: function arr_leagueList(state) {
    return state.arr_leagueList;
  },
  merge_leagueList: function merge_leagueList(state) {
    return state.merge_leagueList;
  },
  arr_selectedLeagueList: function arr_selectedLeagueList(state) {
    return state.arr_selectedLeagueList;
  },
  favouriteEvents: function favouriteEvents(state) {
    return state.favouriteEvents;
  },
  favouriteOTREvents: function favouriteOTREvents(state) {
    return state.favouriteOTREvents;
  },
  favouriteOTREventsCount: function favouriteOTREventsCount(state) {
    return state.favouriteOTREventsCount;
  },
  favouriteEventsCount: function favouriteEventsCount(state) {
    return state.favouriteEventsCount;
  },
  favouriteRBEventsCount: function favouriteRBEventsCount(state) {
    return state.favouriteRBEventsCount;
  },
  favouriteLgeEvents: function favouriteLgeEvents(state) {
    return state.favouriteLgeEvents;
  },
  showFavEvents: function showFavEvents(state) {
    return state.showFavEvents;
  },
  sportInPlayEvents: function sportInPlayEvents(state) {
    return state.sportInPlayEvents;
  },
  sportAllEvents: function sportAllEvents(state) {
    return state.sportAllEvents;
  },
  sportPrevIsMulp: function sportPrevIsMulp(state) {
    return state.sportPrevIsMulp;
  },
  highlightedCell: function highlightedCell(state) {
    return state.highlightedCell;
  },
  parlaySelected: function parlaySelected(state) {
    return state.parlaySelected;
  },
  isGameBannerSelected: function isGameBannerSelected(state) {
    return state.isGameBannerSelected;
  },
  selectedLeagues: function selectedLeagues(state) {
    return state.selectedLeagues;
  },
  totalLeagues: function totalLeagues(state) {
    return state.totalLeagues;
  },
  sportLeagueWindowEvent: function sportLeagueWindowEvent(state) {
    return state.sportLeagueWindowEvent;
  },
  moreBetLoading: function moreBetLoading(state) {
    return state.moreBetLoading;
  },
  moreBetToggle: function moreBetToggle(state) {
    return state.moreBetToggle;
  },
  allSportCount: function allSportCount(state) {
    return state.allSportCount;
  },
  checked: function checked(state) {
    return state.checked;
  },
  foldopenAllBet: function foldopenAllBet(state) {
    return state.foldopenAllBet;
  },
  foldopenFirstEvent: function foldopenFirstEvent(state) {
    return state.foldopenFirstEvent;
  },
  changeOdds: function changeOdds(state) {
    return state.changeOdds;
  },
  showLeagueTeam: function showLeagueTeam(state) {
    return state.showLeagueTeam;
  },
  showLeagueSearch: function showLeagueSearch(state) {
    return state.showLeagueSearch;
  },
  istodayRB: function istodayRB(state) {
    return state.istodayRB;
  },
  open_RBMarket: function open_RBMarket(state) {
    return state.open_RBMarket;
  },
  selectedInPlaySport: function selectedInPlaySport(state) {
    return state.selectedInPlaySport;
  },
  allBetReloading: function allBetReloading(state) {
    return state.allBetReloading;
  },
  right_allBetReloading: function right_allBetReloading(state) {
    return state.right_allBetReloading;
  },
  arr_earlyEventCountByDate: function arr_earlyEventCountByDate(state) {
    return state.arr_earlyEventCountByDate;
  },
  show_Unfold: function show_Unfold(state) {
    return state.show_Unfold;
  },
  show_RightMenu: function show_RightMenu(state) {
    return state.show_RightMenu;
  },
  show_Fold: function show_Fold(state) {
    return state.show_Fold;
  },
  selected_AllBetTab: function selected_AllBetTab(state) {
    return state.selected_AllBetTab;
  },
  unfold_AllSc: function unfold_AllSc(state) {
    return state.unfold_AllSc;
  },
  miniNormal: function miniNormal(state) {
    return state.miniNormal;
  },
  bWidth: function bWidth(state) {
    return state.bWidth;
  },
  bCenterWidth: function bCenterWidth(state) {
    return state.bCenterWidth;
  },
  bCenterFullWidth: function bCenterFullWidth(state) {
    return state.bCenterFullWidth;
  },
  frameWidthHeight: function frameWidthHeight(state) {
    return state.frameWidthHeight;
  },
  livetv: function livetv(state) {
    return state.livetv;
  },
  filterEventArr: function filterEventArr(state) {
    return state.filterEventArr;
  },
  showRBLgeEve: function showRBLgeEve(state) {
    return state.showRBLgeEve;
  },
  showLgeEve: function showLgeEve(state) {
    return state.showLgeEve;
  },
  sportIdArr: function sportIdArr(state) {
    return state.sportIdArr;
  },
  otrBetType: function otrBetType(state) {
    return state.otrBetType;
  },
  isChangeTemplate: function isChangeTemplate(state) {
    return state.isChangeTemplate;
  },
  selectedEventId: function selectedEventId(state) {
    return state.selectedEventId;
  },
  isParlayTab: function isParlayTab(state) {
    return state.isParlayTab;
  },
  previousBettype: function previousBettype(state) {
    return state.previousBettype;
  },
  gameBannerSportCount: function gameBannerSportCount(state) {
    return state.gameBannerSportCount;
  },
  gameBannerSportId: function gameBannerSportId(state) {
    return state.gameBannerSportId;
  },
  rightBoardChange: function rightBoardChange(state) {
    return state.rightBoardChange;
  },
  simpleSport: function simpleSport(state) {
    return state.simpleSport;
  },
  updateRightBoardToggle: function updateRightBoardToggle(state) {
    return state.updateRightBoardToggle;
  },
  previousLeftEvent: function previousLeftEvent(state) {
    return state.previousLeftEvent;
  },
  bettypeFeature: function bettypeFeature(state) {
    return state.bettypeFeature;
  },
  specialEvent: function specialEvent(state) {
    return state.specialEvent;
  },
  specialEventList: function specialEventList(state) {
    return state.specialEventList;
  },
  refreshToggle: function refreshToggle(state) {
    return state.refreshToggle;
  },
  isLiveOn: function isLiveOn(state) {
    return state.isLiveOn;
  },
  ShowUpDown: function ShowUpDown(state) {
    return state.ShowUpDown;
  }
};

var actions = {
  getFilterEventList: function getFilterEventList(context, payload) {
    var _this = this;

    var url = '/filter-event';
    if (this.getters.account.previewFlag == true) {
      url = '/filter-event-preview';
    }
    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: {
        sorting: 1,
        sportid: payload.sportid
      }
    }).done(function (res) {
      _this.commit('FILTER_EVENT', res.allEvent);
      if (res.earlyParlayDateList) {
        _this.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getSportCCL: function getSportCCL(context, payload) {
    var _this2 = this;

    payload = payload ? payload : {};
    if (!this.getters.account.previewFlag) {
      $('#balancesRefresh').addClass('loading-static-animation');
      var url = window._baseUrl + '/sport-ccl';
      var params = {};
      params.token = payload.token;

      __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
        method: 'get',
        url: url,
        data: params
      }).done(function (res) {
        var updateCurrCL = _this2.getters.account;
        updateCurrCL.currCL = res.cleft;

        var currCL_O = res.cleft * updateCurrCL.currUnit;
        updateCurrCL.currCL_O = new Intl.NumberFormat().format(currCL_O);

        updateCurrCL.lastTrans = res.lastTrans;
        updateCurrCL.outstanding = res.outstanding;

        _this2.commit('ACCOUNT', updateCurrCL);
        $('#balancesRefresh').removeClass('loading-static-animation');
      }.bind(this)).catch(function (errRes) {
        console.log(errRes);
      });
    }
  },
  getSportOdds: function getSportOdds(context, payload) {
    var _this3 = this;

    payload = payload ? payload : {};

    var url = '';

    if (this.getters.account.previewFlag == true) {
      url = window._baseUrl + '/sport-odds-preview';
    } else {
      url = window._baseUrl + '/sport-odds';
    }

    var httpMethod = 'post';
    var bettype = '';
    var plytype = '';
    var schedule = '';

    if (payload.sportId != null) {
      bettype = payload.sportId;
      plytype = "1";
      schedule = '2';
    } else {
      bettype = this.getters.selectedBettype.sprtId;
      plytype = this.getters.selectedBettype.betTypId;
      if (this.getters.selectedBettype.betTypId == '5' && !this.getters.isParlayTab) {
        plytype = this.getters.previousBettype && this.getters.previousBettype.bettype ? this.getters.previousBettype.bettype.betTypId : '1';
      }
      schedule = this.getters.selectedMarket;
      if (payload.scheduleMarket != '' && payload.scheduleMarket != undefined) {
        schedule = payload.scheduleMarket;
      }
    }

    if (this.getters.open_RBMarket) {
      schedule = this.getters.market.inPlayMarket.key;
      bettype = this.getters.selectedSport.sprtId;
    }

    if (this.getters.gameBannerId && this.getters.simpleSport == 'N1') {
      bettype = 'G3';
    }
    if (this.getters.hotSchedule) {
      bettype = 'G98';
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: this.getters.selectedSort,
      token: payload.token
    };

    if (this.getters.searchLeague.lid > 0) {
      if (this.getters.account.previewFlag == true) {
        url = window._baseUrl + '/sport-odds-leagues-preview';
      } else {
        url = window._baseUrl + '/sport-odds-leagues';
      }
      data.leagues = [this.getters.searchLeague.lid];
    } else if (this.getters.cookieLeague) {
      var cookieLeague = this.getters.cookieLeague;
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(cookieLeague).length > 0) {
        var selectedMarket = this.getters.selectedMarket;
        var selectedSport = this.getters.selectedBettype.sprtId;
        var selectedBettype = this.getters.selectedBettype.betTypId;

        if (this.getters.isGameBannerSelected) {
          selectedBettype += 'gmBanner';
        }
        if (!this.getters.selectAllLeague) {
          if (cookieLeague[selectedMarket]) {
            if (cookieLeague[selectedMarket][selectedSport]) {
              if (cookieLeague[selectedMarket][selectedSport][selectedBettype] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(cookieLeague[selectedMarket][selectedSport][selectedBettype]).length > 0) {
                if (this.getters.account.previewFlag == true) {
                  url = window._baseUrl + '/sport-odds-leagues-preview';
                } else {
                  url = window._baseUrl + '/sport-odds-leagues';
                }
                data.leagues = cookieLeague[selectedMarket][selectedSport][selectedBettype];
              } else {
                if (this.getters.account.previewFlag == true) {
                  url = window._baseUrl + '/sport-odds-preview';
                } else {
                  url = window._baseUrl + '/sport-odds';
                }
              }
            } else {
              if (this.getters.account.previewFlag == true) {
                url = window._baseUrl + '/sport-odds-preview';
              } else {
                url = window._baseUrl + '/sport-odds';
              }
            }
          } else {
            if (this.getters.account.previewFlag == true) {
              url = window._baseUrl + '/sport-odds-preview';
            } else {
              url = window._baseUrl + '/sport-odds';
            }
          }
        } else {
          if (this.getters.account.previewFlag == true) {
            url = window._baseUrl + '/sport-odds-preview';
          } else {
            url = window._baseUrl + '/sport-odds';
          }
        }
      }
    }

    if (payload.showfavorite != undefined) {
      this.commit('SPORT_SHOW_FAV_EVENTS', payload.showfavorite);
    } else {}

    if (this.getters.showFavEvents) {
      _.unset(data, 'leagues');

      if (this.getters.favouriteEvents[this.getters.selectedBettype.sprtId] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.favouriteEvents[this.getters.selectedBettype.sprtId]).length > 0) {
        if (this.getters.isGameBannerSelected && (this.getters.eventList.length > 0 || this.getters.sortedRBEventList.length > 0)) {
          var favEvents = this.getters.favouriteEvents[this.getters.selectedBettype.sprtId];

          var eventsList = this.getters.eventList.concat(this.getters.sortedRBEventList);
          var favEventsTemp = [];
          var found = false;
          _.forEach(favEvents, function (feveid, key) {
            found = false;
            _.forEach(eventsList, function (eventObj, eventObjKey) {
              _.forEach(eventObj, function (event, eventKey) {
                if (event.eveid == feveid) {
                  favEventsTemp.push(feveid);
                  found = true;
                  return false;
                }
              });
              if (found) {
                return false;
              }
            });
          });

          if (favEventsTemp.length > 0) {
            data.events = favEventsTemp;
          } else {
            data.events = '0';
          }
        } else {
          data.events = this.getters.favouriteEvents[this.getters.selectedBettype.sprtId];
        }
      } else {
        data.events = '0';
      }
      if (this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId]).length > 0) {
        data.lgevents = this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId];
      } else {
        data.lgevents = '0';
      }

      if (this.getters.account.previewFlag == true) {
        url = window._baseUrl + '/sport-odds-favevents-preview';
      } else {
        url = window._baseUrl + '/sport-odds-favevents';
      }

      if (data.token == undefined) {
        data.token = window.token.arr_7;
      }
      data.showFav = '1';
    }

    if (plytype == '5' && this.getters.account.oddsType != 'am') {
      data.odd = this.getters.oddTypesList.EU.key;
    }

    if (payload.sDate != null) {
      data.date = payload.sDate;
    } else {
      data.date = schedule == this.getters.market.earlyMarket.key ? this.getters.selectedEarlyParlayDate : '0';
      if (plytype == '5') {
        data.date = this.getters.selectedEarlyParlayDate;
      }
    }

    data.plytypgrp = plytype;
    if (plytype == '7' || plytype == '8' || plytype == '9' || plytype == '10') {
      data.plytypgrp = '1';
    }

    if (data.plytypgrp == '2') {
      data.plytypgrp = '12';
    } else if (data.plytypgrp == '3') {
      data.plytypgrp = '13';
    }

    if (state.isGameBannerSelected) {
      data.gameMenuId = this.getters.gameBannerId;
    } else {
      data.gameMenuId = 0;
    }

    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      delete data.schedule;
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(function (res) {
      var events = _.cloneDeep(res.events);
      var rbevents = _.cloneDeep(res.rbevents);

      if (payload.schedule == _this3.getters.market.inPlayMarket.key) {
        rbevents = _.cloneDeep(res.events);
      }
      _this3.commit('IS_CHANGE_TEMPLATE', false);

      if (_this3.getters.sportForecastSelectedEvent && _this3.getters.sportForecastSelectedEvent.rbinfo) {
        var isEventFound = _.find(_.flatMap(res.events), { eveid: _this3.getters.sportForecastSelectedEvent.eveid });
        if (isEventFound && isEventFound.rbinfo) {
          var selectedForecast = _this3.getters.sportForecastSelectedEvent;
          if (selectedForecast.rbinfo.scoa != isEventFound.rbinfo.scoa || selectedForecast.rbinfo.scob != isEventFound.rbinfo.scob) {
            selectedForecast.rbinfo.scoa = isEventFound.rbinfo.scoa;
            selectedForecast.rbinfo.scob = isEventFound.rbinfo.scob;
            __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('FORECAST_GETWAITINGLIST', 'nodata');
            _this3.commit('SPORTFORECAST_SELECTEDEVENT', selectedForecast);
          }
        }
      }
      if (res.earlyParlayDateList) {
        _this3.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
      }

      _this3.commit('TOTALPAGE', res.ttlPg);
      if (_this3.getters.selectedPage > res.ttlPg) {
        _this3.commit('SELECTED_PAGE', res.ttlPg);
      }

      if (schedule == _this3.getters.market.inPlayMarket.key) {
        _this3.commit('FAVOURITERBEVENTCOUNT', 0);
      }
      if (payload.scheduleMarket == _this3.getters.market.inPlayMarket.key) {
        _this3.commit('RBEVENTLIST', _.cloneDeep(res.events));
        _this3.dispatch('sortRBEvents');
      } else {
        if (!payload.showfavorite && !_this3.getters.showFavEvents) {
          _this3.commit('EVENTLIST', events);
        }
      }
      if (payload.showfavorite && _this3.getters.showFavEvents) {
        _this3.commit('FAVOURITERBEVENTCOUNT', 0);
        _this3.commit('FAVOURITEEVENTCOUNT', 0);
        var rbeventsTemp = rbevents;

        if (events && events.length > 0) {
          var DateNow = new __WEBPACK_IMPORTED_MODULE_6_moment___default.a().utcOffset("-04:00").format("YYYY-MM-DD");
          var eventsTemp = [];
          var eCount = 0;
          _.forEach(events, function (event, skey) {
            _.forEach(event, function (data, key) {
              if (data.dt) {
                if ((_this3.getters.selectedMarket == _this3.getters.market.tdyMarket.key || _this3.getters.selectedMarket == _this3.getters.market.hotSportMarket.key) && DateNow == new __WEBPACK_IMPORTED_MODULE_6_moment___default.a(data.dt).format("YYYY-MM-DD")) {
                  if (!eventsTemp[eCount]) {
                    eventsTemp[eCount] = [];
                  }
                  eventsTemp[eCount].push(data);
                } else if (_this3.getters.selectedMarket == _this3.getters.market.earlyMarket.key && DateNow != new __WEBPACK_IMPORTED_MODULE_6_moment___default.a(data.dt).format("YYYY-MM-DD")) {
                  if (!eventsTemp[eCount]) {
                    eventsTemp[eCount] = [];
                  }
                  eventsTemp[eCount].push(data);
                }
              }
            });
            if (eventsTemp[eCount]) {
              eCount++;
            }
          });
        }
        if (payload.scheduleMarket == _this3.getters.market.inPlayMarket.key) {
          _this3.commit('RBEVENTLIST', rbeventsTemp && rbeventsTemp.length > 0 ? rbeventsTemp : eventsTemp);
          _this3.dispatch('sortRBEvents');
        } else {
          if (schedule == _this3.getters.market.inPlayMarket.key) {
            if (rbeventsTemp && rbeventsTemp.length > 0) {
              _this3.commit('EVENTLIST', rbeventsTemp);
              _this3.commit('RBEVENTLIST', rbeventsTemp);
              _this3.dispatch('sortRBEvents');
            } else {
              __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('changemain', true);
            }
          } else if (schedule == _this3.getters.market.hotSportMarket.key) {
            if (rbeventsTemp && rbeventsTemp.length > 0 || eventsTemp && eventsTemp.length > 0) {
              _this3.commit('EVENTLIST', eventsTemp);
              _this3.commit('RBEVENTLIST', rbeventsTemp);
              _this3.dispatch('sortEvents');
              _this3.dispatch('sortRBEvents');
            } else {
              __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('changemain', true);
            }
          } else {
            if (rbeventsTemp && rbeventsTemp.length > 0 || eventsTemp && eventsTemp.length > 0) {
              _this3.commit('EVENTLIST', eventsTemp);
              _this3.commit('RBEVENTLIST', rbeventsTemp);
              _this3.dispatch('sortRBEvents');
            } else {
              __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('changemain', true);
            }
          }
        }
      }

      if (_this3.getters.open_RBMarket || payload.scheduleMarket != _this3.getters.market.inPlayMarket.key && payload.scheduleMarket != _this3.getters.market.hotSportMarket.key) {
        if (_this3.getters.selectedMarket == _this3.getters.market.earlyMarket.key || _this3.getters.selectedBettype.betTypId == '5' && _this3.getters.isParlayTab) {
          state.updateRightBoardToggle = true;
        }
        _this3.dispatch('sortEvents');
      }

      window.STORE = _this3;
      if (payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      if (payload.callback) {
        return payload.callback(errRes);
      }
    }.bind(this));
  },
  getRbTodayOdds: function getRbTodayOdds(context, payload) {
    var _this4 = this;

    payload = payload ? payload : {};

    var url = '';

    if (this.getters.account.previewFlag == true) {
      url = window._baseUrl + '/sport-odds-preview';
    } else {
      url = window._baseUrl + '/sport-odds';
    }

    var httpMethod = 'post';
    var bettype = '';
    var plytype = '';
    var schedule = 4;

    if (payload.sportId != null) {
      bettype = payload.sportId;
      plytype = "1";
    } else {
      bettype = this.getters.selectedBettype.sprtId;
      plytype = this.getters.selectedBettype.betTypId;
      if (this.getters.selectedBettype.betTypId == '5' && !this.getters.isParlayTab) {
        plytype = this.getters.previousBettype && this.getters.previousBettype.bettype ? this.getters.previousBettype.bettype.betTypId : '1';
      }
    }

    if (this.getters.gameBannerId && this.getters.simpleSport == 'N1') {
      bettype = 'G3';
    }

    if (this.getters.hotSchedule) {
      schedule = this.getters.market.hotSportMarket.key;
      bettype = this.getters.selectedSport.sprtId;
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: this.getters.selectedSort,
      token: payload.token
    };

    if (this.getters.searchLeague.lid > 0) {
      if (this.getters.account.previewFlag == true) {
        url = window._baseUrl + '/sport-odds-leagues-preview';
      } else {
        url = window._baseUrl + '/sport-odds-leagues';
      }
      data.leagues = [this.getters.searchLeague.lid];
    } else if (this.getters.cookieLeague) {
      var cookieLeague = this.getters.cookieLeague;
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(cookieLeague).length > 0) {
        var selectedMarket = this.getters.selectedMarket;
        var selectedSport = this.getters.selectedBettype.sprtId;
        var selectedBettype = this.getters.selectedBettype.betTypId;

        if (this.getters.isGameBannerSelected) {
          selectedBettype += 'gmBanner';
        }
        if (!this.getters.selectAllLeague) {
          if (cookieLeague[selectedMarket]) {
            if (cookieLeague[selectedMarket][selectedSport]) {
              if (cookieLeague[selectedMarket][selectedSport][selectedBettype] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(cookieLeague[selectedMarket][selectedSport][selectedBettype]).length > 0) {
                if (this.getters.account.previewFlag == true) {
                  url = window._baseUrl + '/sport-odds-leagues-preview';
                } else {
                  url = window._baseUrl + '/sport-odds-leagues';
                }
                data.leagues = cookieLeague[selectedMarket][selectedSport][selectedBettype];
              } else {
                if (this.getters.account.previewFlag == true) {
                  url = window._baseUrl + '/sport-odds-preview';
                } else {
                  url = window._baseUrl + '/sport-odds';
                }
              }
            } else {
              if (this.getters.account.previewFlag == true) {
                url = window._baseUrl + '/sport-odds-preview';
              } else {
                url = window._baseUrl + '/sport-odds';
              }
            }
          } else {
            if (this.getters.account.previewFlag == true) {
              url = window._baseUrl + '/sport-odds-preview';
            } else {
              url = window._baseUrl + '/sport-odds';
            }
          }
        } else {
          if (this.getters.account.previewFlag == true) {
            url = window._baseUrl + '/sport-odds-preview';
          } else {
            url = window._baseUrl + '/sport-odds';
          }
        }
      }
    }

    if (payload.sDate != null) {
      data.date = payload.sDate;
    } else {
      data.date = schedule == this.getters.market.earlyMarket.key ? this.getters.selectedEarlyParlayDate : '0';
      if (plytype == '5') {
        data.date = this.getters.selectedEarlyParlayDate;
      }
    }

    data.plytypgrp = plytype;
    if (plytype == '7' || plytype == '8' || plytype == '9' || plytype == '10') {
      data.plytypgrp = '1';
    }

    if (data.plytypgrp == '2') {
      data.plytypgrp = '12';
    } else if (data.plytypgrp == '3') {
      data.plytypgrp = '13';
    }

    if (state.isGameBannerSelected) {
      data.gameMenuId = this.getters.gameBannerId;
    } else {
      data.gameMenuId = 0;
    }

    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      delete data.schedule;
    }

    if (plytype == '5' && this.getters.account.oddsType != 'am') {
      data.odd = this.getters.oddTypesList.EU.key;
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(function (res) {
      var events = _.cloneDeep(res.events);
      var rbevents = _.cloneDeep(res.events_rb);

      _this4.commit('IS_CHANGE_TEMPLATE', false);

      if (_this4.getters.sportForecastSelectedEvent && _this4.getters.sportForecastSelectedEvent.rbinfo) {
        var isEventFound = _.find(_.flatMap(res.events_rb), { eveid: _this4.getters.sportForecastSelectedEvent.eveid });
        if (isEventFound && isEventFound.rbinfo) {
          var selectedForecast = _this4.getters.sportForecastSelectedEvent;
          if (selectedForecast.rbinfo.scoa != isEventFound.rbinfo.scoa || selectedForecast.rbinfo.scob != isEventFound.rbinfo.scob) {
            selectedForecast.rbinfo.scoa = isEventFound.rbinfo.scoa;
            selectedForecast.rbinfo.scob = isEventFound.rbinfo.scob;
            __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('FORECAST_GETWAITINGLIST', 'nodata');
            _this4.commit('SPORTFORECAST_SELECTEDEVENT', selectedForecast);
          }
        }
      }
      if (res.earlyParlayDateList) {
        _this4.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
      }

      _this4.commit('TOTALPAGE', res.ttlPg);
      if (_this4.getters.selectedPage > res.ttlPg) {
        _this4.commit('SELECTED_PAGE', res.ttlPg);
      }

      if (schedule == _this4.getters.market.inPlayMarket.key) {
        _this4.commit('FAVOURITERBEVENTCOUNT', 0);
      }

      _this4.commit('RBEVENTLIST', rbevents);
      _this4.dispatch('sortRBEvents');

      _this4.commit('EVENTLIST', events);
      _this4.dispatch('sortEvents');

      window.STORE = _this4;
      if (payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      if (payload.callback) {
        return payload.callback(errRes);
      }
    }.bind(this));
  },
  getSportAllBet: function getSportAllBet(context, payload) {
    var _this5 = this;

    var eventDate = new __WEBPACK_IMPORTED_MODULE_6_moment___default.a(payload.event.dt).locale('en').format("YYYY-MM-DD");
    var schedulesSelected = this.getters.selectedMarket;
    if (this.getters.showFavEvents) {
      schedulesSelected = 2;

      var DateNow = new __WEBPACK_IMPORTED_MODULE_6_moment___default.a().locale('en').utcOffset("-04:00").format("YYYY-MM-DD");
      if (payload.event.rbinfo || payload.event.rbstatus) {
        schedulesSelected = 3;
      } else if (eventDate == DateNow) {
        schedulesSelected = 1;
      }
    }
    var data = {
      sprtid: this.getters.selectedBettype.sprtId,
      schedule: schedulesSelected,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      evntid: payload.event.eveid
    };

    var filterDateIndex = _.indexOf(this.getters.earlyParlayDateList, eventDate);
    data.date = filterDateIndex != -1 ? filterDateIndex : 99;

    var plytype = this.getters.selectedBettype.betTypId;

    if (plytype == '1' || plytype == '5') {
      data.plytypgrp = plytype;
    } else if (plytype == '7' || plytype == '8' || plytype == '9' || plytype == '10') {
        data.plytypgrp = '1';
      }

    if (this.getters.selectedBettype.betTypId == '5' && !this.getters.isParlayTab) {
      data.plytypgrp = this.getters.previousBettype && this.getters.previousBettype.bettype ? this.getters.previousBettype.bettype.betTypId : '1';
      if (data.plytypgrp == '7' || data.plytypgrp == '8' || data.plytypgrp == '9' || data.plytypgrp == '10') {
        data.plytypgrp = '1';
      }
    }

    if (data.sprtid.indexOf('G') >= 0) {
      data.sprtid = 'N' + payload.event.sptid;
    }

    if (this.getters.selectedMarket == '3' || this.getters.selectedMarket == '1' && plytype != '5') {
      data.date = 0;
    }

    if (this.getters.selectedBettype.betTypId == '5' && this.getters.account.oddsType != 'am' && this.getters.isParlayTab) {
      data.odd = this.getters.oddTypesList.EU.key;
    }
    data.token = payload.token;
    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'post',
      url: _baseUrl + '/sport-allbet',
      data: data
    }).done(function (res) {
      if (res.allBet && res.allBet.sp) {
        for (var eveid = 0; eveid < __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(res.allBet.sp).length; eveid++) {
          _.assign(res.allBet.sp[__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(res.allBet.sp)[eveid]], { 'sptid': res.allBet.sptid });
        }
      }
      _this5.commit('IS_CHANGE_TEMPLATE', false);
      _this5.commit('EVENT_ALLBET', res.allBet);
      _this5.commit('MAINMARKET_BET', _.cloneDeep(res.allBet));
      _this5.commit('SELECTED_ALLBETNEW', true);
      _this5.commit('MOREBETLOADING', false);
      if (!payload.inAllBet) __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('sportTableReloading', false);
      if (payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getMatchAllBet: function getMatchAllBet(context, payload) {
    var _this6 = this;

    state.previousLeftEvent = payload.event;
    if (this.getters.open_RBMarket && this.getters.selectedSport.sprtId == 'G98') {
      if (payload.event.sptid != null && payload.event.sptid != '') {
        var sport = this.getters.sportIdArr[payload.event.sptid];
        var selectedBetType = _.find(this.getters.sportList, function (x) {
          return x.sprtId == sport;
        });
        if (this.getters.selectedBettype.sprtId != selectedBetType.sprtId) {
          this.commit('SELECTED_BETTYPE', selectedBetType);
        }
      }
    }

    if (this.getters.hotSchedule && this.getters.selectedSport.sprtId == 'G98') {
      if (payload.event.sptid != null && payload.event.sptid != '') {
        var _sport = this.getters.sportIdArr[payload.event.sptid];
        var _selectedBetType = _.find(this.getters.sportList, function (x) {
          return x.sprtId == _sport;
        });
        if (this.getters.selectedBettype.sprtId != _selectedBetType.sprtId) {
          this.commit('SELECTED_BETTYPE', _selectedBetType);
        }
      }
    }

    this.commit('ALLBET_RELOADING', true);
    var eventDate = new __WEBPACK_IMPORTED_MODULE_6_moment___default.a(payload.event.dt).locale('en').format("YYYY-MM-DD");

    var selMarket = this.getters.selectedMarket;
    if (this.getters.selectedBettype.betTypId == '5') {
      selMarket = 2;
      var DateNow = new __WEBPACK_IMPORTED_MODULE_6_moment___default.a().locale('en').utcOffset("-04:00").format("YYYY-MM-DD");
      if (eventDate == DateNow) {
        selMarket = 1;
      }
    }

    if (this.getters.hotSchedule) {
      selMarket = 1;
    }
    if (payload.isRB) {
      selMarket = state.market.inPlayMarket.key;
    }

    if (!_.isUndefined(payload.event.eveid)) {
      this.commit('SELECTED_EVEID', payload.event.eveid);
    }

    var data = {
      sprtid: this.getters.selectedBettype.sprtId,
      schedule: selMarket,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      evntid: !_.isUndefined(payload.event.eveid) ? payload.event.eveid : this.getters.selectedEventId
    };

    var filterDateIndex = _.indexOf(this.getters.earlyParlayDateList, eventDate);
    data.date = filterDateIndex != -1 ? filterDateIndex : 99;

    var plytype = this.getters.selectedBettype.betTypId;

    if (plytype == '1' || plytype == '5') {
      data.plytypgrp = plytype;
    } else if (plytype == '7' || plytype == '8' || plytype == '9' || plytype == '10') {
        data.plytypgrp = '1';
      } else {
        data.plytypgrp = '1';
      }
    if (this.getters.selectedBettype.betTypId == '5' && !this.getters.isParlayTab) {
      data.plytypgrp = this.getters.previousBettype && this.getters.previousBettype.bettype ? this.getters.previousBettype.bettype.betTypId : '1';
      if (data.plytypgrp == '7' || data.plytypgrp == '8' || data.plytypgrp == '9' || data.plytypgrp == '10') {
        data.plytypgrp = '1';
      }
    }
    if (payload.event.sptid) {
      data.sprtid = 'N' + payload.event.sptid;
    }
    if (data.sprtid.indexOf('G') >= 0) {
      data.sprtid = 'N' + payload.event.sptid;
    }
    if (!_.isUndefined(payload.event.filtersptid)) {
      data.sprtid = 'N' + payload.event.sptid;
    }
    if (this.getters.selectedMarket == '3' || this.getters.selectedMarket == '1' && plytype != '5' || payload.isRB) {
      data.date = 0;
    }

    if (this.getters.selectedBettype.betTypId == '5' && this.getters.account.oddsType != 'am' && this.getters.isParlayTab) {
      data.odd = this.getters.oddTypesList.EU.key;
    }
    data.token = payload.token;
    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'post',
      url: _baseUrl + '/sport-allbet',
      data: data
    }).done(function (res) {
      if (res.allBet) {
        res.allBet.rbstatus = payload.isRB ? 1 : 0;
      }
      if (res.allBet && res.allBet.sp) {
        for (var eveid = 0; eveid < __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(res.allBet.sp).length; eveid++) {
          _.assign(res.allBet.sp[__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(res.allBet.sp)[eveid]], { 'sptid': res.allBet.sptid, 'rbstatus': res.allBet.rbstatus });
        }
      }

      if (res.allBet && res.allBet.eveid == payload.event.eveid) {
        res.allBet.isFavourite = payload.event.isFavourite;
      }
      if (payload.loadTemplate != undefined && (payload.loadTemplate == 1 || payload.loadTemplate == 2 || payload.loadTemplate == 3)) {
        if (payload.loadTemplate == 1) {
          var tvlinkArray = {};
          tvlinkArray.link = null;
          tvlinkArray.eveid = null;
          _this6.commit('LIVETV', tvlinkArray);
        }
        if (payload.loadTemplate == 3) {
          _this6.commit('SORTEDMATCHEVENTLIST', res.allBet);
          _this6.commit('SELECTED_MATCHALLBET', true);
        }
        if (payload.loadTemplate == 2 && !payload.notLoadTV) {
          __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
            url: _baseUrl + '/livetv',
            method: 'post',
            data: {
              chlid: res.allBet.ch,
              eventid: res.allBet.eveid,
              league: res.allBet.lgeid,
              tacap: res.allBet.tacapt,
              tbcap: res.allBet.tbcapt
            }
          }).then(function (response) {
            var tvlinkArray = {};
            tvlinkArray.link = response;
            tvlinkArray.eveid = res.allBet.eveid;
            _this6.commit('LIVETV', tvlinkArray);
          });
        }
        if (_this6.getters.selectedBettype.sprtId == 'N1' && _this6.getters.selectedBettype.tmpltId == '1' && !_this6.getters.simpleSport) {
          var spId = _this6.getters.selectedBettype.sprtId;
          var tpltId = _this6.getters.selectedBettype.tmpltId;
          if (!_.isUndefined(_this6.getters.unfold_AllSc[spId]) && !_.isUndefined(_this6.getters.unfold_AllSc[spId][tpltId])) {
            state.show_Unfold = !_this6.getters.unfold_AllSc[spId][tpltId] ? true : false;
            state.show_Fold = !_this6.getters.unfold_AllSc[spId][tpltId] ? false : true;
            _this6.commit('UNFOLD_ALLSC', _this6.getters.unfold_AllSc[spId][tpltId]);
          } else {
            _this6.commit('UNFOLD_ALLSC', false);
          }
        } else {
          _this6.commit('UNFOLD_ALLSC', false);
        }
        _this6.commit('FIRSTEVENT', res.allBet);
      } else {
        _this6.commit('SORTEDMATCHEVENTLIST', res.allBet);
        _this6.commit('FIRSTEVENT', res.allBet);
        _this6.commit('SELECTED_MATCHALLBET', true);
      }

      _this6.commit('ALLBET_RELOADING', false);
      _this6.commit('R_ALLBET_RELOADING', false);
      $('#tblRefresh').removeClass('loading-static-animation');
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('activeAllBetOsScoreBoard', event);
      if (!payload.inAllBet) if (payload.callback) {
          return payload.callback(res);
        }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getSpecialEventOdds: function getSpecialEventOdds(context, payload) {
    var _this7 = this;

    payload = payload ? payload : {};
    var url = '';
    var httpMethod = 'post';
    var bettype = this.getters.specialEventList['sprtId'];
    var plytype = '1';
    var schedule = this.getters.selectedMarket == '1' ? '4' : this.getters.selectedMarket;

    if (this.getters.account.previewFlag == true) {
      url = window._baseUrl + '/sport-odds-preview';
    } else {
      url = window._baseUrl + '/sport-odds';
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: this.getters.selectedSort,
      token: payload.token,
      plytypgrp: plytype
    };

    if (payload.sDate != null) {
      data.date = payload.sDate;
    } else {
      this.commit('SELECTEDEARLYPARLAYDATE', '99');
      data.date = schedule == this.getters.market.earlyMarket.key ? this.getters.selectedEarlyParlayDate : '0';
    }

    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      delete data.schedule;
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(function (res) {
      var events = _.cloneDeep(res.events);
      var rbevents = _.cloneDeep(res.rbevents);
      _this7.commit('IS_CHANGE_TEMPLATE', false);

      if (res.earlyParlayDateList) {
        _this7.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
      }
      _this7.commit('TOTALPAGE', res.ttlPg);
      if (_this7.getters.selectedPage > res.ttlPg) {
        _this7.commit('SELECTED_PAGE', res.ttlPg);
      }

      _this7.commit('RBEVENTLIST', rbevents == undefined ? [] : rbevents);
      _this7.dispatch('sortRBEvents');

      _this7.commit('EVENTLIST', events);
      _this7.dispatch('sortEvents');


      window.STORE = _this7;
      if (payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      if (payload.callback) {
        return payload.callback(errRes);
      }
    }.bind(this));
  },
  sortEvents: function sortEvents() {
    var _this8 = this;

    var EventsList = _.cloneDeep(this.getters.eventList);
    var sortedEvents = [];
    var lgeArr = _.cloneDeep(this.getters.showLgeEve);
    var countx = 0;
    var VUE = this;

    if (this.getters.selectedMarket != state.market.inPlayMarket.key && this.getters.selectedMarket != state.market.hotSportMarket.key) {
      _.forEach(EventsList, function (dtx, key) {
        lgeArr[key] = _.isUndefined(lgeArr[key]) ? {} : lgeArr[key];
        _.forEach(dtx, function (value, index) {
          if (_.isUndefined(lgeArr[key].hide)) {
            lgeArr[key].hide = countx < window.maxDisplayEvent ? false : true;
          }
          countx++;
        });
      });
      sortedEvents = EventsList;
      this.commit('SHOW_LGEEVE', lgeArr);
    } else if (this.getters.selectedMarket == state.market.inPlayMarket.key || this.getters.selectedMarket == state.market.hotSportMarket.key) {
      var newEveArr = {};
      _.forEach(EventsList, function (evedata, key) {
        var sprtID = !_.isUndefined(VUE.getters.sportIdArr[evedata[0].sptid]) ? VUE.getters.sportIdArr[evedata[0].sptid] : VUE.getters.sportIdArr['99'];

        if (!_.isUndefined(newEveArr[sprtID])) {
          newEveArr[sprtID][key] = evedata;
        } else {
          newEveArr[sprtID] = {};
          newEveArr[sprtID][key] = evedata;
        }

        lgeArr[sprtID] = _.isUndefined(lgeArr[sprtID]) ? {} : lgeArr[sprtID];
        lgeArr[sprtID][key] = _.isUndefined(lgeArr[sprtID][key]) ? {} : lgeArr[sprtID][key];
        lgeArr[sprtID].hide = _.isUndefined(lgeArr[sprtID].hide) ? false : lgeArr[sprtID].hide;

        _.forEach(evedata, function (value, index) {
          if (_.isUndefined(lgeArr[sprtID][key].hide)) {
            lgeArr[sprtID][key].hide = countx < window.maxDisplayEvent ? false : true;
          }
          countx++;
        });
      });

      sortedEvents = newEveArr;
      this.commit('SHOW_LGEEVE', lgeArr);
    }
    this.commit('SORTEDEVENTLIST', sortedEvents);


    if (this.getters.showFavEvents && this.getters.selectedMarket != state.market.hotSportMarket.key) {
      var sortedFavRbEvents = _.cloneDeep(this.getters.rbeventList);
      this.commit('SORTEDRBEVENTLIST', _.cloneDeep(sortedFavRbEvents));
    }

    if (this.getters.favouriteLgeEvents && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.favouriteLgeEvents).length > 0) {
      this.commit('FAVOURITEEVENTCOUNT', 0);
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedEventList,
        callback: function callback(res) {
          _this8.commit('SORTEDEVENTLIST', _.cloneDeep(res));
        }
      });

      if (state.sortedRBEventList && state.sortedRBEventList.length > 0 && state.selectedMarket != 3) {
        this.commit('FAVOURITERBEVENTCOUNT', 0);
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedRBEventList,

          callback: function callback(res) {
            _this8.commit('SORTEDRBEVENTLIST', _.cloneDeep(res));
          }
        });
      }
    } else if (this.getters.favouriteEvents && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.favouriteEvents).length > 0) {
      this.commit('FAVOURITEEVENTCOUNT', 0);
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedEventList,
        callback: function callback(res) {
          _this8.commit('SORTEDEVENTLIST', _.cloneDeep(res));
        }
      });

      if (state.sortedRBEventList && state.sortedRBEventList.length > 0 && state.selectedMarket != 3) {
        this.commit('FAVOURITERBEVENTCOUNT', 0);
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedRBEventList,

          callback: function callback(res) {
            _this8.commit('SORTEDRBEVENTLIST', _.cloneDeep(res));
          }
        });
      }
    }

    var CheckSortedRBEvents = _.cloneDeep(this.getters.rbeventList);
    var CheckSortedEvents = sortedEvents;
    if (this.getters.showFavEvents) {
      state.updateRightBoardToggle = true;
      CheckSortedRBEvents = sortedFavRbEvents;
      CheckSortedEvents = state.sortedEventList;
    }
    if (this.getters.selectedMarket == state.market.inPlayMarket.key) {
      var CheckSortedEvents = sortedEvents;
      var firstKey = null;
      if (CheckSortedEvents !== null && CheckSortedEvents !== undefined) {
        for (var key in CheckSortedEvents) {
          if (CheckSortedEvents.hasOwnProperty(key)) {
            firstKey = key;
            break;
          }
        }
        if (firstKey !== null) {
          var checkLeftEvent = CheckSortedEvents[firstKey][0][0];
        }
      }
      var getSprtId = this.getters.selectedSport.sprtId;
      if (checkLeftEvent && (typeof checkLeftEvent === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(checkLeftEvent)) === 'object') {
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(checkLeftEvent).length > 0) {
          var changeRightScoreBoard = true;
          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.firstEvent).length > 0) {
            if (this.getters.eventList.length == 0) {
              this.commit('FIRSTEVENT', []);
            }
            if (this.getters.selectedMarket == state.market.inPlayMarket.key && changeRightScoreBoard == true) {
              _.forEach(CheckSortedEvents, function (sport_list, key) {
                _.forEach(sport_list, function (league_list, league_value) {
                  _.forEach(league_list, function (value, index) {
                    if (value.eveid == state.firstEvent.eveid && getSprtId != 'G98' && state.firstEvent.eveid != checkLeftEvent.eveid) {
                      checkLeftEvent = value;
                    } else if (value.eveid == state.firstEvent.eveid && getSprtId == 'G98') {
                      checkLeftEvent = value;
                    }
                  });
                });
              });
            }
          }
          if (this.getters.livetv.eveid > 0 && this.getters.livetv.link != '' && (this.getters.previousLeftEvent.length > 0 || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.previousLeftEvent).length > 0) && checkLeftEvent.eveid != this.getters.livetv.eveid && this.getters.previousLeftEvent.eveid == this.getters.livetv.eveid) {
            checkLeftEvent = this.getters.previousLeftEvent;
          }

          var inplayAll = state.show_Unfold === false && state.firstEvent.sptid !== 1;
          if (changeRightScoreBoard == true && !this.getters.liveAllBet && (checkLeftEvent.sptid != 1 || state.show_Unfold == true || state.miniNormal || inplayAll || this.getters.simpleSport)) {
            this.dispatch('getMatchAllBet', {
              event: checkLeftEvent,
              isRB: this.getters.selectedMarket == state.market.inPlayMarket.key ? true : false,
              token: token.arr_8,
              loadTemplate: this.getters.livetv.link != '' && this.getters.livetv.eveid > 0 && this.getters.livetv.eveid == checkLeftEvent.eveid ? 2 : 1,
              notLoadTV: this.getters.livetv.link != '' && this.getters.livetv.eveid > 0 && this.getters.livetv.eveid == checkLeftEvent.eveid ? true : false
            });
          }
        }
      } else {
        this.commit('FIRSTEVENT', []);
      }
    } else {
      if (state.updateRightBoardToggle) {
        if ((CheckSortedRBEvents && CheckSortedRBEvents.length > 0 || CheckSortedEvents && CheckSortedEvents.length > 0) && !this.getters.selectedMatchAllBet) {
          var checkLeftEvent = CheckSortedRBEvents && CheckSortedRBEvents.length > 0 ? CheckSortedRBEvents[0][0] : CheckSortedEvents[0][0];

          var changeRightScoreBoard = true;
          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.firstEvent).length > 0 && state.firstEvent.eveid != checkLeftEvent.eveid) {
            _.forEach(CheckSortedRBEvents, function (league_list, key) {
              _.forEach(league_list, function (value, index) {
                if (value.eveid == state.firstEvent.eveid) {
                  changeRightScoreBoard = false;
                  checkLeftEvent = value;
                }
              });
            });
            if (changeRightScoreBoard == true) {
              _.forEach(CheckSortedEvents, function (league_list, key) {
                _.forEach(league_list, function (value, index) {
                  if (value.eveid == state.firstEvent.eveid) {
                    checkLeftEvent = value;
                  }
                });
              });
            }
          }
          if (this.getters.livetv.eveid > 0 && this.getters.livetv.link != '' && (this.getters.previousLeftEvent.length > 0 || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.previousLeftEvent).length > 0) && checkLeftEvent.eveid != this.getters.livetv.eveid && this.getters.previousLeftEvent.eveid == this.getters.livetv.eveid) {
            checkLeftEvent = this.getters.previousLeftEvent;
          }

          if (checkLeftEvent.sptid != 1 || state.show_Unfold == true || state.miniNormal || this.getters.simpleSport) {
            this.dispatch('getMatchAllBet', {
              event: checkLeftEvent,
              isRB: checkLeftEvent.rbstatus && checkLeftEvent.rb ? true : false,
              token: token.arr_8,
              loadTemplate: this.getters.livetv.link != '' && this.getters.livetv.eveid > 0 && this.getters.livetv.eveid == checkLeftEvent.eveid ? 2 : 1,
              notLoadTV: this.getters.livetv.link != '' && this.getters.livetv.eveid > 0 && this.getters.livetv.eveid == checkLeftEvent.eveid ? true : false
            });
          }
        } else {}
      }
      state.updateRightBoardToggle = !state.updateRightBoardToggle;
    }
  },
  sortRBEvents: function sortRBEvents() {
    var _this9 = this;

    var sortedRBEvents = _.cloneDeep(this.getters.rbeventList);

    var countx = 0;
    var rblgeArr = _.cloneDeep(this.getters.showRBLgeEve);
    _.forEach(sortedRBEvents, function (dtx, key) {
      rblgeArr[key] = _.isUndefined(rblgeArr[key]) ? {} : rblgeArr[key];
      _.forEach(dtx, function (value, index) {
        if (_.isUndefined(rblgeArr[key].hide)) {
          rblgeArr[key].hide = countx < window.maxDisplayEvent ? false : true;
        }
        countx++;
      });
    });
    this.commit('SHOW_RBLGEEVE', rblgeArr);
    this.commit('SORTEDRBEVENTLIST', _.cloneDeep(sortedRBEvents));

    if (this.getters.showFavEvents) {
      var sortedFavRbEvents = _.cloneDeep(this.getters.favrbeventList);
      this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(sortedFavRbEvents));
    }

    if (this.getters.favouriteLgeEvents && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.favouriteLgeEvents).length > 0) {
      this.commit('FAVOURITERBEVENTCOUNT', 0);
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedRBEventList,
        callback: function callback(res) {
          _this9.commit('SORTEDRBEVENTLIST', _.cloneDeep(res));
        }
      });

      if (state.sortedEventList && state.sortedEventList.length > 0) {
        this.commit('FAVOURITEEVENTCOUNT', 0);
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedEventList,

          callback: function callback(res) {
            _this9.commit('SORTEDEVENTLIST', _.cloneDeep(res));
          }
        });
      }
    } else if (this.getters.favouriteEvents && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.favouriteEvents).length > 0) {
      this.commit('FAVOURITERBEVENTCOUNT', 0);
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedRBEventList,
        callback: function callback(res) {
          _this9.commit('SORTEDRBEVENTLIST', _.cloneDeep(res));
        }
      });

      if (state.sortedEventList && state.sortedEventList.length > 0) {
        this.commit('FAVOURITEEVENTCOUNT', 0);
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedEventList,

          callback: function callback(res) {
            _this9.commit('SORTEDEVENTLIST', _.cloneDeep(res));
          }
        });
      }
    }

    if (state.updateRightBoardToggle) {
      var CheckSortedRBEvents = sortedRBEvents;
      var CheckSortedEvents = _.cloneDeep(this.getters.eventList);
      if (this.getters.showFavEvents) {
        CheckSortedRBEvents = sortedFavRbEvents;
        CheckSortedEvents = state.sortedEventList;
      }
      if ((CheckSortedRBEvents && CheckSortedRBEvents.length > 0 || CheckSortedEvents && CheckSortedEvents.length > 0) && !this.getters.selectedMatchAllBet) {
        var checkLeftEvent = CheckSortedRBEvents && CheckSortedRBEvents.length > 0 ? CheckSortedRBEvents[0][0] : CheckSortedEvents[0][0];
        var changeRightScoreBoard = true;

        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.firstEvent).length > 0 && state.firstEvent.eveid != checkLeftEvent.eveid) {
          _.forEach(CheckSortedRBEvents, function (league_list, key) {
            _.forEach(league_list, function (value, index) {
              if (value.eveid == state.firstEvent.eveid) {
                changeRightScoreBoard = false;
                checkLeftEvent = value;
              }
            });
          });
          if (changeRightScoreBoard == true) {
            _.forEach(CheckSortedEvents, function (league_list, key) {
              _.forEach(league_list, function (value, index) {
                if (value.eveid == state.firstEvent.eveid) {
                  checkLeftEvent = value;
                }
              });
            });
          }
        }
        if (this.getters.livetv.eveid > 0 && this.getters.livetv.link != '' && (this.getters.previousLeftEvent.length > 0 || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.previousLeftEvent).length > 0) && checkLeftEvent.eveid != this.getters.livetv.eveid && this.getters.previousLeftEvent.eveid == this.getters.livetv.eveid) {
          checkLeftEvent = this.getters.previousLeftEvent;
        }

        if (checkLeftEvent.sptid != 1 || state.show_Unfold == true || state.miniNormal || this.getters.simpleSport) {
          this.dispatch('getMatchAllBet', {
            event: checkLeftEvent,
            isRB: checkLeftEvent.rbstatus && checkLeftEvent.rb ? true : false,
            token: token.arr_8,
            loadTemplate: this.getters.livetv.link != '' && this.getters.livetv.eveid > 0 && this.getters.livetv.eveid == checkLeftEvent.eveid ? 2 : 1,
            notLoadTV: this.getters.livetv.link != '' && this.getters.livetv.eveid > 0 && this.getters.livetv.eveid == checkLeftEvent.eveid ? true : false
          });
        }
      } else {}
    }
    if (this.getters.selectedMarket == state.market.hotSportMarket.key) {

      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.sortedRBEventList).length > 0) {

        var sortedRBEventList = _.cloneDeep(state.sortedRBEventList);
        var sortedRBEvents = [];
        var RBlgeArr = _.cloneDeep(this.getters.showLgeEve);
        var RBcountx = 0;
        var VUE = this;

        var newEveArr = {};
        _.forEach(sortedRBEventList, function (evedata, key) {
          var sprtID = !_.isUndefined(VUE.getters.sportIdArr[evedata[0].sptid]) ? VUE.getters.sportIdArr[evedata[0].sptid] : VUE.getters.sportIdArr['99'];

          if (!_.isUndefined(newEveArr[sprtID])) {
            newEveArr[sprtID][key] = evedata;
          } else {
            newEveArr[sprtID] = {};
            newEveArr[sprtID][key] = evedata;
          }

          RBlgeArr[sprtID] = _.isUndefined(RBlgeArr[sprtID]) ? {} : RBlgeArr[sprtID];
          RBlgeArr[sprtID][key] = _.isUndefined(RBlgeArr[sprtID][key]) ? {} : RBlgeArr[sprtID][key];
          RBlgeArr[sprtID].hide = _.isUndefined(RBlgeArr[sprtID].hide) ? false : RBlgeArr[sprtID].hide;

          _.forEach(evedata, function (value, index) {
            if (_.isUndefined(RBlgeArr[sprtID][key].hide)) {
              RBlgeArr[sprtID][key].hide = RBcountx < window.maxDisplayEvent ? false : true;
            }
            RBcountx++;
          });
        });
        sortedRBEvents = newEveArr;
        this.commit('SORTEDRBEVENTLIST', sortedRBEvents);
        this.commit('SHOW_RBLGEEVE', RBlgeArr);
      }
    }
    state.updateRightBoardToggle = !state.updateRightBoardToggle;
  },
  advancedSortedEventsByTime: function advancedSortedEventsByTime(orderedEvents, payload) {
    for (var currentEventCount = 0; currentEventCount <= __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(payload.orderedEvents).length - 1; currentEventCount++) {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(payload.orderedEvents)[currentEventCount + 1]) {
        var nextEventCount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(payload.orderedEvents)[currentEventCount + 1];

        if (payload.orderedEvents[nextEventCount].lgeid == payload.orderedEvents[currentEventCount].lgeid) {
          if (!payload.orderedEvents[currentEventCount].moveToTop) {
            payload.orderedEvents[currentEventCount] = payload.orderedEvents[currentEventCount].concat(_.cloneDeep(payload.orderedEvents[nextEventCount]));
            payload.orderedEvents[nextEventCount].moveToTop = true;
          } else {
            for (var prevEventCount = currentEventCount - 1; prevEventCount >= 0; prevEventCount--) {
              if (!payload.orderedEvents[prevEventCount].moveToTop && !payload.orderedEvents[nextEventCount].moveToTop) {
                payload.orderedEvents[prevEventCount] = payload.orderedEvents[prevEventCount].concat(_.cloneDeep(payload.orderedEvents[nextEventCount]));
                payload.orderedEvents[nextEventCount].moveToTop = true;
              }
            }
          }
        }
      }
    }
    payload.orderedEvents = _.reject(payload.orderedEvents, { 'moveToTop': true });
    return payload.callback(payload.orderedEvents);
  },
  setFavLgeEvent: function setFavLgeEvent(context, payload) {
    var VUE = this;
    function recursiveMethod(value, type, league) {
      var selectedMarket = VUE.getters.selectedMarket;
      var selectedSport = VUE.getters.selectedBettype.sprtId;

      if (value == null && type == 'market') {
        value = {};
        return recursiveMethod(value, 'sport', league);
      }

      if (value == null && type == 'sport') {
        value[selectedSport] = {};
        return recursiveMethod(value[selectedSport], 'bettyp', league);
      } else {
        if (value == null) {
          return recursiveMethod(value, 'market', league);
        }
        if (value[selectedSport] == null) {
          value[selectedSport] = [];
          value[selectedSport].push(league);
          return value;
        }
        value[selectedSport].push(league);
        return value;
      }
    }

    _.forEach(payload.orderedEvents, function (events, key) {
      _.forEach(events, function (event, key) {
        if (!_.isUndefined(state.favouriteLgeEvents)) {
          if (_.indexOf(state.favouriteLgeEvents[state.selectedBettype.sprtId], event.lgeid) == 0) {
            if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
              state.favouriteEvents = {};
              state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] = [event.eveid];
            } else {
              var fav = recursiveMethod(state.favouriteEvents, 'market', event.eveid);
            }
          }
        }
      });
    });
  },
  sortFavouriteEvents: function sortFavouriteEvents(orderedEvents, payload) {
    if (state.selectedMarket == 3) {
      _.forEach(payload.orderedEvents, function (sportsList, skey) {
        _.forEach(sportsList, function (events, lkey) {
          _.forEach(events, function (event, key) {
            if (!_.isUndefined(state.favouriteEvents)) {
              if (_.indexOf(state.favouriteLgeEvents[state.selectedBettype.sprtId], event.lgeid) >= 0) {
                payload.orderedEvents[skey][lkey][key]['isFavourite'] = true;
                if (payload.favEve == undefined || payload.favEve == 0) {
                  if (event.rbstatus == 1) {
                    state.favouriteRBEventsCount += 1;
                  } else {
                    state.favouriteEventsCount += 1;
                  }
                }
              } else {
                if (_.indexOf(state.favouriteEvents[state.selectedBettype.sprtId], event.eveid) >= 0) {
                  payload.orderedEvents[skey][lkey][key]['isFavourite'] = true;
                  if (payload.favEve == undefined || payload.favEve == 0) {
                    if (event.rbstatus == 1) {
                      state.favouriteRBEventsCount += 1;
                    } else {
                      state.favouriteEventsCount += 1;
                    }
                  }
                } else {
                  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(payload.orderedEvents[skey][lkey][key]) != 'object') {
                    payload.orderedEvents[skey][lkey]['isFavourite'] = false;
                  } else {
                    payload.orderedEvents[skey][lkey][key]['isFavourite'] = false;
                  }
                }
              }
            }
          });
        });
      });
    } else if (state.selectedMarket == 5) {
      if (payload.isRB == 0) {
        _.forEach(payload.orderedEvents, function (sportsList, skey) {
          _.forEach(sportsList, function (events, lkey) {
            _.forEach(events, function (event, key) {
              if (!_.isUndefined(state.favouriteEvents)) {
                _.forEach(state.favouriteEvents, function (evelist, lskey) {
                  if (_.indexOf(evelist, event.eveid) >= 0) {
                    payload.orderedEvents[skey][lkey][key]['isFavourite'] = true;
                    if (payload.favEve == undefined || payload.favEve == 0) {
                      if (event.rbstatus == 1) {
                        state.favouriteRBEventsCount += 1;
                      } else {
                        state.favouriteEventsCount += 1;
                      }
                    }
                  } else {
                    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(payload.orderedEvents[skey][lkey][key]) != 'object') {
                      payload.orderedEvents[skey][lkey]['isFavourite'] = false;
                    } else {
                      payload.orderedEvents[skey][lkey][key]['isFavourite'] = false;
                    }
                  }
                });
              }
            });
          });
        });
      } else {
        _.forEach(payload.orderedEvents, function (events, lkey) {
          _.forEach(events, function (event, key) {
            if (!_.isUndefined(state.favouriteEvents)) {
              _.forEach(state.favouriteEvents, function (evelist, lskey) {
                if (_.indexOf(evelist, event.eveid) >= 0) {
                  payload.orderedEvents[lkey][key]['isFavourite'] = true;
                  if (payload.favEve == undefined || payload.favEve == 0) {
                    if (event.rbstatus == 1) {
                      state.favouriteRBEventsCount += 1;
                    } else {
                      state.favouriteEventsCount += 1;
                    }
                  }
                } else {
                  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(payload.orderedEvents[lkey][key]) != 'object') {
                    payload.orderedEvents[lkey]['isFavourite'] = false;
                  } else {
                    payload.orderedEvents[lkey][key]['isFavourite'] = false;
                  }
                }
              });
            }
          });
        });
      }
    } else {
      _.forEach(payload.orderedEvents, function (events, lkey) {
        _.forEach(events, function (event, key) {
          if (!_.isUndefined(state.favouriteEvents)) {
            if (_.indexOf(state.favouriteLgeEvents[state.selectedBettype.sprtId], event.lgeid) >= 0) {
              payload.orderedEvents[lkey][key]['isFavourite'] = true;
              if (payload.favEve == undefined || payload.favEve == 0) {
                if (event.rbstatus == 1) {
                  state.favouriteRBEventsCount += 1;
                } else {
                  state.favouriteEventsCount += 1;
                }
              }
            } else {
              if (_.indexOf(state.favouriteEvents[state.selectedBettype.sprtId], event.eveid) >= 0) {
                payload.orderedEvents[lkey][key]['isFavourite'] = true;
                if (payload.favEve == undefined || payload.favEve == 0) {
                  if (event.rbstatus == 1) {
                    state.favouriteRBEventsCount += 1;
                  } else {
                    state.favouriteEventsCount += 1;
                  }
                }
              } else {
                payload.orderedEvents[lkey][key]['isFavourite'] = false;
              }
            }
          }
        });
      });
    }
    payload.callback(payload.orderedEvents);
  },
  sortFavouriteMatchEvents: function sortFavouriteMatchEvents(orderedEvents, payload) {
    if (payload.orderedEvents) {
      if (!_.isUndefined(state.favouriteEvents)) {
        if (_.indexOf(state.favouriteEvents[state.selectedBettype.sprtId], payload.orderedEvents.eveid) >= 0) {
          payload.orderedEvents.isFavourite = true;
        } else {
          payload.orderedEvents.isFavourite = false;
        }
      }
    }

    payload.callback(payload.orderedEvents);
  },
  getLaugueList: function getLaugueList(context, payload) {
    var _this10 = this;

    var date = '0';
    var apiUrl = '';
    if (this.getters.account.previewFlag == true) {
      apiUrl = _baseUrl + '/sport-league-list-preview';
    } else {
      apiUrl = _baseUrl + '/sport-league-list';
    }

    var data = {};
    var httpType = 'get';
    var selmarket = this.getters.selectedMarket;
    var selsportid = this.getters.selectedBettype.sprtId;

    if (this.getters.selectedMarket == this.getters.market.earlyMarket.key) {
      date = this.getters.selectedEarlyParlayDate;
    }
    var plytypgrp = this.getters.selectedBettype.betTypId;

    if (payload.scheduleMarket != '' && payload.scheduleMarket != undefined) {
      selmarket = payload.scheduleMarket;
    } else if (this.getters.open_RBMarket && payload.scheduleMarket == '') {
      selmarket = this.getters.market.inPlayMarket.key;
    } else if (this.getters.hotSchedule && payload.scheduleMarket == '') {
      selmarket = this.getters.market.hotSportMarket.key;
    }

    if (this.getters.open_RBMarket && this.getters.selectedSport.sprtId == 'G98') {
      selsportid = this.getters.selectedSport.sprtId;
    }

    if (this.getters.hotSchedule && this.getters.selectedSport.sprtId == 'G98') {
      selsportid = this.getters.selectedSport.sprtId;
    }

    data = {
      sprtid: selsportid,
      schedule: selmarket,
      date: date,
      plytypgrp: plytypgrp,
      langId: window._langid,
      sort: 2,
      spread: this.getters.account.spread,
      gameMenuId: 0
    };
    if (data.plytypgrp == '2' && this.getters.int_fullHalfTime == '2') {
      data.plytypgrp = '6';
    } else if (data.plytypgrp == '3' && this.getters.int_fullHalfTime == '2') {
      data.plytypgrp = '7';
    }
    if (this.getters.showFavEvents) {
      if (this.getters.favouriteEvents[this.getters.selectedBettype.sprtId] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.favouriteEvents[this.getters.selectedBettype.sprtId]).length > 0) {
        data.events = this.getters.favouriteEvents[this.getters.selectedBettype.sprtId];
      } else {
        data.events = '0';
      }
      if (this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId]).length > 0) {
        data.lgevents = this.getters.favouriteLgeEvents[this.getters.selectedBettype.sprtId];
      } else {
        data.lgevents = '0';
      }
      data.showFav = '1';
    }

    if (this.getters.selectedBettype.betTypId == '7' || this.getters.selectedBettype.betTypId == '8' || this.getters.selectedBettype.betTypId == '9' || this.getters.selectedBettype.betTypId == '10') {
      data.plytypgrp = '1';
    } else if (this.getters.selectedBettype.betTypId == '6') {
      httpType = 'post';
      apiUrl = _baseUrl + '/sport-outright-league';
      data = {
        sprtid: this.getters.selectedBettype.sprtId,
        lang: window._langid,
        action: '1'
      };
    }

    if (state.isGameBannerSelected) {
      data.gameMenuId = this.getters.gameBannerId;
    }

    data.token = token.arr_15;

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: httpType,
      url: apiUrl,
      data: data
    }).done(function (res) {
      var lgeList = res.leagues;
      if (_this10.getters.open_RBMarket) {
        _this10.commit('MERGE_LEAGUELIST', null);
      }

      if (_this10.getters.hotSchedule) {
        _this10.commit('MERGE_LEAGUELIST', null);
      }

      if (_this10.getters.merge_leagueList != null) {
        var arrLge = _this10.getters.merge_leagueList;
        for (var i = 0; i < lgeList.length; i++) {
          var lgedata = lgeList[i];
          arrLge.push(lgedata);
        }
        lgeList = arrLge;
      }
      _this10.commit('MERGE_LEAGUELIST', lgeList);

      _this10.commit('LEAGUELIST', _this10.getters.merge_leagueList);


      if (payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getSportEventList: function getSportEventList(context, payload) {
    var _this11 = this;

    payload = payload ? payload : {};

    var ajaxData = {
      schedule: payload.market ? payload.market : state.selectedMarket,
      spread: this.getters.account.spread,
      gameMenuId: 0
    };

    if (payload.isGameBanner) {
      ajaxData.gameMenuId = this.getters.gameBannerId;
    }

    ajaxData.token = payload.token;

    var url = '';

    if (this.getters.account.previewFlag == true) {
      url = '/sport-event-list-preview';
    } else {
      url = '/sport-event-list';
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: ajaxData
    }).done(function (res) {
      if (!ajaxData.gameMenuId) {
        if (state.selectedMarket == state.market.inPlayMarket.key || payload.market == state.market.inPlayMarket.key) {
          _this11.commit('SPORT_INPLAY_EVENTS', res.totalMatch);
        } else {
          _this11.commit('SPORT_ALL_EVENTS', res.totalMatch);
        }
      }
      if (payload.isGameBanner) {
        _this11.commit('GAME_BANNER_SPORT_COUNT', res.totalMatch);
      }
      if (payload) {
        if (payload.callback) return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getSportCount: function getSportCount(context, payload) {
    var _this12 = this;

    var url = '';

    if (this.getters.account.previewFlag == true) {
      url = '/sport-count-preview';
    } else {
      url = '/sport-count';
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url
    }).done(function (res) {
      _this12.commit('ALLSPORTCOUNT', res.allCount);
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getEarlyEventCountByDate: function getEarlyEventCountByDate(context, payload) {
    var _this13 = this;

    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = '/event-count-bydate-preview';
    } else {
      url = '/event-count-bydate';
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url
    }).done(function (res) {
      _this13.commit('EARLYCOUNT_BYDATE', res.countByDate);
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  toggleSportLeague: function toggleSportLeague(context, payload) {
    this.commit('SPORT_LEAGUE_TOGGLE');
    if (state.bool_leagueToggle) {
      if (this.getters.selectedMarket == this.getters.market.tdyMarket.key) {
        this.dispatch('getLaugueList', {
          scheduleMarket: '4',
          callback: function (res) {
            if (payload.callback) {
              return payload.callback(res);
            }
          }.bind(this)
        });
      } else {
        if (!this.getters.open_RBMarket && this.getters.selectedMarket == this.getters.market.tdyMarket.key && this.getters.selectedBettype.betTypId != '5' && this.getters.selectedBettype.betTypId != '6') {
          this.dispatch('getLaugueList', { scheduleMarket: this.getters.market.inPlayMarket.key });
        }

        this.dispatch('getLaugueList', {
          scheduleMarket: '',
          callback: function (res) {
            if (payload.callback) {
              return payload.callback(res);
            }
          }.bind(this)
        });
      }
    }
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_30" /* MOREBETTOGGLE */], function (state, payload) {
  if (payload.clear) {
    if (state.moreBetToggle.indexOf(payload.eveid) > -1) {
      var _i = state.moreBetToggle.indexOf(payload.eveid);
      state.moreBetToggle.splice(_i, 1);
    }

    console.log('x: ' + i);
  } else {
    state.moreBetToggle.push(payload.eveid);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_29" /* MOREBETLOADING */], function (state, payload) {
  state.moreBetLoading = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_59" /* SELECTEDLEAGUES */], function (state, payload) {
  state.selectedLeagues = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_137" /* TOTALLEAGUES */], function (state, payload) {
  state.totalLeagues = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_102" /* SPORTLEAGUE_WINDOWEVENT */], function (state, payload) {
  state.sportLeagueWindowEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["L" /* EVENTLIST */], function (state, payload) {
  state.eventList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_48" /* RBEVENTLIST */], function (state, payload) {
  state.rbeventList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["V" /* FAVRBEVENTLIST */], function (state, payload) {
  state.favrbeventList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["M" /* EVENT_ALLBET */], function (state, payload) {
  state.eventAllBet = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_25" /* MAINMARKET_BET */], function (state, payload) {
  state.mainMarketBet = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_26" /* MATCH_ALLBET */], function (state, payload) {
  state.matchAllBet = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_85" /* SHOW_LEAGUETEAM */], function (state, payload) {
  state.showLeagueTeam = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_84" /* SHOW_LEAGUESEARCH */], function (state, payload) {
  state.showLeagueSearch = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_90" /* SORTEDEVENTLIST */], function (state, payload) {
  state.sortedEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_93" /* SORTEDRBEVENTLIST */], function (state, payload) {
  state.sortedRBEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_91" /* SORTEDFAVRBEVENTLIST */], function (state, payload) {
  state.sortedFavRbEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_92" /* SORTEDMATCHEVENTLIST */], function (state, payload) {
  state.sortedMatchEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["X" /* FIRSTEVENT */], function (state, payload) {
  if (state.firstEvent && state.firstEvent.eveid) {
    if (this.getters.livetv.eveid != null && this.getters.livetv.eveid > 0 && state.firstEvent.eveid != payload.eveid) {
      var tvlinkArray = {};
      tvlinkArray.link = null;
      tvlinkArray.eveid = null;
      this.commit('LIVETV', tvlinkArray);
    }
  }
  state.firstEvent = payload;
  this.commit('TESTSHOW', true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_136" /* TESTSHOW */], function (state, payload) {
  state.testshow = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_81" /* SHOWRIGHTBANNER */], function (state, payload) {
  state.showRightBanner = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["S" /* FAVOURITEOTREVENT */], function (state, payload) {
  if (!_.isUndefined(state.favouriteOTREvents[payload.selectedSport]) && state.favouriteOTREvents[payload.selectedSport].indexOf(payload.eveId) !== -1) {
    var indexKy = state.favouriteOTREvents[payload.selectedSport].indexOf(payload.eveId);
    if (indexKy != -1) {
      state.favouriteOTREvents[payload.selectedSport].splice(indexKy, 1);
    }
  } else {
    if (_.isUndefined(state.favouriteOTREvents[payload.selectedSport]) || state.favouriteOTREvents[payload.selectedSport] == null) {
      state.favouriteOTREvents[payload.selectedSport] = [];
    }
    state.favouriteOTREvents[payload.selectedSport].push(payload.eveId);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["T" /* FAVOURITEOTREVENTCOUNT */], function (state, payload) {
  state.favouriteOTREventsCount = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["O" /* FAVOURITEEVENTCOUNT */], function (state, payload) {
  state.favouriteEventsCount = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["U" /* FAVOURITERBEVENTCOUNT */], function (state, payload) {
  state.favouriteRBEventsCount = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["N" /* FAVOURITEEVENT */], function (state, payload) {
  var _this14 = this;

  if (payload.clear) {
    state.favouriteEvents = payload.clear ? {} : state.favouriteEvents;
    state.showFavEvents = false;
    if (payload.isrb == '1') {
      _.forEach(state.sortedRBEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          state.sortedRBEventList[eventsKey][eventKey].isFavourite = false;
        });
      });
    } else {
      _.forEach(state.sortedEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          state.sortedEventList[eventsKey][eventKey].isFavourite = false;
        });
      });
    }
    if (state.sortedMatchEventList) {
      if (state.sortedMatchEventList.eveid == payload.event.eveid) {
        state.sortedMatchEventList.isFavourite = false;
      }
    }
  } else {
    var _recursiveMethod = function _recursiveMethod(value, type, league) {
      var selectedMarket = VUE.getters.selectedMarket;
      var selectedSport = VUE.getters.selectedBettype.sprtId;
      if (value == null && type == 'market') {
        value = {};
        return _recursiveMethod(value, 'sport', league);
      }
      if (value == null) {
        return _recursiveMethod(value, 'market', league);
      }
      if (value[selectedSport] == null) {
        value[selectedSport] = [];
        value[selectedSport].push(league);
        return value;
      }
      value[selectedSport].push(league);
      return value;
    };

    var VUE = this;

    var LgeCheck = false;
    if (!_.isUndefined(state.favouriteLgeEvents) && _.indexOf(state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId], payload.event.lgeid) >= 0) {
      _.pull(state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId], payload.event.lgeid);
      this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' });

      _.forEach(state.sortedRBEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          if (event.eveid != payload.event.eveid && event.lgeid == payload.event.lgeid) {
            if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
              state.favouriteEvents = {};
              state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] = [event.eveid];
              _this14.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' });
            } else {
              var fav = _recursiveMethod(state.favouriteEvents, 'market', event.eveid);
              _this14.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' });
            }
          } else if (event.eveid == payload.event.eveid && event.lgeid == payload.event.lgeid) {
            LgeCheck = true;
          }
        });
      });
      _.forEach(state.sortedEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          if (event.eveid != payload.event.eveid && event.lgeid == payload.event.lgeid) {
            if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
              state.favouriteEvents = {};
              state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] = [event.eveid];
              _this14.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' });
            } else {
              var fav = _recursiveMethod(state.favouriteEvents, 'market', event.eveid);
              _this14.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' });
            }
          } else if (event.eveid == payload.event.eveid && event.lgeid == payload.event.lgeid) {
            LgeCheck = true;
          }
        });
      });
      if (state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
        delete state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId];
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteLgeEvents).length <= 0) {
          state.favouriteLgeEvents = {};
        }
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' });
      }
    }

    if (!_.isUndefined(state.favouriteEvents) && _.indexOf(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], payload.event.eveid) >= 0) {
      _.pull(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], payload.event.eveid);
      this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' });
      if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
        delete state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId];
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
          state.favouriteEvents = {};
        }
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' });
      }
    } else if (!LgeCheck) {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
        state.favouriteEvents = {};
        state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] = [payload.event.eveid];
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' });
      } else {
        var fav = _recursiveMethod(state.favouriteEvents, 'market', payload.event.eveid);
        this.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' });
      }
    }

    if (payload.isrb && state.selectedMarket != 3 && !this.getters.hotSchedule) {
      _.forEach(state.sortedRBEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          if (event.eveid == payload.event.eveid) {
            if (!payload.event.isFavourite) {
              state.sortedRBEventList[eventsKey][eventKey].isFavourite = true;
            } else {
              state.sortedRBEventList[eventsKey][eventKey].isFavourite = !payload.event.isFavourite;
            }
          }
        });
      });
      this.commit('FAVOURITERBEVENTCOUNT', 0);
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedRBEventList,
        callback: function callback(res) {
          _this14.commit('SORTEDRBEVENTLIST', _.cloneDeep(res));
        }
      });
    } else if (state.selectedMarket == 3 && !this.getters.hotSchedule) {
      this.commit('FAVOURITERBEVENTCOUNT', 0);
      _.forEach(state.sortedEventList, function (sportslist, SportKey) {
        _.forEach(sportslist, function (events, eventsKey) {
          _.forEach(events, function (event, eventKey) {
            if (event.eveid == payload.event.eveid) {
              if (!payload.event.isFavourite) {
                state.sortedEventList[SportKey][eventsKey][eventKey].isFavourite = true;
              } else {
                state.sortedEventList[SportKey][eventsKey][eventKey].isFavourite = !payload.event.isFavourite;
              }
            }
          });
        });
      });
    } else if (state.selectedMarket == 5 && this.getters.hotSchedule) {
      if (payload.event.rbstatus == 1) {
        _.forEach(state.sortedRBEventList, function (sportslist, SportKey) {
          _.forEach(sportslist, function (events, eventsKey) {
            _.forEach(events, function (event, eventKey) {
              if (event.eveid == payload.event.eveid) {
                if (!payload.event.isFavourite) {
                  state.sortedRBEventList[SportKey][eventsKey][eventKey].isFavourite = true;
                } else {
                  state.sortedRBEventList[SportKey][eventsKey][eventKey].isFavourite = !payload.event.isFavourite;
                }
              }
            });
          });
        });
        this.commit('FAVOURITEEVENTCOUNT', 0);
        this.commit('FAVOURITERBEVENTCOUNT', 0);
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedRBEventList,
          isRB: 0,
          callback: function callback(res) {
            _this14.commit('SORTEDRBEVENTLIST', _.cloneDeep(res));
          }
        });
      } else {
        _.forEach(state.sortedEventList, function (sportslist, SportKey) {
          _.forEach(sportslist, function (events, eventsKey) {
            _.forEach(events, function (event, eventKey) {
              if (event.eveid == payload.event.eveid) {
                if (!payload.event.isFavourite) {
                  state.sortedEventList[SportKey][eventsKey][eventKey].isFavourite = true;
                } else {
                  state.sortedEventList[SportKey][eventsKey][eventKey].isFavourite = !payload.event.isFavourite;
                }
              }
            });
          });
        });
        this.commit('FAVOURITEEVENTCOUNT', 0);
        this.commit('FAVOURITERBEVENTCOUNT', 0);
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedEventList,
          isRB: 0,
          callback: function callback(res) {
            _this14.commit('SORTEDEVENTLIST', _.cloneDeep(res));
          }
        });
      }
    } else {
      _.forEach(state.sortedEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          if (event.eveid == payload.event.eveid) {
            if (!payload.event.isFavourite) {
              state.sortedEventList[eventsKey][eventKey].isFavourite = true;
            } else {
              state.sortedEventList[eventsKey][eventKey].isFavourite = !payload.event.isFavourite;
            }
          }
        });
      });
    }
    if (!this.getters.hotSchedule) {
      this.commit('FAVOURITEEVENTCOUNT', 0);
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedEventList,
        isRB: 0,
        callback: function callback(res) {
          _this14.commit('SORTEDEVENTLIST', _.cloneDeep(res));
        }
      });
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["Q" /* FAVOURITELGEVENT */], function (state, payload) {
  var _this15 = this;

  if (payload.clear) {
    payload.clear ? {} : state.favouriteEvents;
    state.showFavEvents = false;
    if (payload.isrb == '1') {
      _.forEach(state.sortedRBEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          state.sortedRBEventList[eventsKey][eventKey].isFavourite = false;
          if (event.rbstatus == 1) {
            state.favouriteRBEventsCount -= 1;
          } else {
            state.favouriteEventsCount -= 1;
          }
        });
      });
    } else {
      _.forEach(state.sortedEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          state.sortedEventList[eventsKey][eventKey].isFavourite = false;
          if (event.rbstatus == 1) {
            state.favouriteRBEventsCount -= 1;
          } else {
            state.favouriteEventsCount -= 1;
          }
        });
      });
    }

    if (state.sortedMatchEventList) {
      if (state.sortedMatchEventList.eveid == payload.eveid) {
        state.sortedMatchEventList.isFavourite = false;
        if (event.rbstatus == 1) {
          state.favouriteRBEventsCount += 1;
        } else {
          state.favouriteEventsCount += 1;
        }
      }
    }
  } else {
    var _recursiveMethod2 = function _recursiveMethod2(value, type, league) {
      var selectedMarket = VUE.getters.selectedMarket;
      var selectedSport = VUE.getters.selectedBettype.sprtId;
      if (value == null && type == 'market') {
        value = {};
        return _recursiveMethod2(value, 'sport', league);
      }
      if (value == null) {
        return _recursiveMethod2(value, 'market', league);
      }
      if (value[selectedSport] == null) {
        value[selectedSport] = [];
        value[selectedSport].push(league);
        return value;
      }
      value[selectedSport].push(league);
      return value;
    };

    var VUE = this;


    if (!_.isUndefined(state.favouriteEvents) && _.indexOf(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], payload.eveid) >= 0) {
      state.favouriteEvents = {};
      this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' });
    } else {

      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
        state.favouriteEvents = {};
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' });
      }
    }

    if (!_.isUndefined(state.favouriteLgeEvents) && _.indexOf(state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId], payload.lgeid) >= 0) {
      _.pull(state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId], payload.lgeid);
      this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' });
      if (state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
        delete state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId];
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteLgeEvents).length <= 0) {
          state.favouriteLgeEvents = {};
        }
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' });
      }
    } else {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteLgeEvents).length <= 0) {
        state.favouriteLgeEvents = {};
        state.favouriteLgeEvents[window.STORE.getters.selectedBettype.sprtId] = [payload.lgeid];
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' });
      } else {
        var fav = _recursiveMethod2(state.favouriteLgeEvents, 'market', payload.lgeid);
        this.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' });
      }
    }

    if (payload.isrb == '1' && (state.selectedMarket == 3 || this.getters.hotSchedule)) {
      _.forEach(state.sortedEventList, function (SportList, sportKey) {
        _.forEach(SportList, function (events, eventsKey) {
          _.forEach(events, function (event, eventKey) {
            if (event.lgeid == payload.lgeid) {
              if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] && state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].indexOf(event.eveid) !== -1) {
                _.pull(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], event.eveid);
                if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
                  delete state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId];
                  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
                    state.favouriteEvents = {};
                    __WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a.set(window.STORE.getters.account.acccode + '_accfav_event', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.favouriteEvents));
                  }
                }
              }
              if (payload.lgeChk) {
                state.sortedEventList[sportKey][eventsKey][eventKey].isFavourite = false;
              } else {
                state.sortedEventList[sportKey][eventsKey][eventKey].isFavourite = true;
              }
            }
          });
        });
      });
    } else {
      _.forEach(state.sortedRBEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          if (state.sortedRBEventList[eventsKey][eventKey].lgeid == payload.lgeid) {
            if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] && state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].indexOf(state.sortedRBEventList[eventsKey][eventKey].eveid) !== -1) {
              _.pull(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], state.sortedRBEventList[eventsKey][eventKey].eveid);
              if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
                delete state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId];
                if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
                  state.favouriteEvents = {};
                  _this15.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '0' });
                }
              }
            }
            if (payload.lgeChk) {
              state.sortedRBEventList[eventsKey][eventKey].isFavourite = false;
            } else {
              state.sortedRBEventList[eventsKey][eventKey].isFavourite = true;
            }
          }
        });
      });
      this.commit('FAVOURITERBEVENTCOUNT', 0);
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedRBEventList,
        callback: function callback(res) {
          _this15.commit('SORTEDRBEVENTLIST', _.cloneDeep(res));
        }
      });
      _.forEach(state.sortedEventList, function (events, eventsKey) {
        _.forEach(events, function (event, eventKey) {
          if (state.sortedEventList[eventsKey][eventKey].lgeid == payload.lgeid) {
            if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId] && state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].indexOf(state.sortedEventList[eventsKey][eventKey].eveid) !== -1) {
              _.pull(state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId], state.sortedEventList[eventsKey][eventKey].eveid);
              if (state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId].length <= 0) {
                delete state.favouriteEvents[window.STORE.getters.selectedBettype.sprtId];
                if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
                  state.favouriteEvents = {};
                  _this15.commit('ACCOUNT_FAV', { favdt: state.favouriteEvents, isFavLeague: '' });
                }
              }
            }
            if (payload.lgeChk) {
              state.sortedEventList[eventsKey][eventKey].isFavourite = false;
            } else {
              state.sortedEventList[eventsKey][eventKey].isFavourite = true;
            }
          }
        });
      });
    }

    this.commit('FAVOURITEEVENTCOUNT', 0);
    if (state.selectedMarket == 3 && !state.showFavEvents) {
      this.commit('FAVOURITERBEVENTCOUNT', 0);
    } else if (this.getters.hotSchedule && !state.showFavEvents) {
      this.commit('FAVOURITERBEVENTCOUNT', 0);
    }
    this.dispatch('sortFavouriteEvents', {
      orderedEvents: state.sortedEventList,
      callback: function callback(res) {
        _this15.commit('SORTEDEVENTLIST', _.cloneDeep(res));
      }
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["P" /* FAVOURITEEVENT_FIRSTLOAD */], function (state, payload) {
  var favEve_cookie = __WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a.get(this.getters.account.acccode + '_accfav_event');
  var favEveObj = JSON.parse(favEve_cookie);

  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(favEve_cookie).length > 0) {
    state.favouriteEvents = favEveObj;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["R" /* FAVOURITELGEVENT_FIRSTLOAD */], function (state, payload) {
  var favLgEve_cookie = __WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a.get(this.getters.account.acccode + '_accfavlg_event');
  var favLgEveObj = JSON.parse(favLgEve_cookie);

  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(favLgEveObj).length > 0) {
    state.favouriteLgeEvents = favLgEveObj;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_138" /* TOTALPAGE */], function (state, payload) {
  state.totalPage = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_103" /* SPORTLIST */], function (state, payload) {
  state.sportList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["x" /* BETTYPELIST */], function (state, payload) {
  state.bettypeList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_95" /* SPORTBETTYPELIST */], function (state, payload) {
  state.sportBettypeList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_31" /* ODDTYPESLIST */], function (state, payload) {
  state.oddTypesList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["K" /* EARLYPARLAYDATELIST */], function (state, payload) {
  state.earlyParlayDateList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_58" /* SELECTEDEARLYPARLAYDATE */], function (state, payload) {
  state.selectedEarlyParlayDate = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_72" /* SELECTED_PAGE */], function (state, payload) {
  state.selectedPage = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_60" /* SELECTED_ALLBET */], function (state, payload) {
  state.selectedAllBet = payload;
  this.commit('PARLAY_SELECTED', { update: false });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_61" /* SELECTED_ALLBETNEW */], function (state, payload) {
  state.selectedAllBetNew = payload;
  this.commit('PARLAY_SELECTED', { update: false });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_69" /* SELECTED_MATCHALLBET */], function (state, payload) {
  state.selectedMatchAllBet = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_75" /* SELECTED_SORT */], function (state, payload) {
  state.selectedSort = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_74" /* SELECTED_SHOW */], function (state, payload) {
  state.selectedShow = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_68" /* SELECTED_MARKET */], function (state, payload) {
  state.selectedMarket = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_76" /* SELECTED_SPORT */], function (state, payload) {
  state.selectedSport = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_64" /* SELECTED_BETTYPE */], function (state, payload) {
  state.selectedBettype = payload;

  if (payload && payload.sprtId == 'N1' && payload.tmpltId == '1' && !state.miniNormal && !this.getters.simpleSport) {
    if (!_.isUndefined(state.unfold_AllSc[payload.sprtId]) && !_.isUndefined(state.unfold_AllSc[payload.sprtId][payload.tmpltId])) {
      state.show_Unfold = !state.unfold_AllSc[payload.sprtId][payload.tmpltId] ? true : false;
      state.show_Fold = !state.unfold_AllSc[payload.sprtId][payload.tmpltId] ? false : true;

      this.commit('UNFOLD_ALLSC', state.unfold_AllSc[payload.sprtId][payload.tmpltId]);
    }
  } else {
    state.show_Unfold = false;
    state.show_Fold = false;
    this.commit('UNFOLD_ALLSC', false);
  }
  this.commit('FRAME_RESIZE', 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_68" /* SELECTED_MARKET */], function (state, payload) {
  state.selectedMarket = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'PREV_MARKET', function PREV_MARKET(state, payload) {
  state.prevMarket = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["B" /* CHANGE_ODDS */], function (state, payload) {
  state.changeOdds = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_106" /* SPORTTABLELANG */], function (state, payload) {
  state.sportTableLang = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_94" /* SPORTALLBETLANG */], function (state, payload) {
  state.sportAllBetLang = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_110" /* SPORT_LEAGUE_TOGGLE */], function (state) {
  state.bool_leagueToggle = state.bool_leagueToggle === false ? true : false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_108" /* SPORT_FULLHALF_TIME */], function (state, payload) {
  state.int_fullHalfTime = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_17" /* LEAGUELIST */], function (state, payload) {
  state.arr_leagueList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_27" /* MERGE_LEAGUELIST */], function (state, payload) {
  state.merge_leagueList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_67" /* SELECTED_LEAGUELIST */], function (state, payload) {
  state.arr_selectedLeagueList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_109" /* SPORT_INPLAY_EVENTS */], function (state, payload) {
  state.sportInPlayEvents = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_107" /* SPORT_ALL_EVENTS */], function (state, payload) {
  state.sportAllEvents = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_118" /* SPORT_SHOW_FAV_EVENTS */], function (state, payload) {
  state.showFavEvents = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_117" /* SPORT_PREVIOUS_IS_MULP */], function (state, payload) {
  state.sportPrevIsMulp = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_6" /* HIGHLIGHT_CELL */], function (state, payload) {
  state.highlightedCell = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_36" /* PARLAY_SELECTED */], function (state, payload) {
  if (payload == null) {
    state.parlaySelected = payload;
    $('td').removeClass('highlightedP');
    return;
  }
  if (this.getters.selectedBettype.betTypId != undefined && this.getters.selectedBettype.betTypId != "5") {
    return;
  }
  if (payload.update || payload.update == false) {
    $('td').removeClass('highlightedP');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('sportSelectedAllBetChange');
    return;
  }
  if (payload.remove) {
    if (state.parlaySelected) {
      delete state.parlaySelected[payload.eveid];
    }
    if (state.parlaySelected && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.parlaySelected).length <= 0) {
      $('td').removeClass('highlightedP');
      state.parlaySelected = null;
      return;
    }
    $('td').removeClass('highlightedP');
    _.forEach(state.parlaySelected, function (value, key) {
      value.addClass('highlightedP');
    });
    return;
  }
  if (!state.parlaySelected) {
    state.parlaySelected = {};
  }
  state.parlaySelected[payload.eveid] = payload.class;

  $('td').removeClass('highlightedP');
  _.forEach(this.getters.betForm, function (value, key) {
    $('.' + value.uniqueId).closest('td').addClass('highlightedP');
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_2" /* GAMEBANNER_SELECTED */], function (state, payload) {
  state.isGameBannerSelected = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["e" /* ALLSPORTCOUNT */], function (state, payload) {
  state.allSportCount = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["C" /* CHECKED_BALANCE */], function (state, payload) {
  state.checked = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["Y" /* FOLDOPEN_ALLBET */], function (state, payload) {
  state.foldopenAllBet = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["Z" /* FOLDOPEN_FIRSTEVENT */], function (state, payload) {
  state.foldopenFirstEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_15" /* IS_TODAYRB */], function (state, payload) {
  state.istodayRB = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_34" /* OPEN_RBMARKET */], function (state, payload) {
  state.open_RBMarket = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_66" /* SELECTED_INPLAYSPORT */], function (state, payload) {
  state.selectedInPlaySport = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["c" /* ALLBET_RELOADING */], function (state, payload) {
  state.allBetReloading = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_54" /* R_ALLBET_RELOADING */], function (state, payload) {
  state.right_allBetReloading = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["J" /* EARLYCOUNT_BYDATE */], function (state, payload) {
  state.arr_earlyEventCountByDate = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_88" /* SHOW_UNFOLD */], function (state, payload) {
  state.show_Unfold = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_83" /* SHOW_FOLD */], function (state, payload) {
  state.show_Fold = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_62" /* SELECTED_ALLBETTAB */], function (state, payload) {
  if (payload.ab != undefined && payload.ab != '') {
    state.selected_AllBetTab.ab = payload.ab;
  }
  if (payload.firstEvent != undefined && payload.firstEvent != '') {
    state.selected_AllBetTab.firstEvent = payload.firstEvent;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_139" /* UNFOLD_ALLSC */], function (state, payload) {
  var sprt = state.selectedBettype.sprtId;
  var tmp = state.selectedBettype.tmpltId;
  if (sprt == 'N1' && tmp == '1') {
    state.unfold_AllSc[sprt][tmp] = payload;
  }
  this.commit('FRAME_RESIZE', 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_28" /* MINI_NORMAL */], function (state, payload) {

  if (payload == 1 || payload == 2) {
    $('#leftBarNormalScroll').getNiceScroll().remove();
    $('#miniScroll').show();
    $('#normalScroll').hide();
  } else {
    $('#leftBarMiniScroll').getNiceScroll().remove();
    $('#miniScroll').hide();
    $('#normalScroll').show();
  }
  if (payload !== 1 && payload !== 0) {
    if (payload == 2) {
      state.miniNormal = 1;
    } else {
      state.miniNormal = 0;
    }
    var resizeable = {};
    resizeable.LeftPageStatus = payload;
    this.commit('FRAME_WH', resizeable);
  } else {
    state.miniNormal = payload;
  }
  if (state.miniNormal == 1) {
    $('#leftBarMiniScroll').show();
    $('#miniScroll').niceScroll({
      horizrailenabled: false,
      autohidemode: false,
      scrollbarid: 'leftBarMiniScroll',
      cursorborder: "0px solid #fff",
      zindex: 48,
      railoffset: { left: 10 },
      cursordragontouch: true
    });
  } else {
    $('#leftBarNormalScroll').show();
    $('#normalScroll').niceScroll({
      horizrailenabled: false,
      autohidemode: false,
      scrollbarid: 'leftBarNormalScroll',
      cursorborder: "0px solid #fff",
      zindex: 45,
      railoffset: { left: 10 },
      cursordragontouch: true
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_1" /* FRAME_WH */], function (state, payload) {
  var resizeWidth = false;

  if (payload.centerPage != undefined && payload.centerPage != '') {
    if (parseFloat(state.frameWidthHeight.width.CenterPage_current) != parseFloat(payload.centerPage)) {
      state.frameWidthHeight.width.CenterPage_current = payload.centerPage;
    }
  }

  if (payload.rightPage != undefined && payload.rightPage != '') {
    if (parseFloat(state.frameWidthHeight.width.RightPage_current) != parseFloat(payload.rightPage)) {
      state.frameWidthHeight.width.RightPage_current = payload.rightPage;
    }
  }

  if (payload.currentHeight != undefined && payload.currentHeight != '') {
    if (parseFloat(state.frameWidthHeight.height.currentHeight) != parseFloat(payload.currentHeight)) {
      state.frameWidthHeight.height.currentHeight = payload.currentHeight;
    }
  }

  if (payload.currentWidth != undefined && payload.currentWidth != '') {
    var currentWidthSet = state.frameWidthHeight.width.currentWidth;
    var minFull = this.getters.frameWidthHeight.width.minFull;
    if (parseFloat(state.frameWidthHeight.width.currentWidtht) != parseFloat(payload.currentWidth)) {
      state.frameWidthHeight.width.currentWidth = parseFloat(payload.currentWidth);
      currentWidthSet = parseFloat(payload.currentWidth);
    }
    if (currentWidthSet < minFull) {
      this.commit('MINI_NORMAL', 1);
      this.commit('UNFOLD_ALLSC', false);
      state.show_Unfold = false;
      state.show_Fold = false;
      state.frameWidthHeight.width.LeftPage_current = state.frameWidthHeight.width.LeftPage_mini;
    } else {
      this.commit('MINI_NORMAL', 0);
      var sprt = state.selectedBettype.sprtId;
      var tmp = state.selectedBettype.tmpltId;
      if (sprt == 'N1' && tmp == '1') {
        state.show_Unfold = true;
      }
      state.frameWidthHeight.width.LeftPage_current = state.frameWidthHeight.width.LeftPage_normal;
    }
    resizeWidth = true;
  }

  if (payload.LeftPageStatus != undefined && payload.LeftPageStatus != '') {
    if (payload.LeftPageStatus == 2) {
      state.frameWidthHeight.width.LeftPage_current = state.frameWidthHeight.width.LeftPage_mini;
    } else {
      state.frameWidthHeight.width.LeftPage_current = state.frameWidthHeight.width.LeftPage_normal;
    }
    resizeWidth = true;
  }

  if (resizeWidth) {
    this.commit('FRAME_RESIZE', 1);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_0" /* FRAME_RESIZE */], function (state, payload) {
  var currentWidthSet = window.innerWidth;
  var minFull = this.getters.frameWidthHeight.width.minFull;
  var leftPage = this.getters.frameWidthHeight.width.LeftPage_current;
  var rightPage = this.getters.frameWidthHeight.width.RightPage_min;
  if (currentWidthSet <= minFull) {
    currentWidthSet = minFull;
  } else {
    rightPage = (currentWidthSet - minFull) / 5 + rightPage;
    if (rightPage > this.getters.frameWidthHeight.width.RightPage_max) {
      rightPage = this.getters.frameWidthHeight.width.RightPage_max;
    }
  }
  if (this.getters.selectedBettype && this.getters.selectedBettype.sprtId != undefined) {
    var sprt = this.getters.selectedBettype.sprtId;
    var tmp = this.getters.selectedBettype.tmpltId;
    if (!_.isUndefined(this.getters.unfold_AllSc[sprt]) && !_.isUndefined(this.getters.unfold_AllSc[sprt][tmp]) && this.getters.unfold_AllSc[sprt][tmp]) {
      rightPage = 0;
    }
  }
  var centerPage = currentWidthSet - rightPage - leftPage;
  var resizeable = {};

  resizeable.rightPage = rightPage;
  resizeable.centerPage = centerPage;
  this.commit('FRAME_WH', resizeable);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_18" /* LIVETV */], function (state, payload) {
  state.livetv.eveid = payload.eveid;
  state.livetv.link = payload.link;
  __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('rightScoreBoard', true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["W" /* FILTER_EVENT */], function (state, payload) {
  state.filterEventArr = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_87" /* SHOW_RBLGEEVE */], function (state, payload) {
  state.showRBLgeEve = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_86" /* SHOW_LGEEVE */], function (state, payload) {
  state.showLgeEve = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_11" /* IS_CHANGE_TEMPLATE */], function (state, payload) {
  state.isChangeTemplate = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_65" /* SELECTED_EVEID */], function (state, payload) {
  state.selectedEventId = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_13" /* IS_PARLAY_TAB */], function (state, payload) {
  state.isParlayTab = payload;
  if (!window.allowRbParlay && this.getters.isBetParlay && this.getters.betForm.length == 0 && !payload) {
    this.commit("IS_BETPARLAY", false);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_39" /* PREV_BETTYPE */], function (state, payload) {
  state.previousBettype = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_4" /* GAME_BANNER_SPORT_COUNT */], function (state, payload) {
  state.gameBannerSportCount = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_5" /* GAME_BANNER_SPORT_ID */], function (state, payload) {
  state.gameBannerSportId = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_53" /* RIGHT_BOARD_CHG */], function (state, payload) {
  state.rightBoardChange = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_89" /* SIMPLE_SPORT */], function (state, payload) {
  state.simpleSport = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_8" /* HOT_SCHEDULE */], function (state, payload) {
  state.hotSchedule = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["_9" /* HOT_SPORTLIST */], function (state, payload) {
  state.hot_sportList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SPECIAL_EVENT', function SPECIAL_EVENT(state, payload) {
  state.specialEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SPECIAL_EVENT_LIST', function SPECIAL_EVENT_LIST(state, payload) {
  state.specialEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'REFRESHTOGGLE', function REFRESHTOGGLE(state, payload) {
  state.refreshToggle = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SHOW_UP_DOWN', function SHOW_UP_DOWN(state, payload) {
  state.ShowUpDown = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(10);


var _mutations;



var state = {
  sportResultsLang: {},
  sportResultsDateList: []
};

var getters = {
  sportResultsLang: function sportResultsLang(state) {
    return state.sportResultsLang;
  },
  sportResultsDateList: function sportResultsDateList(state) {
    return state.sportResultsDateList;
  }
};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_105" /* SPORTRESULT_LANG */], function (state, payload) {
  state.sportResultsLang = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_104" /* SPORTRESULT_DATELIST */], function (state, payload) {
  state.sportResultsDateList = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_core_core__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(10);





var state = {
    otrSportList: []

};

var getters = {

    otrSportList: function otrSportList(state) {
        return state.otrSportList;
    }
};

var actions = {
    getSportOutrightOdds: function getSportOutrightOdds(context, payload) {
        var _this = this;

        var url = '';

        if (this.getters.account.previewFlag == true) {
            url = window._baseUrl + '/sport-outright-odds-preview';
        } else {
            url = window._baseUrl + '/sport-outright-odds';
        }

        var data = {
            sprtid: this.getters.selectedBettype.sprtId,
            lang: window._langid,
            token: payload.token,
            odd: this.getters.oddTypesList.EU.key
        };
        if (this.getters.account.oddsType == 'am') {
            data.odd = this.getters.oddTypesList.AM.key;
        }
        var STORE = this;

        if (this.getters.cookieLeague) {

            var cookieLeague = this.getters.cookieLeague;
            var selectedMarket = this.getters.selectedMarket;
            var selectedSport = this.getters.selectedBettype.sprtId;
            var selectedBettype = this.getters.selectedBettype.betTypId;
            if (!this.getters.selectAllLeague) {
                if (cookieLeague[selectedMarket]) {
                    if (cookieLeague[selectedMarket][selectedSport]) {
                        if (cookieLeague[selectedMarket][selectedSport][selectedBettype] && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(cookieLeague[selectedMarket][selectedSport][selectedBettype]).length > 0) {
                            url = window._baseUrl + '/sport-outright-league';
                            data.leagues = cookieLeague[selectedMarket][selectedSport][selectedBettype];
                            data.action = '2';
                        } else {
                            if (this.getters.account.previewFlag == true) {
                                url = window._baseUrl + '/sport-outright-odds-preview';
                            } else {
                                url = window._baseUrl + '/sport-outright-odds';
                            }
                        }
                    } else {
                        if (this.getters.account.previewFlag == true) {
                            url = window._baseUrl + '/sport-outright-odds-preview';
                        } else {
                            url = window._baseUrl + '/sport-outright-odds';
                        }
                    }
                } else {
                    if (this.getters.account.previewFlag == true) {
                        url = window._baseUrl + '/sport-outright-odds-preview';
                    } else {
                        url = window._baseUrl + '/sport-outright-odds';
                    }
                }
            } else {
                if (this.getters.account.previewFlag == true) {
                    url = window._baseUrl + '/sport-outright-odds-preview';
                } else {
                    url = window._baseUrl + '/sport-outright-odds';
                }
            }
        }
        __WEBPACK_IMPORTED_MODULE_2__js_core_core__["default"].$ajax({
            method: 'get',
            url: url,
            data: data
        }).done(function (res) {
            if (payload.leagueList) {
                STORE.commit('SPORT_LEAGUE_TOGGLE');
            }
            var counter = 0;
            var events = _.cloneDeep(res.events);
            if (events && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(events).length > 0) {
                var currentEveID = [];
                var sprtlist = [];

                _.forEach(events, function (value, index) {
                    sprtlist.push(value.sptid);
                    currentEveID.push(value.eveid);
                    if (!_.isUndefined(STORE.getters.favouriteOTREvents)) {
                        if (!_.isUndefined(STORE.getters.favouriteOTREvents['N' + value.sptid]) && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(STORE.getters.favouriteOTREvents['N' + value.sptid]).length > 0) {
                            _.forEach(STORE.getters.favouriteOTREvents['N' + value.sptid], function (favEvent, index2) {
                                if (favEvent == value.eveid) {
                                    counter++;
                                }
                            });
                        }
                    }
                });
                var uniqueSites = sprtlist.filter(function (item, i, sprtlist) {
                    return i == sprtlist.indexOf(item);
                });
                _this.commit('OTRSPORTLIST', uniqueSites);
                if (STORE.getters.selectedBettype.sprtId != "G98") {
                    _.forEach(STORE.getters.favouriteOTREvents[STORE.getters.selectedBettype.sprtId], function (favEvent, index2) {
                        if (!(currentEveID.indexOf(favEvent) !== -1)) {
                            this.$store.commit('FAVOURITEOTREVENT', { eveId: favEvent, selectedSport: STORE.getters.selectedBettype.sprtId });
                        }
                    });
                }
            }
            _this.commit('EVENTLIST', events);
            _this.commit('FAVOURITEOTREVENTCOUNT', counter);
            _this.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
            if (payload.callback) {
                return payload.callback(res);
            }
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_35" /* OTRSPORTLIST */], function (state, payload) {
    state.otrSportList = payload;
});

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_core_core__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);





var _mutations;









var state = {
  betLang: null,
  oddSelected: false,
  betForm: [],
  latestInfo: [],
  BetTypeLang: null,
  int_betType: "",
  int_maxParlayMaxMatch: 10,
  bool_checkSameEvent: true,
  betting: {
    betAllUpList: [],
    betAmountOption: {
      min: 50,
      med: 150,
      big: 250,
      big2: 500,
      big3: 1000,
      max: 0
    },
    incentive: 1,
    selectedBetAllup: null,
    sErr: null,
    delayBetTimerId: null
  },
  ajaxBettingList: null,
  allowRequestLatestInfo: true,
  delayBet: null,
  isBetSuccess: false,
  isProcessBet: false,
  isPlacedBet: false,
  pendingFlag: false,
  resizeWHeight: null,
  hdpDisp: window.hdpDisp,
  jsError: { error: false },
  betCombo_jsError: {},
  selectedBetListType: 1,
  selectedBetTab: false,
  openBetForm: false,
  betAmount: '',
  showbetformMenu: false,
  betFormHdpChange: false,
  betFormOddChange: false,
  isBetCombo: false,
  isBetParlay: false,
  comboBetExceedLimit: false,
  betComboAmount: [],
  betComboKeyboardAllow: [],

  wgHdpOddNoChgIndex: [],
  allowErrBetAgain: false,
  betMulpAmount: [],
  betMulpAmtFiltered: [],
  disableBet: false,
  dialogToggle: {
    show: false
  },
  selectedMulpBetBoxId: 0
};

var getters = {
  betLang: function betLang(state) {
    return state.betLang;
  },
  oddSelected: function oddSelected(state) {
    return state.oddSelected;
  },
  betForm: function betForm(state) {
    return state.betForm;
  },
  BetTypeLang: function BetTypeLang(state) {
    return state.BetTypeLang;
  },
  betting: function betting(state) {
    return state.betting;
  },
  isBetSuccess: function isBetSuccess(state) {
    return state.isBetSuccess;
  },
  isProcessBet: function isProcessBet(state) {
    return state.isProcessBet;
  },
  isPlacedBet: function isPlacedBet(state) {
    return state.isPlacedBet;
  },
  pendingFlag: function pendingFlag(state) {
    return state.pendingFlag;
  },
  resizeWHeight: function resizeWHeight(state) {
    return state.resizeWHeight;
  },
  hdpDisp: function hdpDisp(state) {
    return state.hdpDisp;
  },
  jsError: function jsError(state) {
    return state.jsError;
  },
  betCombo_jsError: function betCombo_jsError(state) {
    return state.betCombo_jsError;
  },
  selectedBetTab: function selectedBetTab(state) {
    return state.selectedBetTab;
  },
  selectedBetListType: function selectedBetListType(state) {
    return state.selectedBetListType;
  },
  latestInfo: function latestInfo(state) {
    return state.latestInfo;
  },
  betAmountOption: function betAmountOption(state, getters) {

    if (!__WEBPACK_IMPORTED_MODULE_9_vue_cookie___default.a.get(window.compcode + '_acc_' + getters.account.acccode)) {
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        data: {
          com_code: window.compcode,
          acc: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(state.betting.betAmountOption),
          acc_code: getters.account.acccode
        }
      }).done(function (res) {});
      return state.betting.betAmountOption;
    } else {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_9_vue_cookie___default.a.get(window.compcode + '_acc_' + getters.account.acccode));
    }
  },
  delayBet: function delayBet(state) {
    return state.delayBet;
  },
  openBetForm: function openBetForm(state) {
    return state.openBetForm;
  },
  betAmount: function betAmount(state) {
    return state.betAmount;
  },
  showbetformMenu: function showbetformMenu(state) {
    return state.showbetformMenu;
  },
  betFormHdpChange: function betFormHdpChange(state) {
    return state.betFormHdpChange;
  },
  betFormOddChange: function betFormOddChange(state) {
    return state.betFormOddChange;
  },
  isBetCombo: function isBetCombo(state) {
    return state.isBetCombo;
  },
  isBetParlay: function isBetParlay(state) {
    return state.isBetParlay;
  },
  comboBetExceedLimit: function comboBetExceedLimit(state) {
    return state.comboBetExceedLimit;
  },
  betComboAmount: function betComboAmount(state) {
    return state.betComboAmount;
  },
  betComboKeyboardAllow: function betComboKeyboardAllow(state) {
    return state.betComboKeyboardAllow;
  },

  wgHdpOddNoChgIndex: function wgHdpOddNoChgIndex(state) {
    return state.wgHdpOddNoChgIndex;
  },
  allowErrBetAgain: function allowErrBetAgain(state) {
    return state.allowErrBetAgain;
  },
  betMulpAmount: function betMulpAmount(state) {
    return state.betMulpAmount;
  },
  betMulpAmtFiltered: function betMulpAmtFiltered(state) {
    return state.betMulpAmtFiltered;
  },
  disableBet: function disableBet(state) {
    return state.disableBet;
  },
  dialogToggle: function dialogToggle(state) {
    return state.dialogToggle;
  },
  selectedMulpBetBoxId: function selectedMulpBetBoxId(state) {
    return state.selectedMulpBetBoxId;
  }
};

var actions = {
  removeMatch: function removeMatch(context, payload) {
    if (!_.isUndefined(payload.data.clearType) && payload.data.clearType == '1') {
      var VUE = this;
      var removeArr = [];
      _.forEach(state.betForm, function (value, key) {
        if (!_.isUndefined(value.error) && !_.isUndefined(value.error.status) && value.error.status == 'FAIL' || (VUE.getters.isBetParlay || VUE.getters.selectedBettype.betTypId == '5') && !_.isUndefined(value.error) && value.error != '') {
          removeArr.push(key);
          if (document.getElementById(value.uniqueId)) {
            document.getElementById(value.uniqueId).parentElement.classList.remove('active');
          }
        }
      });
      removeArr = removeArr.sort().reverse();
      _.forEach(removeArr, function (val, id) {
        VUE.commit('REMOVE_MATCH', val);
      });
      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'betcomboerror');
    } else if (!_.isUndefined(payload.data.clearType) && payload.data.clearType == '2') {
      this.commit("REMOVE_ALLBUTLAST");
    } else if (!_.isUndefined(payload.data.clearType) && payload.data.clearType == '3') {
      this.commit('REMOVE_MATCH', payload.data.index);
    } else {
      var index = _.findIndex(state.betForm, { 'eventObj': { 'eveid': payload.data.eveid } });
      this.commit('REMOVE_MATCH', index);
    }

    if (payload) {
      if (payload.callback) {
        return payload.callback();
      }
    }
  },
  confirmBet: function confirmBet(context, payload) {
    this.commit('JS_ERR', '');
    if (this.getters.requestAllow == false) {
      return;
    }
    var estWinningAmount = 0;
    var oddValue = '';
    var STORE = this;
    var bettingAmount = this.getters.sportMiniBet.betAmount;

    function validateOddBetType(betTyp, odd, oddTyp) {

      if (oddTyp == 'am') {
        if (odd < 0) {
          odd = Math.abs(100 / odd);
        } else {
          odd = odd / 100;
        }
        odd = odd.toFixed(3);
      } else if ((betTyp == '4' || betTyp == '11' || betTyp == '12' || betTyp == '13' || betTyp == '3' || betTyp == '10' || betTyp == '5' || betTyp == '6' || betTyp == '7' || betTyp == '14' || betTyp == '16' || betTyp == '17' || betTyp == '18' || betTyp == '19' || betTyp == '20' || betTyp == '21' || betTyp == '25' || betTyp == '27' || betTyp == '28' || betTyp == '29' || betTyp == '30' || betTyp == '31' || betTyp == '32' || betTyp == '33' || betTyp == '34' || betTyp == '35' || betTyp == '36' || betTyp == '37' || betTyp == '38' || betTyp == '39' || betTyp == '40' || betTyp == '41' || betTyp == '42' || betTyp == '43' || betTyp == '44' || betTyp == '45' || betTyp == '50' || betTyp == '51' || betTyp == '52' || betTyp == '53' || betTyp == '54' || betTyp == '55' || betTyp == '56' || betTyp == '59' || betTyp == '73' || betTyp == '60' || betTyp == '61' || betTyp == '62' || betTyp == '63' || betTyp == '64' || betTyp == '65' || betTyp == '66' || betTyp == '67' || betTyp == '68' || betTyp == '69' || betTyp == '70' || betTyp == '71' || betTyp == '72' || betTyp == '73' || betTyp == '74' || betTyp == '76' || betTyp == '79' || betTyp == '77' || betTyp == '78') && odd > 1) {
        if (betTyp == '3' || betTyp == '10') {
          odd = oddTyp != 'in' ? odd - 1 : odd;
        } else {
          odd -= 1;
        }
      } else if (oddTyp == 'eu' && odd > 1) {
        odd -= 1;
      }
      return odd;
    }

    if (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') {
      _.forEach(this.getters.betMulpAmtFiltered, function (arr, id) {
        var allUpIndex = _.findIndex(STORE.getters.betting.allUpList, { 'key': arr.allUpKey });
        var mulpParser = STORE.getters.betting.allUpList[allUpIndex].parser.split('#');
        for (var index = 0; index < mulpParser.length; index++) {
          var commaList = mulpParser[index].split(',');
          var ttlOdds = 1;
          oddValue = '';
          for (var comma = 0; comma < commaList.length; comma++) {
            var betData = STORE.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if (STORE.getters.account.oddsType == 'am') {
              if (betOdd < 0) {
                betOdd = Math.abs(100 / betOdd);
              } else {
                betOdd = betOdd / 100;
              }
              betOdd = betOdd.toFixed(2);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          oddValue = 1;

          estWinningAmount += parseFloat(arr.amount) * oddValue;
        }
      });
    } else {
      var betOdd = parseFloat(this.getters.betForm[0].odd);
      oddValue = betOdd;
      oddValue = oddValue < 0 && (this.getters.account.oddsType == 'my' || this.getters.account.oddsType == 'in') ? 1 : validateOddBetType(this.getters.betForm[0].betType, betOdd, this.getters.account.oddsType);
      estWinningAmount = this.getters.sportMiniBet.betAmount * oddValue;
    }

    var betFormData = _.cloneDeep(this.getters.betForm);
    _.forEach(betFormData, function (value) {
      value.rca = 0;
      value.rcb = 0;
      if (value.eventObj.rbinfo) {
        if (value.eventObj.rbinfo.rca) {
          value.rca = value.eventObj.rbinfo.rca;
        } else if (value.eventObj.rbinfo.rcb) {
          value.rcb = value.eventObj.rbinfo.rcb;
        }
      }
      _.unset(value, 'eventObj');
      _.unset(value, 'oddChg');
    });

    if (this.getters.isBetCombo) {
      var arr = [];
      _.forEach(this.getters.betComboAmount, function (data, key) {
        arr[key] = data.value;
      });
      bettingAmount = arr;
    }

    __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('stopBettingTimer');
    var data = {
      betting: betFormData,
      amount: bettingAmount,

      betterOd: this.getters.account.autoAccBetterOdd,
      oddsType: (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') && this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
      isMulp: this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5' ? 1 : 0,
      isCombo: this.getters.isBetCombo ? 1 : 0,
      market: this.getters.selectedMarket
    };

    if (this.getters.promotionFlag && !this.getters.promotionBetWithoutJoin && !data.isMulp && !this.getters.promotionBetStatus) {
      data.promotionBetIndexArr = this.getters.promotionBetIndex;
    }

    if (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') {
      var amountArr = [];
      var allUpArr = [];
      _.forEach(this.getters.betMulpAmtFiltered, function (arr, key) {
        amountArr[key] = arr.amount;
        allUpArr[key] = arr.allUpKey;
      });
      data.amount = amountArr;
      data.allUp = allUpArr;
      data.minMax = this.getters.betting.minMax;
    }
    this.commit('REQUEST_ALLOW', false);

    if (this.getters.delayBet > 0) {
      this.dispatch('ajaxInitBet', {
        payload: payload,
        data: data
      });
    } else {
      this.dispatch('ajaxConfirmBet', {
        payload: payload,
        data: data
      });
      __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('ttlbetCount');
    }
  },
  ajaxInitBet: function ajaxInitBet(context, payload) {
    var _this = this;

    var STORE = this;
    __WEBPACK_IMPORTED_MODULE_5__js_core_core__["default"].$ajax({
      method: 'post',
      url: window._baseUrl + '/sport-betting/init-bet',
      data: { token: window.token.arr_2 }
    }).done(function (res) {
      var delayTimer = parseInt(res.SYSTEM_DATA.DelayBet) * 1000;

      _this.commit('REQUEST_ALLOW', false);
      state.betting.delayBetTimerId = setTimeout(function () {
        this.dispatch('ajaxConfirmBet', {
          payload: payload.payload,
          data: payload.data
        });
      }.bind(_this), delayTimer);
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  ajaxConfirmBet: function ajaxConfirmBet(context, payload) {
    var _this2 = this;

    var STORE = this;

    if (payload.data.betting) {
      _.forEach(payload.data.betting, function (data) {
        _.unset(data, 'title');
        _.unset(data, 'league');
        _.unset(data, 'ta');
        _.unset(data, 'tb');
        _.unset(data, 'league');
        _.unset(data, 'tbetcapt');
        _.unset(data, 'plyTypCap');
        _.unset(data, 'hdpCap');
        _.unset(data, 'uniqueId');

        if (data.sprtid != '1' && jQuery.inArray(data.betType, ['8', '9', '10', '11', '13', '16', '17', '18', '20', '27', '29', '31', '33', '35', '37', '39', '41', '43', '45', '47', '49', '51', '55', '56', '58', '61', '64', '66', '69', '71', '73']) == '-1') {
          _.unset(data, 'rbscoa');
          _.unset(data, 'rbscob');
          _.unset(data, 'rca');
          _.unset(data, 'rcb');
        }

        _.unset(data, 'error');
        _.unset(data, 'hdpChg');
        _.unset(data, 'oddChg');
        _.unset(data, 'oddChgUpDown');
      });
    }
    var betURL = '/sport-betting/confirm-bet';
    if (this.getters.isBetCombo) {
      betURL = '/sport-betting/confirm-combo-bet';
    } else if (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') {
      betURL = '/sport-betting/confirm-mulp-combo-bet';
    }

    payload.data.token = token.arr_2;
    __WEBPACK_IMPORTED_MODULE_5__js_core_core__["default"].$ajax({
      data: payload.data,
      method: 'post',
      url: window._baseUrl + betURL
    }).done(function (res) {
      var refreshTimer = false;
      STORE.commit('REQUEST_ALLOW', true);
      STORE.commit('BETFORM_HDPCHG', false);
      STORE.commit('BETFORM_ODDCHG', false);
      STORE.commit('ALLOW_ERR_BET_AGAIN', false);
      state.allowRequestLatestInfo = true;
      state.betting.sErr = null;

      if (_this2.getters.isBetCombo) {
        var ret = JSON.parse(res);
        var success = false;
        _.forEach(ret.SYSTEM_DATA.betting, function (arr, key) {
          if (arr.error == '') {
            _.unset(arr, 'error');
          }
          success = !_.isUndefined(arr.wgStatus) && (arr.wgStatus == '0' || arr.wgStatus == '2') ? true : false;
        });

        var wgError = _.findIndex(ret.SYSTEM_DATA.betting, { 'error': { 'status': 'FAIL' } });
        var wgPending = _.findIndex(ret.SYSTEM_DATA.betting, { 'wgStatus': '1' });
        var wgReject = _.findIndex(ret.SYSTEM_DATA.betting, { 'wgStatus': '-1' });
        if (wgPending > -1) {
          _this2.commit('BETTING_MESSAGE', {
            isPending: true,
            data: ret.SYSTEM_DATA
          });
        } else if (success && wgPending < 0 && wgError < 0 && wgReject < 0) {
          _this2.commit('BETCOMBO_MESSAGE', { isSuccess: true });
        }

        if (wgError > -1) {
          _this2.commit('BETCOMBO_MESSAGE', { isError: true });
        }

        var errCodeAllowBetAgain = ['4003-N', '4010-N'];
        var atLeastOneSuccess = _.findIndex(ret.SYSTEM_DATA.betting, function (record) {
          return record.WagerID !== undefined;
        });
        var atLeastOneError = _.findIndex(ret.SYSTEM_DATA.betting, function (record) {
          return record.error !== '' && record.error !== undefined;
        });
        var wgHdpOddNoChgIndex_temp = [];
        if (atLeastOneError > -1 && atLeastOneSuccess > -1) {
          _.forEach(ret.SYSTEM_DATA.betting, function (arr, key) {
            if (!_.isUndefined(arr.error) && !_.isUndefined(arr.error.code)) {
              if (arr.error.code == '4010-N') {
                STORE.commit('BETFORM_HDPCHG', true);
              }
              if (arr.error.code == '4003-N') {
                STORE.commit('BETFORM_ODDCHG', true);
              }
              if (_.indexOf(errCodeAllowBetAgain, arr.error.code) !== -1) {
                STORE.commit('ALLOW_ERR_BET_AGAIN', true);
              }
              if (!(_.indexOf(errCodeAllowBetAgain, arr.error.code) !== -1)) {
                wgHdpOddNoChgIndex_temp.push(key);
              }
            } else {
              wgHdpOddNoChgIndex_temp.push(key);
            }
          });
          _this2.commit('BETCOMBO_MESSAGE', { isSuccess: true });
          if (!_this2.getters.miniNormal) {
            setTimeout(function () {
              if (state.betting.betcombosuccess || state.betting.pending) {
                var elHeight = $("#singleContainer").height() + 50;
                $("#singleContainer").height(elHeight);
              }
            }, 1000);
          }
        } else if (atLeastOneError > -1) {
          if (_this2.getters.miniNormal) {
            __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('expandMini');
          }
        }
        _this2.commit('SET_MATCH_INDEX_NO_ERR', wgHdpOddNoChgIndex_temp);

        var account = _this2.getters.account;
        account.currCL = ret.SYSTEM_DATA.accCcl;
        var currCL_O = ret.SYSTEM_DATA.accCcl * account.currUnit;
        account.currCL_O = new Intl.NumberFormat().format(currCL_O);
        STORE.commit('ACCOUNT', account);

        STORE.commit('PROCESS_BET', false);
        if (state.betting.sErr == null) {
          __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('betSlipCss', true);
          STORE.commit('ODD_SELECTED', false);
        } else {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'betcombosuccess');
        }

        _this2.commit('SPORT_MAPPING_BETTING', {
          newBettingList: ret.SYSTEM_DATA.betting,
          oldBettingList: _.cloneDeep(_this2.getters.betForm),
          betConfirm: 1
        });

        if (_this2.getters.promotionFlag && !_this2.getters.promotionBetStatus) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this2.getters.promotionBetIndex), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var value = _step.value;

              _this2.commit('PROMO_SHOW_JOIN_SUCCESS', ret.SYSTEM_DATA.betting[value].promotionBetStatus != undefined ? ret.SYSTEM_DATA.betting[value].promotionBetStatus : false);
              _this2.commit('PROMO_BET_STATUS', ret.SYSTEM_DATA.betting[value].promotionBetStatus != undefined ? ret.SYSTEM_DATA.betting[value].promotionBetStatus : false);
              if (ret.SYSTEM_DATA.betting[value].promotionBetStatus != undefined && ret.SYSTEM_DATA.betting[value].promotionBetStatus == true) {
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      } else if (_this2.getters.isBetParlay || _this2.getters.selectedBettype.betTypId == '5') {
        var ret = JSON.parse(res);

        __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('stopBettingTimer', res);
        STORE.commit('PROCESS_BET', false);
        var wgSuccess = _.findIndex(ret.SYSTEM_DATA.mulpRes, function (record) {
          return record.WagerID !== undefined;
        });
        var wgError = _.findIndex(ret.SYSTEM_DATA.mulpRes, function (record) {
          return record.error !== '';
        });
        if (wgSuccess > -1) {
          var pendingFlag = false;
          var rbBetTypes = ['8', '9', '10', '11', '13', '16', '17', '18', '20', '27', '29', '31', '33', '35', '37', '39', '41', '43', '45', '47', '49', '51', '55', '56', '58', '61', '64', '66', '69', '71', '73'];
          _.forEach(ret.SYSTEM_DATA.betting, function (value, key) {
            if (rbBetTypes.indexOf(value.betType) != -1 && value.sprtid == '1') {
              pendingFlag = true;
            }
          }.bind(_this2));

          if (pendingFlag) {
            _.forEach(ret.SYSTEM_DATA.mulpRes, function (value, key) {
              ret.SYSTEM_DATA.mulpRes[key]['wgStatus'] = '1';
            }.bind(_this2));

            _this2.commit('BETTING_MESSAGE', {
              isPending: true,
              data: ret.SYSTEM_DATA
            });
          } else {
            _.forEach(ret.SYSTEM_DATA.mulpRes, function (value, key) {
              ret.SYSTEM_DATA.mulpRes[key]['wgStatus'] = '0';
            }.bind(_this2));

            _this2.commit('BETTING_MESSAGE', {
              isSuccess: true,
              data: ret.SYSTEM_DATA
            });
          }

          if (!_.isUndefined(ret.SYSTEM_DATA.accCcl)) {
            var account = _this2.getters.account;
            account.currCL = ret.SYSTEM_DATA.accCcl;
            var currCL_O = ret.SYSTEM_DATA.accCcl * account.currUnit;
            account.currCL_O = new Intl.NumberFormat().format(currCL_O);
            STORE.commit('ACCOUNT', account);
          }

          __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('betSlipCss', true);
          STORE.commit('ODD_SELECTED', false);
          STORE.commit('BET_SUCCESS', true);

          STORE.commit("BETMULP_AMOUNT", { clear: true });

          _this2.commit('SPORT_MAPPING_BETTING', {
            newBettingList: ret.SYSTEM_DATA.betting,
            oldBettingList: _.cloneDeep(_this2.getters.betForm),
            betConfirm: 1
          });
        } else {
          var message = state.betLang['BETTING.LBL_REJECT_BET'];
          var errObj = { error: true, msg: message };
          if (wgError > -1) {
            var err = ret.SYSTEM_DATA.mulpRes[wgError].error;
            message = _.isUndefined(err.message) ? message : err.message;
            errObj.msg = message;
          }
          _this2.commit('JS_ERR', errObj);
        }

        if (_this2.getters.miniNormal) {
          __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('expandMini');
        }
      } else {

        if (res.SYSTEM_DATA.status == 'FAIL') {
          _this2.commit('PROCESS_BET', false);
          _this2.commit('BETTING_MESSAGE', {
            isError: true,
            data: res.SYSTEM_DATA
          });
          if (res.SYSTEM_DATA.code.indexOf('4022') >= 0) {
            alert(res.SYSTEM_DATA.message + '(' + res.SYSTEM_DATA.code + ')');
            window.location = 'login';
          }
        } else if (res.SYSTEM_DATA.WagerID) {
          var wgPending = _.findIndex(res.SYSTEM_DATA.betting, {
            wgStatus: '1'
          });
          if (wgPending > -1) {
            _this2.commit('BETTING_MESSAGE', {
              isPending: true,
              data: res.SYSTEM_DATA
            });
          } else {
            _this2.commit('BETTING_MESSAGE', {
              isSuccess: true,
              data: res.SYSTEM_DATA
            });
          }

          __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('stopBettingTimer', res);
          __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('betSlipCss', true);
          STORE.commit('ODD_SELECTED', false);
          STORE.commit('PROCESS_BET', false);
          STORE.commit('BET_SUCCESS', true);

          if (res.SYSTEM_DATA['betting'][0]['betType'] != '15') {
            if (!_.isEmpty(STORE.getters.sportForecastList)) {
              _this2.dispatch('removeSportForecastList', {
                eveid: res.SYSTEM_DATA['betting'][0]['eveid'],
                ftPlyType: res.SYSTEM_DATA['betting'][0]['plyType'],
                bettypKey: res.SYSTEM_DATA['betting'][0]['betType'],
                tbetKey: res.SYSTEM_DATA['betting'][0]['tbet']
              });
              __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('FORECAST_GETWAITINGLIST', 'nodata');
              __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('FORECAST_CALC', null);
            }
          }
          _this2.commit('SPORT_MINIBET_BETAMOUNT', res.SYSTEM_DATA['amount']);

          _this2.commit('SPORT_MAPPING_BETTING', {
            newBettingList: res.SYSTEM_DATA.betting,
            oldBettingList: _this2.getters.betForm,
            betConfirm: 1
          });

          if (_this2.getters.promotionFlag && !_this2.getters.promotionBetStatus) {
            _this2.commit('PROMO_SHOW_JOIN_SUCCESS', res.SYSTEM_DATA.promotionBetStatus != undefined ? res.SYSTEM_DATA.promotionBetStatus : false);
            _this2.commit('PROMO_BET_STATUS', res.SYSTEM_DATA.promotionBetStatus != undefined ? res.SYSTEM_DATA.promotionBetStatus : false);
          }
        } else {
          if (res.SYSTEM_DATA.error) {
            refreshTimer = true;
            if (res.SYSTEM_DATA.error.message) {
              state.betting.sErr = res.SYSTEM_DATA.error;
            }
            if (res.SYSTEM_DATA.error.code.indexOf('4002') >= 0) {
              _.unset(state.latestInfo, 'callback');
              state.betting.firstLoadError = false;
              _this2.dispatch('ajaxLatestInfo', state.latestInfo);
            }
          }
          _this2.commit('BETTING_MESSAGE', { isError: false });
          _this2.commit('SPORT_MAPPING_BETTING', {
            newBettingList: res.SYSTEM_DATA.betting,
            oldBettingList: _this2.getters.betForm
          });
        }
      }

      if (payload) {
        if (payload.callback) {
          return payload.callback(res);
        } else if (payload.payload && payload.payload.callback) {
          if (refreshTimer) {
            return payload.payload.callback(res);
          }
        }
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getBettingInfo: function getBettingInfo(context, payload) {
    var betData = _.cloneDeep(this.getters.betForm);

    payload.betData = betData;
    this.dispatch('ajaxLatestInfo', payload);
  },
  getLatestInfo: function getLatestInfo(context, payload) {
    var betData = [_.cloneDeep(payload.data)];

    if (this.getters.betting.success && this.getters.selectedBettype.betTypId != '5' && !this.getters.isBetParlay) {
      state.betForm = [];
    }

    if (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') {
      var sportBetFormList = _.filter(this.getters.betForm, { 'sprtid': payload.data.eventObj.sptid });

      if (sportBetFormList.length == 0) {
        state.betForm = [];
        state.betForm = betData;
      }
      if (this.getters.sportPrevIsMulp) {
        if (_.find(this.getters.betForm, { 'eventObj': { 'eveid': payload.data.eventObj.eveid } }) != 'undefined') {
          var index = _.findIndex(this.getters.betForm, { 'eventObj': { 'eveid': payload.data.eventObj.eveid } });
          if (index < 0) {
            var betFormList = _.cloneDeep(this.getters.betForm);
            betData = _.cloneDeep(betData.concat(betFormList));
          } else {
            var storeBetList = _.cloneDeep(this.getters.betForm);
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(storeBetList, index, payload.data);
            betData = _.cloneDeep(storeBetList);
          }
        }
      } else {
        this.commit('SPORT_PREVIOUS_IS_MULP', true);
      }
    } else if (this.getters.isBetCombo || payload.isBetCombo) {
      if (_.find(this.getters.betForm, { 'eventObj': { 'eveid': payload.data.eventObj.eveid } }) != 'undefined') {
        var index = _.findIndex(this.getters.betForm, {
          'eveid': payload.data.eveid,
          'plyType': payload.data.plyType,
          'betType': payload.data.betType,
          'dual': payload.data.dual
        });

        if (index < 0) {
          var betFormList = _.cloneDeep(this.getters.betForm);
          betData = _.cloneDeep(betData.concat(betFormList));
        } else {
          var storeBetList = _.cloneDeep(this.getters.betForm);
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(storeBetList, index, payload.data);
          betData = _.cloneDeep(storeBetList);
        }
      }
    }
    payload.betData = betData;
    payload.token = token.arr_2;
    this.dispatch('ajaxLatestInfo', payload);
  },
  ajaxLatestInfo: function ajaxLatestInfo(context, payload) {
    var _this3 = this;

    var STORE = this;
    if (state.allowRequestLatestInfo == false) {
      return;
    }
    if (this.getters.requestAllow == false) {
      return;
    }
    state.allowRequestLatestInfo = false;
    state.latestInfo = payload;
    _.forEach(payload.betData, function (data) {
      _.unset(data, 'fav');
      _.unset(data, 'hdp');
      _.unset(data, 'odd');
      _.unset(data, 'rbscoa');
      _.unset(data, 'rbscob');
      _.unset(data, 'eventObj');
      _.unset(data, 'league');
      _.unset(data, 'ta');
      _.unset(data, 'tb');
      _.unset(data, 'tbetcapt');
      _.unset(data, 'title');
      _.unset(data, 'oddChg');
      _.unset(data, 'oddChgUpDown');
      _.unset(data, 'hdpChg');
      _.unset(data, 'error');
    });
    if (state.betting.sErr && !state.betting.firstLoadError) {
      state.betting.firstLoadError = true;
    } else if (state.betting.firstLoadError) {
      state.betting.sErr = null;
      state.betting.firstLoadError = false;
    }
    __WEBPACK_IMPORTED_MODULE_5__js_core_core__["default"].$ajax({
      data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        betting: payload.betData,
        oddsType: (this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') && this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
        isMulp: this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5' ? 1 : 0,
        isCombo: this.getters.isBetCombo || payload.isBetCombo ? 1 : 0,
        market: this.getters.selectedMarket,
        token: payload.token
      }, 'market', this.getters.selectedMarket),
      method: 'post',
      async: false,
      url: window._baseUrl + '/sport-betting/latest-info'
    }).done(function (res) {
      var updateCurrCL = _this3.getters.account;
      updateCurrCL.currCL = res.SYSTEM_DATA.cleft;
      _this3.commit('ACCOUNT', updateCurrCL);
      if (_this3.getters.requestAllow == false) {
        return;
      }
      state.allowRequestLatestInfo = true;
      if (typeof res.SYSTEM_DATA.DelayBet !== 'undefined') {
        state.delayBet = res.SYSTEM_DATA.DelayBet;
      }

      if (res.SYSTEM_DATA.status == 'FAIL') {
        _this3.commit('BETTING_MESSAGE', {
          isError: true,
          data: res.SYSTEM_DATA
        });

        if (res.SYSTEM_DATA.code == 'S-4-S') {
          _this3.commit('BETTING_CHIP_OPTION', { isBetting: true, minMax: res.SYSTEM_DATA.minMax });
          if (res.SYSTEM_DATA.allUpList) {
            state.betting.allUpList = res.SYSTEM_DATA.allUpList;
          }
          if (typeof res.SYSTEM_DATA.incentive == 'number') {
            state.betting.incentive = res.SYSTEM_DATA.incentive;
          }
          state.ajaxBettingList = res.SYSTEM_DATA.betting;
          __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('showBetslip');
          STORE.commit('SELECTED_TAB', 'betSlipTab');
          var active = $('.betSlip').hasClass('active');

          var mini = $('.sidebar-first').hasClass('mini');
          if (mini) {}
          __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('initBettingTimer');
        }
      } else if (res.SYSTEM_DATA.WagerID) {
        _this3.commit('BETTING_MESSAGE', {
          isSuccess: true,
          data: res.SYSTEM_DATA
        });

        __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('showBetslip');
        __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('initBettingTimer');
      } else {
        if (_this3.getters.sportForecastSelectedEvent && _this3.getters.sportForecastSelectedEvent.rbinfo && _this3.getters.sportForecastSelectedEvent.eveid == res.SYSTEM_DATA.betting[0].eveid) {
          var selectedForecast = _this3.getters.sportForecastSelectedEvent;
          if (selectedForecast.rbinfo.scoa != res.SYSTEM_DATA.betting[0].rbscoa || selectedForecast.rbinfo.scob != res.SYSTEM_DATA.betting[0].rbscob) {
            selectedForecast.rbinfo.scoa = res.SYSTEM_DATA.betting[0].rbscoa;
            selectedForecast.rbinfo.scob = res.SYSTEM_DATA.betting[0].rbscob;
            _this3.commit('SPORTFORECAST_SELECTEDEVENT', selectedForecast);
          }
        }
        _this3.commit('BETTING_MESSAGE', { isError: false });
        state.betting.minMax = res.SYSTEM_DATA.minMax;
        _this3.commit('BETTING_CHIP_OPTION', { isBetting: true, minMax: res.SYSTEM_DATA.minMax });

        if ((_this3.getters.isBetParlay || _this3.getters.selectedBettype.betTypId == '5') && res.SYSTEM_DATA.betting.length > 1) {
          var firstOccurrencesEvent = {};
          var duplicateEventIndexes = [];
          var earlyEventIndexes = [];
          var rbEventExist = false;
          var hasEarly = false;
          var crossNotAllow = false;
          var allowRBCross = false;
          var earlyMoreThanOneDay = false;

          _.forEach(res.SYSTEM_DATA.betting, function (data, index) {
            if (data.eveid) {
              if (firstOccurrencesEvent[data.eveid] === undefined) {
                firstOccurrencesEvent[data.eveid] = index;
              } else {
                if (!(duplicateEventIndexes.indexOf(firstOccurrencesEvent[data.eveid]) !== -1)) {
                  duplicateEventIndexes.push(firstOccurrencesEvent[data.eveid]);
                }
                duplicateEventIndexes.push(index);
              }

              var DateNow = new __WEBPACK_IMPORTED_MODULE_10_moment___default.a().utcOffset("-04:00").startOf('day').unix();
              var DateTomorrow = new __WEBPACK_IMPORTED_MODULE_10_moment___default.a().utcOffset("-04:00").add(1, 'days').startOf('day').unix();
              var rbBetTypes = ['8', '9', '10', '11', '13', '16', '17', '18', '20', '27', '29', '31', '33', '35', '37', '39', '41', '43', '45', '47', '49', '51', '55', '56', '58', '61', '64', '66', '69', '71', '73'];
              if (window.allowRbParlay) {
                if (rbBetTypes.indexOf(data.betType.toString()) !== -1) {
                  rbEventExist = true;

                  if (DateNow == data.event_date_timestamp && DateTomorrow == data.event_end_timestamp) {
                    allowRBCross = true;
                  }
                  if (allowRBCross) {
                    if (!earlyMoreThanOneDay) {
                      rbEventExist = false;
                    } else {
                      rbEventExist = true;
                    }
                  }
                }

                if (DateNow < data.event_date_timestamp) {
                  hasEarly = true;

                  if ((data.event_date_timestamp - DateNow) / (60 * 60 * 24) > 1) {
                    earlyMoreThanOneDay = true;
                  }
                  if (allowRBCross) {
                    if (!earlyMoreThanOneDay) {
                      rbEventExist = false;
                    } else {
                      rbEventExist = true;
                    }
                  }
                  if (rbEventExist == true) {
                    crossNotAllow = true;
                  }
                } else if (rbEventExist == true && hasEarly == true) {
                  crossNotAllow = true;
                }
              } else {
                crossNotAllow = false;
                if (rbBetTypes.indexOf(data.betType.toString()) !== -1) {
                  crossNotAllow = true;
                }
              }

              if (crossNotAllow) {
                if (!(earlyEventIndexes.indexOf(index) !== -1)) {
                  earlyEventIndexes.push(index);
                }
              }
            }
          });

          if (earlyEventIndexes && earlyEventIndexes.length > 0) {
            earlyEventIndexes.forEach(function (value, id) {
              if (!(duplicateEventIndexes.indexOf(value) !== -1)) {
                duplicateEventIndexes.push(value);
              }
            });
          }

          if (duplicateEventIndexes && duplicateEventIndexes.length > 0) {
            duplicateEventIndexes.forEach(function (value, id) {
              if (res.SYSTEM_DATA.betting[value].error == undefined || res.SYSTEM_DATA.betting[value].error == '') {
                var msg = state.betLang['BETTING.MSG_NOT_SUPPORT_PARLAY'];
                var err = { code: "N-4000", message: msg };
                res.SYSTEM_DATA.betting[value].error = err;
                _this3.commit('BETTING_MESSAGE', {
                  isError: true,
                  data: err
                });
              }
            });
          }
        }

        if (res.SYSTEM_DATA.allUpList) {
          state.betting.allUpList = [];
          state.betting.allUpList = res.SYSTEM_DATA.allUpList;


          if (_this3.getters.betting.allUpList.length != _this3.getters.betMulpAmount.length) {
            _this3.commit('SELECTED_MULP_BOX', 0);
            _this3.commit("BETMULP_AMOUNT", { resetBetMulpAmount: true });
          }
          _.forEach(res.SYSTEM_DATA.allUpList, function (value, i) {
            var maxpay = 0;
            if (res.SYSTEM_DATA.minMax && res.SYSTEM_DATA.minMax.max) {
              if (res.SYSTEM_DATA.minMax.maxPay) {
                var mulpParser = value.parser.split("#");
                for (var index = 0; index < mulpParser.length; index++) {
                  var ttlOdds = 1;
                  var commaList = mulpParser[index].split(",");
                  for (var comma = 0; comma < commaList.length; comma++) {
                    var betData = res.SYSTEM_DATA.betting[commaList[comma]];
                    var betOdd = parseFloat(betData.odd);
                    if (STORE.getters.account.oddsType == 'am') {
                      if (betOdd < 0) {
                        betOdd = Math.abs(100 / betOdd) + 1;
                      } else {
                        betOdd = betOdd / 100 + 1;
                      }
                      betOdd = betOdd.toFixed(3);
                    }
                    ttlOdds *= betOdd;
                  }
                  maxpay += res.SYSTEM_DATA.minMax.maxPay / ttlOdds;
                }
              }
              if (res.SYSTEM_DATA.minMax.max > maxpay) {
                maxpay = __WEBPACK_IMPORTED_MODULE_7_accounting___default.a.toFixed(res.SYSTEM_DATA.minMax.max, 0);
              } else {
                maxpay = __WEBPACK_IMPORTED_MODULE_7_accounting___default.a.toFixed(maxpay, 0);
              }
            }
            if (STORE.getters.betting.allUpList.length != STORE.getters.betMulpAmount.length || STORE.getters.betting.allUpList[i].key != STORE.getters.betMulpAmount[i].allUp || maxpay != STORE.getters.betMulpAmount[i].maxPay) {
              var data = {
                index: i,
                allUp: STORE.getters.betting.allUpList[i].key,
                amount: '',
                stake: '',
                possiblePayout: '',
                maxPay: maxpay
              };
              STORE.commit("BETMULP_AMOUNT", data);
              if (STORE.getters.betting.allUpList.length != STORE.getters.betMulpAmount.length) {
                STORE.commit("BETMULP_AMOUNT", { clear: true });
              }
            }
          });
        }
        if (typeof res.SYSTEM_DATA.incentive == 'number') {
          state.betting.incentive = res.SYSTEM_DATA.incentive;
        }
        state.ajaxBettingList = res.SYSTEM_DATA.betting;
        __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('showBetslip');
        STORE.commit('SELECTED_TAB', 'betSlipTab');
        var active = $('.betSlip').hasClass('active');
        if (!active) {
          $('.betSlip').removeClass('collapsed');
          $('.betSlip').addClass('active');
        }
        var mini = $('.sidebar-first').hasClass('mini');
        if (mini) {
          $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
          $('.widgetArea').find('.scroll-panel').find('.expendScore').css('width', '40em');

          var collapsed = $('.widgetPanel.betSlip').hasClass('collapsed');
          if (collapsed) {
            $('.widgetPanel.betSlip').removeClass('collapsed');
          }
          var collapsed = $('.widgetPanel.betSlip').hasClass('active');
          if (!collapsed) {
            $('.widgetPanel.betSlip').addClass('active');
          }
        }
        __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('initBettingTimer');
      }
      if (payload) {
        if (payload.callback) {
          return payload.callback(res);
        }
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_111" /* SPORT_MAPPING_BETTING */], function (state, payload) {
  var _this4 = this;

  var keyList = ['dual', 'fav', 'hdp', 'hdpCap', 'odd', 'rbscoa', 'rbscob', 'plyTypCap', 'minMax'];
  var VUE = this;
  var chkInvalid = false;

  if (VUE.getters.betting.success || VUE.getters.betting.betcombosuccess || VUE.getters.betting.pending) {
    var keyList = ['wgStatus', 'odd'];
    if (this.getters.isBetCombo) {
      keyList.push("WagerID", 'betAmt', 'error', 'hdp', 'hdpCap');
    }
  } else if (!VUE.getters.betting.success && !VUE.getters.betting.betcombosuccess && !VUE.getters.betting.pending) {
    var indexA = keyList.indexOf('wgStatus');
    if (indexA > 0) {
      keyList.splice(indexA, 1);
    }
  }
  if (this.getters.isBetCombo || VUE.getters.betting.betcomboerror) {
    keyList.push('error');
  }
  if ((this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') && VUE.getters.betting.error && VUE.getters.betting.error.code) {
    keyList = ['error'];
  }

  if (payload.newBettingList) {
    var _loop = function _loop(index) {
      var element = payload.newBettingList[index];

      if (!VUE.getters.isBetCombo && !VUE.getters.selectedBettype.betTypId == '5' && !VUE.getters.isBetParlay) {
        oldBettingIndex = _.findIndex(payload.oldBettingList, {
          eveid: !_.isUndefined(payload.chkPendingWager) ? parseInt(payload.newBettingList[index].eveId) : parseInt(payload.newBettingList[index].eveid)
        });
      } else {
        arr = {
          'eveid': parseInt(payload.newBettingList[index].eveid),
          'plyType': payload.newBettingList[index].plyType,
          'betType': payload.newBettingList[index].betType,
          'dual': payload.newBettingList[index].dual
        };

        if (!_.isUndefined(payload.chkPendingWager)) {
          arr = {
            'eveid': parseInt(payload.newBettingList[index].eveId),
            'plyType': payload.newBettingList[index].plyTypId,
            'betType': payload.newBettingList[index].betTypId,
            'dual': payload.newBettingList[index].dual
          };
        }

        if (VUE.getters.selectedBettype.betTypId == '6') {
          arr2 = { 'tbet': parseInt(payload.newBettingList[index].tbet) };

          arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(arr, arr2);
        }
        oldBettingIndex = _.findIndex(payload.oldBettingList, arr);


        if (VUE.getters.isBetCombo) {
          if (_.isUndefined(VUE.getters.betComboAmount[oldBettingIndex])) {
            data = { index: oldBettingIndex, amount: '' };

            VUE.commit("BETCOMBO_AMOUNT", data);
          }
          if (_.isUndefined(VUE.getters.betComboKeyboardAllow[oldBettingIndex])) {
            kdata = { index: oldBettingIndex, settings: { min: true, med: true, big: true, big2: true, big3: true } };

            VUE.commit("BETCOMBO_KEYBOARDALLOW", kdata);
          }
        }
      }

      if (!_.isUndefined(payload.isRetainSel) && payload.isRetainSel) {
        _.unset(payload.oldBettingList[oldBettingIndex], 'error');
      }

      if (!VUE.getters.betting.success && !VUE.getters.betting.betcombosuccess && !VUE.getters.betting.pending) {
        _.unset(payload.oldBettingList[oldBettingIndex], 'WagerID');
        _.unset(payload.oldBettingList[oldBettingIndex], 'betAmt');
        _.unset(payload.oldBettingList[oldBettingIndex], 'wgStatus');
      }

      if (_.isUndefined(payload.newBettingList[index]['error'])) {
        _.unset(payload.oldBettingList[oldBettingIndex], 'error');
      }

      keyList.forEach(function (value) {
        if (value == 'odd') {
          if (_this4.getters.isBetCombo) {
            if (!_.isUndefined(payload.newBettingList[index]['error'])) {
              if ((!_.isUndefined(payload.oldBettingList[oldBettingIndex][value]) || !_.isUndefined(payload.newBettingList[index][value])) && parseFloat(payload.oldBettingList[oldBettingIndex][value]) != parseFloat(payload.newBettingList[index][value])) {
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'betcombosuccess');

                if (parseFloat(payload.oldBettingList[oldBettingIndex][value]) > parseFloat(payload.newBettingList[index][value])) {
                  payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = 'up';
                } else {
                  payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = 'down';
                }
              } else {
                payload.oldBettingList[oldBettingIndex]['oddChg'] = false;
                payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = '';
              }
            }
          }
          if (!_this4.getters.isBetCombo) {
            if (VUE.getters.betting.success || VUE.getters.betting.betcombosuccess || VUE.getters.betting.pending) {
              return;
            }
            if ((!_.isUndefined(payload.oldBettingList[oldBettingIndex][value]) || !_.isUndefined(payload.newBettingList[index][value])) && parseFloat(payload.oldBettingList[oldBettingIndex][value]) != parseFloat(payload.newBettingList[index][value])) {
              payload.oldBettingList[oldBettingIndex]['oddChg'] = true;

              if (parseFloat(payload.oldBettingList[oldBettingIndex][value]) > parseFloat(payload.newBettingList[index][value])) {
                payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = 'up';
              } else {
                payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = 'down';
              }
            } else {
              payload.oldBettingList[oldBettingIndex]['oddChg'] = false;
              payload.oldBettingList[oldBettingIndex]['oddChgUpDown'] = '';
            }

            STORE.commit('BETFORM_ODDCHG', payload.oldBettingList[oldBettingIndex]['oddChg']);
          }
        }

        if (value == 'hdp') {
          if (!_this4.getters.isBetCombo) {
            if ((!_.isUndefined(payload.oldBettingList[oldBettingIndex][value]) || !_.isUndefined(payload.newBettingList[index][value])) && parseFloat(payload.oldBettingList[oldBettingIndex][value]) != parseFloat(payload.newBettingList[index][value])) {
              payload.oldBettingList[oldBettingIndex]['hdpChg'] = true;
            } else {
              payload.oldBettingList[oldBettingIndex]['hdpChg'] = false;
            }
            _this4.commit('BETFORM_HDPCHG', payload.oldBettingList[oldBettingIndex]['hdpChg']);
          }
        }

        if (value == 'wgStatus' || value == 'WagerID' || value == 'betAmt') {
          if (VUE.getters.isBetCombo) {
            if (_.isUndefined(payload.newBettingList[index][value]) && !_.isUndefined(payload.newBettingList[index]['error'])) {
              return;
            }
            if (payload.chkPendingWager && !_.isUndefined(payload.oldBettingList[oldBettingIndex][value]) && _.isUndefined(payload.newBettingList[index][value])) {
              return;
            }
          }
        }

        if (!_.isUndefined(payload.newBettingList[index][value]) && oldBettingIndex > -1) {
          payload.oldBettingList[oldBettingIndex][value] = payload.newBettingList[index][value];
        }

        if (_this4.getters.isBetCombo && value == 'error') {
          if (!_.isUndefined(payload.newBettingList[index][value]) && payload.newBettingList[index][value] != '') {
            payload.oldBettingList[oldBettingIndex][value] = payload.newBettingList[index][value];
            chkInvalid = true;

            if (payload.newBettingList[index][value].code == '4010-N') {
              _this4.commit('BETFORM_HDPCHG', true);
            }
            if (payload.newBettingList[index][value].code == '4003-N') {
              _this4.commit('BETFORM_ODDCHG', true);
            }
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.betting, 'betcomboerror', {
              code: payload.newBettingList[index][value].code,
              message: payload.newBettingList[index][value].message
            });
          } else if (_.isUndefined(payload.newBettingList[index][value])) {
            _.unset(payload.oldBettingList[oldBettingIndex], 'error');
          }
          if (payload.oldBettingList[oldBettingIndex][value] == '' && payload.newBettingList[index][value] == '') {
            _.unset(payload.oldBettingList[oldBettingIndex], 'error');
          }
          if ((!_.isUndefined(payload.newBettingList[index][value]) && payload.newBettingList[index][value] == '' || !_.isUndefined(payload.newBettingList[index]['WagerID'])) && payload.oldBettingList[oldBettingIndex][value] != '') {
            _.unset(payload.oldBettingList[oldBettingIndex], 'error');
          }
        }
      });
    };

    for (var index = 0; index < payload.newBettingList.length; index++) {
      var oldBettingIndex;
      var arr;
      var arr;
      var arr2;
      var oldBettingIndex;
      var data;
      var kdata;

      _loop(index);
    }

    if (this.getters.isBetCombo && !chkInvalid) {
      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'betcomboerror');
    }
  }

  if (!_.isUndefined(this.getters.betting.error) && this.getters.betting.error.code == 'S-4-S') {
    if (payload.oldBettingList.length != payload.newBettingList.length) {
      for (var index = 0; index < payload.oldBettingList.length; index++) {
        var element = payload.oldBettingList[index];

        var newBettingList = _.findIndex(payload.newBettingList, {
          eveid: String(payload.oldBettingList[index].eveid)
        });
        if (newBettingList == -1) {
          payload.oldBettingList.splice(index, 1);
        }
      }
    }
  }

  if (this.getters.selectedBettype.betTypId != '5' && !this.getters.isBetParlay) {
    var wgPending = _.findIndex(payload.newBettingList, { 'wgStatus': '1' });
    if (wgPending < 0) {
      VUE.commit('BETTING_MESSAGE', { isPending: false });
      __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('stopBettingTimer');
      if (this.getters.isBetCombo && payload.chkPendingWager && wgPending < 0) {
        VUE.commit('BETCOMBO_MESSAGE', { isSuccess: true });
      }
    }
  }
  if (!_.isUndefined(payload.chkPendingWager)) {
    if (VUE.getters.betting.reject) {
      __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('stopBettingTimer');
    }
  }
  state.betForm = [];
  state.betForm = payload.oldBettingList;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* BETLANG */], function (state, payload) {
  state.betLang = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_32" /* ODD_SELECTED */], function (state, payload) {
  state.oddSelected = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* BET_FORM */], function (state, payload) {
  var betData = payload.oldBetData;

  if (this.getters.betting.success || this.getters.betting.betcombosuccess) {
    state.betForm = [];

    this.commit("CLEAR_BET_SUCCESS");
  }

  if (this.getters.selectedBettype.betTypId == 5 || this.getters.isBetParlay) {
    state.int_betType = this.getters.selectedBettype.betTypId;

    if (state.betForm.length != 0) {
      if (_.find(state.betForm, { 'eventObj': { 'eveid': betData.eventObj.eveid } }) != undefined || _.find(state.betForm, { 'eveid': betData.eventObj.eveid }) != undefined) {
        var index = _.findIndex(state.betForm, { 'eventObj': { 'eveid': betData.eventObj.eveid } });
        if (index < 0) {
          index = _.findIndex(state.betForm, { 'eveid': betData.eventObj.eveid });
        }

        if (index >= 0) {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.betForm, index, betData);
        } else {
          state.betForm.push(betData);
        }
      } else {
        state.betForm.push(betData);
      }
    } else {
      state.betForm.push(betData);
    }
  } else if (this.getters.isBetCombo) {
    var arr = {
      'eveid': parseInt(betData.eveid),
      'plyType': betData.plyType,
      'betType': betData.betType,
      'dual': betData.dual
    };
    if (this.getters.selectedBettype.betTypId == '6') {
      var arr2 = {
        'tbet': betData.tbet
      };
      arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(arr, arr2);
    }

    if (state.betForm.length != 0) {
      if (_.find(state.betForm, { 'eventObj': { 'eveid': betData.eventObj.eveid } }) != 'undefined') {
        var index = _.findIndex(state.betForm, arr);
        if (index >= 0) {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.betForm, index, betData);
        } else {
          state.betForm.push(betData);
        }
      } else {
        state.betForm.push(betData);
      }
    } else {
      state.betForm.push(betData);
    }

    var id = _.findIndex(this.getters.betForm, arr);
    if (id >= 0 && _.isUndefined(this.getters.betComboAmount[id])) {
      var data = {
        index: id,
        amount: ''
      };
      var kdata = { index: id, settings: { min: true, med: true, big: true, big2: true, big3: true } };

      this.commit("BETCOMBO_AMOUNT", data);
      this.commit("BETCOMBO_KEYBOARDALLOW", kdata);
    }
    this.commit("BETCOMBO_AMOUNT", { clear: true });
    this.commit("BETCOMBO_KEYBOARDALLOW", { clear: true });
  } else {
    state.betForm = [];

    state.int_betType = this.getters.selectedBettype.betTypId;
    state.betForm.push(betData);
  }
  this.commit('SPORT_MAPPING_BETTING', {
    newBettingList: payload.newBettingList,
    oldBettingList: state.betForm
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* BETTYPELANG */], function (state, payload) {
  state.BetTypeLang = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_50" /* REMOVE_MATCH */], function (state, payload) {
  if (payload.removeAll) {
    state.betForm = [];
  } else {
    state.betForm.splice(payload, 1);
  }
  if ((this.getters.isBetParlay || this.getters.selectedBettype.betTypId == '5') && !this.getters.isParlayTab && state.betForm.length == 0) {
    this.commit('SELECTED_BETTYPE', this.getters.previousBettype.bettype);
    this.commit('IS_BETCOMBO', this.getters.previousBettype.isBetCombo);
  }
  state.oddSelected = state.betForm.length == 0 ? false : true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_49" /* REMOVE_ALLBUTLAST */], function (state, payload) {
  var a = state.betForm.length * -1;
  var b = state.betForm.length - 1;

  _.forEach(state.betForm, function (value, key) {
    if (key + 1 == state.betForm.length) {} else {
      document.getElementById(value.uniqueId).parentElement.classList.remove('active');
    }
  });

  state.betForm.splice(a, b);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* BETTING_CHIP_OPTION */], function (state, payload) {
  var betAmountOption = {
    min: 0,
    med: 0,
    big: 0,
    big2: 0,
    big3: 0
  };

  if (payload && payload.isBetting) {
    if (!__WEBPACK_IMPORTED_MODULE_9_vue_cookie___default.a.get(window.compcode + '_acc_' + this.getters.account.acccode)) {
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        data: {
          com_code: window.compcode,
          acc: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(state.betting.betAmountOption),
          acc_code: this.getters.account.acccode
        }
      }).done(function (res) {});
      betAmountOption = state.betting.betAmountOption;
    } else {
      betAmountOption = JSON.parse(__WEBPACK_IMPORTED_MODULE_9_vue_cookie___default.a.get(window.compcode + '_acc_' + this.getters.account.acccode));
    }
    betAmountOption.max = payload.minMax.max;
    state.betting.minMax = payload.minMax;
  } else {
    betAmountOption = {
      min: payload.min,
      med: payload.med,
      big: payload.big,
      big2: payload.big2,
      big3: payload.big3
    };
  }
  state.betting.betAmountOption = betAmountOption;

  $.ajax({
    method: 'post',
    url: _baseUrl + '/callCookies',
    data: {
      com_code: window.compcode,
      acc: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(state.betting.betAmountOption),
      acc_code: this.getters.account.acccode
    }
  }).done(function (res) {});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* BETTING_BETAMOUNT_OPTION */], function (state, payload) {
  var betAmountOption = {
    min: payload.min,
    max: payload.max
  };
  betAmountOption.med = betAmountOption.min * 5;
  betAmountOption.big = betAmountOption.med * 5;

  if (payload.minCombo) betAmountOption.minCombo = payload.minCombo;
  if (payload.maxCombo) betAmountOption.maxCombo = payload.maxCombo;

  state.betting.betAmountOption = betAmountOption;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* BETTING_MESSAGE */], function (state, payload) {
  if (payload.isError) {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.betting, 'error', {
      code: payload.data.code,
      message: payload.data.message
    });
  } else if (payload.isSuccess || payload.isPending) {
    if (_.isUndefined(payload.isPendingSuccess)) {
      var account = this.getters.account;
      account.currCL = payload.data.accCcl;
      var currCL_O = payload.data.accCcl * account.currUnit;
      account.currCL_O = new Intl.NumberFormat().format(currCL_O);
      var successPending = payload.isSuccess ? 'success' : 'pending';
      this.commit('ACCOUNT', account);
    } else {
      __WEBPACK_IMPORTED_MODULE_8__events_event_bus__["a" /* default */].$emit('stopBettingTimer');
    }

    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.betting, successPending, {
      data: payload.data
    });
  } else if (payload.isReject) {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.betting, 'reject', {
      data: { reject: true }
    });
  } else if (!_.isUndefined(payload.isPending) && !payload.isPending) {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'pending');
    return;
  } else {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'pending');
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'success');
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'error');
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'reject');
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* BETCOMBO_MESSAGE */], function (state, payload) {
  if (payload.isClear) {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'betcombosuccess');
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'betcomboerror');
  } else if (payload.isClearErr) {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'betcomboerror');
  } else if (payload.isSuccess) {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.betting, 'betcombosuccess', true);
  } else if (payload.isError) {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.betting, 'betcomboerror', true);
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* BETTING_ALLUP */], function (state, payload) {
  if (payload) {
    state.betting.selectedBetAllup = payload;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* BETTING_DELAY_TIMERID */], function (state, payload) {
  if (state.betting.delayBetTimerId) {
    this.commit('REQUEST_ALLOW', true);
    clearTimeout(state.betting.delayBetTimerId);
  }
  state.betting.delayBetTimerId = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["A" /* BET_SUCCESS */], function (state, payload) {
  state.isBetSuccess = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_40" /* PROCESS_BET */], function (state, payload) {
  state.isProcessBet = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_38" /* PLACED_BET */], function (state, payload) {
  state.isPlacedBet = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_37" /* PENDING_FLAG */], function (state, payload) {
  state.pendingFlag = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_52" /* RESIZE_WHEIGHT */], function (state, payload) {
  state.resizeWHeight = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_16" /* JS_ERR */], function (state, payload) {
  state.jsError = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* BETCOMBO_JS_ERR */], function (state, payload) {
  state.betCombo_jsError = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* BETLIST_TYPE */], function (state, payload) {
  state.selectedBetListType = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_63" /* SELECTED_BETTAB */], function (state, payload) {
  state.selectedBetTab = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_33" /* OPEN_BETFORM */], function (state, payload) {
  state.openBetForm = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["y" /* BET_AMOUNT */], function (state, payload) {
  state.betAmount = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_82" /* SHOW_BETFORM_MENU */], function (state, payload) {
  state.showbetformMenu = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["l" /* BETFORM_HDPCHG */], function (state, payload) {
  state.betFormHdpChange = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["m" /* BETFORM_ODDCHG */], function (state, payload) {
  state.betFormOddChange = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_10" /* IS_BETCOMBO */], function (state, payload) {
  state.isBetCombo = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'IS_BETPARLAY', function IS_BETPARLAY(state, payload) {
  state.isBetParlay = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* COMBOBET_EXCEEDLIMIT */], function (state, payload) {
  state.comboBetExceedLimit = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* BETCOMBO_AMOUNT */], function (state, payload) {
  function commasAmount(amount) {
    amount += '';
    var x = amount.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }
  if (payload.clear) {
    var comboAmountArr = _.cloneDeep(state.betComboAmount);
    var clearAll = { value: '' };

    var newItems = comboAmountArr.map(function (item) {
      item.value = clearAll.value;
      return item;
    });
    state.betComboAmount = newItems;
  } else if (payload.spliceIndex) {
    state.betComboAmount.splice(payload.index, 1);
  } else if (payload.resetBetComboAmount) {
    state.betComboAmount = [];
  } else {
    state.betComboAmount[payload.index] = {};
    var clone = _.cloneDeep(state.betComboAmount);
    var fixedAccountingNumber = payload.amount == '' ? "" : __WEBPACK_IMPORTED_MODULE_7_accounting___default.a.toFixed(payload.amount, 0);
    clone[payload.index] = { value: commasAmount(fixedAccountingNumber) };
    state.betComboAmount = [];
    state.betComboAmount = clone;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["j" /* BETCOMBO_KEYBOARDALLOW */], function (state, payload) {
  if (payload.clear) {
    var comboAmountArr = _.cloneDeep(state.betComboKeyboardAllow);

    var newItems = comboAmountArr.map(function (item) {
      item.min = true;
      item.med = true;
      item.big = true;
      item.big2 = true;
      item.big3 = true;
      return item;
    });
    state.betComboKeyboardAllow = newItems;
  } else if (payload.spliceIndex) {
    state.betComboKeyboardAllow.splice(payload.index, 1);
  } else {
    state.betComboKeyboardAllow[payload.index] = {};
    var clone = _.cloneDeep(state.betComboKeyboardAllow);
    clone[payload.index] = payload.settings;
    state.betComboKeyboardAllow = [];
    state.betComboKeyboardAllow = clone;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["D" /* CLEAR_BET_SUCCESS */], function (state, payload) {
  if (this.getters.isBetCombo) {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'betcombosuccess');
  } else {
    __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.betting, 'success');
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_79" /* SET_MATCH_INDEX_NO_ERR */], function (state, payload) {
  state.wgHdpOddNoChgIndex = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* ALLOW_ERR_BET_AGAIN */], function (state, payload) {
  state.allowErrBetAgain = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* BETMULP_AMOUNT */], function (state, payload) {
  function commasAmount(amount) {
    amount += '';
    var x = amount.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }
  if (payload.clear) {
    var mulpAmountArr = _.cloneDeep(state.betMulpAmount);
    var clearAll = { value: '', stake: '', possiblePayout: '' };

    var newItems = mulpAmountArr.map(function (item) {
      item.value = clearAll.value;
      item.stake = clearAll.stake;
      item.possiblePayout = clearAll.possiblePayout;

      return item;
    });
    state.betMulpAmount = newItems;
  } else if (payload.spliceIndex) {
    state.betMulpAmount.splice(payload.index, 1);
  } else if (payload.resetBetMulpAmount) {
    state.betMulpAmount = [];
  } else {
    state.betMulpAmount[payload.index] = {};
    var clone = _.cloneDeep(state.betMulpAmount);
    var fixedAccountingNumber = '';
    fixedAccountingNumber = _.isUndefined(payload.amount) || payload.amount == '' ? "" : __WEBPACK_IMPORTED_MODULE_7_accounting___default.a.toFixed(payload.amount, 0);

    clone[payload.index].value = commasAmount(fixedAccountingNumber);
    fixedAccountingNumber = _.isUndefined(payload.stake) || payload.stake == '' ? "" : __WEBPACK_IMPORTED_MODULE_7_accounting___default.a.toFixed(payload.stake, 0);
    clone[payload.index].stake = commasAmount(fixedAccountingNumber);
    fixedAccountingNumber = _.isUndefined(payload.possiblePayout) || payload.possiblePayout == '' ? "" : __WEBPACK_IMPORTED_MODULE_7_accounting___default.a.toFixed(payload.possiblePayout, 0);
    clone[payload.index].possiblePayout = commasAmount(fixedAccountingNumber);
    clone[payload.index].allUp = payload.allUp;
    clone[payload.index].maxPay = _.isUndefined(payload.maxPay) || payload.maxPay == '' ? "" : __WEBPACK_IMPORTED_MODULE_7_accounting___default.a.toFixed(payload.maxPay, 0);
    state.betMulpAmount = [];
    state.betMulpAmount = clone;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* BETMULP_AMOUNT_FILTERED */], function (state, payload) {
  state.betMulpAmtFiltered = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["H" /* DIALOG_TOGGLE */], function (state, payload) {
  if (payload.reset) {
    state.dialogToggle = { show: false };
  } else {
    state.dialogToggle = payload;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["I" /* DISABLE_BET */], function (state, payload) {
  state.disableBet = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_70" /* SELECTED_MULP_BOX */], function (state, payload) {
  state.selectedMulpBetBoxId = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);



var _mutations;




var state = {
  sportForecastLang: null,
  sportForecastToggle: false,
  sportForecastWindowEvent: null,
  sportForecastSelectedEvent: null,
  sportForecastList: null,
  sportWaitingWagerList: null
};

var getters = {
  sportForecastLang: function sportForecastLang(state) {
    return state.sportForecastLang;
  },
  sportForecastToggle: function sportForecastToggle(state) {
    return state.sportForecastToggle;
  },
  sportForecastWindowEvent: function sportForecastWindowEvent(state) {
    return state.sportForecastWindowEvent;
  },
  sportForecastSelectedEvent: function sportForecastSelectedEvent(state) {
    return state.sportForecastSelectedEvent;
  },
  sportForecastList: function sportForecastList(state) {
    return state.sportForecastList;
  },
  sportWaitingWagerList: function sportWaitingWagerList(state) {
    return state.sportWaitingWagerList;
  }
};

var actions = {
  removeSportForecastList: function removeSportForecastList(context, payload) {
    var sportForecastList = this.getters.sportForecastList;
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].delete(sportForecastList[payload.eveid][payload.ftPlyType][payload.bettypKey], payload.tbetKey);

    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sportForecastList[payload.eveid][payload.ftPlyType][payload.bettypKey]).length == 0) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].delete(sportForecastList[payload.eveid][payload.ftPlyType], payload.bettypKey);

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sportForecastList[payload.eveid][payload.ftPlyType]).length == 0) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].delete(sportForecastList[payload.eveid], payload.ftPlyType);

        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sportForecastList[payload.eveid]).length == 1) {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].delete(sportForecastList, payload.eveid);

          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sportForecastList).length == 0) {
            sportForecastList = null;
          }
        }
      }
    }
    this.commit('SPORTFORECAST_LIST', sportForecastList);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_96" /* SPORTFORECAST_LANG */], function (state, payload) {
  state.sportForecastLang = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_99" /* SPORTFORECAST_TOGGLE */], function (state, payload) {
  state.sportForecastToggle = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_101" /* SPORTFORECAST_WINDOWEVENT */], function (state, payload) {
  state.sportForecastWindowEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_98" /* SPORTFORECAST_SELECTEDEVENT */], function (state, payload) {
  state.sportForecastSelectedEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_97" /* SPORTFORECAST_LIST */], function (state, payload) {
  state.sportForecastList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_100" /* SPORTFORECAST_WAITINGLIST */], function (state, payload) {
  state.sportWaitingWagerList = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(10);


var _mutations;



var state = {
  sportMiniBet: {
    toggle: false,
    allow: true,
    windowEvent: null,
    betAmount: 0,
    rightside: false
  }
};

var getters = {
  sportMiniBet: function sportMiniBet(state) {
    return state.sportMiniBet;
  }
};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_112" /* SPORT_MINIBET */], function (state, payload) {
  state.sportMiniBet = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_115" /* SPORT_MINIBET_TOGGLE */], function (state, payload) {
  state.sportMiniBet.toggle = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_116" /* SPORT_MINIBET_WINDOWEVENT */], function (state, payload) {
  state.sportMiniBet.windowEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_113" /* SPORT_MINIBET_BETAMOUNT */], function (state, payload) {
  state.sportMiniBet.betAmount = payload ? payload : 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_114" /* SPORT_MINIBET_RIGHTSIDE */], function (state, payload) {
  state.sportMiniBet.rightside = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);



var _mutations;




var state = {
    cookieLeague: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_league') != 'undefined' ? JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_league')) : null,
    selectAllLeague: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_league') != 'undefined' ? false : true,
    cookieHistory: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_his') != 'undefined' ? JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_his')) : null,
    searchHistory: [],
    searchLoading: false,
    historyList: [],
    searchLeague: {
        lid: 0,
        lname: ''
    }
};

var getters = {
    cookieLeague: function cookieLeague(state) {
        return state.cookieLeague;
    },
    selectAllLeague: function selectAllLeague(state) {
        return state.selectAllLeague;
    },
    cookieHistory: function cookieHistory(state) {
        return state.cookieHistory;
    },
    searchHistory: function searchHistory(state) {
        return state.searchHistory;
    },
    searchLoading: function searchLoading(state) {
        return state.searchLoading;
    },
    historyList: function historyList(state) {
        return state.historyList;
    },
    searchLeague: function searchLeague(state) {
        return state.searchLeague;
    }
};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_56" /* SEARCH_LEAGUE */], function (state, payload) {
    state.searchLeague = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_78" /* SELECT_ALL_LEAGUE */], function (state, payload) {
    state.selectAllLeague = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["G" /* COOKIE_LEAGUE */], function (state, payload) {
    var selectedMarket = this.getters.selectedMarket;
    var selectedSport = this.getters.selectedBettype.sprtId;
    var selectedBettype = this.getters.selectedBettype.betTypId;
    if (this.getters.isGameBannerSelected) {
        selectedBettype += 'gmBanner';
    }
    if (payload.remove) {
        if (this.getters.cookieLeague) {
            if (this.getters.cookieLeague[selectedMarket]) {
                if (this.getters.cookieLeague[selectedMarket][selectedSport]) {
                    if (this.getters.cookieLeague[selectedMarket][selectedSport][selectedBettype]) {
                        state.cookieLeague[selectedMarket][selectedSport][selectedBettype] = [];
                        __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set(window.compcode + '_league', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.cookieLeague));
                    }
                }
            }
        }

        return;
    }

    var VUE = this;
    function recursiveMethod(value, type, league) {
        var selectedMarket = VUE.getters.selectedMarket;
        var selectedSport = VUE.getters.selectedBettype.sprtId;
        var selectedBettype = VUE.getters.selectedBettype.betTypId;
        if (VUE.getters.isGameBannerSelected) {
            selectedBettype += 'gmBanner';
        }
        if (value == null && type == 'market') {
            value[selectedMarket] = {};
            return recursiveMethod(value[selectedMarket], 'sport', league);
        }

        if (value == null && type == 'sport') {
            value[selectedMarket][selectedSport] = {};
            return recursiveMethod(value[selectedMarket][selectedSport], 'bettyp', league);
        }

        if (value == null && type == 'bettyp') {
            value[selectedMarket][selectedSport][selectedBettype] = [];
            value[selectedMarket][selectedSport][selectedBettype] = league;
            return value;
        } else {
            if (value == null) {
                return recursiveMethod(value, 'market', league);
            }
            if (value[selectedMarket] == null) {
                value[selectedMarket] = {};
                return recursiveMethod(value, 'sport', league);
            }
            if (value[selectedMarket][selectedSport] == null) {
                value[selectedMarket][selectedSport] = {};
                return recursiveMethod(value, 'bettyp', league);
            }
            if (value[selectedMarket][selectedSport][selectedBettype] == null) {
                value[selectedMarket][selectedSport][selectedBettype] = league;
                return value;
            }
            value[selectedMarket][selectedSport][selectedBettype] = league;
            return value;
        }
    }
    if (this.getters.cookieLeague) {
        var cookie = '';
        cookie = recursiveMethod(this.getters.cookieLeague, 'market', payload.selectedLeague);
        state.cookieLeague = cookie;
        __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set(window.compcode + '_league', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(cookie));
    } else {
        var selectedCookieLeague = {};
        selectedCookieLeague[selectedMarket] = {};
        selectedCookieLeague[selectedMarket][selectedSport] = {};
        selectedCookieLeague[selectedMarket][selectedSport][selectedBettype] = payload.selectedLeague;
        state.cookieLeague = selectedCookieLeague;
        __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set(window.compcode + '_league', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(selectedCookieLeague));
        return;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["F" /* COOKIE_HISTORY */], function (state, payload) {
    var currentAcc = this.getters.account.acccode;

    if (payload.remove) {
        if (this.getters.cookieHistory) {
            state.cookieHistory = [];
            __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set(window.compcode + '_his', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.cookieHistory));
        }
        return;
    }

    if (payload.removeSelected) {
        if (this.getters.cookieHistory) {
            state.cookieHistory = _.pull(this.getters.cookieHistory, payload.searchVal);
            __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set(window.compcode + '_his', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.cookieHistory));
        }
        return;
    }
    if (_.indexOf(state.cookieHistory, payload.searchVal) !== -1) {
        return;
    }
    var VUE = this;
    if (state.cookieHistory && state.cookieHistory && state.cookieHistory.length > 0) {
        state.searchHistory = _.reverse(state.cookieHistory);
    }
    if (state.searchHistory.length == 0 || state.searchHistory.length < 3) {
        if (payload.searchVal != '') {
            state.searchHistory.push(payload.searchVal);
        }
    } else {
        if (payload.searchVal != '') {
            state.searchHistory.shift();
            state.searchHistory.push(payload.searchVal);
        }
    }
    var selectedCookieLeague = {};
    selectedCookieLeague = _.reverse(state.searchHistory);
    state.cookieHistory = selectedCookieLeague;
    __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set(window.compcode + '_his', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(selectedCookieLeague));

    return;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_57" /* SEARCH_LOADING */], function (state, payload) {
    state.searchLoading = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_7" /* HIST_LIST */], function (state, payload) {
    state.historyList = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_core_core__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);


var _mutations;





var state = {
  statement: {
    showStatement: false,
    showLedger: false,
    showWagerDetail: false,
    selectedStatementDate: {
      from: 0,
      to: 7,
      selected: null,
      week: 1 },
    wagerType: 'openBet',
    selectedSport: '99',
    selectedWagerPage: 1,
    dateList: [],
    statementList: [],
    wagerList: [],
    last10wagerList: [],
    statementSummary: null,
    isCancelWager: false,
    selectedDateRange: []

  },
  selectedTab: 'betTab',
  statementDetail: {
    data: {},
    total: null
  },
  apiWagerDetail: false
};

var getters = {
  statementDateList: function statementDateList(state) {
    return state.statement.dateList;
  },
  selectedStatementDateRange: function selectedStatementDateRange(state) {
    return state.statement.selectedDateRange;
  },
  statementList: function statementList(state) {
    return state.statement.statementList;
  },
  statementSummary: function statementSummary(state) {
    return state.statement.statementSummary;
  },
  wagerList: function wagerList(state) {
    return state.statement.wagerList;
  },
  statement: function statement(state) {
    return state.statement;
  },
  selectedTab: function selectedTab(state) {
    return state.selectedTab;
  },
  statementDetail: function statementDetail(state) {
    return state.statementDetail;
  },
  apiWagerDetail: function apiWagerDetail(state) {
    return state.apiWagerDetail;
  }
};

var actions = {
  getStatementDetail: function getStatementDetail(context, payload) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__js_core_core__["default"].$ajax({
      method: 'get',
      url: payload.url,
      data: { token: window.token.arr_2 }
    }).done(function (res) {
      _this.commit('STATEMENT_SHOW_LEDGER', true);
      _this.commit('STATEMENT_DETAIL', {
        'data': res.data.DATA,
        'total': res.data.TTL_TRANS
      });
      if (payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getStatementList: function getStatementList(context, payload) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__js_core_core__["default"].$ajax({
      method: 'get',
      url: payload.url,
      data: {
        token: payload.token
      }
    }).done(function (res) {
      if (_this2.getters.account.isApi) {
        _this2.commit('STATEMENT_DATELIST', res.dateList);
        _this2.commit('STATEMENT_API_DATELIST', res.apiDateList);
        _this2.commit('STATEMENT_SELECTED_WEEK', res.selectedWeek);
      } else {
        _this2.commit('STATEMENT_DATELIST', res.dateList);
      }
      _this2.commit('STATEMENT_LIST', res.data.DATA);
      _this2.commit('STATEMENT_DATE_RANGE', res.selectedDateRange);
      if (payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getWagerList: function getWagerList(context, payload) {
    var _this3 = this;

    var params = {};
    if (this.getters.statement.wagerType == 'statementDetail') {
      params = {
        wgrTyp: 'statement'
      };
      params.date = this.getters.statement.selectedStatementDate.selected;
    } else if (this.getters.statement.wagerType == 'openBet') {
      params = {
        wgrTyp: 'openBet'
      };
    }
    if (this.getters.account.isApi && this.getters.apiWagerDetail) {
      params.date = this.getters.statement.selectedStatementDate.selected;
      params.isApi = true;
    }
    if (payload) {
      state.statement.isCancelWager = false;

      if (payload.cancelWager) {
        params.cancelWager = true;
        state.statement.isCancelWager = true;
      } else if (payload.last10Wager) {
        params.last10Wager = true;
      } else if (payload.wagerIds) {
        params.wagerIds = payload.wagerIds;
        params.wgrTyp = 'openBet';
      }
    }
    params.page = this.getters.statement.selectedWagerPage;
    params.sprtId = this.getters.statement.selectedSport;
    params.token = payload.token;
    if (params.token == undefined) {
      params.token = window.token.arr_2;
    }
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('WAGER_RELOADING', true);
    __WEBPACK_IMPORTED_MODULE_2__js_core_core__["default"].$ajax({
      method: 'get',
      url: 'sport-wager1',
      data: params
    }).done(function (res) {
      state.statement.statementSummary = res.statementSummary;
      _this3.commit('STATEMENT_WAGERLIST', res.wagerList);
      _this3.commit('STATEMENT_SHOW_WAGERDETAIL', true);
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('WAGER_RELOADING', false);
      if (payload) {
        if (payload.callback) {
          return payload.callback(res);
        }
      }
    }.bind(this)).catch(function (errRes) {
      console.error(errRes);
    });
  },
  getLast10Wager: function getLast10Wager(context, payload) {
    var _this4 = this;

    var params = {};

    if (payload) {
      if (payload.last10Wager) {
        params.last10Wager = true;
      }
      if (payload.wagerIds) {
        params.wagerIds = payload.wagerIds;
        params.wgrTyp = 'openBet';
      }

      if (payload.wgrTyp) {
        params.wgrTyp = payload.wgrTyp;
      }

      if (payload.novaWager) {
        params.novaWager = payload.novaWager;
      }

      if (payload.isCount) {
        params.isCnt = payload.isCount;
        params.sprtId = '99';
      }
      params.token = payload.token;
    }
    params.sprtId = this.getters.statement.selectedSport;
    __WEBPACK_IMPORTED_MODULE_2__js_core_core__["default"].$ajax({
      method: 'get',
      url: 'sport-wager1',
      data: params
    }).done(function (res) {
      _this4.commit('PLACED_BET', false);
      if (res.wagerList) {
        _this4.commit('STATEMENT_LAST10_WAGERLIST', res.wagerList.data);
      }
      if (payload) {
        if (payload.callback) {
          return payload.callback(res);
        }
      }
    }.bind(this)).catch(function (errRes) {
      console.error(errRes);
    });
  },
  getPendingWager: function getPendingWager(context, payload) {
    var params = {};

    if (payload) {
      if (payload.wagerIds) {
        params.wagerIds = payload.wagerIds;
        params.wgrTyp = 'openBet';
        if (payload.isParlay) {
          params.isParlay = payload.isParlay;
        }
      }
    }
    params.sprtId = this.getters.statement.selectedSport;
    __WEBPACK_IMPORTED_MODULE_2__js_core_core__["default"].$ajax({
      method: 'get',
      url: 'sport-wager1',
      data: params
    }).done(function (res) {
      if (payload) {
        if (payload.callback) {
          return payload.callback(res);
        }
      }
    }.bind(this)).catch(function (errRes) {
      console.error(errRes);
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_129" /* STATEMENT_SELECTED_WEEK */], function (state, payload) {
  state.statement.selectedWeek = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_119" /* STATEMENT_API_DATELIST */], function (state, payload) {
  state.statement.apiDateList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_120" /* STATEMENT_DATELIST */], function (state, payload) {
  state.statement.dateList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_124" /* STATEMENT_LIST */], function (state, payload) {
  state.statement.statementList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_134" /* STATEMENT_WAGERLIST */], function (state, payload) {
  state.statement.wagerList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_123" /* STATEMENT_LAST10_WAGERLIST */], function (state, payload) {
  state.statement.last10wagerList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_126" /* STATEMENT_SELECTED_SPORT */], function (state, payload) {
  state.statement.selectedSport = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_125" /* STATEMENT_SELECTED_DATE */], function (state, payload) {
  state.statement.selectedStatementDate = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_127" /* STATEMENT_SELECTED_WAGER_DATE */], function (state, payload) {
  state.statement.selectedStatementDate.selected = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_128" /* STATEMENT_SELECTED_WAGER_PAGE */], function (state, payload) {
  state.statement.selectedWagerPage = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_133" /* STATEMENT_SHOW_WAGERDETAIL */], function (state, payload) {
  state.statement.showWagerDetail = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_135" /* STATEMENT_WAGER_TYPE */], function (state, payload) {
  state.statement.wagerType = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_132" /* STATEMENT_SHOW_STATEMENT */], function (state, payload) {
  state.statement.showStatement = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_130" /* STATEMENT_SHOW_LEDGER */], function (state, payload) {
  state.statement.showLedger = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_77" /* SELECTED_TAB */], function (state, payload) {
  state.selectedTab = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_55" /* SATEMENT_IS_CANCELWAGER */], function (state, payload) {
  state.statement.isCancelWager = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_121" /* STATEMENT_DATE_RANGE */], function (state, payload) {
  state.statement.selectedDateRange = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["_122" /* STATEMENT_DETAIL */], function (state, payload) {
  state.statementDetail = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* API_WAGER_DETAIL */], function (state, payload) {
  state.apiWagerDetail = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_core_core__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_event_bus__ = __webpack_require__(3);



var _mutations;






var state = {
    liveEvent: null,
    selectedLiveEvent: null,
    allSportLang: window.sportLang,
    sportTitle: null,
    liveSchedule: false,
    liveAllBet: false,
    liveMatch: null,
    isOpenTv: 1
};

var getters = {
    liveEvent: function liveEvent(state) {
        return state.liveEvent;
    },
    selectedLiveEvent: function selectedLiveEvent(state) {
        return state.selectedLiveEvent;
    },
    allSportLang: function allSportLang(state) {
        return state.allSportLang;
    },
    sportTitle: function sportTitle(state) {
        return state.sportTitle;
    },
    liveSchedule: function liveSchedule(state) {
        return state.liveSchedule;
    },
    liveAllBet: function liveAllBet(state) {
        return state.liveAllBet;
    },
    liveMatch: function liveMatch(state) {
        return state.liveMatch;
    },
    isOpenTv: function isOpenTv(state) {
        return state.isOpenTv;
    }
};

var actions = {
    getLiveMatch: function getLiveMatch(context, payload) {
        var _this = this;

        var data = {};
        data.date = payload.date;
        data.sportId = payload.sportId;
        data.lang = window._langid;
        data.action = 'getMatch';
        data.token = payload.token;
        __WEBPACK_IMPORTED_MODULE_3__js_core_core__["default"].$ajax({
            method: 'post',
            url: '',
            data: data
        }).done(function (res) {
            if (res.redirect) {
                window.close();
            }
            _this.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
            _this.commit('LIVE_EVENT', res.events);
            if (_this.getters.selectedLiveEvent) {
                var selectedDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this.getters.selectedLiveEvent.dt).format('YYYY-MM-DD');
                var findEvent = _.find(res.events[selectedDate], { 'eveid': parseInt(_this.getters.selectedLiveEvent.eveid) });
                if (!findEvent) {
                    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('closeTvLink', true);
                }
            }
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    },
    getLiveAllBet: function getLiveAllBet(context, payload) {
        var _this2 = this;

        var data = {
            sprtid: payload.sportId,
            schedule: this.getters.market.inPlayMarket.key,
            lang: window._langid,
            spread: this.getters.account.spread,
            odd: this.getters.account.oddsType,
            evntid: payload.eveid,
            plytypgrp: 1
        };
        data.sprtid = 'N' + payload.sptid;
        if (!payload.redirect) {
            var eventDate = new __WEBPACK_IMPORTED_MODULE_4_moment___default.a(payload.date).locale('en').format("YYYY-MM-DD");
            var filterDateIndex = _.indexOf(this.getters.earlyParlayDateList, eventDate);
            data.date = filterDateIndex != -1 ? filterDateIndex : 0;
        }

        data.date = 0;
        __WEBPACK_IMPORTED_MODULE_3__js_core_core__["default"].$ajax({
            method: 'post',
            url: _baseUrl + '/sport-allbet',
            data: data
        }).done(function (res) {
            if (res.redirect) {
                window.close();
            }
            _this2.commit('EVENT_ALLBET', res.allBet);
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(res.allBet).length > 0 || res.allBet.length > 0) {
                _this2.commit('LIVE_SELECTED_EVENT', _.cloneDeep(res.allBet));
                _this2.commit('LIVE_SPORT_TITLE', _this2.getters.allSportLang[res.allBet.sptid]['caption']);
            } else {
                _this2.commit('LIVE_SPORT_TITLE', _this2.getters.allSportLang[payload.sptid]['caption']);
            }
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    },
    getLiveSchedule: function getLiveSchedule(context, payload) {
        var _this3 = this;

        var token_val = payload.token;
        var data = {};
        data.date = payload.date;
        data.sportId = payload.sportId;
        data.lang = window._langid;
        data.action = 'getMatch';
        data.token = payload.token;
        __WEBPACK_IMPORTED_MODULE_3__js_core_core__["default"].$ajax({
            method: 'post',
            url: window._baseUrl + '/livetv',
            data: data
        }).done(function (res) {
            _this3.commit('LIVE_EVENT', res.events);
            _this3.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_20" /* LIVE_EVENT */], function (state, payload) {
    state.liveEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_23" /* LIVE_SELECTED_EVENT */], function (state, payload) {
    state.selectedLiveEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_24" /* LIVE_SPORT_TITLE */], function (state, payload) {
    state.sportTitle = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_22" /* LIVE_SCHECULE */], function (state, payload) {
    state.liveSchedule = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_19" /* LIVE_ALLBET */], function (state, payload) {
    state.liveAllBet = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_21" /* LIVE_MATCH */], function (state, payload) {
    state.liveMatch = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_12" /* IS_OPEN_TV */], function (state, payload) {
    state.isOpenTv = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_core_core__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);



var _mutations;






var state = {
  promotionDetails: [],
  promotionFlag: false,
  promotionShowJoinSuccess: false,
  promotionBetStatus: false,
  promotionBetIndex: [],
  promotionBetWithoutJoin: false };

var getters = {
  promotionDetails: function promotionDetails(state) {
    return state.promotionDetails;
  },
  promotionFlag: function promotionFlag(state) {
    return state.promotionFlag;
  },

  promotionShowJoinSuccess: function promotionShowJoinSuccess(state) {
    return state.promotionShowJoinSuccess;
  },
  promotionBetStatus: function promotionBetStatus(state) {
    return state.promotionBetStatus;
  },
  promotionBetIndex: function promotionBetIndex(state) {
    return state.promotionBetIndex;
  },
  promotionBetWithoutJoin: function promotionBetWithoutJoin(state) {
    return state.promotionBetWithoutJoin;
  }
};

var actions = {
  setPromoDetails: function setPromoDetails(context, payload) {
    if (payload.promo_details != false && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload.promo_details).length > 0) {
      this.commit('PROMO_DETAILS', payload.promo_details);
      this.commit('PROMO_FLAG', true);
      this.commit('PROMO_BET_STATUS', payload.promotionBetStatus);
    }
  },
  isSportValidPromo: function isSportValidPromo(context, payload) {
    var eventObj = payload.eventObj;
    var bt = payload.bt;
    var res = false;
    if (eventObj && bt && this.getters.promotionDetails) {
      var eventDt = eventObj.dt ? eventObj.dt.split(' ')[0] : eventObj.evedt ? eventObj.evedt.split(' ')[0] : '';
      var promo_sp_id = this.getters.promotionDetails.sp_sport.split(",");
      var promo_bt_not_allow = this.getters.promotionDetails.sp_bt_not_allow.split(",");
      var promo_sp_wager_type = this.getters.promotionDetails.sp_wager_type.split(",");
      var sp_wager_type = false;

      var timeZoneSet = '-04:00';

      var tdyDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().utcOffset(timeZoneSet).format("YYYY-MM-DD").toString();


      if (eventObj.rbstatus) {
        if (promo_sp_wager_type.indexOf("3") !== -1) {
          sp_wager_type = true;
        }
      } else {
        if (eventDt != '') {
          if (eventDt == tdyDate) {
            if (promo_sp_wager_type.indexOf("1") !== -1) {
              sp_wager_type = true;
            }
          } else {
            if (promo_sp_wager_type.indexOf("2") !== -1) {
              sp_wager_type = true;
            }
          }
        }
      }

      res = promo_sp_id.indexOf(String(eventObj.sptid)) !== -1 && !(promo_bt_not_allow.indexOf(bt) !== -1) && sp_wager_type;
    }
    if (payload) {
      if (payload.callback) {
        return payload.callback(res);
      }
    }
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_45" /* PROMO_FLAG */], function (state, payload) {
  state.promotionFlag = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_44" /* PROMO_DETAILS */], function (state, payload) {
  state.promotionDetails = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_46" /* PROMO_SHOW_JOIN_SUCCESS */], function (state, payload) {
  state.promotionShowJoinSuccess = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_42" /* PROMO_BET_STATUS */], function (state, payload) {
  state.promotionBetStatus = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_41" /* PROMO_BET_INDEX */], function (state, payload) {
  state.promotionBetIndex = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_43" /* PROMO_BET_WITHOUT_JOIN */], function (state, payload) {
  state.promotionBetWithoutJoin = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contentsMain_searchLeagueTeam__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__myheader_wob_index__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contentsMain_index__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_components_mini_bet__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(0);
















/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        myheader: __WEBPACK_IMPORTED_MODULE_6__myheader_wob_index__["a" /* default */],
        contentsBody: __WEBPACK_IMPORTED_MODULE_7__contentsMain_index__["a" /* default */],
        searchLeagueTeam: __WEBPACK_IMPORTED_MODULE_5__contentsMain_searchLeagueTeam__["a" /* default */],
        minibet: __WEBPACK_IMPORTED_MODULE_8__vue_components_mini_bet__["a" /* default */]
    },
    data: function data() {
        return {
            lang: window.lang,
            chooseLang: window._cookie,
            customImage: window._customImage,
            token: window.token,
            heightPX: window.innerHeight + 'px',
            bettingModeAlert: window.bettingModeAlert,
            def_edition: window.def_edition,
            def_theme: window.def_theme,
            bettingMode: 'N1',
            lobby: window.lobby,
            lobbyUrl: window.lobbyUrl,
            hasRedirect: window._hasRedirect,
            loginRedirectUrl: window._loginRedirectUrl
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapGetters */])(['account', 'selectedBettype', 'showLeagueTeam', 'unfold_AllSc', 'miniNormal', 'frameWidthHeight', 'sportMiniBet', 'comboBetExceedLimit', 'dialogToggle']), {
        LeftMenu_heightPX: function LeftMenu_heightPX() {
            return this.$store.getters.frameWidthHeight.height.currentHeight;
        },
        current_widthPX: function current_widthPX() {
            return this.$store.getters.frameWidthHeight.width.currentWidth;
        }
    }),
    methods: {
        closeGuide: function closeGuide() {
            $('.fadein').fadeOut();
            var accCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_acc'));
            accCookie.shownGuide = true;

            $.ajax({
                method: 'post',
                url: _baseUrl + '/callCookies',
                data: {
                    com_code: window.compcode,
                    acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(accCookie)
                }
            }).done(function (res) {});
        },
        onResize: function onResize() {
            var resizeable = {};
            if (this.LeftMenu_heightPX != window.innerHeight) {
                resizeable.currentHeight = window.innerHeight;
            }
            if (this.current_widthPX != window.innerWidth) {
                resizeable.currentWidth = window.innerWidth;
            }
            if (resizeable) {
                this.$store.commit('FRAME_WH', resizeable);
            }
        },
        betMode: function betMode(mode) {
            this.bettingMode = mode;
        },
        confirmBetMode: function confirmBetMode() {
            this.bettingModeAlert = false;
            if (this.bettingMode != null) {
                this.setSimpleSoccer(this.bettingMode);
                $.ajax({
                    url: _baseUrl + '/account-def-settings',
                    type: 'get',
                    data: {
                        action: 'updateAccountSportSetting',
                        edition: 3,
                        startedtab: 1,
                        sport_id: this.bettingMode.substring(1)
                    }
                }).done(function (response) {});
            }
        },
        setSimpleSoccer: function setSimpleSoccer(bettingMode) {
            if (this.$store.getters.sportList && this.$store.getters.sportList.length > 0) {
                var sindex = _.findIndex(this.$store.getters.sportList, { 'sprtId': bettingMode });
                if (sindex != -1) {
                    if (this.$store.getters.allSportCount) {
                        if (this.$store.getters.allSportCount['today'] && this.$store.getters.allSportCount['today'][bettingMode] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.allSportCount['today'][bettingMode]).length > 0 || this.$store.getters.allSportCount['live'] && this.$store.getters.allSportCount['live'][bettingMode] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.allSportCount['live'][bettingMode]).length > 0) {
                            if (this.$store.getters.selectedMarket != this.$store.getters.market.tdyMarket.key) {
                                this.$store.commit('SELECTED_MARKET', this.$store.getters.market.tdyMarket.key);
                            }
                        } else if (this.$store.getters.allSportCount['early'] && this.$store.getters.allSportCount['early'][bettingMode] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.allSportCount['early'][bettingMode]).length > 0) {
                            if (this.$store.getters.selectedMarket != this.$store.getters.market.earlyMarket.key) {
                                this.$store.commit('SELECTED_MARKET', this.$store.getters.market.earlyMarket.key);
                            }
                        }
                    }
                    __WEBPACK_IMPORTED_MODULE_9__events_event_bus__["a" /* default */].$emit('changeSimpleSport', this.$store.getters.sportList[sindex]);
                }
            }
        },
        redirectDialogAction: function redirectDialogAction(action) {
            if (action == 'cancel') {
                $('.login-redirect-dialog').hide();
            } else if (action == 'login') {
                window.parent.location.href = this.loginRedirectUrl;
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        $('#loading-root-ele').hide();

        var Vue = this;
        this.$nextTick(function () {
            window.addEventListener('resize', _this.onResize);
            var lastScrollLeft = 0;
            $('#home').scroll(function () {
                var documentScrollLeft = $('#home').scrollLeft();
                if (lastScrollLeft != documentScrollLeft) {
                    $('#leftBarMiniScroll').hide();
                    $('#leftBarNormalScroll').hide();
                    $('#AllBetScrollab').hide();
                    var lefpos = 60 - documentScrollLeft < 0 ? -5 : 60 - documentScrollLeft;
                    var lefpos2 = 225 - documentScrollLeft < 0 ? -5 : 225 - documentScrollLeft;
                    var lefpos3 = 998 - documentScrollLeft < 0 ? -5 : 998 - documentScrollLeft;
                    $('#leftBarMiniScroll').css({ left: lefpos });
                    $('#leftBarNormalScroll').css({ left: lefpos2 });
                    $('#AllBetScrollab').css({ left: lefpos3 });
                    setTimeout(function () {
                        if (Vue.$store.getters.miniNormal == 1) {
                            $('#leftBarMiniScroll').show();
                            $("leftBarMiniScroll").getNiceScroll().resize();
                        } else {
                            $('#leftBarNormalScroll').show();
                            $("leftBarNormalScroll").getNiceScroll().resize();
                        }
                        $('#AllBetScrollab').show();
                    }, 1000);

                    if (documentScrollLeft + $('#home').width() == $('.main').width()) {
                        $('#AllBetScrollfirstEvent').show();
                    } else {
                        $('#AllBetScrollfirstEvent').hide();
                    }

                    lastScrollLeft = documentScrollLeft;
                }
            });
        });

        if (this.def_edition == 3 && !this.bettingModeAlert) {
            this.setSimpleSoccer('N1');
        }
    },
    beforeMount: function beforeMount() {
        if (__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('theme') == 'theme02') {
            document.documentElement.classList.add('theme02');
        } else {
            document.documentElement.classList.remove('theme02');
        }
        this.$store.commit('FRAME_RESIZE', 1);

        if (window.promotion_data != false && window.promotion_data != null) {
            this.$store.dispatch('setPromoDetails', {
                promo_details: window.promotion_data,
                promotionBetStatus: window.promotionBetStatus
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }
});

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_zh_cn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_zh_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__["a" /* default */]],
  components: {},
  data: function data() {
    return {
      templateSearch: false,
      searchedList: null,
      searchedListRB: null,
      cookies_lang: window._cookie,
      langid: '',
      searchVal: null,
      searchSelected: false,
      inputText: '',
      selectedSportSearch: 'N1',
      hoverSport: 'N1',
      selectedSportId: '1',
      selectedLang: window._langid,
      moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a,
      sportBettypeList: window.sportBettypeList
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['langList', 'showLeagueTeam', 'sportList', 'selectedSport', 'bettypeList', 'historyList', 'searchLoading', 'cookieHistory', 'filterEventArr', 'miniNormal', 'frameWidthHeight', 'showLeagueSearch', 'searchLeague']), {
    LeftMenu_heightPX: function LeftMenu_heightPX() {
      return this.$store.getters.frameWidthHeight.height.currentHeight - 160;
    }
  }),
  watch: {
    bool_leagueToggle: function bool_leagueToggle() {
      if (this.$store.getters.bool_leagueToggle) {
        var ht = window.innerHeight - 100;
        this.heightPX = ht + 'px';
      }
    },

    hoverSport: function hoverSport(val) {

      var position = $("#tab-" + val).first().position();
      var center = position.left + $("#tab-" + val).width() / 2.3;
      $('.sports-tab .line').css('transform', 'translateX(' + center + 'px)');
    }
  },
  methods: {
    clear: function clear(e, text) {
      $('#searchField').val(text);
      this.instantSearch(e);
    },
    matchDateCheck: function matchDateCheck(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss");
    },
    instantSearch: function instantSearch(e) {
      var _this = this;

      this.$store.commit('SHOW_LEAGUESEARCH', true);
      this.$store.commit('SEARCH_LOADING', true);
      var vue = this;
      var data = '';
      var dataRB = '';
      var typing = '';
      vue.searchVal = $('#searchField').val();
      clearTimeout(typing);
      typing = setTimeout(function () {
        if (vue.inputText != vue.searchVal) {
          vue.inputText = vue.searchVal;
          if (vue.searchVal != '') {
            _this.$store.commit('COOKIE_HISTORY', {
              searchVal: vue.searchVal,
              remove: false,
              removeSelected: false
            });
            vue.$store.commit('HIST_LIST', vue.$store.getters.cookieHistory);
          }
          vue.$store.commit('SEARCH_LOADING', false);
        }
      }, 2000);
      if (e.code == 'Backspace' || vue.searchVal == '') {
        vue.searchedList = null;
        vue.searchedListRB = null;
        vue.$store.commit('SEARCH_LOADING', false);
      }
      if (vue.searchVal != null && vue.searchVal != '') {
        var filEventArr = vue.filterEventArr;
        if (filEventArr[0] == "NOEVENT") {
          filEventArr = [];
        }
        dataRB = _.filter(filEventArr, function (o, u) {
          if (o['sportid']) {
            o['sptid'] = o['sportid'];
            if (o['rbstatus'] == 1 && vue.selectedSportSearch.replace("N", "") == o['sportid']) {
              if (o['lge' + vue.langid + 'cap'] && o['lge' + vue.langid + 'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              } else if (o['lge1cap'] && o['lge1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              }
              if (o['ta' + vue.langid + 'cap'] && o['ta' + vue.langid + 'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              } else if (o['ta1cap'] && o['ta1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              }
              if (o['tb' + vue.langid + 'cap'] && o['tb' + vue.langid + 'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              } else if (o['tb1cap'] && o['tb1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              }
            }
          }
        });
        data = _.filter(filEventArr, function (o, u) {
          if (o['sportid']) {
            o['sptid'] = o['sportid'];
            if (o['rbstatus'] == 0 && vue.selectedSportSearch.replace("N", "") == o['sportid']) {
              if (o['lge' + vue.langid + 'cap'] && o['lge' + vue.langid + 'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              } else if (o['lge1cap'] && o['lge1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              }
              if (o['ta' + vue.langid + 'cap'] && o['ta' + vue.langid + 'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              } else if (o['ta1cap'] && o['ta1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              }
              if (o['tb' + vue.langid + 'cap'] && o['tb' + vue.langid + 'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              } else if (o['tb1cap'] && o['tb1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1) {
                return true;
              }
            }
          }
        });
      }

      this.searchedList = _(data).groupBy(function (o) {
        return o.lgeid;
      }).value();
      this.searchedListRB = _(dataRB).groupBy(function (o) {
        return o.lgeid;
      }).value();
    },
    changeSearche: function changeSearche() {
      this.templateSearch = !this.templateSearch;
    },
    closeLeagueTeam: function closeLeagueTeam() {
      this.searchVal = '';
      this.$store.commit('SHOW_LEAGUETEAM', false);
      if (this.searchLeague.lid > 0) {
        var lgeList = {};
        lgeList.lid = 0;
        lgeList.lname = '';
        this.$store.commit('SEARCH_LEAGUE', lgeList);
        __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      }
    },
    getLangid: function getLangid() {
      var vue = this;

      if (vue.cookies_lang == 'zh_TW') {
        vue.langid = 3;
      } else if (vue.cookies_lang == 'zh_CN') {
        vue.langid = 2;
      } else if (vue.cookies_lang == 'th_TH') {
        vue.langid = 5;
      } else if (vue.cookies_lang == 'vn_VN') {
        vue.langid = 6;
      } else {
        vue.langid = 1;
      }
    },
    highlightText: function highlightText(words, searchText) {
      return words;
    },
    hidePopUp: function hidePopUp() {
      this.$store.commit('SHOW_FILTER');
    },
    clearSearchHistory: function clearSearchHistory() {
      var vue = this;
      this.$store.commit('COOKIE_HISTORY', {
        searchVal: vue.searchVal,
        remove: true,
        removeSelected: false
      });
      this.$store.commit('HIST_LIST', []);
    },
    changeSport: function changeSport(e, sptid) {
      this.selectedSportSearch = sptid;
      this.selectedSportId = sptid.replace("N", "");
      this.$store.dispatch('getFilterEventList', {
        'sportid': this.selectedSportId
      });
      if (this.searchVal != '') {
        this.instantSearch(e);
      }
    },
    modifyDate: function modifyDate(date) {
      var nDateTime = date.split(' ');

      var nDate = nDateTime[0];

      var nDt = nDate.split('/');

      return nDt[1] + '/' + nDt[2] + ' ' + nDateTime[1];
    },
    pickHistory: function pickHistory(e, history) {
      this.searchVal = history;
      $('#searchField').val(history);
      this.instantSearch(e);
    },
    removeFromHistory: function removeFromHistory(history, hIdx) {
      var cookies = this.$store.getters.historyList;
      var data = _.filter(cookies, function (o, key) {
        return key != hIdx;
      });
      this.$store.commit('HIST_LIST', data);

      this.$store.commit('COOKIE_HISTORY', {
        searchVal: history,
        remove: false,
        removeSelected: true
      });
    },
    modifyEventId: function modifyEventId(eveid) {
      return (eveid - 1000) * 2;
    },
    selectSearchBox: function selectSearchBox() {
      $('#searchField').focus();
      this.searchSelected = true;
    },
    enterAllBet: function enterAllBet(eve) {
      this.$store.commit('FIRSTEVENT', []);
      this.$store.commit('SORTEDMATCHEVENTLIST', []);
      this.$store.commit('SELECTED_MATCHALLBET', false);

      var market = 1;
      if (eve.evetype == 0) {
        market = 1;
      } else if (eve.evetype == 1) {
        market = 2;
      } else if (eve.evetype == 2) {
        market = 3;
      }
      this.$store.commit('SELECTED_MARKET', market);
      __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      eve.eveid = this.modifyEventId(eve.eveid);
      eve.sptid = eve.sportid;
      eve.dt = eve.evedt;
      eve.filtersptid = eve.sportid;
      this.searchVal = null;
      $('#searchField').val('');
      this.closeLeagueTeam();
      this.$store.dispatch('getMatchAllBet', {
        event: eve,
        isRB: eve.rbstatus == 1 ? true : false,
        token: token.arr_8,
        loadTemplate: 3 });
      this.$store.commit('SHOW_LEAGUETEAM', false);
      this.$store.commit('SHOW_LEAGUESEARCH', false);
    },
    searchLeagueList: function searchLeagueList(lge) {
      var lgeList = {};
      lgeList.lid = lge['lgeid'];
      lgeList.lname = lge['lge1cap'];
      if (lge['lge' + this.langid + 'cap']) {
        lgeList.lname = lge['lge' + this.langid + 'cap'];
      }
      $('#searchField').val(lgeList.lname);
      this.$store.commit('SEARCH_LEAGUE', lgeList);

      var market = 1;
      if (lge.evetype == 0) {
        market = 1;
      } else if (lge.evetype == 1) {
        market = 2;
      }
      this.$store.commit('SELECTED_MARKET', market);
      __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      this.$store.commit("GAMEBANNER_SELECTED", false);
      this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
      this.$store.commit('SELECTED_ALLBET', false);
      this.$store.commit('SELECTED_MATCHALLBET', false);
      this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
      this.$store.commit('OPEN_RBMARKET', false);
      this.$store.commit('SHOW_LEAGUESEARCH', false);
      __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
      var sportList = {};
      sportList.sprtId = this.selectedSportSearch;
      this.$store.commit('SELECTED_SPORT', sportList);
      this.commitBettypeList();
      this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.$store.getters.bettypeList[0]));
      __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('sportChange', this.$store.getters.selectedBettype);
      this.$store.commit('SHOW_LEAGUETEAM', false);
      this.$store.commit('SHOW_LEAGUESEARCH', false);
    },
    checkTimer: function checkTimer(event) {
      return this.$options.filters.checkTimer(event);
    },
    commitBettypeList: function commitBettypeList() {
      this.$store.commit('BETTYPELIST', _.filter(this.sportBettypeList, {
        'sprtId': this.selectedSportSearch
      }));
    },
    getFilterEventList: function getFilterEventList() {
      this.$store.dispatch('getFilterEventList', {
        'sportid': this.selectedSportId
      });
    }
  },

  mounted: function mounted() {
    var Vue = this;
    this.getLangid();
    $(document).mouseup(function (e) {
      var container = $("#search-wrap");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        Vue.searchVal = null;
        $('#searchField').val('');
        Vue.closeLeagueTeam();
      }
    });
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.getFilterEventList();
    __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$on("getLatestFilterEventList", function (res) {
      _this2.getFilterEventList();
    });
    this.$store.commit('HIST_LIST', this.$store.getters.cookieHistory);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$off("getLatestFilterEventList");
  }
});

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_mixins_sportMatchCount__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sliderImage__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__contentsLeft_gameBanner__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(0);













/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_5__vue_mixins_sportMatchCount__["a" /* default */]],
    components: {
        sliderImage: __WEBPACK_IMPORTED_MODULE_7__sliderImage__["a" /* default */],
        gameBanner: __WEBPACK_IMPORTED_MODULE_8__contentsLeft_gameBanner__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(['langList', 'account', 'timeZone', 'tvIconFlag', 'oddTypesList', 'miniNormal', 'selectedMarket', 'selectedBettype', 'selectedMatchAllBet', 'selectedSport', 'showFavEvents', 'showLeagueSearch', 'showLeagueSearch', 'showLeagueTeam', 'frameWidthHeight', 'sportList', 'promotionDetails']), {
        right_widthPX: function right_widthPX() {
            return this.$store.getters.frameWidthHeight.width.RightPage_current;
        },
        decimals: function decimals() {
            return this.account._showDecimals ? 2 : 0;
        },
        showLogo: function showLogo() {
            return this.account.showLogo;
        },

        showFavEvents: {
            get: function get() {
                return this.$store.getters.showFavEvents;
            },
            set: function set(value) {
                var _this = this;

                if (!this.account.previewFlag) {
                    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                    this.$store.dispatch('getSportOdds', {
                        showfavorite: value,
                        callback: function (res) {
                            _this.refreshScroll();
                        }.bind(this)
                    });
                }
            }
        },
        leagueShowHide: function leagueShowHide() {
            var a = '';
            if (this.$store.getters.showLeagueTeam) {
                a = 'z-index: 900';
            }
            return a;
        }
    }),
    data: function data() {
        var _ref;

        return _ref = {
            selectedOdd: null,
            currentTime: null,
            tdyDateTime: window.tdyDateTime,
            currentDate: null,
            langId: window._langid,
            langSelect: lang_select,
            currentLang: null,
            cookielang: _cookie,
            timerCount: 60,
            timerIdCount: null
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'cookielang', _cookie), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'content', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'openHeader', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'lobby', window.lobby), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'lobbyUrl', window.lobbyUrl), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showLangActive', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showThemeActive', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedTheme', window.def_theme), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showOddsActive', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'oddsTypeActive', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'reconnectTimerSeconds', 5), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'customTemplate', window._customTemplate), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'normaltable', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'rbtable', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showCCL', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedTimeZone', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showTimeZoneActive', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'promotionRulesShow', window.promotionRulesShow), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'gameBannerStatus', window._gameBanner || window._imageBanner ? true : false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'redirectReq', window._redirectReq), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hasRedirect', window._hasRedirect), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loginRedirectUrl', window._loginRedirectUrl), _ref;
    },

    methods: {
        CCL: function CCL() {
            if (this.showCCL == true) {
                this.showCCL = false;
            } else {
                this.showCCL = true;
            }
        },
        getSportCCL: function getSportCCL(loadAction) {
            if (!this.account.previewFlag) {
                $('#balancesRefresh').addClass('loading-static-animation');
                var active = $('.widgetPanel.personalAccount').hasClass('active');
                if (loadAction == 0 || loadAction == 1 && active) {
                    if (active) {
                        this.$store.dispatch('getSportCCL', {
                            token: token.arr_5,
                            showB: true
                        });
                    } else {
                        this.$store.dispatch('getSportCCL', {
                            token: token.arr_5
                        });
                    }
                }
            }
            setInterval(function () {}, 1500);
        },
        showSearchLeagueTeam: function showSearchLeagueTeam() {
            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit("getLatestFilterEventList", true);
            this.$store.commit('SHOW_LEAGUETEAM', !this.$store.getters.showLeagueTeam);
            this.$store.commit('SHOW_LEAGUESEARCH', true);
            $('#searchField').focus();
        },
        toggleActive: function toggleActive() {
            this.showLangActive = false;
            this.showThemeActive = false;
            this.showOddsActive = false;
            this.oddsTypeActive = false;
            this.showTimeZoneActive = false;
        },
        clickShow: function clickShow(types) {
            if (types == 'slang') {
                this.showLangActive = this.showLangActive ? false : true;
            } else if (types == 'oddsType') {
                this.oddsTypeActive = this.oddsTypeActive ? false : true;
            } else if (types == 'sodds') {
                this.showOddsActive = this.showOddsActive ? false : true;
            } else if (types == 'stheme') {
                this.showThemeActive = this.showThemeActive ? false : true;
            } else if (types == 'sTime') {
                this.showTimeZoneActive = this.showTimeZoneActive ? false : true;
            }
        },
        changeTheme: function changeTheme(t) {
            var theme = 1;
            if (t == 'PM') {
                theme = 2;
            } else if (t == 'AM') {
                theme = 1;
            }

            if (window.windowInfo != undefined) {
                window.windowInfo.close();
            }
            var a = 'theme01';
            if (t == 'PM') {
                a = 'theme02';
                document.documentElement.classList.add('theme02');
                $(document.body).addClass('theme02');
                $(document.body).removeClass('theme01');
            } else {
                document.documentElement.classList.remove('theme02');
                $(document.body).addClass('theme01');
                $(document.body).removeClass('theme02');
            }

            this.selectedTheme = t;
            if (!this.account.previewFlag) {
                this.$ajax({
                    url: _baseUrl + '/account-def-settings',
                    type: 'get',
                    data: {
                        action: 'updateAccountSportSetting',
                        theme: theme
                    }
                }).done(function (response) {});
            } else {
                $.ajax({
                    method: 'post',
                    url: _baseUrl + '/callCookies',
                    async: false,
                    data: {
                        action: 'theme',
                        theme: a
                    }
                }).done(function (res) {});
            }

            this.showThemeActive = false;
        },
        getTheme: function getTheme() {
            if (this.selectedTheme = 'AM') {
                var disp = this.langList.am;
            } else {
                var disp = this.langList.pm;
            }

            return disp;
        },
        refreshTimer: function refreshTimer() {
            this.clearTimer();
            this.timerSeconds = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 180;
            this.startTimer();
        },
        refreshScroll: function refreshScroll() {
            var main = document.getElementById('right_div');
            var sportTableWidth = $('.tableContent').outerWidth();
            if (main) {
                var maxTop = main.parentNode.parentNode.scrollHeight - main.offsetHeight;

                main.parentNode.parentNode.onscroll = function () {
                    main.style.top = Math.min(this.scrollTop + 39) + "px";
                    main.style.left = sportTableWidth + "px";
                };
            }
        },
        updateCurrentTime: function updateCurrentTime() {
            var timeZone = '-04:00';
            if (this.$store.getters.timeZone.list[this.selectedTimeZone] != undefined) {
                timeZone = this.$store.getters.timeZone.list[this.selectedTimeZone][0];
            }
            this.currentTime = __WEBPACK_IMPORTED_MODULE_3_moment___default()().utcOffset(timeZone).format("HH:mm:ss").toString();
        },
        openLiveTv: function openLiveTv() {
            if (!this.account.previewFlag) {
                window.windowTv = window.open('livetv', 'MsgWindow', 'width=1050, height=700');
            }
        },
        showMoreMsg: function showMoreMsg(msg) {
            if (!this.account.previewFlag) {
                window.windowInfo = window.open('annhistory?ann=' + msg, 'MsgWindow', 'width=1024, height=767');
            } else if (window._hasRedirect) {
                $('.login-redirect-dialog').show();
            }
        },
        showMoreFunc: function showMoreFunc(msg) {
            var _this2 = this;

            if (!this.account.previewFlag) {
                var height = window.screen.availHeight - 50;
                var width = window.screen.availWidth - 100;
                var left = screen.width / 2 - width / 2;
                var top = screen.height / 2 - height / 2;
                if (width > 1024) {
                    width = 1024;
                }
                if (height > 600) {
                    height = 600;
                }
                if (msg == 0) {
                    window.windowInfo = window.open('sport-wager?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
                } else if (msg == 1) {
                    window.windowInfo = window.open('statement?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
                } else if (msg == 2) {
                    width = 1319;
                    window.windowInfo = window.open('event-results?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
                } else if (msg == 5) {
                    window.windowInfo = window.open('sport-information?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
                } else if (msg == 4) {
                    window.windowInfo = window.open('account-settings?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
                } else if (msg == 7 || msg == 6) {
                    var langsPost = 1;
                    var pgss = msg == 7 ? 1 : 2;
                    if (this.currentLang.id == 2) {
                        langsPost = 3;
                    } else if (this.currentLang.id == 2) {
                        langsPost = 3;
                    } else if (this.currentLang.id == 3) {
                        langsPost = 4;
                    } else if (this.currentLang.id == 5) {
                        langsPost = 2;
                    }
                    window.open('https://sigma23.3swolf.com/views/page.php?pg=' + pgss + '&acc=' + this.account.acccode + '&lang=' + langsPost, 'MsgWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
                } else if (msg == '8') {
                    window.windowInfo = window.open('event-results?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
                    window.addEventListener('message', function (event) {
                        if (event.source === window.windowInfo) {
                            var data = event.data;
                            if (data.redirectToPromotionSport) {
                                window.windowInfo.close();

                                if (_this2.$store.getters.promotionDetails.length > 0 || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.$store.getters.promotionDetails).length > 0) {
                                    var promo_sp_id = _this2.$store.getters.promotionDetails.sp_sport.split(",");
                                    var promo_sp_wager_type = _this2.$store.getters.promotionDetails.sp_wager_type.split(",");
                                    _this2.$store.commit('SELECTED_MARKET', parseInt(promo_sp_wager_type[0]));
                                    var promo_sport = _this2.$store.getters.sportList.find(function (element) {
                                        return element.sprtId == 'N' + promo_sp_id[0];
                                    });
                                    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('leftBarChangeSport', promo_sport);
                                }

                                data.redirectToPromotionSport = false;
                            }
                        }
                    });
                }
            } else if (window._hasRedirect) {
                $('.login-redirect-dialog').show();
            }
        },
        str_concate: function str_concate(a, b) {
            return a + b;
        },

        changeLanguage: function changeLanguage(value) {
            if (window.windowInfo != undefined) {
                window.windowInfo.close();
            }
            if (value == this.currentLang.id) {
                return false;
            }
            $('#loading-root-ele').show();
            this.$ajax({
                method: 'get',
                url: '',
                data: {
                    language: value,
                    token: token.arr_3
                }
            }).done(function (response) {
                var url = window.location.href;

                if (url.indexOf('langs') != -1) {
                    var url_temp = url.split("langs");
                    var new_url = url_temp[0].slice(-1) == '&' ? url_temp[0].slice(0, -1) : url_temp[0];

                    if (url_temp[1].indexOf('&') != -1) {
                        var url_rest = url_temp[1].split(/&(.*)/);
                        window.location.href = new_url + (new_url.slice(-1) == '?' ? '' : '&') + url_rest[1];
                    } else {
                        window.location.href = new_url;
                    }
                } else {
                    window.location.reload();
                }
            });
        },
        showLogout: function showLogout() {
            if (this.account.previewFlag) {
                return false;
            }
            if (this.account.isApi && !this.account.showDemo) {
                return false;
            }
            return true;
        },
        logout: function logout() {
            if (window.windowTv != undefined) {
                window.windowTv.close();
            }
            if (window.windowInfo != undefined) {
                window.windowInfo.close();
            }
            this.$ajax({
                method: 'post',
                url: _baseUrl + '/login',
                data: {
                    action: 'logout',
                    enableLoading: false,
                    token: token.arr_10
                }
            }).done(function (res) {
                window.location.href = 'login';
            }.bind(this)).catch(function (errRes) {
                console.log(errRes);
            });
        },
        ajaxForAnn: function ajaxForAnn() {
            var _this3 = this;

            var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var url = '';
            this.clearTimer();
            if (!this.account.previewFlag) {
                url = "/annhistory/getAnn?selAnn=0&selDate=all&langId=" + this.currentLang.id;

                this.$ajax({
                    url: _baseUrl + url,
                    type: 'get',
                    data: {
                        langId: window._langid,
                        token: token_val
                    }
                }).done(function (response) {
                    var msg = '';
                    if (response['data'].length > 0) {
                        var self = _this3;
                        response['data'].forEach(function (urgAnn) {
                            msg += self.replaceText(urgAnn['message'], 0) + "&nbsp;&nbsp;&nbsp;&nbsp;";
                        });
                    }
                    _this3.content = msg;
                    _this3.timerCount = 180;
                    _this3.startTimer();
                });
            } else {
                this.content = lang.welcome;
            }
        },
        clearTimer: function clearTimer() {
            if (this.timerIdCount != null) {
                clearInterval(this.timerIdCount);
                this.timerIdCount = null;
            }
        },
        startTimer: function startTimer() {
            var _this4 = this;

            if (this.timerIdCount == null) {
                this.timerIdCount = setInterval(function () {
                    if (_this4.timerCount - 1 < 0) {
                        _this4.ajaxForAnn(token.arr_1);
                    } else {
                        _this4.timerCount -= 1;
                    }
                }, 1000);
            }
        },
        ajaxUrgentAnn: function ajaxUrgentAnn() {
            var _this5 = this;

            this.$ajax({
                url: _baseUrl + '/annhistory',
                type: 'get',
                data: {
                    action: 'getUrgentAnn',
                    langId: window._langid
                }
            }).done(function (response) {

                if (response['data'].length > 0) {
                    var self = _this5;
                    response['data'].forEach(function (urgAnn) {
                        alert(self.replaceText(urgAnn, 0));
                    });
                }
            });
        },
        ajaxFirstloadAnn: function ajaxFirstloadAnn() {
            var _this6 = this;

            this.$ajax({
                url: _baseUrl + '/annhistory',
                type: 'get',
                data: {
                    action: 'getFirstLoadAnn',
                    langId: window._langid
                }
            }).done(function (response) {
                if (response['data']['urg'].length > 0) {
                    var self = _this6;
                    var urgText = '';
                    response['data']['urg'].forEach(function (urgAnn, index) {
                        urgText += index + 1 + ') ' + urgAnn + '\n';
                    });
                    alert(urgText);
                }
                if (response['data']['left']) {
                    if (response['data']['left']['message']) {
                        _this6.content = response['data']['left']['message'];
                    }
                }
                _this6.timerCount = 60;
                _this6.startTimer();
            });
        },
        getMarketTimer: function getMarketTimer(selMarket) {
            if (selMarket == this.$store.getters.market.inPlayMarket.key) {
                return this.rbTimer;
            } else if (selMarket == this.$store.getters.market.earlyMarket.key) {
                return this.earlyTimer;
            } else if (selMarket == this.$store.getters.market.tdyMarket.key) {
                return this.todayTimer;
            }
        },
        changeTimeZone: function changeTimeZone(selectedTimeZone) {
            if (window.windowInfo != undefined) {
                window.windowInfo.close();
            }
            this.selectedTimeZone = selectedTimeZone;
            this.$store.commit('TIME_ZONE', this.selectedTimeZone);
            $('.TimeZone_dropdown').removeClass('active');
        },
        changeOdd: function changeOdd(orderkey, event) {
            if (!this.account.previewFlag) {
                this.$ajax({
                    url: _baseUrl + '/account-def-settings',
                    type: 'get',
                    data: {
                        action: 'updateAccountSportSetting',
                        odd: orderkey
                    }
                }).done(function (response) {});
            }

            this.reloading = true;
            event.preventDefault();
            event.stopPropagation();

            this.oddsTypeActive = false;
            this.selectedOdd = orderkey;
            this.$store.commit('SELECTED_ODD', orderkey);
            this.$store.commit('SHOW_UP_DOWN', false);

            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('cancelBetForm');
            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('REMOVE_ALL_FORECAST');

            this.$store.commit('R_ALLBET_RELOADING', true);
            if (this.selectedMatchAllBet) {
                __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('refreshAllbetTable', token.arr_4);
            } else {
                __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('selectLeagueRefreshTable', token.arr_4);

                if (this.$store.getters.show_Unfold || this.selectedBettype && this.selectedBettype.sprtId != 'N1' || this.$store.getters.simpleSport) {
                    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('refreshRightScoreBoard', token.arr_4);
                }
            }

            $('.odds_dropdown').removeClass('active');
        },
        replaceText: function replaceText(words, repBool) {

            var blue_start = '[blue]';
            var blue_end = '[/blue]';
            var red_start = '[red]';
            var red_end = '[/red]';

            if (repBool == 0) {
                var blue_replace_start = '';
                var red_replace_start = '';
                var end = '';
            } else {
                var blue_replace_start = '<span style="color:blue">';
                var red_replace_start = '<span style="color:red">';
                var end = '</span>';
            }

            if (words) {
                if (words.indexOf(blue_start) != -1) {
                    words = words.replace('[blue]', blue_replace_start);
                }
                if (words.indexOf(blue_end) != -1) {
                    words = words.replace('[/blue]', end);
                }
                if (words.indexOf(red_start) != -1) {
                    words = words.replace('[red]', red_replace_start);
                }
                if (words.indexOf(red_end) != -1) {
                    words = words.replace('[/red]', end);
                }
            }
            return words;
        },
        showLobby: function showLobby() {
            if (this.lobby != '' && this.lobbyUrl != '') {
                if (this.lobby != null && this.lobbyUrl != null) {
                    return true;
                }
            }
            return false;
        },
        backToLobby: function backToLobby() {
            if (window.self !== window.top) {
                window.top.location.href = this.lobbyUrl;
            } else {
                window.location.href = this.lobbyUrl;
            }
        },
        highlightLine: function highlightLine(val) {
            var position = $(".tab-" + val).first().position();
            var center = position.left + ($(".tab-" + val).width() + 30) / 2 - 18;
            $('.site-nav .line').css('transform', 'translateX(' + center + 'px)');
        },
        redirectPage: function redirectPage() {
            var url = this.customTemplate['redirect_web'];
            if (this.redirectReq) {
                var req = this.redirectReq.split('&');
                _.each(req, function (val) {
                    if (!(val.indexOf('prefix') !== -1)) {
                        url += '&' + val;
                    }
                });
            }
            window.location.href = url;
        }
    },
    created: function created() {
        var _this7 = this;

        var timeZone = '-04:00';
        if (this.$store.getters.timeZone.list[this.selectedTimeZone] != undefined) {
            timeZone = this.$store.getters.timeZone.list[this.selectedTimeZone][0];
        }
        this.currentTime = __WEBPACK_IMPORTED_MODULE_3_moment___default()().utcOffset(timeZone).format("HH:mm:ss").toString();
        setInterval(function () {
            return _this7.updateCurrentTime();
        }, 1 * 1000);
    },
    mounted: function mounted() {

        this.normaltable = false, this.rbtable = false, this.ajaxForAnn(token.arr_7);
        var Vue = this;
        $(document).on('click', function (e) {
            if (Vue.showLangActive) {
                if ($(e.target).closest(".wrap-language").length === 0 && $(e.target).closest(".language-text").length === 0) {
                    Vue.showLangActive = false;
                }
            }
            if (Vue.showThemeActive) {
                if ($(e.target).closest(".stheme").length === 0) {
                    Vue.showThemeActive = false;
                }
            }
            if (Vue.showOddsActive) {
                if ($(e.target).closest(".showOddsActive").length === 0) {
                    Vue.showOddsActive = false;
                }
            }
        });
    },

    watch: {},
    destroyed: function destroyed() {
        this.clearTimer();
    },
    beforeMount: function beforeMount() {
        var _this8 = this;

        this.selectedOdd = this.$store.getters.account.oddsType;
        if (this.hasRedirect) {
            var theme = 'theme02';
        } else {
            var theme = 'theme01';
        }
        if (this.selectedTheme == 'PM') {
            theme = 'theme02';
            document.documentElement.classList.add('theme02');
            $(document.body).addClass('theme02');
            $(document.body).removeClass('theme01');
        } else if (this.selectedTheme == 'AM') {
            theme = 'theme01';
            document.documentElement.classList.add('theme01');
            $(document.body).addClass('theme01');
            $(document.body).removeClass('theme02');
        }

        if (!__WEBPACK_IMPORTED_MODULE_6_vue_cookie___default.a.get('theme')) {
            $.ajax({
                method: 'post',
                url: _baseUrl + '/callCookies',
                async: false,
                data: {
                    action: 'theme',
                    theme: theme
                }
            }).done(function (res) {});
        } else {
            if (__WEBPACK_IMPORTED_MODULE_6_vue_cookie___default.a.get('theme') == 'theme01') {
                this.selectedTheme = 'AM';
            } else {
                this.selectedTheme = 'PM';
            }
        }

        _.map(this.langSelect, function (langObj, key) {
            _.assign(langObj, { id: key });
            return langObj;
        });
        var selectedLangKey = _.findKey(this.langSelect, function (langObj) {
            return langObj.language_code == _this8.cookielang;
        }.bind(this));
        this.currentLang = this.langSelect[selectedLangKey];
        this.langSelect = _.filter(this.langSelect, function (langObj, key) {
            return langObj.language_code != _this8.cookielang;
        });
        this.langSelect.unshift(this.currentLang);
        if (__WEBPACK_IMPORTED_MODULE_6_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_timeZone') && false) {
            var tms = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_timeZone'));
            this.selectedTimeZone = tms.default;
        } else {
            this.selectedTimeZone = this.$store.getters.timeZone.default;
        }
    }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contentsLeft_gameBanner__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);






/* harmony default export */ __webpack_exports__["a"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])([])),
    components: {
        gameBanner: __WEBPACK_IMPORTED_MODULE_1__contentsLeft_gameBanner__["a" /* default */]
    },
    data: function data() {
        return {
            lang: window.lang
        };
    },

    methods: {},
    beforeMount: function beforeMount() {},
    mounted: function mounted() {
        var options = { $AutoPlay: 1, $SlideDuration: 1800 };
        var jssor_1_slider = new $JssorSlider$("jssor_1", options);

        var MAX_WIDTH = 400;
        function ScaleSlider() {
            var containerElement = jssor_1_slider.$Elmt.parentNode;

            var containerWidth = 400;
            if (containerWidth) {
                var expectedWidth = Math.min(MAX_WIDTH || containerWidth, containerWidth);
                $('#jssor_1').height(50);
                jssor_1_slider.$ScaleWidth(containerWidth);
            } else {
                window.setTimeout(ScaleSlider, 30);
            }
        }

        ScaleSlider();

        $Jssor$.$AddEvent(window, "load", ScaleSlider);
        $Jssor$.$AddEvent(window, "resize", ScaleSlider);
    }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_mixins_sportMatchCount__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__vue_mixins_sportMatchCount__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["oddSelected", "selectedTab", "langList", "isGameBannerSelected", "market", "selectedMarket", "openBetForm"]), {
    sportList: function sportList() {
      return _.keyBy(this.$store.getters.sportList, 'sprtId');
    }
  }),
  props: {
    position: null
  },
  data: function data() {
    return {
      timer1: 60,
      timerId1: null,
      timer2: 180,
      timerId2: null,
      timer3: 180,
      timerId3: null,
      tdyCount: 0,
      earlyCount: 0,
      inPlyCount: 0,
      showGameBanner: false,
      showImageBanner: false,
      gameBannerImage: window._gameBannerImage,
      cookies_lang: window._cookie,
      isClicked: false
    };
  },

  methods: {
    startTimer: function startTimer(market) {
      var _this = this;

      if (this['timerId' + market] == null) {
        this['timerId' + market] = setInterval(function () {
          if (_this.isGameBannerSelected) {
            if (_this['timer' + market] - 1 < 0) {
              _this.getMatches(market);
            } else {
              _this['timer' + market] -= 1;
            }
          } else {
            _this.clearTimer(market);
          }
        }, 1000);
      }
    },
    clearTimer: function clearTimer(market) {
      market = market.toString();
      clearInterval(this['timerId' + market]);
      this['timerId' + market] = null;
    },
    reinitTimer: function reinitTimer(market) {
      var timer = 0;

      timer = 60;

      this['timer' + market] = timer;
      this.startTimer(market);
    },
    getGameBannerCount: function getGameBannerCount(market, count) {
      if (this.market.inPlayMarket.key == market) {
        this.inPlyCount = count;
      } else if (this.market.tdyMarket.key == market) {
        this.tdyCount = count;
      } else if (this.market.earlyMarket.key == market) {
        this.earlyCount = count;
      }
    },
    getMatches: function getMatches(market) {
      var _this2 = this;

      market = market.toString();
      this.clearTimer(market);
      this.$store.dispatch("getSportEventList", {
        market: market,
        isGameBanner: true,
        callback: function (res) {
          if (res.totalMatch) {
            if (res.totalMatch[_this2.market.inPlayMarket.key]) {
              _this2.getGameBannerCount(_this2.market.inPlayMarket.key, res.totalMatch[_this2.market.inPlayMarket.key][_this2.sportList.N1.sprtId.slice(1)]);
            } else {
              _this2.getGameBannerCount(_this2.market.inPlayMarket.key, 0);
            }
            if (res.totalMatch[_this2.market.tdyMarket.key]) {
              _this2.getGameBannerCount(_this2.market.tdyMarket.key, res.totalMatch[_this2.market.tdyMarket.key][_this2.sportList.N1.sprtId.slice(1)]);
            } else {
              _this2.getGameBannerCount(_this2.market.tdyMarket.key, 0);
            }
            if (res.totalMatch[_this2.market.earlyMarket.key]) {
              _this2.getGameBannerCount(_this2.market.earlyMarket.key, res.totalMatch[_this2.market.earlyMarket.key][_this2.sportList.N1.sprtId.slice(1)]);
            } else {
              _this2.getGameBannerCount(_this2.market.earlyMarket.key, 0);
            }
            if (_this2.isClicked) {
              if (_this2.inPlyCount > 0) {
                _this2.$store.commit('SELECTED_MARKET', _this2.market.tdyMarket.key);
                market = _this2.market.tdyMarket.key;
              } else {
                if (_this2.tdyCount > 0) {
                  _this2.$store.commit('SELECTED_MARKET', _this2.market.tdyMarket.key);
                  market = _this2.market.tdyMarket.key;
                } else {
                  if (_this2.earlyCount > 0) {
                    _this2.$store.commit('SELECTED_MARKET', _this2.market.earlyMarket.key);
                    market = _this2.market.earlyMarket.key;
                  }
                }
              }
              _this2.isClicked = false;
              _this2.$store.commit('SELECTED_MARKET', market);
              __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
              __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('marketChange', market);
            }
          } else {
            _this2.getGameBannerCount(_this2.market.inPlayMarket.key, 0);
            _this2.getGameBannerCount(_this2.market.tdyMarket.key, 0);
            _this2.getGameBannerCount(_this2.market.earlyMarket.key, 0);
            if (_this2.isClicked) {
              _this2.isClicked = false;
              _this2.$store.commit('SELECTED_MARKET', _this2.selectedMarket);
              __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
              __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('marketChange', _this2.selectedMarket);
            }
          }
          _this2.reinitTimer(market);
        }.bind(this)
      });
    },
    gameMarket: function gameMarket(market) {
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
      this.$store.commit("GAMEBANNER_SELECTED", true);
      this.$store.commit('SELECTED_ALLBET', false);
      this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
      this.$store.commit('SELECTED_MARKET', market);
      this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
      this.$store.commit('SELECTED_SPORT', _.keyBy(this.$store.getters.sportList, 'sprtId')['N1']);
      this.resetSportBettype();
      this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.$store.getters.bettypeList[0]));
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('sportChange', this.$store.getters.selectedBettype);
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('marketChange', market);
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
    },
    selectGameBanner: function selectGameBanner() {
      if (this.showGameBanner && !this.showImageBanner) {
        this.isClicked = true;
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('changeShowOdds', false);
        this.$store.commit("SPECIAL_EVENT", false);
        this.$store.commit("HOT_SCHEDULE", false);
        this.$store.commit('SIMPLE_SPORT', null);
        this.$store.commit("GAMEBANNER_SELECTED", true);
        this.$store.commit('SELECTED_ALLBET', false);
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
        this.$store.commit('SELECTED_MATCHALLBET', false);
        this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
        this.$store.commit('OPEN_RBMARKET', false);
        this.$store.commit('LIVE_SCHECULE', false);
        this.$store.commit('EVENTLIST', []);
        this.$store.commit('SORTEDEVENTLIST', []);
        this.$store.commit('SORTEDRBEVENTLIST', []);
        var market = this.$store.getters.market.tdyMarket.key;
        if (this.$store.getters.selectedMarket == '2') {
          market = this.$store.getters.market.earlyMarket.key;
          this.$store.commit('RBEVENTLIST', []);
          this.$store.dispatch('getEarlyEventCountByDate');
        }
        this.$store.commit('SELECTED_MARKET', market);
        this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[0]);
        this.resetSportBettype();

        this.getMatches([1, 2, 3]);
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    if (window._gameBanner) {
      this.showGameBanner = true;
      this.$store.commit('GAME_BANNER_ID', window._gameBanner);

      this.$store.commit('GAME_BANNER_SPORT_ID', 'N1');

      this.getMatches([1, 2, 3]);
    } else if (window._imageBanner) {
      var def_pos = window._gameBannerImage.position ? window._gameBannerImage.position : ['l', 't'];
      if (def_pos.indexOf(this.position) !== -1) {
        this.showImageBanner = true;
      }
    }
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off('selectGameBanner');
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('selectGameBanner', function () {
      _this3.selectGameBanner();
    });
  },
  destroyed: function destroyed() {
    this.clearTimer([1, 2, 3]);
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off('selectGameBanner');
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contentsLeft_leftBar__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__centerContent__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contentsRight_index__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__["a" /* default */]],
  components: {
    leftMenu: __WEBPACK_IMPORTED_MODULE_1__contentsLeft_leftBar__["a" /* default */],
    centerContent: __WEBPACK_IMPORTED_MODULE_2__centerContent__["a" /* default */],
    rightMenu: __WEBPACK_IMPORTED_MODULE_3__contentsRight_index__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['betLang', 'selectedBettype', 'resizeWHeight', 'unfold_AllSc', 'miniNormal', 'frameWidthHeight']), {
    heightPX: function heightPX() {
      return this.$store.getters.frameWidthHeight.height.currentHeight;
    }
  }),
  watch: {
    'selectedBettype': {
      handler: function handler(val, oldVal) {
        if (val != null) {
          var sprt = this.selectedBettype.sprtId;
          var tmp = this.selectedBettype.tmpltId;

          if (sprt == 'N1' && tmp != '1' || sprt != 'N1') {
            this.showRightMenu = true;
          } else if (sprt == 'N1' && tmp == '1') {
            if (!_.isUndefined(this.unfold_AllSc[sprt]) && !_.isUndefined(this.unfold_AllSc[sprt][tmp])) {
              this.showRightMenu = !this.unfold_AllSc[sprt][tmp];
            }
          }
        }
      },

      deep: true,
      immediate: true
    },
    unfold_AllSc: {
      handler: function handler(val, oldVal) {
        if (this.selectedBettype != null) {
          var sprt = this.selectedBettype.sprtId;
          var tmp = this.selectedBettype.tmpltId;

          if (sprt == 'N1' && tmp != '1' || sprt != 'N1') {
            this.showRightMenu = true;
          } else if (sprt == 'N1' && tmp == '1') {
            if (!_.isUndefined(val) && !_.isUndefined(val[sprt]) && !_.isUndefined(val[sprt][tmp])) {
              this.showRightMenu = !val[sprt][tmp];
            }
          }
        }
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      timerId: null,
      pendingTimerId: null,
      timerSeconds: 10,
      widthPX: window.innerWidth + 'px !important;',
      baseWidth: 1440,
      showRightMenu: true
    };
  },

  methods: {
    widthHandler: function widthHandler(e) {}
  },
  mounted: function mounted() {},
  beforeMount: function beforeMount() {},
  created: function created() {
    window.addEventListener("resize", this.widthHandler);
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.widthHandler);
  },
  beforeDestroy: function beforeDestroy() {},
  updated: function updated() {}
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gameBanner__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userInfo__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__myFavorite__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__allSport__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bettingFormFooter__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mainB__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(0);













/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */]],
    components: {
        mainB: __WEBPACK_IMPORTED_MODULE_6__mainB__["a" /* default */],

        userInfo: __WEBPACK_IMPORTED_MODULE_2__userInfo__["a" /* default */],
        favorite: __WEBPACK_IMPORTED_MODULE_3__myFavorite__["a" /* default */],
        allSport: __WEBPACK_IMPORTED_MODULE_4__allSport__["a" /* default */],
        gameBanner: __WEBPACK_IMPORTED_MODULE_1__gameBanner__["a" /* default */],
        bettingFormFooter: __WEBPACK_IMPORTED_MODULE_5__bettingFormFooter__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(['oddSelected', 'selectedTab', 'resizeWHeight', 'openBetForm', 'miniNormal', 'sportList', 'market', 'frameWidthHeight', 'betting', 'isProcessBet', 'sportMiniBet', 'betLang', 'pendingFlag', 'specialEventList']), {
        heightPX: function heightPX() {
            return this.$store.getters.frameWidthHeight.height.currentHeight;
        },
        widthPX: function widthPX() {
            return this.$store.getters.frameWidthHeight.width.LeftPage_current;
        },
        showToggleFloat: function showToggleFloat() {
            return this.$store.getters.frameWidthHeight.width.minFull > this.$store.getters.frameWidthHeight.width.currentWidth;
        }
    }),
    data: function data() {
        return {
            isMini: false,
            cBetting: false,
            otrBt: {
                betTypId: "6",
                betTypLang: "Outrights",
                sprtId: "G98",

                tmpltId: "11"
            },
            rbAllSport: {
                "sprtId": "G98"
            },
            specialEventStatus: window.specialEventStatus
        };
    },
    mounted: function mounted() {
        if (this.isUsingPhone() === 1) {
            var scrollArea = document.querySelector('.betForm-scrollArea-phone');
            var mulpScrollArea = document.querySelector('.mulpbetForm-scrollArea-phone');
            var betSlipArea = document.querySelector('.betSlip-scrollArea-phone');
            if (scrollArea) {
                scrollArea.style.height = '100% !important';
            }
            if (mulpScrollArea) {
                mulpScrollArea.style.height = '100% !important';
            }
            if (betSlipArea) {
                betSlipArea.style.height = '100% !important';
            }
        }
        var Vue = this;
        if (Vue.miniNormal == 1) {
            $('#miniScroll').niceScroll({
                horizrailenabled: false,
                autohidemode: false,
                scrollbarid: 'leftBarMiniScroll',
                cursorborder: "0px solid #fff",
                zindex: 48,
                railoffset: { left: 10 },
                cursordragontouch: true
            });
        } else {
            $('#normalScroll').niceScroll({
                horizrailenabled: false,
                autohidemode: false,
                scrollbarid: 'leftBarNormalScroll',
                cursorborder: "0px solid #fff",
                zindex: 45,
                railoffset: { left: 10 },
                cursordragontouch: true
            });
        }
        $('.scroll').hover(function () {
            $(this).addClass('active');
        }, function () {
            $(this).removeClass('active');
        });

        $('.collapseExpand').hover(function () {
            $('#leftBar').addClass('selected');
        }, function () {
            $('#leftBar').removeClass('selected');
        });

        $('.collapseExpand').on('click', function () {
            var widerClass = $('.sidebar-first').hasClass('wider');
            if (widerClass) {
                Vue.isMini = true;
                $('.sidebar-first').removeClass('wider');
                $('.category-sportList').removeClass('active');
                $('.sidebar-first').addClass('mini');
            } else {
                Vue.isMini = false;
                $('.sidebar-first').removeClass('mini');
                $('.category-sportList').addClass('active');
                $('.sidebar-first').addClass('wider');
            }
        });
        $('#ascrail2000').addClass('mini');
        $('#ascrail2001').addClass('normal');
    },
    updated: function updated() {},

    methods: {
        openLivetv: function openLivetv() {
            if (!this.$store.getters.account.previewFlag || this.$store.getters.isLiveOn) {
                this.$store.commit("LIVE_SCHECULE", true);
                this.$store.commit('OPEN_RBMARKET', false);
                this.$store.commit("GAMEBANNER_SELECTED", false);
                this.$store.commit('SELECTED_ALLBET', false);
                this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
                this.$store.commit('SELECTED_MATCHALLBET', true);

                if ($('.menu-fold2-wrap').hasClass('open')) {
                    $('.menu-fold2-wrap').removeClass('open');
                }

                __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('callLivetv');
            } else if (window._hasRedirect) {
                $('.login-redirect-dialog').show();
            }
        },
        openRBMarket: function openRBMarket(market) {
            this.$store.commit('MINI_NORMAL', 0);
            __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('SELECTED_ALLBET', false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
            this.$store.commit('SELECTED_MATCHALLBET', false);
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
            this.$store.commit('SORTEDRBEVENTLIST', []);
            this.$store.commit('SORTEDEVENTLIST', []);

            this.$store.commit('MINI_NORMAL', 3);
            this.$store.commit('SPORTFORECAST_LIST', null);
            this.$store.commit('OPEN_RBMARKET', true);
            this.$store.commit('SELECTED_MARKET', market);
            __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
            __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.inPlayMarket.key);
        },
        showFullLeft: function showFullLeft(val) {
            if (val < 0) {
                if (this.miniNormal == 1) {
                    val = 3;
                } else {
                    val = 2;
                }
            }
            this.$store.commit('MINI_NORMAL', val);
        },
        changeBettype: function changeBettype(bettype, otr) {
            __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
            this.$store.commit('SIMPLE_SPORT', null);
            if (otr == 11) {
                bettype.tmpltId = 11;
                this.$store.commit('SELECTED_SPORT', this.rbAllSport);
                __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                this.commitBettypeList();
                this.$store.commit('OPEN_RBMARKET', false);
                __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.selectedMarket == 3 ? '1' : this.$store.getters.selectedMarket);
                this.$store.commit('SELECTED_MARKET', this.$store.getters.selectedMarket == 3 ? '1' : this.$store.getters.selectedMarket);
            }
            if (bettype.betTypId == '5') {
                this.$store.commit("IS_BETCOMBO", false);
                this.$store.dispatch('getEarlyEventCountByDate');
                if (this.$store.getters.betForm.length > 0) {
                    this.$store.commit("REMOVE_MATCH", { removeAll: true });
                    this.$store.commit("SHOW_BETFORM_MENU", false);
                }
            }
            if (this.$store.getters.selectedBettype.betTypId == '5' && this.$store.getters.betForm.length > 0) {
                this.$store.commit("REMOVE_MATCH", { removeAll: true });
                this.$store.commit("SHOW_BETFORM_MENU", false);
            }

            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
            this.$store.commit('SELECTED_ALLBET', false);
            this.$store.commit('SELECTED_MATCHALLBET', false);
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
            this.$store.commit('SORTEDRBEVENTLIST', []);
            this.$store.commit('SORTEDEVENTLIST', []);
            this.$store.commit('EVENTLIST', []);
            this.$store.commit('MERGE_LEAGUELIST', null);

            if (this.$store.getters.selectedMarket == '1') {
                this.$store.commit('SELECTEDEARLYPARLAYDATE', this.todayDate);
            } else {
                this.$store.commit('SELECTEDEARLYPARLAYDATE', this.allDate);
            }


            __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
            if (bettype) {
                if (bettype.betTypId == '5' && this.$store.getters.sportPrevIsMulp) {
                    this.$store.commit('SPORT_PREVIOUS_IS_MULP', true);
                } else {
                    this.$store.commit('PARLAY_SELECTED', { update: false });
                    this.$store.commit('SPORT_PREVIOUS_IS_MULP', false);
                }
                this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(bettype));
            } else {
                var temp = this.$store.getters.selectedBettype;
                temp.betTypId = null;
                temp.tmpltId = null;
                this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp));
            }
            __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('sportChange', this.$store.getters.selectedBettype);
        },
        changeSport: function changeSport(sport) {
            var simpleSport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this.$store.getters.selectedSport == sport) {} else {}
            this.$store.commit('MINI_NORMAL', 3);

            if (simpleSport) {
                __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('changeSimpleSport', sport);
            } else {
                __WEBPACK_IMPORTED_MODULE_7__events_event_bus__["a" /* default */].$emit('leftBarChangeSport', sport);
            }
        },
        commitBettypeList: function commitBettypeList() {
            if (this.$store.getters.selectedSport.sprtId == 'G98') {
                this.$store.commit('BETTYPELIST', _.filter(this.sportBettypeList, {
                    'sprtId': 'N1'
                }));
            } else {
                this.$store.commit('BETTYPELIST', _.filter(this.sportBettypeList, {
                    'sprtId': this.$store.getters.selectedSport.sprtId
                }));
            }
        }
    },
    watch: {
        resizeWHeight: function resizeWHeight() {}
    }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_sportMatchCount__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__allSport__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_filters_vue_filter_number__ = __webpack_require__(14);












/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        allSport: __WEBPACK_IMPORTED_MODULE_4__allSport__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['account', 'langList', 'checked', 'betLang', 'allSportCount', 'sportList', 'selectedMarket']), {
        decimals: function decimals() {
            return this.account._showDecimals ? 2 : 0;
        },
        bettypeList: function bettypeList() {
            var availableBettypeList = this.$store.getters.bettypeList;

            if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
                availableBettypeList = _.remove(availableBettypeList, function (bettype) {
                    return bettype.betTypId != '5' || bettype.betTypId != '6';
                });
            }
            return availableBettypeList;
        }
    }),
    data: function data() {
        return {
            sportBettypeList: window.sportBettypeList,

            isMini: false,
            showCCL: true,
            timerSeconds: 60,
            timerSec: 60
        };
    },

    methods: {
        CCL: function CCL() {
            if (this.showCCL == true) {
                this.showCCL = false;
            } else {
                this.showCCL = true;
            }
        },
        showMoreFunc: function showMoreFunc(msg) {
            if (!this.account.previewFlag) {
                var height = window.screen.availHeight - 50;
                var width = window.screen.availWidth - 100;
                if (width > 1024) {
                    width = 1024;
                }

                if (height > 600) {
                    height = 600;
                }

                if (msg == 0) {
                    window.open('sport-wager?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + '');
                } else if (msg == 1) {
                    window.open('statement?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + '');
                } else if (msg == 2) {
                    window.open('event-results?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + '');
                } else if (msg == 5) {
                    window.open('sport-information?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + '');
                } else if (msg == 4) {
                    window.open('account-settings?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + '');
                }
            }
        },
        changeMarket: function changeMarket(market) {
            __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('SELECTED_ALLBET', false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
            this.$store.commit('SELECTED_MATCHALLBET', false);
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
            switch (market) {
                case this.$store.getters.market.inPlayMarket.key:
                    this.$store.commit('SPORTFORECAST_LIST', null);
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.inPlayMarket.key);
                    this.resetSportBettype();
                    __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                    __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.inPlayMarket.key);
                    break;
                case this.$store.getters.market.tdyMarket.key:
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.tdyMarket.key);
                    this.resetSportBettype();
                    __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                    __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.tdyMarket.key);
                    break;
                case this.$store.getters.market.earlyMarket.key:
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.earlyMarket.key);
                    this.resetSportBettype();
                    __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                    __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.earlyMarket.key);
                    break;
                default:
                    return false;
            }
            this.$store.dispatch('getSportEventList', {
                token: token.arr_2
            });
        },
        title_display: function title_display(selectedMarket) {
            if (selectedMarket == 1) {
                return this.langList.welcomeTdyMarket;
            } else if (selectedMarket == 3) {
                return this.langList.welcomeInPlay;
            } else {
                return this.langList.welcomeEarlyMarket;
            }
        },
        getSportCCL: function getSportCCL(loadAction) {
            if (!this.account.previewFlag) {
                $('#balancesRefresh').addClass('loading-static-animation');
                var active = $('.widgetPanel.personalAccount').hasClass('active');
                if (loadAction == 0 || loadAction == 1 && active) {
                    if (active) {
                        this.$store.dispatch('getSportCCL', {
                            token: token.arr_5,
                            showB: true
                        });
                    } else {
                        this.$store.dispatch('getSportCCL', {
                            token: token.arr_5
                        });
                    }
                }
            }
        },
        startTimer: function startTimer() {
            var _this = this;

            if (this.timerIdccl == null) {
                this.timerIdccl = setInterval(function () {
                    if (_this.timerSeconds - 1 < 0) {
                        _this.$store.dispatch('getSportCCL', {
                            token: token.arr_7
                        });
                        _this.timerSeconds = _this.timerSec;
                    } else {
                        _this.timerSeconds -= 1;
                    }
                }, 1000);
            }
        },
        clearTimer: function clearTimer() {
            clearInterval(this.timerIdccl);
            this.timerIdccl = null;
        },
        getChecked: function getChecked() {
            if (this.checked) {
                this.$store.commit('CHECKED_BALANCE', false);
            } else {
                this.$store.commit('CHECKED_BALANCE', true);
            }
        },
        hideInfo: function hideInfo() {
            var active = $('.widgetPanel.personalAccount').hasClass('active');
            if (active) {
                $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                $('.widgetArea').find('.expendScore').css('width', '');
            }
            $('.widgetPanel.personalAccount').removeClass('openContent');
            $('.widgetPanel.personalAccount').removeClass('active');
            $('#AccountList').css('display', 'none');
        },
        showPanelMini: function showPanelMini() {
            if ($('.sidebar-first').hasClass('mini')) {
                this.showPanel();
            }
        },
        countMatch: function countMatch(sprtId, market) {

            var Vue = this;
            var count = [];

            var tdyElyOTR = this.countOTR();
            if (market == '1') {
                $.each(Vue.allSportCount['today'], function (sport, bettype) {
                    if (sprtId == 'N1' && sport == 'Soccer') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'G1' && sport == 'Basketball') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'N3' && sport == 'Tennis') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'N21' && sport == 'Volleyball') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'N12' && sport == 'Badminton') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'N15' && sport == 'Snooker') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'G2' && sport == 'Others') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    }
                });
            } else if (market == '2') {
                $.each(Vue.allSportCount['early'], function (sport, bettype) {
                    if (sprtId == 'N1' && sport == 'Soccer') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'G1' && sport == 'Basketball') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'N3' && sport == 'Tennis') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'N21' && sport == 'Volleyball') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'N12' && sport == 'Badminton') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'N15' && sport == 'Snooker') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    } else if (sprtId == 'G2' && sport == 'Others') {
                        $.each(bettype, function (key, val) {
                            if (key == 'AH') {
                                count.push(val);
                            } else if (key == 'OTR') {
                                count = _.clone(tdyElyOTR);
                            }
                        });
                    }
                });
            } else if (market == '3') {
                $.each(Vue.allSportCount['live'], function (sport, bettype) {
                    if (sprtId == 'N1' && sport == 'Soccer') {
                        $.each(bettype, function (key, val) {
                            if (key == 'RAH') {
                                count.push(val);
                            }
                        });
                    } else if (sprtId == 'G1' && sport == 'Basketball') {
                        $.each(bettype, function (key, val) {
                            if (key == 'RAH') {
                                count.push(val);
                            }
                        });
                    } else if (sprtId == 'N3' && sport == 'Tennis') {
                        $.each(bettype, function (key, val) {
                            if (key == 'RAH') {
                                count.push(val);
                            }
                        });
                    } else if (sprtId == 'N21' && sport == 'Volleyball') {
                        $.each(bettype, function (key, val) {
                            if (key == 'RAH') {
                                count.push(val);
                            }
                        });
                    } else if (sprtId == 'N12' && sport == 'Badminton') {
                        $.each(bettype, function (key, val) {
                            if (key == 'RAH') {
                                count.push(val);
                            }
                        });
                    } else if (sprtId == 'N15' && sport == 'Snooker') {
                        $.each(bettype, function (key, val) {
                            if (key == 'RAH') {
                                count.push(val);
                            }
                        });
                    } else if (sprtId == 'G2' && sport == 'Others') {
                        $.each(bettype, function (key, val) {
                            if (key == 'RAH') {
                                count.push(val);
                            }
                        });
                    }
                });
            }

            return _.sum(count);
        },
        countOTR: function countOTR() {

            var Vue = this;
            var count = [];
            var sportList = Vue.allSportCount;

            $.each(sportList['today'], function (sport, bettype) {
                $.each(bettype, function (key, val) {
                    if (key == 'OTR') {
                        count.push(val);
                    }
                });
            });

            $.each(sportList['early'], function (esport, ebettype) {
                $.each(ebettype, function (ekey, eVal) {
                    if (ekey == 'OTR') {
                        count.push(eVal);
                    }
                });
            });

            return count;
        },
        showPanel: function showPanel() {
            if ($('.sidebar-first').hasClass('mini')) {
                this.isMini = true;
            }
            var active = $('.widgetPanel.personalAccount').hasClass('active');
            if (active) {
                $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                $('.widgetArea').find('.expendScore').css('width', '');
                $('.widgetPanel.personalAccount').removeClass('openContent');
                $('.widgetPanel.personalAccount').removeClass('active');

                $('#AccountList').css('display', 'none');
            } else {

                $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
                $('.widgetArea').find('.expendScore').css('width', '40em');

                $('.icon-refresh').addClass('spin');
                $('.widgetPanel.personalAccount').addClass('openContent');
                $('.widgetPanel.personalAccount').addClass('active');

                $('#AccountList').css('display', 'block');
                this.getSportCCL(1);
                setInterval(function () {
                    $('.icon-refresh').removeClass('spin');
                }, 1500);
            }
        }
    },
    beforeMount: function beforeMount() {
        if (!this.account.previewFlag) {
            this.startTimer();
        }
        this.$store.dispatch('getSportCCL', {
            token: token.arr_7
        });
        this.$store.commit('SPORTLIST', _.uniqBy(this.sportBettypeList, 'sprtId'));
    },
    destroyed: function destroyed() {
        this.clearTimer();
    },
    updated: function updated() {},
    mounted: function mounted() {}
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allSport_vue__ = __webpack_require__(149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60667d27_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allSport_vue__ = __webpack_require__(321);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allSport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60667d27_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allSport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_sportMatchCount__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sportCategory__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bettingForm__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__betSlipForm__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(0);












/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__vue_mixins_sportMatchCount__["a" /* default */]],
    components: {
        sportCategory: __WEBPACK_IMPORTED_MODULE_4__sportCategory__["a" /* default */],
        bettingForm: __WEBPACK_IMPORTED_MODULE_5__bettingForm__["a" /* default */],
        betSlipForm: __WEBPACK_IMPORTED_MODULE_6__betSlipForm__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['account', 'market', 'selectedMarket', 'selectedBettype', 'selectedSport', 'sportList', 'hot_sportList', 'langList', 'oddSelected', 'allSportCount', 'open_RBMarket', 'betForm', 'openBetForm', 'frameWidthHeight', 'miniNormal', 'selectedTab', 'selectedBetTab']), {
        midContent: function midContent() {
            var a = !this.$store.getters.oddSelected && !this.$store.getters.openBetForm ? '81' : '115';
            var b = this.tvIconFlag ? 40 : 0;
            var c = this.showGameBanner ? 83 : 0;
            if (this.tvIconFlag && !this.$store.getters.oddSelected && !this.$store.getters.openBetForm) {
                a = parseInt(a) + b + c;
            }
            if (this.$store.getters.selectedBetTab && !this.$store.getters.openBetForm && !this.$store.getters.showbetformMenu) {
                a = 120 + c;
            } else if (this.betForm.length > 0 && this.$store.getters.showbetformMenu) {
                a = this.$store.getters.openBetForm ? 120 : 120 + b + c;
            }
            return 'padding-top: ' + a + 'px; padding-bottom: 0px;';
        },
        heightPX: function heightPX() {
            return this.$store.getters.frameWidthHeight.height.currentHeight - 100;
        },
        selectedTab: function selectedTab() {
            return this.$store.getters.selectedTab;
        }
    }),
    watch: {
        betForm: {
            handler: function handler(val, oldVal) {
                if (this.betForm.length > 0) {
                    this.showBetForm = true;
                }
            }
        }
    },
    props: {
        isMini: Boolean
    },
    data: function data() {
        return {
            showBetForm: false,
            rbAllSport: {
                "sprtId": "G98"
            },

            sport_profile: window.def_sport_profile,
            hotSport: window.hotSport,
            showGameBanner: false,
            tvIconFlag: window.tvIconFlag ? true : false
        };
    },

    methods: {
        getFormHeightClass: function getFormHeightClass() {
            var bet = this.$store.getters.betting;
            var isMulp = this.$store.getters.selectedBettype;
            if (this.isUsingPhone() === 1 && this.$store.getters.openBetForm && isMulp.betTypId != '5' && !bet.success && !bet.pending && !bet.reject && !bet.betcombosuccess) {
                return 'betForm-scrollArea-phone';
            } else if (this.$store.getters.openBetForm && isMulp.betTypId != '5' && !bet.success && !bet.pending && !bet.reject && !bet.betcombosuccess) {
                return 'betForm-scrollArea';
            } else if (!this.$store.getters.openBetForm) {
                return 'sportMenu-scrollArea';
            } else if (this.isUsingPhone() === 1 && this.$store.getters.openBetForm && (bet.success || bet.pending || bet.reject || bet.betcombosuccess)) {
                return 'betSlip-scrollArea-phone';
            } else if (this.$store.getters.openBetForm && (bet.success || bet.pending || bet.reject || bet.betcombosuccess)) {
                return 'betSlip-scrollArea';
            } else if (this.isUsingPhone() === 1 && isMulp.betTypId == '5') {
                return 'mulpbetForm-scrollArea-phone';
            } else if (isMulp.betTypId == '5') {
                return 'mulpbetForm-scrollArea';
            }
        },
        changeMarket: function changeMarket(market, stpid) {
            this.$store.commit("IS_PARLAY_TAB", false);
            this.$store.commit("LIVE_SCHECULE", false);
            __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
            if (window._gameBanner && this.$store.getters.isGameBannerSelected) {
                this.$store.commit("GAMEBANNER_SELECTED", true);
            } else {
                this.$store.commit("GAMEBANNER_SELECTED", false);
            }
            this.$store.commit('SELECTED_ALLBET', false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
            this.$store.commit('SELECTED_MATCHALLBET', false);
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
            this.$store.commit('OPEN_RBMARKET', false);
            this.$store.commit('EVENTLIST', []);
            this.$store.commit('FAVOURITEEVENTCOUNT', 0);
            switch (market) {
                case this.$store.getters.market.inPlayMarket.key:
                    this.$store.commit('SPORTFORECAST_LIST', null);
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.inPlayMarket.key);
                    this.resetSportBettype();
                    __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                    __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.inPlayMarket.key);
                    this.$store.commit('HOT_SCHEDULE', false);
                    this.$store.commit('SPECIAL_EVENT', false);
                    break;
                case this.$store.getters.market.tdyMarket.key:
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.tdyMarket.key);
                    var spt = this.$store.getters.specialEvent ? this.$store.getters.specialEventList['sprtId'] : this.$store.getters.sportList[0];
                    this.$store.commit('SELECTED_SPORT', spt);
                    __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                    if (this.$store.getters.specialEvent) {
                        __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('getSpecialEvent');
                    } else {
                        this.resetSportBettype();
                        __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.tdyMarket.key);
                    }
                    this.$store.commit('HOT_SCHEDULE', false);
                    break;
                case this.$store.getters.market.earlyMarket.key:
                    this.$store.commit('SORTEDRBEVENTLIST', []);
                    this.$store.commit('RBEVENTLIST', []);
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.earlyMarket.key);
                    this.$store.dispatch('getEarlyEventCountByDate');
                    var spt = this.$store.getters.specialEvent ? 'SP' : this.$store.getters.sportList[0];
                    this.$store.commit('SELECTED_SPORT', spt);
                    __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                    if (this.$store.getters.specialEvent) {
                        __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('getSpecialEvent');
                    } else {
                        this.resetSportBettype();
                        __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.earlyMarket.key);
                    }
                    this.$store.commit('HOT_SCHEDULE', false);
                    break;
                case this.$store.getters.market.hotSportMarket.key:
                    if (this.$store.getters.selectedMarket != this.$store.getters.market.hotSportMarket.key) this.$store.commit('PREV_MARKET', this.$store.getters.selectedMarket);
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.hotSportMarket.key);

                    this.$store.commit('SELECTED_BETTYPE', this.$store.getters.bettypeList[0]);
                    this.$store.commit('SELECTED_SPORT', this.rbAllSport);
                    this.$store.commit('HOT_SCHEDULE', true);
                    this.$store.commit("GAMEBANNER_SELECTED", false);
                    this.$store.commit('SIMPLE_SPORT', null);
                    this.$store.commit('SPECIAL_EVENT', false);
                    __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('inplaySportChange', this.rbAllSport);
                    __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                    __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.hotSportMarket.key);
                    break;
                default:
                    return false;
            }
            this.$store.dispatch('getSportEventList', {
                token: token.arr_2
            });
            if (window._gameBanner) {
                this.$store.dispatch("getSportEventList", {
                    market: "1,2,3",
                    isGameBanner: true,
                    callback: function (res) {}.bind(this)
                });
            }
        },
        allLive: function allLive(market) {
            var allLiveSport = this.allSportCount['live'];
            var count = [];
            $.each(allLiveSport, function (sport, bettype) {
                if (sport.charAt(0) == 'N') {
                    $.each(bettype, function (key, val) {
                        if (key == 'RAH') {
                            count.push(val);
                        }
                    });
                }
            });

            return _.sum(count);
        },
        openRBMarket: function openRBMarket(market, sport) {
            this.$store.commit("IS_PARLAY_TAB", false);
            this.$store.commit('HOT_SCHEDULE', false);
            this.$store.commit('SPECIAL_EVENT', false);

            __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('SELECTED_ALLBET', false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
            this.$store.commit('SELECTED_MATCHALLBET', false);
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
            this.$store.commit('SORTEDRBEVENTLIST', []);
            this.$store.commit('SORTEDEVENTLIST', []);
            this.$store.commit('MERGE_LEAGUELIST', null);
            this.$store.commit('FAVOURITERBEVENTCOUNT', 0);

            this.$store.commit('SPORTFORECAST_LIST', null);
            this.$store.commit('OPEN_RBMARKET', true);
            this.$store.commit('SELECTED_MARKET', market);
            __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('inplaySportChange', sport);
            this.$store.commit('SELECTED_BETTYPE', this.$store.getters.bettypeList[0]);
            this.$store.commit('SELECTED_SPORT', sport);
            this.$store.commit("LIVE_SCHECULE", false);

            __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
            __WEBPACK_IMPORTED_MODULE_1__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.inPlayMarket.key);

            this.$store.dispatch('getSportEventList', {
                token: token.arr_2
            });
        },
        title_display: function title_display(selectedMarket) {
            if (selectedMarket == 1) {
                return this.langList.welcomeTdyMarket;
            } else if (selectedMarket == 3) {
                return this.langList.welcomeInPlay;
            } else {
                return this.langList.welcomeEarlyMarket;
            }
        },
        getAllSportCount: function getAllSportCount(comid) {
            var Vue = this;

            Vue.$store.dispatch('getSportCount');

            setInterval(function () {
                Vue.$store.dispatch('getSportCount');
            }, 60000);
        },
        hideContent: function hideContent() {
            var showNav = $('.nav-widgetPanel').hasClass('showNav');
            if (showNav) {
                $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                $('.widgetArea').find('.expendScore').css('width', '');
            }

            $('.nav-widgetPanel').removeClass('showNav');
            $('.sportsMenu').removeClass('active');
        },
        showNav: function showNav() {
            var mini = $('.sidebar-first').hasClass('mini');
            if (mini) {
                var showNav = $('.nav-widgetPanel').hasClass('showNav');
                if (showNav) {
                    $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                    $('.widgetArea').find('.expendScore').css('width', '');

                    $('.nav-widgetPanel').removeClass('showNav');
                    $('.sportsMenu').removeClass('active');
                } else {
                    $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
                    $('.widgetArea').find('.expendScore').css('width', '40em');

                    $('.nav-widgetPanel').addClass('showNav');
                    $('.sportsMenu').addClass('active');
                }
            }
        },
        showSport: function showSport() {
            $('.sportsMenu').removeClass('collapsed');

            var isBetSlip = $('.widgetPanel.group').hasClass('betSlip');

            if (isBetSlip) {
                $('.betSlip').removeClass('active');
                $('.betSlip').addClass('collapsed');
            } else {
                $('.betList').removeClass('active');
                $('.betList').addClass('collapsed');
            }
        }
    },
    mounted: function mounted() {
        this.getAllSportCount(this.account.comId);
    },
    beforeMount: function beforeMount() {
        this.$store.dispatch('getSportCCL', {
            token: token.arr_7
        });
        if (!_.isUndefined(this.sportBettypeList)) {
            this.$store.commit('SPORTLIST', _.uniqBy(this.sportBettypeList, 'sprtId'));
        }
        if (hotSport) {
            if (this.sport_profile && !_.isUndefined(this.sport_profile['hot_sportList'])) {
                this.$store.commit('HOT_SPORTLIST', _.uniqBy(this.sport_profile['hot_sportList'], 'sprtId'));
            }
        }

        if (window._gameBanner) {
            this.showGameBanner = true;
        } else if (window._imageBanner && window._gameBannerImage && window._gameBannerImage.position && window._gameBannerImage.position.indexOf('l') !== -1) {
            this.showGameBanner = true;
        }
    }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_mixins_sportMatchCount__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gameBanner__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);










/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__vue_mixins_sportMatchCount__["a" /* default */]],
    components: {
        gameBanner: __WEBPACK_IMPORTED_MODULE_5__gameBanner__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['selectedBettype', 'selectedSport', 'sportList', 'market', 'selectedMarket', 'allSportCount', 'open_RBMarket', 'otrBetType', 'isParlayTab', 'previousBettype', 'isGameBannerSelected', 'gameBannerSportCount', 'gameBannerSportId', 'simpleSport', 'liveSchedule', 'bettypeFeature', 'specialEvent', 'specialEventList']), {
        bettypeList: function bettypeList() {
            var _this = this;

            var availableBettypeList = this.$store.getters.bettypeList;

            if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
                availableBettypeList = _.remove(availableBettypeList, function (bettype) {
                    return bettype.betTypId != '5' || bettype.betTypId != '6';
                });
            }

            if (this.bettypeFeature) {
                var btlist = {};
                var VUE = this;

                availableBettypeList = availableBettypeList.filter(function (bettype) {
                    if (_this.bettypeFeature.indexOf('15') !== -1 && bettype.betTypId === '5') return false;
                    if (_this.bettypeFeature.indexOf('14') !== -1 && bettype.betTypId === '6') return false;
                    if (_this.$store.getters.selectedMarket == _this.$store.getters.market.earlyMarket.key || _this.$store.getters.selectedMarket == _this.$store.getters.market.tdyMarket.key) {
                        if (_this.bettypeFeature.indexOf('7') !== -1 && bettype.betTypId == '2') return false;
                        if (_this.bettypeFeature.indexOf('5') !== -1 && bettype.betTypId == '3') return false;
                        if (_this.bettypeFeature.indexOf('6') !== -1 && bettype.betTypId == '4') return false;
                    } else if (_this.$store.getters.selectedMarket == _this.$store.getters.market.inPlayMarket.key) {
                        if (_this.bettypeFeature.indexOf('16') !== -1 && bettype.betTypId == '2') return false;
                        if (_this.bettypeFeature.indexOf('18') !== -1 && bettype.betTypId == '3') return false;
                        if (_this.bettypeFeature.indexOf('17') !== -1 && bettype.betTypId == '4') return false;
                    }

                    return true;
                });
            }
            return availableBettypeList;
        },
        showOutright: function showOutright() {
            if (this.bettypeFeature && this.bettypeFeature.indexOf('14') !== -1) {
                return false;
            }
            return true;
        }
    }),
    data: function data() {
        return {
            sportBettypeList: window.sportBettypeList,
            lang: window.lang,
            selectedLang: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get(window.compcode + '_lang'),
            allDate: '99',
            todayDate: '0',
            showOdds: true,

            rbAllSport: {
                "sprtId": "G98"
            },
            gameBannerStatus: window._gameBanner,
            gameBannerImage: window._gameBannerImage,
            sport_feature: window.sport_feature,
            specialEventStatus: window.specialEventStatus,
            spEventList: window.specialEventList
        };
    },

    methods: {
        checkHeartbeat: function checkHeartbeat() {
            return true;
        },
        changeSport: function changeSport(sport) {
            var simpleSport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this.$store.getters.selectedSport.sprtId != 'G98' && this.$store.getters.selectedSport != sport && this.$store.getters.isBetParlay) {
                this.$store.commit("IS_BETPARLAY", false);
                this.$store.commit("REMOVE_MATCH", { removeAll: true });
                this.$store.commit("SHOW_BETFORM_MENU", false);
            }
            if (this.$store.getters.selectedMarket == 2) {
                this.$store.dispatch('getEarlyEventCountByDate');
            }
            if (simpleSport) {
                this.$store.commit('SIMPLE_SPORT', sport.sprtId);
            } else {
                this.$store.commit('SIMPLE_SPORT', null);
            }
            this.$store.commit("IS_PARLAY_TAB", false);
            this.$store.commit("SPECIAL_EVENT", sport == this.specialEventList['sprtId'] ? true : false);
            if (simpleSport || this.$store.getters.specialEvent) {
                this.showOdds = false;
            } else if (this.$store.getters.selectedSport == sport && this.$store.getters.selectedBettype.tmpltId != 11) {
                this.showOdds = !this.showOdds;
            } else {
                this.showOdds = true;
            }
            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
            this.$store.commit('SELECTED_ALLBET', false);
            this.$store.commit('SELECTED_MATCHALLBET', false);
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
            this.$store.commit('OPEN_RBMARKET', false);
            this.$store.commit('SORTEDRBEVENTLIST', []);
            this.$store.commit('SORTEDEVENTLIST', []);
            this.$store.commit('EVENTLIST', []);
            this.$store.commit('FAVOURITERBEVENTCOUNT', 0);
            this.$store.commit('FAVOURITEEVENTCOUNT', 0);
            this.$store.commit("LIVE_SCHECULE", false);

            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
            this.$store.commit('SELECTED_SPORT', sport);
            if (this.$store.getters.selectedMarket == 3 || this.$store.getters.hotSchedule) {
                this.$store.commit('SELECTED_MARKET', 1);
            }
            this.$store.commit("HOT_SCHEDULE", false);
            this.commitBettypeList();
            this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.$store.getters.bettypeList[0]));
            var setBt = this.$store.getters.selectedBettype;
            if (this.$store.getters.selectedBettype.tmpltId == 11) {
                setBt.tmpltId = 1;
            }
            if (!this.$store.getters.specialEvent) {
                __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('sportChange', setBt);
                if (this.$store.getters.selectedMarket == 3 || this.$store.getters.hotSchedule) {
                    this.$store.commit('SELECTED_MARKET', 1);
                }
            } else {
                __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('getSpecialEvent');
            }
            var sideBarMini = $('.sidebar-first').hasClass('mini');
        },
        comp_live: function comp_live(sport) {
            var Vue = this;
            if (!_.isUndefined(Vue.allSportCount.live) && Vue.allSportCount.live[sport] !== undefined) {
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(Vue.allSportCount.live[sport]).length > 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        changeBettype: function changeBettype(bettype, otr) {
            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
            this.$store.commit("IS_PARLAY_TAB", false);
            this.$store.commit('SIMPLE_SPORT', null);
            this.$store.commit("SPECIAL_EVENT", false);
            if (otr == 11) {
                bettype.tmpltId = 11;
                this.$store.commit('SELECTED_SPORT', this.rbAllSport);
                __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                this.commitBettypeList();
                this.$store.commit('OPEN_RBMARKET', false);
                __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.selectedMarket == 3 ? '1' : this.$store.getters.selectedMarket);
                this.$store.commit('SELECTED_MARKET', this.$store.getters.selectedMarket == 3 ? '1' : this.$store.getters.selectedMarket);
            }
            if (bettype.betTypId == '5') {
                this.$store.commit("IS_PARLAY_TAB", true);
                this.$store.commit("IS_BETCOMBO", false);
                this.$store.commit("SPORT_MINIBET_TOGGLE", false);
                this.$store.dispatch('getEarlyEventCountByDate');
                if (!this.$store.getters.isBetParlay && this.$store.getters.betForm.length > 0) {
                    this.$store.commit("REMOVE_MATCH", { removeAll: true });
                    this.$store.commit("SHOW_BETFORM_MENU", false);
                }
            }
            if (bettype.betTypId == '6') {
                if (this.$store.getters.isBetParlay || this.$store.getters.selectedBettype.betTypId == '5') {
                    this.$store.commit("IS_BETPARLAY", false);
                    if (this.$store.getters.betForm.length > 0) {
                        this.$store.commit("REMOVE_MATCH", { removeAll: true });
                    }
                    this.$store.commit("SHOW_BETFORM_MENU", false);
                }
            }

            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
            this.$store.commit('SELECTED_ALLBET', false);
            this.$store.commit('SELECTED_MATCHALLBET', false);
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
            this.$store.commit('SORTEDRBEVENTLIST', []);
            this.$store.commit('SORTEDEVENTLIST', []);
            this.$store.commit('RBEVENTLIST', []);
            this.$store.commit('EVENTLIST', []);
            this.$store.commit('MERGE_LEAGUELIST', null);
            this.$store.commit("LIVE_SCHECULE", false);
            this.$store.commit("HOT_SCHEDULE", false);

            if (this.$store.getters.selectedMarket == '1') {
                this.$store.commit('SELECTEDEARLYPARLAYDATE', this.todayDate);
            } else {
                this.$store.commit('SELECTEDEARLYPARLAYDATE', this.allDate);
            }


            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
            if (bettype) {
                if (bettype.betTypId == '5' && this.$store.getters.sportPrevIsMulp) {
                    this.$store.commit('SPORT_PREVIOUS_IS_MULP', true);
                } else {
                    this.$store.commit('PARLAY_SELECTED', { update: false });
                    this.$store.commit('SPORT_PREVIOUS_IS_MULP', false);
                }
                this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(bettype));
            } else {
                var temp = this.$store.getters.selectedBettype;
                temp.betTypId = null;
                temp.tmpltId = null;
                this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp));
            }
            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('sportChange', this.$store.getters.selectedBettype);
        },
        sportIcon: function sportIcon(sportID) {

            return this.selectedSport.sprtId == sportID ? 'icon-sport' + sportID + ' active' : 'icon-sport' + sportID;
        },
        sportItem: function sportItem(betTypId) {
            var ret = '';
            if (this.selectedBettype.betTypId == betTypId) {
                ret = 'active';
                if (this.selectedBettype.betTypId == '5' && !this.isParlayTab) {
                    ret = '';
                }
            }
            if (this.selectedBettype.betTypId == '5' && !this.isParlayTab && this.previousBettype && this.previousBettype.bettype && betTypId == this.previousBettype.bettype.betTypId) {
                ret = 'active';
            }
            return ret;
        },
        commitBettypeList: function commitBettypeList() {
            if (this.$store.getters.selectedSport.sprtId == 'G98' || this.$store.getters.specialEvent) {
                this.$store.commit('BETTYPELIST', _.filter(this.sportBettypeList, {
                    'sprtId': this.sport_feature ? this.sportList[0]['sprtId'] : 'N1'
                }));
            } else {
                this.$store.commit('BETTYPELIST', _.filter(this.sportBettypeList, {
                    'sprtId': this.$store.getters.selectedSport.sprtId
                }));
            }
        },
        countMatch: function countMatch(sprtId, market) {

            var Vue = this;
            var count = [];
            var markerKey = [];
            markerKey[1] = 'today';
            markerKey[2] = 'early';
            markerKey[3] = 'live';

            if (this.$store.getters.hotSchedule && market == 5) {
                market = this.$store.getters.prevMarket;
            }

            if (markerKey[market] != undefined && Vue.allSportCount[markerKey[market]] != undefined) {
                if (Vue.allSportCount[markerKey[market]][sprtId] != undefined) {
                    $.each(Vue.allSportCount[markerKey[market]][sprtId], function (key, val) {
                        if (key == 'AH') {
                            count.push(val);
                        } else if (key == 'RAH' && market != 2) {
                            count.push(val);
                        } else if (key == 'OTR') {
                            count.push(val);
                        }
                    });
                }
            }
            if (market == 1) {
                if (Vue.allSportCount[markerKey[2]] != undefined && Vue.allSportCount[markerKey[2]][sprtId] != undefined) {
                    $.each(Vue.allSportCount[markerKey[2]][sprtId], function (key, val) {
                        if (key == 'OTR') {
                            count.push(val);
                        }
                    });
                }
            }
            return _.sum(count);
        },
        sportCount: function sportCount(sprtId, betTypId, market) {
            var amount = 0;
            var Vue = this;
            var markerKey = [];
            markerKey[1] = 'today';
            markerKey[2] = 'early';
            markerKey[3] = 'live';
            if (markerKey[market] != undefined && Vue.allSportCount[markerKey[market]] != undefined) {
                if (Vue.allSportCount[markerKey[market]][sprtId] != undefined) {
                    $.each(Vue.allSportCount[markerKey[market]][sprtId], function (key, val) {
                        if (key == 'AH' && (betTypId == '1' || betTypId == '7' || betTypId == '9' || betTypId == '10')) {
                            amount += val;
                        } else if (key == 'RAH' && ((betTypId == '1' || betTypId == '7' || betTypId == '9' || betTypId == '10') && market != 3 || betTypId == '8')) {
                            amount += val;
                        } else if (key == 'CS' && betTypId == '2') {
                            amount += val;
                        } else if (key == 'RCS' && betTypId == '2' && market != 3) {
                            amount += val;
                        } else if (key == 'TG' && betTypId == '3') {
                            amount += val;
                        } else if (key == 'RTG' && betTypId == '3' && market != 3) {
                            amount += val;
                        } else if (key == 'HT' && betTypId == '4') {
                            amount += val;
                        } else if (key == 'RHT' && betTypId == '4' && market != 3) {
                            amount += val;
                        } else if (key == 'MULP' && betTypId == '5') {
                            amount += val;
                        } else if (key == 'OTR' && betTypId == '6') {
                            amount += val;
                        }
                    });
                }
                if (market == 1 && betTypId == '6') {
                    if (Vue.allSportCount[markerKey[2]] != undefined && Vue.allSportCount[markerKey[2]][sprtId] != undefined) {
                        $.each(Vue.allSportCount[markerKey[2]][sprtId], function (key, val) {
                            if (key == 'OTR' && betTypId == '6') {
                                amount += val;
                            }
                        });
                    }
                }
            }
            if (market == 1 && Vue.allSportCount[markerKey[3]] != undefined) {
                if (Vue.allSportCount[markerKey[3]][sprtId] != undefined) {
                    $.each(Vue.allSportCount[markerKey[3]][sprtId], function (key, val) {
                        if (key == 'RCS' && betTypId == '2' && market != 3) {
                            amount += val;
                        } else if (key == 'RTG' && betTypId == '3' && market != 3) {
                            amount += val;
                        } else if (key == 'RHT' && betTypId == '4' && market != 3) {
                            amount += val;
                        }
                    });
                }
            }
            return amount;
        },
        hideContent: function hideContent() {
            var sportListActive = $('.category-sportList').hasClass('active');

            if (sportListActive) {
                $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                $('.widgetArea').find('.scroll-content').css('width', '');
            }
            $('.mini').find('.category-sportList').removeClass('active');
        },
        countOTR: function countOTR() {

            var Vue = this;
            var count = 0;
            var sportList = Vue.allSportCount;

            $.each(sportList['today'], function (sport, bettype) {
                $.each(bettype, function (key, val) {
                    if (key == 'OTR' && sport.charAt(0) == 'N') {
                        count += val;
                    }
                });
            });

            $.each(sportList['early'], function (esport, ebettype) {
                $.each(ebettype, function (ekey, eVal) {
                    if (ekey == 'OTR' && esport.charAt(0) == 'N') {
                        count += eVal;
                    }
                });
            });

            return count;
        },
        selectGameBanner: function selectGameBanner() {
            this.$store.commit("LIVE_SCHECULE", false);
            this.$store.commit("HOT_SCHEDULE", false);
            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('selectGameBanner');
        },
        gameBannerCountMatch: function gameBannerCountMatch(market) {
            if (this.$store.getters.hotSchedule && market == 5) {
                market = this.$store.getters.prevMarket;
            }
            if (this.gameBannerSportCount && this.gameBannerSportCount[market] && this.gameBannerSportCount[market][this.gameBannerSportId.split('N').pop()]) {
                return this.gameBannerSportCount[market][this.gameBannerSportId.split('N').pop()];
            } else {
                return 0;
            }
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$on('leftBarChangeSport', function (sport) {
            _this2.changeSport(sport);
        });
        __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$on('changeSimpleSport', function (sport) {
            _this2.changeSport(sport, true);
        });
        __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$on('changeShowOdds', function (res) {
            _this2.showOdds = res;
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$off('leftBarChangeSport');
        __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$off('changeSimpleSport');
        __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$off('changeShowOdds');
    },
    beforeMount: function beforeMount() {
        this.$store.commit('SPECIAL_EVENT_LIST', this.spEventList);
        this.$store.commit('SPORTLIST', _.uniqBy(this.sportBettypeList, 'sprtId'));
        this.$store.commit('SPORTBETTYPELIST', this.sportBettypeList);
        var sport_id = 0;
        if (window.sprtid != '') {
            var index = this.$store.getters.sportList.findIndex(function (item) {
                return item.sprtId === 'N' + window.sprtid;
            });
            if (index !== -1) {
                sport_id = index;
                if (window.selectedMrkt != '') {
                    this.$store.commit('SELECTED_MARKET', window.selectedMrkt);
                    if (window.selectedMrkt == this.$store.getters.market.earlyMarket.key) {
                        this.$store.dispatch('getEarlyEventCountByDate');
                    }
                }
            }
        }
        this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[sport_id]);
        this.commitBettypeList();
        this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.$store.getters.bettypeList[0]));
    }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bettingForm_vue__ = __webpack_require__(152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d80545e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bettingForm_vue__ = __webpack_require__(318);
function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d80545e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bettingForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d80545e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bettingForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_accounting__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_mixins_favourite__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bettingFormFooter__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(0);















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    bettingFormFooter: __WEBPACK_IMPORTED_MODULE_9__bettingFormFooter__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__vue_mixins_favourite__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapGetters */])(["oddSelected", "BetTypeLang", "selectedMarket", "selectedBettype", "selectedSport", "betting", "requestAllow", "account", 'isBetSuccess', 'isProcessBet', 'isPlacedBet', 'pendingFlag', 'hdpDisp', 'mulpSetting', 'jsError', 'sportForecastToggle', 'oddTypesList', 'isBetCombo', 'betComboAmount', 'betCombo_jsError', 'openBetForm', 'promotionFlag', 'promotionBetStatus', 'betMulpAmount', 'betMulpAmtFiltered', 'isParlayTab', 'selectedMulpBetBoxId']), {
    selectedMarket: function selectedMarket() {
      return this.$store.getters.selectedMarket;
    },

    betAmount: {
      get: function get() {
        var fixedAccountingNumber = parseInt(this.$store.getters.sportMiniBet.betAmount);
        var res = this.$store.getters.sportMiniBet.betAmount == 0 ? "" : this.commasAmount(fixedAccountingNumber);

        if (this.selectedBettype.betTypId != "5" && this.$store.getters.account.rememberStake && __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting') && this.$store.getters.sportMiniBet.betAmount == 0) {
          var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
          var bamt = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(b.stkAmt, 0);
          res = bamt == 0 ? '' : this.commasAmount(bamt);

          this.betAmount = res;
          this.possiblePayout;
          if (this.$refs.betAmount && this.$refs.betAmount.length > 0) {
            this.$refs.betAmount[0].focus();
          }
        }

        return res;
      },
      set: function set(value) {
        var fixedAccountingNumber = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(value, 0);

        if (this.$store.getters.account.currCL < parseInt(fixedAccountingNumber)) {
          fixedAccountingNumber = this.$store.getters.account.currCL;
        }

        if (this.$store.getters.account.oddsType == 'in' && this.$store.getters.betForm[0].odd <= 0) {
          var maxAccNum = parseInt(parseInt(this.$store.getters.account.currCL) / Math.abs(this.$store.getters.betForm[0].odd));
          if (fixedAccountingNumber > maxAccNum) {
            fixedAccountingNumber = maxAccNum;
          }
        }
        this.$store.commit("SPORT_MINIBET_BETAMOUNT", fixedAccountingNumber);

        var b = '';
        if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting')) {
          b = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
        }
        if (b == '' || b && (b.rmbStk != value || b.stkAmt != this.$store.getters.sportMiniBet.betAmount)) {
          this.usualStakeAmount = fixedAccountingNumber;
        }
        this.JSErr = '';

        var remainingBal = this.$store.getters.account.currCL - parseInt(fixedAccountingNumber);

        if (this.$store.getters.account.oddsType == 'in' && this.$store.getters.betForm[0].odd <= 0) {
          remainingBal = parseInt(parseInt(this.$store.getters.account.currCL) - parseInt(fixedAccountingNumber) * Math.abs(this.$store.getters.betForm[0].odd));
        }
        this.setKeyboardSettings('-1', remainingBal);

        if (value != fixedAccountingNumber) {
          this.betAmount = fixedAccountingNumber;
        }
      }
    },
    betComboAmount: {
      get: function get() {
        var betAmountArr = this.$store.getters.betComboAmount;

        if (this.selectedBettype.betTypId != "5" && this.$store.getters.account.rememberStake && __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting') && this.betFormList.length == 1) {
          var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
          var bamt = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(b.stkAmt, 0);
          var res = bamt == 0 ? '' : this.commasAmount(bamt);
          betAmountArr[0].value = res;
        }

        return betAmountArr;
      },
      set: function set(arr) {
        this.$store.commit("BETCOMBO_AMOUNT", arr);
        this.JSErr = '';

        if (this.selectedBettype.betTypId != "5" && this.$store.getters.account.rememberStake && __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting') && this.betFormList.length == 1) {
          var b = '';
          b = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
          if (b == '' || b && b.stkAmt != parseInt(arr.amount)) {
            this.usualStakeAmount = arr.amount;
          }
        }
      }
    },
    betComboKeyboardAllow: {
      get: function get() {
        var betComboKeyboardArr = this.$store.getters.betComboKeyboardAllow;
        return betComboKeyboardArr;
      },
      set: function set(arr) {
        this.$store.commit("BETCOMBO_KEYBOARDALLOW", arr);
      }
    },
    usualStakeAmount: {
      get: function get() {},
      set: function set(value) {
        var b = '';
        if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting')) {
          b = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
        }
        if (b && parseInt(value) != b.stkAmt) {
          var stkset = {
            rmbStk: b.rmbStk,
            stkAmt: value
          };
          $.ajax({
            method: 'post',
            url: _baseUrl + '/callCookies',
            data: {
              action: 'rememberStk',
              stkSetting: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(stkset),
              acc_code: this.$store.getters.account.acccode
            }
          }).done(function (res) {});
        }
      }
    },
    betAllUp: {
      get: function get() {
        if (this.isMulp && this.$store.getters.betting.selectedBetAllup != null) {
          var totalBetSlip = this.$store.getters.betting.selectedBetAllup.split('x');
          if (this.$store.getters.betAmount && this.$store.getters.betAmount > 0) {
            this.totalStake = this.$store.getters.betAmount * totalBetSlip[1];
          } else {
            this.totalStake = 0;
          }

          this.totalBet = totalBetSlip[1];
        }
        return this.$store.getters.betting.selectedBetAllup;
      },
      set: function set(value) {
        this.$store.commit("BETTING_ALLUP", value);
      }
    },
    possiblePayout: function possiblePayout() {
      var oddValue = "";
      if (this.isMulp) {
        var amount = 0;

        var allUpIndex = _.findIndex(this.betting.allUpList, {
          key: this.$store.getters.betting.selectedBetAllup
        });
        var mulpParser = this.betting.allUpList[allUpIndex].parser.split("#");
        for (var index = 0; index < mulpParser.length; index++) {
          var commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (var comma = 0; comma < commaList.length; comma++) {
            var betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if (this.$store.getters.account.oddsType == 'am') {
              if (betOdd < 0) {
                betOdd = Math.abs(100 / betOdd) + 1;
              } else {
                betOdd = betOdd / 100 + 1;
              }

              betOdd = betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          amount += this.betAmount * oddValue;
        }

        return amount;
      } else {
        var betOdd = parseFloat(this.$store.getters.betForm[0].odd);
        oddValue = betOdd < 0 && (this.$store.getters.account.oddsType == 'my' || this.$store.getters.account.oddsType == 'in') ? 1 : this.validateOddBetType(this.$store.getters.betForm[0].betType, this.$store.getters.betForm[0].odd);
      }

      return this.$store.getters.sportMiniBet.betAmount * oddValue;
    },

    betFormList: function betFormList() {
      return this.$store.getters.betForm;
    },
    isBetCombo: {
      get: function get() {
        return this.$store.getters.isBetCombo;
      },
      set: function set(value) {
        var _this = this;

        var bet = this.betting;

        if (!value && this.betFormList.length > 1 && !bet.pending && !bet.success) {
          this.$store.dispatch("removeMatch", {
            data: { clearType: '2' },
            callback: function () {
              _this.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this.$store.commit("IS_BETCOMBO", value);
                  _this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this.$store.getters.betForm
                  });

                  _this.refreshTimer();
                  _this.isReloading = false;
                }.bind(_this)
              });
            }.bind(this)
          });
        } else if (!bet.pending && !bet.success) {
          this.$store.dispatch("getBettingInfo", {
            isBetCombo: value,
            callback: function (res) {
              _this.$store.commit("IS_BETCOMBO", value);

              _this.$store.commit("SPORT_MAPPING_BETTING", {
                newBettingList: res.SYSTEM_DATA.betting,
                oldBettingList: _this.$store.getters.betForm
              });

              if (_this.$store.getters.isBetCombo && _this.betFormList.length == 1) {
                var singleBetAmount = _this.$store.getters.sportMiniBet.betAmount;
                var betAmountArr = _this.$store.getters.betComboAmount;
                if (singleBetAmount != '' && singleBetAmount != '0') {
                  var arr = { index: 0, amount: singleBetAmount };
                  _this.betComboAmount = arr;
                }

                if (_this.$store.getters.betComboAmount[0].value != '') {
                  var amt = _this.$store.getters.betComboAmount[0].value;
                  var betAmt = amt != '' || amt != 0 ? parseInt(amt.replace(",", "")) : 0;
                  var remainingBal = _this.$store.getters.account.currCL - betAmt;
                  _this.setKeyboardSettings(0, remainingBal);
                }
              } else {
                var _betAmountArr = _this.$store.getters.betComboAmount[0].value;
                var fixedAccountingNumber = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(_betAmountArr, 0);
                _this.$store.commit("SPORT_MINIBET_BETAMOUNT", fixedAccountingNumber);
                if (fixedAccountingNumber != '') {
                  var amt = fixedAccountingNumber;
                  var betAmt = amt != '' || amt != 0 ? parseInt(amt.replace(",", "")) : 0;
                  var remainingBal = _this.$store.getters.account.currCL - betAmt;
                  _this.setKeyboardSettings('-1', remainingBal);
                }
              }

              _this.refreshTimer();
              _this.isReloading = false;
            }.bind(this)
          });
        } else {
          this.$store.commit("IS_BETCOMBO", value);
        }
      }
    },
    betMulpAmount: {
      get: function get() {
        var betMulpArr = this.$store.getters.betMulpAmount;
        return betMulpArr;
      },
      set: function set(arr) {
        if (!_.isUndefined(arr.index) && !_.isUndefined(arr.allUp) && !_.isUndefined(arr.amount)) {
          arr = this.mulpPossiblePayout(arr);
          this.$store.commit("BETMULP_AMOUNT", arr);
          this.JSErr = '';

          var ttlMulpAmt = this.countTotalStakePayout('totalStake');
          var currCL = parseInt(this.$store.getters.account.currCL);

          if (currCL < ttlMulpAmt) {
            var allUpKey = this.$store.getters.betMulpAmount[arr.index].allUp;
            var totalBetSlip = allUpKey.split('x');
            var remainingAmt = currCL - (ttlMulpAmt - Number(this.$store.getters.betMulpAmount[arr.index].stake == '' ? 0 : this.$store.getters.betMulpAmount[arr.index].stake.replaceAll(",", "")));
            if (remainingAmt >= 0) {
              arr.amount = Math.floor(remainingAmt / parseInt(totalBetSlip[1]));
            } else {
              arr.amount = '';
            }
            arr = this.mulpPossiblePayout(arr);
            this.$store.commit("BETMULP_AMOUNT", arr);

            ttlMulpAmt = this.countTotalStakePayout('totalStake');
          }

          var remainingBal = currCL - parseInt(ttlMulpAmt);
          this.setKeyboardSettings('-1', remainingBal);
        }
      }
    }
  }),
  props: {},
  data: function data() {
    return {
      isNegative: false,
      isDiff: false,
      isMulp: false,
      timerSeconds: 10,
      fixTimer: 10,
      timerId: null,
      pendingTimerId: null,
      isReloading: false,
      isJustRecheck: false,
      isFirstLoad: true,
      selectedLang: window._langid,
      wagerId: null,
      pendingWager: {
        data: null,
        status: false
      },
      isMulpDayExceed: false,
      totalStake: 0,
      totalBet: 0,
      langList: window.lang,
      betMinMaxVal: '',
      JSErr: '',
      odChgClass: '',
      hoverInfo: false,
      showMULPopt: false,
      multipleBetToggle: true,
      mulpOdds: 0,
      amountMaxLength: window.amountMaxLength
    };
  },

  watch: {
    betFormList: {
      handler: function handler(val, oldVal) {
        var _this2 = this;

        this.isMulpDayExceed = false;

        if (this.$store.getters.betting.pending) {
          var pendingWagerIds = this.$store.getters.isBetCombo ? _.map(_.filter(val, { wgStatus: '1' }), 'WagerID') : [this.$store.getters.betting.pending.data.WagerID];
          if (this.isMulp) {
            pendingWagerIds = [];
            _.forEach(this.$store.getters.betting.pending.data.mulpRes, function (value, key) {
              pendingWagerIds.push(value.WagerID);
            }.bind(this));
          }
          this.checkPendingWager(pendingWagerIds);
        }

        if (val.length > 0 && !this.$store.getters.sportMiniBet.toggle) {
          this.$nextTick(function () {
            if (_this2.$store.getters.isBetCombo) {
              if (_this2.betFormList.length > 1) {
                if (_this2.$refs.betAmount) {
                  _this2.$refs.betAmount.focus();
                }
              } else {
                if (_this2.$refs.betAmount0 && _this2.$refs.betAmount0.length > 0) {
                  _this2.$refs.betAmount0[0].focus();
                }
              }
            } else if (_this2.selectedBettype.betTypId == "5") {
              if (_this2.betting && _this2.betting.minMax && _this2.betFormList.length >= _this2.betting.minMax.minCombo) {
                if ($('.bet-input')[_this2.selectedMulpBetBoxId] != undefined) {
                  $('.bet-input')[_this2.selectedMulpBetBoxId].focus();
                }
              }
            } else {
              if (_this2.$refs.betAmount && _this2.$refs.betAmount.length > 0) {
                _this2.$refs.betAmount[0].focus();
              }
            }
          });
        }
        if (!this.betting.error) {
          this.betMinMax();
        }
        if (this.selectedBettype.betTypId == "5" || this.$store.getters.isBetParlay) {
          var smallDate = null;
          var bigDate = null;
          _.forEach(val, function (value) {
            if (value.oddChg == true || value.hdpChg == true) {
              _this2.$store.commit("BETMULP_AMOUNT", { clear: true });
            }

            var eventDate = "";
            if (value.eventObj && value.eventObj.dt) {
              var onlyDate = new __WEBPACK_IMPORTED_MODULE_8_moment___default.a(value.eventObj.dt).format("YYYY-MM-DD 00:00:00");
              eventDate = new __WEBPACK_IMPORTED_MODULE_8_moment___default.a(onlyDate);
            }
            if (eventDate != "") {
              if (smallDate == null && bigDate == null) {
                smallDate = eventDate;
                bigDate = eventDate;
              }

              if (smallDate.diff(eventDate, "days") > 0) {
                smallDate = eventDate;
              } else if (eventDate.diff(bigDate, "days") > 0) {
                bigDate = eventDate;
              }

              if (bigDate.diff(smallDate, "days") >= 7) {
                _this2.isMulpDayExceed = true;
              }
            }
          }.bind(this));
          this.isMulp = true;
        } else {
          this.isMulp = false;
        }

        this.$nextTick(function () {
          $('#singleContainer').css({ height: 'auto' });
          var screenHeight = $(window).height();
          var topY;
          if (_this2.isUsingPhone() === 0) {
            var scrFooter = document.getElementById('scrollFooter');
            if (_this2.$store.getters.isBetCombo && _this2.$store.getters.betForm.length > 1) {
              scrFooter.style.position = 'absolute';
              scrFooter.style.bottom = 0;
              scrFooter.style.top = null;
            } else {
              if (_this2.selectedBettype.betTypId == "5") {
                if (_this2.$store.getters.betForm.length > 2) {
                  topY = $('#normalScroll').height();
                } else if (_this2.$store.getters.betForm.length == 1) {
                  topY = $('#scrollHeaderX').height() + $('#normal-middle-content').height();
                } else if (_this2.$store.getters.betForm.length == 2) {
                  topY = screenHeight <= 765 ? $('#mulpBetArea').height() : $('#scrollHeaderX').height() + $('#normal-middle-content').height();
                }
              } else {
                if (screenHeight <= 765) {
                  topY = document.querySelector('.bet-confirm-message') ? $('#normalScroll').height() - 10 : $('#normalScroll').height();
                } else {
                  topY = $('#normal-middle-content').height() + $('#scrollHeaderX').height();
                }
              }
              document.getElementById('scrollFooter').style.top = topY + 'px';
            }
            $("#leftBarNormalScroll").getNiceScroll().resize();
          }
        });
      },
      deep: true,
      immediate: true
    },
    jsError: {
      handler: function handler(value, oldVal) {
        if (value.error && value.errorId == '4') {
          this.JSErr = 'input-border-red';
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    handleResize: function handleResize() {
      $("#normalScroll").getNiceScroll().resize();
    },
    getOddChange: function getOddChange(data) {
      var sts = '';
      if (this.betting.success || this.betting.pending || this.betting.betcombosuccess && !_.isUndefined(data.error) && data.error != '') {
        return sts;
      }

      if (data.oddChg && data.oddChgUpDown == 'up' || !_.isUndefined(data.error) && data.error != '' && data.oddChgUpDown == 'up') {
        sts = 'up-red';
      } else if (data.oddChg && data.oddChgUpDown == 'down' || !_.isUndefined(data.error) && data.error != '' && data.oddChgUpDown == 'down') {
        sts = 'down-green';
      }
      return sts;
    },
    getBetConfirmClass: function getBetConfirmClass(data, key) {
      if ((data.hdpChg || data.oddChg) && _.isUndefined(data.wgStatus) && _.isUndefined(data.error) && data.error != '') {
        return '';
      }

      if (this.betting.success || this.$store.getters.isBetCombo && this.wgSuccess.indexOf(data.wgStatus) !== -1) {
        return 'bet-success-order';
      } else if (this.betting.pending && data.wgStatus == 1) {
        return 'bet-pending-order';
      } else {
        var singleLine = this.jsError.error || !_.isUndefined(this.betCombo_jsError[key]) && this.betCombo_jsError[key].error ? ' bet-js-error' : '';
        return 'bet-fail-order' + singleLine;
      }
      hdpChg;
    },
    checkShowErrMsg: function checkShowErrMsg(data, jsErr, key) {
      if (data.error || jsErr.error || data.oddChg || data.hdpChg || this.wgSts.indexOf(data.wgStatus) !== -1 || !_.isUndefined(this.betCombo_jsError[key]) && this.betCombo_jsError[key].error) {
        return true;
      }
    },
    bettingResultClass: function bettingResultClass(data, key) {
      var index = key + 1;
      var b = key != 0 ? ' mt5' : '';
      var last = index == this.betFormList.length ? ' last-item' : '';
      var err = data.error || this.betting.error || data.wgStatus == '-1' ? ' bet-no-effect' : '';
      var single = this.chkBettingSuccess(data) || this.chkBetPending(data) ? ' bet-single-record ' : '';
      var res = this.chkIsBetting(data) || this.chkBetPending(data) || data.wgStatus == '-1' ? ' relative-position bet-card bet-single-item-card' : '';

      return err + single + last + res + b;
    },
    chkIsBetting: function chkIsBetting(data, where) {
      var isBC = this.$store.getters.isBetCombo;
      var r = false;
      if (isBC) {
        if (_.isUndefined(data.WagerID) && $.inArray(data.wgStatus, ['0', '1', '-1', '2']) < 0) {
          r = true;
        }
      } else {
        if (!this.betting.success && _.isUndefined(data.wgStatus)) {
          r = true;
        }
      }
      return r;
    },
    chkBettingSuccess: function chkBettingSuccess(data, where) {
      var isBC = this.$store.getters.isBetCombo;
      var r = false;
      if (isBC) {
        if (!_.isUndefined(data.WagerID) && _.isUndefined(data.error) && $.inArray(data.wgStatus, ['0', '2']) > -1) {
          r = true;
        } else if (this.betting.success) {
          r = true;
        }
      } else {
        if (this.betting.success) {
          r = true;
        }
      }

      return r;
    },
    chkBetPending: function chkBetPending(data, where) {
      var isBC = this.$store.getters.isBetCombo;
      var r = false;
      if (isBC) {
        if (data.wgStatus == '1' && this.betting.pending) {
          r = true;
        }
      } else {
        if ($.inArray(data.betType, this.rbBetTypeList) > -1 && data.wgStatus == '1' && this.betting.pending) {
          r = true;
        }
      }

      return r;
    },
    selAllUp: function selAllUp(allupKey) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var VUE = this;
      var ttlBet = 0;
      this.betAllUp = allupKey;
      if (action == null && action != '1') {
        this.toggleMULPopt();
      }

      if (mulpSetting[VUE.betAllUp]) {
        var ccBr = 0;
        $.each(mulpSetting[VUE.betAllUp], function (listup, cbet) {
          ttlBet += cbet;
        });
        this.totalBet = ttlBet;
      }
    },
    toggleMULPopt: function toggleMULPopt() {
      this.showMULPopt = !this.showMULPopt;
    },
    getMulpCaption: function getMulpCaption(betLang, allup) {
      var Mchar = allup.split("x");
      if (Mchar[1] == '1') {
        return betLang["BETTING.LBL_PARLAY_" + allup] + " X 1";
      } else {
        if (mulpSetting[allup]) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mulpSetting[allup]).length > 0) {
            var ccBr = 0;
            var countMBet = 0;
            var lastKey = "";
            $.each(mulpSetting[allup], function (listup, cbet) {
              ccBr += 1;
              countMBet += cbet;
              lastKey = listup;
            });
            if (ccBr == 1) {
              if (lastKey != "") {
                return betLang["BETTING.LBL_PARLAY_" + lastKey] + " X " + countMBet;
              }
            } else {
              var cap = betLang["BETTING.LBL_YANKEE"];
              if (ccBr > 2) {
                cap = betLang["BETTING.LBL_SUPER_YANKEE"];
              }

              if (cap == "Super Yankee" || cap == "Yankee") {
                return cap + " X " + countMBet;
              } else {
                return Mchar[0] + cap + countMBet + " X " + countMBet;
              }
            }
          }
        }
      }
      return allup;
    },
    getHdpCapt: function getHdpCapt(data) {
      if (data.hdp == 0 && (data.betType == '1' || data.betType == '8')) {
        return '0';
      }
      var str = '';
      if (data.fav == data.tbet) {
        if (data.betType == '1' || data.betType == '8') {
          str = '-';
        }
      } else {
        if (data.betType == '1' || data.betType == '8') {
          str = '+';
        }
      }
      var strCap = !_.isUndefined(data.hdpCap) ? data.hdpCap : data.hdp;

      if (str != '' && strCap.toString().indexOf(str) == 0) {
        str = '';
      }

      return str + strCap;
    },
    betSuccessPPayout: function betSuccessPPayout(dataArr, selectedBetAllup) {
      var data = dataArr;

      if (selectedBetAllup == null) {

        if (this.$store.getters.isBetCombo) {
          var betOdd = data.odd ? parseFloat(data.odd) : parseFloat(data.betting[0].odd);
          var betOdd2 = data.odd ? data.odd : data.betting[0].odd;
          var betType = data.betType ? data.betType : data.betting[0].betType;
          var oddValue = betOdd < 0 && (this.$store.getters.account.oddsType == 'my' || this.$store.getters.account.oddsType == 'in') ? 1 : this.validateOddBetType(betType, betOdd2);
          return data.betAmt * oddValue;
        } else {
          if (this.betting.success) {
            data = this.betting.success.data;
          } else if (this.betting.pending) {
            data = this.betting.pending.data;
          }
          var betOdd = parseFloat(data.betting[0].odd);
          var oddValue = betOdd < 0 && (this.$store.getters.account.oddsType == 'my' || this.$store.getters.account.oddsType == 'in') ? 1 : this.validateOddBetType(data.betting[0].betType, data.betting[0].odd);
          return data.betAmt * oddValue;
        }
      } else {
        var amount = 0;

        var allUpIndex = _.findIndex(this.betting.allUpList, {
          key: this.$store.getters.betting.selectedBetAllup
        });
        var mulpParser = this.betting.allUpList[allUpIndex].parser.split("#");
        for (var index = 0; index < mulpParser.length; index++) {
          var commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (var comma = 0; comma < commaList.length; comma++) {
            var betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if (this.$store.getters.account.oddsType == 'am') {
              if (betOdd < 0) {
                betOdd = Math.abs(100 / betOdd) + 1;
              } else {
                betOdd = betOdd / 100 + 1;
              }
              betOdd = betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          amount += this.$store.getters.sportMiniBet.betAmount * oddValue;
        }

        return amount;
      }
    },
    betMinMax: function betMinMax() {
      this.betMinMaxVal = this.sportAllBetLang['ALL_BET.LIMITS'] + ' ' + this.commasAmount(this.$store.getters.betting.minMax.min) + ' ~ ' + this.commasAmount(this.$store.getters.betting.minMax.max);
    },
    eventBetMinMax: function eventBetMinMax(data) {
      if (!_.isUndefined(data.minMax)) {
        var a = this.sportAllBetLang['ALL_BET.LIMITS'] + ' ' + this.commasAmount(data.minMax.min) + ' ~ ' + this.commasAmount(data.minMax.max);
        return a;
      }
    },
    getOddsTypeCap: function getOddsTypeCap(dt) {
      var otype = this.$store.getters.account.oddsType;
      var ot_cap = this.oddTypesList[otype.toUpperCase()].lang;
      var btList = ['1', '8', '2', '9', '3', '10', '46', '47', '48', '49', '80', '81', '82', '83'];

      if (this.isMulp || $.inArray(dt.betType, btList) == -1) {
        var str = otype == 'am' ? 'AM' : 'EU';
        ot_cap = this.oddTypesList[str].lang;
      }

      if (dt.sprtid == '255') {
        var str = 'HK';
        if ($.inArray(dt.betType, btList) == -1) {
          str = 'EU';
        }
        ot_cap = this.oddTypesList[str].lang;
      }

      return '[' + ot_cap + ']';
    },
    getPtBtCapt: function getPtBtCapt(dt) {
      var space = this.selectedLang == 1 ? ' ' : '';
      var ptCapt = '';
      var btCapt = this.BetTypeLang[dt.betType]["caption"];
      var homeAway = '';
      var res = '';

      if (dt.betType == '8') {
        btCapt = this.BetTypeLang['1']["caption"];
      } else if (dt.betType == '27') {
        btCapt = this.BetTypeLang['21']["caption"];
      } else if (dt.betType == '58') {
        btCapt = this.BetTypeLang['57']["caption"];
      } else if (dt.betType == '64') {
        btCapt = this.BetTypeLang['63']["caption"];
      } else if (dt.betType == '66') {
        btCapt = this.BetTypeLang['65']["caption"];
      } else if (dt.betType == '73') {
        btCapt = this.BetTypeLang['59']["caption"];
      } else if (dt.betType == '61') {
        btCapt = this.BetTypeLang['60']["caption"];
      } else if (dt.betType == '69') {
        btCapt = this.BetTypeLang['68']["caption"];
      } else if (dt.betType == '71') {
        btCapt = this.BetTypeLang['70']["caption"];
      }

      if (dt.betType == '14') {
        res = btCapt;
      } else {
        if (dt.plyType != '1') {
          ptCapt = this.langList.playTypeLang[dt.plyType]['caption'] + ' - ';
        }

        res = ptCapt + homeAway + space + btCapt;
      }

      return res;
    },
    getDecimalDisplay: function getDecimalDisplay(value, sprtid) {
      if (this.$store.getters.account.oddsType == 'am' && sprtid != 255) {
        return Math.floor(parseFloat(value).toFixed(0));
      }
      return parseFloat(value).toFixed(2);
    },
    allupBetting: function allupBetting(allup, betLang, selectedLang) {
      var str = "";
      if (mulpSetting[allup]) {
        var ccBr = 0;
        $.each(mulpSetting[allup], function (listup, cbet) {
          var ssAdd = "";
          if (selectedLang == 1 && parseInt(cbet) > 1) {
            ssAdd = "s";
          }
          if (betLang["BETTING.LBL_PARLAY_" + listup]) {
            if (ccBr != 0) str += "<br>";
            str += " > " + betLang["BETTING.LBL_PARLAY_" + listup] + " (" + cbet + " " + betLang["BETTING.LBL_PARLAY_BET"] + ssAdd + ")";
            ccBr = 1;
          }
        });
      }
      return str;
    },
    allupCaption: function allupCaption(allup, betLang, selectedLang) {
      var str = betLang["BETTING.LBL_PARLAY_" + allup];
      return str;
    },
    addsum: function addsum(amount) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.$store.getters.isBetCombo && !this.isMulp) {
        var amt = this.$store.getters.sportMiniBet.betAmount == '' ? 0 : this.$store.getters.sportMiniBet.betAmount;
        amount += Number(amt);

        if (this.$store.getters.account.currCL < amount) {
          amount = this.$store.getters.account.currCL;
        }
        this.betAmount = amount;
      } else if (key != null) {
        var VUE = this;
        if (this.$store.getters.isBetCombo) {
          var amt = _.isUndefined(VUE.betComboAmount[key]) ? 0 : VUE.betComboAmount[key].value.replace(",", "");
          amount += Number(amt);

          var arr = {
            index: key,
            amount: amount
          };
          VUE.betComboAmount = arr;


          var remainingBal = this.$store.getters.account.currCL - parseInt(amount);
          this.setKeyboardSettings(key, remainingBal);
        } else if (this.isMulp) {
          var amt = _.isUndefined(VUE.betMulpAmount[key]) ? 0 : VUE.betMulpAmount[key].value.replaceAll(",", "");
          amount += Number(amt);
          var arr = {
            index: key,
            allUp: VUE.betMulpAmount[key].allUp,
            amount: amount
          };
          VUE.betMulpAmount = arr;
        }
      } else {
        var VUE = this;
        var amt = VUE.allBetComboAmount == '' ? 0 : VUE.allBetComboAmount.replace(",", "");

        amount += Number(amt);
        var sum = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(amount, 0);
        var total = sum;
        VUE.allBetComboAmount = sum == 0 ? "" : this.commasAmount(sum);
        var rBal = VUE.$store.getters.account.currCL - parseInt(total.replace(",", ""));
        VUE.setKeyboardSettings('-1', rBal);

        var remainingBal = VUE.$store.getters.account.currCL;
        $.each(VUE.betFormList, function (id, data) {
          var arr = {
            index: id,
            amount: amount,
            clear: false
          };
          VUE.betComboAmount = arr;

          remainingBal -= parseInt(VUE.$store.getters.betComboAmount[id].value.replace(",", ""));
          VUE.setKeyboardSettings(id, remainingBal);
        });
      }
    },
    MaxAmt: function MaxAmt(amount) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var VUE = this;
      if (this.$store.getters.isBetCombo) {
        var arr = {
          index: key,
          amount: amount
        };
        VUE.betComboAmount = arr;


        var remainingBal = this.$store.getters.account.currCL - parseInt(amount);
        this.setKeyboardSettings(key, remainingBal);
      } else if (this.isMulp) {
        var arr = {
          index: key,
          allUp: VUE.betMulpAmount[key].allUp,
          amount: amount
        };
        VUE.betMulpAmount = arr;
      }
    },
    checkOrder: function checkOrder() {
      this.isJustRecheck = true;

      this.refreshTimer();
      this.startTimer();
    },
    onClickStartTimer: function onClickStartTimer() {
      var _this3 = this;

      if (!this.isJustRecheck) {
        this.isJustRecheck = false;
        this.timerSeconds = this.fixTimer;
        this.$store.dispatch("getBettingInfo", {
          token: token.arr_5,
          callback: function (res) {
            _this3.$store.commit("SPORT_MAPPING_BETTING", {
              newBettingList: res.SYSTEM_DATA.betting,
              oldBettingList: _this3.$store.getters.betForm
            });
            _this3.refreshTimer();
            _this3.isReloading = false;
          }.bind(this)
        });
      }
    },
    clearTimer: function clearTimer() {
      clearInterval(this.pendingTimerId);

      this.pendingTimerId = null;
    },
    refreshTimer: function refreshTimer() {
      this.timerSeconds = this.fixTimer;
    },
    startTimer: function startTimer() {
      var _this4 = this;

      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (_this4.timerSeconds - 1 < 0) {
            _this4.timerSeconds = _this4.fixTimer;
            if (_this4.oddSelected && !_this4.isFirstLoad) {
              _this4.isReloading = true;
              _this4.$store.dispatch("getBettingInfo", {
                token: token.arr_1,
                callback: function (res) {
                  _this4.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this4.$store.getters.betForm
                  });
                  _this4.refreshTimer();
                  _this4.isReloading = false;
                }.bind(_this4)
              });
            }
            _this4.isFirstLoad = false;
          } else {
            if (!_this4.isReloading) {
              _this4.timerSeconds -= 1;
            }
          }
        }.bind(this), 1000);
      }
      return this.timerSeconds;
    },
    classNegative: function classNegative(odd) {
      return odd < 0 ? true : false;
    },
    cancelMiniBet: function cancelMiniBet() {
      this.$store.commit("SPORT_MINIBET_TOGGLE", false);
    },
    cancelBetForm: function cancelBetForm() {
      this.cancelMiniBet();
      if (this.selectedBettype.betTypId == "5") {
        this.$store.commit("PARLAY_SELECTED", null);
      }
      this.$store.commit("BETTING_DELAY_TIMERID", null);
      this.$store.commit("REMOVE_MATCH", { removeAll: true });
      this.$store.commit("ODD_SELECTED", false);
      this.$store.commit("SELECTED_BETTAB", false);
      this.$store.commit("BETTING_MESSAGE", {
        isError: false
      });
      this.$store.commit("JS_ERR", '');
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    deleteMatch: function deleteMatch(eventid, event, key) {
      var _this5 = this;

      if (!this.isProcessBet) {
        if (this.$store.getters.isBetCombo) {

          this.$store.dispatch("removeMatch", {
            data: { clearType: '3', index: key },
            callback: function () {
              document.getElementById(event.uniqueId).parentElement.classList.remove('active');
              _this5.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: eventid
              });
              if (_this5.betFormList.length <= 0) {
                _this5.$store.commit("OPEN_BETFORM", false);
                _this5.$store.commit('ODD_SELECTED', false);
                _this5.$store.commit("SHOW_BETFORM_MENU", false);
                _this5.$store.commit('SELECTED_TAB', 'betTab');
                return;
              }
              _this5.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this5.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this5.$store.getters.betForm
                  });
                  _this5.refreshTimer();
                  _this5.isReloading = false;
                }.bind(_this5)
              });
            }.bind(this)
          });
        } else {
          this.$store.dispatch("removeMatch", {
            data: { eveid: eventid },
            callback: function () {
              document.getElementById(event.uniqueId).parentElement.classList.remove('active');
              _this5.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: eventid
              });
              if (_this5.betFormList.length <= 0) {
                _this5.$store.commit("OPEN_BETFORM", false);
                _this5.$store.commit('ODD_SELECTED', false);
                _this5.$store.commit("SHOW_BETFORM_MENU", false);
                _this5.$store.commit('SELECTED_TAB', 'betTab');
                return;
              }
              _this5.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this5.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this5.$store.getters.betForm
                  });
                  _this5.refreshTimer();
                  _this5.isReloading = false;
                }.bind(_this5)
              });
            }.bind(this)
          });
        }
      }
    },
    checkPendingWager: function checkPendingWager(pendingWagerIds) {
      var _this6 = this;

      var RBbtList = this.rbBetTypeList;

      var VUE = this;
      if (this.pendingTimerId == null) {
        this.pendingTimerId = setInterval(function () {
          if (pendingWagerIds.length > 0) {
            _this6.$store.dispatch('getPendingWager', {
              'wagerIds': pendingWagerIds,
              'isParlay': VUE.isMulp ? 1 : 0,
              'callback': function callback(res) {
                if (res) {
                  if (_this6.$store.getters.isBetCombo) {} else if (VUE.isMulp) {
                    var pending_flag = false;
                    var bettingData = VUE.betting.pending.data;
                    _.forEach(res.wagerList.data, function (value, key) {
                      var windex = _.findIndex(bettingData.mulpRes, { WagerID: value.wgNo });
                      if (windex > -1) {
                        bettingData.mulpRes[windex]['wgStatus'] = value.wgStatus;
                      }
                      if (value.wgStatus == '1') {
                        pending_flag = true;
                      }
                    }.bind(_this6));

                    if (pending_flag) {
                      _this6.$store.commit('BETTING_MESSAGE', {
                        isPending: true,
                        data: bettingData
                      });
                    } else {
                      _this6.$store.commit('BETTING_MESSAGE', {
                        isSuccess: true,
                        data: bettingData
                      });
                    }
                  } else {
                    var betData = res.wagerList.data[0];

                    var rbconfirm = $.inArray(betData.betTypId, RBbtList) > -1 ? '2' : '0';
                    var wgReject = _.findIndex(res.wagerList.data, { wgStatus: '-1' });
                    var wgSuccess = _.findIndex(res.wagerList.data, { wgStatus: rbconfirm });

                    if (wgReject > -1) {
                      _this6.$store.commit('BETTING_MESSAGE', {
                        isReject: true
                      });
                    } else if (wgSuccess > -1) {
                      _this6.$store.commit('BETTING_MESSAGE', {
                        isSuccess: true,
                        chkPendingSuccess: true,
                        data: VUE.betting.pending.data
                      });
                    }
                  }

                  _this6.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.wagerList.data,
                    oldBettingList: _this6.$store.getters.betForm,
                    chkPendingWager: 1
                  });
                }
              }
            });
          }
        }.bind(this), 5000);
      }
    },
    clearInput: function clearInput() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (key != null) {
        var arr = {
          index: key,
          amount: '',
          clear: false
        };
        if (this.$store.getters.isBetCombo) {
          this.betComboAmount = arr;
          var kdata = { index: key, settings: { min: true, med: true, big: true, big2: true, big3: true } };
          this.betComboKeyboardAllow = kdata;
        } else if (this.isMulp) {
          arr.stake = '';
          arr.possiblePayout = '';
          arr.allUp = this.$store.getters.betMulpAmount[key].allUp;
          this.betMulpAmount = arr;

          return;
        }
      } else if (key == null && mode == 'all') {
        var VUE = this;
        this.allBetComboAmount = '';

        var arr = { clear: true };
        VUE.betComboAmount = arr;
        VUE.betComboKeyboardAllow = arr;
        VUE.resetKeyboardAllow();
      } else {
        this.betAmount = '';
      }

      this.possiblePayout;
    },
    showProcessBet: function showProcessBet() {
      if (!this.isProcessBet) {
        var minMaxValidation = this.jsMinMaxValidation(this.$store.getters.betAmount, this.isMulp);
        if (minMaxValidation.error) {
          this.$store.commit('JS_ERR', minMaxValidation);

          if (minMaxValidation.errorId == 1) {
            this.$store.getters.betAmount = Math.round(this.account.currCL);
          } else if (minMaxValidation.errorId == 2) {
            this.$store.getters.betAmount = Math.round(this.betting.minMax.min);
          } else if (minMaxValidation.errorId == 3) {
            this.$store.getters.betAmount = Math.round(this.betting.minMax.max);
          }
          var vue = this;
          setTimeout(function () {
            vue.$store.commit('JS_ERR', '');
          }, 5000);
        } else {
          this.$store.commit('JS_ERR', '');

          this.checkOrder();
          if (this.betting.sErr) {
            this.betting.sErr = '';
          }
          this.$store.commit('PROCESS_BET', true);
          $('#submitBet').focus();
        }
      } else if (this.isProcessBet) {
        this.checkOrder();
        this.$store.commit('PROCESS_BET', false);
      }
    },
    checkError: function checkError(errMsg) {
      if (errMsg) {
        this.$store.commit('PLACED_BET', false);
        this.$store.commit('PROCESS_BET', false);
        return errMsg;
      }
    },
    h1x2Header: function h1x2Header(hdp, team) {
      if (team == 'a') {
        if (hdp > 0) {
          return ' +' + parseInt(hdp);
        } else if (hdp < 0) {
          return parseInt(hdp);
        }
      } else if (team == 'b') {
        var nhdp = parseInt(hdp) * -1;
        var ahdp = '';

        if (nhdp > 0) {
          ahdp = '+' + nhdp;
        } else if (nhdp < 0) {
          ahdp = nhdp;
        }

        return ahdp;
      } else if (team == 'x') {
        if (hdp > 0) {
          return this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' +' + parseInt(hdp);
        } else if (hdp < 0) {
          var nhdp = parseInt(hdp) * -1;
          var ahdp = '';

          if (nhdp > 0) {
            ahdp = '+' + nhdp;
          } else if (nhdp < 0) {
            ahdp = nhdp;
          }
          return this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' ' + ahdp;
        }
      }
    },
    modifyTitle: function modifyTitle(odds) {
      var title = this.sportAllBetLang["ALL_BET.LBL_WIN_BY_26MORE"];
      if (odds == 'h_26_x' || odds == 'a_26_x') {
        return title.replace('26', '26+');
      }
    },
    resetKeyboardAllow: function resetKeyboardAllow() {
      this.keyboardAllow = {
        min: true,
        med: true,
        big: true,
        big2: true,
        big3: true
      };
    },
    confirmBetForm: function confirmBetForm(event) {
      var _this7 = this;

      var vue = this;
      var errArr = [];

      if (!this.$store.getters.isBetCombo) {
        var minMaxValidation = this.jsMinMaxValidation(this.$store.getters.sportMiniBet.betAmount, this.isMulp);
      } else {
        var betAmountArr = this.$store.getters.betComboAmount;
        var amt = '';
        var minMaxValidation = {};
        var ttlAmt = 0;

        $.each(betAmountArr, function (id, data) {
          amt = data.value == '' ? 0 : data.value.replace(",", "");
          ttlAmt += parseInt(amt);
          var validation = vue.jsMinMaxValidation(amt, vue.isMulp);
          errArr[id] = { error: false };
          if (validation.error) {
            minMaxValidation = validation;
            errArr[id] = validation;
          }
        });

        var minMaxValidationSUM = vue.jsMinMaxValidation(ttlAmt, vue.isMulp);
        if (minMaxValidationSUM.error) {
          vue.$store.commit('JS_ERR', minMaxValidationSUM);
          setTimeout(function () {
            vue.$store.commit('JS_ERR', '');
          }, 5000);
          return;
        }
      }

      if (!minMaxValidation.error) {
        this.$store.commit('PROCESS_BET', true);
        this.$store.dispatch("confirmBet", {
          callback: function (res) {
            if (_this7.$store.getters.isBetCombo) {
              _this7.betFormHeight();
            }
            _this7.$store.commit('PROCESS_BET', false);
            _this7.startTimer();
          }.bind(this)
        });
        this.$store.commit('PLACED_BET', true);
      } else {
        if (!this.$store.getters.isBetCombo) {
          this.$store.commit('JS_ERR', minMaxValidation);

          if (minMaxValidation.errorId == 1) {
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.account.currCL);
          } else if (minMaxValidation.errorId == 2) {
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.min);
          } else if (minMaxValidation.errorId == 3) {
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.max);
          }
        } else {
          this.$store.commit('BETCOMBO_JS_ERR', errArr);
          var a = '';
          var _betAmountArr2 = this.$store.getters.betComboAmount;
          $.each(_betAmountArr2, function (idx, val) {
            if (errArr[idx] && errArr[idx].error) {
              if (errArr[idx].errorId == 1) {
                a = Math.round(vue.account.currCL);
              } else if (errArr[idx].errorId == 2) {
                a = Math.round(vue.betting.minMax.min);
              } else if (errArr[idx].errorId == 3) {
                a = Math.round(vue.betting.minMax.max);
              }
              var arr = { index: idx, amount: a, clear: false };
              vue.$store.commit("BETCOMBO_AMOUNT", arr);
            }
          });
        }

        setTimeout(function () {
          vue.$store.commit('JS_ERR', '');
          if (vue.$store.getters.isBetCombo) {
            vue.$store.commit('BETCOMBO_JS_ERR', {});
          }
        }, 5000);
      }
    },
    isSportValidPromo: function isSportValidPromo(eventObj, bt) {
      var result = false;
      this.$store.dispatch("isSportValidPromo", {
        eventObj: eventObj,
        bt: bt,
        callback: function (res) {
          result = res;
        }.bind(this)
      });
      return result;
    },
    checkMaxOdds: function checkMaxOdds(index) {
      var ret = this.countMaxOdds(index);

      if (ret == true) {
        this.$store.commit('DISABLE_BET', false);
      }
      return ret;
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    var element = document.querySelector("#leftBarNormalScroll");

    if (element) {
      var observer = new MutationObserver(this.handleResize);
      var config = { attributes: true, childList: true, subtree: true };
      observer.observe(element, config);
    }

    var Vue = this;
    $('#singleContainer').niceScroll({
      horizrailenabled: false,
      autohidemode: true,
      scrollbarid: 'singleContainerScrollbar',
      cursorborder: "0px solid #fff",
      zindex: 45,
      railoffset: { left: -5 },
      cursordragontouch: true
    });


    this.$store.commit("SELECTED_BETTAB", false);
    if (!this.betting.error) {
      this.betMinMax();
    }
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("stopBettingTimer", function (res) {
      _this8.clearTimer();
    });

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("clearAllBetComboAmount", function () {
      _this8.allBetComboAmount = '';
    });
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("resetKeyboard", function () {
      _this8.resetKeyboardAllow();
    });
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("cancelBetForm", function () {
      _this8.cancelBetForm();
    });
    if (this.oddSelected) {
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit("initBettingTimer");
    }
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("processBet", function () {
      _this8.showProcessBet();
      if (_this8.isProcessBet) {
        _this8.checkOrder();
      } else {
        _this8.checkOrder();
      }
    });

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("setBetMulpAmount", function (res) {
      _this8.betMulpAmount = res;
    });
  },
  beforeUnmount: function beforeUnmount() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("stopBettingTimer");
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("initBettingTimer");
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("cancelBetForm");
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("processBet");
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("clearAllBetComboAmount");
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("resetKeyboard");

    this.clearTimer();
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_mixins_favourite__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_accounting__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(0);













/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__vue_mixins_favourite__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(["oddSelected", "BetTypeLang", "selectedBettype", "betForm", "betting", "requestAllow", "selectedSport", "account", "selectedMarket", 'isBetSuccess', 'isProcessBet', 'isPlacedBet', 'pendingFlag', 'hdpDisp', 'mulpSetting', 'jsError', 'sportForecastToggle', 'sportMiniBet', 'betFormHdpChange', 'betFormOddChange', 'isBetCombo', 'promotionDetails', 'promotionFlag', 'promotionBetStatus', 'promotionShowJoinSuccess', 'wgHdpOddNoChgIndex', 'allowErrBetAgain', 'betMulpAmount', 'disableBet', 'selectedMulpBetBoxId']), {
    selectedMarket: function selectedMarket() {
      return this.$store.getters.selectedMarket;
    },

    autoAccBetterOdd: {
      get: function get() {
        return this.$store.getters.account.autoAccBetterOdd;
      },
      set: function set(value) {
        var account = this.$store.getters.account;
        account.autoAccBetterOdd = value;
        this.$store.commit("ACCOUNT", account);
      }
    },
    rememberStake: {
      get: function get() {

        return this.$store.getters.account.rememberStake;
      },
      set: function set(value) {
        var _this = this;

        var b = '';
        if (__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting')) {
          b = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
        }

        if (b == '' || b && (b.rmbStk != value || b.stkAmt != this.$store.getters.sportMiniBet.betAmount)) {
          var stkset = {
            rmbStk: value,
            stkAmt: this.$store.getters.sportMiniBet.betAmount
          };
          var rmbstkVal = value;
          $.ajax({
            method: 'post',
            url: _baseUrl + '/callCookies',
            data: {
              action: 'rememberStk',
              stkSetting: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(stkset),
              acc_code: this.$store.getters.account.acccode
            }
          }).done(function (res) {
            var account = _this.$store.getters.account;
            account.rememberStake = rmbstkVal;
            _this.$store.commit("ACCOUNT", account);
          });
        }
      }
    },
    possiblePayout: function possiblePayout() {
      var oddValue = "";
      if (this.isMulp) {
        var amount = 0;

        var allUpIndex = _.findIndex(this.betting.allUpList, {
          key: this.$store.getters.betting.selectedBetAllup
        });
        var mulpParser = this.betting.allUpList[allUpIndex].parser.split("#");
        for (var index = 0; index < mulpParser.length; index++) {
          var commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (var comma = 0; comma < commaList.length; comma++) {
            var betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if (this.$store.getters.account.oddsType == 'am') {
              if (betOdd < 0) {
                betOdd = Math.abs(100 / betOdd) + 1;
              } else {
                betOdd = betOdd / 100 + 1;
              }

              betOdd = betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          amount += this.$store.getters.sportMiniBet.betAmount * oddValue;
        }

        return amount;
      } else {
        var betOdd = parseFloat(this.$store.getters.betForm[0].odd);
        oddValue = betOdd < 0 && (this.$store.getters.account.oddsType == 'my' || this.$store.getters.account.oddsType == 'in') ? 1 : this.validateOddBetType(this.$store.getters.betForm[0].betType, this.$store.getters.betForm[0].odd);
      }
      return this.$store.getters.sportMiniBet.betAmount * oddValue;
    },

    betAmount: function betAmount() {
      var fixedAccountingNumber = __WEBPACK_IMPORTED_MODULE_6_accounting___default.a.toFixed(this.$store.getters.sportMiniBet.betAmount, 0);
      return this.commasAmount(fixedAccountingNumber);
    }
  }),
  props: {},
  data: function data() {
    var _ref;

    return _ref = {
      isNegative: false,
      isDiff: false,
      isMulp: false,
      timerSeconds: 10,
      fixTimer: 10,
      timerId: null,
      pendingTimerId: null,
      isReloading: false,
      isJustRecheck: false,
      isFirstLoad: true,
      selectedLang: window._langid,

      wagerId: null,
      pendingWager: {
        data: null,
        status: false
      },
      isMulpDayExceed: false,
      totalStake: 0,
      totalBet: 0,
      langList: window.lang
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "isMulp", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "rememberStakeVal", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mulpJsErr", {
      'error': false,
      'msg': ''
    }), _ref;
  },

  watch: {
    betForm: {
      handler: function handler(val, oldVal) {
        var vue = this;
        if (this.selectedBettype.betTypId == "5" || this.$store.getters.isBetParlay) {
          this.isMulp = true;
          if (val && val.length > 0) {
            vue.$store.commit('BETFORM_HDPCHG', false);
            vue.$store.commit('BETFORM_ODDCHG', false);
            _.forEach(val, function (arr, key) {
              if (arr.oddChg) {
                vue.$store.commit('BETFORM_ODDCHG', true);
                return;
              } else if (arr.hdpChg) {
                vue.$store.commit('BETFORM_HDPCHG', true);
                return;
              }
            });
          }
        } else {
          this.isMulp = false;
        }
      },
      deep: true,
      immediate: true
    },
    betAmount: {
      handler: function handler(value, oldVal) {

        if (this.selectedBettype.betTypId == "5" && this.$store.getters.betting.selectedBetAllup != null) {
          var totalBetSlip = this.$store.getters.betting.selectedBetAllup.split('x');
          if (this.betAmount && this.$store.getters.sportMiniBet.betAmount > 0) {
            this.totalStake = this.$store.getters.sportMiniBet.betAmount * totalBetSlip[1];
          } else {
            this.totalStake = 0;
          }

          this.totalBet = totalBetSlip[1];
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    clearInvalidBetCombo: function clearInvalidBetCombo() {
      var _this2 = this;

      this.$store.commit('BETCOMBO_MESSAGE', { isClearErr: true });
      this.$store.dispatch("removeMatch", {
        data: { clearType: '1' },
        callback: function () {
          if (_this2.betForm.length <= 0) {
            _this2.cancelBetForm();
            return;
          }
          _this2.$store.dispatch("getBettingInfo", {
            callback: function (res) {
              _this2.$store.commit("SPORT_MAPPING_BETTING", {
                newBettingList: res.SYSTEM_DATA.betting,
                oldBettingList: _this2.$store.getters.betForm
              });
              _this2.refreshTimer();
              _this2.isReloading = false;
            }.bind(_this2)
          });
        }.bind(this)
      });
    },
    minComboCaption: function minComboCaption() {
      return this.betLang["BETTING.LBL_MIN_COMBO"].replace('{minCombo}', this.betting.minMax.minCombo);
    },
    getSubmitStyle: function getSubmitStyle() {
      var s = '';
      if (this.betFormOddChange || this.betFormHdpChange) {
        s = 'bet-accpet';
      } else if (this.betting.error || this.betting.betcomboerror) {
        s = 'bet-submit2';
      } else if (!this.betting.success && !this.betFormOddChange && !this.betFormHdpChange) {
        s = 'bet-submit';
      }
      return s;
    },
    closeBetForm: function closeBetForm() {
      this.$store.commit('SPORT_MINIBET_TOGGLE', false);

      this.$store.commit("OPEN_BETFORM", false);


      this.$store.commit('ODD_SELECTED', false);
      this.$store.commit("SHOW_BETFORM_MENU", false);
      this.$store.commit('SELECTED_TAB', 'betTab');
      this.$store.commit("REMOVE_MATCH", { removeAll: true });
      this.$store.commit('BETTING_MESSAGE', { isPending: false });
      this.$store.commit("BETCOMBO_MESSAGE", { isClear: true });
      this.$store.commit("BETCOMBO_AMOUNT", { resetBetComboAmount: true });
      this.$store.commit("BETMULP_AMOUNT", { resetBetMulpAmount: true });
      this.$store.commit("BETMULP_AMOUNT_FILTERED", []);

      $('div.c-bet-item').removeClass('active');
    },
    retainSelection: function retainSelection() {
      var _this3 = this;

      if (!this.$store.getters.isBetCombo) {
        this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
        this.$store.commit('BETTING_MESSAGE', { isError: false });
        this.$store.commit("BETMULP_AMOUNT", { resetBetMulpAmount: true });
        this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
      } else {
        var arr = { clear: true };
        var VUE = this;
        this.$store.commit("BETCOMBO_AMOUNT", arr);
        this.$store.commit("BETCOMBO_MESSAGE", { isClear: true });

        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('clearAllBetComboAmount');


        this.$store.dispatch("removeMatch", {
          data: { clearType: '1' },
          callback: function () {
            if (_this3.betForm.length <= 0) {
              _this3.cancelBetForm();
              return;
            }
          }.bind(this)
        });
      }
      this.$store.commit('ODD_SELECTED', true);
      this.$store.commit('CLEAR_BET_SUCCESS');
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('stopBettingTimer');
      this.$store.commit('BETTING_MESSAGE', { isPending: false });

      this.$store.dispatch("getBettingInfo", {
        isRetainSel: true,
        callback: function (res) {
          _this3.$store.commit("SPORT_MAPPING_BETTING", {
            newBettingList: res.SYSTEM_DATA.betting,
            oldBettingList: _this3.$store.getters.betForm
          });
          _this3.refreshTimer();
          _this3.isReloading = false;
        }.bind(this)
      });
    },
    getStyleTop: function getStyleTop() {
      var _this4 = this;

      var screenHeight = $(window).height();
      var topY;
      if (this.isUsingPhone() === 0) {
        var scrFooter = document.getElementById('scrollFooter');
        if (this.$store.getters.isBetCombo) {
          scrFooter.style.position = 'absolute';
          scrFooter.style.bottom = 0;
          scrFooter.style.top = null;
        } else {
          this.$nextTick(function () {
            if (_this4.selectedBettype.betTypId == "5") {
              if (_this4.$store.getters.betForm.length > 2) {
                topY = $('#normalScroll').height();
              } else if (_this4.$store.getters.betForm.length == 1) {
                topY = $('#scrollHeaderX').height() + $('#normal-middle-content').height();
              } else if (_this4.$store.getters.betForm.length == 2) {
                topY = screenHeight <= 765 ? $('#mulpBetArea').height() : $('#scrollHeaderX').height() + $('#normal-middle-content').height();
              }
            } else {
              var topY;
              if (screenHeight <= 765) {
                topY = document.querySelector('.bet-confirm-message') ? $('#normalScroll').height() - 10 : $('#normalScroll').height();
              } else {
                topY = $('#normal-middle-content').height() + $('#scrollHeaderX').height();
              }
            }
            document.getElementById('scrollFooter').style.top = topY + 'px';
          });
        }
      }
      $("#leftBarNormalScroll").getNiceScroll().resize();
    },
    getDecimalDisplay: function getDecimalDisplay(value) {
      if (this.$store.getters.account.oddsType == 'am') {
        return parseFloat(value).toFixed(0);
      }
      return parseFloat(value).toFixed(2);
    },
    convertDate: function convertDate(val) {
      return new __WEBPACK_IMPORTED_MODULE_7_moment___default.a(val).format("MM-DD");
    },
    allupBetting: function allupBetting(allup, betLang, selectedLang) {
      var str = "";
      if (mulpSetting[allup]) {
        var ccBr = 0;
        $.each(mulpSetting[allup], function (listup, cbet) {
          var ssAdd = "";
          if (selectedLang == 1 && parseInt(cbet) > 1) {
            ssAdd = "s";
          }
          if (betLang["BETTING.LBL_PARLAY_" + listup]) {
            if (ccBr != 0) str += "<br>";
            str += " > " + betLang["BETTING.LBL_PARLAY_" + listup] + " (" + cbet + " " + betLang["BETTING.LBL_PARLAY_BET"] + ssAdd + ")";
            ccBr = 1;
          }
        });
      }
      return str;
    },
    onClickStartTimer: function onClickStartTimer() {
      var _this5 = this;

      if (!this.isJustRecheck) {
        this.isJustRecheck = false;
        this.timerSeconds = this.fixTimer;
        this.$store.dispatch("getBettingInfo", {
          token: token.arr_5,
          callback: function (res) {
            _this5.$store.commit("SPORT_MAPPING_BETTING", {
              newBettingList: res.SYSTEM_DATA.betting,
              oldBettingList: _this5.$store.getters.betForm
            });
            _this5.refreshTimer();
            _this5.isReloading = false;
          }.bind(this)
        });
      }
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
      clearInterval(this.pendingTimerId);
      this.timerId = null;
      this.pendingTimerId = null;
      this.timerSeconds = this.fixTimer;
    },
    refreshTimer: function refreshTimer() {
      this.timerSeconds = this.fixTimer;
    },
    startTimer: function startTimer() {
      var _this6 = this;

      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (_this6.timerSeconds - 1 < 0) {
            if (_this6.oddSelected && !_this6.isFirstLoad) {
              _this6.isReloading = true;
              _this6.$store.dispatch("getBettingInfo", {

                token: token.arr_1,
                callback: function (res) {
                  _this6.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this6.$store.getters.betForm
                  });

                  _this6.isReloading = false;
                }.bind(_this6)
              });
            }
            _this6.isFirstLoad = false;
          } else {
            if (!_this6.isReloading) {
              _this6.timerSeconds -= 1;
            }
          }
        }.bind(this), 1000);
      }
      return this.timerSeconds;
    },
    classNegative: function classNegative(odd) {
      return odd < 0 ? true : false;
    },
    cancelMiniBet: function cancelMiniBet() {
      this.$store.commit("SPORT_MINIBET_TOGGLE", false);
    },
    printBetForm: function printBetForm() {
      window.print();
    },
    cancelBetForm: function cancelBetForm() {
      if (this.betFormOddChange || this.betFormHdpChange || this.$store.getters.allowErrBetAgain) {
        this.$store.commit('BETFORM_HDPCHG', false);
        this.$store.commit('BETFORM_ODDCHG', false);
        this.$store.commit('ALLOW_ERR_BET_AGAIN', false);
      }
      if (this.$store.getters.sportMiniBet.toggle) {
        this.cancelMiniBet();
      }
      $('div.c-bet-item.active').removeClass('active');
      $('div.c-bet-item.yb-family-odds').removeClass('active');
      if (this.selectedBettype.betTypId == "5") {
        this.$store.commit("PARLAY_SELECTED", null);
      } else if (this.$store.getters.isBetCombo) {
        this.$store.commit("BETCOMBO_MESSAGE", { isClear: true });
      }
      this.$store.commit("BETTING_DELAY_TIMERID", null);
      this.$store.commit("REMOVE_MATCH", { removeAll: true });
      this.$store.commit("ODD_SELECTED", false);

      this.$store.commit('SELECTED_TAB', 'betTab');
      this.$store.commit("OPEN_BETFORM", false);
      this.$store.commit("SHOW_BETFORM_MENU", false);
      this.$store.commit("BETTING_MESSAGE", {
        isError: false
      });
      this.$store.commit("JS_ERR", '');
      this.$store.commit("BETCOMBO_AMOUNT", { resetBetComboAmount: true });
      this.$store.commit("BETMULP_AMOUNT", { resetBetMulpAmount: true });
      this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    confirmBetForm: function confirmBetForm(event) {
      var _this7 = this;

      var vue = this;
      var errArr = [];
      this.$store.commit('PROMO_BET_INDEX', []);
      this.$store.commit('PROMO_SHOW_JOIN_SUCCESS', false);
      this.$store.commit('PROMO_BET_WITHOUT_JOIN', false);
      this.$store.commit('SHOW_BETFORM_MENU', false);

      if (!this.$store.getters.miniNormal && this.$store.getters.sportMiniBet.toggle) {
        this.$store.commit('SPORT_MINIBET_TOGGLE', false);
      }
      if (!this.$store.getters.miniNormal) {
        $('#normalScroll').scrollTop(0);
      }

      if (!this.$store.getters.isBetCombo && !this.isMulp) {
        var inputAmt = $('.bet-input').val();
        if (inputAmt != '') {
          var modAmt = inputAmt.replace(',', '');
          if (modAmt != this.$store.getters.sportMiniBet.betAmount) {
            var minMaxValidation = this.jsMinMaxValidation(modAmt, this.isMulp);
          } else {
            var minMaxValidation = this.jsMinMaxValidation(this.$store.getters.sportMiniBet.betAmount, this.isMulp);
          }

          if (this.$store.getters.promotionFlag && !this.isMulp && !this.$store.getters.promotionBetStatus && this.isSportValidPromo(this.$store.getters.betForm[0].eventObj, this.$store.getters.betForm[0].betType)) {
            if (parseFloat(this.$store.getters.sportMiniBet.betAmount) < parseFloat(this.$store.getters.promotionDetails.min_bet)) {
              this.$store.commit('PROMO_BET_WITHOUT_JOIN', true);
            } else {
              var promoBetIndex = [0];
              this.$store.commit('PROMO_BET_INDEX', promoBetIndex);
            }
          }
        } else {
          var minMaxValidation = this.jsMinMaxValidation(this.$store.getters.sportMiniBet.betAmount, this.isMulp);
        }
      } else if (this.isMulp) {
        var betMulpArr = this.$store.getters.betMulpAmount;
        var minMaxValidation = {};
        var ttlAmt = 0;
        var betMulpArrFiltered = [];

        $.each(betMulpArr, function (index, data) {
          var allUp = data.allUp;
          var amt = data.value == '' ? 0 : data.value.replaceAll(",", "");
          var stk = data.stake == '' ? 0 : data.stake.replaceAll(",", "");
          var pp = data.possiblePayout == '' ? 0 : data.possiblePayout.replaceAll(",", "");
          ttlAmt += parseInt(stk);
          if (parseInt(amt) != 0) {
            betMulpArrFiltered.push({
              'allUpKey': allUp,
              'amount': amt,
              'stake': stk,
              'possiblePayout': pp
            });
            var validation = vue.jsMinMaxValidation(amt, vue.isMulp, allUp);
            errArr[index] = { error: false };
            if (validation.error) {
              minMaxValidation = validation;
              errArr[index] = validation;
            }
          }
        });
        this.$store.commit('BETMULP_AMOUNT_FILTERED', betMulpArrFiltered);

        var minMaxValidationSUM = vue.jsMinMaxValidation(ttlAmt, vue.isMulp);
        if (minMaxValidationSUM.error) {

          if (minMaxValidation.error) {
            var a = '';
            $.each(betMulpArr, function (idx, val) {
              if (errArr[idx] && errArr[idx].error) {
                if (errArr[idx].errorId == 1) {
                  a = Math.round(vue.account.currCL);
                } else if (errArr[idx].errorId == 2) {
                  a = Math.round(vue.betting.minMax.min);
                } else if (errArr[idx].errorId == 3) {
                  a = Math.round(val.maxPay);
                }
                var arr = { index: idx, allUp: val.allUp, amount: a };
                __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('setBetMulpAmount', arr);
              }
            });
          }

          this.mulpJsErr = {
            'error': minMaxValidationSUM.error,
            'msg': minMaxValidationSUM.msg
          };
          setTimeout(function () {
            vue.mulpJsErr = {
              'error': false,
              'msg': ''
            };
          }, 5000);
          return;
        }
      } else {
        var _betAmountArr = this.$store.getters.betComboAmount;
        var amt = '';
        var minMaxValidation = {};
        var ttlAmt = 0;

        if ((this.betFormOddChange || this.betFormHdpChange || this.$store.getters.allowErrBetAgain) && this.$store.getters.wgHdpOddNoChgIndex.length > 0) {
          var wgHdpOddNoChgIndex_temp = this.$store.getters.wgHdpOddNoChgIndex.sort().reverse();
          $.each(wgHdpOddNoChgIndex_temp, function (id, data) {
            vue.$store.commit('BETCOMBO_AMOUNT', { spliceIndex: true, index: data });
            vue.$store.commit('REMOVE_MATCH', data);
          });
          _betAmountArr = this.$store.getters.betComboAmount;
          wgHdpOddNoChgIndex_temp = [];
          this.$store.commit('SET_MATCH_INDEX_NO_ERR', wgHdpOddNoChgIndex_temp);
        }

        $.each(_betAmountArr, function (id, data) {
          amt = data.value == '' ? 0 : data.value.replace(",", "");
          ttlAmt += parseInt(amt);
          var validation = vue.jsMinMaxValidation(amt, vue.isMulp);
          errArr[id] = { error: false };
          if (validation.error) {
            minMaxValidation = validation;
            errArr[id] = validation;
          }
        });

        var minMaxValidationSUM = vue.jsMinMaxValidation(ttlAmt, vue.isMulp);
        if (minMaxValidationSUM.error) {
          vue.$store.commit('JS_ERR', minMaxValidationSUM);
          setTimeout(function () {
            vue.$store.commit('JS_ERR', '');
          }, 5000);
          return;
        }

        if (this.$store.getters.promotionFlag && !this.isMulp && !this.$store.getters.promotionBetStatus) {
          var promoBetIndex = [];

          $.each(_betAmountArr, function (id, data) {
            amt = data.value == '' ? 0 : data.value.replace(",", "");
            if (vue.$store.getters.betForm[id] != undefined && vue.isSportValidPromo(vue.$store.getters.betForm[id].eventObj, vue.$store.getters.betForm[id].betType)) {
              if (parseFloat(amt) >= parseFloat(vue.$store.getters.promotionDetails.min_bet)) {
                promoBetIndex.push(id);
              }
            }
          });
          if (promoBetIndex.length > 0) {
            this.$store.commit('PROMO_BET_INDEX', promoBetIndex);
          } else {
            this.$store.commit('PROMO_BET_WITHOUT_JOIN', true);
          }
        }
      }

      if (!minMaxValidation.error) {
        this.$store.commit('PROCESS_BET', true);
        this.$store.dispatch("confirmBet", {
          callback: function (res) {
            if (_this7.$store.getters.isBetCombo) {
              _this7.betFormHeight();
            }
            _this7.$store.commit('PROCESS_BET', false);
            _this7.startTimer();
          }.bind(this)
        });
        this.$store.commit('PLACED_BET', true);
      } else {
        if (!this.$store.getters.isBetCombo && !this.isMulp) {
          this.$store.commit('JS_ERR', minMaxValidation);

          if (minMaxValidation.errorId == 1) {
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.account.currCL);
          } else if (minMaxValidation.errorId == 2) {
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.min);
          } else if (minMaxValidation.errorId == 3) {
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.max);
          }
        } else {
          var betAmountArr = this.$store.getters.betComboAmount;
          if (vue.isMulp) {
            betAmountArr = this.$store.getters.betMulpAmount;
          }
          var a = '';
          $.each(betAmountArr, function (idx, val) {
            if (errArr[idx] && errArr[idx].error) {
              if (errArr[idx].errorId == 1) {
                a = Math.round(vue.account.currCL);
              } else if (errArr[idx].errorId == 2) {
                a = Math.round(vue.betting.minMax.min);
              } else if (errArr[idx].errorId == 3) {
                a = Math.round(vue.betting.minMax.max);
                if (this.isMulp) {
                  a = Math.round(val.maxPay);
                }
              }
              if (vue.isMulp) {
                var arr = { index: idx, allUp: val.allUp, amount: a };
                __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('setBetMulpAmount', arr);
              } else {
                var arr = { index: idx, amount: a, clear: false };
                vue.$store.commit("BETCOMBO_AMOUNT", arr);
              }
            }
          });
          if (this.isMulp) {
            this.mulpJsErr = {
              'error': minMaxValidation.error,
              'msg': minMaxValidation.msg
            };
          } else {
            this.$store.commit('BETCOMBO_JS_ERR', errArr);
          }
        }

        this.$nextTick(function () {
          if (_this7.selectedBettype.betTypId == "5") {
            $('.bet-input')[_this7.selectedMulpBetBoxId].focus();
          } else if (_this7.$store.getters.isBetCombo) {
            $('.bet-input').focus();
          } else {
            $('.bet-input')[0].focus();
          }
        });

        setTimeout(function () {
          vue.$store.commit('JS_ERR', '');
          if (vue.$store.getters.isBetCombo) {
            vue.$store.commit('BETCOMBO_JS_ERR', {});
          }
          vue.mulpJsErr = {
            'error': false,
            'msg': ''
          };
        }, 5000);
      }
    },
    checkPendingWager: function checkPendingWager(wagerId) {
      var _this8 = this;

      if (this.pendingTimerId == null) {
        if (this.pendingFlag) {
          this.$store.dispatch("getPendingWager", {
            wagerIds: [wagerId],
            callback: function callback(res) {
              if (res) {
                if (res.wagerList.data[0]["wgStatus"] != "1") {
                  _this8.$store.commit('PENDING_FLAG', false);
                  if (parseInt(res.wagerList.data[0]["wgStatus"]) < 0) {
                    _this8.pendingWager.data = res.wagerList.data[0];
                  }
                }
              }
            }
          });
        }
      }
    },
    showAutoInfo: function showAutoInfo() {
      if (this.$store.getters.account.oneWallet == "1") {
        if (this.$store.getters.account.oddsType == "my" || this.$store.getters.account.oddsType == "in" || this.$store.getters.account.oddsType == "am") {
          this.autoAccBetterOdd = false;
          return false;
        }
      }
      return true;
    },
    showProcessBet: function showProcessBet() {
      if (!this.isProcessBet) {
        var minMaxValidation = this.jsMinMaxValidation(this.$store.getters.sportMiniBet.betAmount, this.isMulp);
        if (minMaxValidation.error) {
          this.$store.commit('JS_ERR', minMaxValidation);

          var vue = this;
          setTimeout(function () {
            vue.$store.commit('JS_ERR', '');
          }, 5000);
        } else {
          this.$store.commit('JS_ERR', '');
          $('#checkOrder').removeAttr('checked');
          this.checkOrder();
          if (this.betting.sErr) {
            this.betting.sErr = '';
          }
          this.$store.commit('PROCESS_BET', true);
          $('#submitBet').focus();
        }
      } else if (this.isProcessBet) {
        $('#checkOrder').attr('checked', 'checked');
        this.checkOrder();
        this.$store.commit('PROCESS_BET', false);
      }
    },
    checkError: function checkError(errMsg) {
      if (errMsg) {
        this.$store.commit('PLACED_BET', false);
        this.$store.commit('PROCESS_BET', false);
        return errMsg;
      }
    },
    h1x2Header: function h1x2Header(hdp, team) {
      if (team == 'a') {
        if (hdp > 0) {
          return ' +' + parseInt(hdp);
        } else if (hdp < 0) {
          return parseInt(hdp);
        }
      } else if (team == 'b') {
        var nhdp = parseInt(hdp) * -1;
        var ahdp = '';

        if (nhdp > 0) {
          ahdp = '+' + nhdp;
        } else if (nhdp < 0) {
          ahdp = nhdp;
        }

        return ahdp;
      } else if (team == 'x') {
        if (hdp > 0) {
          return this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' +' + parseInt(hdp);
        } else if (hdp < 0) {
          var nhdp = parseInt(hdp) * -1;
          var ahdp = '';

          if (nhdp > 0) {
            ahdp = '+' + nhdp;
          } else if (nhdp < 0) {
            ahdp = nhdp;
          }
          return this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' ' + ahdp;
        }
      }
    },
    modifyTitle: function modifyTitle(odds) {
      var title = this.sportAllBetLang["ALL_BET.LBL_WIN_BY_26MORE"];
      if (odds == 'h_26_x' || odds == 'a_26_x') {
        return title.replace('26', '26+');
      }
    },
    isSportValidPromo: function isSportValidPromo(eventObj, bt) {
      var result = false;
      this.$store.dispatch("isSportValidPromo", {
        eventObj: eventObj,
        bt: bt,
        callback: function (res) {
          result = res;
        }.bind(this)
      });
      return result;
    },
    getBetConfirmClass: function getBetConfirmClass() {
      if (this.betting.success || this.betting.betcombosuccess) {
        return 'bet-success-order';
      } else if (this.betting.pending) {
        return 'bet-pending-order';
      } else {
        return 'bet-fail-order';
      }
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this9 = this;

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("betSlipCss", function (res) {
      _this9.getStyleTop();
    });
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("initBettingTimer", function (res) {
      _this9.clearTimer();
      _this9.startTimer();
      _this9.pendingWager.data = null;

      _this9.$store.commit('PENDING_FLAG', false);
    });
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("cancelBetForm", function () {
      _this9.cancelBetForm();
    });
    if (this.oddSelected) {
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit("initBettingTimer");
    }
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on("processBet", function () {
      _this9.showProcessBet();
      if (_this9.isProcessBet) {
        _this9.checkOrder();
      } else {
        _this9.checkOrder();
      }
    });
    if (!this.$store.getters.sportMiniBet.toggle) {
      this.getStyleTop();
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("stopBettingTimer");
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("betSlipCss");
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("initBettingTimer");
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("cancelBetForm");
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off("processBet");

    this.clearTimer();
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_betSlipForm_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ef9996_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_betSlipForm_vue__ = __webpack_require__(320);
function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47ef9996"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_betSlipForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ef9996_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_betSlipForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_mixins_wagersMixins__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__events_event_bus__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__vue_mixins_wagersMixins__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['account', 'betLang', 'statement', 'betLang', 'selectedMarket', 'BetTypeLang', 'betting', 'isPlacedBet', 'hdpDisp', 'sportAllBetLang', 'selectedBetListType', 'pendingFlag', 'selectedTab', 'langList', 'specialEventList'])),
    watch: {
        'statement': {
            handler: function handler(val, oldVal) {
                this.pendingWagerIds = _.map(_.filter(this.statement.last10wagerList, { wgStatus: '1' }), 'wgNo');
                this.checkPendingWager();
            },

            deep: true,
            immediate: true
        }
    },
    data: function data() {
        return {
            reloadingBet: true,
            pendingWagerIds: null,
            pendingTimerId: null,
            hover: false,
            isOpen: false,
            waitingTimer: 10,
            fixTimer: 5
        };
    },

    methods: {
        getDecimalDisplay: function getDecimalDisplay(otid, value) {
            if (otid == '6') {
                return parseFloat(value).toFixed(0);
            }

            return Math.floor(parseFloat(value) * 100) / 100;
        },
        checkRunningBettype: function checkRunningBettype(bettype, sprtId) {
            if (this.rbettype.indexOf(bettype) < 0 || sprtId != '1') {
                return false;
            }
            return true;
        },
        checkPendingWager: function checkPendingWager() {
            var _this = this;

            if (this.pendingTimerId == null) {
                this.pendingTimerId = setInterval(function () {
                    if (_this.waitingTimer - 1 < 0) {
                        _this.waitingTimer = _this.fixTimer;
                        if (_this.pendingWagerIds.length > 0) {
                            _this.$store.dispatch('getPendingWager', {
                                'wagerIds': _this.pendingWagerIds,
                                'callback': function callback(res) {
                                    if (res) {
                                        for (var index = 0; index < res.wagerList.data.length; index++) {
                                            var wager = res.wagerList.data[index];
                                            if (wager.wgStatus != '1') {
                                                if (wager.wgStatus == '0' || wager.wgStatus == '2') {
                                                    _this.$store.commit('BETLIST_TYPE', 1);
                                                    __WEBPACK_IMPORTED_MODULE_6__events_event_bus__["a" /* default */].$emit('upWaitStatus');
                                                } else if (wager.wgStatus == '-1' || wager.wgStatus == '-2') {
                                                    _this.$store.commit('BETLIST_TYPE', 3);
                                                    __WEBPACK_IMPORTED_MODULE_6__events_event_bus__["a" /* default */].$emit('upWaitStatus');
                                                }
                                                _this.pendingWagerIds.splice(index, 1);
                                                var last10Index = _.findIndex(_this.statement.last10wagerList, { wgNo: wager.wgNo });
                                                _this.$set(_this.statement.last10wagerList, last10Index, wager);
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    } else {
                        _this.waitingTimer -= 1;
                    }
                }.bind(this), 1000);
            }
        },
        getLast10Bets: function getLast10Bets() {
            var _this2 = this;

            this.reloadingBet = true;
            this.$store.dispatch('getLast10Wager', {
                token: token.arr_5,
                last10Wager: true,
                callback: function (res) {
                    _this2.pendingWagerIds = _.map(_.filter(res.wagerList.data, { wgStatus: '1' }), 'wgNo');
                    _this2.checkPendingWager();
                    _this2.reloadingBet = false;
                    var mini = $('.sidebar-first').hasClass('mini');
                    if (mini) {
                        $('#betSlipForm').css('width', '17em');
                    }
                }.bind(this)
            });
        },
        showMulpDetails: function showMulpDetails(index) {
            this.$set(this.statement.last10wagerList[index], 'hide', !this.statement.last10wagerList[index].hide);
            var active = $('#' + index).hasClass('active');

            if (active) {
                $('#' + index).removeClass('active');
                this.isOpen = true;
            } else {
                $('#' + index).addClass('active');
                this.isOpen = false;
            }
        },
        isRB: function isRB(bt) {
            if ($.inArray(bt, this.rbettype) > -1) {
                return true;
            }
            return false;
        },
        drawTeamBet: function drawTeamBet(wager) {
            var display = wager.tbetCap;
            if (wager.betTypId == 2 || wager.betTypId == 9 || wager.betTypId == 46 || wager.betTypId == 47 || wager.betTypId == 48 || wager.betTypId == 49) {
                if (wager.tbet == 'over') {
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'];
                } else if (wager.tbet == 'under') {
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'];
                }
            } else if (wager.betTypId == 6 || wager.betTypId == 17) {
                var htft = wager.tbet.split("");
                if (htft[0] === 'h' && htft[1] === 'h') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_HOME'];
                } else if (htft[0] === 'h' && htft[1] === 'd') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_PUSH'];
                } else if (htft[0] === 'h' && htft[1] === 'a') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_AWAY'];
                } else if (htft[0] === 'd' && htft[1] === 'h') {
                    display = this.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_HOME'];
                } else if (htft[0] === 'd' && htft[1] === 'd') {
                    display = this.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_PUSH'];
                } else if (htft[0] === 'd' && htft[1] === 'a') {
                    display = this.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_AWAY'];
                } else if (htft[0] === 'a' && htft[1] === 'h') {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_HOME'];
                } else if (htft[0] === 'a' && htft[1] === 'd') {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_PUSH'];
                } else if (htft[0] === 'a' && htft[1] === 'a') {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_AWAY'];
                }
                return display;
            } else if (wager.betTypId == '19' || wager.betTypId == '20') {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'];
                } else if (wager.tbetid == 'hd' || wager.tbet == 'hd') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'];
                } else {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'];
                }
            } else if (wager.betTypId == 5 || wager.betTypId == 18) {
                if (wager.tbetid == '7' || wager.tbet == '7' || wager.tbetid == 'tg7' || wager.tbet == 'tg7') {
                    if (wager.plyTypId == 1) {
                        display = '7 +';
                    } else if (wager.plyTypId == 2) {
                        display = '3 +';
                    }
                }
            } else if (wager.tbetid == 'aos' || wager.tbet == 'aos') {
                display = 'AOS';
            } else if (wager.betTypId == 63 || wager.betTypId == 64) {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'hb' || wager.tbet == 'hb') {
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'da' || wager.tbet == 'da') {
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'db' || wager.tbet == 'db') {
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'aa' || wager.tbet == 'aa') {
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'ab' || wager.tbet == 'ab') {
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp;
                }
            } else if (wager.betTypId == 57 || wager.betTypId == 58) {
                if (wager.tbetid == 'ng0' || wager.tbet == 'ng0') {
                    display = '0';
                } else if (wager.tbetid == 'ng1' || wager.tbet == 'ng1') {
                    display = '1';
                } else if (wager.tbetid == 'ng2' || wager.tbet == 'ng2') {
                    display = '2';
                } else if (wager.tbetid == 'ng3' || wager.tbet == 'ng3') {
                    display = '3';
                } else if (wager.tbetid == 'ng4' || wager.tbet == 'ng4') {
                    display = '4';
                } else if (wager.tbetid == 'ng5' || wager.tbet == 'ng5') {
                    display = '5';
                } else if (wager.tbetid == 'ng6' || wager.tbet == 'ng6') {
                    display = '6+';
                }
            } else if (wager.betTypId == 65 || wager.betTypId == 66) {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES'];
                } else if (wager.tbetid == 'hb' || wager.tbet == 'hb') {
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO'];
                } else if (wager.tbetid == 'da' || wager.tbet == 'da') {
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES'];
                } else if (wager.tbetid == 'db' || wager.tbet == 'db') {
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO'];
                } else if (wager.tbetid == 'aa' || wager.tbet == 'aa') {
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES'];
                } else if (wager.tbetid == 'ab' || wager.tbet == 'ab') {
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO'];
                }
            } else if (wager.betTypId == 59 || wager.betTypId == 73) {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_ODD'];
                } else if (wager.tbetid == 'hb' || wager.tbet == 'hb') {
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_EVEN'];
                } else if (wager.tbetid == 'aa' || wager.tbet == 'aa') {
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_ODD'];
                } else if (wager.tbetid == 'ab' || wager.tbet == 'ab') {
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_EVEN'];
                }
            } else if (wager.betTypId == 60 || wager.betTypId == 61) {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES'];
                } else if (wager.tbetid == 'hb' || wager.tbet == 'hb') {
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO'];
                } else if (wager.tbetid == 'aa' || wager.tbet == 'aa') {
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES'];
                } else if (wager.tbetid == 'ab' || wager.tbet == 'ab') {
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO'];
                }
            } else if (wager.betTypId == 62) {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap;
                } else if (wager.tbetid == 'hb' || wager.tbet == 'hb') {
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap;
                } else if (wager.tbetid == 'aa' || wager.tbet == 'aa') {
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap;
                } else if (wager.tbetid == 'ab' || wager.tbet == 'ab') {
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap;
                }
            } else if (wager.betTypId == 67) {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap;
                } else if (wager.tbetid == 'hb' || wager.tbet == 'hb') {
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap;
                } else if (wager.tbetid == 'da' || wager.tbet == 'da') {
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap;
                } else if (wager.tbetid == 'db' || wager.tbet == 'db') {
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap;
                } else if (wager.tbetid == 'aa' || wager.tbet == 'aa') {
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap;
                } else if (wager.tbetid == 'ab' || wager.tbet == 'ab') {
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap;
                }
            } else if (wager.betTypId == 68 || wager.betTypId == 69) {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'hb' || wager.tbet == 'hb') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'da' || wager.tbet == 'da') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'db' || wager.tbet == 'db') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'aa' || wager.tbet == 'aa') {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp;
                } else if (wager.tbetid == 'ab' || wager.tbet == 'ab') {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp;
                }
            } else if (wager.betTypId == 70 || wager.betTypId == 71) {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES'];
                } else if (wager.tbetid == 'hb' || wager.tbet == 'hb') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO'];
                } else if (wager.tbetid == 'da' || wager.tbet == 'da') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES'];
                } else if (wager.tbetid == 'db' || wager.tbet == 'db') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO'];
                } else if (wager.tbetid == 'aa' || wager.tbet == 'aa') {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES'];
                } else if (wager.tbetid == 'ab' || wager.tbet == 'ab') {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO'];
                }
            } else if (wager.betTypId == 72) {
                if (wager.tbetid == 'ha' || wager.tbet == 'ha') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap;
                } else if (wager.tbetid == 'hb' || wager.tbet == 'hb') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap;
                } else if (wager.tbetid == 'da' || wager.tbet == 'da') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap;
                } else if (wager.tbetid == 'db' || wager.tbet == 'db') {
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap;
                } else if (wager.tbetid == 'aa' || wager.tbet == 'aa') {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap;
                } else if (wager.tbetid == 'ab' || wager.tbet == 'ab') {
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap;
                }
            }
            var parser = new DOMParser();
            return parser.parseFromString(display, "text/html").body.textContent;
        }
    },
    mounted: function mounted() {
        $('.ellipsis').bind('mouseenter', function () {
            var $this = $(this);
            if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
                $this.attr('title', $this.text());
            }
        });
    },
    beforeMount: function beforeMount() {
        var Vue = this;
        __WEBPACK_IMPORTED_MODULE_6__events_event_bus__["a" /* default */].$on("reloadingLast10Wager", function (reloadingReturn) {
            Vue.reloadingBet = reloadingReturn;
            Vue.pendingWagerIds = _.map(_.filter(Vue.statement.last10wagerList, { wgStatus: '1' }), 'wgNo');
            Vue.checkPendingWager();
        });
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_6__events_event_bus__["a" /* default */].$off('reloadingLast10Wager');
        clearInterval(this.pendingTimerId);
    }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_sportMatchCount__ = __webpack_require__(48);







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_mixins_sportMatchCount__["a" /* default */]],
  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['langList', 'showFavEvents', 'account']), {
    showFavEvents: {
      get: function get() {
        return this.$store.getters.showFavEvents;
      },
      set: function set(value) {
        var _this = this;

        if (!this.account.previewFlag) {
          __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
          this.$store.dispatch('getSportOdds', {
            showfavorite: value,
            callback: function (res) {
              _this.refreshScroll();
            }.bind(this)
          });
        }
      }
    }
  }),
  data: function data() {
    return {
      timerSeconds: 180
    };
  },

  methods: {
    changeFavorite: function changeFavorite() {
      this.showFavEvents = true;
      this.$store.commit('EVENTLIST', []);
      __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
      this.$store.commit("GAMEBANNER_SELECTED", false);
      this.$store.commit('SELECTED_ALLBET', false);
      this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
      this.$store.commit('SELECTED_MATCHALLBET', false);
      this.resetSportBettype();
      __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('pageChange', this.$store.getters.market.favMarket.key);
    },
    refreshTimer: function refreshTimer() {
      this.clearTimer();
      this.timerSeconds = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 180;
      this.startTimer();
    },
    refreshScroll: function refreshScroll() {
      var main = document.getElementById('right_div');
      var sportTableWidth = $('.tableContent').outerWidth();
      if (main) {
        var maxTop = main.parentNode.parentNode.scrollHeight - main.offsetHeight;

        main.parentNode.parentNode.onscroll = function () {
          main.style.top = Math.min(this.scrollTop + 39) + "px";
          main.style.left = sportTableWidth + "px";
        };
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bettingForm__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__betSlipForm__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    bettingForm: __WEBPACK_IMPORTED_MODULE_2__bettingForm__["a" /* default */],
    betSlipForm: __WEBPACK_IMPORTED_MODULE_3__betSlipForm__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['account', 'oddSelected', 'betting', 'betLang', 'isBetSuccess', 'isPlacedBet', 'selectedBettype', 'betForm', 'parlaySelected', 'selectedBetListType', 'pendingFlag', 'selectedBetTab', 'openBetForm', 'showbetformMenu', 'isParlayTab', 'bettypeList', 'previousBettype', 'isBetCombo', 'selectedLiveEvent', 'selectedMatchAllBet', 'LivetvLang', 'liveSchedule', 'tvIconFlag', 'bettypeFeature'])),
  data: function data() {
    return {
      selectedTab: 'betTab',
      last10TimerId: null,
      isMulp: false,
      ttlBetAmount: 0,
      waitingTimer: 60,
      fixTimer: 5,

      hasParlay: false,
      lang: window.lang,
      allowRbParlay: window.allowRbParlay
    };
  },

  watch: {
    betForm: {
      handler: function handler(val, oldVal) {
        var vue = this;
        if (!this.allowRbParlay && this.$store.getters.isBetParlay && val.length == 0 && this.selectedBettype.betTypId != "5") {
          this.$store.commit("IS_BETPARLAY", false);
        }

        if (this.$store.getters.isBetParlay && val.length > 0 && this.selectedBettype.betTypId != "5") {
          this.updateParlay();
        }

        if (this.selectedBettype.betTypId == "5") {
          this.isMulp = true;
          this.hasParlay = true;
          if (val.length > 0) {
            this.$store.commit("IS_BETPARLAY", true);
          }
        } else {
          this.isMulp = false;
          this.hasParlay = false;
          if (val && val.length > 0) {
            if (this.isBetCombo) {
              var stopLoop = false;
              _.forEach(val, function (arr, key) {
                if (stopLoop) return;
                for (var index = 0; index < vue.$store.getters.eventList.length; index++) {
                  var eid = _.findIndex(vue.$store.getters.eventList[index], function (e) {
                    return e.eveid == arr.eveid;
                  });
                  if (eid > -1) {
                    var event = vue.$store.getters.eventList[index][eid];
                    if (event.sptid == '1') {
                      vue.hasParlay = true;
                      if (!vue.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                        vue.hasParlay = false;
                        stopLoop = true;
                      }
                    } else {
                      if (event.sptid == '2' && event.lgeflag == '0' && !event.rbinfo && event.rbstatus != '1') {
                        vue.hasParlay = true;
                      } else {
                        if (vue.hasParlay) {
                          vue.hasParlay = false;
                          stopLoop = true;
                        }
                      }
                    }
                    break;
                  }
                }
                for (var _index = 0; _index < vue.$store.getters.rbeventList.length; _index++) {
                  var eid = _.findIndex(vue.$store.getters.rbeventList[_index], function (e) {
                    return e.eveid == arr.eveid;
                  });
                  if (eid > -1) {
                    var event = vue.$store.getters.rbeventList[_index][eid];
                    if (event.sptid == '1') {
                      vue.hasParlay = true;
                      if (!vue.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                        vue.hasParlay = false;
                        stopLoop = true;
                      }
                    } else {
                      if (vue.hasParlay) {
                        vue.hasParlay = false;
                        stopLoop = true;
                      }
                    }
                    break;
                  }
                }
              });
            } else {
              var eventId = val[0].eveid;
              for (var index = 0; index < vue.$store.getters.eventList.length; index++) {
                var eid = _.findIndex(vue.$store.getters.eventList[index], function (e) {
                  return e.eveid == eventId;
                });
                if (eid > -1) {
                  var event = vue.$store.getters.eventList[index][eid];
                  if (event.sptid == '1') {
                    this.hasParlay = true;
                    if (!this.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                      this.hasParlay = false;
                    }
                  } else {
                    if (event.sptid == '2' && event.lgeflag == '0' && !event.rbinfo && event.rbstatus != '1') {
                      this.hasParlay = true;
                    }
                  }
                  break;
                }
              }

              for (var _index2 = 0; _index2 < vue.$store.getters.rbeventList.length; _index2++) {
                var eid = _.findIndex(vue.$store.getters.rbeventList[_index2], function (e) {
                  return e.eveid == eventId;
                });
                if (eid > -1) {
                  var event = vue.$store.getters.rbeventList[_index2][eid];
                  if (event.sptid == '1') {
                    this.hasParlay = true;
                    if (!this.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                      this.hasParlay = false;
                    }
                  }
                  break;
                }
              }
            }
          }
        }

        if (this.bettypeFeature && this.bettypeFeature.indexOf('15') !== -1) {
          this.hasParlay = false;
        }
      }
    }
  },
  methods: {
    openLivetv: function openLivetv() {
      if (!this.$store.getters.account.previewFlag || this.$store.getters.isLiveOn) {
        this.$store.commit("LIVE_SCHECULE", true);
        this.$store.commit('OPEN_RBMARKET', false);
        this.$store.commit("GAMEBANNER_SELECTED", false);
        this.$store.commit('SELECTED_ALLBET', false);
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
        this.$store.commit('SELECTED_MATCHALLBET', true);

        if ($('.menu-fold2-wrap').hasClass('open')) {
          $('.menu-fold2-wrap').removeClass('open');
        }

        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('callLivetv');
      } else if (window._hasRedirect) {
        $('.login-redirect-dialog').show();
      }
    },
    toggleBetForm: function toggleBetForm() {
      var _this = this;

      this.$store.commit("OPEN_BETFORM", true);
      this.$store.commit("ODD_SELECTED", true);
      this.$store.commit('SELECTED_TAB', 'betSlipTab');
      this.$store.commit("SHOW_BETFORM_MENU", false);

      this.$store.dispatch("getBettingInfo", {
        isRetainSel: this.$store.getters.betting.success || this.$store.getters.betting.betcombosuccess ? true : false,
        callback: function (res) {
          _this.$store.commit("SPORT_MAPPING_BETTING", {
            newBettingList: res.SYSTEM_DATA.betting,
            oldBettingList: _this.$store.getters.betForm
          });
        }.bind(this)
      });
    },
    backMenu: function backMenu() {
      this.selectedTab = 'betTab';
      this.$store.commit("ODD_SELECTED", false);
      this.$store.commit("OPEN_BETFORM", false);
      this.$store.commit("SELECTED_BETTAB", false);
      this.$store.commit('SELECTED_TAB', 'betTab');
      this.$store.commit("SPORT_MINIBET_BETAMOUNT", 0);
      this.$store.commit('BETTING_MESSAGE', { isError: false });
      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('stopBettingTimer');

      if (this.betForm.length > 0) {
        this.$store.commit("SHOW_BETFORM_MENU", true);
      }
    },
    changeTab: function changeTab(tab) {
      var mini = $('.sidebar-first').hasClass('mini');

      this.$store.getters.oddSelected && this.$store.commit("ODD_SELECTED", false);
      this.$store.getters.openBetForm && this.$store.commit("OPEN_BETFORM", false);
      this.$store.getters.showbetformMenu && this.$store.commit("SHOW_BETFORM_MENU", false);

      if (!this.account.previewFlag) {
        this.selectedTab = tab;
        this.$store.commit('SELECTED_TAB', tab);
        if (this.selectedTab == 'betSlipTab') {
          var isBetSlip = !this.oddSelected && this.showBetFormMenu;


          this.getLast10Bets();


          var active = $('.betList').hasClass('active');
          var collapsed = $('.betList').hasClass('collapsed');

          if (mini) {}

          if (active) {
            if (!isBetSlip) {
              this.$store.commit('SELECTED_BETTAB', false);

              $('.sportsMenu').removeClass('collapsed');
            }
          } else if (collapsed) {
            this.$store.commit('SELECTED_BETTAB', true);
            $('.sportsMenu').addClass('collapsed');
          } else {
            this.$store.commit('SELECTED_BETTAB', true);
            if (mini) {
              $('.betList').addClass('active');
            }
          }
        } else {
          var isBetList = $('.widgetPanel.group').hasClass('betList');

          $('.widgetPanel.group').removeClass('betList');
          $('.widgetPanel.group').addClass('betSlip');
          this.$store.commit('BET_SUCCESS', false);

          var active = $('.betSlip').hasClass('active');
          var collapsed = $('.betSlip').hasClass('collapsed');

          $('.item-bet').removeClass('hidden');
          if (mini) {}
          if (active) {
            if (!isBetList) {
              this.$store.commit('SELECTED_BETTAB', false);

              $('.sportsMenu').removeClass('collapsed');
            }
          } else if (collapsed) {
            this.$store.commit('SELECTED_BETTAB', true);
            $('.sportsMenu').addClass('collapsed');
          } else {
            if (mini) {
              $('.betSlip').addClass('active');
            }
          }
        }
      } else if (window._hasRedirect) {
        $('.login-redirect-dialog').show();
      }
    },
    CountbetTimer: function CountbetTimer() {
      var _this2 = this;

      if (this.pendingTimerId == null) {
        this.pendingTimerId = setInterval(function () {
          if (_this2.waitingTimer - 1 < 0) {
            _this2.waitingTimer = _this2.fixTimer;
            __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('ttlbetCount');
          } else {
            _this2.waitingTimer -= 1;
          }
        }.bind(this), 1000);
      }
    },
    getLast10Bets: function getLast10Bets() {
      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('reloadingLast10Wager', true);
      this.$store.dispatch('getLast10Wager', {
        token: token.arr_2,
        last10Wager: true,
        novaWager: this.selectedBetListType,
        callback: function (res) {
          __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('reloadingLast10Wager', false);
        }.bind(this)
      });
    },
    getCountBet: function getCountBet() {
      var _this3 = this;

      this.$store.dispatch('getLast10Wager', {
        token: token.arr_2,
        last10Wager: true,
        isCount: true,
        wgrTyp: 'openBet',

        callback: function (res) {
          _this3.ttlBetAmount = res.count;
        }.bind(this)
      });
    },
    closeTab: function closeTab() {
      var betSlipAct = $('.betSlip').hasClass('active');
      var betListAct = $('.betList').hasClass('active');

      if (betSlipAct || betListAct) {}

      $('.widgetPanel.group').removeClass('active');
    },
    confirmBetSlip: function confirmBetSlip(tab) {

      this.selectedTab = tab;
      this.$store.commit('SELECTED_TAB', tab);
      this.$store.commit('PLACED_BET', true);
      if (this.selectedTab == 'betSlipTab') {
        this.getLast10Bets();
        this.$store.commit('ODD_SELECTED', false);

        this.changeTab(this.selectedTab);
      }
    },
    changeBetSlipType: function changeBetSlipType(type) {
      this.$store.commit('PENDING_FLAG', false);
      this.$store.commit('BETLIST_TYPE', type);
      this.getLast10Bets();
    },
    updateParlay: function updateParlay() {
      var _this4 = this;

      var clickParlayButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.betting.pending || this.betting.success || this.betting.betcombosuccess || this.betting.reject) {
        this.$store.commit('BETTING_MESSAGE', { isError: false });
        this.$store.commit("BETCOMBO_MESSAGE", { isClear: true });

        this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
        this.$store.commit("BETMULP_AMOUNT", { resetBetMulpAmount: true });
        this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
        var arr = { clear: true };
        this.$store.commit("BETCOMBO_AMOUNT", arr);
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('clearAllBetComboAmount');
        this.$store.commit('ODD_SELECTED', true);
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('stopBettingTimer');
        this.$store.commit('SET_MATCH_INDEX_NO_ERR', []);
      }
      if (clickParlayButton) {
        this.$store.commit("BETMULP_AMOUNT", { resetBetMulpAmount: true });
        this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
      }
      if (this.selectedBettype != undefined && this.selectedBettype.betTypId == '5') {
        this.$store.commit("IS_BETPARLAY", false);
        this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.previousBettype.bettype));
        this.$store.commit("IS_BETCOMBO", this.previousBettype.isBetCombo);
        this.$store.commit('PREV_BETTYPE', null);

        if (!this.isBetCombo && this.betForm.length > 1) {
          this.$store.dispatch("removeMatch", {
            data: { clearType: '2' }
          });
        }
      } else {
        this.$store.commit("IS_BETPARLAY", true);
        this.$store.commit('PREV_BETTYPE', { bettype: this.selectedBettype, isBetCombo: this.isBetCombo });
        var bettyp_index = _.findIndex(this.bettypeList, function (value, id) {
          return value.betTypId == '5';
        });
        if (bettyp_index > -1) {
          this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.bettypeList[bettyp_index]));
        }
        this.$store.commit("IS_BETCOMBO", false);
      }
      if (clickParlayButton) {
        this.$store.dispatch("getBettingInfo", {
          callback: function (res) {
            _this4.$store.commit("SPORT_MAPPING_BETTING", {
              newBettingList: res.SYSTEM_DATA.betting,
              oldBettingList: _this4.$store.getters.betForm
            });
          }.bind(this)
        });
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('showBetslip', function (show) {
      _this5.selectedTab = 'betTab';
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('returnBetTab', function (show) {
      _this5.selectedTab = 'betTab';
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('confirmBetSlip', function (tab) {
      _this5.confirmBetSlip(tab);
    });

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('upWaitStatus', function () {
      _this5.changeBetSlipType(_this5.selectedBetListType);
    });

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('ttlbetCount', function (tab) {
      _this5.getCountBet();
    });
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('ttlbetCount');
  },
  beforeMount: function beforeMount() {

    this.CountbetTimer();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('showBetslip');
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('upWaitStatus');
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('stopBettingTimer');
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('returnBetTab');
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('ttlbetCount');
  },
  updated: function updated() {
    this.selectedBetType = this.selectedBettype.betTypId;
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sport_allBetCommon__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sport_sportTable__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__livetv_livetvEventsList__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(0);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    sportTable: __WEBPACK_IMPORTED_MODULE_2__sport_sportTable__["a" /* default */],
    allBetCommon: __WEBPACK_IMPORTED_MODULE_1__sport_allBetCommon__["a" /* default */],
    livetvEventsList: __WEBPACK_IMPORTED_MODULE_3__livetv_livetvEventsList__["a" /* default */]
  },
  data: function data() {
    return {
      heightPX: window.innerHeight + 'px',
      widthPX: '775px'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['selectedTab', 'selectedBettype', 'selectedMatchAllBet', 'liveSchedule', 'resizeWHeight', 'bool_leagueToggle', 'unfold_AllSc', 'miniNormal', 'frameWidthHeight', 'hotSchedule']), {
    LeftMenu_heightPX: function LeftMenu_heightPX() {
      return this.$store.getters.frameWidthHeight.height.currentHeight - 100;
    },
    center_widthPX: function center_widthPX() {
      return this.$store.getters.frameWidthHeight.width.CenterPage_current;
    }
  }),
  watch: {
    resizeWHeight: function resizeWHeight() {
      var hgt = this.$store.getters.resizeWHeight;
      if (this.$store.getters.bool_leagueToggle) {
        hgt = hgt - 100;
      }
      this.heightPX = hgt + 'px';
    },
    bool_leagueToggle: function bool_leagueToggle() {
      if (this.$store.getters.bool_leagueToggle) {
        var ht = window.innerHeight - 100;
        this.heightPX = ht + 'px';
      }
    }
  },
  methods: {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {}
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allBet_all_bet__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__allBetHeader__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__allBetContent__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_mixins_favourite__ = __webpack_require__(17);
















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__vue_mixins_favourite__["a" /* default */]],
  components: {
    allBetComponent: __WEBPACK_IMPORTED_MODULE_7__allBet_all_bet__["a" /* default */],
    allBetHeader: __WEBPACK_IMPORTED_MODULE_8__allBetHeader__["a" /* default */],
    allBetContent: __WEBPACK_IMPORTED_MODULE_9__allBetContent__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'matchAllBet', 'sortedMatchEventList', 'market', 'selectedShow', 'selectedMarket', 'selectedBettype', 'tvIconFlag', 'selectedAllBetNew', 'foldopenAllBet', 'allBetReloading'])),
  watch: {
    'showhideBanner': {
      handler: function handler(val, oldVal) {
        this.allBet_mContent();
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,
      fT: ['2', '3'],
      hT: ['2', '4'],
      showhideAll: true,
      selectedBetTab: 'hot',
      otherSport1: ['N3', 'N12', 'N21'],
      betTab: {
        hot: {
          key: 'hot',
          value: true,
          flag: true
        },
        hdpou: {
          key: 'hdpou',
          value: [1, 2, 4, 32, 46, 48],
          rbvalue: [8, 9, 11, 33, 47, 49],
          flag: true
        },
        goals: {
          key: 'goals',
          value: [2, 3, 5],
          rbvalue: [18, 9, 10],
          flag: true
        },
        cs: {
          key: 'cs',
          value: [7],
          rbvalue: [16],
          flag: true
        },
        ft: {
          key: 'ft',
          value: [1],
          rbvalue: [8],
          flag: true
        },
        ht: {
          key: 'ht',
          value: [2],
          flag: true
        },
        sh: {
          key: 'sh',
          value: [19],
          flag: true
        },
        others: {
          key: 'others',
          value: true,
          flag: true
        },
        special: {
          key: 'special',
          value: true,
          flag: true
        },
        other: {
          key: 'other',
          value: [21, 34, 28, 30],
          rbvalue: [27, 29, 35, 31],
          flag: true
        },
        scrMarket: {
          key: 'scrMarket',
          value: [2, 3, 5, 7, 9, 10],
          flag: true
        },
        sethdp: {
          key: 'set',
          value: [3, 7, 8, 9, 10, 11, 12],
          rbvalue: [27, 29, 35, 31],
          flag: true
        },
        gamehdp: {
          key: 'game',
          value: [6],
          flag: true
        },
        pointhdp: {
          key: 'point',
          value: [4],
          flag: true
        },
        all: {
          key: 'all',
          value: true,
          flag: true
        },
        innings: {
          key: 'innings',
          value: [__WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().first5InningsPlyType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().first3InningsPlyType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().firstInningsPlayType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().secondInningsPlyType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().thirdInningsPlyType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().fourthInningsPlyType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().fifthInningsPlyType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().sixthInningsPlyType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().seventhInningsPlyType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().eightthInningsPlayType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().nineInningsPlayType, __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */].data().OTPlyType],
          flag: true
        },
        team: {
          key: 'team',
          value: [80, 82],
          rbvalue: [81, 83],
          flag: true
        },
        booking: {
          key: 'booking',
          value: ['7b', '10a', '23a'],
          flag: true
        },
        corner: {
          key: 'corner',
          value: ['7a', '9a', '22a'],
          flag: true
        }
      },
      showhideBanner: true,
      mContentPadding: '',
      reloading: false,
      bannerSize: 190
    };
  },

  methods: {
    checkBTExist: function checkBTExist(BTkey) {
      var vue = this;

      var exist = false;
      var btArray = this.sortedMatchEventList.rbinfo ? vue.betTab[BTkey].rbvalue : vue.betTab[BTkey].value;

      _.forEach(this.sortedMatchEventList.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), btArray) > -1) {
            exist = true;
          }
        });
      });

      return exist;
    },
    allBet_mContent: function allBet_mContent() {
      var a = 76;
      var b = this.showhideBanner ? a + this.bannerSize : a;

      this.mContentPadding = 'padding-top: ' + b + 'px;';
    },
    showhide_Banner: function showhide_Banner(val) {
      this.showhideBanner = val;
    },
    getABetSport: function getABetSport() {
      var sprt = this.$store.getters.selectedBettype.sprtId;

      return 'allBet' + sprt;
    },
    foldopenAB: function foldopenAB() {
      this.$store.commit('FOLDOPEN_ALLBET', !this.$store.getters.foldopenAllBet);
    },
    showhideMain: function showhideMain() {
      this.showhideAll = this.showhideAll ? false : true;
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide);
    },
    colspanS: function colspanS() {
      return 2;
    },
    getSubMatch: function getSubMatch(sub) {
      return sub + 1;
    },
    showLeg: function showLeg() {
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide);
    },
    chooseBetTab: function chooseBetTab(betTab) {
      if (betTab.flag) {
        this.selectedBetTab = betTab.key;
      }
    },
    switchAllBetTab: function switchAllBetTab(id) {
      $('.moreBetTypeNav-Item').removeClass('active');
      $(id).addClass('active');
    },
    checkOpenMore: function checkOpenMore(event) {
      if (event.sp) {
        return true;
      } else if (event.od) {
        var show = true;
        $.each(event.od, function (plyTypes, drawBt) {
          if (plyTypes !== '1' && plyTypes !== '3') {
            return true;
          } else {
            show = true;
            if (plyTypes == '1' || plyTypes == '2') {
              $.each(drawBt, function (bidx, drawDual) {
                show = true;

                if (bidx == 1 || bidx == 2 || bidx == 4 || bidx == 8 || bidx == 9 || bidx == 11) {
                  show = false;
                }
              });
            }
          }
        });
        return show;
      }
      return false;
    },
    reloadTable: function reloadTable() {
      var _this = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.oddsReload = true;

      __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('templateChange', this.oddsReload);

      var dispatchName = 'getSportOdds';
      if (this.$store.getters.selectedBettype.betTypId == '6') {
        dispatchName = 'getSportOutrightOdds';
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8;
      }

      this.$store.dispatch(dispatchName, {
        token: token_val,
        callback: function (res) {
          if (res.events) {
            _this.reconnectTimerId = null;
            _.forEach(res.events, function (val, key) {
              _.forEach(val, function (v, k) {
                var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse');
                if (showAllBet) {
                  $('#moreExpand' + v.eveid).addClass('icon-moreExpand');
                  $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse');
                  $('#moreBets' + v.eveid).css("display", "none");
                }
              });
            });
          } else {
            _this.reconnectTimerSeconds = 5;
            if (_this.reconnectTimerId == null) {
              _this.reconnectTimerId = setInterval(function () {
                if (_this.reconnectTimerSeconds - 1 < 0) {
                  _this.reloadTable();
                } else {
                  _this.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (_this.showFavEvents) {
            _this.$store.dispatch('getLaugueList', function (res) {
              this.$store.commit('SELECTEDLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
              this.$store.commit('TOTALLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
            }.bind(_this));
          }
          _this.reloading = false;
          _this.oddsReload = false;
          __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('templateChange', _this.oddsReload);


          _this.$store.commit('PARLAY_SELECTED', { update: false });
        }.bind(this)
      });
    },
    backToMain: function backToMain() {
      __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('sportTableReloading', true);
      this.reloadTable();
      this.$store.commit('SELECTED_MATCHALLBET', false);
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    getMarketTimer: function getMarketTimer(selMarket) {
      if (this.$store.getters.open_RBMarket) {
        return this.rbTimer;
      } else if (selMarket == this.$store.getters.market.earlyMarket.key) {
        return this.earlyTimer;
      } else if (selMarket == this.$store.getters.market.tdyMarket.key) {
        return this.todayTimer;
      }
    },
    startAllBetTimer: function startAllBetTimer() {
      var _this2 = this;

      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (_this2.timerSeconds - 1 < 0) {
            _this2.refreshTbl(token.arr_1);
          } else {
            _this2.timerSeconds -= 1;
          }
        }, 1000);
      }
    },
    refreshTbl: function refreshTbl(token_val) {
      this.reloading = token_val == token.arr_1 || token_val == token.arr_5 ? false : true;
      if (this.selectedMatchAllBet) {
        this.reloadAllBetTable(token_val);
      }
    },
    reloadAllBetTable: function reloadAllBetTable() {
      var _this3 = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (token_val == '') {
        token_val = token.arr_5;
      }
      this.clearTimer();

      this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList);

      this.$store.dispatch('getSportAllBet', {
        token: token_val,
        inAllBet: true,
        event: this.$store.getters.sortedMatchEventList,
        callback: function (res) {
          _this3.timerSeconds = _this3.getMarketTimer(_this3.$store.getters.selectedMarket);

          _this3.startAllBetTimer();
          _this3.mainMarketList = _.cloneDeep(_this3.$store.getters.sortedMatchEventList);

          _this3.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('diffOdd', _this3.cloneEventAllBet);
          });
          _this3.reloading = false;
        }.bind(this)
      });
    },
    checkTimer: function checkTimer(event) {
      return this.$options.filters.checkTimer(event);
    }
  },
  mounted: function mounted() {
    this.allBet_mContent();
  },
  beforeMount: function beforeMount() {
    this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket);
    this.startAllBetTimer();
  },
  destroyed: function destroyed() {
    this.clearTimer();
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__all_bet_team_info__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allBet_hdp__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__allBet_ou__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__allBet_1x2__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__allBet_cs__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__allBet_tg__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__allBet_htft__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__allBet_oe__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__all_bet_atg__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__all_bet_htg__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__allBet_btts__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__allBet_dbch__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__allBet_csh__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__allBet_tw__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__allBet_wm__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__allBet_flg__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__allBet_hmg__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__allBet_ml__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__allBet_lds__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__allBet_wd__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__fullTime_cs__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__fullTime_tg__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__all_bet_h1x2__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__allBet_nog__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__all_bet_1x2tgou__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__all_bet_1x2btts__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__all_bet_ouoe__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__all_bet_oubtts__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__all_bet_oufts__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__all_bet_1x2fts__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__all_bet_dbchou__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__all_bet_dbchbtts__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__all_bet_dbchfts__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__all_bet_eg__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__vue_events_event_bus__ = __webpack_require__(3);





















































/* harmony default export */ __webpack_exports__["a"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_40__mixins_allBet__["a" /* default */]],
	props: {
		betTab: null,
		mode: null
	},
	components: {
		allBetTeamInfo: __WEBPACK_IMPORTED_MODULE_6__all_bet_team_info__["a" /* default */],
		allBetHDP: __WEBPACK_IMPORTED_MODULE_7__allBet_hdp__["a" /* default */],
		allBetOU: __WEBPACK_IMPORTED_MODULE_8__allBet_ou__["a" /* default */],
		allBet1x2: __WEBPACK_IMPORTED_MODULE_9__allBet_1x2__["a" /* default */],
		allBetCS: __WEBPACK_IMPORTED_MODULE_10__allBet_cs__["a" /* default */],
		allBetTG: __WEBPACK_IMPORTED_MODULE_11__allBet_tg__["a" /* default */],
		ftCS: __WEBPACK_IMPORTED_MODULE_26__fullTime_cs__["a" /* default */],
		ftTG: __WEBPACK_IMPORTED_MODULE_27__fullTime_tg__["a" /* default */],
		allBetDBCH: __WEBPACK_IMPORTED_MODULE_17__allBet_dbch__["a" /* default */],
		allBetOE: __WEBPACK_IMPORTED_MODULE_13__allBet_oe__["a" /* default */],
		allBetHTFT: __WEBPACK_IMPORTED_MODULE_12__allBet_htft__["a" /* default */],

		allBetATG: __WEBPACK_IMPORTED_MODULE_14__all_bet_atg__["a" /* default */],
		allBetHTG: __WEBPACK_IMPORTED_MODULE_15__all_bet_htg__["a" /* default */],
		allBetBTTS: __WEBPACK_IMPORTED_MODULE_16__allBet_btts__["a" /* default */],
		allBetWM: __WEBPACK_IMPORTED_MODULE_20__allBet_wm__["a" /* default */],
		allBetTW: __WEBPACK_IMPORTED_MODULE_19__allBet_tw__["a" /* default */],
		allBetCSH: __WEBPACK_IMPORTED_MODULE_18__allBet_csh__["a" /* default */],
		allBetH1X2: __WEBPACK_IMPORTED_MODULE_28__all_bet_h1x2__["a" /* default */],
		allBetHMG: __WEBPACK_IMPORTED_MODULE_22__allBet_hmg__["a" /* default */],
		allBetML: __WEBPACK_IMPORTED_MODULE_23__allBet_ml__["a" /* default */],
		allBetFLG: __WEBPACK_IMPORTED_MODULE_21__allBet_flg__["a" /* default */],
		allBetLDS: __WEBPACK_IMPORTED_MODULE_24__allBet_lds__["a" /* default */],
		allBetWD: __WEBPACK_IMPORTED_MODULE_25__allBet_wd__["a" /* default */],
		allBet1x2tgou: __WEBPACK_IMPORTED_MODULE_30__all_bet_1x2tgou__["a" /* default */],
		allBet1x2btts: __WEBPACK_IMPORTED_MODULE_31__all_bet_1x2btts__["a" /* default */],
		allBetNOG: __WEBPACK_IMPORTED_MODULE_29__allBet_nog__["a" /* default */],
		allBetouoe: __WEBPACK_IMPORTED_MODULE_32__all_bet_ouoe__["a" /* default */],
		allBetoubtts: __WEBPACK_IMPORTED_MODULE_33__all_bet_oubtts__["a" /* default */],
		allBetOuFts: __WEBPACK_IMPORTED_MODULE_34__all_bet_oufts__["a" /* default */],
		allBet1x2Fts: __WEBPACK_IMPORTED_MODULE_35__all_bet_1x2fts__["a" /* default */],
		allBetDbchOu: __WEBPACK_IMPORTED_MODULE_36__all_bet_dbchou__["a" /* default */],
		allBetDbchBtts: __WEBPACK_IMPORTED_MODULE_37__all_bet_dbchbtts__["a" /* default */],
		allBetDbchFts: __WEBPACK_IMPORTED_MODULE_38__all_bet_dbchfts__["a" /* default */],
		allBetEg: __WEBPACK_IMPORTED_MODULE_39__all_bet_eg__["a" /* default */]
	},
	watch: {
		firstEvent: function firstEvent() {
			if (this.mode == 'firstEvent') {
				this.mainMarketList = _.cloneDeep(this.$store.getters.firstEvent);
			}
		},

		sortedMatchEventList: {
			handler: function handler(value, oldVal) {
				this.mainMarketList = _.cloneDeep(value);
			},

			deep: true,
			immediate: true
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['eventAllBet', 'selectedShow', 'selectedBettype', 'selectedSport', 'selected_AllBetTab', 'firstEvent', 'market', 'selectedMarket', 'open_RBMarket']), {
		selected_Tab: {
			get: function get() {
				if (this.mode == 'ab') {
					return this.$store.getters.selected_AllBetTab.ab;
				} else {
					return this.$store.getters.selected_AllBetTab.firstEvent;
				}
			}
		},
		filMarketList: function filMarketList() {
			var eventAllBet = _.cloneDeep(this.mainMarketList);
			switch (this.selected_Tab) {
				case this.marketSelect.hdpou.key:
					eventAllBet = this.getHdpOUOdd(eventAllBet);
					break;
				case this.marketSelect.sethdp.key:
					eventAllBet.od = _.pick(eventAllBet.od, this.marketSelect.sethdp.value);
					break;
				case this.marketSelect.gamehdp.key:
					eventAllBet.od = _.pick(eventAllBet.od, this.marketSelect.gamehdp.value);
					break;
				case this.marketSelect.pointhdp.key:
					eventAllBet.od = _.pick(eventAllBet.od, this.marketSelect.pointhdp.value);
					break;
				case this.marketSelect.special.key:
					eventAllBet.od[this.ftPlyType] = _.pick(eventAllBet.od[this.ftPlyType], this.marketSelect.special.value);
					break;
				case this.betTab.corner.key:
					var prefixes = this.betTab.corner.value;
					var filteredSp = {};
					$.each(eventAllBet.sp, function (key, value) {
						var sbid = value.sbid;
						if (prefixes.some(function (prefix) {
							return sbid.startsWith(prefix);
						})) {
							filteredSp[key] = value;
						}
					});
					eventAllBet.sp = filteredSp;
					break;
				case this.betTab.booking.key:
					var prefixes = this.betTab.booking.value;
					var filteredSp = {};
					$.each(eventAllBet.sp, function (key, value) {
						var sbid = value.sbid;
						if (prefixes.some(function (prefix) {
							return sbid.startsWith(prefix);
						})) {
							filteredSp[key] = value;
						}
					});
					eventAllBet.sp = filteredSp;
					break;
				default:
			}

			return eventAllBet;
		},

		sortedMatchEventList: {
			get: function get() {
				this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList);
				return this.$store.getters.sortedMatchEventList;
			},
			set: function set(value) {}
		}
	}),
	data: function data() {
		return {
			lang: window.lang,
			marketSelect: {
				hdpou: {
					key: 'hdpou',
					value: [1, 8, 2, 9, 4, 11, 32, 33, 46, 47, 48, 49, 80, 81, 82, 83],
					flag: true
				},
				special: {
					key: 'special',

					value: [57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73],
					flag: true
				},
				others: {
					key: 'others',
					value: true,
					flag: true
				},
				sethdp: {
					key: 'set',
					value: [3, 7, 8, 9, 10, 11, 12],
					flag: true
				},
				gamehdp: {
					key: 'game',
					value: [6],
					flag: true
				},
				pointhdp: {
					key: 'point',
					value: [4],
					flag: true
				}
			},
			cloneEventAllBet: null,
			mainMarketList: null,
			showMyMarkets: false,
			showMainMarkets: true,
			allBetRefreshTimer: 60,
			allBetTimerId: null,
			myMarketList: null,

			token: window.token,
			OtherSportList: ['G1', 'N2', 'N3', 'N21', 'N12', 'N7', 'N14', 'N15', 'N19', 'N20'],
			bbPlaytype: null
		};
	},

	methods: {
		getRB: function getRB(bt) {
			if (bt == 1 || bt == 8) {
				return this.filMarketList.rbstatus == '1' ? '8' : '1';
			} else if (bt == 2 || bt == 9) {
				return this.filMarketList.rbstatus == '1' ? '9' : '2';
			} else if (bt == 3 || bt == 10) {
				return this.filMarketList.rbstatus == '1' ? '10' : '3';
			} else if (bt == 4 || bt == 11) {
				return this.filMarketList.rbstatus == '1' ? '11' : '4';
			} else if (bt == 5 || bt == 18) {
				return this.filMarketList.rbstatus == '1' ? '18' : '5';
			} else if (bt == 6 || bt == 17) {
				return this.filMarketList.rbstatus == '1' ? '17' : '6';
			} else if (bt == 7 || bt == 16) {
				return this.filMarketList.rbstatus == '1' ? '16' : '7';
			} else if (bt == 12 || bt == 13) {
				return this.filMarketList.rbstatus == '1' ? '13' : '12';
			} else if (bt == 19 || bt == 20) {
				return this.filMarketList.rbstatus == '1' ? '20' : '19';
			} else if (bt == 21 || bt == 27) {
				return this.filMarketList.rbstatus == '1' ? '27' : '21';
			} else if (bt == 28 || bt == 29) {
				return this.filMarketList.rbstatus == '1' ? '29' : '28';
			} else if (bt == 30 || bt == 31) {
				return this.filMarketList.rbstatus == '1' ? '31' : '30';
			} else if (bt == 32 || bt == 33) {
				return this.filMarketList.rbstatus == '1' ? '33' : '32';
			} else if (bt == 34 || bt == 35) {
				return this.filMarketList.rbstatus == '1' ? '35' : '34';
			} else if (bt == 36 || bt == 37) {
				return this.filMarketList.rbstatus == '1' ? '37' : '36';
			} else if (bt == 38 || bt == 39) {
				return this.filMarketList.rbstatus == '1' ? '39' : '38';
			} else if (bt == 40 || bt == 41) {
				return this.filMarketList.rbstatus == '1' ? '41' : '40';
			} else if (bt == 42 || bt == 43) {
				return this.filMarketList.rbstatus == '1' ? '43' : '42';
			} else if (bt == 44 || bt == 45) {
				return this.filMarketList.rbstatus == '1' ? '45' : '44';
			} else if (bt == 46 || bt == 47) {
				return this.filMarketList.rbstatus == '1' ? '47' : '46';
			} else if (bt == 48 || bt == 49) {
				return this.filMarketList.rbstatus == '1' ? '49' : '48';
			} else if (bt == 50 || bt == 51) {
				return this.filMarketList.rbstatus == '1' ? '51' : '50';
			} else if (bt == 53 || bt == 55) {
				return this.filMarketList.rbstatus == '1' ? '55' : '53';
			} else if (bt == 54 || bt == 56) {
				return this.filMarketList.rbstatus == '1' ? '56' : '54';
			} else if (bt == 57 || bt == 58) {
				return this.filMarketList.rbstatus == '1' ? '58' : '57';
			} else if (bt == 59 || bt == 73) {
				return this.filMarketList.rbstatus == '1' ? '73' : '59';
			} else if (bt == 60 || bt == 61) {
				return this.filMarketList.rbstatus == '1' ? '61' : '60';
			} else if (bt == 63 || bt == 64) {
				return this.filMarketList.rbstatus == '1' ? '64' : '63';
			} else if (bt == 65 || bt == 66) {
				return this.filMarketList.rbstatus == '1' ? '66' : '65';
			} else if (bt == 68 || bt == 69) {
				return this.filMarketList.rbstatus == '1' ? '69' : '68';
			} else if (bt == 70 || bt == 71) {
				return this.filMarketList.rbstatus == '1' ? '71' : '70';
			} else if (bt == 80 || bt == 81) {
				return this.filMarketList.rbstatus == '1' ? '81' : '80';
			} else if (bt == 76 || bt == 79) {
				return this.filMarketList.rbstatus == '1' ? '79' : '76';
			} else if (bt == 77 || bt == 78) {
				return this.filMarketList.rbstatus == '1' ? '78' : '77';
			} else if (bt == 82 || bt == 83) {
				return this.filMarketList.rbstatus == '1' ? '83' : '82';
			}
			return bt;
		},
		rbdata: function rbdata() {
			return this.filMarketList.rbinfo;
		},
		chkShow: function chkShow(sportId, betType, plyType) {
			if (sportId == 13) {
				if (plyType == 1 && betType != 3 && betType != 10) {
					return false;
				}
			} else if (sportId == 1) {
				if (this.$store.getters.selectedShow != 4 && plyType == 1 && (betType == 1 || betType == 2 || betType == 4 || betType == 8 || betType == 9 || betType == 11)) {
					if (this.$store.getters.selectedShow == 3 && (betType == 4 || betType == 11)) {} else if (this.$store.getters.selectedShow == 1 && (betType == 4 || betType == 11)) {} else {
						return false;
					}
				} else if (this.$store.getters.selectedShow != 3 && plyType == 2 && (betType == 1 || betType == 2 || betType == 4 || betType == 8 || betType == 9 || betType == 11)) {
					if (this.$store.getters.selectedShow == 4 && (betType == 4 || betType == 11)) {} else if (this.$store.getters.selectedShow == 1 && (betType == 4 || betType == 11)) {} else {
						return false;
					}
				}
			} else if (plyType == 1 || plyType == 3) {
				return false;
			}
			return true;
		},
		setToTop: function setToTop(e) {
			var selected = 0;
			var itemlist = $('.group-template');
			var len = $(itemlist).children().length;

			selected = $(e.target).closest(".template").index();
			jQuery($(itemlist).children().eq(0)).before(jQuery($(itemlist).children().eq(selected)));
		},
		closeAllBetForm: function closeAllBetForm() {
			this.$store.commit('SELECTED_ALLBET', false);
		},
		backToTop: function backToTop() {
			document.getElementById("more_div").scrollTop = "0";
		},
		countOddsType: function countOddsType(marKetList) {
			var count = 0;

			function getOddsCount(event) {
				var odCount = 0;
				for (var plytyp = 0; plytyp < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od).length; plytyp++) {
					var plytypKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od)[plytyp];
					for (var bettyp = 0; bettyp < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od[plytypKey]).length; bettyp++) {
						var bettypKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od[plytypKey])[bettyp];

						if (_.indexOf([this.hdpBetType, this.ouBetType, this.rhdpBetType, this.rouBetType], bettypKey) >= 0) {
							odCount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.od[plytypKey][bettypKey]).length;
						} else {
							odCount += 1;
						}
					}
				}
				return odCount;
			}

			var getCount = getOddsCount.bind(this);
			count += getCount(marKetList);
			if (marKetList.sp) {
				for (var eventId = 0; eventId < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(marKetList.sp).length; eventId++) {
					var event = marKetList.sp[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(marKetList.sp)[eventId]];
					count += getCount(event);
				}
			}
			return count;
		},
		syncMainMarket: function syncMainMarket() {
			if (this.myMarketList) {
				if (this.myMarketList.od[this.ftPlyType]) {
					var ftBetTyp = _.pick(this.mainMarketList.od[this.ftPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.ftPlyType]));
					this.$set(this.myMarketList.od, this.ftPlyType, ftBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.ftPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.ftPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.ftPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.firstHtPlyType]) {
					var firstHtBetTyp = _.pick(this.mainMarketList.od[this.firstHtPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstHtPlyType]));
					this.$set(this.myMarketList.od, this.firstHtPlyType, firstHtBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstHtPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.firstHtPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstHtPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.setHandicapPlyType]) {
					var setHandicapBetTyp = _.pick(this.mainMarketList.od[this.setHandicapPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.setHandicapPlyType]));
					this.$set(this.myMarketList.od, this.setHandicapPlyType, setHandicapBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.setHandicapPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.setHandicapPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.setHandicapPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.pointHdpPlyType]) {
					var pointHandicapBetTyp = _.pick(this.mainMarketList.od[this.pointHdpPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.pointHdpPlyType]));
					this.$set(this.myMarketList.od, this.pointHdpPlyType, pointHandicapBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.pointHdpPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.pointHdpPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.pointHdpPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.iotPlyType]) {
					var iotBetTyp = _.pick(this.mainMarketList.od[this.iotPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.iotPlyType]));
					this.$set(this.myMarketList.od, this.iotPlyType, iotBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.iotPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.iotPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.iotPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.gameHdpPlyType]) {
					var gameHandicapBetTyp = _.pick(this.mainMarketList.od[this.gameHdpPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.gameHdpPlyType]));
					this.$set(this.myMarketList.od, this.gameHdpPlyType, gameHandicapBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.gameHdpPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.gameHdpPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.gameHdpPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.firstSetPlyType]) {
					var firstSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.firstSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstSetPlyType]));
					this.$set(this.myMarketList.od, this.firstSetPlyType, firstSetHandicapBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.firstSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstSetPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.secondSetPlyType]) {
					var secondSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.secondSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.secondSetPlyType]));
					this.$set(this.myMarketList.od, this.secondSetPlyType, secondSetHandicapBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.secondSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.secondSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.secondSetPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.thirdSetPlyType]) {
					var thirdSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.thirdSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.thirdSetPlyType]));
					this.$set(this.myMarketList.od, this.thirdSetPlyType, thirdSetHandicapBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.thirdSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.thirdSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.thirdSetPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.fourthSetPlyType]) {
					var fourthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.fourthSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fourthSetPlyType]));
					this.$set(this.myMarketList.od, this.fourthSetPlyType, fourthSetHandicapBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fourthSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.fourthSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fourthSetPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.fifthSetPlyType]) {
					var fifthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.fifthSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fifthSetPlyType]));
					this.$set(this.myMarketList.od, this.fifthSetPlyType, fifthSetHandicapBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fifthSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.fifthSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fifthSetPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.sixthSetPlyType]) {
					var sixthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.sixthSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.sixthSetPlyType]));
					this.$set(this.myMarketList.od, this.sixthSetPlyType, sixthSetHandicapBetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.sixthSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.sixthSetPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.sixthSetPlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.game1PlyType]) {
					var game1BetTyp = _.pick(this.mainMarketList.od[this.game1PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game1PlyType]));
					this.$set(this.myMarketList.od, this.game1PlyType, game1BetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game1PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game1PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game1PlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.game2PlyType]) {
					var game2BetTyp = _.pick(this.mainMarketList.od[this.game2PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game2PlyType]));
					this.$set(this.myMarketList.od, this.game2PlyType, game2BetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game2PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game2PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game2PlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.game3PlyType]) {
					var game3BetTyp = _.pick(this.mainMarketList.od[this.game3PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game3PlyType]));
					this.$set(this.myMarketList.od, this.game3PlyType, game3BetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game3PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game3PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game3PlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.game4PlyType]) {
					var game4BetTyp = _.pick(this.mainMarketList.od[this.game4PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game4PlyType]));
					this.$set(this.myMarketList.od, this.game4PlyType, game4BetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game4PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game4PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game4PlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.game5PlyType]) {
					var game5BetTyp = _.pick(this.mainMarketList.od[this.game5PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game5PlyType]));
					this.$set(this.myMarketList.od, this.game5PlyType, game5BetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game5PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game5PlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game5PlyType])[i]);
					}
				}
				if (this.myMarketList.od[this.SecondHtPlyType]) {
					var game5BetTyp = _.pick(this.mainMarketList.od[this.SecondHtPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.SecondHtPlyType]));
					this.$set(this.myMarketList.od, this.SecondHtPlyType, game5BetTyp);
					for (var i = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.SecondHtPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.SecondHtPlyType], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.SecondHtPlyType])[i]);
					}
				}

				if (this.myMarketList.sp) {
					for (var eveid = 0; eveid < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp).length; eveid++) {
						var specialEvent = this.myMarketList.sp[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp)[eveid]];
						for (var plytyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(specialEvent.od).length - 1; plytyp >= 0; plytyp--) {
							var plytypId = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(specialEvent.od)[plytyp];
							if (this.mainMarketList.sp && this.mainMarketList.sp[specialEvent.eveid] && this.mainMarketList.sp[specialEvent.eveid].od[plytypId] && specialEvent.od[plytypId]) {
								var betTypList = _.pick(this.mainMarketList.sp[specialEvent.eveid].od[plytypId], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(specialEvent.od[plytypId]));
								this.$set(this.myMarketList.sp[specialEvent.eveid].od, plytypId, betTypList);
								for (var bettyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(specialEvent.od[plytypId]).length - 1; bettyp >= 0; bettyp--) {
									this.$delete(this.mainMarketList.sp[specialEvent.eveid].od[plytypId], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp[specialEvent.eveid].od[plytypId])[bettyp]);
								}
							}
						}
					}
				}
			}
		},
		updateFavCookie: function updateFavCookie(plytyp, bettyp, isDelete) {
			var isSpecial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

			var favCookie = {};
			if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_fav')) {
				favCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_fav'));
				if (!isSpecial) {
					if (!favCookie[plytyp]) favCookie[plytyp] = {};
					favCookie[plytyp][bettyp] = {};
					if (isDelete) {
						_.unset(favCookie[plytyp], [bettyp]);
						if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie[plytyp]).length == 0) {
							_.unset(favCookie, [plytyp]);
						}
					}
				} else {
					if (!favCookie.sp) favCookie.sp = {};
					if (!favCookie.sp[isSpecial.eveid]) favCookie.sp[isSpecial.eveid] = {};
					if (!favCookie.sp[isSpecial.eveid][plytyp]) favCookie.sp[isSpecial.eveid][plytyp] = {};
					favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {};
					if (isDelete) {
						_.unset(favCookie.sp[isSpecial.eveid][plytyp], [bettyp]);
						if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[isSpecial.eveid][plytyp]).length == 0) {
							_.unset(favCookie.sp[isSpecial.eveid], [plytyp]);
						}
						if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[isSpecial.eveid]).length == 0) {
							_.unset(favCookie.sp, isSpecial.eveid);
						}
					}
				}
			} else {
				if (!isSpecial) {
					favCookie[plytyp] = {};
					favCookie[plytyp][bettyp] = {};
				} else {
					favCookie.sp = {};
					favCookie.sp[isSpecial.eveid] = {};
					favCookie.sp[isSpecial.eveid][plytyp] = {};
					favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {};
				}
			}
			__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set(window.compcode + '_fav', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(favCookie));
		},
		getFavCookieMarket: function getFavCookieMarket() {
			var favCookie = {};
			if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_fav')) {
				favCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_fav'));
				for (var plytyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie).length - 1; plytyp >= 0; plytyp--) {
					var pt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie)[plytyp];
					if (pt != 'sp') {
						for (var bettyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie[pt]).length - 1; bettyp >= 0; bettyp--) {
							var bt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie[pt])[bettyp];
							if (this.$store.getters.sortedMatchEventList.od[pt]) {
								if (this.$store.getters.sortedMatchEventList.od[pt][bt]) {
									this.pickMarket(this.$store.getters.sortedMatchEventList, pt, bt);
								}
							}
						}
					} else {
						for (var eve = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp).length - 1; eve >= 0; eve--) {
							var eveid = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp)[eve];
							for (var plytyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid]).length - 1; plytyp >= 0; plytyp--) {
								var pt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid])[plytyp];
								for (var bettyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid][pt]).length - 1; bettyp >= 0; bettyp--) {
									var bt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid][pt])[bettyp];
									if (this.$store.getters.sortedMatchEventList.sp && this.$store.getters.sortedMatchEventList.sp[eveid]) {
										if (this.$store.getters.sortedMatchEventList.sp[eveid].od[pt]) {
											if (this.$store.getters.sortedMatchEventList.sp[eveid].od[pt][bt]) {
												this.pickMarket(this.$store.getters.sortedMatchEventList.sp[eveid], pt, bt, true);
											}
										}
									}
								}
							}
						}
					}
				}
			}
			return {};
		},
		pickMarket: function pickMarket(market, plytyp, bettyp) {
			var isSpecial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

			if (this.myMarketList) {
				if (!isSpecial) {
					if (!this.myMarketList.od[plytyp]) {
						this.$set(this.myMarketList.od, plytyp, {});
					}
					this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp]);
				} else {
					!this.myMarketList.sp ? this.$set(this.myMarketList, 'sp', {}) : this.myMarketList.sp;
					!this.myMarketList.sp[market.eveid] ? this.$set(this.myMarketList.sp, market.eveid, {}) : this.myMarketList.sp[market.eveid];

					var copyMarket = _.cloneDeep(market);
					_.unset(copyMarket, 'od');
					_.assign(this.myMarketList.sp[market.eveid], copyMarket);

					!this.myMarketList.sp[market.eveid].od ? this.$set(this.myMarketList.sp[market.eveid], 'od', {}) : this.myMarketList.sp[market.eveid].od;
					!this.myMarketList.sp[market.eveid].od[plytyp] ? this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {}) : this.myMarketList.sp[market.eveid].od[plytyp];
					this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp]);
				}
			} else {
				this.myMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList);
				this.$set(this.myMarketList, 'od', {});
				this.$set(this.myMarketList, 'sp', {});
				if (!isSpecial) {
					this.$set(this.myMarketList.od, plytyp, {});
					this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp]);
				} else {
					this.$set(this.myMarketList.sp, market.eveid, _.cloneDeep(market));
					this.$set(this.myMarketList.sp[market.eveid], 'od', {});
					this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {});
					this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp]);
				}
				this.showMyMarkets = true;
			}
			!isSpecial ? this.updateFavCookie(plytyp, bettyp, false) : this.updateFavCookie(plytyp, bettyp, false, market);
			!isSpecial ? this.$delete(this.mainMarketList.od[plytyp], bettyp) : this.$delete(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp);
		},
		removeFromMyMarket: function removeFromMyMarket(market, plytyp, bettyp) {
			var isSpecial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

			if (!isSpecial) {
				this.$set(this.mainMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp]);
				if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[plytyp]).length > 1) this.$delete(this.myMarketList.od[plytyp], bettyp);else this.$delete(this.myMarketList.od, plytyp);

				if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.od).length == 0) this.myMarketList = null;
			} else {
				this.$set(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp]);
				if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp[market.eveid].od[plytyp]).length > 1) this.$delete(this.myMarketList.sp[market.eveid].od[plytyp], bettyp);else this.$delete(this.myMarketList.sp[market.eveid].od, plytyp);

				if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp[market.eveid].od).length == 0) this.$delete(this.myMarketList.sp, market.eveid);
				if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp).length == 0) this.$delete(this.myMarketList, 'sp');
			}

			!isSpecial ? this.updateFavCookie(plytyp, bettyp, true) : this.updateFavCookie(plytyp, bettyp, true, market);
		},
		getHdpOUOdd: function getHdpOUOdd(event) {
			if (event.od[this.ftPlyType]) event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.firstHtPlyType]) event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.setHandicapPlyType]) event.od[this.setHandicapPlyType] = _.pick(event.od[this.setHandicapPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.pointHandicapPlyType]) event.od[this.pointHandicapPlyType] = _.pick(event.od[this.pointHandicapPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.iotPlyType]) event.od[this.iotPlyType] = _.pick(event.od[this.iotPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.gameHdpPlyType]) event.od[this.gameHdpPlyType] = _.pick(event.od[this.gameHdpPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.firstSetPlyType]) event.od[this.firstSetPlyType] = _.pick(event.od[this.firstSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.secondSetPlyType]) event.od[this.secondSetPlyType] = _.pick(event.od[this.secondSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.thirdSetPlyType]) event.od[this.thirdSetPlyType] = _.pick(event.od[this.thirdSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.fourthSetPlyType]) event.od[this.fourthSetPlyType] = _.pick(event.od[this.fourthSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.fifthSetPlyType]) event.od[this.fifthSetPlyType] = _.pick(event.od[this.fifthSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.sixthSetPlyType]) event.od[this.sixthSetPlyType] = _.pick(event.od[this.sixthSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game1PlyType]) event.od[this.game1PlyType] = _.pick(event.od[this.game1PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game2PlyType]) event.od[this.game2PlyType] = _.pick(event.od[this.game2PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game3PlyType]) event.od[this.game3PlyType] = _.pick(event.od[this.game3PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game4PlyType]) event.od[this.game4PlyType] = _.pick(event.od[this.game4PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game5PlyType]) event.od[this.game5PlyType] = _.pick(event.od[this.game5PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.SecondHtPlyType]) event.od[this.SecondHtPlyType] = _.pick(event.od[this.SecondHtPlyType], this.marketSelect.hdpou.value);

			return event;
		},
		getScoreMarketOdd: function getScoreMarketOdd(event) {
			if (event.od[this.ftPlyType]) event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.firstHtPlyType]) event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.setHandicapPlyType]) event.od[this.setHandicapPlyType] = _.pick(event.od[this.setHandicapPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.pointHandicapPlyType]) event.od[this.pointHandicapPlyType] = _.pick(event.od[this.pointHandicapPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.iotPlyType]) event.od[this.iotPlyType] = _.pick(event.od[this.iotPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.gameHdpPlyType]) event.od[this.gameHdpPlyType] = _.pick(event.od[this.gameHdpPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.firstSetPlyType]) event.od[this.firstSetPlyType] = _.pick(event.od[this.firstSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.secondSetPlyType]) event.od[this.secondSetPlyType] = _.pick(event.od[this.secondSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.thirdSetPlyType]) event.od[this.thirdSetPlyType] = _.pick(event.od[this.thirdSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.fourthSetPlyType]) event.od[this.fourthSetPlyType] = _.pick(event.od[this.fourthSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.fifthSetPlyType]) event.od[this.fifthSetPlyType] = _.pick(event.od[this.fifthSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.sixthSetPlyType]) event.od[this.sixthSetPlyType] = _.pick(event.od[this.sixthSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game1PlyType]) event.od[this.game1PlyType] = _.pick(event.od[this.game1PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game2PlyType]) event.od[this.game2PlyType] = _.pick(event.od[this.game2PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game3PlyType]) event.od[this.game3PlyType] = _.pick(event.od[this.game3PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game4PlyType]) event.od[this.game4PlyType] = _.pick(event.od[this.game4PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game5PlyType]) event.od[this.game5PlyType] = _.pick(event.od[this.game5PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.SecondHtPlyType]) event.od[this.SecondHtPlyType] = _.pick(event.od[this.SecondHtPlyType], this.marketSelect.scrMarket.value);

			return event;
		},
		chooseMarketType: function chooseMarketType(market, id) {
			if (market.flag) {
				this.selectedMarket = market.key;
			}
			this.switchAllBetTab(id);
		},
		sortSpecialEvents: function sortSpecialEvents(specialEvents) {
			$.each(specialEvents.sp, function (key, value) {
				if (specialEvents.sp_rbinfo && specialEvents.sp_rbinfo[key]) {
					specialEvents.sp[key].sprbinfo = specialEvents.sp_rbinfo[key];
				}
			});
			return _.sortBy(specialEvents.sp, ['no']);
		},
		switchAllBetTab: function switchAllBetTab(id) {
			$('.moreBetTypeNav-Item').removeClass('active');
			$(id).addClass('active');
		}
	},
	beforeMount: function beforeMount() {
		if (this.mode == 'firstEvent') {
			this.mainMarketList = _.cloneDeep(this.$store.getters.firstEvent);
		} else {
			this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList);
		}
		this.bbPlaytype = [this.first5InningsPlayType, this.first3InningsPlayType, this.firstInningsPlayType, this.secondInningsPlayType, this.thirdInningsPlayType, this.fourthInningsPlayType, this.fifthInningsPlayType, this.sixthInningsPlayType, this.seventhInningsPlayType, this.eightthInningsPlayType, this.nineInningsPlayType, this.OTPlayType];

		this.getFavCookieMarket();
	},
	updated: function updated() {
		var _this = this;

		if (this.$store.getters.rightBoardChange != null) {
			$('#firstEventallBetGroup' + this.$store.getters.rightBoardChange.eveid + ' .c-bet-item').removeClass('active');
			this.$store.getters.betForm.forEach(function (value) {
				var MID = value.uniqueId;
				var prt = $('#firstEventallBetGroup' + _this.$store.getters.rightBoardChange.eveid + ' #' + MID);
				if (prt.length > 0) {
					prt.closest('.c-bet-item').addClass('active');
				}
			});
			this.$store.commit('RIGHT_BOARD_CHG', null);
		}
	},
	destroyed: function destroyed() {}
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__all_bet_team_info_sc__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__all_bet_team_info_tn__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */]],
  components: {
    allBetSoccer: __WEBPACK_IMPORTED_MODULE_4__all_bet_team_info_sc__["a" /* default */],
    allBetTennis: __WEBPACK_IMPORTED_MODULE_5__all_bet_team_info_tn__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['eventAllBet', 'selectedBettype', 'selectedMarket'])),
  methods: {
    sportListByKey: function sportListByKey() {
      return _.keyBy(this.$store.getters.sportList, 'sprtId');
    },
    getSportBackgroundImage: function getSportBackgroundImage() {
      var isRbInfo = this.$store.getters.eventAllBet.rbinfo ? true : false;
      switch (this.$store.getters.selectedBettype.sprtId) {
        case this.sportListByKey().N1.sprtId:
          return 'more_bg_table';
          break;
        case this.sportListByKey().G1.sprtId:
          return isRbInfo ? 'more_bg_table_bkr' : 'more_bg_table_bk';
          break;
        case this.sportListByKey().N3.sprtId:
          return isRbInfo ? 'more_bg_table_tnr' : 'more_bg_table_tn';
          break;
        case this.sportListByKey().N21.sprtId:
          return isRbInfo ? 'more_bg_table_vbr' : 'more_bg_table_vb';
          break;
        case this.sportListByKey().N12.sprtId:
          return isRbInfo ? 'more_bg_table_bmr' : 'more_bg_table_bm';
          break;

        case this.sportListByKey().N15.sprtId:
          return isRbInfo ? 'more_bg_table_skr' : 'more_bg_table_sk';
          break;

        default:
          return 'more_bg_table';
          break;
      }
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(0);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__vue_mixins_allBet__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['eventAllBet', 'sportTableLang', 'sportAllBetLang', 'selectedMarket']))
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['eventAllBet', 'sportAllBetLang', 'eventAllBet']))
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,

    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().hdpBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rhdpBetType],
      show: true,
      shdp: ['7', '8', '9', '10', '11', '12'],
      gamePt: ['14', '15', '16', '17', '18'],
      pt: {
        7: '1',
        8: '2',
        9: '3',
        10: '4',
        11: '5',
        12: '6'
      },
      gamePtLang: {
        '14': '1',
        '15': '2',
        '16': '3',
        '17': '4',
        '18': '5'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = '';
      var title = '';
      var sCapt = '';
      if (this.plytyp == this.ftPlyType) {
        a = '_FT';
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H';
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP';
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP';
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP';
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') {
        a = '_' + this.pt[this.plytyp] + 'SET';
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') {
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME';
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS';
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS';
      } else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS';
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS';
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS';
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS';
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS';
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS';
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS';
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS';
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS';
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME';
      }

      var pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a];
      var bt = this.sportAllBetLang['ALL_BET.SUBHEADER_HDP'];
      if (this.newAllBetEvent.event_rb == 1 && this.newAllBetEvent.rbinfo && this.newAllBetEvent.sptid == 1) {
        bt += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')';
      }

      if (this.isSpecial) {
        var st = this.specialLeagueCaption(this.newAllBetEvent, this.bettyp);
        sCapt = ' ' + st + ' (' + this.sportAllBetLang['ALL_BET.LBL_SPECIALS'] + ')';
      }
      return pt + bt + sCapt;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, hdpBetType) {
      if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, hdpBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, hdpBetType) {
      if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, hdpBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_directives_globalClickEvent__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_accounting__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_mixins_forecastCalculation__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apps_home_contentsLeft_bettingFormFooter__ = __webpack_require__(103);

















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__vue_mixins_forecastCalculation__["a" /* default */]],
  components: {
    bettingFormFooter: __WEBPACK_IMPORTED_MODULE_12__apps_home_contentsLeft_bettingFormFooter__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['BetTypeLang', 'langList', 'selectedMarket', "selectedBettype", 'selectedSport', "betting", 'requestAllow', 'isProcessBet', 'isPlacedBet', 'hdpDisp', 'sportAllBetLang', 'jsError', 'oddTypesList', 'sportMiniBet', 'mulpSetting', 'isBetCombo', 'betComboAmount', 'betCombo_jsError', 'promotionFlag', 'promotionBetStatus', 'betMulpAmount', 'betMulpAmtFiltered', 'isParlayTab', 'previousBettype', 'bettypeList', 'selectedMulpBetBoxId', 'bettypeFeature']), {
    betAmount: {
      get: function get() {
        var fixedAccountingNumber = parseInt(this.$store.getters.sportMiniBet.betAmount);
        var res = this.$store.getters.sportMiniBet.betAmount == 0 ? "" : this.commasAmount(fixedAccountingNumber);

        if (this.selectedBettype.betTypId != "5" && this.$store.getters.account.rememberStake && __WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting') && this.$store.getters.sportMiniBet.betAmount == 0) {
          var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
          var bamt = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(b.stkAmt, 0);
          res = bamt == 0 ? '' : this.commasAmount(bamt);
          this.betAmount = res;
          this.possiblePayout;
          if (this.$refs.betAmount && this.$refs.betAmount.length > 0) {
            this.$refs.betAmount[0].focus();
          }
        }
        return res;
      },
      set: function set(value) {
        var fixedAccountingNumber = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(value, 0);

        if (this.$store.getters.account.currCL < parseInt(fixedAccountingNumber)) {
          fixedAccountingNumber = this.$store.getters.account.currCL;
        }

        if (this.$store.getters.account.oddsType == 'in' && this.$store.getters.betForm[0].odd <= 0) {
          fixedAccountingNumber = parseInt(parseInt(this.$store.getters.account.currCL) / Math.abs(this.$store.getters.betForm[0].odd));
        }
        this.$store.commit("SPORT_MINIBET_BETAMOUNT", fixedAccountingNumber);

        var b = '';
        if (__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting')) {
          b = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
        }
        if (b == '' || b && (b.rmbStk != value || b.stkAmt != this.$store.getters.sportMiniBet.betAmount)) {
          this.usualStakeAmount = fixedAccountingNumber;
        }
        this.JSErr = '';

        var remainingBal = this.$store.getters.account.currCL - parseInt(fixedAccountingNumber);

        if (this.$store.getters.account.oddsType == 'in' && this.$store.getters.betForm[0].odd <= 0) {
          remainingBal = parseInt(parseInt(this.$store.getters.account.currCL) - parseInt(fixedAccountingNumber) * Math.abs(this.$store.getters.betForm[0].odd));
        }
        this.setKeyboardSettings('-1', remainingBal);

        if (value != fixedAccountingNumber) {
          this.betAmount = fixedAccountingNumber;
        }
      }
    },
    betComboAmount: {
      get: function get() {
        var betAmountArr = this.$store.getters.betComboAmount;

        if (this.selectedBettype.betTypId != "5" && this.$store.getters.account.rememberStake && __WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting') && this.betFormList.length == 1) {
          var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
          var bamt = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(b.stkAmt, 0);
          var res = bamt == 0 ? '' : this.commasAmount(bamt);
          betAmountArr[0].value = res;
        }

        return betAmountArr;
      },
      set: function set(arr) {
        this.$store.commit("BETCOMBO_AMOUNT", arr);
        this.JSErr = '';

        if (this.selectedBettype.betTypId != "5" && this.$store.getters.account.rememberStake && __WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting') && this.betFormList.length == 1) {
          var b = '';
          b = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
          if (b == '' || b && b.stkAmt != parseInt(arr.amount)) {
            this.usualStakeAmount = arr.amount;
          }
        }
      }
    },
    betComboKeyboardAllow: {
      get: function get() {
        var betComboKeyboardArr = this.$store.getters.betComboKeyboardAllow;
        return betComboKeyboardArr;
      },
      set: function set(arr) {
        this.$store.commit("BETCOMBO_KEYBOARDALLOW", arr);
      }
    },
    usualStakeAmount: {
      get: function get() {},
      set: function set(value) {
        var b = '';
        if (__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting')) {
          b = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_stakeSetting'));
        }
        if (b && parseInt(value) != b.stkAmt) {
          var stkset = {
            rmbStk: b.rmbStk,
            stkAmt: value
          };
          $.ajax({
            method: 'post',
            url: _baseUrl + '/callCookies',
            data: {
              action: 'rememberStk',
              stkSetting: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(stkset),
              acc_code: this.$store.getters.account.acccode
            }
          }).done(function (res) {});
        }
      }
    },
    betAllUp: {
      get: function get() {
        if (this.selectedBettype.betTypId == '6' && this.$store.getters.betting.selectedBetAllup != null) {
          var totalBetSlip = this.$store.getters.betting.selectedBetAllup.split('x');
          if (this.$store.getters.betAmount && this.$store.getters.betAmount > 0) {
            this.totalStake = this.$store.getters.betAmount * totalBetSlip[1];
          } else {
            this.totalStake = 0;
          }

          this.totalBet = totalBetSlip[1];
        }
        return this.$store.getters.betting.selectedBetAllup;
      },
      set: function set(value) {
        this.$store.commit("BETTING_ALLUP", value);
      }
    },
    possiblePayout: function possiblePayout() {
      var oddValue = "";
      if (this.isMulp) {
        var amount = 0;
        var allUpIndex = _.findIndex(this.betting.allUpList, {
          key: this.$store.getters.betting.selectedBetAllup
        });
        var mulpParser = this.betting.allUpList[allUpIndex].parser.split("#");
        for (var index = 0; index < mulpParser.length; index++) {
          var commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (var comma = 0; comma < commaList.length; comma++) {
            var betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if (this.$store.getters.account.oddsType == 'am') {
              if (betOdd < 0) {
                betOdd = Math.abs(100 / betOdd) + 1;
              } else {
                betOdd = betOdd / 100 + 1;
              }

              betOdd = betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          amount += this.betAmount * oddValue;
        }

        return amount;
      } else {
        var betOdd = parseFloat(this.$store.getters.betForm[0].odd);
        oddValue = betOdd < 0 && (this.$store.getters.account.oddsType == 'my' || this.$store.getters.account.oddsType == 'in') ? 1 : this.validateOddBetType(this.$store.getters.betForm[0].betType, this.$store.getters.betForm[0].odd);
      }

      return this.$store.getters.sportMiniBet.betAmount * oddValue;
    },

    betFormList: function betFormList() {
      return this.$store.getters.betForm;
    },
    isBetCombo: {
      get: function get() {
        return this.$store.getters.isBetCombo;
      },
      set: function set(value) {
        var _this = this;

        var bet = this.betting;
        if (!value && this.betFormList.length > 1 && !bet.pending && !bet.success) {
          this.$store.dispatch("removeMatch", {
            data: { clearType: '2' },
            callback: function () {
              _this.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this.$store.commit("IS_BETCOMBO", value);
                  _this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this.$store.getters.betForm
                  });

                  _this.refreshTimer();
                  _this.isReloading = false;
                }.bind(_this)
              });
            }.bind(this)
          });
        } else if (!bet.pending && !bet.success) {
          this.$store.dispatch("getBettingInfo", {
            isBetCombo: value,
            callback: function (res) {
              _this.$store.commit("IS_BETCOMBO", value);
              _this.$store.commit("SPORT_MAPPING_BETTING", {
                newBettingList: res.SYSTEM_DATA.betting,
                oldBettingList: _this.$store.getters.betForm
              });

              if (_this.$store.getters.isBetCombo && _this.betFormList.length == 1) {
                var singleBetAmount = _this.$store.getters.sportMiniBet.betAmount;
                var betAmountArr = _this.$store.getters.betComboAmount;
                if (singleBetAmount != '' && singleBetAmount != '0') {
                  var arr = { index: 0, amount: singleBetAmount };
                  _this.betComboAmount = arr;
                }

                if (_this.$store.getters.betComboAmount[0].value != '') {
                  var amt = _this.$store.getters.betComboAmount[0].value;
                  var betAmt = amt != '' || amt != 0 ? parseInt(amt.replace(",", "")) : 0;
                  var remainingBal = _this.$store.getters.account.currCL - betAmt;
                  _this.setKeyboardSettings(0, remainingBal);
                }
              } else {
                var _betAmountArr = _this.$store.getters.betComboAmount[0].value;
                var fixedAccountingNumber = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(_betAmountArr, 0);
                _this.$store.commit("SPORT_MINIBET_BETAMOUNT", fixedAccountingNumber);
                if (fixedAccountingNumber != '') {
                  var amt = fixedAccountingNumber;
                  var betAmt = amt != '' || amt != 0 ? parseInt(amt.replace(",", "")) : 0;
                  var remainingBal = _this.$store.getters.account.currCL - betAmt;
                  _this.setKeyboardSettings('-1', remainingBal);
                }
              }

              _this.refreshTimer();
              _this.isReloading = false;
            }.bind(this)
          });
        } else {
          this.$store.commit("IS_BETCOMBO", value);
        }
      }
    },
    betMulpAmount: {
      get: function get() {
        var betMulpArr = this.$store.getters.betMulpAmount;
        return betMulpArr;
      },
      set: function set(arr) {
        if (!_.isUndefined(arr.index) && !_.isUndefined(arr.allUp) && !_.isUndefined(arr.amount)) {
          arr = this.mulpPossiblePayout(arr);
          this.$store.commit("BETMULP_AMOUNT", arr);
          this.JSErr = '';

          var ttlMulpAmt = this.countTotalStakePayout('totalStake');
          var currCL = parseInt(this.$store.getters.account.currCL);

          if (currCL < ttlMulpAmt) {
            var allUpKey = this.$store.getters.betMulpAmount[arr.index].allUp;
            var totalBetSlip = allUpKey.split('x');
            var remainingAmt = currCL - (ttlMulpAmt - Number(this.$store.getters.betMulpAmount[arr.index].stake == '' ? 0 : this.$store.getters.betMulpAmount[arr.index].stake.replaceAll(",", "")));
            if (remainingAmt >= 0) {
              arr.amount = Math.floor(remainingAmt / parseInt(totalBetSlip[1]));
            } else {
              arr.amount = '';
            }
            arr = this.mulpPossiblePayout(arr);
            this.$store.commit("BETMULP_AMOUNT", arr);

            ttlMulpAmt = this.countTotalStakePayout('totalStake');
          }

          var remainingBal = currCL - parseInt(ttlMulpAmt);
          this.setKeyboardSettings('-1', remainingBal);
        }
      }
    }
  }),
  props: {},
  data: function data() {
    return {
      isQuickBet: false,
      betMinMaxVal: '',
      showExpandMini: true,
      selectedLang: window._langid,
      hoverInfo: false,
      isMulp: false,
      odChgClass: '',
      showMULPopt: false,
      JSErr: '',
      pendingTimerId: null,
      showModal: false,
      isDragging: false,
      offset: { x: 0, y: 0 },

      multipleBetToggle: true,
      hasParlay: false,
      mulpOdds: 0,
      amountMaxLength: window.amountMaxLength,
      allowRbParlay: window.allowRbParlay
    };
  },

  watch: {
    betFormList: {
      handler: function handler(val, oldVal) {
        var _this2 = this;

        var vue = this;
        if (!this.allowRbParlay && this.$store.getters.isBetParlay && val.length == 0 && this.selectedBettype.betTypId != "5") {
          this.$store.commit("IS_BETPARLAY", false);
        }

        if (this.$store.getters.isBetParlay && val.length > 0 && this.selectedBettype.betTypId != "5") {
          this.updateParlay();
        }

        if (val.length == 0) {
          this.$store.commit("SPORT_MINIBET_TOGGLE", false);
        }
        this.isMulpDayExceed = false;

        if (this.$store.getters.betting.pending) {
          var pendingWagerIds = this.$store.getters.isBetCombo ? _.map(_.filter(val, { wgStatus: '1' }), 'WagerID') : [this.$store.getters.betting.pending.data.WagerID];
          if (this.isMulp) {
            pendingWagerIds = [];
            _.forEach(this.$store.getters.betting.pending.data.mulpRes, function (value, key) {
              pendingWagerIds.push(value.WagerID);
            }.bind(this));
          }
          this.checkPendingWager(pendingWagerIds);
        }

        if (val.length > 0) {
          this.$nextTick(function () {
            if (_this2.$store.getters.isBetCombo) {
              if (_this2.betFormList.length > 1) {
                if (_this2.$refs.betAmount) {
                  _this2.$refs.betAmount.focus();
                }
              } else {
                if (_this2.$refs.betAmount0 && _this2.$refs.betAmount0.length > 0) {
                  _this2.$refs.betAmount0[0].focus();
                }
              }
            } else if (_this2.selectedBettype.betTypId == "5") {
              if (_this2.betting && _this2.betting.minMax && _this2.betFormList.length >= _this2.betting.minMax.minCombo) {
                if ($('.bet-input')[_this2.selectedMulpBetBoxId] != undefined) {
                  $('.bet-input')[_this2.selectedMulpBetBoxId].focus();
                }
              }
            } else {
              if (_this2.$refs.betAmount && _this2.$refs.betAmount.length > 0) {
                _this2.$refs.betAmount[0].focus();
              }
            }
          });
        }
        if (!this.betting.error) {
          this.betMinMax();
        }
        if (this.selectedBettype.betTypId == "5") {
          if (val.length > 0) {
            this.$store.commit("IS_BETPARLAY", true);
          }
          var smallDate = null;
          var bigDate = null;
          _.forEach(val, function (value) {
            if (value.oddChg == true || value.hdpChg == true) {
              _this2.$store.commit("BETMULP_AMOUNT", { clear: true });
            }

            var eventDate = "";
            if (value.eventObj && value.eventObj.dt) {
              var onlyDate = new __WEBPACK_IMPORTED_MODULE_6_moment___default.a(value.eventObj.dt).format("YYYY-MM-DD 00:00:00");
              eventDate = new __WEBPACK_IMPORTED_MODULE_6_moment___default.a(onlyDate);
            }
            if (eventDate != "") {
              if (smallDate == null && bigDate == null) {
                smallDate = eventDate;
                bigDate = eventDate;
              }

              if (smallDate.diff(eventDate, "days") > 0) {
                smallDate = eventDate;
              } else if (eventDate.diff(bigDate, "days") > 0) {
                bigDate = eventDate;
              }

              if (bigDate.diff(smallDate, "days") >= 7) {
                _this2.isMulpDayExceed = true;
              }
            }
          }.bind(this));
          this.isMulp = true;
          this.hasParlay = true;
        } else {
          this.isMulp = false;
          this.hasParlay = false;
          if (val && val.length > 0) {
            if (this.isBetCombo) {
              var stopLoop = false;
              _.forEach(val, function (arr, key) {
                if (stopLoop) return;
                for (var index = 0; index < vue.$store.getters.eventList.length; index++) {
                  var eid = _.findIndex(vue.$store.getters.eventList[index], function (e) {
                    return e.eveid == arr.eveid;
                  });
                  if (eid > -1) {
                    var event = vue.$store.getters.eventList[index][eid];
                    if (event.sptid == '1') {
                      vue.hasParlay = true;
                      if (!vue.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                        vue.hasParlay = false;
                        stopLoop = true;
                      }
                    } else {
                      if (event.sptid == '2' && event.lgeflag == '0' && !event.rbinfo && event.rbstatus != '1') {
                        vue.hasParlay = true;
                      } else {
                        if (vue.hasParlay) {
                          vue.hasParlay = false;
                          stopLoop = true;
                        }
                      }
                    }
                    break;
                  }
                }
                for (var _index = 0; _index < vue.$store.getters.rbeventList.length; _index++) {
                  var eid = _.findIndex(vue.$store.getters.rbeventList[_index], function (e) {
                    return e.eveid == arr.eveid;
                  });
                  if (eid > -1) {
                    var event = vue.$store.getters.rbeventList[_index][eid];
                    if (event.sptid == '1') {
                      vue.hasParlay = true;
                      if (!vue.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                        vue.hasParlay = false;
                        stopLoop = true;
                      }
                    } else {
                      if (vue.hasParlay) {
                        vue.hasParlay = false;
                        stopLoop = true;
                      }
                    }
                    break;
                  }
                }
              });
            } else {
              var eventId = val[0].eveid;
              for (var index = 0; index < vue.$store.getters.eventList.length; index++) {
                var eid = _.findIndex(vue.$store.getters.eventList[index], function (e) {
                  return e.eveid == eventId;
                });
                if (eid > -1) {
                  var event = vue.$store.getters.eventList[index][eid];
                  if (event.sptid == '1') {
                    this.hasParlay = true;
                    if (!this.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                      this.hasParlay = false;
                    }
                  } else {
                    if (event.sptid == '2' && event.lgeflag == '0' && !event.rbinfo && event.rbstatus != '1') {
                      this.hasParlay = true;
                    }
                  }
                  break;
                }
              }

              for (var _index2 = 0; _index2 < vue.$store.getters.rbeventList.length; _index2++) {
                var eid = _.findIndex(vue.$store.getters.rbeventList[_index2], function (e) {
                  return e.eveid == eventId;
                });
                if (eid > -1) {
                  var event = vue.$store.getters.rbeventList[_index2][eid];
                  if (event.sptid == '1') {
                    this.hasParlay = true;
                    if (!this.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                      this.hasParlay = false;
                    }
                  }
                  break;
                }
              }
            }
          }
        }

        if (this.bettypeFeature && this.bettypeFeature.indexOf('15') !== -1) {
          this.hasParlay = false;
        }
      },
      deep: true,
      immediate: true
    },
    jsError: {
      handler: function handler(value, oldVal) {
        if (value.error && value.errorId == '4') {
          this.JSErr = 'input-border-red';
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    startDrag: function startDrag(e) {
      if (e.target.id === "singleContainer") return;
      var touch = e.touches[0];
      this.isDragging = true;
      this.offset.x = touch.clientX - this.$refs.miniBetModal.offsetLeft;
      this.offset.y = touch.clientY - this.$refs.miniBetModal.offsetTop;
    },
    drag: function drag(e) {
      if (!this.isDragging) return;
      if (e.target.id === "singleContainer") return;
      e.preventDefault();
      var touch = e.touches[0];
      this.$refs.miniBetModal.style.left = touch.clientX - this.offset.x + "px";
      this.$refs.miniBetModal.style.top = touch.clientY - this.offset.y + "px";
    },
    endDrag: function endDrag() {
      this.isDragging = false;
    },
    getOddChange: function getOddChange(data) {
      var sts = '';
      if (this.betting.success || this.betting.pending || this.betting.betcombosuccess) {
        return sts;
      }

      if (data.oddChg && data.oddChgUpDown == 'up') {
        sts = 'up-red';
      } else if (data.oddChg && data.oddChgUpDown == 'down') {
        sts = 'down-green';
      }
      return sts;
    },
    getBetConfirmClass: function getBetConfirmClass(data, key) {
      if ((data.hdpChg || data.oddChg) && _.isUndefined(data.wgStatus) && _.isUndefined(data.error) && data.error != '') {
        return '';
      }

      if (this.betting.success || this.$store.getters.isBetCombo && this.wgSuccess.indexOf(data.wgStatus) !== -1) {
        return 'bet-success-order';
      } else if (this.betting.pending && data.wgStatus == 1) {
        return 'bet-pending-order';
      } else {
        var singleLine = this.jsError.error || !_.isUndefined(this.betCombo_jsError[key]) && this.betCombo_jsError[key].error ? ' bet-js-error' : '';
        return 'bet-fail-order' + singleLine;
      }
      hdpChg;
    },
    checkShowErrMsg: function checkShowErrMsg(data, jsErr, key) {
      if (data.error || jsErr.error || data.oddChg || data.hdpChg || this.wgSts.indexOf(data.wgStatus) !== -1 || !_.isUndefined(this.betCombo_jsError[key]) && this.betCombo_jsError[key].error) {
        return true;
      }
    },
    bettingResultClass: function bettingResultClass(data, key) {
      var index = key + 1;
      var b = key != 0 ? ' mt5' : '';
      var last = index == this.betFormList.length ? ' last-item' : '';
      var err = data.error || this.betting.error || data.wgStatus == '-1' ? ' bet-no-effect' : '';
      var single = this.chkBettingSuccess(data) || this.chkBetPending(data) ? ' bet-single-record ' : '';
      var res = this.chkIsBetting(data) || this.chkBetPending(data) || data.wgStatus == '-1' ? ' relative-position bet-card bet-single-item-card' : '';

      return err + single + last + res + b;
    },
    chkIsBetting: function chkIsBetting(data, where) {
      var isBC = this.$store.getters.isBetCombo;
      var r = false;
      if (isBC) {
        if (_.isUndefined(data.WagerID) && $.inArray(data.wgStatus, ['0', '1', '-1', '2']) < 0) {
          r = true;
        }
      } else {
        if (!this.betting.success && _.isUndefined(data.wgStatus)) {
          r = true;
        }
      }
      return r;
    },
    chkBetSuccessPending: function chkBetSuccessPending(data, from) {
      var isBC = this.$store.getters.isBetCombo;
      var r = false;
      if (isBC) {
        if (!_.isUndefined(data.WagerID) && _.isUndefined(data.error) && $.inArray(data.wgStatus, ['0', '2']) > -1) {
          r = true;
        } else if (!_.isUndefined(data.WagerID) && data.wgStatus == '1' && this.betting.pending) {
          r = true;
        }
      } else {
        if (this.betting.success) {
          r = true;
        } else if ($.inArray(data.betType, this.rbBetTypeList) > -1 && data.wgStatus == '1' && this.betting.pending) {
          r = true;
        }
      }

      return r;
    },
    chkBettingSuccess: function chkBettingSuccess(data, where) {
      var isBC = this.$store.getters.isBetCombo;
      var r = false;
      if (isBC) {
        if (!_.isUndefined(data.WagerID) && _.isUndefined(data.error) && $.inArray(data.wgStatus, ['0', '2']) > -1) {
          r = true;
        } else if (this.betting.success) {
          r = true;
        }
      } else {
        if (this.betting.success) {
          r = true;
        }
      }

      return r;
    },
    chkBetPending: function chkBetPending(data, where) {
      var isBC = this.$store.getters.isBetCombo;
      var r = false;
      if (isBC) {
        if (data.wgStatus == '1' && this.betting.pending) {
          r = true;
        }
      } else {
        if ($.inArray(data.betType, this.rbBetTypeList) > -1 && data.wgStatus == '1' && this.betting.pending) {
          r = true;
        }
      }

      return r;
    },
    selAllUp: function selAllUp(allupKey) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var VUE = this;
      var ttlBet = 0;
      this.betAllUp = allupKey;
      if (action == null && action != '1') {
        this.toggleMULPopt();
      }

      if (mulpSetting[VUE.betAllUp]) {
        var ccBr = 0;
        $.each(mulpSetting[VUE.betAllUp], function (listup, cbet) {
          ttlBet += cbet;
        });
        this.totalBet = ttlBet;
      }
    },
    toggleMULPopt: function toggleMULPopt() {
      this.showMULPopt = !this.showMULPopt;
    },
    getMulpCaption: function getMulpCaption(betLang, allup) {
      var Mchar = allup.split("x");
      if (Mchar[1] == '1') {
        return betLang["BETTING.LBL_PARLAY_" + allup] + " X 1";
      } else {
        if (mulpSetting[allup]) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mulpSetting[allup]).length > 0) {
            var ccBr = 0;
            var countMBet = 0;
            var lastKey = "";
            $.each(mulpSetting[allup], function (listup, cbet) {
              ccBr += 1;
              countMBet += cbet;
              lastKey = listup;
            });
            if (ccBr == 1) {
              if (lastKey != "") {
                return betLang["BETTING.LBL_PARLAY_" + lastKey] + " X " + countMBet;
              }
            } else {
              var cap = betLang["BETTING.LBL_YANKEE"];
              if (ccBr > 2) {
                cap = betLang["BETTING.LBL_SUPER_YANKEE"];
              }

              if (cap == "Super Yankee" || cap == "Yankee") {
                return cap + " X " + countMBet;
              } else {
                return Mchar[0] + cap + countMBet + " X " + countMBet;
              }
            }
          }
        }
      }
      return allup;
    },
    getHdpCapt: function getHdpCapt(data) {
      if (data.hdp == 0 && (data.betType == '1' || data.betType == '8')) {
        return '0';
      }
      var str = '';
      if (data.fav == data.tbet) {
        if (data.betType == '1' || data.betType == '8') {
          str = '-';
        }
      } else {
        if (data.betType == '1' || data.betType == '8') {
          str = '+';
        }
      }
      var strCap = !_.isUndefined(data.hdpCap) ? data.hdpCap : data.hdp;

      if (str != '' && strCap.toString().indexOf(str) == 0) {
        str = '';
      }

      return str + strCap;
    },
    betSuccessPPayout: function betSuccessPPayout(dataArr, selectedBetAllup) {
      var data = dataArr;

      if (selectedBetAllup == null) {
        if (this.$store.getters.isBetCombo) {
          var betOdd = data.odd ? parseFloat(data.odd) : parseFloat(data.betting[0].odd);
          var betOdd2 = data.odd ? data.odd : data.betting[0].odd;
          var betType = data.betType ? data.betType : data.betting[0].betType;
          var oddValue = betOdd < 0 && (this.$store.getters.account.oddsType == 'my' || this.$store.getters.account.oddsType == 'in') ? 1 : this.validateOddBetType(betType, betOdd2);

          return data.betAmt * oddValue;
        } else {
          if (this.betting.success) {
            data = this.betting.success.data;
          } else if (this.betting.pending) {
            data = this.betting.pending.data;
          }

          var betOdd = parseFloat(data.betting[0].odd);
          var oddValue = betOdd < 0 && (this.$store.getters.account.oddsType == 'my' || this.$store.getters.account.oddsType == 'in') ? 1 : this.validateOddBetType(data.betting[0].betType, data.betting[0].odd);
          return data.betAmt * oddValue;
        }
      } else {
        var amount = 0;

        var allUpIndex = _.findIndex(this.betting.allUpList, {
          key: this.$store.getters.betting.selectedBetAllup
        });
        var mulpParser = this.betting.allUpList[allUpIndex].parser.split("#");
        for (var index = 0; index < mulpParser.length; index++) {
          var commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (var comma = 0; comma < commaList.length; comma++) {
            var betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if (this.$store.getters.account.oddsType == 'am') {
              if (betOdd < 0) {
                betOdd = Math.abs(100 / betOdd) + 1;
              } else {
                betOdd = betOdd / 100 + 1;
              }
              betOdd = betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          amount += this.$store.getters.sportMiniBet.betAmount * oddValue;
        }

        return amount;
      }
    },
    betMinMax: function betMinMax() {
      this.betMinMaxVal = this.sportAllBetLang['ALL_BET.LIMITS'] + ' ' + this.commasAmount(this.$store.getters.betting.minMax.min) + ' ~ ' + this.commasAmount(this.$store.getters.betting.minMax.max);
    },
    toggleMini: function toggleMini() {
      this.showExpandMini = !this.showExpandMini;
    },
    eventBetMinMax: function eventBetMinMax(data) {
      if (!_.isUndefined(data.minMax)) {
        var a = this.sportAllBetLang['ALL_BET.LIMITS'] + ' ' + this.commasAmount(data.minMax.min) + ' ~ ' + this.commasAmount(data.minMax.max);
        return a;
      }
    },
    getOddsTypeCap: function getOddsTypeCap(dt) {
      var otype = this.$store.getters.account.oddsType;
      var ot_cap = this.oddTypesList[otype.toUpperCase()].lang;
      var btList = ['1', '8', '2', '9', '3', '10', '46', '47', '48', '49'];

      if (this.isMulp || $.inArray(dt.betType, btList) == -1) {
        var str = otype == 'am' ? 'AM' : 'EU';
        ot_cap = this.oddTypesList[str].lang;
      }

      if (dt.sprtid == '255') {
        var str = 'HK';
        if ($.inArray(dt.betType, btList) == -1) {
          str = 'EU';
        }
        ot_cap = this.oddTypesList[str].lang;
      }

      return '[' + ot_cap + ']';
    },
    getPtBtCapt: function getPtBtCapt(dt) {
      var space = this.selectedLang == 1 ? ' ' : '';
      var ptCapt = '';
      var btCapt = this.BetTypeLang[dt.betType]["caption"];
      var homeAway = '';
      var res = '';

      if (dt.betType == '8') {
        btCapt = this.BetTypeLang['1']["caption"];
      } else if (dt.betType == '27') {
        btCapt = this.BetTypeLang['21']["caption"];
      } else if (dt.betType == '58') {
        btCapt = this.BetTypeLang['57']["caption"];
      } else if (dt.betType == '64') {
        btCapt = this.BetTypeLang['63']["caption"];
      } else if (dt.betType == '66') {
        btCapt = this.BetTypeLang['65']["caption"];
      } else if (dt.betType == '73') {
        btCapt = this.BetTypeLang['59']["caption"];
      } else if (dt.betType == '61') {
        btCapt = this.BetTypeLang['60']["caption"];
      } else if (dt.betType == '69') {
        btCapt = this.BetTypeLang['68']["caption"];
      } else if (dt.betType == '71') {
        btCapt = this.BetTypeLang['70']["caption"];
      }

      if (dt.betType == '14') {
        res = btCapt;
      } else {
        if (dt.plyType != '1') {
          ptCapt = this.langList.playTypeLang[dt.plyType]['caption'];
        }

        res = ptCapt + homeAway + space + btCapt;
      }

      return res;
    },
    getDecimalDisplay: function getDecimalDisplay(value, sprtid) {
      if (this.$store.getters.account.oddsType == 'am' && sprtid != 255) {
        return parseFloat(value).toFixed(0);
      }
      return parseFloat(value).toFixed(2);
    },
    allupBetting: function allupBetting(allup, betLang, selectedLang) {
      var str = "";
      if (mulpSetting[allup]) {
        var ccBr = 0;
        $.each(mulpSetting[allup], function (listup, cbet) {
          var ssAdd = "";
          if (selectedLang == 1 && parseInt(cbet) > 1) {
            ssAdd = "s";
          }
          if (betLang["BETTING.LBL_PARLAY_" + listup]) {
            if (ccBr != 0) str += "<br>";
            str += " > " + betLang["BETTING.LBL_PARLAY_" + listup] + " (" + cbet + " " + betLang["BETTING.LBL_PARLAY_BET"] + ssAdd + ")";
            ccBr = 1;
          }
        });
      }
      return str;
    },
    allupCaption: function allupCaption(allup, betLang, selectedLang) {
      var str = betLang["BETTING.LBL_PARLAY_" + allup];
      return str;
    },
    addsum: function addsum(amount) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.$store.getters.isBetCombo && !this.isMulp) {
        var amt = this.$store.getters.sportMiniBet.betAmount == '' ? 0 : this.$store.getters.sportMiniBet.betAmount;
        amount += Number(amt);

        if (this.$store.getters.account.currCL < amount) {
          amount = this.$store.getters.account.currCL;
        }
        this.betAmount = amount;
      } else if (key != null) {
        var VUE = this;
        if (this.$store.getters.isBetCombo) {
          var amt = _.isUndefined(VUE.betComboAmount[key]) ? 0 : VUE.betComboAmount[key].value.replace(",", "");
          amount += Number(amt);

          var arr = {
            index: key,
            amount: amount
          };
          VUE.betComboAmount = arr;


          var remainingBal = this.$store.getters.account.currCL - parseInt(amount);
          this.setKeyboardSettings(key, remainingBal);
        } else if (this.isMulp) {
          var amt = _.isUndefined(VUE.betMulpAmount[key]) ? 0 : VUE.betMulpAmount[key].value.replaceAll(",", "");
          amount += Number(amt);
          var arr = {
            index: key,
            allUp: VUE.betMulpAmount[key].allUp,
            amount: amount
          };
          VUE.betMulpAmount = arr;
        }
      } else {
        var VUE = this;
        var amt = VUE.allBetComboAmount == '' ? 0 : VUE.allBetComboAmount.replace(",", "");

        amount += Number(amt);
        var sum = __WEBPACK_IMPORTED_MODULE_5_accounting___default.a.toFixed(amount, 0);
        var total = sum;
        VUE.allBetComboAmount = sum == 0 ? "" : this.commasAmount(sum);
        var rBal = VUE.$store.getters.account.currCL - parseInt(total.replace(",", ""));
        VUE.setKeyboardSettings('-1', rBal);

        var remainingBal = VUE.$store.getters.account.currCL;
        $.each(VUE.betFormList, function (id, data) {
          var arr = {
            index: id,
            amount: amount,
            clear: false
          };
          VUE.betComboAmount = arr;

          remainingBal -= parseInt(VUE.$store.getters.betComboAmount[id].value.replace(",", ""));
          VUE.setKeyboardSettings(id, remainingBal);
        });
      }
    },
    clearTimer: function clearTimer() {
      clearInterval(this.pendingTimerId);

      this.pendingTimerId = null;
    },
    refreshTimer: function refreshTimer() {
      this.timerSeconds = this.fixTimer;
    },
    deleteMatch: function deleteMatch(eventid, event, key) {
      var _this3 = this;

      if (!this.isProcessBet) {
        if (this.$store.getters.isBetCombo) {

          this.$store.dispatch("removeMatch", {
            data: { clearType: '3', index: key },
            callback: function () {
              document.getElementById(event.uniqueId).parentElement.classList.remove('active');
              _this3.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: eventid
              });
              if (_this3.betFormList.length <= 0) {
                _this3.$store.commit("OPEN_BETFORM", false);
                _this3.$store.commit('ODD_SELECTED', false);
                _this3.$store.commit("SHOW_BETFORM_MENU", false);
                _this3.$store.commit('SELECTED_TAB', 'betTab');
                return;
              }
              _this3.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this3.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this3.$store.getters.betForm
                  });
                  _this3.refreshTimer();
                  _this3.isReloading = false;
                }.bind(_this3)
              });
            }.bind(this)
          });
        } else {
          this.$store.dispatch("removeMatch", {
            data: { eveid: eventid },
            callback: function () {
              document.getElementById(event.uniqueId).parentElement.classList.remove('active');
              _this3.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: eventid
              });
              if (_this3.betFormList.length <= 0) {
                _this3.$store.commit("OPEN_BETFORM", false);
                _this3.$store.commit('ODD_SELECTED', false);
                _this3.$store.commit("SHOW_BETFORM_MENU", false);
                _this3.$store.commit('SELECTED_TAB', 'betTab');
                return;
              }
              _this3.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this3.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this3.$store.getters.betForm
                  });
                  _this3.refreshTimer();
                  _this3.isReloading = false;
                }.bind(_this3)
              });
            }.bind(this)
          });
        }
      }
    },
    checkPendingWager: function checkPendingWager(pendingWagerIds) {
      var _this4 = this;

      var RBbtList = this.rbBetTypeList;

      var VUE = this;
      if (this.pendingTimerId == null) {
        this.pendingTimerId = setInterval(function () {
          if (pendingWagerIds.length > 0) {
            _this4.$store.dispatch('getPendingWager', {
              'wagerIds': pendingWagerIds,
              'isParlay': VUE.isMulp ? 1 : 0,
              'callback': function callback(res) {
                if (res) {
                  if (_this4.$store.getters.isBetCombo) {} else if (VUE.isMulp) {
                    var pending_flag = false;
                    var bettingData = VUE.betting.pending.data;
                    _.forEach(res.wagerList.data, function (value, key) {
                      var windex = _.findIndex(bettingData.mulpRes, { WagerID: value.wgNo });
                      if (windex > -1) {
                        bettingData.mulpRes[windex]['wgStatus'] = value.wgStatus;
                      }
                      if (value.wgStatus == '1') {
                        pending_flag = true;
                      }
                    }.bind(_this4));

                    if (pending_flag) {
                      _this4.$store.commit('BETTING_MESSAGE', {
                        isPending: true,
                        data: bettingData
                      });
                    } else {
                      _this4.$store.commit('BETTING_MESSAGE', {
                        isSuccess: true,
                        data: bettingData
                      });
                    }
                  } else {
                    var betData = res.wagerList.data[0];

                    var rbconfirm = $.inArray(betData.betTypId, RBbtList) > -1 ? '2' : '0';
                    var wgReject = _.findIndex(res.wagerList.data, { wgStatus: '-1' });
                    var wgSuccess = _.findIndex(res.wagerList.data, { wgStatus: rbconfirm });

                    if (wgReject > -1) {
                      _this4.$store.commit('BETTING_MESSAGE', {
                        isReject: true
                      });
                    } else if (wgSuccess > -1) {
                      _this4.$store.commit('BETTING_MESSAGE', {
                        isSuccess: true,
                        chkPendingSuccess: true,
                        data: VUE.betting.pending.data
                      });
                    }
                  }

                  _this4.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.wagerList.data,
                    oldBettingList: _this4.$store.getters.betForm,
                    chkPendingWager: 1
                  });
                }
              }
            });
          }
        }.bind(this), 5000);
      }
    },
    clearInput: function clearInput() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (key != null) {
        var arr = {
          index: key,
          amount: '',
          clear: false
        };
        if (this.$store.getters.isBetCombo) {
          this.betComboAmount = arr;

          var kdata = { index: key, settings: { min: true, med: true, big: true, big2: true, big3: true } };
          this.betComboKeyboardAllow = kdata;
        } else if (this.isMulp) {
          arr.stake = '';
          arr.possiblePayout = '';
          arr.allUp = this.$store.getters.betMulpAmount[key].allUp;
          this.betMulpAmount = arr;

          return;
        }
      } else if (key == null && mode == 'all') {
        var VUE = this;
        this.allBetComboAmount = '';

        var arr = { clear: true };
        VUE.betComboAmount = arr;
        VUE.betComboKeyboardAllow = arr;
        VUE.resetKeyboardAllow();
      } else {
        this.betAmount = '';
      }

      this.possiblePayout;
    },
    validateChipOption: function validateChipOption(amount) {
      return amount >= this.betting.minMax.min && amount <= this.betting.minMax.max ? true : false;
    },
    initMinibet: function initMinibet() {
      $('.bet-zone').draggable();
      if (!this.betting.error) {
        if (this.$refs.betAmount && this.$refs.betAmount.length > 0) {
          this.$refs.betAmount[0].focus();
        }
      }
    },
    cancelMiniBet: function cancelMiniBet() {
      if (!this.isPlacedBet) {
        this.$store.commit('BETTING_DELAY_TIMERID', null);
        this.$store.commit('SPORT_MINIBET_TOGGLE', false);
        __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit("processBet");
        this.$store.commit('PROCESS_BET', false);
      }
    },
    confirmBetForm: function confirmBetForm(event) {
      var _this5 = this;

      var vue = this;
      var errArr = [];

      if (!this.$store.getters.isBetCombo) {
        var minMaxValidation = this.jsMinMaxValidation(this.$store.getters.sportMiniBet.betAmount, this.isMulp);
      } else {
        var betAmountArr = this.$store.getters.betComboAmount;
        var amt = '';
        var minMaxValidation = {};
        var ttlAmt = 0;

        $.each(betAmountArr, function (id, data) {
          amt = data.value == '' ? 0 : data.value.replace(",", "");
          ttlAmt += parseInt(amt);
          var validation = vue.jsMinMaxValidation(amt, vue.isMulp);
          errArr[id] = { error: false };
          if (validation.error) {
            minMaxValidation = validation;
            errArr[id] = validation;
          }
        });

        var minMaxValidationSUM = vue.jsMinMaxValidation(ttlAmt, vue.isMulp);
        if (minMaxValidationSUM.error) {
          vue.$store.commit('JS_ERR', minMaxValidationSUM);
          setTimeout(function () {
            vue.$store.commit('JS_ERR', '');
          }, 5000);
          return;
        }
      }

      if (!minMaxValidation.error) {
        this.$store.commit('PROCESS_BET', true);
        this.$store.dispatch("confirmBet", {
          callback: function (res) {
            if (_this5.$store.getters.isBetCombo) {
              _this5.betFormHeight();
            }
            _this5.$store.commit('PROCESS_BET', false);
            _this5.startTimer();
          }.bind(this)
        });
        this.$store.commit('PLACED_BET', true);
      } else {
        if (!this.$store.getters.isBetCombo) {
          this.$store.commit('JS_ERR', minMaxValidation);

          if (minMaxValidation.errorId == 1) {
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.account.currCL);
          } else if (minMaxValidation.errorId == 2) {
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.min);
          } else if (minMaxValidation.errorId == 3) {
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.max);
          }
        } else {
          this.$store.commit('BETCOMBO_JS_ERR', errArr);
          var a = '';
          var _betAmountArr2 = this.$store.getters.betComboAmount;
          $.each(_betAmountArr2, function (idx, val) {
            if (errArr[idx] && errArr[idx].error) {
              if (errArr[idx].errorId == 1) {
                a = Math.round(vue.account.currCL);
              } else if (errArr[idx].errorId == 2) {
                a = Math.round(vue.betting.minMax.min);
              } else if (errArr[idx].errorId == 3) {
                a = Math.round(vue.betting.minMax.max);
              }
              var arr = { index: idx, amount: a, clear: false };
              vue.$store.commit("BETCOMBO_AMOUNT", arr);
            }
          });
        }

        setTimeout(function () {
          vue.$store.commit('JS_ERR', '');
          if (vue.$store.getters.isBetCombo) {
            vue.$store.commit('BETCOMBO_JS_ERR', {});
          }
        }, 5000);
      }
    },
    showConfirmForm: function showConfirmForm() {
      if (this.isProcessBet) {
        __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit("processBet");
      } else if (!this.isProcessBet) {
        __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit("processBet");
      }
    },
    h1x2Header: function h1x2Header(hdp, team) {
      if (team == 'a') {
        if (hdp > 0) {
          return ' +' + parseInt(hdp);
        } else if (hdp < 0) {
          return parseInt(hdp);
        }
      } else if (team == 'b') {
        var nhdp = parseInt(hdp) * -1;
        var ahdp = '';

        if (nhdp > 0) {
          ahdp = '+' + nhdp;
        } else if (nhdp < 0) {
          ahdp = nhdp;
        }

        return ahdp;
      } else if (team == 'x') {
        if (hdp > 0) {
          return this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' +' + parseInt(hdp);
        } else if (hdp < 0) {
          var nhdp = parseInt(hdp) * -1;
          var ahdp = '';

          if (nhdp > 0) {
            ahdp = '+' + nhdp;
          } else if (nhdp < 0) {
            ahdp = nhdp;
          }
          return this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' ' + ahdp;
        }
      }
    },
    computeHandicap: function computeHandicap(data) {
      if (this.hdpDisp == '0') {
        if (data.betType == this.ouBetType || data.betType == this.rouBetType || data.betType == this.hdpBetType || data.betType == this.hdpBetType || data.betType == this.htgBetType || data.betType == this.rhtgBetType || data.betType == this.atgBetType || data.betType == this.ratgBetType) {
          return data.hdpCap;
        } else {
          return '';
        }
      } else if (this.hdpDisp == '1') {
        if (data.betType == this.ouBetType || data.betType == this.rouBetType || data.betType == this.htgBetType || data.betType == this.rhtgBetType || data.betType == this.atgBetType || data.betType == this.ratgBetType) {
          return data.hdpCap;
        } else if (data.betType == this.hdpBetType || data.betType == this.hdpBetType) {
          return data.hdp;
        } else {
          return '';
        }
      } else {
        return data.hdpCap;
      }
    },
    resetKeyboardAllow: function resetKeyboardAllow() {
      this.keyboardAllow = {
        min: true,
        med: true,
        big: true,
        big2: true,
        big3: true
      };
    },
    isSportValidPromo: function isSportValidPromo(eventObj, bt) {
      var result = false;
      this.$store.dispatch("isSportValidPromo", {
        eventObj: eventObj,
        bt: bt,
        callback: function (res) {
          result = res;
        }.bind(this)
      });
      return result;
    },
    updateParlay: function updateParlay() {
      var _this6 = this;

      var clickParlayButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.betting.pending || this.betting.success || this.betting.betcombosuccess || this.betting.reject) {
        this.$store.commit('BETTING_MESSAGE', { isError: false });
        this.$store.commit("BETCOMBO_MESSAGE", { isClear: true });

        this.betAmount = '';
        this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
        this.$store.commit("BETMULP_AMOUNT", { resetBetMulpAmount: true });
        this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
        this.allBetComboAmount = '';
        var arr = { clear: true };
        this.$store.commit("BETCOMBO_AMOUNT", arr);
        this.betComboKeyboardAllow = arr;
        this.resetKeyboardAllow();
        this.$store.commit('ODD_SELECTED', true);
        this.clearTimer();
        this.$store.commit('SET_MATCH_INDEX_NO_ERR', []);
      }
      if (clickParlayButton) {
        this.$store.commit("BETMULP_AMOUNT", { resetBetMulpAmount: true });
        this.$store.commit("BETMULP_AMOUNT_FILTERED", []);
      }
      if (this.selectedBettype != undefined && this.selectedBettype.betTypId == '5') {
        this.$store.commit("IS_BETPARLAY", false);
        this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.previousBettype.bettype));
        this.$store.commit("IS_BETCOMBO", this.previousBettype.isBetCombo);
        this.$store.commit('PREV_BETTYPE', null);

        if (!this.$store.getters.isBetCombo && this.betFormList.length > 1) {
          this.$store.dispatch("removeMatch", {
            data: { clearType: '2' }
          });
        }
      } else {
        this.$store.commit("IS_BETPARLAY", true);
        this.$store.commit('PREV_BETTYPE', { bettype: this.selectedBettype, isBetCombo: this.$store.getters.isBetCombo });
        var bettyp_index = _.findIndex(this.bettypeList, function (value, id) {
          return value.betTypId == '5';
        });
        if (bettyp_index > -1) {
          this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.bettypeList[bettyp_index]));
        }
        this.$store.commit("IS_BETCOMBO", false);
      }
      if (clickParlayButton) {
        this.$store.dispatch("getBettingInfo", {
          callback: function (res) {
            _this6.$store.commit("SPORT_MAPPING_BETTING", {
              newBettingList: res.SYSTEM_DATA.betting,
              oldBettingList: _this6.$store.getters.betForm
            });
          }.bind(this)
        });
      }
    },
    checkMaxOdds: function checkMaxOdds(index) {
      var ret = this.countMaxOdds(index);

      if (ret == true) {
        this.$store.commit('DISABLE_BET', false);
      }
      return ret;
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.$refs.miniBetModal.addEventListener("touchstart", this.startDrag, false);
    this.$refs.miniBetModal.addEventListener("touchmove", this.drag, false);
    this.$refs.miniBetModal.addEventListener("touchend", this.endDrag, false);
    $('#miniBetScroll').niceScroll({
      horizrailenabled: false,
      autohidemode: true,
      scrollbarid: 'miniBetScrollbar',
      cursorborder: "0px solid #fff",

      zindex: 45,
      railoffset: { left: -5 },
      cursordragontouch: true
    });
    $('#miniBetScroll').height(251);


    this.initMinibet();
    if (!this.betting.error) {
      this.betMinMax();
    }
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$on("stopBettingTimer", function (res) {
      _this7.clearTimer();
    });
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$on("clearAllBetComboAmount", function () {
      _this7.allBetComboAmount = '';
    });
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$on("resetKeyboard", function () {
      _this7.resetKeyboardAllow();
    });
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$on("cancelBetForm", function () {
      _this7.cancelBetForm();
    });
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$on("cancelBetForm", function () {
      _this7.cancelBetForm();
    });
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$on("expandMini", function (res) {
      _this7.showExpandMini = true;
      $('#miniBetScroll').height(0);
      $('#miniBetScroll').height(251);
    });


    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$on('SHOW_MINIBET', function () {
      _this7.initMinibet();
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$on("processOdChangeUpDown", function (res) {
      if (res.oddChg) {
        _this7.odChgClass = res.oddChgUpDown == 'up' ? 'up' : 'down';
      } else {
        _this7.odChgClass = '';
      }
    });
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$on("setBetMulpAmount", function (res) {
      _this7.betMulpAmount = res;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$off("stopBettingTimer");
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$off("cancelBetForm");
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$off('SHOW_MINIBET');
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$off("clearAllBetComboAmount");
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$off("resetKeyboard");
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$off("processOdChangeUpDown");
    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$off("expandMini");
    this.clearTimer();
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    computeTeamBet: function computeTeamBet(betForm, isMinibet) {
      var redFont = '';
      var isRbScore = false;
      var scoreCapt = '';

      if (betForm && typeof betForm.eventObj.rbinfo !== 'undefined') {
        isRbScore = true;
      }

      var retCapt = '';
      switch (betForm.betType) {
        case this.hdpBetType:
        case this.rhdpBetType:
          if (betForm.betType == 1 || betForm.betType == 8) {
            if (betForm.colorDis == 1) {
              redFont = 'teamHA_r_mini';
            }
          }

          if (isMinibet) {
            retCapt = '<span class="betinfo-tbet ' + redFont + '">' + betForm.tbetcapt + '</span>';
          } else {
            retCapt = '<span class="betinfo-tbet ' + redFont + '">' + betForm.tbetcapt;
            if (betForm.tbet == betForm.fav) {
              retCapt += '</span>&nbsp;<span class="betinfo-hdp red">(' + betForm.hdpCap + ')</span>';
            } else {
              retCapt += '</span>&nbsp;<span class="betinfo-hdp">' + betForm.hdpCap + '</span>';
            }
          }

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        case this.ouBetType:
        case this.rouBetType:
        case this.htgBetType:
        case this.rhtgBetType:
        case this.atgBetType:
        case this.ratgBetType:
          var capt = betForm.tbet == 'a' ? 'ALL_BET.LBL_OVER' : 'ALL_BET.LBL_UNDER';
          if (isMinibet) retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>';
          retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;';

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        case this.bttsBetType:
        case this.rbttsBetType:
          var capt = betForm.tbet == 'a' ? 'ALL_BET.LBL_YES' : 'ALL_BET.LBL_NO';
          if (isMinibet) retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>';
          retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;';

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        case this.h1x2BetType:
        case this.rh1x2BetType:
        case this.twnBetType:
        case this.rtwnBetType:
        case this.twfbBetType:
        case this.rtwfbBetType:
        case this.twehBetType:
        case this.rtwehBetType:
        case this.twbhBetType:
        case this.rtwbhBetType:
        case this.tsbhBetType:
        case this.rtsbhBetType:
          var capt = '';

          if (betForm.tbet == 'a') {
            capt = 'ALL_BET.LBL_HOME';
          } else if (betForm.tbet == 'b') {
            capt = 'ALL_BET.LBL_AWAY';
          } else if (betForm.tbet == 'x') {
            capt = 'ALL_BET.LBL_DRAW';
          }

          if (isMinibet) retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>';
          retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;';

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        case this.wmBetType:
        case this.rwmBetType:
          var capt = '';

          if (betForm.tbet == 'h1') {
            capt = 'ALL_BET.LBL_HWB1';
          } else if (betForm.tbet == 'h2') {
            capt = 'ALL_BET.LBL_HWB2';
          } else if (betForm.tbet == 'h3') {
            capt = 'ALL_BET.LBL_HWB3';
          } else if (betForm.tbet == 'h4') {
            capt = 'ALL_BET.LBL_HWB4M';
          } else if (betForm.tbet == 'a1') {
            capt = 'ALL_BET.LBL_AWB1';
          } else if (betForm.tbet == 'a2') {
            capt = 'ALL_BET.LBL_AWB2';
          } else if (betForm.tbet == 'a3') {
            capt = 'ALL_BET.LBL_AWB3';
          } else if (betForm.tbet == 'a4') {
            capt = 'ALL_BET.LBL_AWB4M';
          } else if (betForm.tbet == 'sd') {
            capt = 'ALL_BET.LBL_AS';
          } else if (betForm.tbet == 'ng') {
            capt = 'ALL_BET.LBL_NG';
          }

          if (isMinibet) retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>';
          retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;';

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        case this.wmrBetType:
        case this.rwmrBetType:
          var capt = '';

          if (betForm.tbet == 'h1') {
            capt = 'ALL_BET.LBL_HWB1R';
          } else if (betForm.tbet == 'h2') {
            capt = 'ALL_BET.LBL_HWB2R';
          } else if (betForm.tbet == 'h3') {
            capt = 'ALL_BET.LBL_HWB3R';
          } else if (betForm.tbet == 'h4') {
            capt = 'ALL_BET.LBL_HWB4RM';
          } else if (betForm.tbet == 'a1') {
            capt = 'ALL_BET.LBL_AWB1R';
          } else if (betForm.tbet == 'a2') {
            capt = 'ALL_BET.LBL_AWB2R';
          } else if (betForm.tbet == 'a3') {
            capt = 'ALL_BET.LBL_AWB3R';
          } else if (betForm.tbet == 'a4') {
            capt = 'ALL_BET.LBL_AWB4RM';
          } else if (betForm.tbet == 'sd') {
            capt = 'ALL_BET.LBL_AS';
          }

          if (isMinibet) retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>';
          retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;';

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        case this.flgBetType:
          var capt = '';

          if (betForm.tbet == 'hf') {
            capt = 'ALL_BET.SUBHEADER_HF';
          } else if (betForm.tbet == 'hl') {
            capt = 'ALL_BET.SUBHEADER_HL';
          } else if (betForm.tbet == 'af') {
            capt = 'ALL_BET.SUBHEADER_AF';
          } else if (betForm.tbet == 'al') {
            capt = 'ALL_BET.SUBHEADER_AL';
          } else if (betForm.tbet == 'ng') {
            capt = 'ALL_BET.LBL_NG';
          }

          if (isMinibet) retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>';
          retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;';

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        case this.hmgBetType:
        case this.rhmgBetType:
        case this.hmg1x2BetType:
        case this.rhmg1x2BetType:
          var capt = '';

          if (betForm.tbet == 'a') {
            capt = 'ALL_BET.LBL_1HT';
          } else if (betForm.tbet == 'b') {
            capt = 'ALL_BET.LBL_2HT';
          } else if (betForm.tbet == 'x') {
            capt = 'ALL_BET.LBL_DRAW';
          }

          if (isMinibet) retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>';
          retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;';

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        case this.wdBetType:
          var capt = '';
          var teamName = '';

          if (betForm.tbet == 'h_1_5') {
            teamName = 'ALL_BET.LBL_HOME';
            capt = 'ALL_BET.LBL_WIN_BY_1T5';
          } else if (betForm.tbet == 'h_6_10') {
            teamName = 'ALL_BET.LBL_HOME';
            capt = 'ALL_BET.LBL_WIN_BY_6T10';
          } else if (betForm.tbet == 'h_11_15') {
            teamName = 'ALL_BET.LBL_HOME';
            capt = 'ALL_BET.LBL_WIN_BY_11T15';
          } else if (betForm.tbet == 'h_16_20') {
            teamName = 'ALL_BET.LBL_HOME';
            capt = 'ALL_BET.LBL_WIN_BY_16T20';
          } else if (betForm.tbet == 'h_21_25') {
            teamName = 'ALL_BET.LBL_HOME';
            capt = 'ALL_BET.LBL_WIN_BY_21T25';
          } else if (betForm.tbet == 'h_26_x') {
            teamName = 'ALL_BET.LBL_HOME';
            capt = 'ALL_BET.LBL_WIN_BY_26MORE';
          } else if (betForm.tbet == 'a_1_5') {
            teamName = 'ALL_BET.LBL_AWAY';
            capt = 'ALL_BET.LBL_WIN_BY_1T5';
          } else if (betForm.tbet == 'a_6_10') {
            teamName = 'ALL_BET.LBL_AWAY';
            capt = 'ALL_BET.LBL_WIN_BY_6T10';
          } else if (betForm.tbet == 'a_11_15') {
            teamName = 'ALL_BET.LBL_AWAY';
            capt = 'ALL_BET.LBL_WIN_BY_11T15';
          } else if (betForm.tbet == 'a_16_20') {
            teamName = 'ALL_BET.LBL_AWAY';
            capt = 'ALL_BET.LBL_WIN_BY_16T20';
          } else if (betForm.tbet == 'a_21_25') {
            teamName = 'ALL_BET.LBL_AWAY';
            capt = 'ALL_BET.LBL_WIN_BY_21T25';
          } else if (betForm.tbet == 'a_26_x') {
            teamName = 'ALL_BET.LBL_AWAY';
            capt = 'ALL_BET.LBL_WIN_BY_26MORE';
          }

          if (isMinibet) retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[teamName] + ' ' + this.$store.getters.sportAllBetLang[capt] + '</span>';
          retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[teamName] + ' ' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;';

          if (betForm.tbet == 'h_26_x' || betForm.tbet == 'a_26_x') {
            retCapt = retCapt.replace('26', '26+');
          }

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        case this.hldsBetType:
        case this.rhldsBetType:
        case this.aldsBetType:
        case this.raldsBetType:
          var capt = '';

          if (betForm.tbet == '0_5') {
            capt = 'ALL_BET.LBL_05';
          } else if (betForm.tbet == '1_6') {
            capt = 'ALL_BET.LBL_16';
          } else if (betForm.tbet == '2_7') {
            capt = 'ALL_BET.LBL_27';
          } else if (betForm.tbet == '3_8') {
            capt = 'ALL_BET.LBL_38';
          } else if (betForm.tbet == '4_9') {
            capt = 'ALL_BET.LBL_49';
          }

          if (isMinibet) retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>';
          retCapt = '<span class="betinfo-tbet">' + this.$store.getters.sportAllBetLang[capt] + '</span>&nbsp;';

          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
          break;
        default:
          retCapt = betForm.tbetcapt;
          if (isRbScore) {
            retCapt += scoreCapt;
          }
          return retCapt;
      }
    },
    calcForecastWL: function calcForecastWL(plytyp, scoreKey) {
      var amntWL = 0;
      var event = null;
      if (this.selectedForecastEvent) {
        if (this.selectedForecastEvent[plytyp]) {
          for (var bettyp = 0; bettyp < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedForecastEvent[plytyp]).length; bettyp++) {
            var bettypKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedForecastEvent[plytyp])[bettyp];
            for (var tbet = 0; tbet < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedForecastEvent[plytyp][bettypKey]).length; tbet++) {
              var tbetKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedForecastEvent[plytyp][bettypKey])[tbet];
              event = this.selectedForecastEvent[plytyp][bettypKey][tbetKey];

              if (this.selectedForecastEvent[plytyp][bettypKey][tbetKey].forecastInfo && this.selectedForecastEvent[plytyp][bettypKey][tbetKey].check) {
                amntWL += this.selectedForecastEvent[plytyp][bettypKey][tbetKey].forecastInfo[scoreKey];
              }
            }
          }
        }
      }
      if (plytyp == null) {
        var cloneWagerList = _.cloneDeep(this.$store.getters.sportWaitingWagerList);
        for (var key = 0; key < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(cloneWagerList).length; key++) {
          var plytypKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(cloneWagerList)[key];
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(cloneWagerList[plytypKey]) == 'object') {
            var wg = cloneWagerList[plytypKey];
            amntWL += wg.forecastInfo[scoreKey];
          }
        }
      }

      if (plytyp != null) {
        var cloneWagerList = _.cloneDeep(this.$store.getters.sportWaitingWagerList);
        if (cloneWagerList) {
          if (cloneWagerList[plytyp]) {
            var wg = cloneWagerList[plytyp];
            amntWL += wg.forecastInfo[scoreKey];
          }
        }
      }

      return amntWL;
    },
    showRBScore: function showRBScore(plytyp, scoreKey) {
      var showRbSco = false;
      if (this.sportForecastSelectedEvent && this.sportForecastSelectedEvent.rbinfo) {
        var rbsco = this.sportForecastSelectedEvent.rbinfo['scoa'] + '_' + this.sportForecastSelectedEvent.rbinfo['scob'];
        if (rbsco == scoreKey) {
          showRbSco = true;
        }
      }
      return showRbSco;
    },
    checkWaitingWagerForecastInfoExist: function checkWaitingWagerForecastInfoExist(event, plytyp, bettyp, tbet) {
      if (this.waitingWagerList.length > 0) {
        var tbet = null;
        var forecastTbet = null;
        var forecastHdp = null;

        forecastTbet = event.tbet;
        forecastHdp = event.hdp;

        switch (bettyp) {
          case this.onex2BetType:
          case this.ronex2BetType:
            if (event.tbet == 'a') {
              tbet = event.eventObj.taid;
            } else if (event.tbet == 'b') {
              tbet = event.eventObj.tbid;
            } else if (event.tbet == 'x') {
              tbet = 'draw';
            } else {
              console.log('Error: hdp check wager');
            }
            break;
          case this.hdpBetType:
          case this.rhdpBetType:
            if (event.tbet == 'a') {
              tbet = event.eventObj.taid;
            } else if (event.tbet == 'b') {
              tbet = event.eventObj.tbid;
            } else {
              console.log('Error: hdp check wager');
            }
            break;
          case this.ouBetType:
          case this.rouBetType:
            if (event.tbet == 'a') {
              tbet = 'over';
            } else if (event.tbet == 'b') {
              tbet = 'under';
            } else {
              console.log('Error: ou check wager');
            }
            break;
          case this.oeBetType:
          case this.roeBetType:
            if (event.tbet == 'a') {
              tbet = 'odd';
            } else if (event.tbet == 'b') {
              tbet = 'even';
            } else {
              console.log('Error: oe check wager');
            }
            break;
          default:
            return;
        }
        var cloneWagerList = _.cloneDeep(this.waitingWagerList);
        var filterWagerList = _.filter(cloneWagerList, {
          'eveId': String(event.eventObj.eveid),
          'plyTypId': String(plytyp)
        });
        filterWagerList = _.map(filterWagerList, function (wager) {
          wager.tbet = forecastTbet;
          wager.betAmount = wager.stkF;
          wager.odd = parseFloat(wager.od);
          wager.hdp = String(wager.hdp);
          var isTwoHdp = wager.hdp.indexOf('/');
          if (isTwoHdp >= 0) {
            var hdpValues = wager.hdp.split('/');
            wager.hdp = (parseFloat(hdpValues[0]) + parseFloat(hdpValues[1])) / 2;
          } else {
            wager.hdp = parseFloat(wager.hdp);
          }
          return wager;
        });
        return filterWagerList;
      }
      return [];
    },
    get_winlose_amt: function get_winlose_amt(wl, betamt, odds, wl_percentage, bet_info) {
      odds = parseFloat(odds);
      var wl_amt,
          wl_inc_amt = 0;
      if (wl == 'w') {
        if (odds < 0) {
          wl_amt = betamt * wl_percentage;
        } else {
          wl_amt = betamt * odds * wl_percentage;
        }
      } else if (wl == 'l') {
        if (odds < 0) {
          wl_amt = betamt * odds * wl_percentage;
        } else {
          wl_amt = betamt * -1 * wl_percentage;
        }
      } else if (wl == 'd') {
        wl_amt = 0;
      }

      var inc_amt = this.calc_inc(wl, betamt, odds, wl_percentage, bet_info, wl_amt);
      wl_amt = wl_amt + inc_amt;
      return wl_amt;
    },
    calc_inc: function calc_inc(wl, betamt, odds, wl_percentage, bet_info, wl_amt) {
      var wl_incentive_calc_flag = 1;

      var wl_incentive_calc_flag_bettype = ["1", "2", "3", "8", "9", "10", "46", "47", "48", "49", "80", "81", "82", "83"];
      var inc_percentage = this.$store.getters.betting.incentive;
      var inc_amt = 0;

      if (wl == 'd') {
        inc_percentage = 0;
      } else if (wl_percentage == 0.5) {
        if (wl_incentive_calc_flag == 1 && $.inArray(bet_info['betType'], wl_incentive_calc_flag_bettype) != -1) {
          inc_percentage = inc_percentage;
        } else {
          inc_percentage = inc_percentage / 2;
        }
      } else {
        inc_percentage = inc_percentage;
      }

      if (wl_incentive_calc_flag == 1 && $.inArray(bet_info['betType'], wl_incentive_calc_flag_bettype) != -1) {
        inc_amt = Math.abs(wl_amt) * inc_percentage;
      } else {
        inc_amt = betamt * inc_percentage;
      }

      return inc_amt;
    },
    olc_ou: function olc_ou(bet_info, hc, ac) {
      var arr_return = {};
      arr_return = bet_info;
      arr_return['forecastInfo'] = {};

      if (bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b') {
        for (var c = 0; c <= hc; c++) {
          for (var r = 0; r <= ac; r++) {

            var hdp = parseFloat(bet_info['hdp']);
            hdp = bet_info['hdpVal'] ? parseFloat(bet_info['hdpVal']) : hdp;

            var total = 0;
            if (bet_info['betTypId'] == 46 || bet_info['betTypId'] == 47 || bet_info['betTypId'] == 80 || bet_info['betTypId'] == 81) {
              total = c;
            } else if (bet_info['betTypId'] == 48 || bet_info['betTypId'] == 49 || bet_info['betTypId'] == 82 || bet_info['betTypId'] == 83) {
              total = r;
            } else {
              total = r + c;
            }

            var wl_amt = '-';

            var is_ou = '-';

            if (total > hdp) {
              is_ou = 'a';
            } else if (total < hdp) {
              is_ou = 'b';
            } else if (total == hdp) {
              is_ou = 'd';
            }

            var wl_percentage = 1;
            var diff = Math.abs(total - hdp);
            if (diff == 0.25) {
              wl_percentage = 0.5;
            }

            var wl = '';
            if (is_ou == bet_info['tbet']) {
              wl = 'w';
            } else if (is_ou == 'd') {
              wl = 'd';
            } else {
              wl = 'l';
            }

            var od = bet_info['odd'];
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.EU.key) {
              od = bet_info['odd'] - 1;
            }
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if (od < 0) {
                od = Math.abs(100 / od);
              } else {
                od = od / 100;
              }
              od = od.toFixed(3);
            }
            wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
            arr_return['forecastInfo'][c + "_" + r] = wl_amt;
          }
        }
      } else {
        console.log('error -> olc_ou');
        return false;
      }
      return arr_return;
    },
    olc_oe: function olc_oe(bet_info, hc, ac) {

      if (bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b') {
        var arr_return = {};
        arr_return = bet_info;
        arr_return['forecastInfo'] = {};

        for (var c = 0; c <= hc; c++) {
          for (var r = 0; r <= ac; r++) {
            var total = r + c;
            var wl_amt = '-';

            var is_oe = 'a';
            if (total % 2 == '0') {
              is_oe = 'b';
            }

            var wl = '';
            if (bet_info['tbet'] == is_oe) {
              wl = 'w';
            } else {
              wl = 'l';
            }

            var od = bet_info['odd'];
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if (od < 0) {
                od = Math.abs(100 / od);
              } else {
                od = od / 100;
              }
              od = od.toFixed(3);
            } else if (od > 1) {
              if (bet_info['odTypId'] != this.$store.getters.oddTypesList.IN.key) {
                od = bet_info['odd'] - 1;
              }
            }

            var wl_percentage = 1;
            var wl_amt = 0;
            wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
            arr_return['forecastInfo'][c + "_" + r] = wl_amt;
          }
        }
      } else {
        console.log('error -> olc_oe');
        return false;
      }

      return arr_return;
    },
    olc_1x2: function olc_1x2(bet_info, hc, ac) {

      if (bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' || bet_info['tbet'] == 'x') {
        var arr_return = {};
        arr_return = bet_info;
        arr_return['forecastInfo'] = {};

        for (var c = 0; c <= hc; c++) {
          for (var r = 0; r <= ac; r++) {

            var is_ha = '';
            if (c == r) {
              is_ha = 'x';
            } else if (c > r) {
              is_ha = 'a';
            } else if (c < r) {
              is_ha = 'b';
            }

            var wl = '';
            if (bet_info['tbet'] == is_ha) {
              wl = 'w';
            } else {
              wl = 'l';
            }

            var od = bet_info['odd'];
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if (od < 0) {
                od = Math.abs(100 / od);
              } else {
                od = od / 100;
              }
              od = od.toFixed(3);
            } else if (od > 1) {
              od = bet_info['odd'] - 1;
            }
            var wl_percentage = 1;
            var wl_amt = 0;
            wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
            arr_return['forecastInfo'][c + "_" + r] = wl_amt;
          }
        }
      } else {
        console.log('error -> olc_1x2');
        return false;
      }
      return arr_return;
    },
    olc_ah: function olc_ah(bet_info, hc, ac) {
      if (bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b') {
        var arr_return = {};
        arr_return = bet_info;
        arr_return['forecastInfo'] = {};

        for (var c = 0; c <= hc; c++) {
          for (var r = 0; r <= ac; r++) {
            var ch = c;
            var rh = r;
            var hdp = parseFloat(bet_info['hdp']);
            hdp = bet_info['hdpVal'] ? parseFloat(bet_info['hdpVal']) : hdp;

            if (bet_info.eventObj) {
              if (bet_info.eventObj.rbinfo) {
                ch = ch - parseInt(bet_info.eventObj.rbinfo['scoa']);
                rh = rh - parseInt(bet_info.eventObj.rbinfo['scob']);
              }
            }

            if (bet_info['tbet'] == 'a') {
              ch = ch + hdp;
            } else if (bet_info['tbet'] == 'b') {
              rh = rh + hdp;
            }

            var is_ha = '';
            if (ch == rh) {
              is_ha = 'd';
            } else if (ch > rh) {
              is_ha = 'a';
            } else if (ch < rh) {
              is_ha = 'b';
            }

            var wl = '';
            if (is_ha == 'd') {
              wl = 'd';
            } else if (is_ha == bet_info['tbet']) {
              wl = 'w';
            } else {
              wl = 'l';
            }

            var wl_percentage = 1;
            var diff = Math.abs(ch - rh);

            if (diff == 0.25) {
              wl_percentage = 0.5;
            }
            var od = bet_info['odd'];
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.EU.key) {
              od = bet_info['odd'] - 1;
            }
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if (od < 0) {
                od = Math.abs(100 / od);
              } else {
                od = od / 100;
              }
              od = od.toFixed(3);
            }
            var wl_amt = '-';
            wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
            arr_return['forecastInfo'][c + "_" + r] = wl_amt;
          }
        }
      } else {
        console.log('error -> olc_ah');
        return false;
      }

      return arr_return;
    },
    olc_cs: function olc_cs(bet_info, hc, ac) {

      var arr_return = {};
      arr_return = bet_info;
      arr_return['forecastInfo'] = {};

      if ($.inArray(bet_info['tbet'].length, [3, 4]) == -1) {
        console.log('error->olc_cs');
        return false;
      }

      var tbet = bet_info['tbet'] == 'aos' ? 'aos' : bet_info['tbet'];

      var betc = '';
      var betr = '';

      if (tbet == 'aos') {
        betc = 'aos';
        betr = 'aos';
      } else {
        betc = tbet['2'];
        betr = tbet['3'];
      }

      for (var c = 0; c <= hc; c++) {
        for (var r = 0; r <= ac; r++) {

          var wl = 'l';
          if (betc == c && betr == r) {
            wl = 'w';
          } else if (betc == 'aos' && c > 4 && betr == 'aos' && r > 4) {
            wl = 'w';
          }

          var od = bet_info['odd'];

          if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
            if (od < 0) {
              od = Math.abs(100 / od);
            } else {
              od = od / 100;
            }
            od = od.toFixed(3);
          } else if (od > 1) {
            od = bet_info['odd'] - 1;
          }

          var wl_percentage = 1;
          var wl_amt = '-';
          wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
          arr_return['forecastInfo'][c + "_" + r] = wl_amt;
        }
      }

      return arr_return;
    },
    olc_tg: function olc_tg(bet_info, hc, ac) {

      var arr_return = {};
      arr_return = bet_info;
      arr_return['forecastInfo'] = {};

      if ($.inArray(bet_info['tbet'], ['tg01', 'tg23', 'tg456', 'tg7']) == -1) {
        console.log('error->olc_tg');
        return false;
      }

      for (var c = 0; c <= hc; c++) {
        for (var r = 0; r <= ac; r++) {
          var total = c + r;

          var wl = 'l';
          if (bet_info['tbet'] == 'tg01') {
            if ($.inArray(total, [0, 1]) != -1) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'tg23') {
            if ($.inArray(total, [2, 3]) != -1) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'tg456') {
            if ($.inArray(total, [4, 5, 6]) != -1) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'tg7') {
            if (total >= 7) {
              wl = 'w';
            }
          }

          var od = bet_info['odd'];
          if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
            if (od < 0) {
              od = Math.abs(100 / od);
            } else {
              od = od / 100;
            }
            od = od.toFixed(3);
          } else if (od > 1) {
            od = bet_info['odd'] - 1;
          }

          var wl_percentage = 1;
          var wl_amt = '-';
          wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
          arr_return['forecastInfo'][c + "_" + r] = wl_amt;
        }
      }

      return arr_return;
    },
    getScoreDisplay: function getScoreDisplay(sco, rbsco, team) {
      if (rbsco && rbsco.rbinfo) {
        sco = parseInt(rbsco.rbinfo['sco' + team]) >= 2 ? parseInt(rbsco.rbinfo['sco' + team]) + (sco - 1) : sco;
      }
      return sco;
    },
    olc_h1x2: function olc_h1x2(bet_info, hc, ac) {

      if (bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b' || bet_info['tbet'] == 'x') {
        var arr_return = {};
        arr_return = bet_info;
        arr_return['forecastInfo'] = {};

        for (var c = 0; c <= hc; c++) {
          for (var r = 0; r <= ac; r++) {

            var hdp = parseFloat(bet_info['hdp']);
            hdp = bet_info['hdpVal'] ? parseFloat(bet_info['hdpVal']) : hdp;

            var homeDraw = parseFloat(c) - parseFloat(r) - hdp;
            var away = parseFloat(r) + hdp - parseFloat(c);

            var is_ha = '';
            if (homeDraw == 0) {
              is_ha = 'x';
            } else if (homeDraw > 0) {
              is_ha = 'a';
            } else if (away > 0) {
              is_ha = 'b';
            }

            var wl = '';
            if (bet_info['tbet'] == is_ha) {
              wl = 'w';
            } else {
              wl = 'l';
            }

            var od = bet_info['odd'];
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if (od < 0) {
                od = Math.abs(100 / od);
              } else {
                od = od / 100;
              }
              od = od.toFixed(3);
            } else if (od > 1) {
              od = bet_info['odd'] - 1;
            }
            var wl_percentage = 1;
            var wl_amt = 0;
            wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
            arr_return['forecastInfo'][c + "_" + r] = wl_amt;
          }
        }
      } else {
        console.log('error -> olc_h1x2');
        return false;
      }
      return arr_return;
    },
    olc_btts: function olc_btts(bet_info, hc, ac) {

      if (bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b') {
        var arr_return = {};
        arr_return = bet_info;
        arr_return['forecastInfo'] = {};

        for (var c = 0; c <= hc; c++) {
          for (var r = 0; r <= ac; r++) {

            var is_ha = '';
            if (c > 0 && r > 0) {
              is_ha = 'a';
            } else if (c >= 0 || r >= 0) {
              is_ha = 'b';
            }

            var wl = '';
            if (bet_info['tbet'] == is_ha) {
              wl = 'w';
            } else {
              wl = 'l';
            }

            var od = bet_info['odd'];
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if (od < 0) {
                od = Math.abs(100 / od);
              } else {
                od = od / 100;
              }
              od = od.toFixed(3);
            } else if (od > 1) {
              od = bet_info['odd'] - 1;
            }
            var wl_percentage = 1;
            var wl_amt = 0;
            wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
            arr_return['forecastInfo'][c + "_" + r] = wl_amt;
          }
        }
      } else {
        console.log('error -> olc_btts');
        return false;
      }
      return arr_return;
    },
    olc_csh: function olc_csh(bet_info, hc, ac) {

      if (bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b') {
        var arr_return = {};
        arr_return = bet_info;
        arr_return['forecastInfo'] = {};

        for (var c = 0; c <= hc; c++) {
          for (var r = 0; r <= ac; r++) {

            var is_ha = '';

            if (bet_info['tbet'] == 'a') {
              if (c == 0) {
                is_ha = 'a';
              }
            } else if (bet_info['tbet'] == 'b') {
              if (r == 0) {
                is_ha = 'b';
              }
            }

            var wl = '';
            if (bet_info['tbet'] == is_ha) {
              wl = 'w';
            } else {
              wl = 'l';
            }

            var od = bet_info['odd'];
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if (od < 0) {
                od = Math.abs(100 / od);
              } else {
                od = od / 100;
              }
              od = od.toFixed(3);
            } else if (od > 1) {
              od = bet_info['odd'] - 1;
            }
            var wl_percentage = 1;
            var wl_amt = 0;
            wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
            arr_return['forecastInfo'][c + "_" + r] = wl_amt;
          }
        }
      } else {
        console.log('error -> olc_csh');
        return false;
      }
      return arr_return;
    },
    olc_twn: function olc_twn(bet_info, hc, ac) {

      if (bet_info['tbet'] == 'a' || bet_info['tbet'] == 'b') {
        var arr_return = {};
        arr_return = bet_info;
        arr_return['forecastInfo'] = {};

        for (var c = 0; c <= hc; c++) {
          for (var r = 0; r <= ac; r++) {

            var is_ha = '';

            if (c > 0 && r == 0) {
              is_ha = 'a';
            } else if (r > 0 && c == 0) {
              is_ha = 'b';
            }

            var wl = '';
            if (bet_info['tbet'] == is_ha) {
              wl = 'w';
            } else {
              wl = 'l';
            }

            var od = bet_info['odd'];
            if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
              if (od < 0) {
                od = Math.abs(100 / od);
              } else {
                od = od / 100;
              }
              od = od.toFixed(3);
            } else if (od > 1) {
              od = bet_info['odd'] - 1;
            }
            var wl_percentage = 1;
            var wl_amt = 0;
            wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
            arr_return['forecastInfo'][c + "_" + r] = wl_amt;
          }
        }
      } else {
        console.log('error -> olc_csh');
        return false;
      }
      return arr_return;
    },
    olc_wm: function olc_wm(bet_info, hc, ac) {

      var arr_return = {};
      arr_return = bet_info;
      arr_return['forecastInfo'] = {};

      if ($.inArray(bet_info['tbet'], ['h1', 'h2', 'h3', 'h4', 'a1', 'a2', 'a3', 'a4', 'sd', 'ng']) == -1) {
        console.log('error->olc_tg');
        return false;
      }

      for (var c = 0; c <= hc; c++) {
        for (var r = 0; r <= ac; r++) {

          var wl = 'l';
          if (bet_info['tbet'] == 'h1') {
            if (parseFloat(c) - parseFloat(r) > 0 && parseFloat(c) - parseFloat(r) == 1) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'h2') {
            if (parseFloat(c) - parseFloat(r) > 0 && parseFloat(c) - parseFloat(r) == 2) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'h3') {
            if (parseFloat(c) - parseFloat(r) > 0 && parseFloat(c) - parseFloat(r) == 3) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'h4') {
            if (parseFloat(c) - parseFloat(r) > 0 && parseFloat(c) - parseFloat(r) >= 4) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'a1') {
            if (parseFloat(c) - parseFloat(r) < 0 && parseFloat(c) - parseFloat(r) == -1) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'a2') {
            if (parseFloat(c) - parseFloat(r) < 0 && parseFloat(c) - parseFloat(r) == -2) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'a3') {
            if (parseFloat(c) - parseFloat(r) < 0 && parseFloat(c) - parseFloat(r) == -3) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'a4') {
            if (parseFloat(c) - parseFloat(r) < 0 && parseFloat(c) - parseFloat(r) <= -4) {
              wl = 'w';
            }
          } else if (bet_info['tbet'] == 'sd') {
            if (c != 0 || r != 0) {
              if (parseFloat(c) - parseFloat(r) == 0) {
                wl = 'w';
              }
            }
          } else if (bet_info['tbet'] == 'ng') {
            if (c == 0 && r == 0) {
              wl = 'w';
            }
          }

          var od = bet_info['odd'];
          if (bet_info['odTypId'] == this.$store.getters.oddTypesList.AM.key) {
            if (od < 0) {
              od = Math.abs(100 / od);
            } else {
              od = od / 100;
            }
            od = od.toFixed(3);
          } else if (od > 1) {
            od = bet_info['odd'] - 1;
          }

          var wl_percentage = 1;
          var wl_amt = '-';
          wl_amt = this.get_winlose_amt(wl, bet_info['betAmount'], od, wl_percentage, bet_info);
          arr_return['forecastInfo'][c + "_" + r] = wl_amt;
        }
      }

      return arr_return;
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_over_under__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null,
    wdth: $('.betitem').width()
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().ouBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rouBetType],
      show: true,
      shdp: ['7', '8', '9', '10', '11', '12'],
      gamePt: ['14', '15', '16', '17', '18'],
      pt: {
        7: '1',
        8: '2',
        9: '3',
        10: '4',
        11: '5',
        12: '6'
      },
      gamePtLang: {
        '14': '1',
        '15': '2',
        '16': '3',
        '17': '4',
        '18': '5'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = '';
      var pt = '';
      var bt = '';
      var sCapt = '';
      if (this.plytyp == this.ftPlyType) {
        a = '_FT';
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H';
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP';
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP';
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP';
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') {
        a = '_' + this.pt[this.plytyp] + 'SET';
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') {
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME';
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS';
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS';
      } else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS';
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS';
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS';
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS';
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS';
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS';
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS';
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS';
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS';
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME';
      }

      pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a];

      if (jQuery.inArray(this.bettyp, ['2', '9']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.SUBHEADER_OU'];
      } else if (jQuery.inArray(this.bettyp, ['46', '47']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.HTG'];
      } else if (jQuery.inArray(this.bettyp, ['48', '49']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.ATG'];
      } else if (jQuery.inArray(this.bettyp, ['32', '33']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.SUBHEADER_BTTS'];
      } else if (jQuery.inArray(this.bettyp, ['80', '81']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.HTR'];
      } else if (jQuery.inArray(this.bettyp, ['82', '83']) != '-1') {
        bt = this.sportAllBetLang['ALL_BET.ATR'];
      }

      if (this.isSpecial) {
        var st = this.specialLeagueCaption(this.newAllBetEvent, this.btype);
        sCapt = ' ' + st + ' (' + this.sportAllBetLang['ALL_BET.LBL_SPECIALS'] + ')';
      }

      return pt + bt + sCapt;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(d) {
      this.$parent.setToTop(d);
    },
    addToMyMarket: function addToMyMarket(plytyp, ouBetType) {
      if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, ouBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, ouBetType) {
      if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, ouBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd1x2__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().onex2BetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().ronex2BetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = '';

      var sCapt = '';
      if (this.plytyp == this.ftPlyType) {
        a = '_FT';
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H';
      } else if (this.plytyp == this.mlBetType) {
        a = '_GAME_HDP';
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS';
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS';
      } else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS';
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS';
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS';
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS';
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS';
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS';
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS';
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS';
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS';
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME';
      }

      var pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a];
      var bt = this.bettyp == this.mlBetType ? this.sportAllBetLang['ALL_BET.SUBHEADER_ML'] : this.sportAllBetLang['ALL_BET.SUBHEADER_1X2'];
      if (this.isSpecial) {
        var st = this.specialLeagueCaption(this.allBetEvent, this.bettyp);
        sCapt = ' ' + st + ' (' + this.sportAllBetLang['ALL_BET.LBL_SPECIALS'] + ')';
      }

      return pt + bt + sCapt;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, onex2BetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, onex2BetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().csBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rcsBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_CS'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().tgBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rtgBetType],
      tgBetTitle: {
        '1': ['ALL_BET.LBL_01', 'ALL_BET.LBL_23', 'ALL_BET.LBL_46', 'ALL_BET.LBL_7more'],
        '2': ['ALL_BET.LBL_0', 'ALL_BET.LBL_1', 'ALL_BET.LBL_2', 'ALL_BET.LBL_3more']
      },
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_TG'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, tgBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, tgBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().htftBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rhtftBetType],
      lang: window.lang,
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_HDP'];

      if (this.newAllBetEvent.event_rb == 1) {
        b += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')';
      }
      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, htftBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, htftBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, htftBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, htftBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().oeBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().roeBetType],
      show: true,
      shdp: ['7', '8', '9', '10', '11', '12'],
      gamePt: ['14', '15', '16', '17', '18'],
      pt: {
        7: '1',
        8: '2',
        9: '3',
        10: '4',
        11: '5',
        12: '6'
      },
      gamePtLang: {
        '14': '1',
        '15': '2',
        '16': '3',
        '17': '4',
        '18': '5'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption(btype) {
      var a = '';
      var pt = '';
      var bt = '';
      var sCapt = '';
      if (this.plytyp == this.ftPlyType) {
        a = '_FT';
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H';
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP';
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP';
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP';
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') {
        a = '_' + this.pt[this.plytyp] + 'SET';
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') {
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME';
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS';
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS';
      } else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS';
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS';
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS';
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS';
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS';
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS';
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS';
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS';
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS';
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME';
      }

      pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a];
      bt = this.sportAllBetLang['ALL_BET.SUBHEADER_OE'];

      if (this.isSpecial) {
        var st = this.specialLeagueCaption(this.newAllBetEvent, this.btype);
        sCapt = ' ' + st + ' (' + this.sportAllBetLang['ALL_BET.LBL_SPECIALS'] + ')';
      }

      return pt + bt + sCapt;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    addToMyMarket: function addToMyMarket(plytyp, oeBetType) {
      if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, oeBetType, this.isSpecial);
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, oeBetType) {
      if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, oeBetType, this.isSpecial);
    },
    oddsHeader: function oddsHeader() {
      var retCapt = '';
      if (this.isSpecial) {
        retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.oeBetType);
      }

      return retCapt;
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_over_under__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().atgBetType, __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().ratgBetType],
      show: true
    };
  },

  computed: {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  },
  methods: {
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    addToMyMarket: function addToMyMarket(plytyp, atgBetType) {
      if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, atgBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, atgBetType) {
      if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, atgBetType, this.isSpecial);
    },
    oddsHeader: function oddsHeader() {
      var retCapt = '';

      retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.atgBetType);

      return retCapt;
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_over_under__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().htgBetType, __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().rhtgBetType],
      show: true
    };
  },

  computed: {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  },
  methods: {
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    addToMyMarket: function addToMyMarket(plytyp, htgBetType) {
      if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, htgBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, htgBetType) {
      if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, htgBetType, this.isSpecial);
    },
    oddsHeader: function oddsHeader() {
      var retCapt = '';

      retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.htgBetType);

      return retCapt;
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd1x2__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    bettyp: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().bttsBetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().rbttsBetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().exiBetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().rexiBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';

      if (this.bettyp == 76 || this.bettyp == 79) {

        b = this.sportAllBetLang['ALL_BET.SUBHEADER_EI'];
      } else {

        if (this.plytyp == this.firstHtPlyType) {
          a = '1H';
        } else if (this.plytyp == this.SecondHtPlyType) {
          a = '2H';
        }

        b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS'];
      }

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, bttsBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, bttsBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, bttsBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, bttsBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd_dbch__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().dbchBetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().rdbchBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '2H';
      }

      a = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a];


      return a;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    getTeamLabel: function getTeamLabel(team) {
      if (team == 'ha') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'];
      } else if (team == 'ad') {
        return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'];
      } else if (team == 'hd') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'];
      }
    },
    addToMyMarket: function addToMyMarket(plytyp, onex2BetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, onex2BetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd1x2__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, bettyp) {
      if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, bettyp) {
      if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd1x2__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().twnBetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().rtwnBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption(btype) {
      if (btype == this.twnBetType || btype == this.rtwnBetType) {
        return this.sportAllBetLang['ALL_BET.SUBHEADER_TWN'];
      } else if (btype == this.twfbBetType || btype == this.rtwfbBetType) {
        return this.sportAllBetLang['ALL_BET.SUBHEADER_TWFB'];
      } else if (btype == this.twehBetType || btype == this.rtwehBetType) {
        return this.sportAllBetLang['ALL_BET.SUBHEADER_TWEH'];
      } else if (btype == this.twbhBetType || btype == this.rtwbhBetType) {
        return this.sportAllBetLang['ALL_BET.SUBHEADER_TWBH'];
      } else if (btype == this.tsbhBetType || btype == this.rtsbhBetType) {
        return this.sportAllBetLang['ALL_BET.SUBHEADER_TSBH'];
      }
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, bettyp) {
      if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, bettyp) {
      if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
    },
    oddsHeader: function oddsHeader() {
      var retCapt = '';
      if (this.isSpecial) {
        retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.bettyp);
      }

      return retCapt;
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().wmBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rwmBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().wmrBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rwmrBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, wmBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, wmBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, wmBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, wmBetType, this.isSpecial);
    },
    getTitleCaption: function getTitleCaption() {
      var a = '';
      var pt = '';
      var bt = '';
      var sCapt = '';
      if (this.plytyp == this.ftPlyType) {
        a = '_FT';
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '_2H';
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP';
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP';
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP';
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') {
        a = '_' + this.pt[this.plytyp] + 'SET';
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') {
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME';
      } else if (this.plytyp == this.first3InningsPlayType) {
        a = '_FIRST_3_INNINGS';
      } else if (this.plytyp == this.first5InningsPlayType) {
        a = '_FIRST_5_INNINGS';
      } else if (this.plytyp == this.firstInningsPlayType) {
        a = '_FIRST_INNINGS';
      } else if (this.plytyp == this.secondInningsPlayType) {
        a = '_SECOND_INNINGS';
      } else if (this.plytyp == this.thirdInningsPlayType) {
        a = '_THIRD_INNINGS';
      } else if (this.plytyp == this.fourthInningsPlayType) {
        a = '_FOURTH_INNINGS';
      } else if (this.plytyp == this.fifthInningsPlayType) {
        a = '_FIFTH_INNINGS';
      } else if (this.plytyp == this.sixthInningsPlayType) {
        a = '_SIXTH_INNINGS';
      } else if (this.plytyp == this.seventhInningsPlayType) {
        a = '_SEVENTH_INNINGS';
      } else if (this.plytyp == this.eightthInningsPlayType) {
        a = '_EIGHTTH_INNINGS';
      } else if (this.plytyp == this.nineInningsPlayType) {
        a = '_NINETH_INNINGS';
      } else if (this.plytyp == this.OTPlayType) {
        a = '_OVERTIME';
      }

      pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a];

      return pt;
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().flgBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rflgBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, flgBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, flgBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, flgBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, flgBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd1x2__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    bettyp: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption(btype) {
      if (btype == this.hmgBetType || btype == this.rhmgBetType) {
        return this.sportAllBetLang['ALL_BET.SUBHEADER_HMG'];
      } else if (btype == this.hmg1x2BetType || btype == this.rhmg1x2BetType) {
        return this.sportAllBetLang['ALL_BET.SUBHEADER_HMG1x2'];
      }
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, bettyp) {
      if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, bettyp) {
      if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
    },
    oddsHeader: function oddsHeader() {
      var retCapt = '';
      if (this.isSpecial) {
        retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.bettyp);
      }

      return retCapt;
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd1x2__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().onex2BetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().ronex2BetType],
      show: true,
      shdp: ['7', '8', '9', '10', '11', '12'],
      gamePt: ['14', '15', '16', '17', '18'],
      pt: {
        7: '1',
        8: '2',
        9: '3',
        10: '4',
        11: '5',
        12: '6'
      },
      gamePtLang: {
        '14': '1',
        '15': '2',
        '16': '3',
        '17': '4',
        '18': '5'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = '';
      var pt = '';
      var bt = '';
      if (this.plytyp == this.ftPlyType) {
        a = '_FT';
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H';
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP';
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP';
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP';
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') {
        a = '_' + this.pt[this.plytyp] + 'SET';
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') {
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME';
      }

      pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a];

      bt = this.sportAllBetLang['ALL_BET.SUBHEADER_ML'];

      return pt + bt;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, onex2BetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, onex2BetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
    props: {
        allBetEvent: null,
        plytyp: null,
        selectMarket: null,
        removeMarket: null,
        rbinfo: null,
        bettyp: null,
        myMarket: {
            type: Boolean,
            default: false
        },
        isSpecial: {
            type: Boolean,
            default: false
        },
        mode: null
    },
    data: function data() {
        return {
            show: true
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
        newAllBetEvent: function newAllBetEvent() {
            return this.allBetEvent;
        }
    }),
    watch: {
        foldopenAllBet: function foldopenAllBet() {
            if (this.mode == 'ab') {
                this.show = this.$store.getters.foldopenAllBet ? true : false;
            }
        },
        foldopenFirstEvent: function foldopenFirstEvent() {
            if (this.mode != 'ab') {
                this.show = this.$store.getters.foldopenFirstEvent ? true : false;
            }
        }
    },
    methods: {
        getTitleCaption: function getTitleCaption() {
            var team;
            if (this.bettyp == this.hldsBetType || this.bettyp == this.rhldsBetType) {
                team = this.sportAllBetLang['ALL_BET.SUBHEADER_HLDS'] + this.newAllBetEvent.tacapt + ' - ';
            } else if (this.bettyp == this.aldsBetType || this.bettyp == this.raldsBetType) {
                team = this.sportAllBetLang['ALL_BET.SUBHEADER_ALDS'] + this.newAllBetEvent.tbcapt + ' - ';
            }

            return team + this.sportAllBetLang['ALL_BET.SUBHEADER_LAST_DIGIT'];
        },
        showLeg: function showLeg() {
            this.show = !this.show ? true : false;
        },
        setToTop: function setToTop(d) {
            this.$parent.setToTop(d);
        },
        addToMyMarket: function addToMyMarket(plytyp, bettyp) {
            if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
        },
        removeFromMyMarket: function removeFromMyMarket(plytyp, bettyp) {
            if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
        },
        oddsHeader: function oddsHeader() {
            var retCapt = '';

            if (this.bettyp == this.hldsBetType) {
                retCapt += this.sportAllBetLang["ALL_BET.LBL_HTP"] + ": " + this.allBetEvent.tacapt;
            } else if (this.bettyp == this.aldsBetType) {
                retCapt += this.sportAllBetLang["ALL_BET.LBL_ATP"] + ": " + this.allBetEvent.tbcapt;
            }

            retCapt += " - " + this.sportAllBetLang['ALL_BET.LBL_LAST_DIGIT'];

            return retCapt;
        }
    },
    mounted: function mounted() {
        if (this.mode == 'ab') {
            this.show = this.$store.getters.foldopenAllBet ? true : false;
        } else {
            this.show = this.$store.getters.foldopenFirstEvent ? true : false;
        }
    }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
    props: {
        allBetEvent: null,
        plytyp: null,
        selectMarket: null,
        removeMarket: null,
        rbinfo: null,
        bettyp: null,
        myMarket: {
            type: Boolean,
            default: false
        },
        isSpecial: {
            type: Boolean,
            default: false
        },
        mode: null
    },
    data: function data() {
        return {
            show: true
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
        newAllBetEvent: function newAllBetEvent() {
            return this.allBetEvent;
        }
    }),
    watch: {
        foldopenAllBet: function foldopenAllBet() {
            if (this.mode == 'ab') {
                this.show = this.$store.getters.foldopenAllBet ? true : false;
            }
        },
        foldopenFirstEvent: function foldopenFirstEvent() {
            if (this.mode != 'ab') {
                this.show = this.$store.getters.foldopenFirstEvent ? true : false;
            }
        }
    },
    methods: {
        getTitleCaption: function getTitleCaption() {
            var team;
            if (this.bettyp == this.hldsBetType) {
                team = this.newAllBetEvent.tacapt;
            } else if (this.bettyp == this.aldsBetType) {
                team = this.newAllBetEvent.tbcapt;
            }

            return team + this.sportAllBetLang['ALL_BET.SUBHEADER_WD'];
        },
        showLeg: function showLeg() {
            this.show = !this.show ? true : false;
        },
        setToTop: function setToTop(d) {
            this.$parent.setToTop(d);
        },
        addToMyMarket: function addToMyMarket(plytyp, bettyp) {
            if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
        },
        removeFromMyMarket: function removeFromMyMarket(plytyp, bettyp) {
            if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
        },
        oddsHeader: function oddsHeader() {
            var retCapt = '';
            if (this.isSpecial) {
                retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.bettyp);
            }

            return retCapt;
        },
        oddsTitle: function oddsTitle(score) {
            score = score.replace('_', '-');

            return this.sportAllBetLang['ALL_BET.LBL_TO_WIN_BY'] + ' ' + score;
        }
    },
    mounted: function mounted() {
        if (this.mode == 'ab') {
            this.show = this.$store.getters.foldopenAllBet ? true : false;
        } else {
            this.show = this.$store.getters.foldopenFirstEvent ? true : false;
        }
    }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().csBetType, __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().rcsBetType],
      show: true
    };
  },

  methods: {
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().tgBetType, __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().rtgBetType],
      tgBetTitle: {
        '1': ['ALL_BET.LBL_01', 'ALL_BET.LBL_23', 'ALL_BET.LBL_46', 'ALL_BET.LBL_7more'],
        '2': ['ALL_BET.LBL_0', 'ALL_BET.LBL_1', 'ALL_BET.LBL_2', 'ALL_BET.LBL_3more']
      },
      show: true
    };
  },

  methods: {
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    addToMyMarket: function addToMyMarket(plytyp, tgBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, tgBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial);
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd1x2__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '2H';
      }
      a = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a];

      if (this.newAllBetEvent.event_rb == 1) {
        b += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')';
      }
      return a;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, bettyp) {
      if (this.selectMarket) this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, bettyp) {
      if (this.removeMarket) this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial);
    },
    oddsHeader: function oddsHeader() {
      var retCapt = '';
      if (this.isSpecial) {
        retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.bettyp);
      }

      return retCapt;
    },
    hdpTitle: function hdpTitle(team, event) {
      var hdp = event.od[this.plytyp][this.bettyp]['hdp'];
      if (team == 'h') {
        if (hdp > 0) {
          return " +" + parseInt(hdp);
        } else if (hdp < 0) {
          return parseInt(hdp);
        }
      } else if (team == 'a') {
        var newHdp = parseInt(hdp) * -1;
        var awayHdp = '';

        if (newHdp > 0) {
          awayHdp = '+' + newHdp;
        } else if (newHdp < 0) {
          awayHdp = newHdp;
        }
        return awayHdp;
      } else if (team == 'x') {
        if (hdp > 0) {
          return "+" + parseInt(hdp);
        } else if (hdp < 0) {
          var newHdp = parseInt(hdp) * -1;
          var awayHdp = '';

          if (newHdp > 0) {
            awayHdp = '+' + newHdp;
          } else if (newHdp < 0) {
            awayHdp = newHdp;
          }
          return '<div class="ellipsis">' + this.sportAllBetLang['ALL_BET.LBL_AWAY'] + '</div>&nbsp;' + awayHdp;
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().nogBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rnogBetType],
      tgBetTitle: {
        '1': ['ALL_BET.LBL_01', 'ALL_BET.LBL_23', 'ALL_BET.LBL_46', 'ALL_BET.LBL_7more'],
        '2': ['ALL_BET.LBL_0', 'ALL_BET.LBL_1', 'ALL_BET.LBL_2', 'ALL_BET.LBL_3more']
      },
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.SUBHEADER_NOG'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, tgBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, tgBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, tgBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().onex2ouBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().ronex2ouBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.LBL_BETTYPE_SOCCER_1X2'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().onex2bttsBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().ronex2bttsBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.SUBHEADER_1X2_BTTS'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().ouoeBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rouoeBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.SUBHEADER_OU_OE'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().oubttsBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().roubttsBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.SUBHEADER_OU_BTTS'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.SUBHEADER_OU_FTS'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.SUBHEADER_1X2_FTS'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd_dbch__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().dbchouBetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().rdbchouBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '2H';
      }

      a = this.sportAllBetLang['ALL_BET.SUBHEADER_DBCH_OU'];


      return a;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    getTeamLabel: function getTeamLabel(team) {
      if (team == 'ha') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'];
      } else if (team == 'ad') {
        return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'];
      } else if (team == 'hd') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'];
      }
    },
    addToMyMarket: function addToMyMarket(plytyp, onex2BetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, onex2BetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd_dbch__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().dbchbttsBetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().rdbchbttsBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '2H';
      }

      a = this.sportAllBetLang['ALL_BET.SUBHEADER_DBCH_BTTS'];


      return a;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    getTeamLabel: function getTeamLabel(team) {
      if (team == 'ha') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'];
      } else if (team == 'ad') {
        return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'];
      } else if (team == 'hd') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'];
      }
    },
    addToMyMarket: function addToMyMarket(plytyp, onex2BetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, onex2BetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd_dbch__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().dbchftsBetType, __WEBPACK_IMPORTED_MODULE_3__mixins_allBet__["a" /* default */].data().rdbchftsBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      } else if (this.plytyp == this.SecondHtPlyType) {
        a = '2H';
      }

      a = this.sportAllBetLang['ALL_BET.SUBHEADER_DBCH_FTS'];


      return a;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    getTeamLabel: function getTeamLabel(team) {
      if (team == 'ha') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'];
      } else if (team == 'ad') {
        return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'];
      } else if (team == 'hd') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'];
      }
    },
    addToMyMarket: function addToMyMarket(plytyp, onex2BetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, onex2BetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial);
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_odd_edg__ = __webpack_require__(409);










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode: null
  },
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().edgBetType],
      show: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['foldopenAllBet', 'foldopenFirstEvent']), {
    newAllBetEvent: function newAllBetEvent() {
      return this.allBetEvent;
    }
  }),
  watch: {
    foldopenAllBet: function foldopenAllBet() {
      if (this.mode == 'ab') {
        this.show = this.$store.getters.foldopenAllBet ? true : false;
      }
    },
    foldopenFirstEvent: function foldopenFirstEvent() {
      if (this.mode != 'ab') {
        this.show = this.$store.getters.foldopenFirstEvent ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption: function getTitleCaption() {
      var a = 'FT';
      var b = '';
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H';
      }

      b = this.sportAllBetLang['ALL_BET.LBL_EG'];

      return b;
    },
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    setToTop: function setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    showMore: function showMore(eveid) {
      var on = '';
      on = $('.body_EG_' + eveid).hasClass('on');

      if (on) {
        $('.body_EG_' + eveid).removeClass('on');
        $('.row_' + eveid).removeClass('open');
      } else {
        $('.body_EG_' + eveid).addClass('on');
        $('.row_' + eveid).addClass('open');
      }
      $('#AllBet' + this.mode).getNiceScroll().resize();
    }
  },
  mounted: function mounted() {
    if (this.mode == 'ab') {
      this.show = this.$store.getters.foldopenAllBet ? true : false;
    } else {
      this.show = this.$store.getters.foldopenFirstEvent ? true : false;
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBetHeader_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec005a8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBetHeader_vue__ = __webpack_require__(415);
function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBetHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec005a8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBetHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_zh_cn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_locale_zh_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_mixins_favourite__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__osAllBetHeader__ = __webpack_require__(413);















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__vue_mixins_favourite__["a" /* default */]],
  components: {
    osAllBetHeader: __WEBPACK_IMPORTED_MODULE_10__osAllBetHeader__["a" /* default */]
  },
  props: {
    mode: null
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'matchAllBet', 'sortedMatchEventList', 'market', 'tvIconFlag', 'allBetReloading', 'selectedShow', 'selectedMarket', 'selectedBettype', 'selectedAllBetNew', 'selected_AllBetTab', 'selectedSport', 'selectedMatchAllBet', 'foldopenAllBet', 'foldopenFirstEvent', 'show_Unfold', 'showRightBanner', 'firstEvent', 'livetv', 'open_RBMarket', 'timeZone', 'betForm', 'simpleSport', 'liveSchedule', 'liveMatch', 'isOpenTv']), {
    selected_Tab: {
      get: function get() {
        if (this.mode == 'ab') {
          return this.$store.getters.selected_AllBetTab.ab;
        } else {
          return this.$store.getters.selected_AllBetTab.firstEvent;
        }
      }
    },
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    livetvEveLink: {
      get: function get() {
        return this.$store.getters.livetv.link;
      }
    }
  }),
  watch: {
    'livetvEveid': {
      handler: function handler(val, oldVal) {
        if (val != oldVal) {
          this.tvIsOn = true;
        }
      },

      deep: true,
      immediate: true
    },
    'showhideBanner': {
      handler: function handler(val, oldVal) {
        this.allBet_mContent();
      },

      deep: true,
      immediate: true
    },
    'firstEvent': {
      handler: function handler(val, oldVal) {
        var _this = this;

        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(val).length > 0 && !_.isUndefined(oldVal) && val.eveid != oldVal.eveid) {

          this.itemWrapLeft = 0;
          this.eleScrollLeft = 0;
          document.getElementById("tab-wrap-list" + this.mode).scrollLeft = 0;

          var arr = { 'firstEvent': 'all' };
          this.$store.commit('SELECTED_ALLBETTAB', arr);

          if (this.$store.getters.selectedBettype.betTypId == '5') {
            this.$nextTick(function () {
              var allBetparent = document.querySelectorAll('#' + _this.mode + 'allBetGroup' + val.eveid);
              allBetparent.forEach(function (childAllBet, indexAb) {
                var allBetchk = childAllBet.querySelector('.c-bet-item.active');
                if (allBetchk != null) {
                  allBetchk.classList.remove("active");
                }
              });

              if (_this.betForm.length > 0) {
                var bForm = _this.betForm;
                bForm.forEach(function (dt, index) {
                  if (dt.eveid == val.eveid) {
                    $("[id=" + dt.uniqueId + "]").closest('.c-bet-item').addClass('active');
                  }
                });
              }
            });
          }
        }
      },

      deep: true,
      immediate: true
    }

  },
  data: function data() {
    return {
      dragging: false,
      selectedLang: window._langid,
      lang: window.lang,
      fT: ['2', '3'],
      hT: ['2', '4'],
      showhideAll: true,
      otherSport1: ['N3', 'N12', 'N21'],
      betTab: {
        hot: {
          key: 'hot',
          value: true,
          flag: true
        },
        hdpou: {
          key: 'hdpou',
          value: [1, 2, 4, 32, 46, 48],
          rbvalue: [8, 9, 11, 33, 47, 49],
          flag: true
        },
        goals: {
          key: 'goals',
          value: [2, 3, 5],
          rbvalue: [18, 9, 10],
          flag: true
        },
        cs: {
          key: 'cs',
          value: [7],
          rbvalue: [16],
          flag: true
        },
        ft: {
          key: 'ft',
          value: [1],
          rbvalue: [8],
          flag: true
        },
        ht: {
          key: 'ht',
          value: [2],
          flag: true
        },
        sh: {
          key: 'sh',
          value: [19],
          flag: true
        },
        others: {
          key: 'others',
          value: true,
          flag: true
        },
        special: {
          key: 'special',
          value: true,
          flag: true
        },
        other: {
          key: 'other',
          value: [21, 34, 28, 30],
          rbvalue: [27, 29, 35, 31],
          flag: true
        },
        scrMarket: {
          key: 'scrMarket',
          value: [2, 3, 5, 7, 9, 10],
          flag: true
        },
        sethdp: {
          key: 'set',
          value: [3, 7, 8, 9, 10, 11, 12],
          rbvalue: [27, 29, 35, 31],
          flag: true
        },
        gamehdp: {
          key: 'game',
          value: [6],
          flag: true
        },
        pointhdp: {
          key: 'point',
          value: [4],
          flag: true
        },
        all: {
          key: 'all',
          value: true,
          flag: true
        },
        innings: {
          key: 'innings',
          value: [__WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().first5InningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().first3InningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().firstInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().secondInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().thirdInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().fourthInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().fifthInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().sixthInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().seventhInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().eightthInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().nineInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().OTPlayType],
          flag: true
        },
        team: {
          key: 'team',
          value: [__WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().htrBetType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().atrBetType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().rhtrBetType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().ratrBetType],
          flag: true
        },
        booking: {
          key: 'booking',
          value: ['7b', '10a', '23a'],
          flag: true
        },
        corner: {
          key: 'corner',
          value: ['7a', '9a', '22a'],
          flag: true
        }
      },
      showhideBanner: true,
      showTip: false,
      mContentPadding: '',
      reloading: false,
      bannerSize: 190,
      itemWrapLeft: 0,
      eleScrollLeft: 0,
      clientX: 0,
      moment: __WEBPACK_IMPORTED_MODULE_6_moment___default.a,
      token: window.token,

      timerSeconds: 60,
      earlyTimer: 60,
      rbTimer: 15,
      todayTimer: 30,
      reconnectTimerSeconds: 5,
      timerId: null,
      reconnectTimerId: null,
      tvIsOn: false,
      sportColLength: {
        '3': 6,
        '21': 5,
        '12': 3,
        '23': 10,
        '14': 4,
        '19': 2,
        '13': 5,
        '20': 6,
        '15': 35
      }
    };
  },

  methods: {
    displayConnerBooking: function displayConnerBooking(cb, event, team) {
      var disSC = '-';
      if (event.sp_rbinfo != undefined) {
        _.forEach(event.sp_rbinfo, function (data, key) {
          if (data.r == cb) {
            disSC = team == 'a' ? data.scoa : data.scob;
          }
        });
      }
      if (cb == 'b') {
        if (event.rbinfo != undefined && disSC != '-') {
          var redCardPoint = team == 'a' ? event.rbinfo.rca : event.rbinfo.rcb;
          if (redCardPoint > 0) {
            disSC = disSC - redCardPoint * 2;
          }
          if (disSC < 0) {
            disSC = '-';
          }
        } else {
          disSC = '-';
        }
      }
      return disSC;
    },
    matchDateCheck: function matchDateCheck(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default.a.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss");
    },
    closeTv: function closeTv() {
      var tvlinkArray = {};
      tvlinkArray.link = null;
      tvlinkArray.eveid = null;
      this.$store.commit('LIVETV', tvlinkArray);
    },
    startTv: function startTv(event) {
      var _this2 = this;

      if (event.rbstatus == 1) {
        if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
          if (window._hasRedirect) {
            $('.login-redirect-dialog').show();
          }
          return false;
        }
        this.loading = true;
        this.$ajax({
          url: _baseUrl + '/livetv',
          type: 'post',
          data: {
            chlid: event.ch,
            eventid: event.eveid,
            league: event.lgeid,
            tacap: event.tacapt,
            tbcap: event.tbcapt
          }
        }).then(function (response) {
          _this2.loading = false;
          var tvlinkArray = {};
          tvlinkArray.link = response;
          tvlinkArray.eveid = event.eveid;
          _this2.$store.commit('LIVETV', tvlinkArray);
        });
      }
    },
    checkStart: function checkStart(end) {
      var startTime = new __WEBPACK_IMPORTED_MODULE_6_moment___default.a().utcOffset("-04:00").format("YYYY-MM-DD HH:mm:ss");
      var endTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()(end);
      var difference = endTime.diff(__WEBPACK_IMPORTED_MODULE_6_moment___default()(startTime), 'minutes');
      if (difference >= 0) {
        return difference;
      }
      return 10000;
    },
    removeDragHandler: function removeDragHandler() {
      window.addEventListener('mouseup', this.stopDragHandler);
      window.addEventListener('touchend', this.stopDragHandler);
    },
    doDragHandler: function doDragHandler(e) {
      if (this.dragging) {
        var drag = document.getElementById("tab-wrap-list" + this.mode);
        var dx = void 0;
        if (e.type === 'mousemove') {
          dx = e.clientX - this.clientX;
        } else if (e.type === 'touchmove') {
          dx = e.touches[0].clientX - this.clientX;
        }
        drag.scrollLeft = this.eleScrollLeft - dx;
      }
    },
    startDragHandler: function startDragHandler(e) {
      if (e.type === 'mousedown') {
        this.clientX = e.clientX;
      } else if (e.type === 'touchstart') {
        this.clientX = e.touches[0].clientX;
      }
      this.dragging = true;
      var drag = document.getElementById("tab-wrap-list" + this.mode);
      this.eleScrollLeft = drag.scrollLeft;
    },
    stopDragHandler: function stopDragHandler() {
      this.dragging = false;
    },
    toggleTip: function toggleTip() {
      this.showTip = !this.showTip;
    },
    getitemWrapStyle: function getitemWrapStyle() {
      return 'left:' + this.itemWrapLeft + 'px;';
    },
    showhidetvbanner: function showhidetvbanner() {
      this.$store.commit('SHOWRIGHTBANNER', !this.$store.getters.showRightBanner);
    },
    unfoldSc: function unfoldSc() {
      this.$store.commit('SHOW_FOLD', true);
      this.$store.commit('SHOW_UNFOLD', false);
      this.$store.commit('UNFOLD_ALLSC', true);
      var element = document.getElementById('AllBetScrollfirstEvent');
      element.classList.add('hide');
      $('.c-site-header .header-item.item2').css('z-index', '48');
    },
    checkFTExist: function checkFTExist() {
      var exist = false;
      var eveList = this.mode == 'ab' ? this.sortedMatchEventList : this.firstEvent;
      if (eveList.od && eveList.od[this.ftPlyType] && (eveList.sptid == 1 || eveList.sptid == 13)) {
        exist = true;
      }
      return exist;
    },
    checkHTExist: function checkHTExist() {
      var exist = false;
      var eveList = this.mode == 'ab' ? this.sortedMatchEventList : this.firstEvent;
      if (eveList.od && eveList.od[this.firstHtPlyType] && (eveList.sptid == 1 || eveList.sptid == 13)) {
        exist = true;
      }
      if (eveList.od && eveList.od[this.SecondHtPlyType] && eveList.sptid == 1) {
        exist = true;
      }
      return exist;
    },
    checkSPExist: function checkSPExist() {
      var exist = false;
      var eveList = this.mode == 'ab' ? this.sortedMatchEventList : this.firstEvent;
      if (eveList.sp) {
        exist = true;
      }
      var specialBetTypes = [this.nogBetType, this.onex2ouBetType, this.onex2bttsBetType, this.ouoeBetType, this.oubttsBetType, this.ouftsBetType, this.onex2ftsBetType, this.dbchouBetType, this.dbchbttsBetType, this.dbchftsBetType];
      if (!exist) {
        _.forEach(eveList.od, function (data, key) {
          _.forEach(data, function (val, k) {
            if ($.inArray(k, specialBetTypes) > -1) {
              exist = true;
            }
          });
        });
      }
      return exist;
    },
    checkSpecialExist: function checkSpecialExist(type) {
      var exist = false;
      var eveList = this.mode == 'ab' ? this.sortedMatchEventList : this.firstEvent;
      var betTab = this.betTab;
      if (eveList.sp) {
        $.each(eveList.sp, function (key, value) {
          if (type == betTab.corner.key && value.od) {
            var prefixes = betTab.corner.value;
            if (prefixes.some(function (prefix) {
              return value.sbid.startsWith(prefix);
            })) {
              exist = true;
              return false;
            }
          } else if (type == betTab.booking.key && value.od) {
            var _prefixes = betTab.booking.value;
            if (_prefixes.some(function (prefix) {
              return value.sbid.startsWith(prefix);
            })) {
              exist = true;
              return false;
            }
          } else {
            return false;
          }
        });
      }
      return exist;
    },
    checkBTExist: function checkBTExist(BTkey) {
      var vue = this;
      var exist = false;
      var eveList = this.mode == 'ab' ? this.sortedMatchEventList : this.firstEvent;
      var btArray = eveList.rbinfo ? vue.betTab[BTkey].rbvalue : vue.betTab[BTkey].value;

      _.forEach(eveList.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), btArray) > -1) {
            exist = true;
          }
        });
      });
      return exist;
    },
    checkInningsExist: function checkInningsExist() {
      var vue = this;
      var exist = false;
      var eveList = this.mode == 'ab' ? this.sortedMatchEventList : this.firstEvent;

      var ptArray = vue.betTab['innings'].value;
      _.forEach(eveList.od, function (data, key) {
        if ($.inArray(key.toString(), ptArray) > -1) {
          exist = true;
        }
      });
      return exist;
    },
    checkTeamExist: function checkTeamExist() {
      var vue = this;
      var exist = false;
      var eveList = this.mode == 'ab' ? this.sortedMatchEventList : this.firstEvent;
      var btArray = vue.betTab['team'].value;

      _.forEach(eveList.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(k.toString(), btArray) > -1) {
            exist = true;
          }
        });
      });

      return exist;
    },
    allBet_mContent: function allBet_mContent() {
      var a = 76;
      var b = this.showhideBanner ? a + this.bannerSize : a;

      this.mContentPadding = 'padding-top: ' + b + 'px;';
    },
    showhide_Banner: function showhide_Banner(val) {
      this.showhideBanner = val;
      __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('hideScoreBoard', val);
    },
    getABetSport: function getABetSport() {
      var sprt = this.mode == 'ab' ? 'N' + this.$store.getters.sortedMatchEventList.sptid : 'N' + this.$store.getters.firstEvent.sptid;
      var sprt = this.$store.getters.selectedBettype.sprtId;
      if (this.mode == 'ab' && !_.isUndefined(this.$store.getters.sortedMatchEventList.sptid)) {
        sprt = 'N' + this.$store.getters.sortedMatchEventList.sptid;
      } else if (this.mode != 'ab' && !_.isUndefined(this.$store.getters.firstEvent.sptid)) {
        sprt = 'N' + this.$store.getters.firstEvent.sptid;
      }
      if (sprt == 'G98') {
        var spid = 'N' + this.$store.getters.firstEvent.sptid;
        return 'allBet' + spid;
      } else {
        return 'allBet' + sprt;
      }
    },
    foldopenAB: function foldopenAB() {
      if (this.mode == 'ab') {
        this.$store.commit('FOLDOPEN_ALLBET', !this.$store.getters.foldopenAllBet);
      } else {
        this.$store.commit('FOLDOPEN_FIRSTEVENT', !this.$store.getters.foldopenFirstEvent);
      }
    },
    showhideMain: function showhideMain() {
      this.showhideAll = this.showhideAll ? false : true;
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide);
    },
    chooseBetTab: function chooseBetTab(betTab) {
      if (betTab.flag) {
        var BETTAB_value = {};
        if (this.mode == 'ab') {
          BETTAB_value.ab = betTab.key;
        } else {
          BETTAB_value.firstEvent = betTab.key;
        }

        $('#AllBet' + this.mode).getNiceScroll().remove();

        $('#AllBet' + this.mode).niceScroll({
          horizrailenabled: false,
          autohidemode: false,
          scrollbarid: 'AllBetScroll' + this.mode,
          cursorborder: "0px solid #fff",
          zindex: 48,
          railoffset: { left: 10 }
        }), this.$store.commit('SELECTED_ALLBETTAB', BETTAB_value);
      }
    },
    switchAllBetTab: function switchAllBetTab(id) {
      $('.moreBetTypeNav-Item').removeClass('active');
      $(id).addClass('active');
    },
    reloadTable: function reloadTable() {
      var _this3 = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.oddsReload = true;

      __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('templateChange', this.oddsReload);

      var dispatchName = 'getSportOdds';
      if (this.$store.getters.selectedBettype.betTypId == '6') {
        dispatchName = 'getSportOutrightOdds';
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8;
      }

      this.$store.dispatch(dispatchName, {
        token: token_val,
        showfavorite: this.$store.getters.showFavEvents && dispatchName == 'getSportOdds' ? true : false,
        callback: function (res) {
          if (res.events) {
            _this3.reconnectTimerId = null;
            _.forEach(res.events, function (val, key) {
              _.forEach(val, function (v, k) {
                var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse');
                if (showAllBet) {
                  $('#moreExpand' + v.eveid).addClass('icon-moreExpand');
                  $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse');
                  $('#moreBets' + v.eveid).css("display", "none");
                }
              });
            });
          } else {
            _this3.reconnectTimerSeconds = 5;
            if (_this3.reconnectTimerId == null) {
              _this3.reconnectTimerId = setInterval(function () {
                if (_this3.reconnectTimerSeconds - 1 < 0) {
                  _this3.reloadTable();
                } else {
                  _this3.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (_this3.showFavEvents) {
            _this3.$store.dispatch('getLaugueList', function (res) {
              this.$store.commit('SELECTEDLEAGUES', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
              this.$store.commit('TOTALLEAGUES', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
            }.bind(_this3));
          }
          _this3.reloading = false;
          _this3.oddsReload = false;
          __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('templateChange', _this3.oddsReload);


          _this3.$store.commit('PARLAY_SELECTED', { update: false });
        }.bind(this)
      });
    },
    backToMain: function backToMain() {
      __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('sportTableReloading', true);
      this.reloadTable();
      this.$store.commit('SELECTED_MATCHALLBET', false);
      $('#AllBet' + this.mode).getNiceScroll().remove();
      $('#AllBet' + this.mode).remove();
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    getMarketTimer: function getMarketTimer(selMarket) {
      if (this.$store.getters.open_RBMarket) {
        return this.rbTimer;
      } else if (selMarket == this.$store.getters.market.earlyMarket.key) {
        return this.earlyTimer;
      } else if (selMarket == this.$store.getters.market.tdyMarket.key) {
        return this.todayTimer;
      }
    },
    startAllBetTimer: function startAllBetTimer() {
      var _this4 = this;

      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (_this4.timerSeconds - 1 < 0) {
            _this4.refreshTbl(token.arr_1);
          } else {
            _this4.timerSeconds -= 1;
          }
        }, 1000);
      }
    },
    refreshTbl: function refreshTbl(token_val) {
      $('#tblRefresh').addClass('loading-static-animation');
      this.reloading = token_val == token.arr_1 || token_val == token.arr_5 ? false : true;
      if (this.selectedMatchAllBet) {
        this.reloadAllBetTable(token_val);
      }
    },
    reloadAllBetTable: function reloadAllBetTable() {
      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (token_val == '') {
        token_val = token.arr_5;
      }
      var getEvent = '';
      var rbSta = '';
      var startTv = 0;
      this.clearTimer();
      if (this.$store.getters.liveSchedule && this.$store.getters.liveMatch != null) {
        getEvent = this.$store.getters.liveMatch;
        rbSta = this.$store.getters.liveMatch.rbstatus;
        startTv = this.$store.getters.isOpenTv;
      } else {
        getEvent = this.$store.getters.sortedMatchEventList;
        rbSta = this.$store.getters.sortedMatchEventList.rbstatus;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: getEvent,
        isRB: rbSta == 1 ? true : false,

        token: token.arr_8,
        loadTemplate: startTv,
        reload: true,
        notLoadTV: true
      });

      this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket);

      this.startAllBetTimer();
    },
    refreshRightScoreBoard: function refreshRightScoreBoard() {
      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (this.$store.getters.firstEvent && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.firstEvent).length > 0 || this.$store.getters.firstEvent.length > 0)) {
        this.$store.dispatch('getMatchAllBet', {
          event: this.$store.getters.firstEvent,
          isRB: this.$store.getters.firstEvent.rbstatus == 1 ? true : false,
          token: token.arr_8,
          loadTemplate: this.livetvEveLink != '' && this.livetvEveid > 0 ? 2 : 1,
          notLoadTV: this.livetvEveLink != '' && this.livetvEveid > 0 ? true : false,
          reload: true
        });
      }
    },
    checkTimer: function checkTimer(event) {
      return this.$options.filters.checkTimer(event);
    },
    getSportIcon: function getSportIcon(sptid) {
      return 'N' + sptid + '_R';
    },
    getScoreSet: function getScoreSet(event, team) {
      var total = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var teamA = 0;
      var teamB = 0;

      _.forEach(event.rbinfo.score, function (data, key) {
        if (event.sptid == 3) {
          if (key == 'SH') {
            teamA = parseInt(data.scoa);
            teamB = parseInt(data.scob);
          }
        } else if (event.sptid == 23) {
          if (key == 'FT') {
            teamA = parseInt(data.scoa);
            teamB = parseInt(data.scob);
          }
        } else if (event.sptid == 14) {
          if (key == 'FT') {
            teamA = parseInt(data.scoa);
            teamB = parseInt(data.scob);
          }
        } else if (event.sptid == 12 || event.sptid == 21) {
          if (total) {
            if (key == 'PT') {
              teamA = parseInt(data.scoa);
              teamB = parseInt(data.scob);
            }
          } else {
            if (key == 'SH') {
              teamA = parseInt(data.scoa);
              teamB = parseInt(data.scob);
            }
          }
        } else if (event.sptid == 20 || event.sptid == 15) {
          if (key == 'FT') {
            teamA = parseInt(data.scoa);
            teamB = parseInt(data.scob);
          }
        } else if (event.sptid == 13) {
          if (total) {
            if (key == 'FT') {
              teamA = parseInt(data.scoa);
              teamB = parseInt(data.scob);
            }
          }
        } else if (event.sptid == 7 || event.sptid == 19) {
          if (key == 'FT') {
            teamA = data.scoa;
            teamB = data.scob;
          }
        }
      });

      return team == 'A' ? teamA : teamB;
    },
    activeRbScoreBoard: function activeRbScoreBoard() {

      var $container = $('.time-node.mini');
      var $next = $('#next');
      var $prev = $('#prev');
      var itemWidth = 35;

      var isAnimating = false;

      $('.icon-arrow').hover(function () {
        $(this).css('color', 'rgb(255, 112, 0)');
      }, function () {
        $(this).css('color', 'rgb(109, 114, 120)');
      });

      $next.off('click').on('click', function () {
        if (isAnimating) return;
        isAnimating = true;

        $container.animate({ scrollLeft: $container.scrollLeft() + itemWidth }, 300, function () {
          isAnimating = false;
          updateArrowVisibility();
        });
      });

      $prev.off('click').on('click', function () {
        if (isAnimating) return;
        isAnimating = true;

        $container.animate({ scrollLeft: $container.scrollLeft() - itemWidth }, 300, function () {
          isAnimating = false;
          updateArrowVisibility();
        });
      });

      function updateArrowVisibility() {
        var scrollLeft = $container.scrollLeft();
        if (scrollLeft != undefined) {
          var maxScrollLeft = $container[0].scrollWidth - $container.outerWidth();

          if (scrollLeft > 0) {
            $('#prev .arrow-left').css('display', 'block');
          } else {
            $('#prev .arrow-left').css('display', 'none');
          }
          if (scrollLeft < maxScrollLeft) {
            $('#next .arrow-right').css('display', 'block');
          } else {
            $('#next .arrow-right').css('display', 'none');
          }
        }
      }

      updateArrowVisibility();

      $container.on('scroll', function () {
        if (!isAnimating) updateArrowVisibility();
      });
    },
    activeAllBetOsScoreBoard: function activeAllBetOsScoreBoard(event) {
      this.$nextTick(function () {
        var $container = $('.time-node.is_details');
        var $next = $('#next-sn');
        var $prev = $('#prev-sn');
        var itemWidth = 35;

        var isAnimating = false;

        $('.is_details .icon-arrow').hover(function () {
          $(this).css('color', 'rgb(255, 112, 0)');
        }, function () {
          $(this).css('color', 'rgb(109, 114, 120)');
        });

        $next.off('click').on('click', function () {
          if (isAnimating) return;
          isAnimating = true;

          $container.animate({ scrollLeft: $container.scrollLeft() + itemWidth }, 300, function () {
            isAnimating = false;
            updateArrowVisibility();
          });
        });

        $prev.off('click').on('click', function () {
          if (isAnimating) return;
          isAnimating = true;

          $container.animate({ scrollLeft: $container.scrollLeft() - itemWidth }, 300, function () {
            isAnimating = false;
            updateArrowVisibility();
          });
        });

        function updateArrowVisibility() {
          var scrollLeft = $container.scrollLeft();
          if (scrollLeft != undefined) {
            var maxScrollLeft = $container[0].scrollWidth - $container.outerWidth();

            if (scrollLeft > 0) {
              $('#prev-sn .arrow-left').css('display', 'block');
            } else {
              $('#prev-sn .arrow-left').css('display', 'none');
            }
            if (scrollLeft < maxScrollLeft) {
              $('#next-sn .arrow-right').css('display', 'block');
            } else {
              $('#next-sn .arrow-right').css('display', 'none');
            }
          }
        }

        updateArrowVisibility();

        $container.on('scroll', function () {
          if (!isAnimating) updateArrowVisibility();
        });
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.allBet_mContent();
    this.removeDragHandler();
    this.$refs.tabWrapList.addEventListener('mousedown', this.startDragHandler);
    this.$refs.tabWrapList.addEventListener('touchstart', this.startDragHandler);
    window.addEventListener('mousemove', this.doDragHandler);
    window.addEventListener('touchmove', this.doDragHandler);
    var Vue = this;
    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$on('refreshAllbetTable', function (params) {
      if (_this5.selectedMatchAllBet) {
        _this5.refreshTbl(params.token);
      }
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$on('refreshRightScoreBoard', function (params) {
      _this5.refreshRightScoreBoard(params.token);
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$on('activeRbScoreBoard', function () {
      _this5.activeRbScoreBoard();
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$on('activeAllBetOsScoreBoard', function (params) {
      _this5.activeAllBetOsScoreBoard(params);
    }.bind(this));

    $(document).on('click', function (e) {
      if (Vue.showTip) {
        if ($(e.target).closest(".tip-content").length === 0 && $(e.target).closest(".showTip").length === 0) {
          Vue.showTip = false;
        }
      }
    });
  },
  beforeMount: function beforeMount() {
    if (this.mode == 'ab') {
      var BETTAB_value = {};
      if (this.mode == 'ab') {
        BETTAB_value.ab = this.betTab.all.key;
      } else {
        BETTAB_value.firstEvent = this.betTab.all.key;
      }
      this.$store.commit('SELECTED_ALLBETTAB', BETTAB_value);
      this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket);
      this.startAllBetTimer();
      if (this.$refs.tabWrapList) {
        this.$refs.tabWrapList.removeEventListener('mousedown', this.startDragHandler);
        this.$refs.tabWrapList.removeEventListener('touchstart', this.startDragHandler);
      }
      window.removeEventListener('mousemove', this.doDragHandler);
      window.removeEventListener('touchmove', this.doDragHandler);
      window.removeEventListener('mouseup', this.stopDragHandler);
      window.removeEventListener('touchend', this.stopDragHandler);
    }
  },
  updated: function updated() {
    if (this.tvIsOn) {
      this.tvIsOn = false;
      __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('rightScoreBoard', true);
    }
    this.activeRbScoreBoard();
  },
  destroyed: function destroyed() {
    this.clearTimer();
    this.removeDragHandler();
    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$off('templateChange');
    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$off('sportTableReloading');
    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$off('refreshAllbetTable');
    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$off('refreshRightScoreBoard');
    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$off('activeRbScoreBoard');
  }
});
var playframe_original_style;
window.addEventListener("message", function (ev) {
  if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(ev.data) !== "object") return;
  if (!ev.data.type) return;
  if (ev.data.type !== "full_screen_click") return;
  var playframe_message = ev.data.message;
  var playframe = document.getElementById("livetv");

  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(playframe_message).length > 0) {
    var playframe_fullscreen_style = "";
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(playframe_message).forEach(function (val, idx) {
      var style_name = val;
      playframe_fullscreen_style += style_name + ': ' + playframe_message[val] + ';';
    });
    playframe_original_style = playframe.getAttribute("style");
    playframe.setAttribute("style", playframe_fullscreen_style);
    $('.nicescroll-cursors').css('display', 'none');
    $('.v-scroll-area').css('display', 'block');
    $('.c-site-header .header-item.item2').css('z-index', '45');
    $('.scroll-fixed-headerA').css('z-index', '46');
    $('.yb-match-list').css('z-index', '46');
  } else {
    $('.nicescroll-cursors').css('display', '');
    $('.c-site-header .header-item.item2').css('z-index', '47');
    $('.scroll-fixed-headerA').css('z-index', '48');
    $('.v-scroll-area').css('display', '');
    $('.yb-match-list').css('z-index', '48');
    if (playframe_original_style != null) {
      playframe.setAttribute("style", playframe_original_style);
    } else {
      playframe.removeAttribute("style");
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_zh_cn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_locale_zh_cn__);










/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        sportColLength: {
            type: Object
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'matchAllBet', 'sortedMatchEventList', 'market', 'tvIconFlag', 'allBetReloading', 'selectedShow', 'selectedMarket', 'selectedBettype', 'selectedAllBetNew', 'selected_AllBetTab', 'selectedSport', 'selectedMatchAllBet', 'foldopenAllBet', 'foldopenFirstEvent', 'show_Unfold', 'showRightBanner', 'firstEvent', 'livetv', 'open_RBMarket', 'timeZone', 'betForm', 'simpleSport', 'liveSchedule', 'liveMatch', 'isOpenTv'])),
    methods: {
        getScoreSet: function getScoreSet(event, team) {
            var total = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var teamA = 0;
            var teamB = 0;
            var hasRec = 0;
            if (event.rbinfo != undefined && event.rbinfo.score != undefined) {
                _.forEach(event.rbinfo.score, function (data, key) {
                    hasRec = 1;
                    if (event.sptid == 3) {
                        if (key == 'SH') {
                            teamA = data.scoa;
                            teamB = data.scob;
                        }
                    } else if (event.sptid == 23) {
                        if (key == 'FT') {
                            teamA = parseInt(data.scoa);
                            teamB = parseInt(data.scob);
                        }
                    } else if (event.sptid == 14) {
                        if (key == 'FT') {
                            teamA = parseInt(data.scoa);
                            teamB = parseInt(data.scob);
                        }
                    } else if (event.sptid == 12 || event.sptid == 21) {
                        if (total) {
                            if (key == 'PT') {
                                teamA = parseInt(data.scoa);
                                teamB = parseInt(data.scob);
                            }
                        } else {
                            if (key == 'SH') {
                                teamA = parseInt(data.scoa);
                                teamB = parseInt(data.scob);
                            }
                        }
                    } else if (event.sptid == 20 || event.sptid == 15) {
                        if (key == 'FT') {
                            teamA = parseInt(data.scoa);
                            teamB = parseInt(data.scob);
                        }
                    } else if (event.sptid == 13) {
                        if (total) {
                            if (key == 'FT') {
                                teamA = parseInt(data.scoa);
                                teamB = parseInt(data.scob);
                            }
                        }
                    } else if (event.sptid == 7 || event.sptid == 19) {
                        if (key == 'FT') {
                            teamA = data.scoa;
                            teamB = data.scob;
                        }
                    }
                });
            }
            if (hasRec == 0) {
                return '-';
            }
            return team == 'A' ? teamA : teamB;
        }
    }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBetContent_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6d8d096_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBetContent_vue__ = __webpack_require__(417);
function injectStyle (ssrContext) {
  __webpack_require__(416)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBetContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6d8d096_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBetContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allBet_all_bet__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_mixins_favourite__ = __webpack_require__(17);
















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__vue_mixins_favourite__["a" /* default */]],
  props: {
    mode: null
  },
  components: {
    allBetComponent: __WEBPACK_IMPORTED_MODULE_7__allBet_all_bet__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'matchAllBet', 'sortedMatchEventList', 'market', 'selectedShow', 'selectedMarket', 'selectedBettype', 'tvIconFlag', 'selectedAllBetNew', 'foldopenAllBet', 'allBetReloading', 'testshow', 'showRightBanner', 'frameWidthHeight', 'livetv']), {
    heightPX: function heightPX() {
      return this.$store.getters.frameWidthHeight.height.currentHeight;
    }
  }),
  watch: {
    'showhideBanner': {
      handler: function handler(val, oldVal) {
        this.allBet_mContent();
      },

      deep: true,
      immediate: true
    },
    showRightBanner: function showRightBanner() {
      this.allBet_mContent();
    }
  },
  data: function data() {
    return {
      showALL: false,
      selectedLang: window._langid,
      lang: window.lang,
      fT: ['2', '3'],
      hT: ['2', '4'],
      showhideAll: true,

      otherSport1: ['N3', 'N12', 'N21'],
      betTab: {
        hot: {
          key: 'hot',
          value: true,
          flag: true
        },
        hdpou: {
          key: 'hdpou',
          value: [1, 2, 4, 32, 46, 48],
          rbvalue: [8, 9, 11, 33, 47, 49],
          flag: true
        },
        goals: {
          key: 'goals',
          value: [2, 3, 5],
          rbvalue: [18, 9, 10],
          flag: true
        },
        cs: {
          key: 'cs',
          value: [7],
          rbvalue: [16],
          flag: true
        },
        ft: {
          key: 'ft',
          value: [1],
          rbvalue: [8],
          flag: true
        },
        ht: {
          key: 'ht',
          value: [2],
          flag: true
        },
        sh: {
          key: 'sh',
          value: [19],
          flag: true
        },
        others: {
          key: 'others',
          value: true,
          flag: true
        },
        special: {
          key: 'special',
          value: true,
          flag: true
        },
        other: {
          key: 'other',
          value: [21, 34, 28, 30],
          rbvalue: [27, 29, 35, 31],
          flag: true
        },
        scrMarket: {
          key: 'scrMarket',
          value: [2, 3, 5, 7, 9, 10],
          flag: true
        },
        sethdp: {
          key: 'set',
          value: [3, 7, 8, 9, 10, 11, 12],
          rbvalue: [27, 29, 35, 31],
          flag: true
        },
        gamehdp: {
          key: 'game',
          value: [6],
          flag: true
        },
        pointhdp: {
          key: 'point',
          value: [4],
          flag: true
        },
        all: {
          key: 'all',
          value: true,
          flag: true
        },
        innings: {
          key: 'innings',
          value: [__WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().first5InningsPlyType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().first3InningsPlyType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().firstInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().secondInningsPlyType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().thirdInningsPlyType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().fourthInningsPlyType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().fifthInningsPlyType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().sixthInningsPlyType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().seventhInningsPlyType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().eightthInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().nineInningsPlayType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().OTPlyType],
          flag: true
        },
        team: {
          key: 'team',
          value: [80, 82],
          rbvalue: [81, 83],
          flag: true
        },
        booking: {
          key: 'booking',
          value: ['7b', '10a', '23a'],
          flag: true
        },
        corner: {
          key: 'corner',
          value: ['7a', '9a', '22a'],
          flag: true
        }
      },
      showhideBanner: true,
      mContentPadding: '',
      reloading: false,
      bannerSize: 190
    };
  },

  methods: {
    checkBTExist: function checkBTExist(BTkey) {
      var vue = this;

      var exist = false;
      var btArray = this.sortedMatchEventList.rbinfo ? vue.betTab[BTkey].rbvalue : vue.betTab[BTkey].value;

      _.forEach(this.sortedMatchEventList.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), btArray) > -1) {
            exist = true;
          }
        });
      });

      return exist;
    },
    allBet_mContent: function allBet_mContent() {
      if (this.mode == 'firstEvent') {
        var b = this.$store.getters.showRightBanner ? '303' : '113';
        if (this.$store.getters.showRightBanner && this.$store.getters.livetv.eveid > 0) {
          b = 363;
          if ($('#AllBetfirstEvent').parent().parent().children('.scroll-header.absolute').length > 0) {
            b = $('#AllBetfirstEvent').parent().parent().children('.scroll-header.absolute').height();
          }
        }
      } else {
        var a = 76;
        var b = this.showhideBanner ? a + this.bannerSize : a;
      }
      this.mContentPadding = 'padding-top: ' + b + 'px;';
    },
    showhide_Banner: function showhide_Banner(val) {
      this.showhideBanner = val;
      this.allBet_mContent();
    },
    getABetSport: function getABetSport() {
      var sprt = this.$store.getters.selectedBettype.sprtId;

      return 'allBet' + sprt;
    },
    foldopenAB: function foldopenAB() {
      this.$store.commit('FOLDOPEN_ALLBET', !this.$store.getters.foldopenAllBet);
    },
    backtoTop: function backtoTop() {
      $(".scroll").animate({ scrollTop: 0 }, 100);
    },
    showhideMain: function showhideMain() {
      this.showhideAll = this.showhideAll ? false : true;
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide);
    },
    getSubMatch: function getSubMatch(sub) {
      return sub + 1;
    },
    showLeg: function showLeg() {
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide);
    },
    switchAllBetTab: function switchAllBetTab(id) {
      $('.moreBetTypeNav-Item').removeClass('active');
      $(id).addClass('active');
    },
    checkOpenMore: function checkOpenMore(event) {
      if (event.sp) {
        return true;
      } else if (event.od) {
        var show = true;
        $.each(event.od, function (plyTypes, drawBt) {
          if (plyTypes !== '1' && plyTypes !== '3') {
            return true;
          } else {
            show = true;
            if (plyTypes == '1' || plyTypes == '2') {
              $.each(drawBt, function (bidx, drawDual) {
                show = true;

                if (bidx == 1 || bidx == 2 || bidx == 4 || bidx == 8 || bidx == 9 || bidx == 11) {
                  show = false;
                }
              });
            }
          }
        });
        return show;
      }
      return false;
    },
    reloadTable: function reloadTable() {
      var _this = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.oddsReload = true;

      __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('templateChange', this.oddsReload);

      var dispatchName = 'getSportOdds';
      if (this.$store.getters.selectedBettype.betTypId == '6') {
        dispatchName = 'getSportOutrightOdds';
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8;
      }

      this.$store.dispatch(dispatchName, {
        token: token_val,
        callback: function (res) {
          if (res.events) {
            _this.reconnectTimerId = null;
            _.forEach(res.events, function (val, key) {
              _.forEach(val, function (v, k) {
                var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse');
                if (showAllBet) {
                  $('#moreExpand' + v.eveid).addClass('icon-moreExpand');
                  $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse');
                  $('#moreBets' + v.eveid).css("display", "none");
                }
              });
            });
          } else {
            _this.reconnectTimerSeconds = 5;
            if (_this.reconnectTimerId == null) {
              _this.reconnectTimerId = setInterval(function () {
                if (_this.reconnectTimerSeconds - 1 < 0) {
                  _this.reloadTable();
                } else {
                  _this.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (_this.showFavEvents) {
            _this.$store.dispatch('getLaugueList', function (res) {
              this.$store.commit('SELECTEDLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
              this.$store.commit('TOTALLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
            }.bind(_this));
          }
          _this.reloading = false;
          _this.oddsReload = false;
          __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('templateChange', _this.oddsReload);


          _this.$store.commit('PARLAY_SELECTED', { update: false });
        }.bind(this)
      });
    },
    backToMain: function backToMain() {
      __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('sportTableReloading', true);
      this.reloadTable();
      this.$store.commit('SELECTED_MATCHALLBET', false);
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    getMarketTimer: function getMarketTimer(selMarket) {
      if (this.$store.getters.open_RBMarket) {
        return this.rbTimer;
      } else if (selMarket == this.$store.getters.market.earlyMarket.key) {
        return this.earlyTimer;
      } else if (selMarket == this.$store.getters.market.tdyMarket.key) {
        return this.todayTimer;
      }
    },
    startAllBetTimer: function startAllBetTimer() {
      var _this2 = this;

      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (_this2.timerSeconds - 1 < 0) {
            _this2.refreshTbl(token.arr_1);
          } else {
            _this2.timerSeconds -= 1;
          }
        }, 1000);
      }
    },
    refreshTbl: function refreshTbl(token_val) {
      this.reloading = token_val == token.arr_1 || token_val == token.arr_5 ? false : true;
      if (this.selectedMatchAllBet) {
        this.reloadAllBetTable(token_val);
      }
    },
    reloadAllBetTable: function reloadAllBetTable() {
      var _this3 = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (token_val == '') {
        token_val = token.arr_5;
      }
      this.clearTimer();

      this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList);

      this.$store.dispatch('getSportAllBet', {
        token: token_val,
        inAllBet: true,
        event: this.$store.getters.sortedMatchEventList,
        callback: function (res) {
          _this3.timerSeconds = _this3.getMarketTimer(_this3.$store.getters.selectedMarket);

          _this3.startAllBetTimer();
          _this3.mainMarketList = _.cloneDeep(_this3.$store.getters.sortedMatchEventList);

          _this3.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('diffOdd', _this3.cloneEventAllBet);
          });
          _this3.reloading = false;
        }.bind(this)
      });
    },
    checkTimer: function checkTimer(event) {
      return this.$options.filters.checkTimer(event);
    }
  },
  mounted: function mounted() {
    this.allBet_mContent();
    $('#AllBet' + this.mode).addClass('dragable');
    $('#AllBet' + this.mode).niceScroll({
      horizrailenabled: false,
      autohidemode: false,
      scrollbarid: 'AllBetScroll' + this.mode,
      cursorborder: "0px solid #fff",
      zindex: 48,
      railoffset: { left: 10 },
      cursordragontouch: true

    });
  },
  beforeMount: function beforeMount() {
    if (this.sortedMatchEventList.rbinfo && this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key) {
      this.$store.commit('IS_TODAYRB', true);
    } else if (this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key) {
      this.$store.commit('IS_TODAYRB', false);
    }
    this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket);
    this.startAllBetTimer();

    var Vue = this;
    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$on("hideScoreBoard", function (hideShow) {
      Vue.showhide_Banner(hideShow);
    });
    if (Vue.mode != 'ab') {
      __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$off('rightScoreBoard');
      __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$on("rightScoreBoard", function (hideShow) {
        Vue.allBet_mContent();
      });
    }
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$off('hideScoreBoard');
    this.clearTimer();
    $('#AllBet' + this.mode).getNiceScroll().remove();
    $('#AllBet' + this.mode).remove();
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportTable_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf7979b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportTable_vue__ = __webpack_require__(508);
function injectStyle (ssrContext) {
  __webpack_require__(419)
  __webpack_require__(420)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf7979b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sportTemplate__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__box_leagueSelectionBox__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__footerContent__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__allBet_all_bet__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vue_components_forecast__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vue_components_mini_bet__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vue_mixins_sportMatchCount__ = __webpack_require__(48);






















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_14__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__vue_mixins_sportMatchCount__["a" /* default */]],
  components: {
    allBetComponent: __WEBPACK_IMPORTED_MODULE_9__allBet_all_bet__["a" /* default */],
    sportTemplate: __WEBPACK_IMPORTED_MODULE_6__sportTemplate__["a" /* default */],
    leagueSelectionBox: __WEBPACK_IMPORTED_MODULE_7__box_leagueSelectionBox__["a" /* default */],
    forecast: __WEBPACK_IMPORTED_MODULE_12__vue_components_forecast__["a" /* default */],
    minibet: __WEBPACK_IMPORTED_MODULE_13__vue_components_mini_bet__["a" /* default */],
    footerContent: __WEBPACK_IMPORTED_MODULE_8__footerContent__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['account', 'totalPage', 'oddTypesList', 'earlyParlayDateList', 'sportTableLang', 'market', 'sortTypes', 'sortShowTypes', 'marketType', 'selectedMarket', 'selectedBettype', 'selectedEarlyParlayDate', 'selectedAllBet', 'arr_selectedLeagueList', 'favouriteEvents', 'favouriteOTREvents', 'favouriteOTREventsCount', 'favouriteEventsCount', 'favouriteRBEventsCount', 'favouriteLgeEvents', 'showFavEvents', 'sportForecastToggle', 'sportMiniBet', 'cookieLeague', 'selectedSport', 'selectedMatchAllBet', 'sortedMatchEventList', 'langList', 'open_RBMarket', 'sportList', 'allSportCount', 'unfold_AllSc', 'show_Fold', 'showLeagueSearch', 'searchLeague', 'isParlayTab', 'previousBettype', 'isGameBannerSelected', 'simpleSport', 'hotSchedule', 'hot_sportList', 'specialEvent', 'refreshToggle']), {
    showFavEvents: {
      get: function get() {
        return this.$store.getters.showFavEvents;
      },
      set: function set(value) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
        var dispatchName = 'getSportOdds';
        if (this.$store.getters.selectedBettype.betTypId == '6') {
          dispatchName = 'getSportOutrightOdds';
        }
        this.$store.dispatch(dispatchName, {
          showfavorite: value,
          callback: function (res) {
            _this.refreshTimer();
            _this.refreshScroll();
          }.bind(this)
        });
      }
    },
    selectedPage: {
      get: function get() {
        return this.$store.getters.selectedPage;
      },
      set: function set(value) {
        this.reloading = true;
        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
        this.$store.commit('SELECTED_PAGE', value);
        this.reloadTable(token.arr_13 + '|' + value);
      }
    },
    selectedSort: {
      get: function get() {
        return this.$store.getters.selectedSort;
      },
      set: function set(value) {
        this.$store.commit('SELECTED_SORT', value);
      }
    },
    selectedShow: {
      get: function get() {
        return this.$store.getters.selectedShow;
      },
      set: function set(value) {
        this.$store.commit('SELECTED_SHOW', value);
      }
    },
    selectedLeagues: {
      get: function get() {
        return this.$store.getters.selectedLeagues;
      },
      set: function set(value) {
        this.reloading = true;
        this.$store.commit('SELECTEDLEAGUES', value);
      }
    },
    totalLeagues: {
      get: function get() {
        return this.$store.getters.totalLeagues;
      },
      set: function set(value) {
        this.$store.commit('TOTALLEAGUES', value);
      }
    },
    leagueToggle: function leagueToggle() {
      return this.$store.getters.bool_leagueToggle;
    },
    countFav: function countFav() {
      var count = 0;
      var betTypId = this.selectedBettype.betTypId;
      var sprtid = this.selectedBettype.sprtId;
      if (betTypId == 6) {
        count = this.favouriteOTREventsCount;
      } else {
        if (this.selectedMarket == '1' || this.selectedMarket == '5') {
          count = this.favouriteEventsCount + this.favouriteRBEventsCount;
        } else if (this.selectedMarket == '3') {
          count = this.favouriteRBEventsCount;
        } else {
          count = this.favouriteEventsCount;
        }
      }
      return count;
    },
    onlyCommonAndNotParlayOTRTemplate: function onlyCommonAndNotParlayOTRTemplate() {
      var quickbet = ['1', '2', '3', '4', '5', '6', '7', '8'];

      return quickbet.indexOf(this.currentTemplate.id) !== -1;
    },
    onlyCommonAndNotParlayTemplate: function onlyCommonAndNotParlayTemplate() {
      var quickbet = ['1', '2', '3', '4', '6', '7', '8'];

      return quickbet.indexOf(this.currentTemplate.id) !== -1 && this.$store.getters.selectedBettype.betTypId != '5';
    }
  }),
  watch: {
    favouriteLgeEvents: {
      handler: function handler(val, oldVal) {},

      deep: true,
      immediate: true
    },
    favouriteOTREventsCount: {
      handler: function handler(val, oldVal) {},

      deep: true,
      immediate: true
    },
    favouriteEventsCount: {
      handler: function handler(val, oldVal) {},

      deep: true,
      immediate: true
    },
    favouriteRBEventsCount: {
      handler: function handler(val, oldVal) {},

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      hover: false,
      selectedOdd: null,
      lang: window.lang,
      timerSeconds: 60,
      earlyTimer: 60,
      rbTimer: 15,
      todayTimer: 30,
      reconnectTimerSeconds: 5,
      futureDate: '8',
      allDate: '99',
      todayDate: '0',
      selectedLang: window._langid,
      timerId: null,
      reconnectTimerId: null,
      reloading: false,
      oddsReload: false,
      currentTemplate: {},
      currentMarket: null,
      rbtable: false,
      normaltable: false,
      hoverDay: false,
      maxPayout: false,
      maxPayout_O: false,
      templateClass: "tableContent",
      templateClassArr: {
        "1": "FTR",
        "2": "FTPD",
        "3": "FTT",
        "4": "FTF",
        "8": "BKR",
        '6': 'FSFT'
      },
      subTitle: "",
      accountData: this.$store.getters.account,
      token: window.token,
      sortActive: false,
      showTypeActive: false,
      oddsTypeActive: false,
      marketActive: false,

      parlayST: ['N2', 'N1'],
      parlayBT: ['1', '2', '3', '4', '7'],
      sportBettypeList: window.sportBettypeList,
      selRBSprtId: 'N1',
      countAllSport: 0,
      rbAllSport: {
        "sprtId": "G98"
      },
      showLarrowEarly: false,
      showRarrowEarly: true,
      showLarrowRB: true,
      showRarrowRB: true,
      excludeLge: ['6'],
      dateLeft: 0,
      rbSportLeft: 0,
      showGameBanner: window._gameBanner ? true : false,
      gameBannerImage: window._gameBannerImage,
      cookies_lang: window._cookie
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'cookies_lang', window._cookie), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hotSport', window.hotSport), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sport_profile', window.def_sport_profile), _ref;
  },
  beforeMount: function beforeMount() {
    this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket);
    if (this.selectedSport.sprtId == '' && this.selectedBettype.betTypId == '') {
      this.$store.commit('SPORTLIST', _.uniqBy(this.sportBettypeList, 'sprtId'));
      this.$store.commit('SPORTBETTYPELIST', this.sportBettypeList);
      this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[0]);
      this.commitBettypeList();
      this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.$store.getters.bettypeList[0]));
    }

    this.selectedOdd = this.$store.getters.account.oddsType;
    this.startTimer();
    this.getSportSettings(token.arr_7);
    $('#AllBetab').getNiceScroll().remove();
    $('#AllBetab').remove();

    var favEvent_Arr = __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_accfav_event');
    var favLgEvent_Arr = __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(this.$store.getters.account.acccode + '_accfavlg_event');

    favEvent_Arr = JSON.parse(favEvent_Arr);
    favLgEvent_Arr = JSON.parse(favLgEvent_Arr);

    if (favEvent_Arr != null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(favEvent_Arr).length > 0) {
      this.$store.commit('FAVOURITEEVENT_FIRSTLOAD');
    }
    if (favLgEvent_Arr != null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(favLgEvent_Arr).length > 0) {
      this.$store.commit('FAVOURITELGEVENT_FIRSTLOAD');
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var VUE = this;

    this.$set(this.currentTemplate, 'id', _.cloneDeep(this.$store.getters.selectedBettype.tmpltId));
    this.currentMarket = this.$store.getters.selectedMarket;

    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('lgreloading', function (res) {
      _this2.reloading = res;
    });
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('sportChange', function (params) {
      _this2.rbtable = false, _this2.normaltable = false, _this2.$store.commit('SPORTFORECAST_TOGGLE', false);

      _this2.$store.commit('SORTEDEVENTLIST', []);
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      _this2.$store.commit('SELECTED_PAGE', 1);
      if (params.tmpltId) {
        if (_this2.currentTemplate.id != params.tmpltId) {
          _this2.currentTemplate.id = params.tmpltId;
        }
        _this2.reloading = true;

        _this2.getSportSettings(token.arr_2);
      }
      if (_this2.$store.getters.selectedBettype.betTypId == '5') {
        var dtVal = _this2.selectedMarket == _this2.$store.getters.market.earlyMarket.key ? '99' : '0';
        _this2.setDateArrow('default');
        _this2.$nextTick(function () {
          _this2.highlightLine(dtVal);
        });
      }
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('inplaySportChange', function (params) {

      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      _this2.getSportSettings(token.arr_2);
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('pageChange', function (params) {
      _this2.$store.commit('SPORTFORECAST_TOGGLE', false);
      _this2.cancelMiniBet();
      _this2.$store.commit('SELECTED_PAGE', 1);

      _this2.reloading = true;
      _this2.$store.dispatch('getLaugueList', {
        callback: function (res) {
          _this2.$store.commit('SELECTEDLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.$store.getters.arr_leagueList).length);
          _this2.$store.commit('TOTALLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.$store.getters.arr_leagueList).length);
          _this2.reloading = false;
        }.bind(_this2)
      });

      if (_this2.leagueToggle === true) {
        _this2.toggleLeague();
      }
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('marketChange', function (params) {
      _this2.maxPayout = false;
      _this2.maxPayout_O = false;
      _this2.$store.commit('SPORTFORECAST_TOGGLE', false);
      _this2.$store.commit('SORTEDEVENTLIST', []);
      if (_this2.selectedMarket == '1' && _this2.$store.getters.selectedBettype.betTypId != '5') {
        _this2.$store.commit('SELECTEDEARLYPARLAYDATE', _this2.todayDate);
      } else {
        _this2.$store.commit('SELECTEDEARLYPARLAYDATE', _this2.allDate);
      }
      _this2.$store.commit('SELECTED_PAGE', 1);
      _this2.currentMarket = params;
      _this2.computeSubTitle();
      if (_this2.$store.getters.selectedMarket != 5) {
        if (_this2.currentTemplate.id != _this2.$store.getters.selectedBettype.tmpltId) {
          _this2.getSportSettings();
          _this2.$set(_this2.currentTemplate, 'id', _.cloneDeep(_this2.$store.getters.selectedBettype.tmpltId));
        } else {
          _this2.reloading = true;
          _this2.getLeagueList();
        }
      }
      if (_this2.leagueToggle === true) {
        _this2.toggleLeague();
      }

      if ((_this2.selectedMarket == _this2.$store.getters.market.earlyMarket.key || _this2.$store.getters.selectedBettype.betTypId == '5') && _this2.$store.getters.selectedBettype.betTypId != '6' && !(_this2.isGameBannerSelected && _this2.showGameBanner)) {
        _this2.setDateArrow('default');
        _this2.$nextTick(function () {
          _this2.highlightLine(_this2.allDate);
        });
      }
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('sportTableReloading', function (params) {
      _this2.reloading = params;
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('selectLeagueRefreshTable', function (params) {
      _this2.refreshTbl(params.token);
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('changemain', function (params) {

      _this2.changeMain();
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('sportSelectedAllBetChange', function (params) {
      _this2.$nextTick(function () {
        if (_this2.$store.getters.selectedBettype.betTypId == '5') {
          _.forEach(_this2.$store.getters.betForm, function (value, key) {
            if (VUE.selectedAllBet) {
              $('.' + value.uniqueId).closest('td').addClass('bg_yellow');
            } else {
              $('.' + value.uniqueId).closest('td').addClass('highlightedP');
            }
          });
        }
      });
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on('getSpecialEvent', function (params) {
      _this2.$store.commit('SPORTFORECAST_TOGGLE', false);
      _this2.$store.commit('SORTEDEVENTLIST', []);
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      _this2.$store.commit('SELECTED_PAGE', 1);
      _this2.reloadTable();
    }.bind(this));
  },
  beforeUpdate: function beforeUpdate() {
    this.refreshScroll();
  },
  updated: function updated() {
    if (!this.reloading) {
      this.updateHightlightOdds();
    }
  },
  destroyed: function destroyed() {
    this.clearTimer();
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('lgreloading');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('sportChange');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('inplaySportChange');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('pageChange');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('marketChange');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('sportTableReloading');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('selectLeagueRefreshTable');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('chamgemain');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('sportSelectedAllBetChange');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('refreshOdd');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('viewAccountSetting');
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off('getSpecialEvent');
  },

  methods: {
    highlightLine: function highlightLine(val) {
      this.$nextTick(function () {
        var position = $("#tabDate-" + val).first().position();
        if (position) {
          var center = position.left + $("#tabDate-" + val).outerWidth() / 2 - 25;
          $('.c-match-list-filter .line').css('transform', 'translateX(' + center + 'px)');
        }
      });
    },
    foldSc: function foldSc() {
      this.$store.commit('SHOW_UNFOLD', true);
      this.$store.commit('SHOW_FOLD', false);
      this.$store.commit('UNFOLD_ALLSC', false);
      var temp = this.$store.getters.selectedBettype;
      var element = document.getElementById('AllBetScrollfirstEvent');
      element.classList.remove('hide');
      this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp));
    },
    setDateArrow: function setDateArrow(direction) {
      if (direction == 'default') {
        this.dateLeft = 0;
        this.showLarrowEarly = false;
        this.showRarrowEarly = true;
        return;
      }
      this.dateLeft += direction == 'R' ? -100 : 100;

      var totalWidth = 0;
      var holderWidth = $('#tabWrap').width();
      this.showLarrowEarly = this.dateLeft < 0 ? true : false;

      $("#earlyDateScroll > .tab-item").each(function () {
        totalWidth = totalWidth + $(this).outerWidth();
      });
      var calc = totalWidth + this.dateLeft;
      this.showRarrowEarly = calc > holderWidth ? true : false;
    },
    clickMove: function clickMove(e, direction) {
      var VUE = this;
      var holderWidth = $('#rb-sport-scroll').width();
      var totalWidth = 0;
      var count = 0;
      $("#rb-scroll-content > .item.column").each(function () {
        totalWidth = totalWidth + $(this).outerWidth();
      });

      var setI = setInterval(function () {
        count++;
        if (count > 12) {
          clearInterval(setI);
        }

        VUE.rbSportLeft += direction == 'right' ? 15 : -15;
        document.getElementById("rb-sport-scroll").scrollLeft = VUE.rbSportLeft;

        var calc = totalWidth - VUE.rbSportLeft;
        VUE.showLarrowRB = VUE.rbSportLeft > 0 ? true : false;
        VUE.showRarrowRB = calc > holderWidth ? true : false;
      }, 16);
    },
    getCountAllSport: function getCountAllSport() {
      var Vue = this;
      var count = [];
      if (this.selectedMarket == 3) {
        $.each(Vue.allSportCount['live'], function (sport, bettype) {
          if (sport.charAt(0) == 'N') {
            $.each(bettype, function (key, val) {
              if (key == 'RAH' && Vue.$store.getters.selectedBettype.tmpltId != '11') {
                count.push(val);
              } else if (key == 'OTR' && Vue.$store.getters.selectedBettype.tmpltId == '11') {
                count.push(val);
              }
            });
          }
        });
      } else {
        $.each(Vue.allSportCount['today'], function (sport, bettype) {
          if (sport.charAt(0) == 'N') {
            $.each(bettype, function (key, val) {
              if (key == 'RAH' && Vue.$store.getters.selectedBettype.tmpltId != '11') {
                count.push(val);
              } else if (key == 'OTR' && Vue.$store.getters.selectedBettype.tmpltId == '11') {
                count.push(val);
              }
            });
          }
        });
        $.each(Vue.allSportCount['early'], function (sport, bettype) {
          if (sport.charAt(0) == 'N') {
            $.each(bettype, function (key, val) {
              if (key == 'RAH' && Vue.$store.getters.selectedBettype.tmpltId != '11') {
                count.push(val);
              } else if (key == 'OTR' && Vue.$store.getters.selectedBettype.tmpltId == '11') {
                count.push(val);
              }
            });
          }
        });
      }
      return _.sum(count);
    },
    countSport: function countSport(sprtId) {
      var Vue = this;
      var count = [];
      var counter = 0;
      if (Vue.$store.getters.selectedBettype.tmpltId == '11') {
        $.each(Vue.allSportCount['early'], function (sport, bettype) {
          if (sprtId == sport) {
            count.push(bettype['OTR']);
          } else if (sprtId == 'G1' && sport == 'Basketball') {
            count.push(bettype['OTR']);
          } else if (sprtId == 'G2' && sport == 'Others') {
            count.push(bettype['OTR']);
          }
        });
      } else {
        $.each(Vue.allSportCount['live'], function (sport, bettype) {
          if (sprtId == sport) {
            count.push(bettype['RAH']);
          } else if (sprtId == 'G1' && sport == 'Basketball') {
            count.push(bettype['RAH']);
          } else if (sprtId == 'G2' && sport == 'Others') {
            count.push(bettype['RAH']);
          }
        });
      }
      if (_.isUndefined(_.sum(count))) {
        return 0;
      }

      return _.sum(count);
    },
    selectRBSport: function selectRBSport(sport) {
      var simpleSport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (simpleSport) {
        this.$store.commit('SIMPLE_SPORT', sport.sprtId);
      } else {
        this.$store.commit('SIMPLE_SPORT', null);
      }
      var sprtData = sport;
      if (this.$store.getters.selectedBettype.tmpltId == '11') {
        this.selRBSprtId = sprtData.sprtId == this.rbAllSport.sprtId ? this.rbAllSport.sprtId : sprtData.sprtId;
        var arr = _.cloneDeep(this.$store.getters.otrBetType);
        arr.sprtId = this.selRBSprtId;
        this.$store.commit('SELECTED_BETTYPE', arr);
        this.$store.commit('SELECTED_SPORT', arr);
        this.$store.dispatch('getSportOutrightOdds', {
          callback: function (res) {
            __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
          }.bind(this)
        });
      } else {
        this.selRBSprtId = sport.sprtId == this.rbAllSport.sprtId ? this.rbAllSport.sprtId : sport.sprtId;
        this.$store.commit("GAMEBANNER_SELECTED", false);
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
        this.$store.commit('SELECTED_ALLBET', false);
        this.$store.commit('SELECTED_MATCHALLBET', false);
        this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
        if (sport.sprtId != 'N1') {
          this.$store.commit('SHOW_UNFOLD', false);
        } else {
          if (!_.isUndefined(this.unfold_AllSc[sport.sprtId]) && !_.isUndefined(this.unfold_AllSc[sport.sprtId][sport.betTypId])) {
            if (!this.unfold_AllSc[sport.sprtId][sport.betTypId]) {
              this.$store.commit('SHOW_UNFOLD', true);
            }
          }
        }
        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
        this.$store.commit('SELECTED_SPORT', sport);
        this.commitBettypeList();
        this.$store.commit('SELECTED_BETTYPE', this.$store.getters.bettypeList[0]);

        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('inplaySportChange', sport);
        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);
        this.$store.commit("GAMEBANNER_SELECTED", false);
        this.$store.commit('SELECTED_ALLBET', false);
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
        this.$store.commit('SELECTED_MATCHALLBET', false);
        this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
        this.$store.commit('SORTEDRBEVENTLIST', []);
        this.$store.commit('RBEVENTLIST', []);
        this.$store.commit('SPORTFORECAST_LIST', null);
        if (this.$store.getters.hotSchedule == false) {
          this.$store.commit('OPEN_RBMARKET', true);
        }

        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('marketChange', this.$store.getters.market.inPlayMarket.key);
      }
      if (this.selectedBettype.betTypId != 5) {
        this.$store.commit("IS_BETPARLAY", false);
      }
    },
    commitBettypeList: function commitBettypeList() {
      if (this.$store.getters.selectedSport.sprtId == 'G98') {
        this.$store.commit('BETTYPELIST', _.filter(this.sportBettypeList, {
          'sprtId': 'N1'
        }));
      } else {
        this.$store.commit('BETTYPELIST', _.filter(this.sportBettypeList, {
          'sprtId': this.$store.getters.selectedSport.sprtId
        }));
      }
    },
    getActive: function getActive(sport) {
      var str = 'no-active';
      var str2 = sport.sprtId == this.rbAllSport.sprtId ? '' : '';

      this.selRBSprtId = this.$store.getters.selectedSport.sprtId;
      if ((this.selRBSprtId == this.rbAllSport.sprtId && this.selRBSprtId != sport.sprtId || this.selRBSprtId == sport.sprtId) && this.$store.getters.simpleSport == null) {
        str = 'active';
      }

      $.each(this.allSportCount['live'], function (sportLang, bettype) {
        if (sport.sprtId == sportLang && bettype['RAH'] > 0) {
          str2 = '';
        } else if (sport.sprtId == 'G1' && sportLang == 'Basketball' && bettype['RAH'] > 0) {
          str2 = '';
        } else if (sport.sprtId == 'G2' && sportLang == 'Others' && bettype['RAH'] > 0) {
          str2 = '';
        }
      });

      return str + str2;
    },
    getBGPos: function getBGPos(sprtId) {
      var a = '';
      if (sprtId == 'N1') {
        a = 'background-position: 0px -28.33px;';
      } else if (sprtId == 'G1' || sprtId == 'N2') {
        a = 'background-position: 0px -85px;';
      } else if (sprtId == 'N3') {
        a = 'background-position: 0px -538.33px;';
      } else if (sprtId == 'N21') {
        a = 'background-position: 0px -170px;';
      } else if (sprtId == 'N12') {
        a = 'background-position: 0px -623.33px;';
      } else if (sprtId == 'N15') {
        a = 'background-position: 0px -425px;';
      } else if (sprtId == 'G2') {
        a = '';
      } else if (sprtId == 'N7') {
        a = 'background-position: 0px -1445px;';
      } else if (sprtId == 'N14') {
        a = 'background-position: 0px -57px;';
      } else if (sprtId == 'N13') {
        a = 'background-position: 0px -114px;';
      } else if (sprtId == 'N19') {
        a = 'background-position: 0px -368.5px;';
      } else if (sprtId == 'N20') {
        a = 'background-position: 0px -142px;';
      } else if (sprtId == 'N23') {
        a = 'background-position: 0px -793px;';
      } else {
        a = 'background-position: 0px -85px;';
      }
      return a;
    },
    getMarketTimer: function getMarketTimer(selMarket) {
      if (this.$store.getters.open_RBMarket) {
        return this.rbTimer;
      } else if (selMarket == this.$store.getters.market.earlyMarket.key) {
        return this.earlyTimer;
      } else if (selMarket == this.$store.getters.market.tdyMarket.key) {
        return this.todayTimer;
      }
    },
    deactiveDropDown: function deactiveDropDown() {
      if (this.oddsTypeActive) {
        this.oddsTypeActive = false;
      }
      if (this.sortActive) {
        this.sortActive = false;
      }
      if (this.marketActive) {
        this.marketActive = false;
      }
      if (this.showTypeActive) {
        this.showTypeActive = false;
      }
    },
    sportTitle: function sportTitle() {
      if (this.$store.getters.selectedSport.sprtId == 'N1') {
        return 'sport1';
      } else if (this.$store.getters.selectedSport.sprtId == 'G1') {
        return 'sport2';
      } else if (this.$store.getters.selectedSport.sprtId == 'N3') {
        return 'sport5';
      } else if (this.$store.getters.selectedSport.sprtId == 'N21') {
        return 'sport6';
      } else if (this.$store.getters.selectedSport.sprtId == 'N15') {
        return 'sport7';
      } else if (this.$store.getters.selectedSport.sprtId == 'N12') {
        return 'sport9';
      } else {
        return 'sport99';
      }
    },
    backToMain: function backToMain() {
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('sportTableReloading', true);
      this.reloadTable();
      this.$store.commit('SELECTED_MATCHALLBET', false);
    },
    oddsTypeClass: function oddsTypeClass(key) {
      if (key == 'my') {
        return 'icon-malayOdds';
      } else if (key == 'hk') {
        return 'icon-hongKongOdds';
      } else if (key == 'in') {
        return 'icon-indonesianOdds';
      } else if (key == 'eu') {
        return 'icon-decimalOdds';
      } else if (key == 'am') {
        return 'icon-americanOdds';
      }
    },
    showTypeClass: function showTypeClass(key) {
      if (key == '1') {
        return 'icon-singleLine';
      } else if (key == '2') {
        return 'icon-doubleLine';
      } else if (key == '3') {
        return 'icon-fullTimes';
      } else if (key == '4') {
        return 'icon-halfTime';
      }
    },
    marketTypeClass: function marketTypeClass(key) {
      if (key == '1') {
        return 'icon-allMarkets';
      } else if (key == '2') {
        return 'icon-mainMarkets';
      } else if (key == '3') {
        return 'icon-otherMarkets';
      }
    },
    cancelMiniBet: function cancelMiniBet() {
      var sportMiniBet = this.$store.getters.sportMiniBet;
      sportMiniBet.toggle = false;
      this.$store.commit('SPORT_MINIBET', sportMiniBet);
    },
    countCookieLeague: function countCookieLeague() {
      var countLeague = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var selectedMarket = this.$store.getters.selectedMarket;
      var selectedSport = this.$store.getters.selectedBettype.sprtId;
      var selectedBettype = this.$store.getters.selectedBettype.betTypId;
      if (this.$store.getters.isGameBannerSelected) {
        selectedBettype += 'gmBanner';
      }

      if (this.cookieLeague) {
        if (this.cookieLeague[selectedMarket]) {
          if (this.cookieLeague[selectedMarket][selectedSport]) {
            if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype]) {
              if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length > 0) {
                if (countLeague) {
                  return this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length;
                }
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    countLeagues: function countLeagues() {
      var countLeague = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var selectedMarket = this.$store.getters.selectedMarket;
      var selectedSport = this.$store.getters.selectedBettype.sprtId;
      var selectedBettype = this.$store.getters.selectedBettype.betTypId;
      var totalLeagues = '';
      if (this.$store.getters.isGameBannerSelected) {
        selectedBettype += 'gmBanner';
      }

      if (this.cookieLeague) {
        if (this.cookieLeague[selectedMarket]) {
          if (this.cookieLeague[selectedMarket][selectedSport]) {
            if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype]) {
              if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length > 0) {
                if (countLeague) {

                  if (this.$store.getters.arr_leagueList != null) {
                    totalLeagues = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length;
                  }

                  return this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length + ' / ' + totalLeagues;
                }
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    checkMinibet: function checkMinibet(windowEvent) {
      this.toggleActive();
      var sportMiniBet = this.$store.getters.sportMiniBet;
      sportMiniBet.allow = !this.$store.getters.sportMiniBet.allow;
      this.$store.commit('SPORT_MINIBET', sportMiniBet);
      if (!sportMiniBet.allow) {
        this.$store.commit('SPORT_MINIBET_TOGGLE', false);
      }
    },
    clearFavourite: function clearFavourite() {
      this.$store.commit('FAVOURITEEVENT', { clear: true });
      if (!this.$store.getters.showFavEvents) {
        var dispatchName = 'getSportOdds';
        if (this.$store.getters.selectedBettype.betTypId == '6') {
          dispatchName = 'getSportOutrightOdds';
        }
        this.$store.dispatch(dispatchName, {
          callback: function (res) {
            __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
          }.bind(this)
        });
      }
    },
    changeFavorite: function changeFavorite() {
      if (this.countFav != 0 && (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.favouriteLgeEvents).length > 0 || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.favouriteEvents).length > 0 || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.favouriteOTREvents).length > 0)) {
        this.showFavEvents = true;
        this.$store.commit('SPORT_SHOW_FAV_EVENTS', true);
        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);

        this.$store.commit('SELECTED_ALLBET', false);
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
        this.$store.commit('SELECTED_MATCHALLBET', false);

        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);

        __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('pageChange', this.$store.getters.market.favMarket.key);
      }
    },
    changeMain: function changeMain() {
      this.showFavEvents = false;
      this.$store.commit('SPORT_SHOW_FAV_EVENTS', false);
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('viewAccountSetting', false);

      this.$store.commit('SELECTED_ALLBET', false);
      this.$store.commit('STATEMENT_SHOW_STATEMENT', false);
      this.$store.commit('SELECTED_MATCHALLBET', false);

      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('selectLeagueRefreshTable', token.arr_4);
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);

      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('pageChange', this.$store.getters.selectedMarket);
    },
    changeTime: function changeTime(event) {
      this.$store.commit('SPORT_FULLHALF_TIME', event.target.value);
      this.reloadTable();
    },
    toggleLeague: function toggleLeague() {
      var windowEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$store.commit('MERGE_LEAGUELIST', null);
      this.reloading = true;
      this.toggleActive();
      this.$store.commit('SPORT_MINIBET_TOGGLE', false);

      this.$store.commit('SORTEDEVENTLIST', []);
      this.$store.commit('SORTEDRBEVENTLIST', []);
      this.$store.dispatch('toggleSportLeague', {
        callback: function (res) {

          __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('setLeagueList', res);
        }.bind(this)
      });

      if (windowEvent != null) {
        this.$store.commit('SPORTLEAGUE_WINDOWEVENT', windowEvent);
      }
    },
    toggleActive: function toggleActive() {
      this.sortActive = false;
      this.showTypeActive = false;
      this.oddsTypeActive = false;
      this.marketActive = false;
    },
    clickSort: function clickSort(types) {
      this.toggleActive();
      if (types == 'showType') {
        this.showTypeActive = this.showTypeActive ? false : true;
      } else if (types == 'sortGame') {
        this.sortActive = this.sortActive ? false : true;
      } else if (types == 'oddsType') {
        this.oddsTypeActive = this.oddsTypeActive ? false : true;
      } else if (types == 'showMarket') {
        this.marketActive = this.marketActive ? false : true;
      }
    },
    changeSort: function changeSort(sortkey, event) {
      this.reloading = true;
      event.preventDefault();
      event.stopPropagation();
      this.sortActive = false;

      this.$store.commit('SELECTED_SORT', sortkey);
      this.$store.commit('SHOW_UP_DOWN', false);
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      this.refreshTbl(token.arr_17);
    },
    changeShow: function changeShow(showkey, event) {
      var _this3 = this;

      this.reloading = true;
      event.preventDefault();
      event.stopPropagation();
      this.showTypeActive = false;

      this.$store.commit('SELECTED_SHOW', showkey);
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);

      if (this.selectedMatchAllBet) {
        this.$store.dispatch('getMatchAllBet', {
          event: this.sortedMatchEventList,
          token: token.arr_4,
          callback: function (res) {
            _this3.reloading = false;
            _this3.oddsReload = false;
            _this3.refreshScroll();
          }.bind(this)
        });
      } else {
        this.reloadTable(token.arr_17);
      }
    },
    changeMarket: function changeMarket(marketkey) {
      this.$store.commit('SELECTED_MARKET', marketkey);

      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      this.reloadTable(token.arr_17);
    },
    changeOdd: function changeOdd(orderkey, event) {
      var _this4 = this;

      this.reloading = true;
      event.preventDefault();
      event.stopPropagation();

      this.oddsTypeActive = false;
      this.selectedOdd = orderkey;
      this.$store.commit('SELECTED_ODD', orderkey);

      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('cancelBetForm');
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('REMOVE_ALL_FORECAST');

      if (this.selectedMatchAllBet) {
        this.$store.dispatch('getMatchAllBet', {
          event: this.sortedMatchEventList,
          token: token.arr_4,
          callback: function (res) {
            _this4.reloading = false;
            _this4.oddsReload = false;
            _this4.refreshScroll();
          }.bind(this)
        });
      } else {
        this.reloadTable(token.arr_4);
      }
    },
    changeEarlyParlayDate: function changeEarlyParlayDate(dateKey) {
      this.$store.commit('SORTEDRBEVENTLIST', []);
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);

      this.reloading = true;
      this.$store.commit('SELECTED_PAGE', 1);
      this.$store.commit('SELECTEDEARLYPARLAYDATE', dateKey);
      this.reloadTable();
    },
    refreshTbl: function refreshTbl(token_val) {
      if (!this.refreshToggle) {
        $('#tblRefresh').addClass('loading-static-animation');

        this.reloading = token_val == token.arr_1 || token_val == token.arr_5 ? false : true;
        if (this.selectedMatchAllBet) {
          this.reloadAllBetTable(token_val);
        } else {
          this.reloadTable(token_val);
        }
      }
    },
    reloadAllBetTable: function reloadAllBetTable() {
      var _this5 = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (token_val == '') {
        token_val = token.arr_5;
      }

      this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList);

      this.$store.dispatch('getSportAllBet', {
        token: token_val,
        inAllBet: true,
        event: this.$store.getters.sortedMatchEventList,
        callback: function (res) {
          _this5.timerSeconds = _this5.getMarketTimer(_this5.$store.getters.selectedMarket);

          _this5.startTimer();
          _this5.mainMarketList = _.cloneDeep(_this5.$store.getters.sortedMatchEventList);

          _this5.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('diffOdd', _this5.cloneEventAllBet);
          });
          _this5.reloading = false;
          $('#tblRefresh').removeClass('loading-static-animation');
        }.bind(this)
      });
    },
    reloadTable: function reloadTable() {
      var _this6 = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.$store.commit('REFRESHTOGGLE', true);
      this.oddsReload = true;
      this.clearTimer();
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('templateChange', this.oddsReload);

      var dispatchName = 'getSportOdds';

      if (!this.$store.getters.open_RBMarket && (this.$store.getters.selectedMarket == this.market.hotSportMarket.key || this.$store.getters.selectedMarket == this.market.tdyMarket.key) && !(this.excludeLge.indexOf(this.$store.getters.selectedBettype.betTypId) !== -1) && !this.showFavEvents) {
        if (this.$store.getters.isParlayTab && (!window.allowRbParlay || this.$store.getters.selectedEarlyParlayDate != 99 && this.$store.getters.selectedEarlyParlayDate != 0)) {
          this.$store.commit('SORTEDRBEVENTLIST', []);
          dispatchName = 'getSportOdds';
        } else {
          dispatchName = 'getRbTodayOdds';
        }
      }

      if (this.$store.getters.selectedBettype.betTypId == '6') {
        dispatchName = 'getSportOutrightOdds';
      }
      if (this.$store.getters.specialEvent) {
        dispatchName = 'getSpecialEventOdds';
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8;
      }

      this.$store.dispatch(dispatchName, {
        token: token_val,
        showfavorite: this.$store.getters.showFavEvents && dispatchName == 'getSportOdds' ? true : false,
        callback: function (res) {
          if (res.events || res.events_rb) {
            _this6.timerSeconds = _this6.getMarketTimer(_this6.$store.getters.selectedMarket);

            _this6.startTimer();
            clearInterval(_this6.reconnectTimerId);
            _this6.reconnectTimerId = null;

            _this6.normaltable = res.events ? true : false;
            _this6.rbtable = res.events_rb ? true : false;
          } else {
            _this6.reconnectTimerSeconds = 5;
            if (_this6.reconnectTimerId == null) {
              _this6.reconnectTimerId = setInterval(function () {
                if (_this6.reconnectTimerSeconds - 1 < 0) {
                  _this6.reloadTable();
                } else {
                  _this6.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (_this6.showFavEvents) {
            _this6.$store.dispatch('getLaugueList', {
              callback: function (res) {
                _this6.$store.commit('SELECTEDLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this6.$store.getters.arr_leagueList).length);
                _this6.$store.commit('TOTALLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this6.$store.getters.arr_leagueList).length);
              }.bind(_this6)
            });
          }
          if (_this6.$store.getters.selectedMarket == 1 && _this6.$store.getters.selectedBettype.betTypId != '6' && _this6.$store.getters.selectedBettype.betTypId != '5') {
            _this6.reloading = false;
            _this6.oddsReload = false;
            __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('templateChange', _this6.oddsReload);
            _this6.refreshScroll();

            _this6.$store.commit('PARLAY_SELECTED', { update: false });
          } else {
            _this6.reloading = false;
            _this6.oddsReload = false;
            __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('templateChange', _this6.oddsReload);
            _this6.refreshScroll();

            _this6.$store.commit('PARLAY_SELECTED', { update: false });
          }
          $('#tblRefresh').removeClass('loading-static-animation');
          _this6.$store.commit('REFRESHTOGGLE', false);
        }.bind(this)
      });
    },
    reloadRBTable: function reloadRBTable() {
      var _this7 = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.oddsReload = true;
      this.clearTimer();
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('templateChange', this.oddsReload);

      var dispatchName = 'getSportOdds';
      if (this.$store.getters.selectedBettype.betTypId == '6') {
        dispatchName = 'getSportOutrightOdds';
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8;
      }

      this.$store.dispatch(dispatchName, {
        token: token_val,
        scheduleMarket: this.$store.getters.market.inPlayMarket.key,
        showfavorite: this.$store.getters.showFavEvents && dispatchName == 'getSportOdds' ? true : false,
        callback: function (res) {
          if (res.events) {
            _this7.timerSeconds = _this7.getMarketTimer(_this7.$store.getters.selectedMarket);
            _this7.startTimer();
            clearInterval(_this7.reconnectTimerId);
            _this7.reconnectTimerId = null;
            _.forEach(res.events, function (val, key) {});
            _this7.rbtable = true;
          } else {
            _this7.reconnectTimerSeconds = 5;
            if (_this7.reconnectTimerId == null) {
              _this7.reconnectTimerId = setInterval(function () {
                if (_this7.reconnectTimerSeconds - 1 < 0) {
                  _this7.reloadRBTable();
                } else {
                  _this7.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }

          if (_this7.$store.getters.selectedMarket == 1 && _this7.$store.getters.selectedBettype.betTypId != '6' && _this7.$store.getters.selectedBettype.betTypId != '5') {
            if (_this7.normaltable == true && _this7.rbtable == true) {
              _this7.reloading = false;
              _this7.oddsReload = false;
              __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('templateChange', _this7.oddsReload);
              _this7.refreshScroll();

              _this7.$store.commit('PARLAY_SELECTED', { update: false });
            }
          } else {
            _this7.reloading = false;
            _this7.oddsReload = false;
            __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('templateChange', _this7.oddsReload);
            _this7.refreshScroll();

            _this7.$store.commit('PARLAY_SELECTED', { update: false });
          }

          $('#tblRefresh').removeClass('loading-static-animation');
        }.bind(this)
      });
    },
    startTimer: function startTimer() {
      var _this8 = this;

      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (_this8.timerSeconds - 1 < 0) {

            _this8.$store.commit('SHOW_UP_DOWN', true);

            _this8.refreshTbl(token.arr_1);
          } else {
            _this8.timerSeconds -= 1;
          }
        }, 1000);
      }
    },
    getLeagueList: function getLeagueList() {
      var _this9 = this;

      if (this.$store.getters.int_fullHalfTime == '2') {
        this.$store.commit('SPORT_FULLHALF_TIME', 1);
      }

      if (!this.$store.getters.open_RBMarket && this.$store.getters.selectedMarket == this.market.tdyMarket.key && (!(this.excludeLge.indexOf(this.$store.getters.selectedBettype.betTypId) !== -1) || this.$store.getters.selectedBettype.betTypId == '5' && !this.$store.getters.isParlayTab)) {
        this.$store.dispatch('getLaugueList', {
          scheduleMarket: this.market.inPlayMarket.key });
      }

      this.$store.dispatch('getLaugueList', {
        callback: function (res) {
          if (_this9.$store.getters.arr_leagueList != undefined) {
            _this9.$store.commit('SELECTEDLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this9.$store.getters.arr_leagueList).length);
            _this9.$store.commit('TOTALLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this9.$store.getters.arr_leagueList).length);
          }

          _this9.reloadTable();
        }.bind(this)
      });
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    refreshTimer: function refreshTimer() {
      this.clearTimer();
      this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket);

      this.startTimer();
    },
    refreshScroll: function refreshScroll() {
      var main = document.getElementById('right_div');
      var sportTableWidth = $('.tableContent').outerWidth();
      if (main) {
        var maxTop = main.parentNode.parentNode.scrollHeight - main.offsetHeight;

        main.parentNode.parentNode.onscroll = function () {
          main.style.top = Math.min(this.scrollTop + 39) + "px";
          main.style.left = sportTableWidth + "px";
        };
      }
    },
    getSportSettings: function getSportSettings() {
      var _this10 = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.reloading = true;
      this.maxPayout = false;
      this.maxPayout_O = false;
      var data = {
        market: this.$store.getters.selectedMarket,
        template: this.$store.getters.open_RBMarket || this.$store.getters.hotSchedule ? '1' : this.$store.getters.selectedBettype.tmpltId
      };
      if (this.$store.getters.selectedBettype.betTypId == '5') {
        data.sportId = this.$store.getters.selectedBettype.sprtId;
      }
      data.token = token_val;

      this.$ajax({
        method: 'get',
        url: window._baseUrl + '/sport-settings',
        data: data
      }).done(function (res) {
        var sportTableLang = {
          table: window.lang.sportTableLang,
          template_lang: res.data._lang.template_lang
        };
        _this10.$store.commit('SPORTTABLELANG', sportTableLang);
        _this10.getLeagueList();
        _this10.templateClass = 'tableContent common';
        if (_this10.templateClassArr[_this10.$store.getters.selectedBettype.tmpltId]) {
          _this10.templateClass = 'tableContent ' + _this10.templateClassArr[_this10.$store.getters.selectedBettype.tmpltId];
        }

        _this10.computeSubTitle(res);
        if (_this10.leagueToggle === true) {
          _this10.toggleLeague();
        }
      }.bind(this)).catch(function (errRes) {
        console.log(errRes);
      });
    },
    showEarlyDateList: function showEarlyDateList() {
      var isEarly = this.selectedMarket == this.market.earlyMarket.key ? true : false;
      var isParlay = this.selectedBettype.betTypId == '5' ? true : false;
      var isOTR = this.selectedBettype.betTypId == '6' ? true : false;
      if (this.showFavEvents) {
        return false;
      }
      if (!(isEarly && isOTR) && (isEarly || isParlay)) {
        return true;
      }

      return false;
    },
    computeSubTitle: function computeSubTitle(res) {
      if (this.$store.getters.selectedBettype.tmpltId != '1' && this.$store.getters.selectedBettype.tmpltId != '7' && this.$store.getters.selectedBettype.tmpltId != '8') {
        this.subTitle = ' / ' + this.$store.getters.selectedBettype.betTypLang;
      } else if (this.$store.getters.selectedBettype.betTypId == '5' || this.$store.getters.selectedBettype.betTypId == '6') {
        this.subTitle = ' / ' + this.$store.getters.selectedBettype.betTypLang;
        if (this.selectedBettype.sprtId == 'N1' && res && res.data.max_payout_setting) {
          this.maxPayout = res.data.max_payout_setting[1];
          this.maxPayout_O = res.data.max_payout_setting[1];
        } else if (this.selectedBettype.sprtId == 'G1' && res && res.data.max_payout_setting) {
          this.maxPayout = res.data.max_payout_setting[2];
          this.maxPayout_O = res.data.max_payout_setting[2];
        }
      } else {
        this.subTitle = "";
      }
    },
    totalCountByDate: function totalCountByDate(date) {
      var temp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var currectSport = this.$store.getters.selectedBettype.sprtId;
      var betTypId = this.$store.getters.selectedBettype.betTypId;
      var sportId = '';
      var sid = [];
      var totalCount = 0;
      var allDateCount = this.$store.getters.arr_earlyEventCountByDate;
      if (this.$store.getters.selectedBettype.betTypId == '5' && !this.$store.getters.isParlayTab) {
        betTypId = this.$store.getters.previousBettype && this.$store.getters.previousBettype.bettype ? this.$store.getters.previousBettype.bettype.betTypId : '1';
      }
      if (currectSport.charAt(0) == 'N') {
        var ss = currectSport.replace("N", '');
        sid.push(ss);
      } else if (currectSport == 'G1') {
        sid.push('2', '13');
      } else if (currectSport == 'G2') {
        sid.push('7', '14', '19', '20');
      }

      _.forEach(sid, function (sval) {
        if (betTypId == 5) {
          totalCount = allDateCount['p' + sval] && allDateCount['p' + sval][date] ? allDateCount['p' + sval][date] : 0;
        } else {
          if (temp == 'all') {
            totalCount = allDateCount[sval] && allDateCount[sval][date] ? allDateCount[sval][0] ? allDateCount[sval][date] - allDateCount[sval][0] : allDateCount[sval][date] : 0;
          } else {
            totalCount = allDateCount[sval] && allDateCount[sval][date] ? allDateCount[sval][date] : 0;
          }
        }
      });

      return totalCount;
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inPlayCommon__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__soccerCommon__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hotSportCommon__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__soccerCorrectScore__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__soccerTotalGoal__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__soccerHTFT__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__otherSportCommon2__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sportOutright__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__specialEventCommon__ = __webpack_require__(475);



















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    inPlayCommon: __WEBPACK_IMPORTED_MODULE_3__inPlayCommon__["a" /* default */],
    soccerCommon: __WEBPACK_IMPORTED_MODULE_4__soccerCommon__["a" /* default */],
    hotSportCommon: __WEBPACK_IMPORTED_MODULE_5__hotSportCommon__["a" /* default */],

    soccerAllCommon: __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__["a" /* default */],
    soccerCorrectScore: __WEBPACK_IMPORTED_MODULE_7__soccerCorrectScore__["a" /* default */],
    soccerTotalGoal: __WEBPACK_IMPORTED_MODULE_8__soccerTotalGoal__["a" /* default */],
    soccerHTFT: __WEBPACK_IMPORTED_MODULE_9__soccerHTFT__["a" /* default */],

    otherSportCommon2: __WEBPACK_IMPORTED_MODULE_10__otherSportCommon2__["a" /* default */],
    sportOutright: __WEBPACK_IMPORTED_MODULE_11__sportOutright__["a" /* default */],
    specialEventCommon: __WEBPACK_IMPORTED_MODULE_12__specialEventCommon__["a" /* default */]
  },
  data: function data() {
    return {
      reloading: true,
      langSport: window.lang['sportTableLang']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sportTableLang', 'eventList', 'rbeventList', 'selectedBettype', 'selectedShow', 'selectedAllBet', 'selectedMarket', 'showFavEvents', 'sortedEventList', 'sortedFavRbEventList', 'bool_leagueToggle', 'open_RBMarket', 'market', 'isParlayTab', 'previousBettype', 'isGameBannerSelected', 'hotSchedule', 'selectedSport', 'specialEvent'])),
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$on('templateChange', function (reloading) {
      _this.reloading = reloading;
    }.bind(this));
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$off('templateChange');
  },

  methods: {
    getStyle: function getStyle() {
      var val = '36';
      if (this.open_RBMarket && !this.showFavEvents) {
        val = '84';
      } else if (this.$store.getters.selectedBettype.tmpltId == 11 && !this.showFavEvents) {
        val = '84';
      } else if (this.$store.getters.selectedBettype.betTypId == 5 && this.isParlayTab && !this.showFavEvents) {
        val = '90';
      } else if (this.selectedMarket == this.market.earlyMarket.key && this.$store.getters.selectedBettype.betTypId != 6) {
        val = '90';
      }
      if ((this.isGameBannerSelected || this.specialEvent) && this.selectedMarket == this.market.earlyMarket.key) {
        val = '36';
      }

      return 'height:' + val + 'px';
    },
    checkTemplate: function checkTemplate(tmplt) {
      var selectedTmplt = this.$store.getters.selectedBettype.tmpltId;
      if (this.$store.getters.selectedBettype.betTypId == '5' && !this.isParlayTab) {
        selectedTmplt = this.previousBettype && this.previousBettype.bettype ? this.previousBettype.bettype.tmpltId : '1';
      }
      return selectedTmplt == tmplt;
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allBet_more_bet__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__simpleSoccer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vue_mixins_favourite__ = __webpack_require__(17);
















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__vue_mixins_favourite__["a" /* default */]],
  components: {
    moreBetComponent: __WEBPACK_IMPORTED_MODULE_7__allBet_more_bet__["a" /* default */],
    soccerAllCommon: __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__["a" /* default */],
    sportTime: __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__["a" /* default */],
    simpleSoccer: __WEBPACK_IMPORTED_MODULE_8__simpleSoccer__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'sportList', 'sportIdArr', 'sortedEventList', 'sortedFavRbEventList', 'market', 'selectedShow', 'selectedMarket', 'selectedBettype', 'selectedSport', 'selectedAllBetNew', 'selectedMatchAllBet', 'tvIconFlag', 'moreBetLoading', 'favouriteLgeEvents', 'open_RBMarket', 'unfold_AllSc', 'frameWidthHeight', 'livetv', 'firstEvent', 'account', 'showFavEvents', 'showLgeEve', 'simpleSport']), {
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid: {
      get: function get() {
        var ft = this.$store.getters.firstEvent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ft).length > 0 ? ft.eveid : 0;
      }
    },
    widthColumn: {
      get: function get() {
        var fm = this.$store.getters.frameWidthHeight;
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount = fm.leagueTeam.columnCountBet;
        var columnCountBetShow = fm.leagueTeam.columnCountBetShow;
        var sprt = this.$store.getters.selectedBettype.sprtId;
        var tmp = this.$store.getters.selectedBettype.tmpltId;
        var hideCol = 0;
        if (!_.isUndefined(this.$store.getters.unfold_AllSc[sprt]) && !_.isUndefined(this.$store.getters.unfold_AllSc[sprt][tmp]) && this.$store.getters.unfold_AllSc[sprt][tmp]) {
          if (pageCenter <= 1370) {
            columnCountBetShow -= 1;
            hideCol += 1;
          }
          if (pageCenter < 1280) {
            columnCountBetShow -= 1;
            hideCol += 1;
          }
          columnCount = columnCountBetShow;
        }
        var AvailableLT = pageCenter - timeColumn - favColumn - betBoxWidthMin * columnCount - leagueBoxWidthMin;
        if (AvailableLT > 0) {
          var TeamCal = AvailableLT * 0.7;
          team = betBoxWidthMin + TeamCal / columnCount;
          team = Math.floor(team);
          if (team < betBoxWidthMin) {
            team = betBoxWidthMin;
          } else if (team > betBoxWidthMax) {
            team = betBoxWidthMax;
          }
          var caladd = team - betBoxWidthMin;
          if (caladd > 0) {
            AvailableLT = AvailableLT - (team - betBoxWidthMin) * columnCount;
            if (AvailableLT > 0) {
              league = AvailableLT + leagueBoxWidthMin;
            }
          } else {
            league = AvailableLT + leagueBoxWidthMin;
          }
        } else {
          league = AvailableLT + leagueBoxWidthMin;
        }
        league = league - 15;
        return [league, team, league + timeColumn, hideCol];
      }
    },
    drawEventList: {
      get: function get() {
        var vue = this;
        var sEve = '';
        var countx = 0;
        var lgeArr = _.cloneDeep(this.$store.getters.showLgeEve);

        var eveArr = _.cloneDeep(this.$store.getters.sortedEventList);
        sEve = eveArr;

        this.$store.commit('SHOW_LGEEVE', lgeArr);

        return sEve;
      },
      set: function set(value) {
        alert('val : ' + value);
      }
    }
  }),
  watch: {
    unfold_AllSc: {
      handler: function handler(val, oldVal) {
        this.checkUnfold();
      },
      deep: true
    }
  },
  data: function data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,
      moreBetEveId: null,
      allSportId: 'G98',
      newEventList: {},
      isUnfold: false,
      subMatchKeyCap: {
        0: 'a',
        1: 'b',
        2: 'c',
        3: 'd'
      }
    };
  },
  beforeMount: function beforeMount() {
    this.checkUnfold();

    var vue = this;
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$on('moreBetLoading', function (params) {}.bind(this));
  },

  methods: {
    getSMKey: function getSMKey(smKey) {
      var smKeyId = '';
      if (smKey == 0 || smKey == 'a') {
        smKeyId = 'a';
      } else if (smKey == 1 || smKey == 'b') {
        smKeyId = 'b';
      } else if (smKey == 2 || smKey == 'c') {
        smKeyId = 'c';
      } else {
        smKeyId = 'd';
      }
      return smKeyId;
    },
    checkUnfold: function checkUnfold() {
      var sprt = this.selectedBettype.sprtId;
      var tmp = this.selectedBettype.tmpltId;
      if (!_.isUndefined(this.unfold_AllSc[sprt]) && !_.isUndefined(this.unfold_AllSc[sprt][tmp])) {
        this.isUnfold = this.unfold_AllSc[sprt][tmp];
      }
    },
    getEvent: function getEvent(eveObj, sport) {
      var a = false;
      if (eveObj.sptid == this.sportIdArr[sport.sprtId]) {
        a = true;
      } else if (sport.sprtId == 'G2' && $.inArray(parseInt(eveObj.sptid), [1, 2, 3, 21, 12, 15]) == -1) {
        a = true;
      }
      return a;
    },
    getSportLang: function getSportLang(sportID) {
      var vue = this;
      var capt = '';
      _.forEach(vue.sportList, function (sportdata, key) {
        if (sportID == sportdata.sprtId) {
          capt = sportdata.sprtLang.replace("<br/>", "");
        }
      });

      return capt;
    },
    chkSport: function chkSport(eventObj, sportList) {
      var vue = this;
      var capt = '';
      _.forEach(sportList, function (sportdata, key) {
        if (vue.sportIdArr[eventObj.sptid] == sportdata.sprtId) {
          capt = sportdata.sprtLang;
        }
      });

      return capt;
    },
    getBetCaption: function getBetCaption(bt) {
      return this.sportAllBetLang['ALL_BET.SUBHEADER_FT_' + bt];
    },
    colspanS: function colspanS() {
      return 2;
    },
    showSport: function showSport(sportKey) {
      this.$set(this.showLgeEve[sportKey], 'hide', !this.showLgeEve[sportKey].hide);
    },
    showLeg: function showLeg(key, sportKey, isRB) {
      this.$set(this.showLgeEve[sportKey][key], 'hide', !this.showLgeEve[sportKey][key].hide);
    },
    enterAllBet: function enterAllBet(event, startTv) {
      this.$store.commit('SHOW_UNFOLD', true);
      this.$store.commit('SHOW_FOLD', false);
      this.$store.commit('UNFOLD_ALLSC', false);
      if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv = 1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: true,

        token: token.arr_8,
        loadTemplate: startTv });
    },
    enterMatch: function enterMatch(event) {
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        token: token.arr_8
      });
    },
    backtoTop: function backtoTop() {
      $(".sport-table-scroll").animate({ scrollTop: 0 }, 100);
    }
  },
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SHOW_LGEEVE', {});
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$off("moreBetLoading");
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_zh_cn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_locale_zh_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(0);










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__["a" /* default */]],
  props: {
    event: null,
    rowspan: {
      type: String,
      default: '3'
    },
    subMatchKey: null
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['sportTableLang', 'market', 'selectedMarket', 'selectedBettype', 'timeZone', 'simpleSport', 'specialEvent'])),
  data: function data() {
    return {
      selectedLang: window._langid,
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a
    };
  },

  methods: {
    checkStart: function checkStart(end) {
      var startTime = new __WEBPACK_IMPORTED_MODULE_1_moment___default.a().utcOffset("-04:00").format("YYYY-MM-DD HH:mm:ss");
      var endTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(end);
      var difference = endTime.diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(startTime), 'minutes');
      if (difference >= 0) {
        return difference;
      }
      return 10000;
    },
    timerDisplay: function timerDisplay(eve) {
      var style = 'display: none;';
      if (eve.rbinfo) {
        style = '';
      }

      return style;
    },
    sportListByKey: function sportListByKey() {
      return _.keyBy(this.$store.getters.sportList, 'sptid');
    },
    checkTodayMatch: function checkTodayMatch(event) {
      var status = false;
      var eventDate = new __WEBPACK_IMPORTED_MODULE_1_moment___default.a(event.dt).format("DD/MM/YYYY");

      var DateNow = new __WEBPACK_IMPORTED_MODULE_1_moment___default.a().utcOffset("-04:00").format("DD/MM/YYYY");
      var eventDate = new Date(eventDate);
      var DateNow = new Date(DateNow);

      if (eventDate.valueOf() <= DateNow.valueOf()) {
        status = true;
      }
      return status;
    },
    checkTimer: function checkTimer(event) {
      return this.$options.filters.checkTimer(event);
    },
    matchDateCheck: function matchDateCheck(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_favourite__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_event_bus__ = __webpack_require__(3);



var _props;






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_mixins_favourite__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__["a" /* default */]],
  props: (_props = {
    selMarket: null,
    subMatchKey: {
      type: Number,
      default: 0
    },
    event: null,
    rowspan: {
      type: String,
      default: '2'
    },
    classes: {
      type: String,
      default: ''
    },
    isos2: {
      type: Boolean,
      default: false
    },
    plytyp: {
      type: String,
      default: ''
    },
    issc: {
      type: Boolean,
      default: false
    }
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_props, 'subMatchKey', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_props, 'isAllBet', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_props, 'isRB', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_props, 'mode', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_props, 'widthL', {
    type: Number,
    default: 238
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_props, 'specialEveId', null), _props),
  data: function data() {
    return {
      btid: ['1', '2', '3'],
      sprtid: ['G1', 'N1'] };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['account', 'sportAllBetLang', 'sportTableLang', 'market', 'selectedMarket', 'selectedBettype', 'tvIconFlag', 'selectedShow', 'showFavEvents'])),
  methods: {
    getTeamCapt: function getTeamCapt(teamCapt, selectedMarket) {
      var t = teamCapt;
      if (selectedMarket == 'cs') {
        t = t + ' - ' + this.sportAllBetLang['ALL_BET.SUBHEADER_CS'];
      }
      var parser = new DOMParser();
      return parser.parseFromString(t, "text/html").body.textContent;
    },
    countAllBet: function countAllBet(event, selectedShow) {
      var countCv = event.all;
      return countCv;
    },
    teamColor: function teamColor(event, team, plytyp) {
      var cls = '';
      if (plytyp == "") {
        plytyp = 1;
      }
      if (event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['hdp'] == '0') {} else if (event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['hdp'] == '0') {} else {
        if (team == 'A' && event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['fav'] == 'a') {
          cls = 'bold';
        } else if (team == 'A' && event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['fav'] == 'a') {
          cls = 'bold';
        } else if (team == 'B' && event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['fav'] == 'b') {
          cls = 'bold';
        } else if (team == 'B' && event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['fav'] == 'b') {
          cls = 'bold';
        }
      }
      return cls;
    },
    forecastNotIn: function forecastNotIn(betTypId) {
      if (this.btid.indexOf(betTypId) > -1) {
        return true;
      }
      return false;
    },
    sportIdIN: function sportIdIN(sportId) {
      if (this.sprtid.indexOf(sportId) > -1) {
        return true;
      }
      return false;
    },
    openAllBetForm: function openAllBetForm(event) {
      this.$store.dispatch('getSportAllBet', { event: event });
    },
    enterAllBet: function enterAllBet(event) {
      if (this.specialEveId) {
        event.eveid = event.sp[this.specialEveId].maineveid || this.specialEveId;
      }
      this.$store.commit('RIGHT_BOARD_CHG', event);
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: event.rbstatus == 1 ? true : false,
        token: token.arr_8,
        loadTemplate: 3 });
    },
    getScoreSet: function getScoreSet(event, team) {
      var total = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var teamA = 0;
      var teamB = 0;
      var hasRec = 0;
      if (event.rbinfo != undefined && event.rbinfo.score != undefined) {
        _.forEach(event.rbinfo.score, function (data, key) {
          hasRec = 1;
          if (event.sptid == 3) {
            if (key == 'SH' || key == 'PT') {
              teamA = data.scoa;
              teamB = data.scob;
            }
          } else if (event.sptid == 23) {
            if (key == 'FT') {
              teamA = parseInt(data.scoa);
              teamB = parseInt(data.scob);
            }
          } else if (event.sptid == 14) {
            if (key == 'FT') {
              teamA = parseInt(data.scoa);
              teamB = parseInt(data.scob);
            }
          } else if (event.sptid == 12 || event.sptid == 21) {
            if (total) {
              if (key == 'PT') {
                teamA = parseInt(data.scoa);
                teamB = parseInt(data.scob);
              }
            } else {
              if (key == 'SH') {
                teamA = parseInt(data.scoa);
                teamB = parseInt(data.scob);
              }
            }
          } else if (event.sptid == 20 || event.sptid == 15) {
            if (key == 'FT') {
              teamA = parseInt(data.scoa);
              teamB = parseInt(data.scob);
            }
          } else if (event.sptid == 13) {
            if (total) {
              if (key == 'FT') {
                teamA = parseInt(data.scoa);
                teamB = parseInt(data.scob);
              }
            }
          } else if (event.sptid == 19) {
            if (key == 'FT') {
              teamA = parseInt(data.scoa);
              teamB = parseInt(data.scob);
            }
          } else if (event.sptid == 7) {
            if (key == 'FT') {
              teamA = data.scoa;
              teamB = data.scob;
            }
          }
        });
      }
      if (hasRec == 0) {
        return '-';
      }
      return team == 'A' ? teamA : teamB;
    }
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allBet_all_bet__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_mixins_favourite__ = __webpack_require__(17);
















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__vue_mixins_favourite__["a" /* default */]],
  components: {
    allBetComponent: __WEBPACK_IMPORTED_MODULE_7__allBet_all_bet__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'matchAllBet', 'sortedMatchEventList', 'market', 'selectedShow', 'selectedMarket', 'selectedBettype', 'tvIconFlag', 'selectedAllBetNew', 'foldopenAllBet', 'allBetReloading', 'livetv']), {
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    }
  }),
  watch: {
    'showhideBanner': {
      handler: function handler(val, oldVal) {
        this.allBet_mContent();
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,
      fT: ['2', '3'],
      hT: ['2', '4'],
      showhideAll: true,
      selectedBetTab: 'hot',
      otherSport1: ['N3', 'N12', 'N21'],
      betTab: {
        hot: {
          key: 'hot',
          value: true,
          flag: true
        },
        hdpou: {
          key: 'hdpou',
          value: [1, 2, 4, 32, 46, 48],
          rbvalue: [8, 9, 11, 33, 47, 49],
          flag: true
        },
        goals: {
          key: 'goals',
          value: [2, 3, 5],
          rbvalue: [18, 9, 10],
          flag: true
        },
        cs: {
          key: 'cs',
          value: [7],
          rbvalue: [16],
          flag: true
        },
        ft: {
          key: 'ft',
          value: [1],
          rbvalue: [8],
          flag: true
        },
        ht: {
          key: 'ht',
          value: [2],
          flag: true
        },
        others: {
          key: 'others',
          value: true,
          flag: true
        },
        special: {
          key: 'special',
          value: true,
          flag: true
        },
        other: {
          key: 'other',
          value: [21, 34, 28, 30],
          rbvalue: [27, 29, 35, 31],
          flag: true
        },
        scrMarket: {
          key: 'scrMarket',
          value: [2, 3, 5, 7, 9, 10],
          flag: true
        },
        sethdp: {
          key: 'set',
          value: [3, 7, 8, 9, 10, 11, 12],
          rbvalue: [27, 29, 35, 31],
          flag: true
        },
        gamehdp: {
          key: 'game',
          value: [6],
          flag: true
        },
        pointhdp: {
          key: 'point',
          value: [4],
          flag: true
        },
        all: {
          key: 'all',
          value: true,
          flag: true
        }
      },
      showhideBanner: true,
      mContentPadding: '',
      reloading: false,
      bannerSize: 190,
      liveTvheight: 290
    };
  },

  methods: {
    checkBTExist: function checkBTExist(BTkey) {
      var vue = this;

      var exist = false;
      var btArray = this.sortedMatchEventList.rbinfo ? vue.betTab[BTkey].rbvalue : vue.betTab[BTkey].value;

      _.forEach(this.sortedMatchEventList.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), btArray) > -1) {
            exist = true;
          }
        });
      });

      return exist;
    },
    allBet_mContent: function allBet_mContent() {
      var a = 76;
      var b = this.showhideBanner ? a + this.bannerSize : a;
      if (this.livetvEveid > 0 && this.showhideBanner) {
        b = 400;
      }
      this.mContentPadding = 'padding-top: ' + b + 'px;';
    },
    showhide_Banner: function showhide_Banner(val) {
      this.showhideBanner = val;
    },
    getABetSport: function getABetSport() {
      var sprt = this.$store.getters.selectedBettype.sprtId;

      return 'allBet' + sprt;
    },
    foldopenAB: function foldopenAB() {
      this.$store.commit('FOLDOPEN_ALLBET', !this.$store.getters.foldopenAllBet);
    },
    backtoTop: function backtoTop() {
      $(".list-scrollbar").animate({ scrollTop: 0 }, 100);
    },
    showhideMain: function showhideMain() {
      this.showhideAll = this.showhideAll ? false : true;
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide);
    },
    colspanS: function colspanS() {
      return 2;
    },
    getSubMatch: function getSubMatch(sub) {
      return sub + 1;
    },
    showLeg: function showLeg() {
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide);
    },
    chooseBetTab: function chooseBetTab(betTab) {
      if (betTab.flag) {
        this.selectedBetTab = betTab.key;
      }
    },
    switchAllBetTab: function switchAllBetTab(id) {
      $('.moreBetTypeNav-Item').removeClass('active');
      $(id).addClass('active');
    },
    checkOpenMore: function checkOpenMore(event) {
      if (event.sp) {
        return true;
      } else if (event.od) {
        var show = true;
        $.each(event.od, function (plyTypes, drawBt) {
          if (plyTypes !== '1' && plyTypes !== '3') {
            return true;
          } else {
            show = true;
            if (plyTypes == '1' || plyTypes == '2') {
              $.each(drawBt, function (bidx, drawDual) {
                show = true;

                if (bidx == 1 || bidx == 2 || bidx == 4 || bidx == 8 || bidx == 9 || bidx == 11) {
                  show = false;
                }
              });
            }
          }
        });
        return show;
      }
      return false;
    },
    reloadTable: function reloadTable() {
      var _this = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.oddsReload = true;

      __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('templateChange', this.oddsReload);

      var dispatchName = 'getSportOdds';
      if (this.$store.getters.selectedBettype.betTypId == '6') {
        dispatchName = 'getSportOutrightOdds';
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8;
      }

      this.$store.dispatch(dispatchName, {
        token: token_val,
        callback: function (res) {
          if (res.events) {
            _this.reconnectTimerId = null;
            _.forEach(res.events, function (val, key) {
              _.forEach(val, function (v, k) {
                var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse');
                if (showAllBet) {
                  $('#moreExpand' + v.eveid).addClass('icon-moreExpand');
                  $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse');
                  $('#moreBets' + v.eveid).css("display", "none");
                }
              });
            });
          } else {
            _this.reconnectTimerSeconds = 5;
            if (_this.reconnectTimerId == null) {
              _this.reconnectTimerId = setInterval(function () {
                if (_this.reconnectTimerSeconds - 1 < 0) {
                  _this.reloadTable();
                } else {
                  _this.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (_this.showFavEvents) {
            _this.$store.dispatch('getLaugueList', function (res) {
              this.$store.commit('SELECTEDLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
              this.$store.commit('TOTALLEAGUES', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
            }.bind(_this));
          }
          _this.reloading = false;
          _this.oddsReload = false;
          __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('templateChange', _this.oddsReload);


          _this.$store.commit('PARLAY_SELECTED', { update: false });
        }.bind(this)
      });
    },
    backToMain: function backToMain() {
      __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('sportTableReloading', true);
      this.reloadTable();
      this.$store.commit('SELECTED_MATCHALLBET', false);
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    getMarketTimer: function getMarketTimer(selMarket) {
      if (this.$store.getters.open_RBMarket) {
        return this.rbTimer;
      } else if (selMarket == this.$store.getters.market.earlyMarket.key) {
        return this.earlyTimer;
      } else if (selMarket == this.$store.getters.market.tdyMarket.key) {
        return this.todayTimer;
      }
    },
    startAllBetTimer: function startAllBetTimer() {
      var _this2 = this;

      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (_this2.timerSeconds - 1 < 0) {
            _this2.refreshTbl(token.arr_1);
          } else {
            _this2.timerSeconds -= 1;
          }
        }, 1000);
      }
    },
    refreshTbl: function refreshTbl(token_val) {
      this.reloading = token_val == token.arr_1 || token_val == token.arr_5 ? false : true;
      if (this.selectedMatchAllBet) {
        this.reloadAllBetTable(token_val);
      }
    },
    reloadAllBetTable: function reloadAllBetTable() {
      var _this3 = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (token_val == '') {
        token_val = token.arr_5;
      }
      this.clearTimer();

      this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList);

      this.$store.dispatch('getSportAllBet', {
        token: token_val,
        inAllBet: true,
        event: this.$store.getters.sortedMatchEventList,
        callback: function (res) {
          _this3.timerSeconds = _this3.getMarketTimer(_this3.$store.getters.selectedMarket);

          _this3.startAllBetTimer();
          _this3.mainMarketList = _.cloneDeep(_this3.$store.getters.sortedMatchEventList);

          _this3.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('diffOdd', _this3.cloneEventAllBet);
          });
          _this3.reloading = false;
        }.bind(this)
      });
    },
    checkTimer: function checkTimer(event) {
      return this.$options.filters.checkTimer(event);
    }
  },
  mounted: function mounted() {
    this.allBet_mContent();
  },
  beforeMount: function beforeMount() {
    if (this.sortedMatchEventList.rbinfo && this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key) {
      this.$store.commit('IS_TODAYRB', true);
    } else if (this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key) {
      this.$store.commit('IS_TODAYRB', false);
    }
    this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket);
    this.startAllBetTimer();
  },
  destroyed: function destroyed() {
    this.clearTimer();
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_cs_tg_ftht__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_btts_tg_ft__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__more_bet_header__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__moreBet_cs__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__moreBet_1x2btts__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__moreBet_special__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vue_events_event_bus__ = __webpack_require__(3);
























/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_14__mixins_allBet__["a" /* default */]],
  components: {
    mbHeader: __WEBPACK_IMPORTED_MODULE_9__more_bet_header__["a" /* default */],
    moreCS: __WEBPACK_IMPORTED_MODULE_10__moreBet_cs__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_13__sportTeamColumn__["a" /* default */],
    more1x2btts: __WEBPACK_IMPORTED_MODULE_11__moreBet_1x2btts__["a" /* default */],
    moreSpecial: __WEBPACK_IMPORTED_MODULE_12__moreBet_special__["a" /* default */]
  },
  props: {
    event: null,
    widthColumn: null,
    isUnfold: false
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['eventAllBet', 'selectedShow', 'selectedBettype', 'moreBetLoading', 'moreBetToggle', 'myMarketList', 'firstEvent', 'simpleSport', 'bettypeFeature']), {
    filteredMainMarketList: function filteredMainMarketList() {
      this.specialEveId = null;

      var eventAllBet = _.cloneDeep(this.event);
      switch (this.selectedMarket) {
        case this.mBetTab.cs.key:
          eventAllBet = this.getCSOdd(eventAllBet);
          break;
        case this.mBetTab.onex2btts.key:
          eventAllBet = this.getOnex2bttsOdd(eventAllBet);
          break;
        case this.mBetTab.booking.key:
          eventAllBet = this.getSpecialOdd(eventAllBet, this.mBetTab.booking.value);
          break;
        case this.mBetTab.corner.key:
          eventAllBet = this.getSpecialOdd(eventAllBet, this.mBetTab.corner.value);
          break;
        default:
      }
      return eventAllBet;
    },

    sortedMatchEventList: {
      get: function get() {
        this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList);
        return this.$store.getters.sortedMatchEventList;
      },
      set: function set(value) {}
    },
    hasCS: function hasCS() {
      return this.checkMBTexist(this.event, this.mBetTab.cs.key);
    },
    hasOneX2BTTS: function hasOneX2BTTS() {
      return this.checkMBTexist(this.event, this.mBetTab.onex2btts.key);
    },
    hasBooking: function hasBooking() {
      return this.checkMBTexist(this.event, this.mBetTab.booking.key);
    },
    hasCorner: function hasCorner() {
      return this.checkMBTexist(this.event, this.mBetTab.corner.key);
    }
  }),
  updated: function updated() {},
  data: function data() {
    return {
      lang: window.lang,
      mBetTab: {
        cs: {
          key: 'cs',
          value: [7],
          rbvalue: [16],
          flag: true
        },
        onex2btts: {
          key: 'onex2btts',
          value: [65, 70],
          rbvalue: [66, 71],
          flag: true
        },
        dbchbtts: {
          key: 'dbchbtts',
          value: [70],
          rbvalue: [71],
          flag: true
        },
        booking: {
          key: 'booking',
          value: "b",
          flag: true
        },
        corner: {
          key: 'corner',
          value: "c",
          flag: true
        }
      },
      cloneEventAllBet: null,
      mainMarketList: null,
      showMyMarkets: false,
      showMainMarkets: true,
      allBetRefreshTimer: 90,
      allBetTimerId: null,

      selectedMarket: null,
      token: window.token,
      isRB: false,
      showMoreBet: false,
      show: true,
      childHeight: 0,
      clickMoreBet: false,
      moreBetmatchesHeight: 0,
      xParent1: 0,
      xParent2: 0,
      ousub: null,
      specialEveId: null
    };
  },

  methods: {
    checkMBTexist: function checkMBTexist(event, btKey) {
      var vue = this;
      var exist = false;
      var btArray = event.rbinfo ? vue.mBetTab[btKey].rbvalue : vue.mBetTab[btKey].value;

      if (btKey == this.mBetTab.cs.key) {
        _.forEach(event.od, function (data, key) {
          _.forEach(data, function (val, k) {
            if ($.inArray(parseInt(k), btArray) > -1) {
              exist = true;
            }
          });
        });
      }

      if (btKey == this.mBetTab.onex2btts.key || btKey == this.mBetTab.dbchbtts.key) {
        _.forEach(event.od, function (data, key) {
          _.forEach(data, function (val, k) {
            if ($.inArray(parseInt(k), btArray) > -1) {
              exist = true;
            }
          });
        });

        if (this.bettypeFeature) {
          _.forEach(btArray, function (val, k) {
            if (_.indexOf(vue.bettypeFeature, String(val)) !== -1) {
              exist = false;
            }
          });
        }
      }

      if (btKey == this.mBetTab.booking.key) {
        $.each(event.sp, function (key, value) {
          if (value.r == "b" && value.od) {
            exist = true;
            return false;
          }
        });
      }

      if (btKey == this.mBetTab.corner.key) {
        $.each(event.sp, function (key, value) {
          if (value.r == "c" && value.od) {
            exist = true;
            return false;
          }
        });
      }

      this.show = exist || this.simpleSport != null ? true : false;
      return exist;
    },
    setTabActive: function setTabActive(event) {
      var vue = this;
      var existCs = 0;
      var bttsArray = event.rbinfo ? vue.mBetTab['onex2btts'].rbvalue : vue.mBetTab['onex2btts'].value;
      var csArray = event.rbinfo ? vue.mBetTab['cs'].rbvalue : vue.mBetTab['cs'].value;

      _.forEach(event.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), csArray) > -1) {
            existCs = 1;
            return false;
          } else if ($.inArray(parseInt(k), bttsArray) > -1) {
            existCs = 2;
            return false;
          }
        });
      });

      return existCs;
    },
    openMoreBetForm: function openMoreBetForm(event, clickFrom) {
      var _this = this;

      var expanded = $('#moreBet' + event.eveid).hasClass('active');
      var csForm = $('.cstab-' + event.eveid).hasClass('active');
      var mmForm = $('.mmtab-' + event.eveid).hasClass('active');
      var bookingForm = $('.bookingtab-' + event.eveid).hasClass('active');
      var cornerForm = $('.cornertab-' + event.eveid).hasClass('active');
      var mbetHeader = this.simpleSport ? 80 : 40;

      if (csForm) {
        this.selectedMarket = this.mBetTab.cs.key;
      } else if (mmForm) {
        this.selectedMarket = this.mBetTab.onex2btts.key;
      } else if (bookingForm) {
        this.selectedMarket = this.mBetTab.booking.key;
      } else if (cornerForm) {
        this.selectedMarket = this.mBetTab.corner.key;
      } else {
        if (this.hasCS) this.selectedMarket = this.mBetTab.cs.key;else if (this.hasOneX2BTTS) this.selectedMarket = this.mBetTab.onex2btts.key;else if (this.hasBooking) this.selectedMarket = this.mBetTab.booking.key;else if (this.hasCorner) this.selectedMarket = this.mBetTab.corner.key;
      }

      if (expanded) {
        this.$store.commit('MOREBETLOADING', true);
        this.$store.dispatch('getSportAllBet', {
          event: event,
          token: token.arr_8,
          callback: function (res) {
            _this.showMoreBet = true;
            _this.clickMoreBet = true;
            _this.$store.commit('MOREBETLOADING', false);
            _this.$nextTick(function () {
              if (_this.showMoreBet && _this.clickMoreBet) {
                _this.xParent1 = _this.$parent.$refs['eCardWrap' + _this.event.eveid] && _this.$parent.$refs['eCardWrap' + _this.event.eveid].length > 0 ? _this.$parent.$refs['eCardWrap' + _this.event.eveid][0].offsetHeight : _this.$parent.$refs['eCardWrap' + _this.event.eveid].offsetHeight;
                _this.xParent2 = _this.$parent.$refs['eCard' + _this.event.eveid] && _this.$parent.$refs['eCard' + _this.event.eveid].length > 0 ? _this.$parent.$refs['eCard' + _this.event.eveid][0].offsetHeight : _this.$parent.$refs['eCard' + _this.event.eveid].offsetHeight;
                _this.childHeight = _this.$refs['moreBetmatches' + _this.event.eveid].offsetHeight + mbetHeader;
                var p1 = _this.xParent1 + _this.childHeight;
                var p2 = _this.xParent2 + _this.childHeight;
                document.getElementById('eCardWrap' + _this.event.eveid).style.height = p1 + "px";
                document.getElementById('eCard' + _this.event.eveid).style.height = p2 + "px";
                _this.clickMoreBet = false;
              }
            });
          }.bind(this)
        });
      } else {
        if (clickFrom == 'arrow') {
          this.showMoreBet = false;
        }
        if (this.showMoreBet && !this.clickMoreBet) {
          this.$nextTick(function () {
            var p1 = $('#eCard' + _this.event.eveid).children().height() + 6;
            var p2 = $('#eCard' + _this.event.eveid).children().height() + 3;

            document.getElementById('eCardWrap' + _this.event.eveid).style.height = p1 + "px";
            document.getElementById('eCard' + _this.event.eveid).style.height = p2 + "px";
          });
        } else if (!this.showMoreBet && !this.clickMoreBet) {
          var xParent1 = this.$parent.$refs['eCardWrap' + this.event.eveid] && this.$parent.$refs['eCardWrap' + this.event.eveid].length > 0 ? this.$parent.$refs['eCardWrap' + this.event.eveid][0].offsetHeight : this.$parent.$refs['eCardWrap' + this.event.eveid].offsetHeight;
          var xParent2 = this.$parent.$refs['eCard' + this.event.eveid] && this.$parent.$refs['eCard' + this.event.eveid].length > 0 ? this.$parent.$refs['eCard' + this.event.eveid][0].offsetHeight : this.$parent.$refs['eCard' + this.event.eveid].offsetHeight;
          var childHeight = this.$refs['moreBetmatches' + this.event.eveid].offsetHeight + mbetHeader;
          var p1 = xParent1 - childHeight;
          var p2 = xParent2 - childHeight;
          document.getElementById('eCardWrap' + this.event.eveid).style.height = p1 + "px";
          document.getElementById('eCard' + this.event.eveid).style.height = p2 + "px";
          this.clickMoreBet = false;
        }
      }
    },
    updateElementHeights: function updateElementHeights(newHeight) {
      var mbetHeader = 40;

      var p1 = this.xParent1 + newHeight + mbetHeader;
      var p2 = this.xParent2 + newHeight + mbetHeader;

      document.getElementById('eCardWrap' + this.event.eveid).style.height = p1 + "px";
      document.getElementById('eCard' + this.event.eveid).style.height = p2 + "px";
    },
    rbdata: function rbdata() {
      this.isRB = this.filteredMainMarketList.event_rb == '1' || this.filteredMainMarketList.rbinfo || this.filteredMainMarketList.status == '1' ? true : false;
      return this.isRB;
    },
    chkShow: function chkShow(sportId, betType, plyType) {
      if (sportId == 13) {
        if (plyType == 1 && betType != 3 && betType != 10) {
          return false;
        }
      } else if (sportId == 1) {
        if (this.$store.getters.selectedShow != 4 && plyType == 1 && (betType == 1 || betType == 2 || betType == 4 || betType == 8 || betType == 9 || betType == 11)) {
          if (this.$store.getters.selectedShow == 3 && (betType == 4 || betType == 11)) {} else if (this.$store.getters.selectedShow == 1 && (betType == 4 || betType == 11)) {} else {
            return false;
          }
        } else if (this.$store.getters.selectedShow != 3 && plyType == 2 && (betType == 1 || betType == 2 || betType == 4 || betType == 8 || betType == 9 || betType == 11)) {
          if (this.$store.getters.selectedShow == 4 && (betType == 4 || betType == 11)) {} else if (this.$store.getters.selectedShow == 1 && (betType == 4 || betType == 11)) {} else {
            return false;
          }
        }
      } else if (plyType == 1 || plyType == 3) {
        return false;
      }
      return true;
    },
    closeAllBetForm: function closeAllBetForm() {
      this.$store.commit('SELECTED_ALLBET', false);
    },
    backToTop: function backToTop() {
      document.getElementById("more_div").scrollTop = "0";
    },
    countOddsType: function countOddsType(marKetList) {
      var count = 0;

      function getOddsCount(event) {
        var odCount = 0;
        for (var plytyp = 0; plytyp < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(event.od).length; plytyp++) {
          var plytypKey = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(event.od)[plytyp];
          for (var bettyp = 0; bettyp < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(event.od[plytypKey]).length; bettyp++) {
            var bettypKey = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(event.od[plytypKey])[bettyp];

            if (_.indexOf([this.hdpBetType, this.ouBetType, this.rhdpBetType, this.rouBetType], bettypKey) >= 0) {
              odCount += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(event.od[plytypKey][bettypKey]).length;
            } else {
              odCount += 1;
            }
          }
        }
        return odCount;
      }

      var getCount = getOddsCount.bind(this);
      count += getCount(marKetList);
      if (marKetList.sp) {
        for (var eventId = 0; eventId < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(marKetList.sp).length; eventId++) {
          var event = marKetList.sp[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(marKetList.sp)[eventId]];
          count += getCount(event);
        }
      }
      return count;
    },
    syncMainMarket: function syncMainMarket() {
      if (this.myMarketList) {
        if (this.myMarketList.od[this.ftPlyType]) {
          var ftBetTyp = _.pick(this.mainMarketList.od[this.ftPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.ftPlyType]));
          this.$set(this.myMarketList.od, this.ftPlyType, ftBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.ftPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.ftPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.ftPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.firstHtPlyType]) {
          var firstHtBetTyp = _.pick(this.mainMarketList.od[this.firstHtPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstHtPlyType]));
          this.$set(this.myMarketList.od, this.firstHtPlyType, firstHtBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstHtPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.firstHtPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstHtPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.setHandicapPlyType]) {
          var setHandicapBetTyp = _.pick(this.mainMarketList.od[this.setHandicapPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.setHandicapPlyType]));
          this.$set(this.myMarketList.od, this.setHandicapPlyType, setHandicapBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.setHandicapPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.setHandicapPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.setHandicapPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.pointHdpPlyType]) {
          var pointHandicapBetTyp = _.pick(this.mainMarketList.od[this.pointHdpPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.pointHdpPlyType]));
          this.$set(this.myMarketList.od, this.pointHdpPlyType, pointHandicapBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.pointHdpPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.pointHdpPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.pointHdpPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.iotPlyType]) {
          var iotBetTyp = _.pick(this.mainMarketList.od[this.iotPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.iotPlyType]));
          this.$set(this.myMarketList.od, this.iotPlyType, iotBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.iotPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.iotPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.iotPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.gameHdpPlyType]) {
          var gameHandicapBetTyp = _.pick(this.mainMarketList.od[this.gameHdpPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.gameHdpPlyType]));
          this.$set(this.myMarketList.od, this.gameHdpPlyType, gameHandicapBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.gameHdpPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.gameHdpPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.gameHdpPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.firstSetPlyType]) {
          var firstSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.firstSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstSetPlyType]));
          this.$set(this.myMarketList.od, this.firstSetPlyType, firstSetHandicapBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.firstSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.firstSetPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.secondSetPlyType]) {
          var secondSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.secondSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.secondSetPlyType]));
          this.$set(this.myMarketList.od, this.secondSetPlyType, secondSetHandicapBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.secondSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.secondSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.secondSetPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.thirdSetPlyType]) {
          var thirdSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.thirdSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.thirdSetPlyType]));
          this.$set(this.myMarketList.od, this.thirdSetPlyType, thirdSetHandicapBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.thirdSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.thirdSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.thirdSetPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.fourthSetPlyType]) {
          var fourthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.fourthSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fourthSetPlyType]));
          this.$set(this.myMarketList.od, this.fourthSetPlyType, fourthSetHandicapBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fourthSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.fourthSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fourthSetPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.fifthSetPlyType]) {
          var fifthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.fifthSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fifthSetPlyType]));
          this.$set(this.myMarketList.od, this.fifthSetPlyType, fifthSetHandicapBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fifthSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.fifthSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.fifthSetPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.sixthSetPlyType]) {
          var sixthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.sixthSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.sixthSetPlyType]));
          this.$set(this.myMarketList.od, this.sixthSetPlyType, sixthSetHandicapBetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.sixthSetPlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.sixthSetPlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.sixthSetPlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.game1PlyType]) {
          var game1BetTyp = _.pick(this.mainMarketList.od[this.game1PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game1PlyType]));
          this.$set(this.myMarketList.od, this.game1PlyType, game1BetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game1PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game1PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game1PlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.game2PlyType]) {
          var game2BetTyp = _.pick(this.mainMarketList.od[this.game2PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game2PlyType]));
          this.$set(this.myMarketList.od, this.game2PlyType, game2BetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game2PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game2PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game2PlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.game3PlyType]) {
          var game3BetTyp = _.pick(this.mainMarketList.od[this.game3PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game3PlyType]));
          this.$set(this.myMarketList.od, this.game3PlyType, game3BetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game3PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game3PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game3PlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.game4PlyType]) {
          var game4BetTyp = _.pick(this.mainMarketList.od[this.game4PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game4PlyType]));
          this.$set(this.myMarketList.od, this.game4PlyType, game4BetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game4PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game4PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game4PlyType])[i]);
          }
        }
        if (this.myMarketList.od[this.game5PlyType]) {
          var game5BetTyp = _.pick(this.mainMarketList.od[this.game5PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game5PlyType]));
          this.$set(this.myMarketList.od, this.game5PlyType, game5BetTyp);
          for (var i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game5PlyType]).length - 1; i >= 0; i--) {
            this.$delete(this.mainMarketList.od[this.game5PlyType], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[this.game5PlyType])[i]);
          }
        }
        if (this.myMarketList.sp) {
          for (var eveid = 0; eveid < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp).length; eveid++) {
            var specialEvent = this.myMarketList.sp[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp)[eveid]];
            for (var plytyp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(specialEvent.od).length - 1; plytyp >= 0; plytyp--) {
              var plytypId = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(specialEvent.od)[plytyp];
              if (this.mainMarketList.sp && this.mainMarketList.sp[specialEvent.eveid] && this.mainMarketList.sp[specialEvent.eveid].od[plytypId] && specialEvent.od[plytypId]) {
                var betTypList = _.pick(this.mainMarketList.sp[specialEvent.eveid].od[plytypId], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(specialEvent.od[plytypId]));
                this.$set(this.myMarketList.sp[specialEvent.eveid].od, plytypId, betTypList);
                for (var bettyp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(specialEvent.od[plytypId]).length - 1; bettyp >= 0; bettyp--) {
                  this.$delete(this.mainMarketList.sp[specialEvent.eveid].od[plytypId], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp[specialEvent.eveid].od[plytypId])[bettyp]);
                }
              }
            }
          }
        }
      }
    },
    updateFavCookie: function updateFavCookie(plytyp, bettyp, isDelete) {
      var isSpecial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var favCookie = {};
      if (__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get(window.compcode + '_fav')) {
        favCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get(window.compcode + '_fav'));
        if (!isSpecial) {
          if (!favCookie[plytyp]) favCookie[plytyp] = {};
          favCookie[plytyp][bettyp] = {};
          if (isDelete) {
            _.unset(favCookie[plytyp], [bettyp]);
            if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie[plytyp]).length == 0) {
              _.unset(favCookie, [plytyp]);
            }
          }
        } else {
          if (!favCookie.sp) favCookie.sp = {};
          if (!favCookie.sp[isSpecial.eveid]) favCookie.sp[isSpecial.eveid] = {};
          if (!favCookie.sp[isSpecial.eveid][plytyp]) favCookie.sp[isSpecial.eveid][plytyp] = {};
          favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {};
          if (isDelete) {
            _.unset(favCookie.sp[isSpecial.eveid][plytyp], [bettyp]);
            if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie.sp[isSpecial.eveid][plytyp]).length == 0) {
              _.unset(favCookie.sp[isSpecial.eveid], [plytyp]);
            }
            if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie.sp[isSpecial.eveid]).length == 0) {
              _.unset(favCookie.sp, isSpecial.eveid);
            }
          }
        }
      } else {
        if (!isSpecial) {
          favCookie[plytyp] = {};
          favCookie[plytyp][bettyp] = {};
        } else {
          favCookie.sp = {};
          favCookie.sp[isSpecial.eveid] = {};
          favCookie.sp[isSpecial.eveid][plytyp] = {};
          favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {};
        }
      }
      __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.set(window.compcode + '_fav', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(favCookie));
    },
    getFavCookieMarket: function getFavCookieMarket() {
      var favCookie = {};
      if (__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get(window.compcode + '_fav')) {
        favCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a.get(window.compcode + '_fav'));
        for (var plytyp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie).length - 1; plytyp >= 0; plytyp--) {
          var pt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie)[plytyp];
          if (pt != 'sp') {
            for (var bettyp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie[pt]).length - 1; bettyp >= 0; bettyp--) {
              var bt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie[pt])[bettyp];
              if (this.$store.getters.eventAllBet.od[pt]) {
                if (this.$store.getters.eventAllBet.od[pt][bt]) {
                  this.pickMarket(this.$store.getters.eventAllBet, pt, bt);
                }
              }
            }
          } else {
            for (var eve = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie.sp).length - 1; eve >= 0; eve--) {
              var eveid = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie.sp)[eve];
              for (var plytyp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid]).length - 1; plytyp >= 0; plytyp--) {
                var pt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid])[plytyp];
                for (var bettyp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid][pt]).length - 1; bettyp >= 0; bettyp--) {
                  var bt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid][pt])[bettyp];
                  var bt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid][pt])[bettyp]['a'];
                  if (this.$store.getters.eventAllBet.sp && this.$store.getters.eventAllBet.sp[eveid]) {
                    if (this.$store.getters.eventAllBet.sp[eveid].od[pt]) {
                      if (this.$store.getters.eventAllBet.sp[eveid].od[pt][bt]) {
                        this.pickMarket(this.$store.getters.eventAllBet.sp[eveid], pt, bt, true);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return {};
    },
    pickMarket: function pickMarket(market, plytyp, bettyp) {
      var isSpecial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (this.myMarketList) {
        if (!isSpecial) {
          if (!this.myMarketList.od[plytyp]) {
            this.$set(this.myMarketList.od, plytyp, {});
          }
          this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp]);
        } else {
          !this.myMarketList.sp ? this.$set(this.myMarketList, 'sp', {}) : this.myMarketList.sp;
          !this.myMarketList.sp[market.eveid] ? this.$set(this.myMarketList.sp, market.eveid, {}) : this.myMarketList.sp[market.eveid];

          var copyMarket = _.cloneDeep(market);
          _.unset(copyMarket, 'od');
          _.assign(this.myMarketList.sp[market.eveid], copyMarket);

          !this.myMarketList.sp[market.eveid].od ? this.$set(this.myMarketList.sp[market.eveid], 'od', {}) : this.myMarketList.sp[market.eveid].od;
          !this.myMarketList.sp[market.eveid].od[plytyp] ? this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {}) : this.myMarketList.sp[market.eveid].od[plytyp];
          this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp]);
        }
      } else {
        this.myMarketList = _.cloneDeep(this.$store.getters.eventAllBet);
        this.$set(this.myMarketList, 'od', {});
        this.$set(this.myMarketList, 'sp', {});
        if (!isSpecial) {
          this.$set(this.myMarketList.od, plytyp, {});
          this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp]);
        } else {
          this.$set(this.myMarketList.sp, market.eveid, _.cloneDeep(market));
          this.$set(this.myMarketList.sp[market.eveid], 'od', {});
          this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {});
          this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp]);
        }
        this.showMyMarkets = true;
      }
      !isSpecial ? this.updateFavCookie(plytyp, bettyp, false) : this.updateFavCookie(plytyp, bettyp, false, market);
      !isSpecial ? this.$delete(this.mainMarketList.od[plytyp], bettyp) : this.$delete(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp);
    },
    removeFromMyMarket: function removeFromMyMarket(market, plytyp, bettyp) {
      var isSpecial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (!isSpecial) {
        this.$set(this.mainMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp]);
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od[plytyp]).length > 1) this.$delete(this.myMarketList.od[plytyp], bettyp);else this.$delete(this.myMarketList.od, plytyp);

        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.od).length == 0) this.myMarketList = null;
      } else {
        this.$set(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp]);
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp[market.eveid].od[plytyp]).length > 1) this.$delete(this.myMarketList.sp[market.eveid].od[plytyp], bettyp);else this.$delete(this.myMarketList.sp[market.eveid].od, plytyp);

        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp[market.eveid].od).length == 0) this.$delete(this.myMarketList.sp, market.eveid);
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.myMarketList.sp).length == 0) this.$delete(this.myMarketList, 'sp');
      }

      !isSpecial ? this.updateFavCookie(plytyp, bettyp, true) : this.updateFavCookie(plytyp, bettyp, true, market);
    },
    getHdpOUOdd: function getHdpOUOdd(event) {
      if (event.od[this.ftPlyType]) event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], this.market.hdpou.value);
      if (event.od[this.firstHtPlyType]) event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], this.market.hdpou.value);
      if (event.od[this.setHandicapPlyType]) event.od[this.setHandicapPlyType] = _.pick(event.od[this.setHandicapPlyType], this.market.hdpou.value);
      if (event.od[this.pointHandicapPlyType]) event.od[this.pointHandicapPlyType] = _.pick(event.od[this.pointHandicapPlyType], this.market.hdpou.value);
      if (event.od[this.iotPlyType]) event.od[this.iotPlyType] = _.pick(event.od[this.iotPlyType], this.market.hdpou.value);
      if (event.od[this.gameHdpPlyType]) event.od[this.gameHdpPlyType] = _.pick(event.od[this.gameHdpPlyType], this.market.hdpou.value);
      if (event.od[this.firstSetPlyType]) event.od[this.firstSetPlyType] = _.pick(event.od[this.firstSetPlyType], this.market.hdpou.value);
      if (event.od[this.secondSetPlyType]) event.od[this.secondSetPlyType] = _.pick(event.od[this.secondSetPlyType], this.market.hdpou.value);
      if (event.od[this.thirdSetPlyType]) event.od[this.thirdSetPlyType] = _.pick(event.od[this.thirdSetPlyType], this.market.hdpou.value);
      if (event.od[this.fourthSetPlyType]) event.od[this.fourthSetPlyType] = _.pick(event.od[this.fourthSetPlyType], this.market.hdpou.value);
      if (event.od[this.fifthSetPlyType]) event.od[this.fifthSetPlyType] = _.pick(event.od[this.fifthSetPlyType], this.market.hdpou.value);
      if (event.od[this.sixthSetPlyType]) event.od[this.sixthSetPlyType] = _.pick(event.od[this.sixthSetPlyType], this.market.hdpou.value);
      if (event.od[this.game1PlyType]) event.od[this.game1PlyType] = _.pick(event.od[this.game1PlyType], this.market.hdpou.value);
      if (event.od[this.game2PlyType]) event.od[this.game2PlyType] = _.pick(event.od[this.game2PlyType], this.market.hdpou.value);
      if (event.od[this.game3PlyType]) event.od[this.game3PlyType] = _.pick(event.od[this.game3PlyType], this.market.hdpou.value);
      if (event.od[this.game4PlyType]) event.od[this.game4PlyType] = _.pick(event.od[this.game4PlyType], this.market.hdpou.value);
      if (event.od[this.game5PlyType]) event.od[this.game5PlyType] = _.pick(event.od[this.game5PlyType], this.market.hdpou.value);
      return event;
    },
    getCSOdd: function getCSOdd(event) {
      var csBT = event.rbinfo ? this.mBetTab.cs.rbvalue : this.mBetTab.cs.value;

      if (event.od[this.ftPlyType]) event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], csBT);
      if (event.od[this.firstHtPlyType]) event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], csBT);

      return event;
    },
    getOnex2bttsOdd: function getOnex2bttsOdd(event) {
      var onex2bttsBT = event.rbinfo ? this.mBetTab.onex2btts.rbvalue : this.mBetTab.onex2btts.value;

      if (event.od[this.ftPlyType]) event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], onex2bttsBT);
      if (event.od[this.firstHtPlyType]) event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], onex2bttsBT);
      return event;
    },
    getSpecialOdd: function getSpecialOdd(event, specialType) {
      this.specialEveId = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(event.sp).find(function (key) {
        return event.sp[key].r === specialType;
      });

      if (!this.specialEveId) return event;

      var event_ret = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, event, {
        eveid: +this.specialEveId,
        lgecapt: event.sp[this.specialEveId].lgecapt,
        lgeid: event.sp[this.specialEveId].lgeid,
        tacapt: event.sp[this.specialEveId].tacapt,
        taid: event.sp[this.specialEveId].taid,
        tbcapt: event.sp[this.specialEveId].tbcapt,
        tbid: event.sp[this.specialEveId].tbid,
        od: event.sp[this.specialEveId].od,
        sp: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.specialEveId, event.sp[this.specialEveId])
      }, event.sp_rbinfo ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.specialEveId, event.sp_rbinfo[this.specialEveId]) : {});

      return event_ret;
    },
    getScoreMarketOdd: function getScoreMarketOdd(event) {
      if (event.od[this.ftPlyType]) event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], this.market.scrMarket.value);
      if (event.od[this.firstHtPlyType]) event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], this.market.scrMarket.value);
      if (event.od[this.setHandicapPlyType]) event.od[this.setHandicapPlyType] = _.pick(event.od[this.setHandicapPlyType], this.market.scrMarket.value);
      if (event.od[this.pointHandicapPlyType]) event.od[this.pointHandicapPlyType] = _.pick(event.od[this.pointHandicapPlyType], this.market.scrMarket.value);
      if (event.od[this.iotPlyType]) event.od[this.iotPlyType] = _.pick(event.od[this.iotPlyType], this.market.scrMarket.value);
      if (event.od[this.gameHdpPlyType]) event.od[this.gameHdpPlyType] = _.pick(event.od[this.gameHdpPlyType], this.market.scrMarket.value);
      if (event.od[this.firstSetPlyType]) event.od[this.firstSetPlyType] = _.pick(event.od[this.firstSetPlyType], this.market.scrMarket.value);
      if (event.od[this.secondSetPlyType]) event.od[this.secondSetPlyType] = _.pick(event.od[this.secondSetPlyType], this.market.scrMarket.value);
      if (event.od[this.thirdSetPlyType]) event.od[this.thirdSetPlyType] = _.pick(event.od[this.thirdSetPlyType], this.market.scrMarket.value);
      if (event.od[this.fourthSetPlyType]) event.od[this.fourthSetPlyType] = _.pick(event.od[this.fourthSetPlyType], this.market.scrMarket.value);
      if (event.od[this.fifthSetPlyType]) event.od[this.fifthSetPlyType] = _.pick(event.od[this.fifthSetPlyType], this.market.scrMarket.value);
      if (event.od[this.sixthSetPlyType]) event.od[this.sixthSetPlyType] = _.pick(event.od[this.sixthSetPlyType], this.market.scrMarket.value);
      if (event.od[this.game1PlyType]) event.od[this.game1PlyType] = _.pick(event.od[this.game1PlyType], this.market.scrMarket.value);
      if (event.od[this.game2PlyType]) event.od[this.game2PlyType] = _.pick(event.od[this.game2PlyType], this.market.scrMarket.value);
      if (event.od[this.game3PlyType]) event.od[this.game3PlyType] = _.pick(event.od[this.game3PlyType], this.market.scrMarket.value);
      if (event.od[this.game4PlyType]) event.od[this.game4PlyType] = _.pick(event.od[this.game4PlyType], this.market.scrMarket.value);
      if (event.od[this.game5PlyType]) event.od[this.game5PlyType] = _.pick(event.od[this.game5PlyType], this.market.scrMarket.value);

      return event;
    },
    chooseMarketType: function chooseMarketType(market, event, tab) {

      if (market.flag) {
        this.selectedMarket = market.key;
      }
      this.switchAllBetTab(tab);
      this.openMoreBetForm(event, tab);
      this.$store.commit('SHOW_UP_DOWN', false);
    },
    sortSpecialEvents: function sortSpecialEvents(specialEvents) {
      return _.sortBy(specialEvents, ['no']);
    },
    switchAllBetTab: function switchAllBetTab(tab) {
      var splitId = tab.split('-').pop();

      $('.cstab-' + splitId).removeClass('active');
      $('.mmtab-' + splitId).removeClass('active');
      $('.bookingtab-' + splitId).removeClass('active');
      $('.cornertab-' + splitId).removeClass('active');

      $(tab).addClass('active');
    }
  },
  mounted: function mounted() {},
  beforeMount: function beforeMount() {
    this.allBetRefreshTimer = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 90;

    if (this.hasCS) this.selectedMarket = this.mBetTab.cs.key;else if (this.hasOneX2BTTS) this.selectedMarket = this.mBetTab.onex2btts.key;else if (this.hasBooking) this.selectedMarket = this.mBetTab.booking.key;else if (this.hasCorner) this.selectedMarket = this.mBetTab.corner.key;else this.selectedMarket = this.mBetTab.cs.key;

    this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList);

    this.getFavCookieMarket();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_more_bet_header_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492d0db4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_more_bet_header_vue__ = __webpack_require__(431);
function injectStyle (ssrContext) {
  __webpack_require__(430)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_more_bet_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492d0db4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_more_bet_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    selMarket: null,
    event: null,
    widthColumn: null,
    isUnfold: false
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'simpleSport'])),
  data: function data() {
    return {
      lang: window.lang,
      token: window.token
    };
  },

  methods: {},
  beforeMount: function beforeMount() {},
  destroyed: function destroyed() {}
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */]],
  props: {
    event: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    widthColumn: null,
    isUnfold: false
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['mainMarketBet', 'selectedShow', 'moreBetLoading', 'sportAllBetLang'])),
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().csBetType, __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rcsBetType],
      show: true,
      mainMarketList: null,
      bettype: this.event.rbinfo ? __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().rcsBetType : __WEBPACK_IMPORTED_MODULE_4__mixins_allBet__["a" /* default */].data().csBetType
    };
  },

  methods: {
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    addToMyMarket: function addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial);
    }
  },
  beforeMount: function beforeMount() {
    this.mainMarketList = _.cloneDeep(this.$store.getters.eventAllBet);
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_over_under__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_allBet__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_allBet__["a" /* default */]],
  props: {
    allBetEvent: null,
    event: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    widthColumn: null,
    isUnfold: false,
    eventbtts: null
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['mainMarketBet', 'selectedShow', 'moreBetLoading', 'sportAllBetLang', 'sportTableLang'])),
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_6__mixins_allBet__["a" /* default */].data().onex2bttsBetType, __WEBPACK_IMPORTED_MODULE_6__mixins_allBet__["a" /* default */].data().ronex2bttsBetType],
      show: true,
      mainMarketList: null,
      bettype: this.event.rbinfo ? __WEBPACK_IMPORTED_MODULE_6__mixins_allBet__["a" /* default */].data().ronex2bttsBetType : __WEBPACK_IMPORTED_MODULE_6__mixins_allBet__["a" /* default */].data().onex2bttsBetType,
      betTypeou: this.event.rbinfo ? __WEBPACK_IMPORTED_MODULE_6__mixins_allBet__["a" /* default */].data().ronex2ouBetType : __WEBPACK_IMPORTED_MODULE_6__mixins_allBet__["a" /* default */].data().onex2ouBetType,
      betTypedbchbtts: this.event.rbinfo ? __WEBPACK_IMPORTED_MODULE_6__mixins_allBet__["a" /* default */].data().rdbchbttsBetType : __WEBPACK_IMPORTED_MODULE_6__mixins_allBet__["a" /* default */].data().dbchbttsBetType,
      selectedMarket: null,
      lang: window.lang,
      oudual: 'a',
      ousub: 0,
      susub2: []
    };
  },

  methods: {
    showLeg: function showLeg() {
      this.show = !this.show ? true : false;
    },
    addToMyMarket: function addToMyMarket(plytyp, onex2bttsBetType) {
      if (this.selectMarket) this.selectMarket(this.allBetEvent, plytyp, onex2bttsBetType, this.isSpecial);
    },
    removeFromMyMarket: function removeFromMyMarket(plytyp, onex2bttsBetType) {
      if (this.removeMarket) this.removeMarket(this.allBetEvent, plytyp, onex2bttsBetType, this.isSpecial);
    },
    getOuDual: function getOuDual(event) {
      var vue = this;
      var betTypeou = [63, 64];
      var getou = false;
      var getDual = '';

      _.forEach(this.event.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), betTypeou) > -1) {
            _.forEach(val, function (odd, d) {
              if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(val).indexOf('a') !== -1) {
                getou = true;
                getDual = val['a']['dual'];
              }
            });
          }
        });
      });

      if (getou) {
        this.ousub = 0;
        this.oudual = getDual;
      }
    }
  },
  mouted: function mouted() {},
  beforeMount: function beforeMount() {
    this.mainMarketList = _.cloneDeep(this.$store.getters.eventAllBet);
    this.getOuDual(event);
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_over_under__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */]],
  props: {
    event: null,
    plytyp: null,
    widthColumn: null,
    isUnfold: false,
    specialType: null,
    specialEveId: null
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sportAllBetLang', 'sportTableLang'])),
  data: function data() {
    return {
      selectedLang: window._langid,
      show: true,
      playType: [__WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().ftPlyType, __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().firstHtPlyType],
      betTypeonex2: this.event.rbinfo ? __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().ronex2BetType : __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().onex2BetType,
      betTypehdp: this.event.rbinfo ? __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().rhdpBetType : __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().hdpBetType,
      betTypeou: this.event.rbinfo ? __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().rouBetType : __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().ouBetType,
      betTypeoe: this.event.rbinfo ? __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().roeBetType : __WEBPACK_IMPORTED_MODULE_5__mixins_allBet__["a" /* default */].data().oeBetType,
      lang: window.lang,
      subMatchKey: 'a'
    };
  },

  methods: {},
  mouted: function mouted() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_mixins_favourite__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__allBet_more_bet__ = __webpack_require__(68);










/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    event: null,

    isRB: null,
    widthColumn: null,
    isUnfold: null,
    firstEventEveid: null,
    livetvEveid: null
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__vue_mixins_favourite__["a" /* default */]],
  components: {
    sportTime: __WEBPACK_IMPORTED_MODULE_5__sportTimeColumn__["a" /* default */],
    moreBetComponent: __WEBPACK_IMPORTED_MODULE_6__allBet_more_bet__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'selectedShow', 'selectedMarket', 'account', 'simpleSport', 'tvIconFlag'])),
  data: function data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,
      subMatchKeyCap: {
        0: 'a',
        1: 'b',
        2: 'c',
        3: 'd'
      }
    };
  },

  methods: {
    countAllBet: function countAllBet(event) {
      var selectedShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var countCv = event.all;

      return countCv;
    },
    enterAllBet: function enterAllBet(event, startTv, isRB) {
      if (startTv == 2 && !(event.rbstatus && event.rbinfo)) {
        return;
      }
      if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv = 1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: isRB,

        token: token.arr_8,
        loadTemplate: startTv });
      if (startTv == 1 || startTv == 3) {
        this.$store.commit('RIGHT_BOARD_CHG', event);
      }
    },
    teamColor: function teamColor(event, team, plytyp) {
      var cls = '';
      if (plytyp == "") {
        plytyp = 1;
      }
      if (event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['hdp'] == '0') {} else if (event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['hdp'] == '0') {} else {
        if (team == 'A' && event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['fav'] == 'a') {
          cls = 'bold';
        } else if (team == 'A' && event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['fav'] == 'a') {
          cls = 'bold';
        } else if (team == 'B' && event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['fav'] == 'b') {
          cls = 'bold';
        } else if (team == 'B' && event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['fav'] == 'b') {
          cls = 'bold';
        }
      }
      return cls;
    },
    getTeamCapt: function getTeamCapt(teamCapt) {
      var selectedMarket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var t = teamCapt;
      if (selectedMarket == 'cs') {
        t = t + ' - ' + this.sportAllBetLang['ALL_BET.SUBHEADER_CS'];
      }

      return t;
    },
    getWidth: function getWidth() {
      var widthValue = 150;
      if (this.$store.getters.miniNormal) {
        widthValue += 50;
      }
      if (this.$store.getters.show_Fold) {
        widthValue += 130;
      }
      return 'width: ' + widthValue + 'px';
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {}
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allBet_more_bet__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__todayHeader__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__simpleSoccer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_mixins_favourite__ = __webpack_require__(17);

















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__vue_mixins_favourite__["a" /* default */]],
  components: {
    moreBetComponent: __WEBPACK_IMPORTED_MODULE_7__allBet_more_bet__["a" /* default */],
    soccerAllCommon: __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__["a" /* default */],
    sportTime: __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__["a" /* default */],
    todayHeader: __WEBPACK_IMPORTED_MODULE_8__todayHeader__["a" /* default */],
    simpleSoccer: __WEBPACK_IMPORTED_MODULE_9__simpleSoccer__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'sortedEventList', 'sortedFavRbEventList', 'market', 'selectedShow', 'selectedMarket', 'selectedBettype', 'selectedAllBetNew', 'selectedMatchAllBet', 'moreBetLoading', 'tvIconFlag', 'favouriteLgeEvents', 'showFavEvents', 'show_Unfold', 'unfold_AllSc', 'frameWidthHeight', 'livetv', 'firstEvent', 'account', 'showRBLgeEve', 'showLgeEve', 'isParlayTab', 'isGameBannerSelected', 'simpleSport']), {
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid: {
      get: function get() {
        var ft = this.$store.getters.firstEvent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ft).length > 0 ? ft.eveid : 0;
      }
    },
    widthColumn: {
      get: function get() {
        var fm = this.$store.getters.frameWidthHeight;
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount = fm.leagueTeam.columnCountBet;
        var columnCountBetShow = fm.leagueTeam.columnCountBetShow;
        var sprt = this.$store.getters.selectedBettype.sprtId;
        var tmp = this.$store.getters.selectedBettype.tmpltId;
        var hideCol = 0;

        if (!_.isUndefined(this.$store.getters.unfold_AllSc[sprt]) && !_.isUndefined(this.$store.getters.unfold_AllSc[sprt][tmp]) && this.$store.getters.unfold_AllSc[sprt][tmp]) {
          if (pageCenter <= 1370) {
            columnCountBetShow -= 1;
            hideCol += 1;
          }
          if (pageCenter < 1280) {
            columnCountBetShow -= 1;
            hideCol += 1;
          }
          columnCount = columnCountBetShow;
        }
        var AvailableLT = pageCenter - timeColumn - favColumn - betBoxWidthMin * columnCount - leagueBoxWidthMin;
        if (AvailableLT > 0) {
          var TeamCal = AvailableLT * 0.7;
          team = betBoxWidthMin + TeamCal / columnCount;
          team = Math.floor(team);
          if (team < betBoxWidthMin) {
            team = betBoxWidthMin;
          } else if (team > betBoxWidthMax) {
            team = betBoxWidthMax;
          }
          var caladd = team - betBoxWidthMin;
          if (caladd > 0) {
            AvailableLT = AvailableLT - (team - betBoxWidthMin) * columnCount;
            if (AvailableLT > 0) {
              league = AvailableLT + leagueBoxWidthMin;
            }
          } else {
            league = AvailableLT + leagueBoxWidthMin;
          }
        } else {
          league = AvailableLT + leagueBoxWidthMin;
        }
        league = league - 15;
        var league2 = league + timeColumn;
        return [league, team, league2, hideCol];
      }
    },
    sortedRBEventList: function sortedRBEventList() {
      return this.$store.getters.sortedRBEventList;
    }
  }),
  data: function data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,

      moreBetEveId: null,
      showhideAll: true,
      showRBhideAll: true,
      reloadingPer: '0 %',
      showLimit: 6,
      isUnfold: false,
      subMatchKeyCap: {
        0: 'a',
        1: 'b',
        2: 'c',
        3: 'd'
      }
    };
  },

  watch: {
    unfold_AllSc: {
      handler: function handler(val, oldVal) {
        this.checkUnfold();
      },
      deep: true
    }
  },
  beforeMount: function beforeMount() {
    this.checkUnfold();
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$on('moreBetLoading', function (params) {
      _this.reloadingPer = '75 %';
    }.bind(this));
  },

  methods: {
    checkClass: function checkClass(LgeEve, eventObjKey) {
      var match = '';
      var leagues = '';
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(LgeEve).length > 0) {
        if (!_.isUndefined(LgeEve[eventObjKey].hide)) {
          match = !LgeEve[eventObjKey].hide ? 'match-tpl0' : '';
          leagues = LgeEve[eventObjKey].hide ? 'leagues-pack' : '';
        }
      }

      return match + ' ' + leagues;
    },
    getSMKey: function getSMKey(smKey) {
      var smKeyId = '';
      if (smKey == 0 || smKey == 'a') {
        smKeyId = 'a';
      } else if (smKey == 1 || smKey == 'b') {
        smKeyId = 'b';
      } else if (smKey == 2 || smKey == 'c') {
        smKeyId = 'c';
      } else {
        smKeyId = 'd';
      }
      return smKeyId;
    },
    checkUnfold: function checkUnfold() {
      var sprt = this.selectedBettype.sprtId;
      var tmp = this.selectedBettype.tmpltId;
      if (!_.isUndefined(this.unfold_AllSc[sprt]) && !_.isUndefined(this.unfold_AllSc[sprt][tmp])) {
        this.isUnfold = this.unfold_AllSc[sprt][tmp];
      }
    },
    getTop: function getTop() {
      var topVal = this.selectedMarket == this.$store.getters.market.tdyMarket.key && (this.$store.getters.selectedBettype.betTypId != 5 || !this.isParlayTab) ? '73.5' : '89.5';
      if (this.isGameBannerSelected && this.selectedMarket == this.$store.getters.market.earlyMarket.key) {
        topVal = '37.5';
      }

      return 'top:' + topVal + 'px';
    },
    showMarketMatches: function showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll;
      } else {
        this.showhideAll = !this.showhideAll;
      }
    },
    showhideMain: function showhideMain(isRB) {
      var key = '';
      if (!isRB) {
        this.showhideAll = this.showhideAll ? false : true;
        for (key in this.sortedEventList) {
          this.$set(this.sortedEventList[key], 'hide', !this.showhideAll);
        }
      }
      if (this.showFavEvents && isRB) {
        this.showRBhideAll = this.showRBhideAll ? false : true;
      }
    },
    showLeg: function showLeg(key, isRB) {
      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide);
      } else if (isRB) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide);
      }
    },
    countAllBet: function countAllBet(event, selectedShow) {
      var countCv = event.all;
      if (event.od) {
        $.each(event.od, function (plyTypes, drawBt) {
          if (selectedShow == 3 && plyTypes == 2) {} else if (selectedShow == 4 && plyTypes == 1) {} else {
            $.each(drawBt, function (bidx, drawDual) {
              if (bidx == 1 || bidx == 2 || bidx == 8 || bidx == 9) {
                $.each(drawDual, function (dd, val) {
                  --countCv;
                });
              } else if (bidx == 4 || bidx == 11) {
                if (selectedShow == 2) {
                  --countCv;
                }
              }
            });
          }
        });
      }
      return countCv;
    },
    enterMatch: function enterMatch(event) {
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        token: token.arr_8
      });
    },
    enterAllBet: function enterAllBet(event, startTv) {
      var isRB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.$store.commit('SHOW_UNFOLD', true);
      this.$store.commit('SHOW_FOLD', false);
      this.$store.commit('UNFOLD_ALLSC', false);
      if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv = 1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: isRB,

        token: token.arr_8,
        loadTemplate: startTv });
      if (startTv == 1) {
        this.$store.commit('RIGHT_BOARD_CHG', event);
      }
    },
    backtoTop: function backtoTop() {
      $(".sport-table-scroll").animate({ scrollTop: 0 }, 100);
    }
  },
  updated: function updated() {
    $('.ellipsis').bind('mouseenter', function () {
      var $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SHOW_RBLGEEVE', []);
    this.$store.commit('SHOW_LGEEVE', {});
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$off('moreBetLoading');
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_event_bus__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    marketType: null
  },
  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sportTableLang', 'sortedEventList', 'sortedRBEventList', 'selectedBettype', 'selectedMarket', 'market'])),
  data: function data() {
    return {
      reloading: false
    };
  },

  methods: {
    showMarketMatches: function showMarketMatches(mrkt) {
      var isRB = mrkt == this.market.inPlayMarket.key ? true : false;
      this.$emit('updateMethod', isRB);
    },
    getTop: function getTop() {
      var topVal = this.selectedMarket == this.$store.getters.market.tdyMarket.key && (this.$store.getters.selectedBettype.betTypId != 5 || !this.isParlayTab) ? '35.5' : '85.5';
      if (this.selectedMarket == this.$store.getters.market.hotSportMarket.key && this.$store.getters.showFavEvents) {
        topVal = '35.5';
      }
      return 'top:' + topVal + 'px';
    }
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_2__events_event_bus__["a" /* default */].$off("updateMethod");
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allBet_more_bet__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__allBet_more_bet_other_sport__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__todayHeader__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__simpleSoccer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vue_mixins_favourite__ = __webpack_require__(17);


















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__vue_mixins_favourite__["a" /* default */]],
  components: {
    moreBetComponent: __WEBPACK_IMPORTED_MODULE_7__allBet_more_bet__["a" /* default */],
    moreBetComponent_os: __WEBPACK_IMPORTED_MODULE_8__allBet_more_bet_other_sport__["a" /* default */],
    soccerAllCommon: __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__["a" /* default */],
    sportTime: __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__["a" /* default */],
    todayHeader: __WEBPACK_IMPORTED_MODULE_9__todayHeader__["a" /* default */],
    simpleSoccer: __WEBPACK_IMPORTED_MODULE_10__simpleSoccer__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'sortedEventList', 'sportList', 'sortedFavRbEventList', 'market', 'selectedShow', 'selectedMarket', 'selectedBettype', 'selectedAllBetNew', 'selectedMatchAllBet', 'moreBetLoading', 'tvIconFlag', 'favouriteLgeEvents', 'showFavEvents', 'show_Unfold', 'unfold_AllSc', 'frameWidthHeight', 'livetv', 'firstEvent', 'account', 'showRBLgeEve', 'showLgeEve', 'isParlayTab', 'isGameBannerSelected', 'simpleSport']), {
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid: {
      get: function get() {
        var ft = this.$store.getters.firstEvent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ft).length > 0 ? ft.eveid : 0;
      }
    },
    widthColumn: {
      get: function get() {
        var fm = this.$store.getters.frameWidthHeight;
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount = fm.leagueTeam.columnCountBet;
        var columnCountBetShow = fm.leagueTeam.columnCountBetShow;
        var sprt = this.$store.getters.selectedBettype.sprtId;
        var tmp = this.$store.getters.selectedBettype.tmpltId;
        var hideCol = 0;

        if (!_.isUndefined(this.$store.getters.unfold_AllSc[sprt]) && !_.isUndefined(this.$store.getters.unfold_AllSc[sprt][tmp]) && this.$store.getters.unfold_AllSc[sprt][tmp]) {
          if (pageCenter <= 1370) {
            columnCountBetShow -= 1;
            hideCol += 1;
          }
          if (pageCenter < 1280) {
            columnCountBetShow -= 1;
            hideCol += 1;
          }
          columnCount = columnCountBetShow;
        }
        var AvailableLT = pageCenter - timeColumn - favColumn - betBoxWidthMin * columnCount - leagueBoxWidthMin;
        if (AvailableLT > 0) {
          var TeamCal = AvailableLT * 0.7;
          team = betBoxWidthMin + TeamCal / columnCount;
          team = Math.floor(team);
          if (team < betBoxWidthMin) {
            team = betBoxWidthMin;
          } else if (team > betBoxWidthMax) {
            team = betBoxWidthMax;
          }
          var caladd = team - betBoxWidthMin;
          if (caladd > 0) {
            AvailableLT = AvailableLT - (team - betBoxWidthMin) * columnCount;
            if (AvailableLT > 0) {
              league = AvailableLT + leagueBoxWidthMin;
            }
          } else {
            league = AvailableLT + leagueBoxWidthMin;
          }
        } else {
          league = AvailableLT + leagueBoxWidthMin;
        }
        league = league - 15;
        var league2 = league + timeColumn;
        return [league, team, league2, hideCol];
      }
    },
    sortedRBEventList: function sortedRBEventList() {
      return this.$store.getters.sortedRBEventList;
    },
    drawEventList: {
      get: function get() {
        var vue = this;
        var sEve = '';
        var countx = 0;
        var lgeArr = _.cloneDeep(this.$store.getters.showLgeEve);

        var eveArr = _.cloneDeep(this.$store.getters.sortedEventList);
        sEve = eveArr;

        this.$store.commit('SHOW_LGEEVE', lgeArr);

        return sEve;
      },
      set: function set(value) {
        alert('val : ' + value);
      }
    }
  }),
  data: function data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,

      moreBetEveId: null,
      showhideAll: true,
      showRBhideAll: true,
      reloadingPer: '0 %',
      showLimit: 6,
      isUnfold: false,
      subMatchKeyCap: {
        0: 'a',
        1: 'b',
        2: 'c',
        3: 'd'
      }
    };
  },

  watch: {
    unfold_AllSc: {
      handler: function handler(val, oldVal) {
        this.checkUnfold();
      },
      deep: true
    }
  },
  beforeMount: function beforeMount() {
    this.checkUnfold();
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$on('moreBetLoading', function (params) {
      _this.reloadingPer = '75 %';
    }.bind(this));
  },

  methods: {
    checkClass: function checkClass(LgeEve, eventObjKey) {
      var match = '';
      var leagues = '';
      if (!_.isUndefined(LgeEve) && LgeEve != null) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(LgeEve).length > 0) {
          if (!_.isUndefined(LgeEve[eventObjKey])) {
            if (!_.isUndefined(LgeEve[eventObjKey].hide)) {
              match = !LgeEve[eventObjKey].hide ? 'match-tpl0' : '';
              leagues = LgeEve[eventObjKey].hide ? 'leagues-pack' : '';
            }
          }
        }
      }

      return match + ' ' + leagues;
    },
    getSMKey: function getSMKey(smKey) {
      var smKeyId = '';
      if (smKey == 0 || smKey == 'a') {
        smKeyId = 'a';
      } else if (smKey == 1 || smKey == 'b') {
        smKeyId = 'b';
      } else if (smKey == 2 || smKey == 'c') {
        smKeyId = 'c';
      } else {
        smKeyId = 'd';
      }
      return smKeyId;
    },
    checkUnfold: function checkUnfold() {
      var sprt = this.selectedBettype.sprtId;
      var tmp = this.selectedBettype.tmpltId;
      if (!_.isUndefined(this.unfold_AllSc[sprt]) && !_.isUndefined(this.unfold_AllSc[sprt][tmp])) {
        this.isUnfold = this.unfold_AllSc[sprt][tmp];
      }
    },
    getTop: function getTop() {
      var topVal = this.selectedMarket == this.$store.getters.market.tdyMarket.key && (this.$store.getters.selectedBettype.betTypId != 5 || !this.isParlayTab) ? '73.5' : '157.5';
      if (this.isGameBannerSelected && this.selectedMarket == this.$store.getters.market.earlyMarket.key) {
        topVal = '37.5';
      }

      return 'top:' + topVal + 'px';
    },
    showMarketMatches: function showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll;
      } else {
        this.showhideAll = !this.showhideAll;
      }
    },
    showhideMain: function showhideMain(isRB) {
      var key = '';
      if (!isRB) {
        this.showhideAll = this.showhideAll ? false : true;
        for (key in this.sortedEventList) {
          this.$set(this.sortedEventList[key], 'hide', !this.showhideAll);
        }
      }
      if (this.showFavEvents && isRB) {
        this.showRBhideAll = this.showRBhideAll ? false : true;
      }
    },
    showLeg: function showLeg(key, isRB, sport) {
      if (!isRB) {
        this.$set(this.showLgeEve[sport][key], 'hide', !this.showLgeEve[sport][key].hide);
      } else if (isRB) {
        this.$set(this.showRBLgeEve[sport][key], 'hide', !this.showRBLgeEve[sport][key].hide);
      }
    },
    getBetCaption: function getBetCaption(bt) {
      return this.sportAllBetLang['ALL_BET.SUBHEADER_FT_' + bt];
    },
    countAllBet: function countAllBet(event, selectedShow) {
      var countCv = event.all;
      if (event.od) {
        $.each(event.od, function (plyTypes, drawBt) {
          if (selectedShow == 3 && plyTypes == 2) {} else if (selectedShow == 4 && plyTypes == 1) {} else {
            $.each(drawBt, function (bidx, drawDual) {
              if (bidx == 1 || bidx == 2 || bidx == 8 || bidx == 9) {
                $.each(drawDual, function (dd, val) {
                  --countCv;
                });
              } else if (bidx == 4 || bidx == 11) {
                if (selectedShow == 2) {
                  --countCv;
                }
              }
            });
          }
        });
      }
      return countCv;
    },
    enterMatch: function enterMatch(event) {
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        token: token.arr_8
      });
    },
    getSportLang: function getSportLang(sportID) {
      var vue = this;
      var capt = '';
      _.forEach(vue.sportList, function (sportdata, key) {
        if (sportID == sportdata.sprtId) {
          capt = sportdata.sprtLang.replace("<br/>", "");
        }
      });

      return capt;
    },
    showSport: function showSport(sportKey, marketKey) {
      if (marketKey == this.$store.getters.market.inPlayMarket.key) {
        this.$set(this.showRBLgeEve[sportKey], 'hide', !this.showRBLgeEve[sportKey].hide);
      } else if (marketKey == this.$store.getters.market.tdyMarket.key) {
        this.$set(this.showLgeEve[sportKey], 'hide', !this.showLgeEve[sportKey].hide);
      }
    },
    enterAllBet: function enterAllBet(event, startTv) {
      var isRB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.$store.commit('SHOW_UNFOLD', true);
      this.$store.commit('SHOW_FOLD', false);
      this.$store.commit('UNFOLD_ALLSC', false);
      if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv = 1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: event.rbstatus == 1 ? true : false,

        token: token.arr_8,
        loadTemplate: startTv });
      if (startTv == 1) {
        this.$store.commit('RIGHT_BOARD_CHG', event);
      }
    },
    backtoTop: function backtoTop() {
      $(".sport-table-scroll").animate({ scrollTop: 0 }, 100);
    },
    chkMoreBetExist: function chkMoreBetExist(event) {
      var vue = this;
      var exist = false;

      _.forEach(event.od, function (ptydata, key) {
        _.forEach(ptydata, function (val, k) {
          if ($.inArray(k, vue.moreBetTab) > -1) {
            exist = true;
          }
        });
      });

      return exist;
    }
  },
  updated: function updated() {
    $('.ellipsis').bind('mouseenter', function () {
      var $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SHOW_RBLGEEVE', []);
    this.$store.commit('SHOW_LGEEVE', {});
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$off('moreBetLoading');
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_more_bet_other_sport_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43fa9042_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_more_bet_other_sport_vue__ = __webpack_require__(454);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_more_bet_other_sport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43fa9042_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_more_bet_other_sport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__more_bet_header__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__moreBet_eg__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_allBet__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_allBet__["a" /* default */]],
  components: {
    mbHeader: __WEBPACK_IMPORTED_MODULE_5__more_bet_header__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_6__sportTeamColumn__["a" /* default */],
    moreEG: __WEBPACK_IMPORTED_MODULE_7__moreBet_eg__["a" /* default */]
  },
  props: {
    event: null,
    isUnfold: false
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['eventAllBet', 'selectedShow', 'selectedBettype', 'moreBetLoading', 'moreBetToggle', 'myMarketList', 'firstEvent', 'simpleSport', 'hotSchedule']), {
    filteredMainMarketList: function filteredMainMarketList() {
      var vue = this;
      var eventAllBet = _.cloneDeep(this.event);
      if (vue.selectedMarket) {
        _.forEach(vue.plyTypes, function (plytyp) {
          if (eventAllBet.od[plytyp]) eventAllBet.od[plytyp] = _.pick(eventAllBet.od[plytyp], vue.mBetTab[vue.selectedMarket].value);
        });
      }
      return eventAllBet;
    },

    sortedMatchEventList: {
      get: function get() {
        this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList);
        return this.$store.getters.sortedMatchEventList;
      },
      set: function set(value) {}
    }
  }),
  updated: function updated() {},
  data: function data() {
    return {
      lang: window.lang,
      plyTypes: [__WEBPACK_IMPORTED_MODULE_8__mixins_allBet__["a" /* default */].data().ftPlyType, __WEBPACK_IMPORTED_MODULE_8__mixins_allBet__["a" /* default */].data().firstHtPlyType, __WEBPACK_IMPORTED_MODULE_8__mixins_allBet__["a" /* default */].data().SecondHtPlyType],
      sportTabs: {
        N2: ['EG'] },
      mBetTab: {
        EG: {
          key: 'EG',
          value: [__WEBPACK_IMPORTED_MODULE_8__mixins_allBet__["a" /* default */].data().edgBetType],
          flag: true
        }
      },
      mainMarketList: null,
      showMyMarkets: false,
      showMainMarkets: true,
      allBetRefreshTimer: 90,
      allBetTimerId: null,
      selectedMarket: null,
      token: window.token,
      isRB: false,
      showMoreBet: false,
      show: true,
      childHeight: 0,
      clickMoreBet: false,
      moreBetmatchesHeight: 0,
      xParent1: 0,
      xParent2: 0
    };
  },

  methods: {
    checkAnyExist: function checkAnyExist(event) {
      var vue = this;
      var exist = false;
      var tabArray = [];
      if (vue.hotSchedule == true) {
        tabArray = vue.sportTabs['N2'];
      } else {
        tabArray = vue.sportTabs[vue.selectedBettype.sprtId];
      }
      var btArray = [];

      _.forEach(tabArray, function (tab) {
        if (vue.mBetTab[tab]) {
          btArray = btArray.concat(vue.mBetTab[tab].value);
        }
      });

      if (!_.isNull(btArray)) {
        _.forEach(event.od, function (data, key) {
          _.forEach(data, function (val, k) {
            if ($.inArray(k, btArray) > -1) {
              exist = true;
            }
          });
        });
      }

      this.show = exist ? true : false;
      return exist;
    },
    checkMBTexist: function checkMBTexist(event, btKey) {
      var vue = this;
      var exist = false;
      var btArray = vue.mBetTab[btKey].value;

      _.forEach(event.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(k, btArray) > -1) {
            exist = true;
          }
        });
      });

      return exist;
    },
    setTabActive: function setTabActive(event) {
      var vue = this;
      var existCs = 0;

      var sport = this.$store.getters.sportIdArr[event.sptid];
      _.forEach(event.od, function (data, key) {
        _.forEach(data, function (val, k) {
          _.forEach(vue.sportTabs[sport], function (tabkey) {
            if ($.inArray(k, vue.mBetTab[tabkey].value) > -1) {
              if (vue.selectedMarket != vue.mBetTab[tabkey].key) vue.selectedMarket = vue.mBetTab[tabkey].key;
              existCs = 1;
              return false;
            }
          });
        });
      });

      return existCs;
    },
    openMoreBetForm: function openMoreBetForm(event, clickFrom) {
      var _this = this;

      var vue = this;
      var expanded = $('#moreBet' + event.eveid).hasClass('active');
      var mbetHeader = 0;

      var sport = this.$store.getters.sportIdArr[event.sptid];
      _.forEach(vue.sportTabs[sport], function (tabkey) {
        if ($('.' + tabkey + 'tab-' + event.eveid).hasClass('active')) {
          vue.selectedMarket = vue.mBetTab[tabkey].key;
          return false;
        }
      });

      if (expanded) {
        this.$store.dispatch('getSportAllBet', {
          event: event,
          token: token.arr_8,
          callback: function (res) {
            _this.showMoreBet = true;
            _this.clickMoreBet = true;

            _this.$nextTick(function () {
              if (_this.showMoreBet && _this.clickMoreBet) {
                _this.xParent1 = _this.$parent.$refs['eCardWrap' + _this.event.eveid] && _this.$parent.$refs['eCardWrap' + _this.event.eveid].length > 0 ? _this.$parent.$refs['eCardWrap' + _this.event.eveid][0].offsetHeight : _this.$parent.$refs['eCardWrap' + _this.event.eveid].offsetHeight;
                _this.xParent2 = _this.$parent.$refs['eCard' + _this.event.eveid] && _this.$parent.$refs['eCard' + _this.event.eveid].length > 0 ? _this.$parent.$refs['eCard' + _this.event.eveid][0].offsetHeight : _this.$parent.$refs['eCard' + _this.event.eveid].offsetHeight;
                _this.childHeight = _this.$refs['moreBetmatches' + _this.event.eveid].offsetHeight + mbetHeader;
                var p1 = _this.xParent1 + _this.childHeight;
                var p2 = _this.xParent2 + _this.childHeight;
                document.getElementById('eCardWrap' + _this.event.eveid).style.height = p1 + "px";
                document.getElementById('eCard' + _this.event.eveid).style.height = p2 + "px";
                _this.clickMoreBet = false;
              }
            });
          }.bind(this)
        });
      } else {
        if (clickFrom == 'arrow') {
          this.showMoreBet = false;
        }
        if (this.showMoreBet && !this.clickMoreBet) {
          this.$nextTick(function () {
            var p1 = $('#eCard' + _this.event.eveid).children().height() + 6;
            var p2 = $('#eCard' + _this.event.eveid).children().height() + 3;

            document.getElementById('eCardWrap' + _this.event.eveid).style.height = p1 + "px";
            document.getElementById('eCard' + _this.event.eveid).style.height = p2 + "px";
          });
        } else if (!this.showMoreBet && !this.clickMoreBet) {
          var xParent1 = this.$parent.$refs['eCardWrap' + this.event.eveid] && this.$parent.$refs['eCardWrap' + this.event.eveid].length > 0 ? this.$parent.$refs['eCardWrap' + this.event.eveid][0].offsetHeight : this.$parent.$refs['eCardWrap' + this.event.eveid].offsetHeight;
          var xParent2 = this.$parent.$refs['eCard' + this.event.eveid] && this.$parent.$refs['eCard' + this.event.eveid].length > 0 ? this.$parent.$refs['eCard' + this.event.eveid][0].offsetHeight : this.$parent.$refs['eCard' + this.event.eveid].offsetHeight;
          var childHeight = this.$refs['moreBetmatches' + this.event.eveid].offsetHeight + mbetHeader;
          var p1 = xParent1 - childHeight;
          var p2 = xParent2 - childHeight;
          document.getElementById('eCardWrap' + this.event.eveid).style.height = p1 + "px";
          document.getElementById('eCard' + this.event.eveid).style.height = p2 + "px";
          this.clickMoreBet = false;
        }
      }
    },
    backToTop: function backToTop() {
      document.getElementById("more_div").scrollTop = "0";
    },
    updateFavCookie: function updateFavCookie(plytyp, bettyp, isDelete) {
      var isSpecial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var favCookie = {};
      if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_fav')) {
        favCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_fav'));
        if (!isSpecial) {
          if (!favCookie[plytyp]) favCookie[plytyp] = {};
          favCookie[plytyp][bettyp] = {};
          if (isDelete) {
            _.unset(favCookie[plytyp], [bettyp]);
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie[plytyp]).length == 0) {
              _.unset(favCookie, [plytyp]);
            }
          }
        } else {
          if (!favCookie.sp) favCookie.sp = {};
          if (!favCookie.sp[isSpecial.eveid]) favCookie.sp[isSpecial.eveid] = {};
          if (!favCookie.sp[isSpecial.eveid][plytyp]) favCookie.sp[isSpecial.eveid][plytyp] = {};
          favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {};
          if (isDelete) {
            _.unset(favCookie.sp[isSpecial.eveid][plytyp], [bettyp]);
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[isSpecial.eveid][plytyp]).length == 0) {
              _.unset(favCookie.sp[isSpecial.eveid], [plytyp]);
            }
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[isSpecial.eveid]).length == 0) {
              _.unset(favCookie.sp, isSpecial.eveid);
            }
          }
        }
      } else {
        if (!isSpecial) {
          favCookie[plytyp] = {};
          favCookie[plytyp][bettyp] = {};
        } else {
          favCookie.sp = {};
          favCookie.sp[isSpecial.eveid] = {};
          favCookie.sp[isSpecial.eveid][plytyp] = {};
          favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {};
        }
      }
      __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set(window.compcode + '_fav', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(favCookie));
    },
    getFavCookieMarket: function getFavCookieMarket() {
      var favCookie = {};
      if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_fav')) {
        favCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_fav'));
        for (var plytyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie).length - 1; plytyp >= 0; plytyp--) {
          var pt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie)[plytyp];
          if (pt != 'sp') {
            for (var bettyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie[pt]).length - 1; bettyp >= 0; bettyp--) {
              var bt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie[pt])[bettyp];
              if (this.$store.getters.eventAllBet.od[pt]) {
                if (this.$store.getters.eventAllBet.od[pt][bt]) {
                  this.pickMarket(this.$store.getters.eventAllBet, pt, bt);
                }
              }
            }
          } else {
            for (var eve = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp).length - 1; eve >= 0; eve--) {
              var eveid = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp)[eve];
              for (var plytyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid]).length - 1; plytyp >= 0; plytyp--) {
                var pt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid])[plytyp];
                for (var bettyp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid][pt]).length - 1; bettyp >= 0; bettyp--) {
                  var bt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid][pt])[bettyp];
                  var bt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(favCookie.sp[eveid][pt])[bettyp]['a'];
                  if (this.$store.getters.eventAllBet.sp && this.$store.getters.eventAllBet.sp[eveid]) {
                    if (this.$store.getters.eventAllBet.sp[eveid].od[pt]) {
                      if (this.$store.getters.eventAllBet.sp[eveid].od[pt][bt]) {
                        this.pickMarket(this.$store.getters.eventAllBet.sp[eveid], pt, bt, true);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return {};
    },
    pickMarket: function pickMarket(market, plytyp, bettyp) {
      var isSpecial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (this.myMarketList) {
        if (!isSpecial) {
          if (!this.myMarketList.od[plytyp]) {
            this.$set(this.myMarketList.od, plytyp, {});
          }
          this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp]);
        } else {
          !this.myMarketList.sp ? this.$set(this.myMarketList, 'sp', {}) : this.myMarketList.sp;
          !this.myMarketList.sp[market.eveid] ? this.$set(this.myMarketList.sp, market.eveid, {}) : this.myMarketList.sp[market.eveid];

          var copyMarket = _.cloneDeep(market);
          _.unset(copyMarket, 'od');
          _.assign(this.myMarketList.sp[market.eveid], copyMarket);

          !this.myMarketList.sp[market.eveid].od ? this.$set(this.myMarketList.sp[market.eveid], 'od', {}) : this.myMarketList.sp[market.eveid].od;
          !this.myMarketList.sp[market.eveid].od[plytyp] ? this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {}) : this.myMarketList.sp[market.eveid].od[plytyp];
          this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp]);
        }
      } else {
        this.myMarketList = _.cloneDeep(this.$store.getters.eventAllBet);
        this.$set(this.myMarketList, 'od', {});
        this.$set(this.myMarketList, 'sp', {});
        if (!isSpecial) {
          this.$set(this.myMarketList.od, plytyp, {});
          this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp]);
        } else {
          this.$set(this.myMarketList.sp, market.eveid, _.cloneDeep(market));
          this.$set(this.myMarketList.sp[market.eveid], 'od', {});
          this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {});
          this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp]);
        }
        this.showMyMarkets = true;
      }
      !isSpecial ? this.updateFavCookie(plytyp, bettyp, false) : this.updateFavCookie(plytyp, bettyp, false, market);
      !isSpecial ? this.$delete(this.mainMarketList.od[plytyp], bettyp) : this.$delete(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp);
    },
    chooseMarketType: function chooseMarketType(market, event, tab) {

      if (market.flag) {
        this.selectedMarket = market.key;
      }
      this.switchAllBetTab(tab, event);
      this.openMoreBetForm(event, tab);
    },
    switchAllBetTab: function switchAllBetTab(tab, event) {
      var vue = this;
      var splitId = tab.split('-').pop();

      var sport = this.$store.getters.sportIdArr[event.sptid];
      _.forEach(vue.sportTabs[sport], function (tabkey) {
        $('.' + tabkey + 'tab-' + splitId).removeClass('active');
      });

      $(tab).addClass('active');
    },
    widthColumn: function widthColumn(leagueBox, column) {
      var widthColumn = 0;
      var fm = this.$store.getters.frameWidthHeight;
      var pageCenter = fm.width.CenterPage_current;
      var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
      var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
      var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
      var league = leagueBoxWidthMin;
      var team = betBoxWidthMin;
      var timeColumn = fm.leagueTeam.timeColumn;
      var favColumn = fm.leagueTeam.favColumn;
      var columnCount = fm.leagueTeam.columnCountBet;
      var columnCountBetShow = fm.leagueTeam.columnCountBetShow;
      var sprt = this.$store.getters.selectedBettype.sprtId;
      var tmp = this.$store.getters.selectedBettype.tmpltId;
      var hideCol = 0;
      var extraWidth = 15;

      var AvailableLT = pageCenter - timeColumn - favColumn - (leagueBox ? leagueBoxWidthMin : 0) - extraWidth;
      if (AvailableLT > 0) {
        widthColumn = AvailableLT / column;
      }
      return widthColumn;
    }
  },
  mounted: function mounted() {},
  beforeMount: function beforeMount() {
    this.allBetRefreshTimer = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 90;
    this.selectedMarket = this.sportTabs[this.selectedBettype.sprtId] ? this.sportTabs[this.selectedBettype.sprtId][0] : null;
    this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList);
    this.getFavCookieMarket();
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */]],
  props: {
    event: null,

    widthColumn: null,
    isUnfold: false
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sportAllBetLang'])),
  data: function data() {
    return {
      btypes: [__WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().edgBetType],

      bettype: __WEBPACK_IMPORTED_MODULE_2__mixins_allBet__["a" /* default */].data().edgBetType
    };
  },

  methods: {
    getCount: function getCount(row, col, type) {
      var total = (col - 1) * 20 + row - 1;
      var xCount = Math.floor(total / 10);
      var yCount = total % 10;
      var result = xCount;
      switch (type) {
        case 'x':
          result = xCount;
          break;
        case 'y':
          result = xCount;
          break;
        case '-':
          result = xCount + ' - ' + yCount;
          break;
        default:
          result = '' + type + xCount + yCount;
          break;
      }
      return result;
    },
    moreBtnHandle: function moreBtnHandle(eveid) {
      var oriMoreBetHeight = this.$parent.$refs['moreBetmatches' + eveid].offsetHeight;
      if ($('#cmatch' + eveid + ' .box_innbet_btn').hasClass('open')) {
        $('#cmatch' + eveid + ' .box_innbet_btn').removeClass('open');
        $('body .yb-match-list .c-match-item #cmatch' + eveid + '.c-match-handicap.morebeteg .handicap-col .bet-item-wrap:nth-of-type(n+6)').css('display', 'none');
      } else {
        $('#cmatch' + eveid + ' .box_innbet_btn').addClass('open');
        $('body .yb-match-list .c-match-item #cmatch' + eveid + '.c-match-handicap.morebeteg .handicap-col .bet-item-wrap:nth-of-type(n+6)').css('display', 'block');
      }
      var afterMoreBetHeight = this.$parent.$refs['moreBetmatches' + eveid].offsetHeight;
      var offset = afterMoreBetHeight - oriMoreBetHeight;
      var xParent1 = this.$parent.$parent.$refs['eCardWrap' + eveid];
      var xParent2 = this.$parent.$parent.$refs['eCard' + eveid];
      var xParent1Height = xParent1 && xParent1.length > 0 ? xParent1[0].offsetHeight : xParent1.offsetHeight;
      var xParent2Height = xParent2 && xParent2.length > 0 ? xParent2[0].offsetHeight : xParent2.offsetHeight;
      var p1 = xParent1Height + offset;
      var p2 = xParent2Height + offset;
      document.getElementById('eCardWrap' + eveid).style.height = p1 + "px";
      document.getElementById('eCard' + eveid).style.height = p2 + "px";
    }
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cs_tg_ftht__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__todayHeader__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_mixins_favourite__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__ = __webpack_require__(4);
















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__vue_mixins_favourite__["a" /* default */]],
  components: {
    sportTime: __WEBPACK_IMPORTED_MODULE_5__sportTimeColumn__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_6__sportTeamColumn__["a" /* default */],
    todayHeader: __WEBPACK_IMPORTED_MODULE_7__todayHeader__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sortedEventList', 'sortedRBEventList', 'selectedBettype', 'selectedMarket', 'int_fullHalfTime', 'favouriteLgeEvents', 'market', 'frameWidthHeight', 'livetv', 'firstEvent', 'account', 'showRBLgeEve', 'showLgeEve', 'tvIconFlag']), {
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid: {
      get: function get() {
        var ft = this.$store.getters.firstEvent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ft).length > 0 ? ft.eveid : 0;
      }
    },
    widthColumn: {
      get: function get() {
        var fm = this.$store.getters.frameWidthHeight;
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount = 6;
        var AvailableLT = pageCenter - timeColumn - favColumn - betBoxWidthMin * columnCount - leagueBoxWidthMin;
        if (AvailableLT > 0) {
          var TeamCal = AvailableLT * 0.7;
          team = betBoxWidthMin + TeamCal / columnCount;
          team = Math.floor(team);
          if (team < betBoxWidthMin) {
            team = betBoxWidthMin;
          } else if (team > betBoxWidthMax) {
            team = betBoxWidthMax;
          }
          var caladd = team - betBoxWidthMin;
          if (caladd > 0) {
            AvailableLT = AvailableLT - (team - betBoxWidthMin) * columnCount;
            if (AvailableLT > 0) {
              league = AvailableLT + leagueBoxWidthMin;
            }
          } else {
            league = AvailableLT + leagueBoxWidthMin;
          }
        } else {
          league = AvailableLT + leagueBoxWidthMin;
        }
        league = league - 15;
        return [league, team, league + timeColumn];
      }
    }
  }),
  data: function data() {
    return {
      reloading: false,
      btype: this.$store.getters.selectedMarket == '3' ? __WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__["a" /* default */].data().rcsBetType : __WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__["a" /* default */].data().csBetType,
      rbbtype: __WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__["a" /* default */].data().rcsBetType,
      lang: window.lang,
      showhideAll: true,
      showRBhideAll: true,
      fthtptype: [__WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__["a" /* default */].data().ftPlyType, __WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__["a" /* default */].data().firstHtPlyType],
      itemsRow: [['od10', 'od20', 'od21', 'od30', 'od31', 'od32', 'od40', 'od41', 'od42', 'od43', 'aos'], ['od00', 'od11', 'od22', 'od33', 'od44', 'odempty', 'odempty', 'odempty', 'odempty', 'odempty', 'odlast'], ['od01', 'od02', 'od12', 'od03', 'od13', 'od23', 'od04', 'od14', 'od24', 'od34', 'odlast']],
      htExclude: ['od40', 'od41', 'od42', 'od43', 'od44', 'od04', 'od14', 'od24', 'od34']
    };
  },

  mounted: function mounted() {},
  methods: {
    enterAllBet: function enterAllBet(event, startTv) {
      if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv = 1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: event.rbstatus == 1 ? true : false,
        token: token.arr_8,
        loadTemplate: startTv });
    },
    showMarketMatches: function showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll;
      } else {
        this.showhideAll = !this.showhideAll;
      }
    },
    excludeHT: function excludeHT(oddcapt, ptype) {
      var r = false;
      if (oddcapt != 'aos' && oddcapt != 'odempty' && oddcapt != 'odlast') {
        r = true;
        if (ptype == 2 && jQuery.inArray(oddcapt, this.htExclude) != '-1') {
          r = false;
        }
      }
      return r;
    },
    chkCSOdds: function chkCSOdds(event, oddcapt, ptype, btype) {
      var r = false;
      if (event.od[ptype] && event.od[ptype][btype] && event.od[ptype][btype][oddcapt]) {
        r = true;
      }
      return r;
    },
    getCSLabel: function getCSLabel(od) {
      var capt = this.sportTableLang.template_lang['SPORT_TEMPLATE_2.' + od];
      if (od == 'aos') {
        capt = this.lang.sportAllBet['ALL_BET.LBL_AOS'];
      }

      return capt;
    },
    showhideMain: function showhideMain() {
      this.showhideAll = this.showhideAll ? false : true;
      var key = '';
      for (key in this.sortedEventList) {
        this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide);
      }
    },
    showLeg: function showLeg(key, isRB) {

      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide);
      } else if (isRB && !this.showFavEvents) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide);
      }

      if (this.showFavEvents && isRB) {
        this.$set(this.sortedFavRbEventList[key], 'hide', !this.sortedFavRbEventList[key].hide);
      }
    }
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cs_tg_ftht__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_mixins_favourite__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__todayHeader__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__ = __webpack_require__(4);













/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__vue_mixins_favourite__["a" /* default */]],
  components: {
    sportTime: __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__["a" /* default */],
    todayHeader: __WEBPACK_IMPORTED_MODULE_7__todayHeader__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sortedEventList', 'sortedRBEventList', 'selectedBettype', 'selectedMarket', 'market', 'frameWidthHeight', 'livetv', 'firstEvent', 'account', 'showRBLgeEve', 'showLgeEve', 'tvIconFlag']), {
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid: {
      get: function get() {
        var ft = this.$store.getters.firstEvent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ft).length > 0 ? ft.eveid : 0;
      }
    },
    widthColumn: {
      get: function get() {
        var fm = this.$store.getters.frameWidthHeight;
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = 53;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount = 8;
        var AvailableLT = pageCenter - timeColumn - favColumn - betBoxWidthMin * columnCount - leagueBoxWidthMin;
        if (AvailableLT > 0) {
          var TeamCal = AvailableLT * 0.7;
          team = betBoxWidthMin + TeamCal / columnCount;
          team = Math.floor(team);
          if (team < betBoxWidthMin) {
            team = betBoxWidthMin;
          } else if (team > betBoxWidthMax) {
            team = betBoxWidthMax;
          }
          var caladd = team - betBoxWidthMin;
          if (caladd > 0) {
            AvailableLT = AvailableLT - (team - betBoxWidthMin) * columnCount;
            if (AvailableLT > 0) {
              league = AvailableLT + leagueBoxWidthMin;
            }
          } else {
            league = AvailableLT + leagueBoxWidthMin;
          }
        } else {
          league = AvailableLT + leagueBoxWidthMin;
        }
        league = league - 15;
        return [league, team, league + timeColumn];
      }
    }
  }),
  data: function data() {
    return {
      reloading: false,
      playtype: this.$store.getters.int_fullHalfTime,
      bettype: this.$store.getters.selectedMarket == '3' ? __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().rtgBetType : __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().tgBetType,
      rbbettype: __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().rtgBetType,
      tgBetTitle: {
        '1': ['SPORT_TEMPLATE_3.0-1', 'SPORT_TEMPLATE_3.2-3', 'SPORT_TEMPLATE_3.4-6', 'SPORT_TEMPLATE_3.7_ABOVE'],
        '2': ['SPORT_TEMPLATE_3.0', 'SPORT_TEMPLATE_3.1', 'SPORT_TEMPLATE_3.2', 'SPORT_TEMPLATE_3.3_ABOVE']
      },
      fthtptype: [__WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().ftPlyType, __WEBPACK_IMPORTED_MODULE_8__vue_mixins_allBet__["a" /* default */].data().firstHtPlyType],
      showhideAll: true,
      showRBhideAll: true,
      betBoxWidth: 60,
      betBoxWidthMin: 60,
      betBoxWidthMax: 101,
      leagueBoxWidth: 238,
      leagueBoxWidthMin: 238,
      leagueBoxWidthMax: 320
    };
  },

  mounted: function mounted() {},
  methods: {
    enterAllBet: function enterAllBet(event, startTv) {
      if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv = 1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: event.rbstatus == 1 ? true : false,
        token: token.arr_8,
        loadTemplate: startTv });
    },
    showMarketMatches: function showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll;
      } else {
        this.showhideAll = !this.showhideAll;
      }
    },
    showhideMain: function showhideMain() {
      this.showhideAll = this.showhideAll ? false : true;
      var key = '';
      for (key in this.sortedEventList) {
        this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide);
      }
    },
    showLeg: function showLeg(key, isRB) {

      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide);
      } else if (isRB && !this.showFavEvents) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide);
      }
      if (this.showFavEvents && isRB) {
        this.$set(this.sortedFavRbEventList[key], 'hide', !this.sortedFavRbEventList[key].hide);
      }
    }
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cs_tg_ftht__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__todayHeader__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_mixins_favourite__ = __webpack_require__(17);













/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__vue_mixins_favourite__["a" /* default */]],
  components: {
    sportTime: __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__["a" /* default */],
    todayHeader: __WEBPACK_IMPORTED_MODULE_6__todayHeader__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sortedEventList', 'sortedRBEventList', 'selectedMarket', 'selectedBettype', 'favouriteLgeEvents', 'market', 'frameWidthHeight', 'livetv', 'firstEvent', 'account', 'showRBLgeEve', 'showLgeEve', 'tvIconFlag']), {
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid: {
      get: function get() {
        var ft = this.$store.getters.firstEvent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ft).length > 0 ? ft.eveid : 0;
      }
    },
    widthColumn: {
      get: function get() {
        var fm = this.$store.getters.frameWidthHeight;
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = 53;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount = 9;
        var AvailableLT = pageCenter - timeColumn - favColumn - betBoxWidthMin * columnCount - leagueBoxWidthMin;
        if (AvailableLT > 0) {
          var TeamCal = AvailableLT * 0.7;
          team = betBoxWidthMin + TeamCal / columnCount;
          team = Math.floor(team);
          if (team < betBoxWidthMin) {
            team = betBoxWidthMin;
          } else if (team > betBoxWidthMax) {
            team = betBoxWidthMax;
          }
          var caladd = team - betBoxWidthMin;
          if (caladd > 0) {
            AvailableLT = AvailableLT - (team - betBoxWidthMin) * columnCount;
            if (AvailableLT > 0) {
              league = AvailableLT + leagueBoxWidthMin;
            }
          } else {
            league = AvailableLT + leagueBoxWidthMin;
          }
        } else {
          league = AvailableLT + leagueBoxWidthMin;
        }
        league = league - 15;
        return [league, team, league + timeColumn];
      }
    }
  }),
  data: function data() {
    return {
      reloading: false,
      playtype: '1',
      bettype: this.$store.getters.selectedMarket == '3' ? __WEBPACK_IMPORTED_MODULE_7__vue_mixins_allBet__["a" /* default */].data().rhtftBetType : __WEBPACK_IMPORTED_MODULE_7__vue_mixins_allBet__["a" /* default */].data().htftBetType,
      rbbettype: __WEBPACK_IMPORTED_MODULE_7__vue_mixins_allBet__["a" /* default */].data().rhtftBetType,
      showhideAll: true,
      showRBhideAll: true
    };
  },

  mounted: function mounted() {},
  methods: {
    enterAllBet: function enterAllBet(event, startTv) {
      if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv = 1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: event.rbstatus == 1 ? true : false,
        token: token.arr_8,
        loadTemplate: startTv });
    },
    showMarketMatches: function showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll;
      } else {
        this.showhideAll = !this.showhideAll;
      }
    },
    showhideMain: function showhideMain() {
      this.showhideAll = this.showhideAll ? false : true;
      var key = '';
      for (key in this.sortedEventList) {
        this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide);
      }
    },
    showLeg: function showLeg(key, isRB) {

      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide);
      } else if (isRB && !this.showFavEvents) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide);
      }
      if (this.showFavEvents && isRB) {
        this.$set(this.sortedFavRbEventList[key], 'hide', !this.sortedFavRbEventList[key].hide);
      }
    }
  },
  destroyed: function destroyed() {}
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__otherSportAllCommon2__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__allBet_more_bet_other_sport__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__todayHeader__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vue_mixins_favourite__ = __webpack_require__(17);

















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__vue_mixins_favourite__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__vue_mixins_allBet__["a" /* default */]],
  data: function data() {
    return {
      plytyp: null,
      lang: window.lang,
      showhideAll: true,
      showRBhideAll: true,
      moreBetEveId: null,
      os1x2: '19'
    };
  },

  components: {
    sportTime: __WEBPACK_IMPORTED_MODULE_7__sportTimeColumn__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_6__sportTeamColumn__["a" /* default */],
    otherSportAllCommon2: __WEBPACK_IMPORTED_MODULE_4__otherSportAllCommon2__["a" /* default */],
    moreBetComponent: __WEBPACK_IMPORTED_MODULE_5__allBet_more_bet_other_sport__["a" /* default */],
    todayHeader: __WEBPACK_IMPORTED_MODULE_8__todayHeader__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sortedEventList', 'sortedRBEventList', 'sortedFavRbEventList', 'sortedMatchEventList', 'selectedMarket', 'selectedBettype', 'selectedMatchAllBet', 'selectedAllBetNew', 'moreBetLoading', 'favouriteLgeEvents', 'market', 'livetv', 'firstEvent', 'account', 'showFavEvents', 'showRBLgeEve', 'showLgeEve', 'isParlayTab', 'tvIconFlag']), {
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid: {
      get: function get() {
        var ft = this.$store.getters.firstEvent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ft).length > 0 ? ft.eveid : 0;
      }
    }

  }),
  methods: {
    chkOddCaption: function chkOddCaption(event, subMatchKey, bettype) {
      var res = false;
      var sm = '';
      if (subMatchKey == 0) {
        sm = 'a';
      } else if (subMatchKey == 1) {
        sm = 'b';
      } else if (subMatchKey == 2) {
        sm = 'c';
      } else if (subMatchKey == 3) {
        sm = 'd';
      }
      if (event.od[this.getFullTime(event['od'])] && event.od[this.getFullTime(event['od'])][bettype] && event.od[this.getFullTime(event['od'])][bettype][sm]) {
        res = true;
      }
      return res;
    },
    showMarketMatches: function showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll;
      } else {
        this.showhideAll = !this.showhideAll;
      }
    },
    getTop: function getTop() {
      var topVal = this.selectedMarket == this.$store.getters.market.tdyMarket.key && (this.$store.getters.selectedBettype.betTypId != 5 || !this.isParlayTab) ? '73.5' : '89.5';

      return 'top:' + topVal + 'px';
    },
    showhideMain: function showhideMain(isRB) {
      var key = '';
      if (!isRB) {
        this.showhideAll = this.showhideAll ? false : true;
        for (key in this.sortedEventList) {
          this.$set(this.sortedEventList[key], 'hide', !showhideAll);
        }
      }
      if (this.showFavEvents && isRB) {
        this.showRBhideAll = this.showRBhideAll ? false : true;
        if (this.showFavEvents) {
          for (key in this.sortedFavRbEventList) {
            this.$set(this.sortedFavRbEventList[key], 'hide', !showRBhideAll);
          }
        }
      }
    },
    getBetCaption: function getBetCaption(bt) {
      return this.sportTableLang.template_lang['SPORT_TEMPLATE_' + this.selectedBettype.tmpltId + '.' + bt];
    },
    showLeg: function showLeg(key, isRB) {
      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide);
      } else if (isRB) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide);
      }
    },
    openAllBetForm: function openAllBetForm(event) {
      this.$store.dispatch('getSportAllBet', { event: event });
    },
    countAllBet: function countAllBet(event) {
      var countCv = event.all;
      var loop = 0;
      if (event.od) {
        $.each(event.od, function (plyTypes, drawBt) {
          if (loop < 1) {
            $.each(drawBt, function (bidx, drawDual) {
              if (bidx == 1 || bidx == 2 || bidx == 8 || bidx == 9 || bidx == 3 || bidx == 10) {
                $.each(drawDual, function (dd, val) {
                  --countCv;
                });
              } else if (event.sptid == "3" || event.sptid == "12" || event.sptid == "2" || event.sptid == "15" || event.sptid === "21") {
                --countCv;
              }
            });
            loop = 1;
          }
        });
      }
      return countCv;
    },
    openMoreBetForm: function openMoreBetForm(event) {
      $('.moreB').css("display", "none");
      this.$store.commit('SELECTED_ALLBETNEW', false);
      var expanded = $('#moreExpand' + event.eveid).hasClass('icon-moreExpand');
      this.moreBetEveId = event.eveid;
      if (expanded) {
        $('#moreBets' + event.eveid).css("display", "");
        this.$store.commit('MOREBETLOADING', true);
        $('.moreExpd').removeClass('icon-moreCollapse');
        $('.moreExpd').addClass('icon-moreExpand');
        $('#moreExpand' + event.eveid).removeClass('icon-moreExpand');
        $('#moreExpand' + event.eveid).addClass('icon-moreCollapse');
        this.$store.dispatch('getSportAllBet', {
          event: event,
          token: token.arr_8,
          callback: function (res) {}.bind(this)
        });
      } else {
        $('#moreExpand' + event.eveid).addClass('icon-moreExpand');
        $('#moreExpand' + event.eveid).removeClass('icon-moreCollapse');
        $('#moreBets' + event.eveid).css("display", "none");
      }
    },
    isPrior: function isPrior(event, plytyp) {
      if (this.$store.getters.selectedBettype.sprtId == 'G2') {
        return false;
      } else if (event.prior.indexOf(parseInt(plytyp)) >= 0) {
        return true;
      }
      return false;
    },
    enterMatch: function enterMatch(event) {
      this.$store.commit('SELECTED_MATCHALLBET', true);

      this.$store.dispatch('getMatchAllBet', {
        event: event,
        token: token.arr_8
      });
    },
    enterAllBet: function enterAllBet(event, startTv) {
      var isRB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv = 1;
      }
      __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('activeRbScoreBoard');
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: isRB,

        token: token.arr_8,
        loadTemplate: startTv });
    },
    backtoTop: function backtoTop() {
      $(".sport-table-scroll").animate({ scrollTop: 0 }, 100);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$on('sportChange', function (params) {
      _this.checkPlayType();
    }.bind(this));

    this.checkPlayType();
    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
  },
  updated: function updated() {},
  destroyed: function destroyed() {}
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_odd__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_odd1x2__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_handicap__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_over_under__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__allBet_all_bet__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vue_mixins_favourite__ = __webpack_require__(17);























/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_14__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__vue_mixins_favourite__["a" /* default */]],
  components: {
    allBetComponent: __WEBPACK_IMPORTED_MODULE_13__allBet_all_bet__["a" /* default */],
    sportTime: __WEBPACK_IMPORTED_MODULE_11__sportTimeColumn__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_12__sportTeamColumn__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'matchAllBet', 'sortedMatchEventList', 'market', 'selectedShow', 'selectedMarket', 'selectedBettype', 'tvIconFlag', 'selectedAllBetNew', 'foldopenAllBet'])),
  data: function data() {
    return {
      lang: window.lang,
      fT: ['2', '3'],
      hT: ['2', '4'],
      showhideAll: true,
      selectedBetTab: 'hot',
      betTab: {
        hot: {
          key: 'hot',
          value: true,
          flag: true
        },
        hdpou: {
          key: 'hdpou',
          value: [1, 2, 8, 9],
          flag: true
        },
        goals: {
          key: 'goals',
          value: [2, 3, 5, 7, 9, 10],
          flag: true
        },
        cs: {
          key: 'cs',
          value: [7, 16],
          flag: true
        },
        ft: {
          key: 'ft',
          value: [1],
          flag: true
        },
        ht: {
          key: 'ht',
          value: [2],
          flag: true
        },
        others: {
          key: 'others',
          value: true,
          flag: true
        },
        special: {
          key: 'special',
          value: true,
          flag: true
        },
        scrMarket: {
          key: 'scrMarket',
          value: [2, 3, 5, 7, 9, 10],
          flag: true
        },
        sethdp: {
          key: 'set',
          value: [3],
          flag: true
        },
        gamehdp: {
          key: 'game',
          value: [6],
          flag: true
        },
        pointhdp: {
          key: 'point',
          value: [4],
          flag: true
        },
        p2: {
          key: 'p2',
          value: [2],
          flag: true
        },
        p4: {
          key: 'p4',
          value: [4],
          flag: true
        },
        p5: {
          key: 'p5',
          value: [5],
          flag: true
        },
        p6: {
          key: 'p6',
          value: [6],
          flag: true
        },
        p7: {
          key: 'p7',
          value: [7],
          flag: true
        },
        all: {
          key: 'all',
          value: true,
          flag: true
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    foldopenAB: function foldopenAB() {
      this.$store.commit('FOLDOPEN_ALLBET', !this.$store.getters.foldopenAllBet);
    },
    backtoTop: function backtoTop() {
      $('html, body').animate({
        scrollTop: 0
      }, 400);
    },
    showhideMain: function showhideMain() {
      this.showhideAll = this.showhideAll ? false : true;
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide);
    },
    colspanS: function colspanS() {
      return 2;
    },
    getSubMatch: function getSubMatch(sub) {
      return sub + 1;
    },
    showLeg: function showLeg() {
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide);
    },
    chooseBetTab: function chooseBetTab(betTab) {
      if (betTab.flag) {
        this.selectedBetTab = betTab.key;
      }
    },
    switchAllBetTab: function switchAllBetTab(id) {
      $('.moreBetTypeNav-Item').removeClass('active');
      $(id).addClass('active');
    },
    checkOpenMore: function checkOpenMore(event) {
      if (event.sp) {
        return true;
      } else if (event.od) {
        var show = true;
        $.each(event.od, function (plyTypes, drawBt) {
          if (plyTypes !== '1' && plyTypes !== '3') {
            return true;
          } else {
            show = true;
            if (plyTypes == '1' || plyTypes == '2') {
              $.each(drawBt, function (bidx, drawDual) {
                show = true;

                if (bidx == 1 || bidx == 2 || bidx == 4 || bidx == 8 || bidx == 9 || bidx == 11) {
                  show = false;
                }
              });
            }
          }
        });
        return show;
      }
      return false;
    },
    reloadTable: function reloadTable() {
      var _this = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.oddsReload = true;

      __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('templateChange', this.oddsReload);

      var dispatchName = 'getSportOdds';
      if (this.$store.getters.selectedBettype.betTypId == '6') {
        dispatchName = 'getSportOutrightOdds';
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8;
      }

      this.$store.dispatch(dispatchName, {
        token: token_val,
        callback: function (res) {
          if (res.events) {
            _this.timerSeconds = _this.getMarketTimer(_this.$store.getters.selectedMarket);

            _this.reconnectTimerId = null;
            _.forEach(res.events, function (val, key) {
              _.forEach(val, function (v, k) {
                var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse');
                if (showAllBet) {
                  $('#moreExpand' + v.eveid).addClass('icon-moreExpand');
                  $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse');
                  $('#moreBets' + v.eveid).css("display", "none");
                }
              });
            });
          } else {
            _this.reconnectTimerSeconds = 5;
            if (_this.reconnectTimerId == null) {
              _this.reconnectTimerId = setInterval(function () {
                if (_this.reconnectTimerSeconds - 1 < 0) {
                  _this.reloadTable();
                } else {
                  _this.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (_this.showFavEvents) {
            _this.$store.dispatch('getLaugueList', function (res) {
              this.$store.commit('SELECTEDLEAGUES', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
              this.$store.commit('TOTALLEAGUES', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
            }.bind(_this));
          }
          _this.reloading = false;
          _this.oddsReload = false;
          __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('templateChange', _this.oddsReload);
          _this.refreshScroll();

          _this.$store.commit('PARLAY_SELECTED', { update: false });
        }.bind(this)
      });
    },
    backToMain: function backToMain() {
      __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('sportTableReloading', true);
      this.reloadTable();
      this.$store.commit('SELECTED_MATCHALLBET', false);
    },
    refreshTbl: function refreshTbl(token_val) {
      this.reloading = token_val == token.arr_1 || token_val == token.arr_5 ? false : true;
      if (this.selectedMatchAllBet) {
        this.reloadAllBetTable(token_val);
      } else {
        this.reloadTable(token_val);
      }
    },
    reloadAllBetTable: function reloadAllBetTable() {
      var _this2 = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (token_val == '') {
        token_val = token.arr_5;
      }
      this.reloadingPer = '25%';
      this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList);

      this.reloadingPer = '80%';
      this.$store.dispatch('getSportAllBet', {
        token: token_val,
        inAllBet: true,
        event: this.$store.getters.sortedMatchEventList,
        callback: function (res) {
          _this2.timerSeconds = _this2.getMarketTimer(_this2.$store.getters.selectedMarket);

          _this2.startTimer();
          _this2.mainMarketList = _.cloneDeep(_this2.$store.getters.sortedMatchEventList);

          _this2.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('diffOdd', _this2.cloneEventAllBet);
          });
          _this2.reloading = false;
        }.bind(this)
      });
    }
  }, 'reloadTable', function reloadTable() {
    var _this3 = this;

    var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    this.oddsReload = true;
    this.clearTimer();
    __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('templateChange', this.oddsReload);
    this.reloadingPer = '25%';
    var dispatchName = 'getSportOdds';
    if (this.$store.getters.selectedBettype.betTypId == '6') {
      dispatchName = 'getSportOutrightOdds';
    }
    if (token_val == '' || token_val == undefined) {
      token_val = token.arr_8;
    }
    this.reloadingPer = '80%';
    this.$store.dispatch(dispatchName, {
      token: token_val,
      callback: function (res) {
        if (res.events) {
          _this3.timerSeconds = _this3.getMarketTimer(_this3.$store.getters.selectedMarket);

          _this3.startTimer();
          clearInterval(_this3.reconnectTimerId);
          _this3.reconnectTimerId = null;
          _.forEach(res.events, function (val, key) {
            _.forEach(val, function (v, k) {
              var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse');
              if (showAllBet) {
                $('#moreExpand' + v.eveid).addClass('icon-moreExpand');
                $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse');
                $('#moreBets' + v.eveid).css("display", "none");
              }
            });
          });
        } else {
          _this3.reconnectTimerSeconds = 5;
          if (_this3.reconnectTimerId == null) {
            _this3.reconnectTimerId = setInterval(function () {
              if (_this3.reconnectTimerSeconds - 1 < 0) {
                _this3.reloadTable();
              } else {
                _this3.reconnectTimerSeconds -= 1;
              }
            }, 1000);
          }
        }
        if (_this3.showFavEvents) {
          _this3.$store.dispatch('getLaugueList', function (res) {
            this.$store.commit('SELECTEDLEAGUES', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
            this.$store.commit('TOTALLEAGUES', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_leagueList).length);
          }.bind(_this3));
        }
        _this3.reloading = false;
        _this3.oddsReload = false;
        __WEBPACK_IMPORTED_MODULE_4__events_event_bus__["a" /* default */].$emit('templateChange', _this3.oddsReload);
        _this3.refreshScroll();

        _this3.$store.commit('PARLAY_SELECTED', { update: false });
      }.bind(this)
    });
  })

});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_zh_cn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_zh_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_filters_date__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_odd_outright__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_mixins_favourite__ = __webpack_require__(17);











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__vue_mixins_favourite__["a" /* default */]],
  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['eventList', 'sportTableLang', 'selectedBettype', 'favouriteOTREvents', 'sportList', 'otrSportList', 'timeZone', 'showLgeEve']), {
    favouriteOTREventsList: {
      get: function get() {
        return this.$store.getters.favouriteOTREvents;
      }
    },
    showFavEvents: {
      get: function get() {
        return this.$store.getters.showFavEvents;
      }
    }
  }),
  watch: {
    favouriteOTREventsList: {
      handler: function handler(val, oldVal) {},

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      lang: window.lang,
      showhideAll: true,
      moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a,
      selectedLang: window._langid
    };
  },

  methods: {
    matchDateCheck: function matchDateCheck(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss");
    },
    checkValue: function checkValue(value, arr) {
      var status = 'false';

      for (var i = 0; i < arr.length; i++) {
        var name = arr[i];
        if ('N' + name == value) {
          status = 'true';
          break;
        }
      }

      return status;
    },
    showEvent: function showEvent(sptid, eveid, eve) {
      if (this.$store.getters.showFavEvents) {
        return this.otrFavorite(eveid, sptid, eve);
      } else {
        return true;
      }
    },
    getTop: function getTop() {
      var topVal = '73.5';
      return 'top:' + topVal + 'px';
    },
    showLeg: function showLeg(key) {
      this.$set(this.eventList[key], 'hide', !this.eventList[key].hide);
    },
    showSportMatches: function showSportMatches(key) {
      this.$set(this.sportList[key], 'hide', !this.sportList[key].hide);
    },
    getSportLang: function getSportLang(sptId) {
      var vue = this;
      var capt = '';
      _.forEach(vue.sportList, function (sportdata, key) {
        if (sptId == sportdata.sprtId) {
          capt = sportdata.sprtLang;
        }
        return capt;
      });

      return capt;
    },
    backtoTop: function backtoTop() {
      $(".sport-table-scroll").animate({ scrollTop: 0 }, 100);
    }
  },
  updated: function updated() {
    $('#showtable').children().closest('.evecardwrap').each(function () {
      var a = jQuery(this).find(".evecard").height();
      jQuery(this).find(".evecard").height(a);
      jQuery(this).height(a + 5);
    });
  },
  mounted: function mounted() {}
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__allBet_more_bet__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__todayHeader__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__simpleSoccer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_mixins_favourite__ = __webpack_require__(17);

















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__vue_mixins_favourite__["a" /* default */]],
  components: {
    moreBetComponent: __WEBPACK_IMPORTED_MODULE_7__allBet_more_bet__["a" /* default */],
    soccerAllCommon: __WEBPACK_IMPORTED_MODULE_6__soccerAllCommon__["a" /* default */],
    sportTime: __WEBPACK_IMPORTED_MODULE_4__sportTimeColumn__["a" /* default */],
    sportTeam: __WEBPACK_IMPORTED_MODULE_5__sportTeamColumn__["a" /* default */],
    todayHeader: __WEBPACK_IMPORTED_MODULE_8__todayHeader__["a" /* default */],
    simpleSoccer: __WEBPACK_IMPORTED_MODULE_9__simpleSoccer__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportAllBetLang', 'sortedEventList', 'sortedFavRbEventList', 'market', 'selectedShow', 'selectedMarket', 'selectedBettype', 'selectedAllBetNew', 'selectedMatchAllBet', 'moreBetLoading', 'tvIconFlag', 'favouriteLgeEvents', 'showFavEvents', 'show_Unfold', 'unfold_AllSc', 'frameWidthHeight', 'livetv', 'firstEvent', 'account', 'showRBLgeEve', 'showLgeEve', 'isParlayTab', 'isGameBannerSelected', 'simpleSport', 'specialEvent']), {
    livetvEveid: {
      get: function get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid: {
      get: function get() {
        var ft = this.$store.getters.firstEvent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ft).length > 0 ? ft.eveid : 0;
      }
    },
    widthColumn: {
      get: function get() {
        var fm = this.$store.getters.frameWidthHeight;
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount = fm.leagueTeam.columnCountBet;
        var columnCountBetShow = fm.leagueTeam.columnCountBetShow;
        var sprt = this.$store.getters.selectedBettype.sprtId;
        var tmp = this.$store.getters.selectedBettype.tmpltId;
        var hideCol = 0;

        if (!_.isUndefined(this.$store.getters.unfold_AllSc[sprt]) && !_.isUndefined(this.$store.getters.unfold_AllSc[sprt][tmp]) && this.$store.getters.unfold_AllSc[sprt][tmp]) {
          if (pageCenter <= 1370) {
            columnCountBetShow -= 1;
            hideCol += 1;
          }
          if (pageCenter < 1280) {
            columnCountBetShow -= 1;
            hideCol += 1;
          }
          columnCount = columnCountBetShow;
        }
        var AvailableLT = pageCenter - timeColumn - favColumn - betBoxWidthMin * columnCount - leagueBoxWidthMin;
        if (AvailableLT > 0) {
          var TeamCal = AvailableLT * 0.7;
          team = betBoxWidthMin + TeamCal / columnCount;
          team = Math.floor(team);
          if (team < betBoxWidthMin) {
            team = betBoxWidthMin;
          } else if (team > betBoxWidthMax) {
            team = betBoxWidthMax;
          }
          var caladd = team - betBoxWidthMin;
          if (caladd > 0) {
            AvailableLT = AvailableLT - (team - betBoxWidthMin) * columnCount;
            if (AvailableLT > 0) {
              league = AvailableLT + leagueBoxWidthMin;
            }
          } else {
            league = AvailableLT + leagueBoxWidthMin;
          }
        } else {
          league = AvailableLT + leagueBoxWidthMin;
        }
        league = league - 15;
        var league2 = league + timeColumn;
        return [league, team, league2, hideCol];
      }
    },
    sortedRBEventList: function sortedRBEventList() {
      return this.$store.getters.sortedRBEventList;
    }
  }),
  data: function data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,

      moreBetEveId: null,
      showhideAll: true,
      showRBhideAll: true,
      reloadingPer: '0 %',
      showLimit: 6,
      isUnfold: false,
      subMatchKeyCap: {
        0: 'a',
        1: 'b',
        2: 'c',
        3: 'd'
      }
    };
  },

  watch: {
    unfold_AllSc: {
      handler: function handler(val, oldVal) {
        this.checkUnfold();
      },
      deep: true
    }
  },
  beforeMount: function beforeMount() {
    this.checkUnfold();
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$on('moreBetLoading', function (params) {
      _this.reloadingPer = '75 %';
    }.bind(this));
  },

  methods: {
    checkClass: function checkClass(LgeEve, eventObjKey) {
      var match = '';
      var leagues = '';
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(LgeEve).length > 0) {
        if (!_.isUndefined(LgeEve[eventObjKey].hide)) {
          match = !LgeEve[eventObjKey].hide ? 'match-tpl0' : '';
          leagues = LgeEve[eventObjKey].hide ? 'leagues-pack' : '';
        }
      }

      return match + ' ' + leagues;
    },
    getSMKey: function getSMKey(smKey) {
      var smKeyId = '';
      if (smKey == 0 || smKey == 'a') {
        smKeyId = 'a';
      } else if (smKey == 1 || smKey == 'b') {
        smKeyId = 'b';
      } else if (smKey == 2 || smKey == 'c') {
        smKeyId = 'c';
      } else {
        smKeyId = 'd';
      }
      return smKeyId;
    },
    checkUnfold: function checkUnfold() {
      var sprt = this.selectedBettype.sprtId;
      var tmp = this.selectedBettype.tmpltId;
      if (!_.isUndefined(this.unfold_AllSc[sprt]) && !_.isUndefined(this.unfold_AllSc[sprt][tmp])) {
        this.isUnfold = this.unfold_AllSc[sprt][tmp];
      }
    },
    getTop: function getTop() {
      var topVal = this.selectedMarket == this.$store.getters.market.tdyMarket.key && (this.$store.getters.selectedBettype.betTypId != 5 || !this.isParlayTab) ? '73.5' : '89.5';
      if ((this.isGameBannerSelected || this.specialEvent) && this.selectedMarket == this.$store.getters.market.earlyMarket.key) {
        topVal = '37.5';
      }

      return 'top:' + topVal + 'px';
    },
    showMarketMatches: function showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll;
      } else {
        this.showhideAll = !this.showhideAll;
      }
    },
    showhideMain: function showhideMain(isRB) {
      var key = '';
      if (!isRB) {
        this.showhideAll = this.showhideAll ? false : true;
        for (key in this.sortedEventList) {
          this.$set(this.sortedEventList[key], 'hide', !this.showhideAll);
        }
      }
      if (this.showFavEvents && isRB) {
        this.showRBhideAll = this.showRBhideAll ? false : true;
      }
    },
    showLeg: function showLeg(key, isRB) {
      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide);
      } else if (isRB) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide);
      }
    },
    countAllBet: function countAllBet(event, selectedShow) {
      var countCv = event.all;
      if (event.od) {
        $.each(event.od, function (plyTypes, drawBt) {
          if (selectedShow == 3 && plyTypes == 2) {} else if (selectedShow == 4 && plyTypes == 1) {} else {
            $.each(drawBt, function (bidx, drawDual) {
              if (bidx == 1 || bidx == 2 || bidx == 8 || bidx == 9) {
                $.each(drawDual, function (dd, val) {
                  --countCv;
                });
              } else if (bidx == 4 || bidx == 11) {
                if (selectedShow == 2) {
                  --countCv;
                }
              }
            });
          }
        });
      }
      return countCv;
    },
    enterMatch: function enterMatch(event) {
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        token: token.arr_8
      });
    },
    enterAllBet: function enterAllBet(event, startTv) {
      var isRB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.$store.commit('SHOW_UNFOLD', true);
      this.$store.commit('SHOW_FOLD', false);
      this.$store.commit('UNFOLD_ALLSC', false);
      if (this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn) {
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv = 1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: isRB,

        token: token.arr_8,
        loadTemplate: startTv });
      if (startTv == 1) {
        this.$store.commit('RIGHT_BOARD_CHG', event);
      }
    },
    backtoTop: function backtoTop() {
      $(".sport-table-scroll").animate({ scrollTop: 0 }, 100);
    },
    openSpecialStream: function openSpecialStream(url) {
      var height = window.screen.availHeight - 50;
      var width = window.screen.availWidth - 100;
      var left = screen.width / 2 - width / 2;
      var top = screen.height / 2 - height / 2;
      if (width > 1024) {
        width = 1024;
      }
      if (height > 600) {
        height = 600;
      }
      window.open(url, "MsgWindow", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left + ", resizable=yes, scrollbars=yes");
    }
  },
  updated: function updated() {
    $('.ellipsis').bind('mouseenter', function () {
      var $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SHOW_RBLGEEVE', []);
    this.$store.commit('SHOW_LGEEVE', {});
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_3__events_event_bus__["a" /* default */].$off('moreBetLoading');
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_event_bus__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['sportTableLang', 'sportList', 'sportIdArr', 'cookieLeague', 'selectedBettype', 'selectedMarket', 'selectedSport', 'market', 'open_RBMarket', 'bool_leagueToggle', 'sortedEventList', 'arr_leagueList']), {
    totalLeagues: {
      get: function get() {
        return this.$store.getters.totalLeagues;
      },
      set: function set(value) {
        this.$store.commit('TOTALLEAGUES', value);
      }
    },
    searchFil_totalLeagues: {
      get: function get() {
        return this.$store.getters.searchFil_totalLeagues;
      },
      set: function set(value) {
        this.$store.commit('SEARCHFIL_TOTALLEAGUES', value);
      }
    }
  }),
  watch: {
    'selectAll': {
      handler: function handler(val, oldVal) {
        this.$store.commit('SELECT_ALL_LEAGUE', val);
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      selectedLeague: [],
      selectedLeagueSport: {},
      selectAll: false,
      showHide: true,
      clearTxt: false,
      searchText: '',
      searchLeague: false,
      selectedOnly: false,
      subTitle: "",
      leagueList: {},
      selectedLeagueState: []
    };
  },

  methods: {
    selCheckLeague: function selCheckLeague(key) {
      var vue = this;
      var selLeaguesId = this.selectedLeague;
      var chked = this.selectedLeagueSport[key].checked;
      $.each(vue.leagueList[key], function (sid, sdata) {
        $.each(sdata, function (id, coldata) {
          if (!(selLeaguesId.indexOf(coldata.id) !== -1) && chked) {
            selLeaguesId.push(coldata.id);
          } else if (!chked) {
            var keyx = _.findIndex(selLeaguesId, function (e) {
              return e == coldata.id;
            }, 0);
            selLeaguesId.splice(keyx, 1);
          }
        });
      });
    },
    groupLGEBySports: function groupLGEBySports() {
      var _this = this;

      var VUE = this;
      var sprtID = '';
      var arrangedArray = {};
      var lgelist = _.cloneDeep(this.$store.getters.arr_leagueList);
      _.forEach(lgelist, function (data) {
        sprtID = !_.isUndefined(VUE.sportIdArr[data.sptid]) && VUE.sportIdArr[data.sptid];

        if (_.isUndefined(arrangedArray[sprtID])) {
          arrangedArray[sprtID] = [];
          arrangedArray[sprtID].push(data);
        } else {
          arrangedArray[sprtID].push(data);
        }
        _this.selectedLeagueSport[sprtID] = { 'checked': false };
      });
      return arrangedArray;
    },
    getSportLang: function getSportLang(sportID) {
      var vue = this;
      var capt = '';
      _.forEach(vue.sportList, function (sportdata, key) {
        if (sportID == sportdata.sprtId) {
          capt = sportdata.sprtLang.replace("<br/>", "");
        }
      });

      return capt;
    },
    showtitle: function showtitle(data) {
      if (data.lgecapt) {
        return data.lgecapt;
      } else if (data.capt) {
        return data.capt;
      }
      return '';
    },
    clearSearch: function clearSearch() {
      $('.search-league').val('');
      this.clearTxt = false;
    },
    changeSelected: function changeSelected() {},
    showLeague: function showLeague($lgId, selectedOnly) {
      if (selectedOnly == false) {
        return true;
      } else if (this.selectedLeague.indexOf($lgId) !== -1) {
        return true;
      }
    },
    searchLg: function searchLg() {
      var searchTxt = $('.search-league').val();
      this.clearTxt = searchTxt == '' ? false : true;
      var count = 0;
      if (this.clearTxt) {
        this.searchLeague = true;
        this.searchText = searchTxt;

        if (this.$store.getters.open_RBMarket && this.$store.getters.selectedSport.sprtId == 'G98') {
          $.each(this.leagueList, function (sid, sdata) {
            sdata.map(function (subArr) {
              return subArr.map(function (obj) {
                var lgCapt = obj.lgecapt;
                obj.show = lgCapt && lgCapt.toUpperCase().indexOf(searchTxt.toUpperCase()) !== -1 ? true : false;

                if (obj.show) {
                  count++;
                }
                return obj;
              });
            });
          });
        } else {
          this.leagueList.map(function (subArr) {
            return subArr.map(function (obj) {
              var lgCapt = obj.lgecapt;
              obj.show = lgCapt && lgCapt.toUpperCase().indexOf(searchTxt.toUpperCase()) !== -1 ? true : false;

              if (obj.show) {
                count++;
              }
              return obj;
            });
          });
        }
        if (!this.$store.getters.open_RBMarket) {
          this.setStateList(this.leagueList, false);
        }

        this.$store.commit('TOTALLEAGUES', count);
      } else {
        this.searchLeague = false;
        if (this.$store.getters.open_RBMarket && this.$store.getters.selectedSport.sprtId == 'G98') {
          $.each(this.leagueList, function (sid, sdata) {
            sdata.map(function (subArr) {
              return subArr.map(function (obj) {
                return obj.show = false;
              });
            });
          });
        } else {
          this.leagueList.map(function (subArr) {
            return subArr.map(function (obj) {
              return obj.show = false;
            });
          });
        }
        if (!this.$store.getters.open_RBMarket) {
          this.setStateList(this.leagueList, false);
        }

        this.$store.commit('TOTALLEAGUES', this.$store.getters.arr_leagueList.length);
      }
    },
    toggleLgSport: function toggleLgSport() {
      this.showHide = this.showHide ? false : true;
    },
    toggleLeague: function toggleLeague() {
      this.$store.commit('SPORT_LEAGUE_TOGGLE');
      var data = {};
      data.token = token.arr_6;
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('selectLeagueRefreshTable', data);
    },
    createGroupedArray: function createGroupedArray(arr, chunkSize, isAllSport) {
      var i;

      if (isAllSport) {
        var groups = {};
        $.each(arr, function (id, data) {
          var grpArr = [];
          groups[id] = {};
          for (i = 0; i < data.length; i += chunkSize) {
            grpArr.push(data.slice(i, i + chunkSize));
          }
          groups[id] = grpArr;
        });
      } else {
        var groups = [];
        if (arr.length < 30) {
          var insertToArraylength = 30 - arr.length;
          for (i = 0; i < insertToArraylength; i++) {
            var defaultvalue = { id: null };
            arr.push(defaultvalue);
          }
        }
        if (this.$store.getters.selectedBettype.betTypId == '6') {
          arr.sort(function (a, b) {
            return a.capt > b.capt && !_.isUndefined(b.capt) && !_.isUndefined(a.capt) ? 1 : -1;
          });
        } else {
          arr.sort(function (a, b) {
            return a.f > b.f && !_.isUndefined(b.f) && !_.isUndefined(a.f) ? 1 : -1;
          });
        }
        var result = [];
        var map = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (!map.has(item.id)) {
              map.set(item.id, true);

              if (this.$store.getters.selectedBettype.betTypId == '6') {
                result.push({
                  c: item.c,
                  id: item.id,
                  capt: item.capt
                });
              } else {
                result.push({
                  c: item.c,
                  f: item.f,
                  id: item.id,
                  lgecapt: item.lgecapt,
                  show: item.show,
                  sptid: item.sptid,
                  state: item.state
                });
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        for (i = 0; i < result.length; i += chunkSize) {
          groups.push(result.slice(i, i + chunkSize));
        }
      }

      return groups;
    },
    filterLeague: function filterLeague() {
      var _this2 = this;

      var data = {
        token: token.arr_6,
        callback: function (res) {
          _this2.toggleLeague();
        }.bind(this)
      };
      this.$store.commit('SELECTED_PAGE', 1);

      if (this.selectedLeague.length != this.$store.getters.arr_leagueList.length) {
        this.$store.commit('SELECTED_LEAGUELIST', this.selectedLeague);
        this.$store.commit('COOKIE_LEAGUE', {
          selectedLeague: this.selectedLeague,
          remove: false
        });

        data.selectedLeague = this.selectedLeague;
      } else {
        this.$store.commit('COOKIE_LEAGUE', {
          remove: true
        });
        this.$store.commit('SELECTED_LEAGUELIST', []);
      }
      this.$store.commit('SELECTEDLEAGUES', this.selectedLeague.length);
      this.$store.commit('TOTALLEAGUES', this.$store.getters.arr_leagueList.length);
      __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      if (this.$store.getters.selectedBettype.betTypId == '6') {
        this.$store.dispatch('getSportOutrightOdds', {
          'leagueList': this.selectedLeague,
          token: token.arr_6
        });
      } else {
        if (this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key) {
          this.toggleLeague();
        } else {
          this.$store.dispatch('getSportOdds', data);
        }
      }
    },
    changeSelectAll: function changeSelectAll() {
      var _this3 = this;

      this.selectAll = !this.selectAll;
      if (this.selectAll == true) {
        this.selectedLeague = [];
        _.forEach(this.$store.getters.arr_leagueList, function (league) {
          _this3.selectedLeague.push(league.id);
        });
        if (!this.$store.getters.open_RBMarket) {
          this.selectedLeagueState.map(function (obj) {
            return obj.checked = true;
          });
        }
      } else {
        this.selectedLeague = [];
        if (!this.$store.getters.open_RBMarket) {
          this.selectedLeagueState.map(function (obj) {
            return obj.checked = false;
          });
        }
      }
    },
    checkLeague: function checkLeague(sport, id) {
      if (this.selectedLeague.indexOf(id) !== -1) {
        var key = _.findIndex(this.selectedLeague, function (e) {
          return e == id;
        }, 0);
        this.selectedLeague.splice(key, 1);
      } else {
        this.selectedLeague.push(id);
      }

      if (sport != null) {
        if (this.$store.getters.open_RBMarket && this.$store.getters.selectedSport.sprtId == 'G98') {
          this.changeSelectedLeague2(sport, id);
        } else {
          this.changeSelectedLeague3(sport);
        }
      }
    },
    changeSelectedLeague: function changeSelectedLeague() {
      this.selectAll = this.selectedLeague.length == this.$store.getters.arr_leagueList.length ? true : false;
    },
    changeSelectedLeague2: function changeSelectedLeague2(sportObjKey, dataID) {
      this.selectAll = this.selectedLeague.length == this.$store.getters.arr_leagueList.length ? true : false;
      var awa = this.selectedLeague;
      var chkkk = false;
      var vue = this;
      var selLeaguesId = this.selectedLeague;

      $.each(vue.leagueList[sportObjKey], function (sid, sdata) {
        $.each(sdata, function (id, coldata) {
          if (selLeaguesId.indexOf(coldata.id) !== -1) {
            chkkk = true;
          }
        });
      });
      this.selectedLeagueSport[sportObjKey].checked = chkkk;
    },
    initleagueSelectionBox: function initleagueSelectionBox() {
      $('#leagueSelectionBox').css({
        'top': '27%',
        'left': '10%'
      }).fadeIn('slow');
      $('#leagueSelectionBox').draggable({});
    },
    highlightText: function highlightText(words, searchText) {
      function pregQuote(str) {
        return (str.trim() + '').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\/\:])/g, "\\$1");
      }
      if (this.searchText != "") {
        var iQuery = new RegExp(pregQuote(searchText), 'ig');
        return words.toString().replace(iQuery, function (matchedTxt, a, b) {
          return '<span class=\'highlight\'>' + matchedTxt + '</span>';
        });
      }
      return words;
    },
    setLeagueList: function setLeagueList() {
      if (this.$store.getters.open_RBMarket && this.$store.getters.selectedSport.sprtId == 'G98') {
        var list = this.groupLGEBySports();
        var isSportAll = true;
      } else {
        var list = _.cloneDeep(this.$store.getters.arr_leagueList);
        var isSportAll = false;

        if (!this.$store.getters.open_RBMarket && list && list.length > 0) {
          this.setStateList(list, true);
        }
      }
      this.$store.commit('TOTALLEAGUES', this.$store.getters.arr_leagueList.length);
      var grouped = this.createGroupedArray(list, 3, isSportAll);

      this.leagueList = grouped;
    },
    setStateList: function setStateList(list, initialSet) {
      var searchLeague = this.searchLeague;
      var stateArr = [];
      if (initialSet) {
        $.each(list, function (key, val) {
          if (_.find(stateArr, { 'state': val.state })) {
            var sIndex = _.findIndex(stateArr, { 'state': val.state });
            if (!(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(stateArr[sIndex]['leagues']).indexOf(val.id.toString()) !== -1)) {
              if (searchLeague && val.show || !searchLeague) {
                stateArr[sIndex]['leagues'][val.id] = val;
              }
            } else {
              stateArr[sIndex]['leagues'][val.id]['c'] += val.c;
            }
          } else {
            var stateArrLen = stateArr.push({
              'state': val.state,
              'leagues': {},
              'checked': false
            });
            if (searchLeague && val.show || !searchLeague) {
              stateArr[stateArrLen - 1]['leagues'][val.id] = val;
            }
          }
        });
      } else {
        $.each(list, function (ridex, rArr) {
          $.each(rArr, function (key, val) {
            if (_.find(stateArr, { 'state': val.state })) {
              var sIndex = _.findIndex(stateArr, { 'state': val.state });
              if (!(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(stateArr[sIndex]['leagues']).indexOf(val.id.toString()) !== -1)) {
                if (searchLeague && val.show || !searchLeague) {
                  stateArr[sIndex]['leagues'][val.id] = val;
                }
              } else {
                stateArr[sIndex]['leagues'][val.id]['c'] += val.c;
              }
            } else {
              var stateArrLen = stateArr.push({
                'state': val.state,
                'leagues': {},
                'checked': false
              });
              if (searchLeague && val.show || !searchLeague) {
                stateArr[stateArrLen - 1]['leagues'][val.id] = val;
              }
            }
          });
        });
      }
      for (var index = stateArr.length - 1; index > -1; index--) {
        if (stateArr[index].leagues && (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(stateArr[index].leagues).length < 1 || stateArr[index].leagues.length < 1)) {
          stateArr.splice(index, 1);
        }
      }
      this.selectedLeagueState = stateArr;
    },
    selState: function selState(key) {
      var vue = this;
      var selLeaguesId = this.selectedLeague;
      var chked = this.selectedLeagueState[key].checked;
      if (vue.selectedLeagueState[key].leagues && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(vue.selectedLeagueState[key].leagues).length > 0) {
        $.each(vue.selectedLeagueState[key].leagues, function (lgeid, lgedt) {
          if (!(selLeaguesId.indexOf(lgedt.id) !== -1) && chked) {
            selLeaguesId.push(lgedt.id);
          } else if (!chked) {
            var keyx = _.findIndex(selLeaguesId, function (e) {
              return e == lgedt.id;
            }, 0);
            selLeaguesId.splice(keyx, 1);
          }
        });
      }
    },
    changeSelectedLeague3: function changeSelectedLeague3(key) {
      this.selectAll = this.selectedLeague.length == this.$store.getters.arr_leagueList.length ? true : false;
      var chkkk = false;
      var vue = this;
      var selLeaguesId = this.selectedLeague;
      if (vue.selectedLeagueState[key].leagues && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(vue.selectedLeagueState[key].leagues).length > 0) {
        $.each(vue.selectedLeagueState[key].leagues, function (lgeid, lgedt) {
          if (selLeaguesId.indexOf(lgedt.id) !== -1) {
            chkkk = true;
          }
        });
      }
      this.selectedLeagueState[key].checked = chkkk;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$emit('lgreloading', false);
    var Vue = this;
    $(document).click(function (e) {

      if (Vue.$store.getters.bool_leagueToggle && $(e.target).closest("#filter-content").length === 0) {
        if ($(e.target).closest(".select-btn.leagues-btn").length === 0) {
          Vue.toggleLeague();
        }
      }
    });
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$on("setLeagueList", function (res) {
      _this4.setLeagueList();
      $('#leagueSelection').niceScroll({
        horizrailenabled: false,
        autohidemode: false,
        cursorborder: "0px solid #fff",
        zindex: 48,
        railoffset: { left: 10 }

      });
    });
  },
  beforeMount: function beforeMount() {
    var selectedMarket = this.$store.getters.selectedMarket;
    var selectedSport = this.$store.getters.selectedBettype.sprtId;
    var selectedBettype = this.$store.getters.selectedBettype.betTypId;
    if (this.$store.getters.isGameBannerSelected) {
      selectedBettype += 'gmBanner';
    }

    if (this.cookieLeague) {
      if (this.cookieLeague[selectedMarket]) {
        if (this.cookieLeague[selectedMarket][selectedSport]) {
          if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype]) {
            if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length > 0) {
              this.$store.commit('SELECTED_LEAGUELIST', this.cookieLeague[selectedMarket][selectedSport][selectedBettype]);
            } else {
              this.$store.commit('SELECTED_LEAGUELIST', []);
            }
          } else {
            this.$store.commit('SELECTED_LEAGUELIST', []);
          }
        } else {
          this.$store.commit('SELECTED_LEAGUELIST', []);
        }
      } else {
        this.$store.commit('SELECTED_LEAGUELIST', []);
      }
    }

    if (this.$store.getters.arr_selectedLeagueList.length == 0) {} else {
      this.selectedLeague = this.$store.getters.arr_selectedLeagueList;
      this.selectAll = this.selectedLeague.length == this.$store.getters.arr_leagueList.length ? true : false;
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__events_event_bus__["a" /* default */].$off("setLeagueList");
  },
  destroyed: function destroyed() {
    $('#leagueSelection').getNiceScroll().remove();
  }
});

/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['langList'])),
  methods: {
    viewSportRules: function viewSportRules(param) {
      if (param == 0) {
        var height = window.screen.availHeight - 50;
        var width = window.screen.availWidth - 100;
        if (width > 1024) {
          width = 1024;
        }
        window.open('sport-information?c=' + param, 'MsgWindow', 'width=' + width + ', height=' + height + '');
      }
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_mixins_forecastCalculation__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_accounting__);












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__vue_mixins_forecastCalculation__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['BetTypeLang', 'sportForecastLang', 'sportForecastToggle', 'sportForecastSelectedEvent', 'betForm', 'sportWaitingWagerList', 'selectedMarket', 'market'])),
  data: function data() {
    return {
      showNote: false,
      forecastList: null,
      betAmount: null,
      selectedForecastEvent: null,
      showFT: true,
      showHT: true,
      waitingWagerList: [],
      wagerCount: 0,
      eventObj: null,
      switchEvent: true,
      firstShowForecast: true,
      timer: 5,
      timerId: null,
      token: window.token
    };
  },

  watch: {
    'sportForecastSelectedEvent': {
      handler: function handler(val, oldVal) {
        if (this.selectedForecastEvent) {
          var selFcEve = this.selectedForecastEvent;
          for (var pt = 0; pt < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selFcEve).length; pt++) {
            var ptKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selFcEve)[pt];
            if (ptKey != 'eveObj') {
              for (var bt = 0; bt < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selFcEve[ptKey]).length; bt++) {
                var btKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selFcEve[ptKey])[bt];
                for (var tbet = 0; tbet < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selFcEve[ptKey][btKey]).length; tbet++) {
                  var tbetKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selFcEve[ptKey][btKey])[tbet];
                  var eveid = selFcEve[ptKey][btKey][tbetKey].eveid;
                  selFcEve[ptKey][btKey][tbetKey].rbscoa = this.$store.getters.sportForecastSelectedEvent.rbinfo['scoa'];
                  selFcEve[ptKey][btKey][tbetKey].rbscob = this.$store.getters.sportForecastSelectedEvent.rbinfo['scob'];
                  this.forecastList[eveid][ptKey][btKey][tbetKey] = this.getForecastInfo(this.forecastList, eveid, ptKey, btKey, tbetKey, { isWager: false });
                }
              }
            }
          }
        }
      },

      deep: true
    },
    'betForm': {
      handler: function handler(val, oldVal) {

        if (val.length > 0 && !this.$store.getters.betting.success) {
          if (val[0]['eveid'] == this.sportForecastSelectedEvent.eveid) {
            this.firstShowForecast = false;
            this.checkForecastExist(_.cloneDeep(val[0]));
            this.getSportWager();
            this.$forceUpdate();
            var data = {
              betForm: _.cloneDeep(this.$store.getters.betForm[0]),
              betAmount: this.$store.getters.sportMiniBet.betAmount
            };
            this.eventBusCalcForecast(data);
          }
        }
        if (this.firstShowForecast) {
          this.getSportWager();
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    getDecimalDisplay: function getDecimalDisplay(value) {
      if (this.$store.getters.account.oddsType == 'am') {
        return parseFloat(value).toFixed(0);
      }
      return parseFloat(value).toFixed(2);
    },
    chckBoxForecast: function chckBoxForecast() {
      this.$forceUpdate();
    },
    removeForecastOdds: function removeForecastOdds(eveid, ftPlyType, bettypKey, tbetKey) {
      var sportForecastList = this.$store.getters.sportForecastList;
      this.$delete(sportForecastList[eveid][ftPlyType][bettypKey], tbetKey);

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sportForecastList[eveid][ftPlyType][bettypKey]).length == 0) {
        this.$delete(sportForecastList[eveid][ftPlyType], bettypKey);

        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sportForecastList[eveid][ftPlyType]).length == 0) {
          this.$delete(sportForecastList[eveid], ftPlyType);

          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sportForecastList[eveid]).length == 1) {
            this.$delete(sportForecastList, eveid);

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sportForecastList).length == 0) {
              sportForecastList = null;
              this.selectedForecastEvent = null;
            }
          }
        }
      }
      this.$store.commit('SPORTFORECAST_LIST', sportForecastList);
    },
    checkForecastExist: function checkForecastExist(betForm) {
      var eveid = betForm.eventObj.eveid;
      var eveObj = betForm.eventObj;
      var plytyp = betForm.plyType;
      var bettyp = betForm.betType;
      var tbetcapt = betForm.tbetcapt;
      var tbet = betForm.tbet;
      var ta = betForm.ta;
      var tb = betForm.tb;
      var odd = betForm.odd;

      var dual = betForm.dual ? '-' + betForm.dual : '';

      tbet += dual;

      this.forecastList = this.$store.getters.sportForecastList ? this.$store.getters.sportForecastList : {};

      if (!this.forecastList[eveid]) {
        this.forecastList[eveid] = {};
        this.forecastList[eveid][plytyp] = {};
        this.forecastList[eveid][plytyp][bettyp] = {};
        this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm);
      } else {
        if (!this.forecastList[eveid][plytyp]) {
          this.forecastList[eveid][plytyp] = {};
          this.forecastList[eveid][plytyp][bettyp] = {};
          this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm);
        } else {
          if (!this.forecastList[eveid][plytyp][bettyp]) {
            this.forecastList[eveid][plytyp][bettyp] = {};
            this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm);
          } else {
            if (!this.forecastList[eveid][plytyp][bettyp][tbet]) {
              this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm);
            } else {
              this.createForecastObj(eveid, plytyp, bettyp, tbet, betForm);
            }
          }
        }
      }
      this.selectedForecastEvent = this.forecastList[eveid];
      this.selectedForecastEvent.eveObj = {
        eveid: eveObj.eveid,
        tacapt: eveObj.tacapt,
        tbcapt: eveObj.tbcapt
      };
    },
    createForecastObj: function createForecastObj(eveid, plytyp, bettyp, tbet, betForm) {
      this.forecastList[eveid][plytyp][bettyp][tbet] = betForm;
      this.forecastList[eveid][plytyp][bettyp][tbet].check = true;
      this.forecastList[eveid][plytyp][bettyp][tbet].betAmount = 0;
      this.$store.commit('SPORTFORECAST_LIST', this.forecastList);
    },
    removeForecastList: function removeForecastList() {
      if (this.selectedForecastEvent) {
        _.unset(this.forecastList, this.selectedForecastEvent.eveObj.eveid);
        this.$store.commit('SPORTFORECAST_LIST', this.forecastList);
        this.selectedForecastEvent = null;
        this.$forceUpdate();
      }
    },
    closeForecast: function closeForecast() {
      this.$store.commit('SPORTFORECAST_TOGGLE', false);
    },
    initForecastTable: function initForecastTable() {
      $('#forecast').css({
        'top': '60%',
        'left': '50%',
        'margin-left': '-200px',
        'margin-top': '-200px'
      }).fadeIn('slow');
      $('#forecast').draggable({
        containment: '#contentsRight'
      });
    },
    getForecastInfo: function getForecastInfo(list, eveid, plytyp, bettyp, tbet, args) {
      var bet_info = list[eveid][plytyp][bettyp][tbet];
      var hc = 4,
          ac = 4;

      bet_info.odTypId = this.$store.getters.account.oddsType;

      if (this.$store.getters.sportForecastSelectedEvent && this.$store.getters.sportForecastSelectedEvent.rbinfo) {
        hc = parseInt(this.$store.getters.sportForecastSelectedEvent.rbinfo['scoa']) >= 2 ? hc + parseInt(this.$store.getters.sportForecastSelectedEvent.rbinfo['scoa']) : hc;
        ac = parseInt(this.$store.getters.sportForecastSelectedEvent.rbinfo['scob']) >= 2 ? ac + parseInt(this.$store.getters.sportForecastSelectedEvent.rbinfo['scob']) : ac;
      }

      switch (bettyp.toString()) {
        case this.onex2BetType:
        case this.ronex2BetType:
          return this.olc_1x2(bet_info, hc, ac);
          break;
        case this.hdpBetType:
        case this.rhdpBetType:
          return this.olc_ah(bet_info, hc, ac);
          break;
        case this.ouBetType:
        case this.rouBetType:
        case this.htgBetType:
        case this.rhtgBetType:
        case this.atgBetType:
        case this.ratgBetType:
          return this.olc_ou(bet_info, hc, ac);
          break;
        case this.oeBetType:
        case this.roeBetType:
          return this.olc_oe(bet_info, hc, ac);
          break;
        case this.csBetType:
        case this.rcsBetType:
          return this.olc_cs(bet_info, hc, ac);
          break;
        case this.tgBetType:
        case this.rtgBetType:
          return this.olc_tg(bet_info, hc, ac);
          break;
        case this.h1x2BetType:
        case this.rh1x2BetType:
          return this.olc_h1x2(bet_info, hc, ac);
          break;
        case this.bttsBetType:
        case this.rbttsBetType:
          return this.olc_btts(bet_info, hc, ac);
          break;
        case this.cshBetType:
        case this.rcshBetType:
          return this.olc_csh(bet_info, hc, ac);
          break;
        case this.twnBetType:
        case this.rtwnBetType:
          return this.olc_twn(bet_info, hc, ac);
          break;
        case this.wmBetType:
        case this.rwmBetType:
          return this.olc_wm(bet_info, hc, ac);
          break;
        default:
          return false;
      }
    },
    eventBusCalcForecast: function eventBusCalcForecast(data) {
      if (data == null) {
        this.removeForecastList();
        return;
      }
      var eveid = data.betForm.eventObj.eveid;
      var eveObj = data.betForm.eventObj;
      var plytyp = data.betForm.plyType;
      var bettyp = data.betForm.betType;
      var tbetcapt = data.betForm.tbetcapt;
      var tbet = data.betForm.tbet;
      var ta = data.betForm.ta;
      var tb = data.betForm.tb;
      var odd = data.betForm.odd;

      var dual = data.betForm.dual ? '-' + data.betForm.dual : '';

      tbet += dual;

      this.checkForecastExist(data.betForm, data.event);
      this.forecastList[eveid][plytyp][bettyp][tbet].betAmount = __WEBPACK_IMPORTED_MODULE_7_accounting___default.a.toFixed(data.betAmount, 0);

      this.forecastList[eveid][plytyp][bettyp][tbet] = this.getForecastInfo(this.forecastList, eveid, plytyp, bettyp, tbet, { isWager: false });

      this.selectedForecastEvent = this.forecastList[eveid];
      this.selectedForecastEvent.eveObj = {
        eveid: eveObj.eveid,
        tacapt: eveObj.tacapt,
        tbcapt: eveObj.tbcapt
      };
      this.$forceUpdate();
    },
    getSportWager: function getSportWager() {
      var _this = this;

      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var selectedEvent = this.$store.getters.sportForecastSelectedEvent;
      var params = {
        eveId: selectedEvent.eveid,
        isForecast: '1',
        token: refresh == true ? token.arr_5 : token.arr_2
      };

      if (selectedEvent.rbinfo) {
        params.scoa = selectedEvent.rbinfo.scoa;
        params.scob = selectedEvent.rbinfo.scob;
      }
      this.$ajax({
        method: 'get',
        url: 'sport-wager',
        data: params
      }).done(function (res) {
        if (res.wFc) {
          _this.waitingWagerList = res.wFc;
          _this.$store.commit('SPORTFORECAST_WAITINGLIST', res.wFc);
          _this.wagerCount = res.wFc.ttl;
          _this.$forceUpdate();
        }
        if (_this.market.inPlayMarket.key == _this.selectedMarket) {
          _this.timer = 5;
          _this.startTimer();
        }
      }.bind(this)).catch(function (errRes) {
        if (_this.market.inPlayMarket.key == _this.selectedMarket) {
          _this.timer = 5;
          _this.startTimer();
        }
      });
    },
    startTimer: function startTimer() {
      var _this2 = this;

      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (_this2.timer - 1 < 0) {
            _this2.getSportWager();
          } else {
            _this2.timer -= 1;
          }
        }, 1000);
      }
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    modifyNote: function modifyNote() {
      var note1 = this.sportForecastLang['FORECAST.LBL_NOTE_INFO'];
      var note2 = this.sportForecastLang['FORECAST.LBL_NOTE_INFO_2'];

      return note1 + ', ' + note2;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.initForecastTable();
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('FORECAST_GETWAITINGLIST', function (data) {
      if (data == 'nodata') {
        _this3.getSportWager();
        return;
      }
      if (data == null) {
        _this3.selectedForecastEvent = null;
        _this3.getSportWager();
        return;
      }
      _this3.selectedForecastEvent = null;
      if (_this3.forecastList && _this3.forecastList[data.eveid]) {
        _this3.selectedForecastEvent = _this3.forecastList[data.eveid];
        _this3.selectedForecastEvent.eveObj = {
          eveid: data.eveid,
          tacapt: data.tacapt,
          tbcapt: data.tbcapt
        };
      }
      _this3.getSportWager();
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('SHOW_FORECAST', function (event) {
      _this3.initForecastTable();
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('FORECAST_CALC', function (data) {
      _this3.eventBusCalcForecast(data);
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('REMOVE_ALL_FORECAST', function () {
      _this3.removeForecastList();
    }.bind(this));
    if (this.market.inPlayMarket.key == this.selectedMarket) {
      this.startTimer();
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('SHOW_FORECAST');
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('FORECAST_GETWAITINGLIST');
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('FORECAST_CALC');
    this.clearTimer();
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sport_sportTable__ = __webpack_require__(204);













/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      cookielang: window._cookie,
      lang: window.lang,
      getDate: window.dates,
      selectedDate: 99,
      sportId: window.sport_feature ? this.$store.getters.sportList[0]['sprtId'] : 'N1',
      type: 'livetv',
      todayEventDate: null,
      token: window.token,
      cookies_lang: window._cookie,
      sportCap: '',
      tvlink: null,
      windowWidth: window.innerWidth,
      showLarrowRB: true,
      showRarrowRB: true,
      showLarrowEarly: false,
      showRarrowEarly: true,
      dateLeft: 0,
      rbSportLeft: 0,
      showGameBanner: window._gameBanner ? true : false,
      gameBannerImage: window._gameBannerImage,
      allDate: '99',
      selectedLang: window._langid,
      selectedSportId: window.sport_feature ? this.$store.getters.sportList[0]['sprtId'].replace('N', '') : '1',
      reloading: true,
      selectAllDate: true,
      selectFuture: false,
      rbAllSport: {
        "sprtId": "G98"
      },
      selectedSportName: this.$store.getters.sportList[0]['sprtLang'],
      liveEve: this.$store.getters.liveEvent,
      sportBettypeList: window.sportBettypeList,
      timerSeconds: 60,
      selectedEvent: null
    };
  },

  components: {
    sportTable: __WEBPACK_IMPORTED_MODULE_8__sport_sportTable__["a" /* default */]
  },
  methods: {
    foldSc: function foldSc() {
      this.$store.commit('SHOW_UNFOLD', true);
      this.$store.commit('SHOW_FOLD', false);
      this.$store.commit('UNFOLD_ALLSC', false);
      var temp = this.$store.getters.selectedBettype;
      var element = document.getElementById('AllBetScrollfirstEvent');
      element.classList.remove('hide');
      this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp));
    },
    getActive: function getActive(sport) {
      var str = 'no-active';
      if (this.sportId == this.rbAllSport.sprtId && this.sportId != sport.sprtId || this.sportId == sport.sprtId) {
        str = 'active';
      }
      return str;
    },
    showLeg: function showLeg(key, isRB) {
      var closeList = document.getElementById('list_wrap_' + key);
      var closeTitle = document.getElementById('title_wrap_' + key);

      closeList.classList.toggle('hide');
      closeTitle.classList.toggle('leagues-pack');
    },
    clickMove: function clickMove(e, direction) {
      var VUE = this;
      var holderWidth = $('#rb-sport-scroll').width();
      var totalWidth = 0;
      var count = 0;
      $("#rb-scroll-content > .item.column").each(function () {
        totalWidth = totalWidth + $(this).outerWidth();
      });

      var setI = setInterval(function () {
        count++;
        if (count > 12) {
          clearInterval(setI);
        }

        VUE.rbSportLeft += direction == 'right' ? 15 : -15;
        document.getElementById("rb-sport-scroll").scrollLeft = VUE.rbSportLeft;

        var calc = totalWidth - VUE.rbSportLeft;
        VUE.showLarrowRB = VUE.rbSportLeft > 0 ? true : false;
        VUE.showRarrowRB = calc > holderWidth ? true : false;
      }, 16);
    },
    enterAllBet: function enterAllBet(event, startTv) {
      var isRB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var rbStatus = arguments[3];

      this.selectedEvent = event;
      this.$store.commit('RIGHT_BOARD_CHG', event);
      this.$store.commit('LIVE_MATCH', event);
      this.$store.commit('IS_OPEN_TV', startTv);
      __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);

      if (rbStatus == 1) {
        this.$store.commit('SELECTED_MATCHALLBET', true);
        this.$store.dispatch('getMatchAllBet', {
          event: event,
          isRB: rbStatus == 1 ? true : false,
          token: token.arr_8,
          loadTemplate: startTv });
      }
    },
    selectRBSport: function selectRBSport(sport) {
      this.sportId = sport.sprtId == this.rbAllSport.sprtId ? this.rbAllSport.sprtId : sport.sprtId;
      if (this.sportId == 'G98') {
        this.selectedSportName = window.lang.sportTableLang['SPORT_TABLE.ALL'];
      } else {
        this.selectedSportName = sport.sprtLang;
      }

      this.getEventsOdds();
    },
    changeEarlyParlayDate: function changeEarlyParlayDate(dateKey) {
      __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      this.$store.commit('SELECTED_PAGE', 1);
      this.$store.commit('SELECTEDEARLYPARLAYDATE', dateKey);
      this.selectedDate = dateKey;

      if (dateKey == '99') {
        this.selectAllDate = true;
      } else {
        this.selectAllDate = false;
      }

      if (dateKey == '8') {
        this.selectFuture = true;
      } else {
        this.selectFuture = false;
      }

      this.getEventsOdds();
    },
    highlightLine: function highlightLine(val) {
      this.$nextTick(function () {
        var tabElement = $("#tabDate-" + val).first();
        if (tabElement.length > 0) {
          var position = tabElement.position();
          if (position) {
            var center = position.left + tabElement.outerWidth() / 2 - 25;
            $('.c-match-list-filter .line').css('transform', 'translateX(' + center + 'px)');
          }
        }
      });
    },
    setDateArrow: function setDateArrow(direction) {
      if (direction == 'default') {
        this.dateLeft = 0;
        this.showLarrowEarly = false;
        this.showRarrowEarly = true;
        return;
      }
      this.dateLeft += direction == 'R' ? -100 : 100;

      var totalWidth = 0;
      var holderWidth = $('#tabWrap').width();
      this.showLarrowEarly = this.dateLeft < 0 ? true : false;

      $("#earlyDateScroll > .tab-item").each(function () {
        totalWidth = totalWidth + $(this).outerWidth();
      });
      var calc = totalWidth + this.dateLeft;
      this.showRarrowEarly = calc > holderWidth ? true : false;
    },
    getBGPos: function getBGPos(sprtId) {
      var a = '';
      if (sprtId == 'N1') {
        a = 'background-position: 0px -28.33px;';
      } else if (sprtId == 'G1' || sprtId == 'N2') {
        a = 'background-position: 0px -85px;';
      } else if (sprtId == 'N3') {
        a = 'background-position: 0px -538.33px;';
      } else if (sprtId == 'N21') {
        a = 'background-position: 0px -170px;';
      } else if (sprtId == 'N12') {
        a = 'background-position: 0px -623.33px;';
      } else if (sprtId == 'N15') {
        a = 'background-position: 0px -425px;';
      } else if (sprtId == 'G2') {
        a = '';
      } else if (sprtId == 'N7') {
        a = 'background-position: 0px -1445px;';
      } else if (sprtId == 'N14') {
        a = 'background-position: 0px -57px;';
      } else if (sprtId == 'N13') {
        a = 'background-position: 0px -114px;';
      } else if (sprtId == 'N19') {
        a = 'background-position: 0px -368.5px;';
      } else if (sprtId == 'N20') {
        a = 'background-position: 0px -142px;';
      } else if (sprtId == 'N23') {
        a = 'background-position: 0px -793px;';
      } else {
        a = 'background-position: 0px -85px;';
      }
      return a;
    },
    drawclass: function drawclass(gid) {
      var classss = 'ball_icon_';
      if (gid == 1) {
        classss += 'ft';
      } else if (gid == 2 || gid == 13) {
        classss += 'bk';
      } else if (gid == 3) {
        classss += 'tn';
      } else if (gid == 21) {
        classss += 'vb';
      } else if (gid == 23) {
        classss += 'bs';
      } else if (gid == 12) {
        classss += 'bm';
      } else {
        classss += 'op';
      }
      return classss;
    },
    getWeekdays: function getWeekdays(dt) {
      if (this.cookies_lang == 'en_US') {
        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(dt).format('ddd');
      } else {
        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(dt).format('dddd');
      }
    },
    getMonth: function getMonth(dt) {
      if (this.cookies_lang == 'en_US') {
        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(dt).format('MMM');
      } else {
        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(dt).format('MMMM');
      }
    },
    selDate: function selDate(key) {
      this.selectedDate = key;
      this.getEventsOdds(token.arr_6);
    },
    getFilterDate: function getFilterDate(dt) {
      return dt;
    },
    matchDateCheck: function matchDateCheck(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default.a.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss");
    },
    getFilterTime: function getFilterTime(dt) {
      if (this.$store.getters.timeZone.default != 'GMT-4') {
        var nDate = this.getNewDate(dt);
        var nTime = this.getTime(dt);

        return nDate + ' ' + nTime;
      } else {
        return new __WEBPACK_IMPORTED_MODULE_7_moment___default.a(dt).format("HH:mm");
      }
    },
    getNewDate: function getNewDate(dt) {
      dt = this.matchDateCheck(dt);
      if (this.cookies_lang == 'zh_TW' || this.cookies_lang == 'zh_CN') {
        return new __WEBPACK_IMPORTED_MODULE_7_moment___default.a(dt).format("MM/DD");
      }
      return new __WEBPACK_IMPORTED_MODULE_7_moment___default.a(dt).format("DD/MM");
    },
    getTime: function getTime(dt) {
      dt = this.matchDateCheck(dt);
      return new __WEBPACK_IMPORTED_MODULE_7_moment___default.a(dt).format("HH:mm");
    },
    getEventsOdds: function getEventsOdds() {
      var _this = this;

      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
      this.reloading = true;
      if (token_val == '') {
        token_val = token.arr_2;
      }

      this.$store.dispatch('getLiveSchedule', {
        date: this.selectedDate,
        sportId: this.sportId,
        token: token_val
      }).then(function () {
        setTimeout(function () {
          _this.reloading = false;
          _this.liveEve = _this.$store.getters.liveEvent;
        }, 500);
      });
    },
    sortEvent: function sortEvent(event) {
      return _.sortBy(event, ['dt']);
    },
    sortDate: function sortDate(event) {
      var datels = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(event);

      var orderedDate = _.orderBy(datels);

      var orderedEvent = _.map(orderedDate, function (date) {
        return {
          'event': event[date],
          'date': date
        };
      });
      return orderedEvent;
    },
    onResize: function onResize() {
      this.windowWidth = window.innerWidth;
    },
    getFilterEventList: function getFilterEventList() {
      this.$store.dispatch('getFilterEventList', {
        'sportid': this.selectedSportId
      });
      this.reloading = false;
    },
    arrayToObject: function arrayToObject(array) {
      return array.reduce(function (acc, curr) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(acc, curr);
      }, {});
    },
    refreshTbl: function refreshTbl(token_val) {
      $('#tblRefresh').addClass('loading-static-animation');

      this.timerSeconds = 30;
      this.reloading = token_val == token.arr_1 || token_val == token.arr_5 ? false : true;
      if (this.selectedMatchAllBet) {
        this.reloadAllBetTable(token_val);

        this.$store.dispatch('getLiveSchedule', {
          date: this.selectedDate,
          sportId: this.sportId,
          token: token_val
        });
      } else {
        this.getEventsOdds(token_val);
      }
    },
    reloadAllBetTable: function reloadAllBetTable() {
      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (token_val == '') {
        token_val = token.arr_5;
      }

      this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList);
      var Vue = this;
      if (this.selectedEvent !== null) {
        if (this.selectedEvent.rbstatus == 1) {
          this.$store.dispatch('getMatchAllBet', {
            event: this.selectedEvent,
            isRB: true,
            token: token.arr_8,
            loadTemplate: 2,
            notLoadTV: true,
            callback: function callback(res) {

              Vue.startTimer();
              Vue.mainMarketList = _.cloneDeep(Vue.$store.getters.sortedMatchEventList);

              Vue.$nextTick(function () {
                __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__["a" /* default */].$emit('diffOdd', Vue.cloneEventAllBet);
              });
              Vue.reloading = false;
              $('#tblRefresh').removeClass('loading-static-animation');
            }
          });
        } else {
          this.$store.dispatch('getMatchAllBet', {
            event: this.selectedEvent,
            isRB: false,
            token: token.arr_8,
            loadTemplate: 1,
            notLoadTV: true,
            callback: function callback(res) {

              Vue.startTimer();
              Vue.mainMarketList = _.cloneDeep(Vue.$store.getters.sortedMatchEventList);

              Vue.$nextTick(function () {
                __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__["a" /* default */].$emit('diffOdd', Vue.cloneEventAllBet);
              });
              Vue.reloading = false;
              $('#tblRefresh').removeClass('loading-static-animation');
            }
          });
        }
      }
    },
    getMarketTimer: function getMarketTimer(selMarket) {

      if (this.$store.getters.open_RBMarket) {
        return this.rbTimer;
      } else if (selMarket == this.$store.getters.market.earlyMarket.key) {
        return this.earlyTimer;
      } else if (selMarket == this.$store.getters.market.tdyMarket.key) {
        return this.todayTimer;
      }
    },
    startTimer: function startTimer() {
      var _this2 = this;

      this.timerSeconds = 30;
      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (_this2.timerSeconds - 1 < 0) {
            _this2.refreshTbl(token.arr_1);
          } else {
            _this2.timerSeconds -= 1;
          }
        }, 1000);
      }
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    refreshTimer: function refreshTimer() {
      this.clearTimer();
      this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket);

      this.startTimer();
    }
  },
  watch: {
    liveEve: {
      handler: function handler(newData, oldData) {
        var sortEve = _.sortBy(newData, [function (event) {
          return new Date(event.dt);
        }]);
        if (sortEve.length > 0) {
          var firstValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(sortEve[0])[0];
          if ((typeof firstValue === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(firstValue)) === 'object' && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(firstValue).length > 0) {
            var eveDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(firstValue.dt, "YYYY-MM-DD");
            var DateNow = __WEBPACK_IMPORTED_MODULE_7_moment___default()().utcOffset("-04:00").startOf('day').valueOf();

            if (eveDate.isAfter(DateNow, 'day')) {
              this.$store.commit('SELECTED_MARKET', "2");
            } else {
              if (firstValue.sptid == 2) {
                this.$store.commit('SELECTED_MARKET', "3");
              } else {
                this.$store.commit('SELECTED_MARKET', "1");
              }
            }

            this.$store.commit('RIGHT_BOARD_CHG', firstValue);
            this.$store.commit('LIVE_MATCH', firstValue);
            this.$store.commit('IS_OPEN_TV', 1);

            this.selectedEvent = firstValue;
            __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
            this.$store.dispatch('getMatchAllBet', {
              event: firstValue,
              isRB: firstValue.rbstatus == 1 ? true : false,
              token: token.arr_8,
              loadTemplate: 1 });
          }
        }
      },

      deep: true
    }
  },
  beforeMount: function beforeMount() {
    $('body').css("background-color", "white");
    this.getFilterEventList();
    this.startTimer();
  },
  created: function created() {},
  mounted: function mounted() {
    var _this3 = this;

    this.getEventsOdds(token.arr_2);
    window.addEventListener('resize', this.onResize);

    __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__["a" /* default */].$on('callLivetv', function () {
      _this3.selectedDate = 99;
      _this3.sportId = window.sport_feature ? _this3.$store.getters.sportList[0]['sprtId'] : 'N1';
      _this3.$store.commit('SELECTEDEARLYPARLAYDATE', 99);

      _this3.highlightLine(99);
      _this3.getEventsOdds();
    });
  },
  destroyed: function destroyed() {
    this.clearTimer();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['sortedEvents', 'arr_selectedTemplate', 'liveEvent', 'livetv', 'sportList', 'selectedEarlyParlayDate', 'earlyParlayDateList', 'selectedBettype', 'sortedMatchEventList', 'selectedMarket', 'liveSchedule', 'show_Fold', 'selectedMatchAllBet', 'openTv', 'timeZone']))
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sport_allBetHeader__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sport_allBetContent__ = __webpack_require__(202);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    allBetHeader: __WEBPACK_IMPORTED_MODULE_3__sport_allBetHeader__["a" /* default */],
    allBetContent: __WEBPACK_IMPORTED_MODULE_4__sport_allBetContent__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['selectedBettype', 'langList', 'betLang', 'frameWidthHeight', 'right_allBetReloading', 'specialEvent']), {
    LeftMenu_heightPX: function LeftMenu_heightPX() {
      return this.$store.getters.frameWidthHeight.height.currentHeight - 100;
    },
    right_widthPX: function right_widthPX() {
      return this.$store.getters.frameWidthHeight.width.RightPage_current;
    }
  }),
  data: function data() {
    return {
      showEveBanner: true,
      showUnfoldBtn: false,
      selectedLang: window._langid
    };
  },

  methods: {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {}
});

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_apps_home_home_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_store___ = __webpack_require__(105);







new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#Home2',
  template: '<Home ></Home>',
  store: __WEBPACK_IMPORTED_MODULE_3__vue_store___["a" /* default */],
  data: {
    account: window.account
  },
  beforeMount: function beforeMount() {
    if (__WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.get(window.compcode + '_acc')) {
      var accCookie = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.get(window.compcode + '_acc'));
      window.account.shownGuide = accCookie.shownGuide ? true : false;
    }
    this.$store.commit('ACCOUNT', window.account);
    this.$store.commit('BETLANG', window.lang.betting);
    this.$store.commit('ODDTYPESLIST', window.odds);
    this.$store.commit('EARLYPARLAYDATELIST', window.earlyParlayDateList);
    this.$store.commit('BETTYPELANG', window.lang.betTypeLang);
    this.$store.commit('SPORTALLBETLANG', window.lang.sportAllBet);
    this.$store.commit('SPORTFORECAST_LANG', window.lang.sportForecast);
  },

  components: {
    Home: __WEBPACK_IMPORTED_MODULE_1__vue_apps_home_home_vue__["a" /* default */]
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596329a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(521);
function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596329a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchLeagueTeam_vue__ = __webpack_require__(136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4c7ce3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchLeagueTeam_vue__ = __webpack_require__(297);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchLeagueTeam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4c7ce3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchLeagueTeam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLeagueTeam)?_c('div',{staticClass:"search-wrap column",class:{ 'mini': _vm.miniNormal==1,'normal':_vm.miniNormal!=1 },staticStyle:{"right":"432px","padding-right":"14px"},attrs:{"id":"search-wrap"}},[_c('div',{staticClass:"wrap-input"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-wrap col"},[_c('input',{staticClass:"search-input col key-is-empty",attrs:{"type":"search","id":"searchField","placeholder":_vm.langList.home['HOME.ENTER_LEAGUE_TEAM']},on:{"keyup":function($event){return _vm.instantSearch($event)},"click":function($event){return _vm.instantSearch($event)}}}),_vm._v(" "),_c('span',{staticClass:"clear_input"},[(_vm.searchVal!=null)?_c('i',{staticClass:"cursor-pointer clear_input_btn q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"data-v-082e727f":"","aria-hidden":"true","role":"presentation"},on:{"click":function($event){return _vm.clear($event,'')}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"close-wrap",on:{"click":function($event){return _vm.closeLeagueTeam()}}},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_CLOSE']))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLeagueSearch),expression:"showLeagueSearch"}],staticClass:"bottom-wrap col search-result relative-position"},[_c('div',{staticClass:"sports-tab"},[_c('div',{staticClass:"tab-wrap fit relative-position"},[_c('div',{staticClass:"item-wrap relative-position",staticStyle:{"left":"0px"}},[_vm._l((_vm.sportList),function(sport){return [_c('div',{staticClass:"tab-item yb-flex-center",class:{ 'active': _vm.selectedSportSearch==sport.sprtId },attrs:{"id":'tab-'+sport.sprtId},domProps:{"innerHTML":_vm._s(sport.sprtLang)},on:{"mouseover":function($event){_vm.hoverSport = sport.sprtId},"mouseleave":function($event){_vm.hoverSport = _vm.selectedSportSearch},"click":function($event){return _vm.changeSport($event,sport.sprtId)}}})]}),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"wrap-init search-background"},[_c('div',{staticStyle:{"height":"50px"}}),_vm._v(" "),(_vm.historyList && _vm.historyList.length>0 && (_vm.searchVal==null||_vm.searchVal==''))?_c('div',{staticClass:"init-wrap"},[_c('div',{staticClass:"init-row"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"row-title col"},[_vm._v(_vm._s(_vm.langList.statementLang['STATEMENT.LBL_HISTORY']))]),_vm._v(" "),_c('div',{staticClass:"clear-history",on:{"click":_vm.clearSearchHistory}},[_vm._v(_vm._s(_vm.langList.home['HOME.CLEAR_SEARCH_HISTORY']))])]),_vm._v(" "),_vm._l((_vm.historyList),function(history,hIdx){return [_c('div',{staticClass:"histroy-item"},[_c('div',{staticClass:"ellipsis",on:{"click":function($event){return _vm.pickHistory($event, history)}}},[_vm._v(_vm._s(history))]),_vm._v(" "),_c('div',{attrs:{"data-v-624a6792":""}},[_c('i',{staticClass:"search_deleteIcon q-icon icon-del c-icon",staticStyle:{"font-size":"8px"},attrs:{"data-v-082e727f":"","aria-hidden":"true","role":"presentation"},on:{"click":function($event){return _vm.removeFromHistory(history, hIdx)}}})])])]})],2):_vm._e(),_vm._v(" "),((_vm.searchVal==null||_vm.searchVal==''))?_c('div',{staticClass:"init-wrap"},[_c('div',{staticClass:"init-row"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"row-title col"},[_vm._v(_vm._s(_vm.langList.home['HOME.SEARCH_HOT']))]),_vm._v(" "),_c('div',{staticClass:"clear-history",on:{"click":function($event){return _vm.changeSearche()}}},[_vm._v(" "+_vm._s(_vm.langList.home['HOME.CHANGE'])+" ")])]),_vm._v(" "),(_vm.templateSearch)?[_c('div',{staticClass:"hot histroy-item",on:{"click":function($event){return _vm.clear($event,_vm.langList.home['HOME.SEARCH_LEAGUE4'])}}},[_vm._v(" 1  "+_vm._s(_vm.langList.home['HOME.SEARCH_LEAGUE4'])+"  ")]),_vm._v(" "),_c('div',{staticClass:"hot histroy-item",on:{"click":function($event){return _vm.clear($event,_vm.langList.home['HOME.SEARCH_LEAGUE5'])}}},[_vm._v(" 2  "+_vm._s(_vm.langList.home['HOME.SEARCH_LEAGUE5'])+"  ")]),_vm._v(" "),_c('div',{staticClass:"hot histroy-item",on:{"click":function($event){return _vm.clear($event,_vm.langList.home['HOME.SEARCH_LEAGUE6'])}}},[_vm._v(" 3  "+_vm._s(_vm.langList.home['HOME.SEARCH_LEAGUE6'])+"  ")])]:[_c('div',{staticClass:"hot histroy-item",on:{"click":function($event){return _vm.clear($event,_vm.langList.home['HOME.SEARCH_LEAGUE1'])}}},[_vm._v(" 1  "+_vm._s(_vm.langList.home['HOME.SEARCH_LEAGUE1'])+" ")]),_vm._v(" "),_c('div',{staticClass:"hot histroy-item",on:{"click":function($event){return _vm.clear($event,_vm.langList.home['HOME.SEARCH_LEAGUE2'])}}},[_vm._v(" 2  "+_vm._s(_vm.langList.home['HOME.SEARCH_LEAGUE2'])+" ")]),_vm._v(" "),_c('div',{staticClass:"hot histroy-item",on:{"click":function($event){return _vm.clear($event,_vm.langList.home['HOME.SEARCH_LEAGUE3'])}}},[_vm._v(" 3  "+_vm._s(_vm.langList.home['HOME.SEARCH_LEAGUE3'])+"  ")])]],2):_vm._e(),_vm._v(" "),(_vm.searchVal!=null && _vm.searchVal!='')?_c('div',{staticClass:"result-wrap",staticStyle:{"overflow":"auto"},style:('max-height:'+_vm.LeftMenu_heightPX+'px !important'),attrs:{"data-v-26cf9bde":"","data-v-43f1557a":""}},[(Object.keys(_vm.searchedList).length>0 || Object.keys(_vm.searchedListRB).length>0 )?[(Object.keys(_vm.searchedListRB).length>0)?[_c('div',{staticClass:"type-item active inplay",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"type-wrap",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"line",attrs:{"data-v-26cf9bde":""}}),_vm._v(" "),_c('div',{staticClass:"type-name",attrs:{"data-v-26cf9bde":""}},[_vm._v(_vm._s(_vm.langList.home['HOME.INPLAY']))])]),_vm._v(" "),_vm._l((_vm.searchedListRB),function(list,lkey){return [_c('div',{staticClass:"league-item active",attrs:{"data-v-26cf9bde":""}},[_vm._m(4,true),_vm._v(" "),_vm._l((list),function(eventlist,ekey){return _c('div',{staticClass:"match-item",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"text-wrap",attrs:{"data-v-26cf9bde":""}},[(eventlist['eve'+_vm.langid+'cap'] || eventlist['eve1cap'])?[(eventlist['eve'+_vm.langid+'cap'])?[_c('div',{staticClass:"team",attrs:{"data-v-26cf9bde":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['eve'+_vm.langid+'cap'], _vm.searchVal))}})]:[_c('div',{staticClass:"team",attrs:{"data-v-26cf9bde":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['eve1cap'], _vm.searchVal))}})]]:[_c('div',{staticClass:"team",attrs:{"data-v-26cf9bde":""},on:{"click":function($event){return _vm.enterAllBet(eventlist);}}},[(eventlist['ta'+_vm.langid+'cap'])?[_c('span',{attrs:{"data-v-3c47a8b4":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['ta'+_vm.langid+'cap'], _vm.searchVal))}})]:[_c('span',{attrs:{"data-v-3c47a8b4":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['ta1cap'], _vm.searchVal))}})],_vm._v("\n                           v \n                          "),(eventlist['tb'+_vm.langid+'cap'])?[_c('span',{attrs:{"data-v-3c47a8b4":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['tb'+_vm.langid+'cap'], _vm.searchVal))}})]:[_c('span',{attrs:{"data-v-3c47a8b4":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['tb1cap'], _vm.searchVal))}})]],2)]],2),_vm._v(" "),_c('div',{staticClass:"text-wrap",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"c-match-process text-center vrow a-row",attrs:{"data-v-ab1566a6":"","data-v-26cf9bde":""}},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"},attrs:{"data-v-ab1566a6":""}}),_vm._v(" "),_c('div',{staticClass:"process-name",attrs:{"data-v-ab1566a6":""}},[(eventlist.rbinfo)?[(eventlist.sportid==1)?[(eventlist.rbinfo.htst == '0')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_HT']))])]:(_vm.validateRBTimer(eventlist) == '1')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_1HT']))])]:(_vm.validateRBTimer(eventlist) == '2')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_2HT']))])]:[_vm._v(" - ")]]:(eventlist.sportid==2)?[(eventlist.rbinfo.htst == '1')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_Q1']))])]:(eventlist.rbinfo.htst == '2')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_Q2']))])]:(eventlist.rbinfo.htst == '3')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_Q3']))])]:(eventlist.rbinfo.htst == '4')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_Q4']))])]:(eventlist.rbinfo.htst == '5')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_1HT']))])]:(eventlist.rbinfo.htst == '6')?[_c('span',{staticClass:"rb_timeHT"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_HT']))])]:(eventlist.rbinfo.htst == '7')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_2HT']))])]:(eventlist.rbinfo.htst == '8')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_OT']))])]:[_vm._v(" - ")]]:_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"c-match-date text-center date-wrap",attrs:{"data-v-ab1566a6":""}},[(eventlist.rbinfo)?[(eventlist.sportid==1)?[(eventlist.rbinfo.htst == '0')?void 0:(_vm.validateRBTimer(eventlist) == '1')?[(eventlist.rbinfo.tlsec)?[_vm._v("\n                                  "+_vm._s(_vm._f("rb-timer")(eventlist,'mm:ss'))+"\n                                ")]:[_vm._v("0")]]:(_vm.validateRBTimer(eventlist) == '2')?[_vm._v("\n                                  "+_vm._s(_vm._f("rb-timer")(eventlist,'mm:ss'))+"\n                              ")]:_vm._e()]:(eventlist.sportid==2)?[(eventlist.rbinfo.htst == '0')?void 0:[(_vm.selectedLang==2 || _vm.selectedLang==3)?[_c('br')]:_vm._e(),_vm._v(" "),(eventlist.rbinfo.evetm)?[_vm._v(_vm._s(_vm._f("rb-timer")(eventlist)))]:_vm._e()]]:_vm._e()]:[_c('span',{staticStyle:{"min-width":"60px"}},[(_vm.selectedLang == 2 || _vm.selectedLang == 3)?[_vm._v("\n                                  "+_vm._s(_vm.moment(_vm.matchDateCheck(eventlist.evedt)).locale('cn').format("MMM Do"))+"\n                              ")]:[_vm._v("\n                                "+_vm._s(_vm._f("date")(_vm.matchDateCheck(eventlist.evedt),'DD/MM'))+"\n                              ")],_vm._v(" "),_c('br')],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("date")(_vm.matchDateCheck(eventlist.evedt),'HH:mm')))])],_vm._v(" "),_c('span',{staticStyle:{"display":"none"}})],2)]),_vm._v(" "),_c('div',{staticClass:"score",attrs:{"data-v-26cf9bde":""}},[(eventlist.rbinfo)?[(eventlist.sportid==1 || eventlist.sportid==2)?[_vm._v(" \n                              "+_vm._s(eventlist.rbinfo.scoa)+"-"+_vm._s(eventlist.rbinfo.scob)+"\n                            ")]:_vm._e()]:_vm._e()],2)])])})],2)]})],2)]:_vm._e(),_vm._v(" "),(Object.keys(_vm.searchedList).length>0)?[_c('div',{staticClass:"type-item active",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"type-wrap",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"line",attrs:{"data-v-26cf9bde":""}}),_vm._v(" "),_c('div',{staticClass:"type-name",attrs:{"data-v-26cf9bde":""}},[_vm._v(_vm._s(_vm.langList.home['HOME.TEAM']))])]),_vm._v(" "),_vm._l((_vm.searchedList),function(list,lkey){return [_c('div',{staticClass:"league-item active",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"league-wrap",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"name-wrap",attrs:{"data-v-26cf9bde":""},on:{"click":function($event){return _vm.searchLeagueList(list[0])}}},[(list[0]['lge'+_vm.langid+'cap'])?[_c('div',{staticClass:"league-name",attrs:{"data-v-26cf9bde":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(list[0]['lge'+_vm.langid+'cap'], _vm.searchVal))}})]:[_c('div',{staticClass:"league-name",attrs:{"data-v-26cf9bde":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(list[0]['lge1cap'], _vm.searchVal))}})],_vm._v(" "),_c('div',{staticClass:"league-total",attrs:{"data-v-26cf9bde":""}},[_vm._v(_vm._s(list.length))])],2)]),_vm._v(" "),_vm._l((list),function(eventlist,ekey){return _c('div',{staticClass:"match-item",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"text-wrap",attrs:{"data-v-26cf9bde":""}},[(eventlist['eve'+_vm.langid+'cap'] || eventlist['eve1cap'])?[(eventlist['eve'+_vm.langid+'cap'])?[_c('div',{staticClass:"team",attrs:{"data-v-26cf9bde":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['eve'+_vm.langid+'cap'], _vm.searchVal))}})]:[_c('div',{staticClass:"team",attrs:{"data-v-26cf9bde":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['eve1cap'], _vm.searchVal))}})]]:[_c('div',{staticClass:"team",attrs:{"data-v-26cf9bde":""},on:{"click":function($event){return _vm.enterAllBet(eventlist);}}},[(eventlist['ta'+_vm.langid+'cap'])?[_c('span',{attrs:{"data-v-3c47a8b4":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['ta'+_vm.langid+'cap'], _vm.searchVal))}})]:[_c('span',{attrs:{"data-v-3c47a8b4":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['ta1cap'], _vm.searchVal))}})],_vm._v("\n                           v \n                          "),(eventlist['tb'+_vm.langid+'cap'])?[_c('span',{attrs:{"data-v-3c47a8b4":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['tb'+_vm.langid+'cap'], _vm.searchVal))}})]:[_c('span',{attrs:{"data-v-3c47a8b4":""},domProps:{"innerHTML":_vm._s(_vm.highlightText(eventlist['tb1cap'], _vm.searchVal))}})]],2)]],2),_vm._v(" "),_c('div',{staticClass:"text-wrap",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"c-match-process text-center vrow a-row",attrs:{"data-v-ab1566a6":"","data-v-26cf9bde":""}},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"},attrs:{"data-v-ab1566a6":""}}),_vm._v(" "),_c('div',{staticClass:"process-name",attrs:{"data-v-ab1566a6":""}}),_vm._v(" "),_c('div',{staticClass:"c-match-date text-center date-wrap",attrs:{"data-v-ab1566a6":""}},[_c('span',{staticStyle:{"min-width":"60px"}},[(_vm.selectedLang == 2 || _vm.selectedLang == 3)?[_vm._v("\n                              "+_vm._s(_vm.moment(_vm.matchDateCheck(eventlist.evedt)).locale('cn').format("MMM Do"))+"\n                            ")]:[_vm._v("\n                              "+_vm._s(_vm._f("date")(_vm.matchDateCheck(eventlist.evedt),'DD/MM'))+"\n                            ")],_vm._v(" "),_c('br')],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("date")(_vm.matchDateCheck(eventlist.evedt),'HH:mm')))])])]),_vm._v(" "),_c('div',{staticClass:"score",attrs:{"data-v-26cf9bde":""}})])])})],2)]})],2)]:_vm._e()]:[_c('div',{staticClass:"load-data-wrap col fit not-list",attrs:{"data-v-21f17103":"","data-v-26cf9bde":""}},[_c('div',{staticClass:"column yb-flex-center empty fit",attrs:{"data-v-21f17103":""}},[_c('div',{staticClass:"wrap empty-wrap",staticStyle:{"margin-bottom":"0px"},attrs:{"data-v-3fbff0d7":"","data-v-21f17103":""}},[_c('div',{staticClass:"img dark",staticStyle:{"width":"180px","height":"180px"},attrs:{"data-v-31145778":""}}),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"data-v-31145778":""}},[_vm._v(_vm._s(_vm.langList.home['HOME.SEARCH_EMPTY']))]),_vm._v(" "),_c('div',{staticClass:"nodata-text2",attrs:{"data-v-31145778":""}},[_vm._v(_vm._s(_vm.langList.home['HOME.SEARCH_TRY_OTHER']))])])])])]],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"play-wrap search-background",staticStyle:{"display":"none"}})])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-icon-container"},[_c('i',{staticClass:"search-icon q-icon icon-search c-icon set-color",staticStyle:{"color":"rgb(171, 186, 200)","font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-wrap"},[_c('div',{staticClass:"line",staticStyle:{"transform":"translateX(10px)","width":"44px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-btn btn",staticStyle:{"display":"none"}},[_c('div',{staticClass:"yb-icon-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-btn btn",staticStyle:{"display":"none"}},[_c('div',{staticClass:"yb-icon-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"league-wrap",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"name-wrap",attrs:{"data-v-26cf9bde":""}},[_c('div',{staticClass:"league-name",attrs:{"data-v-26cf9bde":""}}),_vm._v(" "),_c('div',{staticClass:"league-total",attrs:{"data-v-26cf9bde":""}},[_vm._v("0")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wob_index_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2400c3d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wob_index_vue__ = __webpack_require__(307);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wob_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2400c3d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wob_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sliderImage_vue__ = __webpack_require__(143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6edb7710_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sliderImage_vue__ = __webpack_require__(306);
function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sliderImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6edb7710_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sliderImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showGameBanner || _vm.showImageBanner)?_c('div',{staticClass:"widgetPanel sportsMenu special",class:{'collapsed': _vm.oddSelected},staticStyle:{"margin-bottom":"auto!important","cursor":"pointer","background":"transparent"}},[_c('div',{staticClass:"glyphIcon icon-widgetCollapse",attrs:{"title":"Collapse the Widget Panel"}}),_vm._v(" "),_c('div',{attrs:{"id":"euro_menu_all"}},[(!(_vm.openBetForm && _vm.position == 'l'))?_c('div',{staticClass:"euro_btn",style:({'cursor':(_vm.showImageBanner?'default':'pointer')}),attrs:{"id":"euro_banner"},on:{"click":function($event){$event.preventDefault();return _vm.selectGameBanner()}}},[(_vm.position == 'mini')?[_c('span',{staticClass:"q-icon icon c-icon sport-img icon",staticStyle:{"width":"22px","height":"22px"},style:({ backgroundImage: 'url(' + _vm.gameBannerImage.imgIco + ')' })})]:[(_vm.cookies_lang == 'zh_TW')?[_c('img',{style:(_vm.position == 't'? 'width: 395px;':'width: 220px;'),attrs:{"src":_vm.gameBannerImage['imgList_tw' + (_vm.position == 't'? '':'_l')]}})]:(_vm.cookies_lang == 'zh_CN')?[_c('img',{style:(_vm.position == 't'? 'width: 395px;':'width: 220px;'),attrs:{"src":_vm.gameBannerImage['imgList_cn' + (_vm.position == 't'? '':'_l')]}})]:(_vm.cookies_lang == 'th_TH')?[_c('img',{style:(_vm.position == 't'? 'width: 395px;':'width: 220px;'),attrs:{"src":_vm.gameBannerImage['imgList_th' + (_vm.position == 't'? '':'_l')]}})]:(_vm.cookies_lang == 'vn_VN')?[_c('img',{style:(_vm.position == 't'? 'width: 395px;':'width: 220px;'),attrs:{"src":_vm.gameBannerImage['imgList_vn' + (_vm.position == 't'? '':'_l')]}})]:(_vm.cookies_lang == 'id_ID')?[_c('img',{style:(_vm.position == 't'? 'width: 395px;':'width: 220px;'),attrs:{"src":_vm.gameBannerImage['imgList_id' + (_vm.position == 't'? '':'_l')]}})]:(_vm.cookies_lang == 'pt_PT')?[_c('img',{style:(_vm.position == 't'? 'width: 395px;':'width: 220px;'),attrs:{"src":_vm.gameBannerImage['imgList_pt' + (_vm.position == 't'? '':'_l')]}})]:(_vm.cookies_lang == 'es_MX')?[_c('img',{style:(_vm.position == 't'? 'width: 395px;':'width: 220px;'),attrs:{"src":_vm.gameBannerImage['imgList_sp' + (_vm.position == 't'? '':'_l')]}})]:[_c('img',{style:(_vm.position == 't'? 'width: 395px;':'width: 220px;'),attrs:{"src":_vm.gameBannerImage['imgList_en' + (_vm.position == 't'? '':'_l')]}})]]],2):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"contentArea"},[_c('div',{staticClass:"nav-widgetPanel icon-sportsMenu-today threeColum"},[_c('div',{staticClass:"item icon-sportsMenu-early",class:{'early_on': _vm.selectedMarket == _vm.market.earlyMarket.key && _vm.isGameBannerSelected , 'early': _vm.selectedMarket != _vm.market.earlyMarket.key && _vm.isGameBannerSelected, 'active': _vm.selectedMarket == _vm.market.earlyMarket.key && _vm.isGameBannerSelected},attrs:{"id":"earlyBtn"}},[_c('span',{staticClass:"itemContent",attrs:{"title":_vm.langList.GAME_BANNER['GAME_BANNER.EARLY']}},[_c('span',{staticClass:"text",on:{"click":function($event){return _vm.gameMarket(_vm.market.earlyMarket.key)}}},[_vm._v("\r\n                          "+_vm._s(_vm.langList.GAME_BANNER['GAME_BANNER.EARLY'])+"\r\n                      ")]),_vm._v(" "),(_vm.earlyCount>0)?_c('div',{staticClass:"alertArea"},[_c('div',{staticClass:"alert"},[_vm._v(_vm._s(_vm.earlyCount))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"item icon-sportsMenu-today",class:{'today_on': _vm.selectedMarket == _vm.market.tdyMarket.key && _vm.isGameBannerSelected, 'today': _vm.selectedMarket != _vm.market.tdyMarket.key && _vm.isGameBannerSelected , 'active': _vm.selectedMarket == _vm.market.tdyMarket.key && _vm.isGameBannerSelected},attrs:{"id":"todayBtn"}},[_c('span',{staticClass:"itemContent",attrs:{"title":_vm.langList.GAME_BANNER['GAME_BANNER.TODAY']}},[_c('span',{staticClass:"text",on:{"click":function($event){return _vm.gameMarket(_vm.market.tdyMarket.key)}}},[_vm._v("\r\n                        "+_vm._s(_vm.langList.GAME_BANNER['GAME_BANNER.TODAY'])+"\r\n                      ")]),_vm._v(" "),(_vm.tdyCount>0)?_c('div',{staticClass:"alertArea"},[_c('div',{staticClass:"alert"},[_vm._v(_vm._s(_vm.tdyCount))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"item icon-sportsMenu-live",class:{'rb_on': _vm.selectedMarket == _vm.market.inPlayMarket.key && _vm.isGameBannerSelected, 'rb': _vm.selectedMarket != _vm.market.inPlayMarket.key && _vm.isGameBannerSelected , 'active': _vm.selectedMarket == _vm.market.inPlayMarket.key && _vm.isGameBannerSelected},attrs:{"id":"rbBtn"}},[_c('span',{staticClass:"itemContent",attrs:{"title":_vm.langList.GAME_BANNER['GAME_BANNER.IN_PLAY']}},[_c('span',{staticClass:"text",on:{"click":function($event){return _vm.gameMarket(_vm.market.inPlayMarket.key)}}},[_vm._v("\r\n                          "+_vm._s(_vm.langList.GAME_BANNER['GAME_BANNER.IN_PLAY'])+"\r\n                      ")]),_vm._v(" "),(_vm.inPlyCount>0)?_c('div',{staticClass:"alertArea"},[_c('div',{staticClass:"alert"},[_vm._v(_vm._s(_vm.inPlyCount))])]):_vm._e()])])])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swipper"},[_c('div',{staticStyle:{"position":"relative","margin":"0 auto","top":"0px","left":"0px","width":"400px","height":"60px","overflow":"hidden"},attrs:{"id":"jssor_1"}},[_c('div',{staticStyle:{"cursor":"default","position":"relative","top":"0px","left":"0px","width":"400px","height":"60px","overflow":"hidden"},attrs:{"data-u":"slides"}},[_c('div',[_c('img',{staticStyle:{"width":"400px"},attrs:{"src":"assets/images/topbanner1S.jpg"}})]),_vm._v(" "),_c('div',[_c('img',{staticStyle:{"width":"400px"},attrs:{"src":"assets/images/topbanner2.jpg"}})]),_vm._v(" "),_c('div',[_c('img',{staticStyle:{"width":"400px"},attrs:{"src":"assets/images/topbanner3S.jpg"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-site-header relative-position yb-layout-margin-header",attrs:{"id":"siteHeader"}},[[_c('div',{staticClass:"header-item item1 vrow items-stretch relative-position zh",class:{ 'mini': _vm.miniNormal==1,'normal':_vm.miniNormal!=1 }},[_c('a',{staticClass:"vrow items-center img-logo-wrap",staticStyle:{"background-image":"none"}},[(((_vm.account.showLogo && _vm.account.isApi) ||  !_vm.account.isApi ) && _vm.customTemplate)?[((_vm.langId==2 || _vm.langId==3) && _vm.customTemplate['logo_wob-cn2'] && _vm.selectedTheme=='PM')?_c('img',{staticStyle:{"width":"150px","margin-left":"40px"},attrs:{"src":_vm.customTemplate['logo_wob-cn2']}}):_vm._e(),_vm._v(" "),((_vm.langId==2 || _vm.langId==3) && _vm.customTemplate['logo_wob-cn1'] && _vm.selectedTheme=='AM')?_c('img',{staticStyle:{"width":"150px","margin-left":"40px"},attrs:{"src":_vm.customTemplate['logo_wob-cn1']}}):_vm._e(),_vm._v(" "),((_vm.langId!=2 && _vm.langId!=3) && _vm.customTemplate['logo_wob-en2'] && _vm.selectedTheme=='PM')?_c('img',{staticStyle:{"width":"90px","margin-left":"70px"},attrs:{"src":_vm.customTemplate['logo_wob-en2']}}):_vm._e(),_vm._v(" "),((_vm.langId!=2 && _vm.langId!=3) && _vm.customTemplate['logo_wob-en1'] && _vm.selectedTheme=='AM')?_c('img',{staticStyle:{"width":"90px","margin-left":"70px"},attrs:{"src":_vm.customTemplate['logo_wob-en1']}}):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"site-nav vrow flex-nowrap col"},[_c('div',{staticClass:"tab-wrap fit relative-position"},[_c('div',{staticClass:"item-wrap relative-position",staticStyle:{"left":"0px"}},[_c('div',{staticClass:"tab-item yb-flex-center tab-bet active"},[_vm._v(_vm._s(_vm.langList.statementLang['STATEMENT.LBL_SPORTBET']))]),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center tab-statement",on:{"mouseover":function($event){return _vm.highlightLine('statement')},"mouseleave":function($event){return _vm.highlightLine('bet')},"click":function($event){$event.preventDefault();return _vm.showMoreFunc(1)}}},[_vm._v("\n                            "+_vm._s(_vm.langList.statement)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center tab-result",on:{"mouseover":function($event){return _vm.highlightLine('result')},"mouseleave":function($event){return _vm.highlightLine('bet')},"click":function($event){$event.preventDefault();return _vm.showMoreFunc(2)}}},[_vm._v("\n                            "+_vm._s(_vm.langList.result)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center tab-rules",on:{"mouseover":function($event){return _vm.highlightLine('rules')},"mouseleave":function($event){return _vm.highlightLine('bet')},"click":function($event){$event.preventDefault();return _vm.showMoreFunc(5)}}},[_vm._v("\n                            "+_vm._s(_vm.langList.statementLang['STATEMENT.LBL_SPORTRULES'])+"\n                        ")]),_vm._v(" "),(_vm.lobby!='' && _vm.lobbyUrl!='')?[_c('div',{staticClass:"tab-item yb-flex-center tab-lobby",on:{"mouseover":function($event){return _vm.highlightLine('lobby')},"mouseleave":function($event){return _vm.highlightLine('bet')},"click":function($event){$event.preventDefault();return _vm.backToLobby()}}},[_vm._v("\n                                "+_vm._s(_vm.langList.home['HOME.LBL_LOBBY'])+"\n                            ")])]:_vm._e(),_vm._v(" "),(_vm.promotionRulesShow && _vm.promotionRulesShow != null)?[_c('div',{staticClass:"tab-item yb-flex-center tab-promotion promotion_header",on:{"mouseleave":function($event){return _vm.highlightLine('bet')},"click":function($event){$event.preventDefault();return _vm.showMoreFunc(8)}}},[_c('div',{staticClass:"promotion_header_img"}),_vm._v(" "),_c('span',{staticClass:"promotion_header_title"},[_vm._v(_vm._s(_vm.langList.promotion['promotion.promotion_header']))])])]:_vm._e(),_vm._v(" "),(_vm.account.previewFlag && _vm.hasRedirect && _vm.customTemplate && _vm.customTemplate['redirect_web'] && _vm.customTemplate[(_vm.langId == 2 || _vm.langId == 3 ? 'redirect_cn' : 'redirect_en')] && _vm.loginRedirectUrl && _vm.showLobby())?[_c('div',{staticClass:"tab-item yb-flex-center tab-redirect",attrs:{"id":"redirect_page"},on:{"click":function($event){return _vm.redirectPage()}}},[_c('img',{style:({'width': _vm.customTemplate[(_vm.langId == 2 || _vm.langId == 3) ? 'redirect_cn' : 'redirect_en']['width_web']}),attrs:{"src":_vm.customTemplate[(_vm.langId == 2 || _vm.langId == 3) ? 'redirect_cn' : 'redirect_en']['logo']}})])]:_vm._e(),_vm._v(" "),_vm._m(0)],2)])]),_vm._v(" "),(_vm.gameBannerStatus)?_c('gameBanner',{style:(_vm.miniNormal!=1?'margin-right: -68px;':''),attrs:{"position":'t'}}):(_vm.miniNormal!=1)?_c('sliderImage'):_vm._e(),_vm._v(" "),(_vm.miniNormal!=1)?_c('div',{staticClass:"show-date-wrap relative-position"},[_c('div',{staticClass:"show-date yb-family-odds"},[_c('div',{staticClass:"date-item"},[_c('span',{staticClass:"date-time"},[_vm._v(_vm._s(_vm.currentTime))]),_vm._v(" "),_c('span',{staticClass:"time-zone"},[_vm._v("("+_vm._s(_vm.selectedTimeZone)+")")])])])]):(_vm.miniNormal==1)?_c('div',{staticClass:"user-info rows",attrs:{"token":"?token=d0cc5eb7db2c948b2592a117cb9081dcac4feefa"}},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"refresh-icon-wrap yb-flex-center"},[_c('div',{staticClass:"c-refresh fit yb-flex-center cursor-pointer refresh-btn",on:{"click":function($event){return _vm.getSportCCL(0)}}},[_vm._m(1)])]),_vm._v(" "),(!_vm.account.previewFlag)?_c('div',{staticClass:"user-name",on:{"click":function($event){return _vm.showMoreFunc(4)}}},[_vm._v("Hi, "+_vm._s(_vm.account.acccode))]):_c('div',{staticClass:"user-name"},[_vm._v("Hi, Guest")])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('i',{staticClass:"balance-btn-eye balance-btn-eye2",class:_vm.showCCL ? 'icon-eye_show':'icon-eye_hide2',staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"},on:{"click":_vm.CCL}}),_vm._v(" "),(!_vm.showCCL)?_c('div',{staticClass:"balance-text-hide"},[_vm._v(" ****** ")]):_c('div',{staticClass:"balance-text-show"},[_vm._v(_vm._s(_vm._f("ccl")(_vm.account.currCL,_vm.decimals)))])])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"header-item item2 vrow items-center",style:(_vm.leagueShowHide)},[_c('div',{staticClass:"yb-site-left-width",class:{ 'mini': _vm.miniNormal==1,'normal':_vm.miniNormal!=1 }},[_c('div',{staticClass:"search-wrap",class:{ 'mini': _vm.miniNormal==1,'normal':_vm.miniNormal!=1 },on:{"click":function($event){return _vm.showSearchLeagueTeam()}}},[(_vm.miniNormal!=1)?_c('div',{staticClass:"ellipsis"},[_vm._v("\n                        "+_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_SEARCH_LGETEAM'])+"\n                    ")]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"marquee-wrap col"},[_c('div',{staticClass:"iframe-tab-wrapper iframe-tab-wrapper-left",staticStyle:{"display":"none"}},[_c('div',{staticClass:"tab-item"},[_vm._v("\n                        "+_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LBL_MYBETS'])+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"tab-item"},[_vm._v(_vm._s(_vm.langList.result))])]),_vm._v(" "),_c('div',{staticClass:"mlabel line-height"},[_vm._v(_vm._s(_vm.langList.announceLanguage))]),_vm._v(" "),_c('div',{staticClass:"content col marquee cursor-pointer relative-position",on:{"click":function($event){$event.preventDefault();return _vm.showMoreMsg(0)}}},[_c('marquee',{staticClass:"line-height fit",attrs:{"behavior":"scroll","direction":"left","onmouseout":"this.start()","onmouseover":"this.stop()"},domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._v("Welcome !")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-right vrow items-center",style:({ 'width': _vm.right_widthPX + 'px'})},[(_vm.miniNormal==1)?_c('div',{staticClass:"show-date yb-family-odds col"},[_c('div',{staticClass:"date-item"},[_c('span',{staticClass:"date-time"},[_vm._v(_vm._s(_vm.currentTime))]),_vm._v(" "),(_vm.timeZone.format!=1)?_c('span',{staticClass:"time-zone"},[_vm._v("("+_vm._s(_vm.selectedTimeZone)+")")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-wrap relative-position versions-zhuanye",class:{ 'active': _vm.showLangActive },attrs:{"data-v-147931e8":""}},[_c('div',{staticClass:"language-text popup-text",class:{ 'active': _vm.showLangActive },attrs:{"data-v-147931e8":""},on:{"click":function($event){return _vm.clickShow('slang')}}},[_c('div',{class:_vm.currentLang.language_code},[_c('span',{staticClass:"flag lang-active"}),_vm._v(" "),_c('span',{staticClass:"lang-label ellipsis"},[_vm._v(_vm._s(_vm.currentLang.caption))])]),_vm._v(" "),_c('div',{staticClass:"yb-icon-arrow",attrs:{"data-v-147931e8":""}})]),_vm._v(" "),(_vm.showLangActive)?_c('div',{staticClass:"wrap-language",attrs:{"data-v-147931e8":""}},[_c('div',{staticClass:"triangle",attrs:{"data-v-147931e8":""}}),_vm._v(" "),_vm._l((_vm.langSelect),function(langData,langKey){return [_c('div',{staticClass:"item ellipsis",class:{'active': langData.caption == _vm.currentLang.caption},attrs:{"data-v-147931e8":""},on:{"click":function($event){return _vm.changeLanguage(langData.id)}}},[_c('div',{class:langData.language_code},[_c('span',{staticClass:"flag",attrs:{"data-v-147931e8":""}}),_vm._v(_vm._s(langData.caption)+"\n                                ")])])]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"popup-wrap odds_dropdown showOddsActive",class:{ 'active': _vm.showOddsActive },attrs:{"data-v-0e13a278":""}},[_c('div',{staticClass:"text-wrap",attrs:{"data-v-0e13a278":""},on:{"click":function($event){return _vm.clickShow('sodds')}}},[_c('div',{staticClass:"popup-text",attrs:{"data-v-0e13a278":"","title":""}},[_vm._v(_vm._s(_vm.oddTypesList[_vm.selectedOdd.toUpperCase()].lang))]),_vm._v(" "),_c('div',{staticClass:"yb-icon-arrow",attrs:{"data-v-0e13a278":""}})]),_vm._v(" "),_c('div',{staticClass:"relative-position odds_dropdown",attrs:{"data-v-0e13a278":""}},[_c('div',{staticClass:"item-wrap",staticStyle:{"width":"min-content"},attrs:{"data-v-0e13a278":""}},[_vm._l((_vm.oddTypesList),function(odd){return [_c('div',{staticClass:"item",class:{'active':_vm.selectedOdd == odd.key},staticStyle:{"width":"100%","text-align":"left"},attrs:{"data-v-0e13a278":""},on:{"click":function($event){return _vm.changeOdd(odd.key, $event)}}},[_vm._v(_vm._s(odd.lang))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"popup-wrap stheme",class:{ 'active': _vm.showThemeActive }},[_c('div',{staticClass:"text-wrap",on:{"click":function($event){return _vm.clickShow('stheme')}}},[_c('div',{staticClass:"popup-text",class:{ 'active': _vm.showThemeActive }},[(_vm.selectedTheme == 'AM')?[_vm._v("\n                                "+_vm._s(_vm.langList.am)+"\n                            ")]:[_vm._v("\n                                "+_vm._s(_vm.langList.pm)+"\n                            ")]],2),_vm._v(" "),_c('div',{staticClass:"yb-icon-arrow"})]),_vm._v(" "),_c('div',{staticClass:"relative-position"},[_c('div',{staticClass:"item-wrap"},[_c('div',{staticClass:"triangle"}),_vm._v(" "),_c('div',{staticClass:"item ellipsis",class:{ active: (_vm.selectedTheme == 'AM') },on:{"click":function($event){return _vm.changeTheme('AM')}}},[_vm._v(_vm._s(_vm.langList.am))]),_vm._v(" "),_c('div',{staticClass:"item ellipsis",class:{ active: (_vm.selectedTheme == 'PM') },on:{"click":function($event){return _vm.changeTheme('PM')}}},[_vm._v(_vm._s(_vm.langList.pm))])])])]),_vm._v(" "),(_vm.timeZone.format==1)?_c('div',{staticClass:"popup-wrap TimeZone_dropdown showTimeZoneActive",class:{ 'active': _vm.showTimeZoneActive },attrs:{"data-v-0e13a278":""}},[_c('div',{staticClass:"text-wrap",attrs:{"data-v-0e13a278":""},on:{"click":function($event){return _vm.clickShow('sTime')}}},[_c('div',{staticClass:"popup-text",attrs:{"data-v-0e13a278":"","title":""}},[_vm._v(_vm._s(_vm.selectedTimeZone))]),_vm._v(" "),_c('div',{staticClass:"yb-icon-arrow",attrs:{"data-v-0e13a278":""}})]),_vm._v(" "),_c('div',{staticClass:"relative-position TimeZone_dropdown",attrs:{"data-v-0e13a278":""}},[_c('div',{staticClass:"item-wrap",staticStyle:{"width":"min-content"},attrs:{"data-v-0e13a278":""}},[_vm._l((_vm.timeZone.list),function(dt,index){return [_c('div',{staticClass:"item",class:{'active':_vm.selectedTimeZone == index},staticStyle:{"width":"max-content"},attrs:{"data-v-0e13a278":""},on:{"click":function($event){return _vm.changeTimeZone(index, $event)}}},[_vm._v(_vm._s(index))])]})],2)])]):_vm._e()])])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-wrap pseudo"},[_c('div',{staticClass:"line",staticStyle:{"transform":"translateX(26px)","width":"36px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrap",attrs:{"id":"balancesRefresh"}},[_c('i',{staticClass:"q-icon icon-balance_refresh c-icon",staticStyle:{"font-size":"13px"},attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon q-icon c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}},[_c('img',{attrs:{"src":"assets/images/search-icon.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f62bfb5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(520);
function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f62bfb5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftBar_vue__ = __webpack_require__(146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b07ee90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leftBar_vue__ = __webpack_require__(327);
function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b07ee90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leftBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userInfo_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa8915b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userInfo_vue__ = __webpack_require__(322);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa8915b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportCategory_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f758c9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportCategory_vue__ = __webpack_require__(314);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f758c9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"150px"}},[(_vm.gameBannerStatus)?_c('div',[_c('div',{staticClass:"menu-item menu-fold1",class:[( _vm.isGameBannerSelected? 'active' : '')],staticStyle:{"padding-top":"10px","padding-bottom":"10px"},on:{"click":function($event){$event.preventDefault();return _vm.selectGameBanner()}}},[_c('div',{staticClass:"vrow items-center"},[_c('gameBanner',{attrs:{"position":'mini'}})],1),_vm._v(" "),_c('div',{staticClass:"items-right vrow",staticStyle:{"flex-wrap":"wrap"}},[_c('div',{staticStyle:{"line-height":"1","flex":"1 1 0%"}},[(_vm.selectedLang == 'zh_CN')?_c('span',{staticClass:"menu-text",domProps:{"innerHTML":_vm._s(_vm.gameBannerImage.bannerName_cn)}}):(_vm.selectedLang == 'zh_TW')?_c('span',{staticClass:"menu-text",domProps:{"innerHTML":_vm._s(_vm.gameBannerImage.bannerName_tw)}}):_c('span',{staticClass:"menu-text",domProps:{"innerHTML":_vm._s(_vm.gameBannerImage.bannerName_en)}})]),_vm._v(" "),_c('div',{staticClass:"col-right",staticStyle:{"min-width":"40px"}},[_c('span',{staticClass:"match-count yb-family-odds amount"},[_vm._v(_vm._s(_vm.gameBannerCountMatch(_vm.selectedMarket)))])])])])]):_vm._e(),_vm._v(" "),(_vm.specialEventStatus)?_c('div',[_c('div',{staticClass:"menu-item menu-fold1",class:[( _vm.specialEvent && !_vm.liveSchedule? 'active' : '')],staticStyle:{"padding-top":"10px","padding-bottom":"10px"},on:{"click":function($event){$event.preventDefault();return _vm.changeSport(_vm.specialEventList['sprtId'])}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"items-right vrow",staticStyle:{"flex-wrap":"wrap"}},[_c('div',{staticStyle:{"line-height":"1","flex":"1 1 0%"}},[_c('span',{staticClass:"menu-text"},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.SPECIAL_EVENT']))])]),_vm._v(" "),_vm._m(1)])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.sportList),function(sport){return [(sport.sprtId == 'N1')?_c('div',[_c('div',{staticClass:"menu-item menu-fold1",class:[( _vm.simpleSport == sport.sprtId && _vm.selectedMarket != _vm.market.inPlayMarket.key? 'active' : '')],staticStyle:{"padding-top":"10px","padding-bottom":"10px"},style:((_vm.sport_feature && _vm.countMatch('N1', _vm.selectedMarket)==0 && _vm.sportList[0]['sprtId']!='N1') ? 'display: none' : ''),on:{"click":function($event){$event.preventDefault();return _vm.changeSport(sport,true)}}},[_c('div',{staticClass:"vrow items-center"},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon",class:'icon_simple_'+sport.sprtId})]),_vm._v(" "),_c('div',{staticClass:"items-right vrow",staticStyle:{"flex-wrap":"wrap"}},[_c('div',{staticStyle:{"line-height":"1","flex":"1 1 0%"}},[_c('span',{staticClass:"menu-text"},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.SIMPLE_SOCCER']))])]),_vm._v(" "),_c('div',{staticClass:"col-right",staticStyle:{"min-width":"40px"}},[(_vm.comp_live(sport.sprtId))?_c('div',{staticClass:"live-text"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"match-count yb-family-odds amount"},[_vm._v(_vm._s(_vm.countMatch(sport.sprtId, _vm.selectedMarket)))])])])])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"menu-item menu-fold1",class:[(_vm.selectedSport.sprtId==sport.sprtId && _vm.selectedMarket != _vm.market.inPlayMarket.key && _vm.selectedMarket != _vm.market.hotSportMarket.key  && _vm.selectedBettype.tmpltId!=11 && !_vm.isGameBannerSelected && _vm.simpleSport == null && !_vm.liveSchedule ? 'active' : '')],staticStyle:{"padding-top":"10px","padding-bottom":"10px"},style:(_vm.countMatch(sport.sprtId, _vm.selectedMarket)==0 && sport.sprtId!=((_vm.sport_feature) ? _vm.sportList[0]['sprtId'] : 'N1') ? 'display: none   ':''),on:{"click":function($event){$event.preventDefault();return _vm.changeSport(sport, false)}}},[_c('div',{staticClass:"vrow items-center"},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon img36",class:sport.sprtId})]),_vm._v(" "),_c('div',{staticClass:"items-right vrow",staticStyle:{"flex-wrap":"wrap"}},[_c('div',{staticStyle:{"line-height":"1","flex":"1 1 0%"}},[_c('span',{staticClass:"menu-text",domProps:{"innerHTML":_vm._s(sport.sprtLang)}})]),_vm._v(" "),_c('div',{staticClass:"col-right",staticStyle:{"min-width":"40px"}},[(_vm.comp_live(sport.sprtId))?_c('div',{staticClass:"live-text"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"match-count yb-family-odds amount"},[_vm._v(_vm._s(_vm.countMatch(sport.sprtId, _vm.selectedMarket)))])])])]),_vm._v(" "),(_vm.selectedSport.sprtId == sport.sprtId && _vm.selectedMarket != _vm.market.inPlayMarket.key && _vm.selectedMarket != _vm.market.hotSportMarket.key && _vm.showOdds && _vm.selectedBettype.tmpltId!=11)?_c('div',{staticClass:"menu-fold2-wrap open",attrs:{"data-v-20a71bf8":""}},[_vm._l((_vm.bettypeList),function(bettype,key){return [_c('div',{staticClass:"menu-item menu-fold2",class:_vm.sportItem(bettype.betTypId),on:{"click":function($event){$event.preventDefault();return _vm.changeBettype(bettype)}}},[_c('div',{staticClass:"row items-center relative-position"},[_c('span',{staticClass:"menu-point"}),_vm._v(" "),(_vm.selectedSport.sprtId=='G1' && bettype.betTypId=='7')?_c('span',{staticClass:"betTypeName",attrs:{"title":_vm.lang.sportAllBet['ALL_BET.LBL_BETTYPE_BASKETBALL']}},[_vm._v("\n                                "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_BETTYPE_BASKETBALL'])+"\n                            ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"betTypeName menu-text ellipsis",attrs:{"title":bettype.betTypLang}},[_vm._v(_vm._s(bettype.betTypLang))])]),_vm._v(" "),_c('div',{staticClass:"col-right relative-position",attrs:{"data-v-20a71bf8":""}},[_c('span',{staticClass:"match-count yb-family-odds",attrs:{"data-v-20a71bf8":""}},[_vm._v(_vm._s(_vm.sportCount(sport.sprtId, bettype.betTypId, _vm.selectedMarket)))])])])]})],2):_vm._e()])]}),_vm._v(" "),(_vm.showOutright)?[(_vm.otrBetType!=undefined)?_c('div',{staticClass:"menu-item menu-top menu-virtual menu-border",class:[(_vm.selectedBettype.tmpltId==11 ? 'active' : '')],on:{"click":function($event){$event.preventDefault();return _vm.changeBettype(_vm.otrBetType,11)}}},[_c('span',{staticClass:"q-icon icon c-icon sport-img img36",staticStyle:{"width":"18px","height":"18px","background-position":"0px -943.5px"},attrs:{"data-v-0d68232c":""}}),_vm._v(" "),_c('div',{staticClass:"menu-name col"},[_vm._v(_vm._s(_vm.lang.configLang['CONFIG_LANG.LBL_GAME_OUTRIGHT']))]),_vm._v(" "),_c('div',{staticClass:"col-right"},[_c('span',{staticClass:"match-count yb-family-odds"},[_vm._v(_vm._s(_vm.countOTR()))])])]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vrow items-center"},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon img36 SP"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-right",staticStyle:{"min-width":"40px"}},[_c('span',{staticClass:"match-count yb-family-odds amount"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bet-menu-wrap",class:{'bet-menu-left':!_vm.sportMiniBet.toggle},style:({'width':_vm.sportMiniBet.toggle?'':'221px;'})},[_c('div',{staticClass:"bottom-wrap",class:{'bottom-confirm':_vm.betting.success||_vm.betting.betcombosuccess||_vm.betting.pending||_vm.betting.reject}},[((_vm.isBetCombo && _vm.betting.betcomboerror && _vm.betting.betcomboerror.code=='N-4000-N') || (_vm.isMulp && _vm.betting.error && _vm.betting.error.code != undefined))?_c('div',{staticClass:"remove-invalid-item cursor-pointer text-center",on:{"click":function($event){return _vm.clearInvalidBetCombo()}}},[_vm._v("\n        "+_vm._s(_vm.betLang["BETTING.LBL_REMOVE_INVALID"])+"\n        "),_c('i',{staticClass:"bet-del q-icon icon-del c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e(),_vm._v(" "),(!_vm.isMulp)?[(!_vm.betting.success)?_c('div',{staticClass:"bet-message text-center",class:{'bet-err':_vm.betting.error},style:({'height':_vm.betting.error?'auto':''})},[(_vm.betFormOddChange)?[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_ODDS_CHANGE"]))]:_vm._e(),_vm._v(" "),(_vm.betFormHdpChange)?[(_vm.betFormOddChange)?[_vm._v(",")]:_vm._e(),_vm._v("\n            "+_vm._s(_vm.betLang["BETTING.LBL_HANDICAP_CHANGE"])+"\n          ")]:_vm._e(),_vm._v(" "),(_vm.betting.sErr)?[_vm._v("\n            "+_vm._s(_vm.betting.sErr.message)),_c('br'),_vm._v(_vm._s(_vm.betting.sErr.code)+"\n          ")]:(_vm.betting.error)?[_vm._v("\n            "+_vm._s(_vm.betting.error.message)),_c('br'),_vm._v(_vm._s(_vm.betting.error.code)+"\n          ")]:(_vm.jsError.error)?[_vm._v(_vm._s(_vm.jsError.msg))]:_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.betting.success && !_vm.betting.betcombosuccess && !_vm.betting.pending && !_vm.betting.reject)?_c('div',{staticClass:"full-width"},[_c('div',{staticClass:"vrow bet-buttons"},[_c('div',{staticClass:"full-width cursor-pointer",class:_vm.getSubmitStyle(),on:{"click":function($event){return _vm.confirmBetForm()}}},[(_vm.betFormOddChange || _vm.betFormHdpChange)?[_vm._v("\n                "+_vm._s(_vm.betLang["BETTING.LBL_ACCEPT_CHANGE"])+"\n              ")]:[_vm._v("\n                "+_vm._s(_vm.betLang["BETTING.LBL_BET"])+"\n              ")]],2),_vm._v(" "),(!_vm.betting.success && !_vm.betting.betcombosuccess && !_vm.betting.pending && !_vm.betting.reject)?_c('div',{staticClass:"full-width cursor-pointer bet-delete-all",on:{"click":function($event){return _vm.cancelBetForm()}}},[_vm._v(" \n              "+_vm._s(_vm.betLang['BETTING.LBL_CANCEL'])+"\n            ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.betting.success && !_vm.betting.betcombosuccess && !_vm.betting.pending && !_vm.betting.reject)?_c('div',{staticClass:"full-width bet-foot-menu"},[(_vm.showAutoInfo() && _vm.account.oneWallet!='1')?_c('label',{staticClass:"vrow check-bet-prefer cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autoAccBetterOdd),expression:"autoAccBetterOdd"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.autoAccBetterOdd)?_vm._i(_vm.autoAccBetterOdd,null)>-1:(_vm.autoAccBetterOdd)},on:{"change":function($event){var $$a=_vm.autoAccBetterOdd,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.autoAccBetterOdd=$$a.concat([$$v]))}else{$$i>-1&&(_vm.autoAccBetterOdd=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.autoAccBetterOdd=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.autoAccBetterOdd}}),_vm._v("\n            "+_vm._s(_vm.betLang["BETTING.LBL_AUTO_ACCEPT_BETTER_ODD"])+"\n          ")]):_vm._e(),_vm._v(" "),(!_vm.isBetCombo || (_vm.isBetCombo && Object.keys(_vm.betForm).length==1))?_c('label',{staticClass:"vrow check-box cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rememberStake),expression:"rememberStake"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.rememberStake)?_vm._i(_vm.rememberStake,null)>-1:(_vm.rememberStake)},on:{"change":function($event){var $$a=_vm.rememberStake,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rememberStake=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rememberStake=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rememberStake=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.rememberStake}}),_vm._v("\n            "+_vm._s(_vm.betLang["BETTING.LBL_REMEMBER_STAKE"])+"\n          ")]):_vm._e()]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.betting.success || _vm.betting.betcombosuccess || _vm.betting.pending || _vm.betting.reject)?[(_vm.isMulp)?_c('div',{staticClass:"bet-confirm-message text-center yb-fontsize12",class:_vm.getBetConfirmClass()},[(_vm.betting.success || _vm.betting.betcombosuccess)?[_vm._v("\n            "+_vm._s(_vm.betLang["BETTING.LBL_BET_CONFIRM"])+"\n          ")]:(_vm.betting.pending)?[_vm._v("\n            "+_vm._s(_vm.betLang['BETTING.LBL_PENDING_BET'])+"\n          ")]:[_vm._v("\n            "+_vm._s(_vm.betLang["BETTING.LBL_REJECT_B"])+"\n          ")]],2):_vm._e(),_vm._v(" "),((_vm.betFormOddChange || _vm.betFormHdpChange || _vm.allowErrBetAgain) && !_vm.isMulp)?[_c('div',{staticClass:"full-width bet-foot-complete mt10"},[_c('div',{staticClass:"full-width cursor-pointer bet-accpet",on:{"click":function($event){return _vm.confirmBetForm()}}},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_ACCEPT_CHANGE"]))])]),_vm._v(" "),_c('div',{staticClass:"full-width bet-foot-save"},[_c('div',{staticClass:"full-width cursor-pointer bet-delete-all",on:{"click":function($event){return _vm.cancelBetForm()}}},[_vm._v("\n                "+_vm._s(_vm.betLang['BETTING.LBL_CANCEL'])+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"full-width bet-foot-menu"},[(_vm.showAutoInfo() && _vm.account.oneWallet!='1')?_c('label',{staticClass:"vrow check-bet-prefer cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autoAccBetterOdd),expression:"autoAccBetterOdd"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.autoAccBetterOdd)?_vm._i(_vm.autoAccBetterOdd,null)>-1:(_vm.autoAccBetterOdd)},on:{"change":function($event){var $$a=_vm.autoAccBetterOdd,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.autoAccBetterOdd=$$a.concat([$$v]))}else{$$i>-1&&(_vm.autoAccBetterOdd=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.autoAccBetterOdd=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.autoAccBetterOdd}}),_vm._v("\n              "+_vm._s(_vm.betLang["BETTING.LBL_AUTO_ACCEPT_BETTER_ODD"])+"\n            ")]):_vm._e(),_vm._v(" "),(!_vm.isBetCombo || (_vm.isBetCombo && Object.keys(_vm.betForm).length==1))?_c('label',{staticClass:"vrow check-box cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rememberStake),expression:"rememberStake"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.rememberStake)?_vm._i(_vm.rememberStake,null)>-1:(_vm.rememberStake)},on:{"change":function($event){var $$a=_vm.rememberStake,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rememberStake=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rememberStake=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rememberStake=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.rememberStake}}),_vm._v("\n              "+_vm._s(_vm.betLang["BETTING.LBL_REMEMBER_STAKE"])+"\n            ")]):_vm._e()])]:[_c('div',{staticClass:"full-width bet-foot-complete mt10",on:{"click":function($event){return _vm.closeBetForm()}}},[_c('div',{staticClass:"full-width cursor-pointer bet-confirm"},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_CONFIRM"]))])]),_vm._v(" "),_c('div',{staticClass:"full-width bet-foot-save",on:{"click":function($event){return _vm.retainSelection()}}},[_c('div',{staticClass:"full-width cursor-pointer bet-save-items"},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_RETAIN_SELECTION"]))])])],_vm._v(" "),(_vm.promotionFlag && !_vm.isMulp && (_vm.betting.success || _vm.betting.betcombosuccess || _vm.betting.pending) && _vm.promotionShowJoinSuccess)?[_c('div',{staticClass:"promotion_joined_box"},[_c('div',{staticClass:"promotion_joined"},[_vm._v(_vm._s(_vm.langList.promotion['promotion.promotion_congrats_join']))]),_vm._v(" "),_c('div',{staticClass:"promotion_joined_img"})])]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.isMulp && !_vm.betting.success)?[_c('hr',{staticClass:"q-separator bet-mix-separator q-separator q-separator--horizontal",attrs:{"aria-orientation":"horizontal"}}),_vm._v(" "),_c('div',{staticClass:"full-width pt15"},[_c('div',{staticClass:"vrow bet-total"},[_c('div',{staticClass:"col bet-total-left"},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_TOTAL_BET"])+" "+_vm._s(_vm.countTotalStakePayout('totalBet')))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-total-right"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.countTotalStakePayout('totalStake'),2)))])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-total"},[_c('div',{staticClass:"col bet-total-left"},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_EST_WIN"])+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-total-right bet-gold-text"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.countTotalStakePayout('possiblePayout'),2)))])]),_vm._v(" "),_c('hr',{staticClass:"q-separator bet-mix-separator q-separator q-separator--horizontal",attrs:{"aria-orientation":"horizontal"}}),_vm._v(" "),_c('div',{staticClass:"bet-message text-center",class:{'bet-err':_vm.betting.error},staticStyle:{"height":"auto","line-height":"normal","margin":"15px 0"}},[(_vm.betting.minMax!= undefined && Object.keys(_vm.betForm).length < _vm.betting.minMax.minCombo)?[_vm._v("\n              "+_vm._s(_vm.minComboCaption())+"\n            ")]:(_vm.betting.sErr)?[_vm._v("\n              "+_vm._s(_vm.betting.sErr.message)),_c('br'),_vm._v(_vm._s(_vm.betting.sErr.code)+"\n            ")]:(_vm.betting.error)?[_vm._v("\n              "+_vm._s(_vm.betting.error.message)),_c('br'),_vm._v(_vm._s(_vm.betting.error.code)+"\n            ")]:(_vm.jsError.error)?[_vm._v(_vm._s(_vm.jsError.msg))]:(_vm.mulpJsErr.error)?[_vm._v(_vm._s(_vm.mulpJsErr.msg))]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vrow bet-buttons"},[_c('div',{staticClass:"full-width"},[_c('div',{staticClass:"full-width cursor-pointer bet-submit",class:{'bet-submit2':(_vm.betting.error || _vm.betting.minMax==undefined || Object.keys(_vm.betForm).length < _vm.betting.minMax.minCombo || _vm.disableBet)},on:{"click":function($event){return _vm.confirmBetForm()}}},[(_vm.betFormOddChange || _vm.betFormHdpChange)?[_vm._v("\n                  "+_vm._s(_vm.betLang["BETTING.LBL_ACCEPT_CHANGE"])+"\n                ")]:[_vm._v("\n                  "+_vm._s(_vm.betLang["BETTING.LBL_BET"])+"\n                ")]],2)]),_vm._v(" "),_c('div',{staticClass:"full-width"},[_c('div',{staticClass:"full-width cursor-pointer bet-delete-all",on:{"click":function($event){return _vm.cancelBetForm()}}},[_vm._v(" \n                "+_vm._s(_vm.betLang["BETTING.LBL_REMOVE_ALL"])+"   \n                "),_c('i',{staticClass:"bet-del q-icon icon-del c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])]),_vm._v(" "),_c('div',{staticClass:"full-width bet-foot-menu mulp-bet-foot-menu"},[(_vm.showAutoInfo())?_c('label',{staticClass:"vrow check-bet-prefer cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autoAccBetterOdd),expression:"autoAccBetterOdd"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.autoAccBetterOdd)?_vm._i(_vm.autoAccBetterOdd,null)>-1:(_vm.autoAccBetterOdd)},on:{"change":function($event){var $$a=_vm.autoAccBetterOdd,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.autoAccBetterOdd=$$a.concat([$$v]))}else{$$i>-1&&(_vm.autoAccBetterOdd=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.autoAccBetterOdd=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.autoAccBetterOdd}}),_vm._v("\n                "+_vm._s(_vm.betLang["BETTING.LBL_AUTO_ACCEPT_BETTER_ODD"])+"\n              ")]):_vm._e()])])])]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bet-view",attrs:{"id":"betviewScrollx"}},[(!_vm.isMulp)?_c('div',{staticClass:"bet-mode-zone",attrs:{"id":"betModeZone"}},[_c('div',{staticClass:"left"},[_c('span',[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_SINGLE']))]),_vm._v(" "),_c('span',{staticClass:"bet-single-count"},[_vm._v("\n        "+_vm._s(_vm.betFormList.length)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.allowComboBet && _vm.selectedBettype.betTypId!='5' && _vm.account.oneWallet!='1')?_c('label',{staticClass:"check-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isBetCombo),expression:"isBetCombo"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isBetCombo)?_vm._i(_vm.isBetCombo,null)>-1:(_vm.isBetCombo)},on:{"change":function($event){var $$a=_vm.isBetCombo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isBetCombo=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isBetCombo=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isBetCombo=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.isBetCombo},staticStyle:{"margin-right":"5px"}}),_vm._v("\n        "+_vm._s(_vm.betLang['BETTING.LBL_COMBO'])+"\n      ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.isMulp)?_c('div',{staticClass:"bet-single",attrs:{"data-container":"single-container","id":"singleContainer"}},[_vm._l((_vm.betFormList),function(data,key){return (_vm.betFormList)?[_c('div',{staticClass:"q-card q-card--flat no-shadow",class:_vm.bettingResultClass(data, key)},[_c('div',{staticClass:"q-card__section q-card__section--vert",class:{'bet-item':_vm.chkBettingSuccess(data) || _vm.chkBetPending(data)}},[_c('div',{staticClass:"vrow",class:{'first-row now-wrap':_vm.chkBettingSuccess(data)}},[_c('div',{staticClass:"col bet-league-name"},[_vm._v(_vm._s(data.league))]),_vm._v(" "),_c('div',{staticClass:"col-auto",class:{'col-delete': _vm.chkIsBetting(data, 'del'),'bet-icon-info': _vm.chkBettingSuccess(data)},on:{"click":function($event){return _vm.deleteMatch(data.eventObj.eveid, data, key)}}},[(_vm.chkIsBetting(data) && !_vm.wgNotsuccessreject.includes(data.wgStatus))?[_c('i',{staticClass:"bet-del q-icon icon-del c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]:(data.wgStatus=='2' || data.wgStatus=='0')?[_c('i',{staticClass:"q-icon icon-success c-icon",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true","role":"presentation"}})]:_vm._e(),_vm._v(" "),(data.wgStatus=='1')?[_c('span',{staticClass:"pending_wager",attrs:{"id":"dg_icon"}})]:_vm._e()],2)]),_vm._v(" "),(data.betType != '14')?_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-against"},[_c('span',{staticClass:"home-vs-away"},[_c('span',{domProps:{"innerHTML":_vm._s(data.ta)}}),_vm._v(" "),_c('span',{staticClass:"bet-pk"},[_vm._v("v")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(data.tb)}})]),_vm._v(" "),(data.eventObj && data.eventObj.rbinfo)?_c('span',{staticClass:"score"},[(data.sprtid=='1')?[_vm._v("\n                  ("+_vm._s(data.rbscoa)+"-"+_vm._s(data.rbscob)+")\n                ")]:_vm._e()],2):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.chkBettingSuccess(data))?_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col match-time"},[(_vm.selectedLang==2 || _vm.selectedLang==3)?[_vm._v("\n                "+_vm._s(_vm._f("date")(data.eventObj.dt,'MMMDo HH:mm'))+"\n              ")]:[_vm._v("\n                "+_vm._s(_vm._f("date")(data.eventObj.dt,'MM/DD HH:mm'))+"\n              ")]],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bet-content"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-play-game"},[_c('label',{staticClass:"bet-play-text"},[(data.sprtid == 255)?[_c('span',{staticClass:"sport-name",staticStyle:{"display":"inline-flex","align-items":"center"}},[_c('label',{staticClass:"sport-img img36 SP"}),_vm._v("["+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.SPECIAL_EVENT'])+"]")]),_c('br')]:_vm._e(),_vm._v(" "),(data.eventObj && data.eventObj.rbstatus)?_c('span',{staticClass:"bet-match-playing"},[_vm._v("["+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_LIVE"])+"]")]):_vm._e(),_vm._v(" \n                  "+_vm._s(_vm.getPtBtCapt(data))+"\n                  "),_c('span',{staticClass:"bet-handicap-name",staticStyle:{"height":"15px !important"}},[_vm._v(" "+_vm._s(_vm.getOddsTypeCap(data))+" ")])],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"col bet-play-team yb-fontsize13"},[_c('div',{staticClass:"bet-team-handicap"},[(data.betType == '2' || data.betType == '9' || data.betType == '46' || data.betType == '47' || data.betType == '48' || data.betType == '49' || data.betType=='80' || data.betType=='81' || data.betType=='82' || data.betType=='83')?[(data.tbet == 'a')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_OVER"])+"\n                    ")]:(data.tbet == 'b')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_UNDER"])+"\n                    ")]:_vm._e()]:(data.betType == '32' || data.betType == '33' || data.betType == '76' || data.betType == '79')?[(data.tbet == 'a')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_YES"])+"\n                    ")]:(data.tbet == 'b')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NO"])+"\n                    ")]:_vm._e()]:(data.betType == '21' || data.betType == '27' || data.betType == '36' || data.betType == '37' || data.betType == '38' || data.betType == '39' || data.betType == '40' || data.betType == '41' || data.betType == '42' || data.betType == '43' || data.betType == '44' || data.betType == '45')?[(data.tbet == 'a')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME"])+" \n                    ")]:(data.tbet == 'b')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY"])+"\n                    ")]:(data.tbet == 'x')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                    ")]:_vm._e(),_vm._v(" "),(data.betType == '21' || data.betType == '27')?[_vm._v("\n                      ("+_vm._s(_vm.h1x2Header(data.hdp, data.tbet))+")\n                    ")]:_vm._e()]:(data.betType == '50' || data.betType == '51')?[(data.tbet == 'h1')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1"])+"\n                    ")]:(data.tbet == 'h2')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2"])+"\n                    ")]:(data.tbet == 'h3')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3"])+"\n                    ")]:(data.tbet == 'h4')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4M"])+"\n                    ")]:(data.tbet == 'a1')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1"])+"\n                    ")]:(data.tbet == 'a2')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2"])+"\n                    ")]:(data.tbet == 'a3')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3"])+"\n                    ")]:(data.tbet == 'a4')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4M"])+"\n                    ")]:(data.tbet == 'sd')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AS"])+"\n                    ")]:(data.tbet == 'ng')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                    ")]:_vm._e()]:(data.betType == '77' || data.betType == '78')?[(data.tbet == 'h1')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1R"])+"\n                    ")]:(data.tbet == 'h2')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2R"])+"\n                    ")]:(data.tbet == 'h3')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3R"])+"\n                    ")]:(data.tbet == 'h4')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4RM"])+"\n                    ")]:(data.tbet == 'a1')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1R"])+"\n                    ")]:(data.tbet == 'a2')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2R"])+"\n                    ")]:(data.tbet == 'a3')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3R"])+"\n                    ")]:(data.tbet == 'a4')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4RM"])+"\n                    ")]:(data.tbet == 'sd')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_BB_AS"])+"\n                    ")]:(data.tbet == 'ng')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                    ")]:_vm._e()]:(data.betType == '28' || data.betType == '29' || data.betType == '30' || data.betType == '31')?[(data.tbet == 'a')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1HT"])+"\n                    ")]:(data.tbet == 'b')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2HT"])+"\n                    ")]:(data.tbet == 'x')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                    ")]:_vm._e()]:(data.betType == '25')?[(data.tbet == 'h_1_5')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                    ")]:(data.tbet == 'h_6_10')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                    ")]:(data.tbet == 'h_11_15')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                    ")]:(data.tbet == 'h_16_20')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                    ")]:(data.tbet == 'h_21_25')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                    ")]:(data.tbet == 'h_26_x')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.modifyTitle('h_26_x'))+"\n                    ")]:(data.tbet == 'a_1_5')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                    ")]:(data.tbet == 'a_6_10')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                    ")]:(data.tbet == 'a_11_15')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                    ")]:(data.tbet == 'a_16_20')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                    ")]:(data.tbet == 'a_21_25')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                    ")]:(data.tbet == 'a_26_x')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.modifyTitle('a_26_x'))+"\n                    ")]:_vm._e()]:(data.betType == '52')?[(data.tbet == 'hf')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HFG"])+"\n                    ")]:(data.tbet == 'hl')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HLG"])+"\n                    ")]:(data.tbet == 'af')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AFG"])+"\n                    ")]:(data.tbet == 'al')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_ALG"])+"\n                    ")]:(data.tbet == 'ng')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                    ")]:_vm._e()]:(data.betType == '53' || data.betType == '54' || data.betType == '55' || data.betType == '56')?[(data.tbet == '0_5')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_05"])+"\n                    ")]:(data.tbet == '1_6')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_16"])+"\n                    ")]:(data.tbet == '2_7')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_27"])+"\n                    ")]:(data.tbet == '3_8')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_38"])+"\n                    ")]:(data.tbet == '4_9')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_49"])+"\n                    ")]:_vm._e()]:(data.betType == '19' || data.betType == '20')?[(data.tbet == 'ha')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_AWAY"])+"\n                    ")]:(data.tbet == 'hd')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_DRAW"])+"\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY_OR_DRAW"])+"\n                    ")]]:(data.betType == '57' || data.betType == '58')?[(data.tbet == 'ng0')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_0"])+"\n                    ")]:(data.tbet == 'ng1')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1"])+"\n                    ")]:(data.tbet == 'ng2')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2"])+"\n                    ")]:(data.tbet == 'ng3')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_3"])+"\n                    ")]:(data.tbet == 'ng4')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_4"])+"\n                    ")]:(data.tbet == 'ng5')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_5"])+"\n                    ")]:(data.tbet == 'ng6')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_6more"])+"\n                    ")]:_vm._e()]:(data.betType == '59' || data.betType == '73')?[(data.tbet == 'ha')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                      "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                          "+_vm._s(_vm.getHdpCapt(data))+"\n                        ")])],_vm._v("\n                       "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                    ")]:(data.tbet == 'hb')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                      "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                          "+_vm._s(_vm.getHdpCapt(data))+"\n                        ")])],_vm._v("\n                       "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                    ")]:(data.tbet == 'aa')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                      "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                          "+_vm._s(_vm.getHdpCapt(data))+"\n                        ")])],_vm._v("\n                       "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                    ")]:(data.tbet == 'ab')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                      "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                          "+_vm._s(_vm.getHdpCapt(data))+"\n                        ")])],_vm._v("\n                       "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                    ")]:_vm._e()]:(data.betType == '60' || data.betType == '61')?[(data.tbet == 'ha')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                      "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                          "+_vm._s(_vm.getHdpCapt(data))+"\n                        ")])],_vm._v("\n                       "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                    ")]:(data.tbet == 'hb')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                      "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                          "+_vm._s(_vm.getHdpCapt(data))+"\n                        ")])],_vm._v("\n                       "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                    ")]:(data.tbet == 'aa')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                      "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                          "+_vm._s(_vm.getHdpCapt(data))+"\n                        ")])],_vm._v("\n                       "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                    ")]:(data.tbet == 'ab')?[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                      "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                          "+_vm._s(_vm.getHdpCapt(data))+"\n                        ")])],_vm._v("\n                       "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                    ")]:_vm._e()]:[_c('span',{domProps:{"innerHTML":_vm._s(data.tbetcapt)}})],_vm._v(" "),(data.betType=="1" || data.betType=="2" || data.betType=="8" || data.betType=="9" || data.betType=="46" || data.betType=="47" || data.betType=="48" || data.betType=="49" || data.betType=="63" || data.betType=="64" || data.betType=="68" || data.betType=="69" || data.betType=="80" || data.betType=="81" || data.betType=="82" || data.betType=="83")?[(!_vm.chkIsBetting(data))?[_vm._v(_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                        "+_vm._s(_vm.getHdpCapt(data))+"\n                      ")])]]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-odds-value",class:_vm.getOddChange(data)},[_c('span',{staticClass:"odds-value yb-number-bold",staticStyle:{"float":"left"}},[_c('span',[_vm._v("@")]),_vm._v(" "),(data.betType == 7 || data.betType == 16)?[_vm._v("\n                    "+_vm._s(new Number(parseFloat(data.odd)))+"\n                  ")]:[(_vm.betting.success)?[_vm._v("\n                      "+_vm._s(_vm.getDecimalDisplay(_vm.betting.success.data.betting[key].odd, _vm.betting.success.data.betting[key].sprtid))+"\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm.getDecimalDisplay(data.odd, data.sprtid))+"\n                    ")]]],2)]),_vm._v(" "),_c('div',{staticClass:"auto-col"},[((_vm.betting.error && _vm.betting.error.code=='N-4000-N') || (_vm.isBetCombo && data.error && data.error.code=='N-4000-N'))?_c('span',{staticClass:"invalid"},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang["ALL_BET.BET_CLOSE"])+"\n                ")]):_vm._e(),_vm._v(" "),(data.wgStatus=='-1')?_c('span',{staticClass:"invalid"},[_vm._v("\n                  "+_vm._s(_vm.betLang["BETTING.LBL_REJECT_B"])+"\n                ")]):_vm._e()])])]),_vm._v(" "),(_vm.chkIsBetting(data, 'input'))?_c('div',{staticClass:"vrow bet-single-input"},[_c('div',{staticClass:"col relative-position",attrs:{"data-check-money":"0"}},[((_vm.betting.error && _vm.betting.error.code=='N-4000-N') || (_vm.isBetCombo && data.error && data.error.code=='N-4000-N'))?_c('div',{staticClass:"cathectic-shade"}):_vm._e(),_vm._v(" "),(!_vm.isBetCombo)?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.betAmount),expression:"betAmount"}],ref:"betAmount",refInFor:true,staticClass:"bet-input input-border singleInput",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.betMinMaxVal,"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","size":"8","maxlength":_vm.amountMaxLength},domProps:{"value":(_vm.betAmount)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.betAmount=$event.target.value}}}),_vm._v(" "),(_vm.betAmount.length>0)?_c('div',{staticClass:"bet-input-close",on:{"click":function($event){return _vm.clearInput()}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.betComboAmount[key].value),expression:"betComboAmount[key].value"}],ref:'betAmount'+key,refInFor:true,staticClass:"bet-input input-border betComboInput",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.eventBetMinMax(data),"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","size":"8","maxlength":_vm.amountMaxLength,"disabled":data.error},domProps:{"value":(_vm.betComboAmount[key].value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.betComboAmount[key], "value", $event.target.value)},function($event){return _vm.setbetComboKeyboard(key)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)}}}),_vm._v(" "),(Object.keys(_vm.betComboAmount[key].value).length>0)?_c('div',{staticClass:"bet-input-close",on:{"click":function($event){return _vm.clearInput(key)}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()]],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vrow bet-win yb-fontsize12"},[(_vm.chkIsBetting(data))?[_c('div',{staticClass:"col df-jb"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"])+" ")]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-money yb-number-bold"},[(_vm.isBetCombo)?[_vm._v("\n                  "+_vm._s(_vm._f("decimal")(_vm.betPossiblePayout(key),2))+"\n                ")]:[_vm._v("\n                  "+_vm._s(_vm._f("decimal")(_vm.possiblePayout,2))+"\n                ")]],2)]:(_vm.chkBettingSuccess(data) || _vm.chkBetPending(data))?[_c('div',{staticClass:"col",staticStyle:{"height":"18px"}},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_STAKE']))]),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"height":"18px","max-width":"100px"}},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"]))])]:_vm._e()],2),_vm._v(" "),(_vm.promotionFlag && !((_vm.betting.success || (_vm.isBetCombo && _vm.wgSuccess.includes(data.wgStatus))) && !data.error) && _vm.isSportValidPromo(data.eventObj, data.betType) && !_vm.promotionBetStatus)?[_c('div',{staticClass:"promotion_join_box"},[_c('div',{staticClass:"promotion_join_img"}),_vm._v(" "),_c('div',{staticClass:"promotion_join"},[_vm._v(_vm._s(_vm.langList.promotion['promotion.promotion_join_get']))])])]:_vm._e(),_vm._v(" "),(_vm.chkBettingSuccess(data) || _vm.chkBetPending(data))?_c('div',{staticClass:"vrow bet-win2 yb-fontsize12"},[_c('div',{staticClass:"col black-money-text"},[(_vm.chkBettingSuccess(data))?[(_vm.isBetCombo)?[_vm._v("\n                  "+_vm._s(_vm._f("decimal")(data.betAmt,2))+"\n                ")]:[_vm._v("\n                  "+_vm._s(_vm._f("decimal")(_vm.betting.success.data.betAmt,2))+"\n                ")]]:(!_vm.isBetCombo && _vm.chkBetPending(data))?[_vm._v(_vm._s(_vm._f("decimal")(_vm.betting.pending.data.betAmt,2)))]:[_vm._v(_vm._s(_vm._f("decimal")(data.betAmt,2)))]],2),_vm._v(" "),_c('div',{staticClass:"col-auto black-money-text"},[(!_vm.isBetCombo)?[_vm._v(_vm._s(_vm._f("decimal")(_vm.betSuccessPPayout(null, _vm.betting.selectedBetAllup),2)))]:[_vm._v(_vm._s(_vm._f("decimal")(_vm.betSuccessPPayout(data, _vm.betting.selectedBetAllup),2)))]],2)]):_vm._e()],2),_vm._v(" "),(_vm.chkIsBetting(data, 'keyboard'))?_c('div',{staticClass:"bet-keyboard-zone q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow bet-keyboard bet-keyboard-content"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"q-gutter-xs keyboard-zone"},[_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.min, key, 'min')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.min, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable':_vm.checkAllowKeyboard(data, _vm.keyboardAllow.min, key, 'min')}},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.min))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.med, key, 'med')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.med, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.med, key, 'med')}},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.med))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big, key, 'big')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable':_vm.checkAllowKeyboard(data, _vm.keyboardAllow.big, key, 'big')}},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big2, key, 'big2')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big2, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big2, key, 'big2')}},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big2))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big3, key, 'big3')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big3, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big3, key, 'big3')}},[_vm._v("+"+_vm._s(_vm.commasAmount(_vm.betting.betAmountOption.big3)))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn':_vm.isBetCombo},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.max, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable':_vm.isBetCombo}},[_vm._v("\n                    "+_vm._s(_vm.langList.sportMinibetLang['SPORT_MINIBET.MAX'])+"\n                  ")])])])])])]):_vm._e()]),_vm._v(" "),(!_vm.isBetCombo && _vm.wgSts.includes(data.wgStatus) || (_vm.isBetCombo && _vm.checkShowErrMsg(data, _vm.jsError, key)))?_c('div',{staticClass:"bet-confirm-message text-center yb-fontsize12 ab",class:_vm.getBetConfirmClass(data, key)},[(data.wgStatus==1)?[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_PENDING_BET']))]:((_vm.betting.success || (_vm.isBetCombo && _vm.wgSuccess.includes(data.wgStatus))) && !data.error)?[_vm._v("\n          "+_vm._s(_vm.betLang['BETTING.LBL_BET_CONFIRM'])+"\n        ")]:[(data.oddChg)?[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_ODDS_CHANGE"]))]:_vm._e(),_vm._v(" "),(data.hdpChg)?[(data.oddChg)?[_vm._v(",")]:_vm._e(),_vm._v("\n            "+_vm._s(_vm.betLang["BETTING.LBL_HANDICAP_CHANGE"])+"\n          ")]:(data.error && data.error.code!='N-4000-N')?[_vm._v("\n            "+_vm._s(data.error.message)),_c('br'),_vm._v(_vm._s(data.error.code)+"\n          ")]:(!_vm.isBetCombo && _vm.jsError.error)?[_vm._v("\n            "+_vm._s(_vm.jsError.msg)+"\n          ")]:(_vm.isBetCombo && (_vm.betCombo_jsError[key]!=undefined && _vm.betCombo_jsError[key].error))?[_vm._v("\n            "+_vm._s(_vm.betCombo_jsError[key].msg)+"\n          ")]:_vm._e()]],2):_vm._e()]:_vm._e()}),_vm._v(" "),(_vm.isBetCombo && _vm.betFormList.length>1 && !_vm.betting.betcombosuccess && !_vm.betting.pending)?_c('div',{staticClass:"relative-position bet-multiple bet-card q-card q-card--flat no-shadow",staticStyle:{"margin-top":"5px"},attrs:{"id":"betMultiple","is_forward":"-1"}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.MULTI_SINGLES"]))])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-multiple-input yb-flex-nowrap"},[_c('div',{staticClass:"col bet-count"},[_c('span',[_vm._v(_vm._s(_vm.betFormList.length))]),_vm._v(" "),_c('span',{staticClass:"operation-symbol"},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"col-auto right-input",attrs:{"data-check-money":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allBetComboAmount),expression:"allBetComboAmount"}],ref:"betAmount",staticClass:"bet-input input-border",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.betMinMaxVal,"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","size":"8","maxlength":_vm.amountMaxLength},domProps:{"value":(_vm.allBetComboAmount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.allBetComboAmount=$event.target.value},function($event){return _vm.setALLbetComboAmount()}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)}}}),_vm._v(" "),(_vm.allBetComboAmount!='')?_c('div',{staticClass:"bet-input-close",on:{"click":function($event){return _vm.clearInput(null, 'all')}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-win yb-fontsize12"},[_c('div',{staticClass:"col df-jb"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"])+" ")]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-money yb-number-bold"},[_vm._v("\n            "+_vm._s(_vm._f("decimal")(_vm.betPossiblePayout(),2))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-keyboard bet-keyboard-content"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"q-gutter-xs keyboard-zone"},[_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.min, 'all', 'min') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.min)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.min))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.med, 'all', 'med') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.med)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.med))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big, 'all', 'big') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big2, 'all', 'big2') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big2)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big2))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, 'all', 'big3') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big3)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.commasAmount(_vm.betting.betAmountOption.big3)))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn disable-key-btn",on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.max)}}},[_c('div',{staticClass:"keyboard-btn-text text-disable"},[_vm._v("\n                  "+_vm._s(_vm.langList.sportMinibetLang['SPORT_MINIBET.MAX'])+"\n                ")])])])])])])]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isMulp)?_c('div',{staticClass:"bet-mix height-full full-height bet-layout"},[_c('div',{staticClass:"auto-wrap no-wrap column",attrs:{"id":"mulpContainer"}},[_c('div',{staticClass:"scroll-wrap"},[(_vm.betting.success || _vm.betting.pending)?_c('div',{staticClass:"bet-mix-record"},[_vm._l((_vm.betFormList),function(data,key){return (_vm.betFormList)?[_c('div',{staticClass:"bet-mix-record-item-card q-card q-card--flat no-shadow",class:{'bet-mix-record-item-first':key==0}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-league-name"},[_vm._v(_vm._s(data.league))])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-against"},[_c('span',{staticClass:"home-vs-away"},[_c('span',{domProps:{"innerHTML":_vm._s(data.ta)}}),_c('span',{staticClass:"bet-pk"},[_vm._v("v")]),_c('span',{domProps:{"innerHTML":_vm._s(data.tb)}}),_vm._v(" "),(data.eventObj && data.eventObj.rbinfo)?[_vm._v("("+_vm._s(data.eventObj.rbinfo.scoa)+"-"+_vm._s(data.eventObj.rbinfo.scob)+")")]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col match-time"},[(_vm.selectedLang==2 || _vm.selectedLang==3)?[_vm._v("\n                      "+_vm._s(_vm._f("date")(data.eventObj.dt,'MMMDo HH:mm'))+"\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm._f("date")(data.eventObj.dt,'MM/DD HH:mm'))+"\n                    ")]],2)]),_vm._v(" "),_c('div',{staticClass:"bet-content"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-play-game"},[_c('label',{staticClass:"bet-play-text"},[(data.eventObj && data.eventObj.rbstatus)?_c('label',{staticClass:"bet-match-playing"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_LIVE"]))]):_vm._e(),_vm._v("\n                          "+_vm._s(_vm.getPtBtCapt(data))+"\n                        "),_c('label',{staticClass:"bet-handicap-name"},[_vm._v(_vm._s(_vm.getOddsTypeCap(data))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-auto"})]),_vm._v(" "),_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"col bet-play-team"},[_c('label',{staticClass:"bet-team-handicap"},[(data.betType == '2' || data.betType == '9' || data.betType == '46' || data.betType == '47' || data.betType == '48' || data.betType == '49' || data.betType=='80' || data.betType=='81' || data.betType=='82' || data.betType=='83')?[(data.tbet == 'a')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_OVER"])+"\n                          ")]:(data.tbet == 'b')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_UNDER"])+"\n                          ")]:_vm._e()]:(data.betType == '32' || data.betType == '33' || data.betType == '76' || data.betType == '79')?[(data.tbet == 'a')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_YES"])+"\n                          ")]:(data.tbet == 'b')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NO"])+"\n                          ")]:_vm._e()]:(data.betType == '21' || data.betType == '27' || data.betType == '36' || data.betType == '37' || data.betType == '38' || data.betType == '39' || data.betType == '40' || data.betType == '41' || data.betType == '42' || data.betType == '43' || data.betType == '44' || data.betType == '45')?[(data.tbet == 'a')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME"])+" \n                          ")]:(data.tbet == 'b')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY"])+"\n                          ")]:(data.tbet == 'x')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                          ")]:_vm._e(),_vm._v(" "),(data.betType == '21' || data.betType == '27')?[_vm._v("\n                            ("+_vm._s(_vm.h1x2Header(data.hdp, data.tbet))+")\n                          ")]:_vm._e()]:(data.betType == '50' || data.betType == '51')?[(data.tbet == 'h1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1"])+"\n                          ")]:(data.tbet == 'h2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2"])+"\n                          ")]:(data.tbet == 'h3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3"])+"\n                          ")]:(data.tbet == 'h4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4M"])+"\n                          ")]:(data.tbet == 'a1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1"])+"\n                          ")]:(data.tbet == 'a2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2"])+"\n                          ")]:(data.tbet == 'a3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3"])+"\n                          ")]:(data.tbet == 'a4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4M"])+"\n                          ")]:(data.tbet == 'sd')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AS"])+"\n                          ")]:(data.tbet == 'ng')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                          ")]:_vm._e()]:(data.betType == '77' || data.betType == '78')?[(data.tbet == 'h1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1R"])+"\n                          ")]:(data.tbet == 'h2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2R"])+"\n                          ")]:(data.tbet == 'h3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3R"])+"\n                          ")]:(data.tbet == 'h4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4RM"])+"\n                          ")]:(data.tbet == 'a1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1R"])+"\n                          ")]:(data.tbet == 'a2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2R"])+"\n                          ")]:(data.tbet == 'a3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3R"])+"\n                          ")]:(data.tbet == 'a4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4RM"])+"\n                          ")]:(data.tbet == 'sd')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_BB_AS"])+"\n                          ")]:(data.tbet == 'ng')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                          ")]:_vm._e()]:(data.betType == '28' || data.betType == '29' || data.betType == '30' || data.betType == '31')?[(data.tbet == 'a')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1HT"])+"\n                          ")]:(data.tbet == 'b')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2HT"])+"\n                          ")]:(data.tbet == 'x')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                          ")]:_vm._e()]:(data.betType == '25')?[(data.tbet == 'h_1_5')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                          ")]:(data.tbet == 'h_6_10')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                          ")]:(data.tbet == 'h_11_15')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                          ")]:(data.tbet == 'h_16_20')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                          ")]:(data.tbet == 'h_21_25')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                          ")]:(data.tbet == 'h_26_x')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.modifyTitle('h_26_x'))+"\n                          ")]:(data.tbet == 'a_1_5')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                          ")]:(data.tbet == 'a_6_10')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                          ")]:(data.tbet == 'a_11_15')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                          ")]:(data.tbet == 'a_16_20')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                          ")]:(data.tbet == 'a_21_25')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                          ")]:(data.tbet == 'a_26_x')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.modifyTitle('a_26_x'))+"\n                          ")]:_vm._e()]:(data.betType == '52')?[(data.tbet == 'hf')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HFG"])+"\n                          ")]:(data.tbet == 'hl')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HLG"])+"\n                          ")]:(data.tbet == 'af')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AFG"])+"\n                          ")]:(data.tbet == 'al')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_ALG"])+"\n                          ")]:(data.tbet == 'ng')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                          ")]:_vm._e()]:(data.betType == '53' || data.betType == '54' || data.betType == '55' || data.betType == '56')?[(data.tbet == '0_5')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_05"])+"\n                          ")]:(data.tbet == '1_6')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_16"])+"\n                          ")]:(data.tbet == '2_7')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_27"])+"\n                          ")]:(data.tbet == '3_8')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_38"])+"\n                          ")]:(data.tbet == '4_9')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_49"])+"\n                          ")]:_vm._e()]:(data.betType == '19' || data.betType == '20')?[(data.tbet == 'ha')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_AWAY"])+"\n                          ")]:(data.tbet == 'hd')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_DRAW"])+"\n                          ")]:[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY_OR_DRAW"])+"\n                          ")]]:(data.betType == '57' || data.betType == '58')?[(data.tbet == 'ng0')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_0"])+"\n                          ")]:(data.tbet == 'ng1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1"])+"\n                          ")]:(data.tbet == 'ng2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2"])+"\n                          ")]:(data.tbet == 'ng3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_3"])+"\n                          ")]:(data.tbet == 'ng4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_4"])+"\n                          ")]:(data.tbet == 'ng5')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_5"])+"\n                          ")]:(data.tbet == 'ng6')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_6more"])+"\n                          ")]:_vm._e()]:(data.betType == '59' || data.betType == '73')?[(data.tbet == 'ha')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                          ")]:(data.tbet == 'hb')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                          ")]:(data.tbet == 'aa')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                          ")]:(data.tbet == 'ab')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                          ")]:_vm._e()]:(data.betType == '60' || data.betType == '61')?[(data.tbet == 'ha')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                          ")]:(data.tbet == 'hb')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                          ")]:(data.tbet == 'aa')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                          ")]:(data.tbet == 'ab')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                          ")]:_vm._e()]:[_vm._v("\n                          "+_vm._s(data.tbetcapt)+"\n                        ")],_vm._v(" "),(data.betType=="1" || data.betType=="2" || data.betType=="8" || data.betType=="9" || data.betType=="46" || data.betType=="47" || data.betType=="48" || data.betType=="49" || data.betType=="63" || data.betType=="64" || data.betType=="68" || data.betType=="69" || data.betType=="80" || data.betType=="81" || data.betType=="82" || data.betType=="83")?[((data.hdp!=0 ))?_c('label',{staticClass:"handicap yb-number-bold bet-text-nowrap",class:{'bet-handicap':data.hdpChg}},[_vm._v(_vm._s(_vm.getHdpCapt(data)))]):((data.hdp==0 && (data.betType == '1' ||data.betType == '8')))?_c('label',{staticClass:"handicap yb-number-bold bet-text-nowrap",class:{'bet-handicap':data.hdpChg}},[_vm._v("0")]):_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col yb-fontsize16 bet-odds-value"},[_c('span',{staticClass:"odds-value yb-number-bold"},[_c('span',[_vm._v("@")]),_vm._v(" "),(data.betType == 7 || data.betType == 16)?[_vm._v("\n                          "+_vm._s(new Number(parseFloat(data.odd)))+"\n                        ")]:[(_vm.betting.success)?[_vm._v("\n                            "+_vm._s(_vm.getDecimalDisplay(_vm.betting.success.data.betting[key].odd, _vm.betting.success.data.betting[key].sprtid))+"\n                          ")]:[_vm._v("\n                            "+_vm._s(_vm.getDecimalDisplay(data.odd, data.sprtid))+"\n                          ")]]],2)])])])])])]:_vm._e()}),_vm._v(" "),((_vm.betting.success && _vm.betting.success.data.mulpRes) || (_vm.betting.pending && _vm.betting.pending.data.mulpRes))?[_vm._l((((_vm.betting.success && _vm.betting.success.data.mulpRes) || (_vm.betting.pending && _vm.betting.pending.data.mulpRes))),function(data,key){return [_c('div',{staticClass:"bet-mix-result-card q-card q-card--flat no-shadow bet-mix-record-result-last"},[_c('div',{staticClass:"q-card__section q-card__section--vert bet-success-bg"},[_c('div',{staticClass:"odds-wrap vrow"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"col bet-play-info yb-fontsize13"},[_vm._v(_vm._s(_vm.getMulpCaption(_vm.betLang, data.allUp)))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-icon-info",staticStyle:{"display":"block!important"}},[(data.wgStatus && data.wgStatus == '1')?[_c('span',{staticClass:"pending_wager",attrs:{"id":"dg_icon"}})]:[_c('i',{staticClass:"q-icon c-icon",class:{'icon-failure':data.WagerID==undefined, 'icon-success':data.WagerID!=undefined},staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true","role":"presentation"}})]],2)]),_vm._v(" "),_c('div',{staticClass:"vrow bet-win-info"},[_c('div',{staticClass:"col yb-fontsize12"},[_vm._v(" "+_vm._s(_vm.betLang['BETTING.LBL_STAKE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col-auto yb-fontsize12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"])+" ")])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-win-info2 yb-fontsize12"},[_c('div',{staticClass:"col bet-win-value"},[_vm._v(_vm._s(_vm._f("decimal")(data.amount? data.amount:_vm.betMulpAmtFiltered[key].stake,2)))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-value text-right yb-fontsize12"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.betMulpAmtFiltered[key].possiblePayout,2)))])])])]),_vm._v(" "),(data.error!=undefined && data.error!='')?_c('div',{staticClass:"bet-confirm-message text-center yb-fontsize12 bet-fail-order",staticStyle:{"margin-left":"5px","margin-right":"5px","background":"rgba(255, 64, 64, 0.2)","color":"#ff4040","border-radius":"0px 0px 6px 6px"}},[_vm._v("\n                "+_vm._s(data.error.message)),_c('br'),_vm._v(_vm._s(data.error.code)+"\n              ")]):_vm._e()]})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"bet-mix-result-card q-card q-card--flat no-shadow bet-mix-record-result-last"},[_c('div',{staticClass:"q-card__section q-card__section--vert bet-success-bg"},[_c('div',{staticClass:"vrow bet-total",staticStyle:{"line-height":"24px"}},[_c('div',{staticClass:"col bet-total-left"},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_TOTAL_BET"])+" "+_vm._s(_vm.countTotalStakePayout('totalBet', true)))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-total-right"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.countTotalStakePayout('totalStake', true),2)))])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-total",staticStyle:{"line-height":"24px"}},[_c('div',{staticClass:"col bet-total-left"},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_EST_WIN"])+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-total-right bet-gold-text"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.countTotalStakePayout('possiblePayout', true),2)))])])])])],2):_vm._e(),_vm._v(" "),(!_vm.betting.success && !_vm.betting.pending)?_c('div',{staticClass:"c-bet-mix-info",attrs:{"id":"cbetmixinfo"}},[_vm._l((_vm.betFormList),function(data,key){return (_vm.betFormList)?[_c('div',{staticClass:"relative-position bet-mix-item-card q-card q-card--flat no-shadow",class:{'bet-mix-item-first':key==0, 'bet-no-effect':(_vm.betting.minMax==undefined || Object.keys(_vm.betFormList).length < _vm.betting.minMax.minCombo || (data.error && data.error!=''))}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-league-name"},[_vm._v(_vm._s(data.league))]),_vm._v(" "),_c('div',{staticClass:"col-auto",on:{"click":function($event){return _vm.deleteMatch(data.eventObj.eveid, data)}}},[_c('i',{staticClass:"bet-del q-icon icon-del c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-against"},[_c('span',{staticClass:"home-vs-away"},[_c('span',{domProps:{"innerHTML":_vm._s(data.ta)}}),_c('span',{staticClass:"bet-pk"},[_vm._v("v")]),_c('span',{domProps:{"innerHTML":_vm._s(data.tb)}})]),_vm._v(" "),(data.eventObj && data.eventObj.rbinfo)?_c('span',[_vm._v("("+_vm._s(data.eventObj.rbinfo.scoa)+"-"+_vm._s(data.eventObj.rbinfo.scob)+")")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"bet-content"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-play-game"},[_c('label',{staticClass:"bet-play-text"},[(data.eventObj && data.eventObj.rbstatus)?_c('label',{staticClass:"bet-match-playing"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_LIVE"]))]):_vm._e(),_vm._v("\n                        "+_vm._s(_vm.getPtBtCapt(data))+"\n                        "),_c('label',{staticClass:"bet-handicap-name"},[_vm._v(_vm._s(_vm.getOddsTypeCap(data))+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"col bet-play-team"},[_c('label',{staticClass:"bet-team-handicap"},[(data.betType == '2' || data.betType == '9' || data.betType == '46' || data.betType == '47' || data.betType == '48' || data.betType == '49' || data.betType=='80' || data.betType=='81' || data.betType=='82' || data.betType=='83')?[(data.tbet == 'a')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_OVER"])+"\n                          ")]:(data.tbet == 'b')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_UNDER"])+"\n                          ")]:_vm._e()]:(data.betType == '32' || data.betType == '33' || data.betType == '76' || data.betType == '79')?[(data.tbet == 'a')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_YES"])+"\n                          ")]:(data.tbet == 'b')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NO"])+"\n                          ")]:_vm._e()]:(data.betType == '21' || data.betType == '27' || data.betType == '36' || data.betType == '37' || data.betType == '38' || data.betType == '39' || data.betType == '40' || data.betType == '41' || data.betType == '42' || data.betType == '43' || data.betType == '44' || data.betType == '45')?[(data.tbet == 'a')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME"])+" \n                          ")]:(data.tbet == 'b')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY"])+"\n                          ")]:(data.tbet == 'x')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                          ")]:_vm._e(),_vm._v(" "),(data.betType == '21' || data.betType == '27')?[_vm._v("\n                            ("+_vm._s(_vm.h1x2Header(data.hdp, data.tbet))+")\n                          ")]:_vm._e()]:(data.betType == '50' || data.betType == '51')?[(data.tbet == 'h1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1"])+"\n                          ")]:(data.tbet == 'h2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2"])+"\n                          ")]:(data.tbet == 'h3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3"])+"\n                          ")]:(data.tbet == 'h4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4M"])+"\n                          ")]:(data.tbet == 'a1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1"])+"\n                          ")]:(data.tbet == 'a2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2"])+"\n                          ")]:(data.tbet == 'a3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3"])+"\n                          ")]:(data.tbet == 'a4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4M"])+"\n                          ")]:(data.tbet == 'sd')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AS"])+"\n                          ")]:(data.tbet == 'ng')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                          ")]:_vm._e()]:(data.betType == '77' || data.betType == '78')?[(data.tbet == 'h1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1R"])+"\n                          ")]:(data.tbet == 'h2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2R"])+"\n                          ")]:(data.tbet == 'h3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3R"])+"\n                          ")]:(data.tbet == 'h4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4RM"])+"\n                          ")]:(data.tbet == 'a1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1R"])+"\n                          ")]:(data.tbet == 'a2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2R"])+"\n                          ")]:(data.tbet == 'a3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3R"])+"\n                          ")]:(data.tbet == 'a4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4RM"])+"\n                          ")]:(data.tbet == 'sd')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_BB_AS"])+"\n                          ")]:(data.tbet == 'ng')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                          ")]:_vm._e()]:(data.betType == '28' || data.betType == '29' || data.betType == '30' || data.betType == '31')?[(data.tbet == 'a')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1HT"])+"\n                          ")]:(data.tbet == 'b')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2HT"])+"\n                          ")]:(data.tbet == 'x')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                          ")]:_vm._e()]:(data.betType == '25')?[(data.tbet == 'h_1_5')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                          ")]:(data.tbet == 'h_6_10')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                          ")]:(data.tbet == 'h_11_15')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                          ")]:(data.tbet == 'h_16_20')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                          ")]:(data.tbet == 'h_21_25')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                          ")]:(data.tbet == 'h_26_x')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.modifyTitle('h_26_x'))+"\n                          ")]:(data.tbet == 'a_1_5')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                          ")]:(data.tbet == 'a_6_10')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                          ")]:(data.tbet == 'a_11_15')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                          ")]:(data.tbet == 'a_16_20')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                          ")]:(data.tbet == 'a_21_25')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                          ")]:(data.tbet == 'a_26_x')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.modifyTitle('a_26_x'))+"\n                          ")]:_vm._e()]:(data.betType == '52')?[(data.tbet == 'hf')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HFG"])+"\n                          ")]:(data.tbet == 'hl')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HLG"])+"\n                          ")]:(data.tbet == 'af')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AFG"])+"\n                          ")]:(data.tbet == 'al')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_ALG"])+"\n                          ")]:(data.tbet == 'ng')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                          ")]:_vm._e()]:(data.betType == '53' || data.betType == '54' || data.betType == '55' || data.betType == '56')?[(data.tbet == '0_5')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_05"])+"\n                          ")]:(data.tbet == '1_6')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_16"])+"\n                          ")]:(data.tbet == '2_7')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_27"])+"\n                          ")]:(data.tbet == '3_8')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_38"])+"\n                          ")]:(data.tbet == '4_9')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_49"])+"\n                          ")]:_vm._e()]:(data.betType == '19' || data.betType == '20')?[(data.tbet == 'ha')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_AWAY"])+"\n                          ")]:(data.tbet == 'hd')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_DRAW"])+"\n                          ")]:[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY_OR_DRAW"])+"\n                          ")]]:(data.betType == '57' || data.betType == '58')?[(data.tbet == 'ng0')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_0"])+"\n                          ")]:(data.tbet == 'ng1')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1"])+"\n                          ")]:(data.tbet == 'ng2')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2"])+"\n                          ")]:(data.tbet == 'ng3')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_3"])+"\n                          ")]:(data.tbet == 'ng4')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_4"])+"\n                          ")]:(data.tbet == 'ng5')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_5"])+"\n                          ")]:(data.tbet == 'ng6')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_6more"])+"\n                          ")]:_vm._e()]:(data.betType == '59' || data.betType == '73')?[(data.tbet == 'ha')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                          ")]:(data.tbet == 'hb')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                          ")]:(data.tbet == 'aa')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                          ")]:(data.tbet == 'ab')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                          ")]:_vm._e()]:(data.betType == '60' || data.betType == '61')?[(data.tbet == 'ha')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                          ")]:(data.tbet == 'hb')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                          ")]:(data.tbet == 'aa')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                          ")]:(data.tbet == 'ab')?[_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])],_vm._v("\n                             "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                          ")]:_vm._e()]:[_vm._v("\n                          "+_vm._s(data.tbetcapt)+"\n                        ")],_vm._v(" "),(data.betType=="1" || data.betType=="2" || data.betType=="8" || data.betType=="9" || data.betType=="46" || data.betType=="47" || data.betType=="48" || data.betType=="49" || data.betType=="63" || data.betType=="64" || data.betType=="68" || data.betType=="69" || data.betType=="80" || data.betType=="81" || data.betType=="82" || data.betType=="83")?[((data.hdp!=0 ))?_c('label',{staticClass:"handicap yb-number-bold bet-text-nowrap",class:{'bet-handicap':data.hdpChg}},[_vm._v(_vm._s(_vm.getHdpCapt(data)))]):((data.hdp==0 && (data.betType == '1' ||data.betType == '8')))?_c('label',{staticClass:"handicap yb-number-bold bet-text-nowrap",class:{'bet-handicap':data.hdpChg}},[_vm._v("0")]):_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-odds-value",class:_vm.getOddChange(data)},[_c('span',{staticClass:"odds-value yb-number-bold"},[_c('span',[_vm._v("@")]),_vm._v(" "),(data.betType == 7 || data.betType == 16)?[_vm._v("\n                          "+_vm._s(new Number(parseFloat(data.odd)))+"\n                        ")]:[_vm._v("\n                          "+_vm._s(_vm.getDecimalDisplay(data.odd, data.sprtid))+"\n                        ")]],2)]),_vm._v(" "),_c('div',{staticClass:"auto-col"},[(_vm.betting.error && data.error && data.error!='')?[(data.error.code && (data.error.code.indexOf('4000-N1') > -1 || data.error.code.indexOf('4031') > -1))?_c('span',{staticClass:"invalid serial-msg"},[_vm._v(_vm._s(_vm.betLang["BETTING.NOT_SUPPORT_PARLAY"]))]):_c('span',{staticClass:"invalid serial-msg"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.BET_CLOSE"]))])]:_vm._e()],2)])])])])]:_vm._e()}),_vm._v(" "),(_vm.betMulpAmount && _vm.betMulpAmount.length>0 && _vm.betting.allUpList && _vm.betting.minMax && Object.keys(_vm.betFormList).length >= _vm.betting.minMax.minCombo && !_vm.betting.error)?_c('div',{attrs:{"id":"bet_input_defaut_one"}},[_c('div',{staticClass:"bet-mix-input-card q-card q-card--flat no-shadow bet-mix-input-last",attrs:{"id":'betmixcard_'+_vm.betting.allUpList[0].key}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"odds-wrap vrow"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"col bet-mix-info"},[_vm._v("\n                    "+_vm._s(_vm.getMulpCaption(_vm.betLang, _vm.betting.allUpList[0].key))+"\n                  ")]),_vm._v(" "),_c('span',{staticClass:"odds-value yb-number-bold"},[_vm._v("@"+_vm._s(_vm.getMULPOdds()))])]),_vm._v(" "),(_vm.checkMaxOdds(0))?[_c('div',{staticClass:"vrow bet-mix-input",attrs:{"data-check-money":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.betMulpAmount[0].value),expression:"betMulpAmount[0].value"}],ref:"betAmount0",staticClass:"bet-input input-border",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.betMinMaxMulp(0),"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","id":_vm.betting.allUpList[0].key,"size":"8","maxlength":_vm.amountMaxLength},domProps:{"value":(_vm.betMulpAmount[0].value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.betMulpAmount[0], "value", $event.target.value)},function($event){return _vm.setbetMulpKeyboard(0)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)},"focus":function($event){return _vm.showKeyboard(_vm.betting.allUpList[0].key, 0)}}}),_vm._v(" "),(Object.keys(_vm.betMulpAmount[0].value).length>0)?_c('div',{class:{'bet-input-close-1':_vm.totalBet1(_vm.betting.allUpList[0].key).toString().length==1,'bet-input-close-2':_vm.totalBet1(_vm.betting.allUpList[0].key).toString().length>1},staticStyle:{"top":"40px","right":"10px"},on:{"click":function($event){return _vm.clearInput(0)}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mulp_keyboard",class:_vm.betting.allUpList[0].key},[_c('div',{staticClass:"vrow bet-win yb-fontsize12"},[_c('div',{staticClass:"col df-jb"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"]))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-money yb-number-bold"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.displayMulpPossiblePayout(0),2)))])]),_vm._v(" "),_c('div',{staticClass:"bet-keyboard-zone q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow bet-keyboard bet-keyboard-content"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"q-gutter-xs keyboard-zone"},[_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.min, 0, 'min')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.min, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.min))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.med, 0, 'med')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.med, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.med))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big, 0, 'big')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big2, 0, 'big2')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big2, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big2))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, 0, 'big3')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big3, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.commasAmount(_vm.betting.betAmountOption.big3)))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, 0, 'big3')||_vm.betMulpAmount[0].maxPay==''||_vm.betMulpAmount[0].maxPay==0},on:{"click":function($event){return _vm.MaxAmt(_vm.betMulpAmount[0].maxPay, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v(_vm._s(_vm.langList.sportMinibetLang['SPORT_MINIBET.MAX']))])])])])])])])]:[_c('div',{staticClass:"bet-message text-center",staticStyle:{"height":"auto","line-height":"normal","margin":"15px 0px","color":"#ff4040"},attrs:{"data-v-9f62b2ae":""}},[_vm._v("\n                  "+_vm._s(_vm.betLang['BETTING.EXCEED_MAX_ODDS']+' '+_vm.betting.minMax.maxOdds)+"\n                ")])]],2)])]):_vm._e(),_vm._v(" "),(_vm.betMulpAmount && _vm.betMulpAmount.length>0 && _vm.betting.allUpList && _vm.betting.allUpList.length>1 && _vm.betting.minMax && Object.keys(_vm.betFormList).length >= _vm.betting.minMax.minCombo && !_vm.betting.error)?[_c('div',{staticClass:"row bet-toggle bet-toggle-up",on:{"click":function($event){return _vm.multipleBetClick()}}},[_c('div',{staticClass:"col bet-toggle-text cursor-pointer"},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_MULTIPLE_BET']))]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('span',{},[_c('i',{staticClass:"q-icon icon-triangle c-icon icon-pull-down",class:{'icon-pull-up':_vm.multipleBetToggle},staticStyle:{"font-size":"16px"},attrs:{"aria-hidden":"true","role":"presentation"}})])])]),_vm._v(" "),(_vm.multipleBetToggle)?_c('div',{},[_vm._l((_vm.betting.allUpList),function(allUp,index){return (index>=1)?[_c('div',{staticClass:"bet-mix-input-card q-card q-card--flat no-shadow bet-mix-input-last",attrs:{"id":'betmixcard_'+allUp.key}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"odds-wrap vrow"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"col bet-mix-info"},[_vm._v("\n                        "+_vm._s(_vm.getMulpCaption(_vm.betLang, allUp.key))+"\n                      ")])]),_vm._v(" "),(_vm.checkMaxOdds(index))?[_c('div',{staticClass:"vrow bet-mix-input",attrs:{"data-check-money":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.betMulpAmount[index].value),expression:"betMulpAmount[index].value"}],ref:'betAmount'+index,refInFor:true,staticClass:"bet-input input-border",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.betMinMaxMulp(index),"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","id":allUp.key,"size":"8","maxlength":_vm.amountMaxLength},domProps:{"value":(_vm.betMulpAmount[index].value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.betMulpAmount[index], "value", $event.target.value)},function($event){return _vm.setbetMulpKeyboard(index)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)},"focus":function($event){return _vm.showKeyboard(allUp.key, index)}}}),_vm._v(" "),(Object.keys(_vm.betMulpAmount[index].value).length>0)?_c('div',{class:{'bet-input-close-1':_vm.totalBet1(allUp.key).toString().length==1,'bet-input-close-2':_vm.totalBet1(allUp.key).toString().length>1},staticStyle:{"top":"40px","right":"10px"},on:{"click":function($event){return _vm.clearInput(index)}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mulp_keyboard",class:allUp.key,staticStyle:{"display":"none"}},[_c('div',{staticClass:"vrow bet-win yb-fontsize12"},[_c('div',{staticClass:"col df-jb"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"]))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-money yb-number-bold"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.displayMulpPossiblePayout(index),2)))])]),_vm._v(" "),_c('div',{staticClass:"bet-keyboard-zone q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow bet-keyboard bet-keyboard-content"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"q-gutter-xs keyboard-zone"},[_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.min, index, 'min')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.min, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.min))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.med, index, 'med')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.med, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.med))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big, index, 'big')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big2, index, 'big2')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big2, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big2))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, index, 'big3')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big3, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.commasAmount(_vm.betting.betAmountOption.big3)))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, index, 'big3')||_vm.betMulpAmount[index].maxPay==''||_vm.betMulpAmount[index].maxPay==0},on:{"click":function($event){return _vm.MaxAmt(_vm.betMulpAmount[index].maxPay, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v(_vm._s(_vm.langList.sportMinibetLang['SPORT_MINIBET.MAX']))])])])])])])])]:[_c('div',{staticClass:"bet-message text-center",staticStyle:{"height":"auto","line-height":"normal","margin":"15px 0px","color":"#ff4040"},attrs:{"data-v-9f62b2ae":""}},[_vm._v("\n                        "+_vm._s(_vm.betLang['BETTING.EXCEED_MAX_ODDS']+' '+_vm.betting.minMax.maxOdds)+"\n                      ")])]],2)])]:_vm._e()})],2):_vm._e()]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}})])])]):_vm._e(),_vm._v(" "),(((_vm.oddSelected || _vm.betting.success||_vm.betting.betcombosuccess||_vm.betting.pending||_vm.betting.reject||_vm.betting.betcomboerror) && _vm.openBetForm && _vm.isUsingPhone() === 1))?_c('div',{staticClass:"scroll-footer-phone",staticStyle:{"bottom":"auto","padding-bottom":"70px"},attrs:{"id":"scrollFooterPhone"}},[_c('bettingFormFooter')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedTab == 'betSlipTab')?_c('div',{staticClass:"col"},[_c('div',{staticClass:"load-data-wrap col not-list"},[(_vm.statement.last10wagerList.length > 0 && !_vm.reloadingBet)?[_c('div',{staticClass:"fit",attrs:{"data-v-21f17103":""}},[_c('div',{staticClass:"bet-record-container",attrs:{"data-v-72a40ca0":"","data-v-21f17103":"","data-container":"bet-record-container"}},[_c('div',{staticClass:"bet-record-card full-width q-card q-card--flat no-shadow",attrs:{"data-v-72a40ca0":"","data-v-21f17103":""}},[_vm._l((_vm.statement.last10wagerList),function(wager,index){return [_c('div',{staticClass:"border-shq-card-actionsadow",attrs:{"data-v-72a40ca0":""}},[_c('div',{staticClass:"q-card__actions q-card__actions--horiz vrow justify-start",attrs:{"data-v-72a40ca0":""}},[_c('div',{staticClass:"bet-record-title",attrs:{"data-v-72a40ca0":""}},[(wager.mulpDetails)?[_vm._v("\n                      "+_vm._s(_vm.betLang['BETTING.LBL_PARLAY'])+" "+_vm._s(_vm.betLang["BETTING.LBL_PARLAY_"+wager.tbet])+" (1 "+_vm._s(_vm.betLang["BETTING.LBL_PARLAY_BET"])+")\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm.betLang['BETTING.LBL_SINGLE'])+"\n                    ")]],2),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),(wager.mulpDetails)?[_vm._l((wager.mulpDetails),function(mulp,key){return [_c('div',{staticClass:"bet-item relative-position cursor-pointer",attrs:{"data-v-72a40ca0":""}},[_c('div',{staticClass:"q-card__section q-card__section--vert",attrs:{"data-v-72a40ca0":""}},[_c('div',{attrs:{"data-v-7f8dbb2c":"","data-v-72a40ca0":""}},[_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col bet-league-name",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{attrs:{"data-v-7f8dbb2c":""}},[_vm._v(_vm._s(mulp.lgCap))])])]),_vm._v(" "),(mulp.taCap && mulp.tbCap)?_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col bet-against",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{staticClass:"home-vs-away",attrs:{"data-v-7f8dbb2c":""}},[_vm._v("\n                                "+_vm._s(mulp.taCap)+"\n                                "),_c('span',{staticClass:"bet-pk",attrs:{"data-v-7f8dbb2c":""}},[_vm._v("v")]),_vm._v("\n                                "+_vm._s(mulp.tbCap)+"\n                              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRB(mulp.betTypId) && mulp.sprtId==1),expression:"isRB(mulp.betTypId) && mulp.sprtId==1"}],attrs:{"data-v-7f8dbb2c":""}},[_vm._v("("+_vm._s(mulp.rbscoa!=undefined? mulp.rbscoa:wager.rbscoa)+"-"+_vm._s(mulp.rbscob!=undefined? mulp.rbscob:wager.rbscob)+")")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col match-time",attrs:{"data-v-7f8dbb2c":""}},[_vm._v(" "+_vm._s(_vm._f("date")(mulp.eveDate,'MM/DD HH:mm')))])]),_vm._v(" "),_c('div',{staticClass:"bet-content",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col bet-play-game yb-fontsize13",attrs:{"data-v-7f8dbb2c":""}},[_c('label',{staticClass:"bet-play-handicap",attrs:{"data-v-7f8dbb2c":""}},[_c('label',{staticClass:"sport-name",attrs:{"data-v-7f8dbb2c":""}},[_vm._v("["+_vm._s(mulp.sprtCap)+"]")]),_vm._v(" "),(mulp.betTypId != 14)?[(mulp.plyTypId != _vm.ftPlyType)?[_vm._v("\n                                      "+_vm._s(_vm.betLang["BETTING.LBL_1H"])+" -\n                                    ")]:(mulp.betTypId == '4')?[_vm._v("\n                                      "+_vm._s(_vm.betLang["BETTING.LBL_FT"])+" -\n                                    ")]:_vm._e(),_vm._v("\n                                    "+_vm._s(mulp.plyTypCap + ' - ' + mulp.betTypCap)+"\n                                    ")]:_vm._e(),_vm._v(" "),_c('label',{staticClass:"bet-handicap-name",attrs:{"data-v-7f8dbb2c":""}},[_vm._v("["+_vm._s(wager.odTypCap)+"]")])],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col bet-play-team",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{staticClass:"part-one",attrs:{"data-v-7f8dbb2c":""}},[_vm._v("\n                                  "+_vm._s(_vm.drawTeamBet(mulp))+"\n                                  "),(_vm.hdpDisp == '0')?[(mulp.betTypId == '2' || mulp.betTypId == '9' || mulp.betTypId == '1' || mulp.betTypId == '8' || mulp.betTypId == '46' || mulp.betTypId == '47' || mulp.betTypId == '48' || mulp.betTypId == '49')?[(mulp.betTypId == '1' || mulp.betTypId == '8')?[_vm._v("\n                                        "+_vm._s(mulp.hdpVal<0?'-':mulp.hdpVal==0?'':'+')+"\n                                      ")]:_vm._e(),_vm._v(_vm._s(mulp.hdp)+"\n                                    ")]:_vm._e()]:(_vm.hdpDisp == '1')?[(mulp.betTypId == '2' || mulp.betTypId == '9' || mulp.betTypId == '46' || mulp.betTypId == '47' || mulp.betTypId == '48' || mulp.betTypId == '49')?[_vm._v("\n                                        "+_vm._s(mulp.hdp)+"\n                                      ")]:(mulp.betTypId == '1' || mulp.betTypId == '8')?[_vm._v("\n                                        "+_vm._s(mulp.hdpVal<0?'-':mulp.hdpVal==0?'':'+')+" "+_vm._s(mulp.hdp)+"\n                                      ")]:_vm._e()]:[(mulp.betTypId == '1' || mulp.betTypId == '8')?_c('span',[_vm._v("\n                                        "+_vm._s(mulp.hdpVal<0?'-':mulp.hdpVal==0?'':'+')+"\n                                      ")]):_vm._e(),_vm._v(_vm._s(mulp.hdp)+"\n                                  ")]],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col",attrs:{"data-v-7f8dbb2c":""}},[_c('label',{staticClass:"bet-odds-value",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{attrs:{"data-v-7f8dbb2c":""}},[_vm._v("@")]),_vm._v(_vm._s(mulp.od)+"\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-result",attrs:{"data-v-7f8dbb2c":""}},[(mulp.wgStatus < 0)?[(mulp.cclrsnid > 0)?[_c('span',{staticClass:"invalid serial-msg",attrs:{"data-v-7f8dbb2c":"","title":_vm.langList.statementLang['STATEMENT.LBL_CANCELLED'] + (mulp.cclrsn != undefined? ' ('+mulp.cclrsn+')':'')}},[_vm._v("\n                                      "+_vm._s(_vm.langList.statementLang['STATEMENT.LBL_CANCELLED'])+"\n                                      "),(mulp.cclrsn != undefined)?[_vm._v("\n                                        ("+_vm._s(mulp.cclrsn)+")\n                                      ")]:_vm._e()],2)]:[_c('span',{staticClass:"invalid serial-msg",attrs:{"data-v-7f8dbb2c":""}},[(mulp.wgStatus == '-3')?[_vm._v("\n                                        "+_vm._s(_vm.langList.statementLang['STATEMENT.LBL_REFUND'])+"\n                                      ")]:[_vm._v("\n                                        "+_vm._s(_vm.langList.statementLang['STATEMENT.LBL_REJECTED'])+"\n                                      ")]],2)]]:[_c('span',{attrs:{"data-v-7f8dbb2c":""}})]],2)])])])])])]})]:[_c('div',{staticClass:"bet-item relative-position cursor-pointer",attrs:{"data-v-72a40ca0":""}},[_c('div',{staticClass:"q-card__section q-card__section--vert",attrs:{"data-v-72a40ca0":""}},[_c('div',{attrs:{"data-v-7f8dbb2c":"","data-v-72a40ca0":""}},[_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col bet-league-name",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{attrs:{"data-v-7f8dbb2c":""}},[_vm._v(_vm._s(wager.lgCap))])])]),_vm._v(" "),(wager.taCap && wager.tbCap)?_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col bet-against",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{staticClass:"home-vs-away",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{domProps:{"innerHTML":_vm._s(wager.taCap)}}),_vm._v(" "),_c('span',{staticClass:"bet-pk",attrs:{"data-v-7f8dbb2c":""}},[_vm._v("v")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(wager.tbCap)}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRB(wager.betTypId) && wager.sprtId==1),expression:"isRB(wager.betTypId) && wager.sprtId==1"}],attrs:{"data-v-7f8dbb2c":""}},[_vm._v("("+_vm._s(wager.rbscoa)+"-"+_vm._s(wager.rbscob)+")")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col match-time",attrs:{"data-v-7f8dbb2c":""}},[_vm._v(_vm._s(_vm._f("date")(wager.eveDate,'MM/DD HH:mm')))])]),_vm._v(" "),_c('div',{staticClass:"bet-content",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col bet-play-game yb-fontsize13",attrs:{"data-v-7f8dbb2c":""}},[_c('label',{staticClass:"bet-play-handicap",attrs:{"data-v-7f8dbb2c":""}},[(wager.sprtId == _vm.specialEventList['id'])?[_c('span',{staticClass:"sport-name",staticStyle:{"display":"inline-flex","align-items":"center"}},[_c('label',{staticClass:"sport-img img36 SP"}),_vm._v("["+_vm._s(wager.sprtCap)+"]")]),_c('br')]:_c('label',{staticClass:"sport-name",attrs:{"data-v-7f8dbb2c":""}},[_vm._v("["+_vm._s(wager.sprtCap)+"]")]),_vm._v(" "),(_vm.isRB(wager.betTypId))?[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_INPLAY']+' ')+"\n                                ")]:[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.PREMATCH']+' ')+"\n                                ")],_vm._v(" "),(wager.betTypId != 15)?[(wager.plyTypId == 2)?[_vm._v("\n                                    "+_vm._s(_vm.betLang["BETTING.LBL_1H"])+" -\n                                  ")]:(wager.betTypId == '4' && wager.plyTypId == 1)?[_vm._v("\n                                    "+_vm._s(_vm.betLang["BETTING.LBL_FT"])+" -\n                                  ")]:_vm._e(),_vm._v("\n                                    "+_vm._s(wager.plyTypCap + ' - ' + wager.betTypCap)+"\n                                    ")]:_vm._e(),_vm._v(" "),_c('label',{staticClass:"bet-handicap-name",attrs:{"data-v-7f8dbb2c":""}},[_vm._v("["+_vm._s(wager.odTypCap)+"]")])],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col bet-play-team",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{staticClass:"part-one",attrs:{"data-v-7f8dbb2c":""}},[_vm._v("\n                                "+_vm._s(_vm.drawTeamBet(wager))+"\n                                "),(_vm.hdpDisp == '0')?[(wager.betTypId == '2' || wager.betTypId == '9' || wager.betTypId == '1' || wager.betTypId == '8' || wager.betTypId == '46' || wager.betTypId == '47' || wager.betTypId == '48' || wager.betTypId == '49')?[_vm._v("\n                                    "+_vm._s(wager.hdp)+"\n                                  ")]:_vm._e()]:(_vm.hdpDisp == '1')?[(wager.betTypId == '2' || wager.betTypId == '9' || wager.betTypId == '46' || wager.betTypId == '47' || wager.betTypId == '48' || wager.betTypId == '49')?[_vm._v("\n                                      "+_vm._s(wager.hdp)+"\n                                    ")]:(wager.betTypId == '1' || wager.betTypId == '8')?[_vm._v("\n                                      "+_vm._s(wager.hdpVal<0?'-':wager.hdpVal==0?'':'+')+_vm._s(wager.hdp)+"\n                                    ")]:_vm._e()]:[_vm._v("\n                                  "+_vm._s(wager.hdpVal<0?'-':wager.hdpVal==0?'':'+')+_vm._s(wager.hdp)+"\n                                ")]],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow",attrs:{"data-v-7f8dbb2c":""}},[_c('div',{staticClass:"col",attrs:{"data-v-7f8dbb2c":""}},[_c('label',{staticClass:"bet-odds-value",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{attrs:{"data-v-7f8dbb2c":""}},[_vm._v("@")]),_vm._v(_vm._s(_vm.getDecimalDisplay(wager.odTypid, wager.od))+"\n                              ")])]),_vm._v(" "),_vm._m(1,true)])])])])])],_vm._v(" "),_c('div',{staticClass:"bet-item-result q-card__section q-card__section--vert",attrs:{"data-v-72a40ca0":""}},[_c('div',{attrs:{"data-v-799b9584":"","data-v-72a40ca0":""}},[_c('div',{staticClass:"vrow",attrs:{"data-v-799b9584":""}},[_c('div',{staticClass:"col bet-money",attrs:{"data-v-799b9584":""}},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_TTLSTAKE"]))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-money",attrs:{"data-v-799b9584":""}},[_vm._v(_vm._s(_vm.betLang['BETTING.HIGH_WIN']))])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-win-input",attrs:{"data-v-799b9584":""}},[_c('div',{staticClass:"col bet-value",attrs:{"data-v-799b9584":""}},[_vm._v(_vm._s(_vm._f("number")(wager.stkF,2)))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-value",attrs:{"data-v-799b9584":""}},[_vm._v(_vm._s(_vm._f("number")(wager.estWin,2)))])])])]),_vm._v(" "),_c('div',{staticClass:"bet-item-separator q-card__section q-card__section--vert bet-item-separator-last",attrs:{"data-v-72a40ca0":""}})],2)]})],2)])])]:(_vm.statement.last10wagerList.length == 0 && !_vm.reloadingBet)?[_c('div',{staticClass:"column yb-flex-center empty fit"},[_c('div',{staticClass:"wrap empty-wrap",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"img dark",staticStyle:{"width":"180px","height":"180px"},attrs:{"data-v-31145778":""}}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.betLang['BETTING.NO_DATA']))])])])]:(_vm.reloadingBet)?[_c('div',{staticClass:"column yb-flex-center empty",attrs:{"data-v-21f17103":""}},[_c('div',{staticClass:"load-data-wrap fit video-loading loading-wrap yb-flex-center relative-position",attrs:{"data-v-7eebf246":""}},[_c('div',{staticClass:"img-loading custom-format-img-loading",attrs:{"data-v-7eebf246":""}}),_vm._v(" "),_c('div',{staticClass:"loading-text",attrs:{"data-v-7eebf246":""}},[_vm._v(_vm._s(_vm.betLang['BETTING.LOADING']))])])])]:_vm._e()],2)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bet-record-title",attrs:{"data-v-72a40ca0":""}},[_c('span',{attrs:{"data-v-72a40ca0":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto bet-result",attrs:{"data-v-7f8dbb2c":""}},[_c('span',{attrs:{"data-v-7f8dbb2c":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fit v-scrollarea q-scrollarea",class:_vm.getFormHeightClass(),staticStyle:{"width":"221px !important","background-color":"var(--qq--y0-bg-color12)"},attrs:{"id":"mulpBetArea"}},[_c('div',{staticClass:"q-scrollarea__container scroll relative-position fit hide-scrollbar",attrs:{"id":"normalScroll"}},[_c('div',{staticClass:"q-scrollarea__content absolute",attrs:{"id":"q-scroll-content"}},[_c('div',{staticClass:"middle-content",style:(_vm.midContent),attrs:{"id":"normal-middle-content"}},[_c('div',{staticClass:"scroll-inner-wrap fit",attrs:{"id":"midLeftBar"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.oddSelected && _vm.selectedTab != 'betSlipTab'),expression:"!oddSelected && selectedTab != 'betSlipTab'"}],staticClass:"menu-wrap"},[_c('div',{staticClass:"menu-item menu-top menu-roll menu-border",class:{'active':_vm.open_RBMarket&&_vm.selectedMarket==_vm.market.inPlayMarket.key},on:{"click":function($event){$event.preventDefault();return _vm.openRBMarket(_vm.market.inPlayMarket.key, _vm.rbAllSport)}}},[_c('div',{staticClass:"inplay-icon"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langList.welcomeInPlay))]),_vm._v(" "),_c('span',{staticClass:"bet-count"},[_vm._v(_vm._s(_vm.allLive(_vm.market.inPlayMarket.key)))])]),_vm._v(" "),(_vm.hotSport != 0)?_c('div',{staticClass:"menu-item menu-top menu-roll menu-border",class:{'active':_vm.selectedMarket==_vm.market.hotSportMarket.key},on:{"click":function($event){$event.preventDefault();return _vm.changeMarket(_vm.market.hotSportMarket.key, _vm.rbAllSport)}}},[_c('div',{staticClass:"hotSport-icon"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langList.hotSport))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-menu-sports menu-border"},[_c('div',{staticClass:"relative-position",attrs:{"data-v-20a71bf8":""}},[_c('div',{staticClass:"menu-item menu-top menu-item-title disable-hover",attrs:{"data-v-20a71bf8":""}},[_vm._v(_vm._s(_vm.langList.sportMenu))]),_vm._v(" "),_c('div',{staticClass:"menu-item menu-tab disable-hover double",attrs:{"data-v-20a71bf8":""}},[_c('div',{staticClass:"item yb-flex-center",class:_vm.selectedMarket==_vm.market.tdyMarket.key || _vm.selectedMarket==_vm.market.inPlayMarket.key ? 'active' : '',attrs:{"data-v-20a71bf8":""},on:{"click":function($event){$event.preventDefault();return _vm.changeMarket(_vm.market.tdyMarket.key)}}},[_vm._v(_vm._s(_vm.langList.GAME_BANNER['GAME_BANNER.TODAY']))]),_vm._v(" "),_c('div',{staticClass:"item yb-flex-center",class:_vm.selectedMarket==_vm.market.earlyMarket.key ? 'active' : '',attrs:{"data-v-20a71bf8":""},on:{"click":function($event){$event.preventDefault();return _vm.changeMarket(_vm.market.earlyMarket.key)}}},[_c('span',{staticClass:"ellipsis",staticStyle:{"width":"85px","text-align":"center"}},[_vm._v(_vm._s(_vm.langList.GAME_BANNER['GAME_BANNER.EARLY']))])])])]),_vm._v(" "),_c('sportCategory')],1)]),_vm._v(" "),(_vm.openBetForm && _vm.miniNormal!='1')?_c('bettingForm'):_vm._e(),_vm._v(" "),(_vm.selectedBetTab)?_c('betSlipForm'):_vm._e()],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"global-click-event",rawName:"v-global-click-event",value:(_vm.hideInfo),expression:"hideInfo"}],staticClass:"header-wrap scroll-fixed-bg"},[_c('div',{staticClass:"user-info",attrs:{"token":"?token=d0cc5eb7db2c948b2592a117cb9081dcac4feefa"}},[(!_vm.account.previewFlag)?_c('div',{staticClass:"ellipsis",on:{"click":function($event){return _vm.showMoreFunc(4)}}},[_vm._v("Hi, "+_vm._s(_vm.account.acccode))]):_c('div',{staticClass:"ellipsis",on:{"click":_vm.showPanel}},[_vm._v("Hi, Guest")])]),_vm._v(" "),_c('div',{staticClass:"balance-wrap vrow justify-between relative-position"},[_c('div',{staticClass:"vrow items-center"},[(!_vm.showCCL)?_c('div',{staticClass:"balance-text-hide"},[_vm._v("******")]):_c('div',{staticClass:"balance-text-show"},[_vm._v(_vm._s(_vm.account.currCode)),_c('sup',[_vm._v(_vm._s(_vm.account.currUnit_S))]),_vm._v(" "+_vm._s(_vm._f("ccl")(_vm.account.currCL,_vm.decimals)))]),_vm._v(" "),_c('i',{staticClass:"balance-btn-eye cursor-pointer q-icon c-icon",class:_vm.showCCL ? 'icon-eye_show' : 'icon-eye_hide',staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"},on:{"click":_vm.CCL}})]),_vm._v(" "),(_vm.showCCL)?_c('div',{staticClass:"c-refresh fit yb-flex-center cursor-pointer refresh-btn",on:{"click":function($event){return _vm.getSportCCL(0)}}},[_vm._m(0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widgetPanel personalAccount",staticStyle:{"display":"none"},attrs:{"tabindex":"-1"},on:{"click":_vm.showPanelMini}},[_c('button',{staticClass:"glyphIcon icon-widgetCollapse",attrs:{"title":"Collapse the Widget Panel"},on:{"click":_vm.hideInfo}}),_vm._v(" "),_c('div',{staticClass:"heading current",attrs:{"title":_vm.account.acccode}},[(!_vm.account.previewFlag)?_c('div',{staticClass:"text",on:{"click":_vm.showPanel}},[_vm._v(_vm._s(_vm.account.acccode))]):_c('div',{staticClass:"text",on:{"click":_vm.showPanel}},[_vm._v("Guest")]),_vm._v(" "),_c('div',{staticClass:"floatRight"},[(_vm.checked)?_c('div',{staticClass:"glyphIcon primary icon-refresh",attrs:{"title":_vm.langList.refresh},on:{"click":function($event){return _vm.getSportCCL(0)}}}):_vm._e(),_vm._v(" "),(!_vm.isMini)?_c('div',{staticClass:"glyphIcon icon-widgetCollapse",attrs:{"data-tag":"tagGlyphIconButton"}}):_vm._e()])]),_vm._v(" "),(_vm.checked)?_c('div',{staticClass:"creditArea"},[_c('div',{staticClass:"infoGroup creditInfo"},[_c('div',{staticClass:"infoRow"},[_c('div',{staticClass:"infoTitle",attrs:{"title":_vm.langList.balances}},[_vm._v(_vm._s(_vm.langList.balances))]),_vm._v(" "),_c('div',{staticClass:"infoItem"},[_c('span',{staticClass:"currency"},[_vm._v(_vm._s(_vm.account.currCode)),_c('sup',[_vm._v(_vm._s(_vm.account.currUnit_S))])]),_vm._v(_vm._s(_vm._f("ccl")(_vm.account.currCL,_vm.decimals)))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contentArea",staticStyle:{"display":"none"},attrs:{"id":"AccountList"}},[_c('div',{staticClass:"mainSection"},[_c('div',{staticClass:"panelFunction"},[_c('div',{staticClass:"floatLeft"},[_c('label',{staticClass:"sb_label",attrs:{"title":_vm.langList.showBetCredit}},[_c('input',{attrs:{"id":"","type":"checkbox","checked":""},on:{"click":_vm.getChecked}}),_vm._v(" "),_c('div',{staticClass:"checkbox"}),_vm._v(" "+_vm._s(_vm.langList.showBalance)+"\n                                ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"detailAccount"},[_c('div',{staticClass:"infoGroup creditInfo"},[_c('div',{staticClass:"infoRow"},[_c('div',{staticClass:"infoTitle",attrs:{"title":_vm.langList.balances}},[_vm._v(_vm._s(_vm.langList.balances))]),_vm._v(" "),_c('div',{staticClass:"infoItem"},[_c('span',{staticClass:"currency"},[_vm._v(_vm._s(_vm.account.currCode)),_c('sup',[_vm._v(_vm._s(_vm.account.currUnit_S))])]),_vm._v(_vm._s(_vm._f("ccl")(_vm.account.currCL,_vm.decimals))+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"infoGroup creditInfo"},[_c('div',{staticClass:"infoRow"},[_c('div',{staticClass:"infoTitle",attrs:{"title":_vm.langList.balances}},[_vm._v(_vm._s(_vm.langList.outstanding)+"\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"infoItem"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.account.outstanding,_vm.decimals)))])])]),_vm._v(" "),_c('div',{staticClass:"infoGroup loginInfo"},[_c('div',{staticClass:"infoRow"},[_c('div',{staticClass:"infoTitle",attrs:{"title":_vm.langList.lastLogin}},[_vm._v(_vm._s(_vm.langList.lastLogin)+"\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"infoItem"},[_vm._v(_vm._s(_vm._f("date")(_vm.account.lastLogin,'DD/MM/Y hh:mm:ss A'))+"\n                                    ")])]),_vm._v(" "),(_vm.account.oneWallet !== '1')?_c('div',{staticClass:"infoRow"},[_c('div',{staticClass:"infoTitle",attrs:{"title":_vm.langList.LasTransaction}},[_vm._v(_vm._s(_vm.langList.LasTransaction)+"\n                                    ")]),_vm._v(" "),(_vm.account.lastTrans != '')?_c('div',{staticClass:"infoItem"},[_vm._v(_vm._s(_vm._f("date")(_vm.account.lastTrans,'DD/MM/Y hh: mm: ss A')))]):_c('div',{staticClass:"infoItem"},[_vm._v("-")])]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrap",attrs:{"id":"balancesRefresh"}},[_c('i',{staticClass:"q-icon icon-tbl_refresh c-icon",staticStyle:{"font-size":"18px","transform":"scale(0.8)"},attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floatRight"},[_c('div',{staticClass:"largeBtn iconOnly secondary icon-refresh",attrs:{"title":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myFavorite_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41861269_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myFavorite_vue__ = __webpack_require__(324);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myFavorite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41861269_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myFavorite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widgetPanel favorite collapsed"},[_c('div',{staticClass:"glyphIcon icon-widgetCollapse",attrs:{"title":"Collapse the Widget Panel"}}),_vm._v(" "),_c('div',{staticClass:"heading current icon-favorite added",attrs:{"title":_vm.langList.myFav},on:{"click":_vm.changeFavorite}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.langList.myFav))])]),_vm._v(" "),_c('div',{staticClass:"contentArea"}),_vm._v(" "),_c('div',{staticClass:"bottomArea"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainB_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b179d2e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainB_vue__ = __webpack_require__(326);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainB_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b179d2e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainB_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"global-click-event",rawName:"v-global-click-event",value:(_vm.closeTab),expression:"closeTab"}],staticClass:"widgetPanel",class:{'betSlip': _vm.selectedTab == 'betTab', 'betList': _vm.selectedTab == 'betSlipTab', 'active': _vm.selectedBetTab, 'collapsed': !_vm.selectedBetTab}},[_c('div',{staticClass:"menu-wrap scroll-fixed-bg relative-position bet_history",class:{'item-wrap': _vm.oddSelected||_vm.openBetForm}},[(_vm.tvIconFlag)?_c('div',{staticClass:"menu-item menu-top menu-border item justify-start",class:{'active':_vm.liveSchedule},style:({display: _vm.selectedTab == 'betSlipTab' ? 'none' : ''}),on:{"click":function($event){return _vm.openLivetv()}}},[_c('div',{staticClass:"schedule-icon"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.lang.LivetvLang['LIVETV.SCHEDULE2']))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"glyphIcon icon-widgetCollapse",attrs:{"title":"Collapse the Widget Panel"},on:{"click":function($event){return _vm.closeTab()}}}),_vm._v(" "),_c('div',{staticClass:"menu-wrap scroll-fixed-bg relative-position bet_history"},[(_vm.selectedTab != 'betSlipTab')?_c('div',{staticClass:"menu-item menu-top menu-border item justify-start",on:{"click":function($event){return _vm.changeTab('betSlipTab')}}},[_c('div',{staticClass:"hot-icon"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.betLang['BETTING.MY_BETS']))]),_vm._v(" "),_c('span',{staticClass:"bet-count"},[_vm._v(_vm._s(_vm.ttlBetAmount))])]):_vm._e(),_vm._v(" "),((!_vm.oddSelected && _vm.showbetformMenu))?_c('div',{staticClass:"menu-item menu-top item-bet menu-border",on:{"click":function($event){return _vm.toggleBetForm()}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.betLang['BETTING.MY_BETS']))]),_vm._v(" "),_c('span',{staticClass:"bet-count"},[_vm._v(_vm._s(_vm.betForm.length))])]):_vm._e()]),_vm._v(" "),(_vm.oddSelected || _vm.openBetForm)?_c('div',{staticClass:"bet-scroll-header"},[_c('div',{staticClass:"vrow bet-back-btn yb-flex-between"},[_c('div',{staticClass:"col yb-flex cursor-pointer",on:{"click":function($event){return _vm.backMenu()}}},[_c('i',{staticClass:"q-icon icon-back c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"back-text ellipsis"},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_BACKTOMENU']))])]),_vm._v(" "),(_vm.hasParlay && !_vm.isParlayTab && this.selectedBettype.betTypId != '6')?_c('div',{staticClass:"bet-series-box"},[_c('span',{staticClass:"bet-series-text",class:{'actions':_vm.isMulp}},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_PARLAY']))]),_vm._v(" "),_c('div',{staticClass:"bet-series-switch",class:{'actions':_vm.isMulp},on:{"click":function($event){return _vm.updateParlay(true)}}},[_c('div',{staticClass:"bet-series-ok",class:{'actions':_vm.isMulp}})])]):_c('div',{staticClass:"col-auto bet-series yb-flex-between bet-cursor-none"},[(_vm.isMulp)?_c('span',{staticClass:"series_style"},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_PARLAY']))]):_vm._e(),_vm._v(" "),(!_vm.isMulp)?_c('span',[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_SINGLE']))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"vrow bg-white"}),_vm._v(" "),_c('div',{staticClass:"bet-header-position"})]):_vm._e(),_vm._v(" "),(_vm.selectedTab == 'betSlipTab')?_c('div',{staticClass:"bet-scroll-header"},[_c('div',{staticClass:"vrow bet-back-btn yb-flex-between"},[_c('div',{staticClass:"col yb-flex cursor-pointer",on:{"click":function($event){return _vm.backMenu()}}},[_c('i',{staticClass:"q-icon icon-back c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"back-text ellipsis"},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_BACKTOMENU']))])])]),_vm._v(" "),_c('div',{staticClass:"vrow bg-white"}),_vm._v(" "),_c('div',{staticClass:"bet-header-position"}),_vm._v(" "),_c('div',{staticClass:"full-width bet-type yb-fontsize13",attrs:{"data-v-fec66818":""}},[_c('div',{staticClass:"row bet-record-item cursor-pointer",attrs:{"data-v-fec66818":""}},[_c('div',{staticClass:"col text-center ellipsis",class:{'active': _vm.selectedBetListType == 1 && !_vm.pendingFlag},attrs:{"data-v-fec66818":""},on:{"click":function($event){return _vm.changeBetSlipType(1)}}},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_BETS']))]),_vm._v(" "),_c('div',{staticClass:"col text-center ellipsis",class:{'active': _vm.selectedBetListType == 2 || _vm.pendingFlag},attrs:{"data-v-fec66818":""},on:{"click":function($event){return _vm.changeBetSlipType(2)}}},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_WAITING']))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col text-center ellipsis",class:{'active': _vm.selectedBetListType == 3 && !_vm.pendingFlag},attrs:{"data-v-fec66818":""},on:{"click":function($event){return _vm.changeBetSlipType(3)}}},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_VOID']))])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto menu-tab-line",attrs:{"data-v-fec66818":""}},[_c('div',{staticClass:"line",attrs:{"data-v-fec66818":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-left vrow yb-layout-margin-menu relative-position",class:{ 'mini': _vm.miniNormal==1,'normal':_vm.miniNormal!=1 },style:({ 'width': _vm.widthPX+'px','height':'100% !important' })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProcessBet && !_vm.sportMiniBet.toggle),expression:"isProcessBet && !sportMiniBet.toggle"}],staticClass:"cathectic-shade"},[_c('div',{staticClass:"shade-fixed"},[_c('div',{staticClass:"loading-wrap"},[_c('div',{staticClass:"img-loading"}),_vm._v(" "),_c('div',{staticClass:"text-center loading-text flex items-end justify-center"},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_PROCESSING'])+"...")])])])]),_vm._v(" "),_c('div',{staticClass:"c-main-menu-mini column col",style:({ height: _vm.heightPX+' !important' ,'display': _vm.miniNormal==1?'':'none'}),attrs:{"id":"modal_mini"}},[_c('div',{staticClass:"v-scroll-area fit vrow relative-position",class:{'bet-list': _vm.betting.success}},[_c('div',{staticClass:"content-wrap fit"},[_c('div',{staticClass:"scroll-header absolute"}),_vm._v(" "),_c('div',{staticClass:"fit v-scrollarea q-scrollarea",style:({ 'width': _vm.widthPX + 'px' ,'height': _vm.heightPX + 'px' })},[_c('div',{staticClass:"q-scrollarea__container scroll relative-position fit hide-scrollbar",attrs:{"id":"miniScroll"}},[_c('div',{staticClass:"q-scrollarea__content absolute"},[_c('div',{staticClass:"middle-content",staticStyle:{"padding-top":"0px","padding-bottom":"0px"}},[_c('div',{staticClass:"scroll-inner-wrap fit"},[_c('div',{staticClass:"column items-center yb-padding-t5"},[_c('gameBanner',{attrs:{"position":'mini'}}),_vm._v(" "),_c('div',{staticClass:"menu-item menu-item-schedule",on:{"click":function($event){$event.preventDefault();return _vm.openLivetv()}}},[_c('img',{staticClass:"menu_mini-bet",staticStyle:{"width":"22px","height":"22px"},attrs:{"src":"assets/images/bet-schedule.png"}})]),_vm._v(" "),_c('div',{staticClass:"menu-item",on:{"click":function($event){$event.preventDefault();return _vm.showFullLeft(3)}}},[_c('img',{staticClass:"menu_mini-bet",attrs:{"src":"assets/images/menu_mini_bet.svg"}})]),_vm._v(" "),_c('div',{staticClass:"menu-item",on:{"click":function($event){$event.preventDefault();return _vm.openRBMarket(_vm.market.inPlayMarket.key)}}},[_c('img',{staticClass:"menu_mini-bet",attrs:{"src":"assets/images/in-play.png","width":"22px"}})]),_vm._v(" "),_c('div',{staticClass:"dividing-line"}),_vm._v(" "),(_vm.specialEventStatus)?_c('div',{staticClass:"menu-item",on:{"click":function($event){$event.preventDefault();return _vm.changeSport(_vm.specialEventList['sprtId'],false)}}},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon img36 SP"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"menu-item",on:{"click":function($event){$event.preventDefault();return _vm.changeSport(_vm.sportList[0],true)}}},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon icon_simple_N1"})]),_vm._v(" "),_vm._l((_vm.sportList),function(sport){return [_c('div',{staticClass:"menu-item",on:{"click":function($event){$event.preventDefault();return _vm.changeSport(sport, false)}}},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon img36",class:sport.sprtId})])]}),_vm._v(" "),_c('div',{staticClass:"dividing-line"}),_vm._v(" "),(_vm.otrBt!=undefined)?_c('div',{staticClass:"menu-item menu-top menu-virtual menu-border",on:{"click":function($event){$event.preventDefault();return _vm.changeBettype(_vm.otrBt,11)}}},[_c('span',{staticClass:"q-icon icon c-icon sport-img img36",staticStyle:{"width":"18px","height":"18px","background-position":"0px -943.5px"},attrs:{"data-v-0d68232c":""}})]):_vm._e()],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"scroll-footer",staticStyle:{"bottom":"0px"}})])])]),_vm._v(" "),_c('div',{staticClass:"c-main-menu column",style:({ height: _vm.heightPX+' !important' ,'display': _vm.miniNormal==0?'':'none'}),attrs:{"id":"modal_normal"}},[_c('div',{staticClass:"v-scroll-area fit vrow relative-position",class:{'bet-list': _vm.betting.success},staticStyle:{"margin-left":"0px"}},[_c('div',{staticClass:"content-wrap fit"},[_c('div',{staticClass:"scroll-header absolute",staticStyle:{"width":"220px"},attrs:{"id":"scrollHeaderX"}},[_c('userInfo'),_vm._v(" "),_c('gameBanner',{attrs:{"position":'l'}}),_vm._v(" "),_c('mainB')],1),_vm._v(" "),_c('allSport'),_vm._v(" "),(_vm.isUsingPhone() === 0)?[(((_vm.oddSelected || _vm.betting.success||_vm.betting.betcombosuccess||_vm.betting.pending||_vm.betting.reject||_vm.betting.betcomboerror) && _vm.openBetForm))?_c('div',{staticClass:"scroll-footer",staticStyle:{"bottom":"auto"},attrs:{"id":"scrollFooter"}},[_c('bettingFormFooter')],1):_vm._e()]:_vm._e()],2)]),_vm._v(" "),_c('button',{staticClass:"setting collapseExpand"})]),_vm._v(" "),(_vm.showToggleFloat)?_c('div',{staticClass:"menu_toggle-btn yb-flex-center",class:{ 'mini': _vm.miniNormal==1,'normal':_vm.miniNormal!=1 },attrs:{"data-v-792cb3ce":""},on:{"click":function($event){$event.preventDefault();return _vm.showFullLeft(-1)}}},[_c('img',{attrs:{"data-v-792cb3ce":"","src":"assets/images/left_menu_toggle.svg","alt":""}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_centerContent_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa8157f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_centerContent_vue__ = __webpack_require__(516);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_centerContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa8157f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_centerContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBetCommon_vue__ = __webpack_require__(159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4089792c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBetCommon_vue__ = __webpack_require__(418);
function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBetCommon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4089792c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBetCommon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_team_info_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11839aa4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_team_info_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_team_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11839aa4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_team_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_team_info_sc_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb52f7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_team_info_sc_vue__ = __webpack_require__(336);
function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_team_info_sc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb52f7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_team_info_sc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',{staticClass:"more_bg1"},[(_vm.eventAllBet.rbinfo)?[_c('td',{staticClass:"more_left",attrs:{"colspan":"5"}},[_c('span',{staticClass:"more_time",attrs:{"id":"title_showtype","name":"title_showtype"}},[(_vm.eventAllBet.rbinfo.htst != '0')?[_vm._v("\n            "+_vm._s(_vm._f("rb-timer")(_vm.eventAllBet,'mm:ss'))+"\n          ")]:_vm._e()],2),_vm._v("\n           \n        "),_c('span',{staticClass:"more_yellow_ft"},[(_vm.eventAllBet.rbinfo.htst == '0')?[_vm._v("\n            "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_HT'])+"\n          ")]:(_vm.validateRBTimer(_vm.eventAllBet) == '1')?[_vm._v("\n            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_1HT'])+"\n          ")]:(_vm.validateRBTimer(_vm.eventAllBet) == '2')?[_vm._v("\n            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_2HT'])+"\n          ")]:[_vm._v(" - ")]],2)])]:[_c('td',{staticClass:"more_live",attrs:{"id":"title_showtype","name":"title_showtype"}},[(_vm.eventAllBet.rb == 1)?[_vm._v("\n          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_LIVE'])+"\n        ")]:_vm._e(),_vm._v(" "),(_vm.eventAllBet.ha == 'N')?[_c('img',{staticClass:"more_n",attrs:{"src":'assets/images/more_n_'+ _vm.langSelected +'.jpg'}})]:_vm._e()],2),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"more_date"},[(_vm.selectedMarket != 1)?_c('span',{attrs:{"id":"title_date","name":"title_date"}},[_vm._v(_vm._s(_vm._f("date")(_vm.eventAllBet.dt,'DD / M')))]):_vm._e(),_vm._v("   "),_c('span',{attrs:{"id":"title_time","name":"title_time"}},[_vm._v(_vm._s(_vm._f("date")(_vm.eventAllBet.dt,'HH:mm')))])])]],2),_vm._v(" "),_c('tr',{staticClass:"more_bg2"},[(_vm.eventAllBet.rbinfo)?[(_vm.eventAllBet.rbinfo.rca > 0 )?_c('td',{staticClass:"more_red"},[_vm._v("\n        "+_vm._s(_vm.eventAllBet.rbinfo.rca)+"\n      ")]):_vm._e()]:_vm._e(),_vm._v(" "),_c('td',{staticClass:"mo_bg_1"},[_c('span',{attrs:{"id":"title_team_h","name":"title_team_h"},domProps:{"innerHTML":_vm._s(_vm.eventAllBet.tacapt)}})]),_vm._v(" "),(_vm.eventAllBet.rbinfo)?[_c('td',{staticClass:"mo_bg_2"},[_c('span',{staticClass:"more_score",attrs:{"id":"score_h"}},[_vm._v(_vm._s(_vm.eventAllBet.rbinfo.scoa))]),_vm._v(" \n        "),_c('span',{staticClass:"more_line"},[_vm._v("-")]),_vm._v(" \n        "),_c('span',{staticClass:"more_score2",attrs:{"id":"score_c"}},[_vm._v("\n          "+_vm._s(_vm.eventAllBet.rbinfo.scob)+"\n          ")])])]:[_c('td',{staticClass:"mo_bg_2"},[_vm._v(" V ")])],_vm._v(" "),_c('td',{staticClass:"mo_bg_3"},[_c('span',{attrs:{"id":"title_team_c","name":"title_team_c"},domProps:{"innerHTML":_vm._s(_vm.eventAllBet.tbcapt)}})]),_vm._v(" "),(_vm.eventAllBet.rbinfo)?[(_vm.eventAllBet.rbinfo.rcb > 0 )?_c('td',{staticClass:"more_red"},[_vm._v("\n        "+_vm._s(_vm.eventAllBet.rbinfo.rcb)+"\n      ")]):_vm._e()]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_team_info_tn_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7dd488a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_team_info_tn_vue__ = __webpack_require__(339);
function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_team_info_tn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7dd488a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_team_info_tn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',{staticClass:"more_bg1"},[_c('td',{staticClass:"mo_rbg_1"},[_c('div',{staticClass:"more_div",attrs:{"id":"show_Info"}},[_c('table',{attrs:{"id":"model_GAME3","border":"0","cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_c('tr',{staticClass:"more_bg1_tn"},[_c('td',{staticClass:"more_tn_td",attrs:{"colspan":"2"}},[_c('span',{staticClass:"mbk_ytitle"},[_vm._v("3rd Set")]),_vm._v(" "),(_vm.eventAllBet.ha == 'N')?[_c('img',{staticClass:"more_n",attrs:{"src":'assets/images/more_n_'+ _vm.langSelected +'.jpg'}})]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"tn_w"},[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"tn_w"},[_vm._v("2")]),_vm._v(" "),_c('td',{staticClass:"tn_w"},[_vm._v("3")]),_vm._v(" "),_c('td',{staticClass:"tn_point"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_POINT']))]),_vm._v(" "),_c('td',{staticClass:"tn_pw"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SET']))]),_vm._v(" "),_c('td',{staticClass:"tn_total",domProps:{"innerHTML":_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_TOTAL_GAMES'])}})]),_vm._v(" "),_c('tr',{staticClass:"more_bg2_tn"},[_vm._m(0),_vm._v(" "),_c('td',{staticClass:"mtn_title"},[_c('span',{staticClass:"mtnr_team",domProps:{"innerHTML":_vm._s(_vm.eventAllBet.tacapt)}})]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',{staticClass:"tn_color"},[_vm._v("3")]),_vm._v(" "),_c('td',{staticClass:"more_tn_h"},[_vm._v("0")]),_vm._v(" "),_c('td',{staticClass:"more_tn_h"},[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"more_tn_h"},[_vm._v("13")])]),_vm._v(" "),_c('tr',{staticClass:"more_bg2_tn"},[_vm._m(1),_vm._v(" "),_c('td',{staticClass:"mtn_title"},[_c('span',{staticClass:"mtnr_team",domProps:{"innerHTML":_vm._s(_vm.eventAllBet.tbcapt)}})]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',{staticClass:"tn_color"},[_vm._v("3")]),_vm._v(" "),_c('td',{staticClass:"more_tn_h"},[_vm._v("30")]),_vm._v(" "),_c('td',{staticClass:"more_tn_h"},[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"more_tn_h"},[_vm._v("15")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"mtnr_dot_w"},[_c('span',{staticClass:"more_dot_out"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('span',{staticClass:"more_dot_on"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{class:_vm.getSportBackgroundImage(),attrs:{"id":"gameInfo","width":"100%","border":"0","cellspacing":"0","cellpadding":"0"}},[(_vm.selectedBettype.sprtId == _vm.sportListByKey().N1.sprtId)?[_c('allBetSoccer')]:[(!_vm.eventAllBet.rbinfo)?[_c('tbody',[_c('tr',{staticClass:"more_bg1"},[_c('td',{staticClass:"more_live",attrs:{"id":"title_showtype","name":"title_showtype"}},[(_vm.eventAllBet.rb == 1)?[_vm._v("\n              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_LIVE'])+"\n            ")]:_vm._e(),_vm._v(" "),(_vm.eventAllBet.ha == 'N')?[_c('img',{staticClass:"more_n",attrs:{"src":'assets/images/more_n_'+ _vm.langSelected +'.jpg'}})]:_vm._e()],2),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"more_date"},[(_vm.selectedMarket != 1)?_c('span',{attrs:{"id":"title_date","name":"title_date"}},[_vm._v(_vm._s(_vm._f("date")(_vm.eventAllBet.dt,'DD / M')))]):_vm._e(),_vm._v("   "),_c('span',{attrs:{"id":"title_time","name":"title_time"}},[_vm._v(_vm._s(_vm._f("date")(_vm.eventAllBet.dt,'HH:mm')))])])]),_vm._v(" "),_c('tr',{staticClass:"more_bg2"},[_c('td',{staticClass:"mo_bg_1"},[_c('span',{attrs:{"id":"title_team_h","name":"title_team_h"},domProps:{"innerHTML":_vm._s(_vm.eventAllBet.tacapt)}})]),_vm._v(" "),_c('td',{staticClass:"mo_bg_2"},[_vm._v(" V ")]),_vm._v(" "),_c('td',{staticClass:"mo_bg_3"},[_c('span',{attrs:{"id":"title_team_c","name":"title_team_c"},domProps:{"innerHTML":_vm._s(_vm.eventAllBet.tbcapt)}})])])])]:[_c('tbody',[_c('tr',{staticClass:"more_bg1"},[_c('td',{staticClass:"more_live",attrs:{"id":"title_showtype","name":"title_showtype"}},[_vm._v("\n            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_LIVE'])+"\n            "),(_vm.eventAllBet.ha == 'N')?[_c('img',{staticClass:"more_n",attrs:{"src":'assets/images/more_n_'+ _vm.langSelected +'.jpg'}})]:_vm._e()],2),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"more_date"},[_c('span',{attrs:{"id":"title_date","name":"title_date"}},[_vm._v(_vm._s(_vm._f("date")(_vm.eventAllBet.dt,'DD / M')))]),_vm._v("   "),_c('span',{attrs:{"id":"title_time","name":"title_time"}},[_vm._v(_vm._s(_vm._f("date")(_vm.eventAllBet.dt,'HH:mm')))])])]),_vm._v(" "),_c('tr',{staticClass:"more_bg2"},[_c('td',{staticClass:"mo_bg_1"},[_c('span',{attrs:{"id":"title_team_h","name":"title_team_h"},domProps:{"innerHTML":_vm._s(_vm.eventAllBet.tacapt)}})]),_vm._v(" "),_c('td',{staticClass:"mo_bg_2"},[_vm._v(" V ")]),_vm._v(" "),_c('td',{staticClass:"mo_bg_3"},[_c('span',{attrs:{"id":"title_team_c","name":"title_team_c"},domProps:{"innerHTML":_vm._s(_vm.eventAllBet.tbcapt)}})])])])]]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_hdp_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12308820_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_hdp_vue__ = __webpack_require__(345);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_hdp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12308820_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_hdp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('global-click-event', {
    bind: function bind(el, binding, vnode) {
        el.addEventListener('click', function (event) {
            event.stopImmediatePropagation();
        });
        document.body.addEventListener('click', function () {
            binding.value();
        });
    },
    unbind: function unbind(el, binding, vnode) {
        el.removeEventListener('click', function (event) {
            event.stopImmediatePropagation();
        });
        document.body.removeEventListener('click', function () {
            binding.value();
        });
    }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"miniBetModal",staticClass:"active draggable resizable bet-zone",staticStyle:{"z-index":"2000","top":"20px","width":"300px"},attrs:{"id":"miniBetzone"}},[_c('div',{staticClass:"handle handle-tl",staticStyle:{"display":"block"}}),_vm._v(" "),_c('div',{staticClass:"handle handle-tm",staticStyle:{"display":"block"}}),_vm._v(" "),_c('div',{staticClass:"handle handle-tr",staticStyle:{"display":"block"}}),_vm._v(" "),_c('div',{staticClass:"handle handle-mr",staticStyle:{"display":"block"}}),_vm._v(" "),_c('div',{staticClass:"handle handle-br",staticStyle:{"display":"block"}}),_vm._v(" "),_c('div',{staticClass:"handle handle-bm",staticStyle:{"display":"block"}}),_vm._v(" "),_c('div',{staticClass:"handle handle-bl",staticStyle:{"display":"block"}}),_vm._v(" "),_c('div',{staticClass:"handle handle-ml",staticStyle:{"display":"block"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProcessBet && _vm.sportMiniBet.toggle),expression:"isProcessBet && sportMiniBet.toggle"}],staticClass:"cathectic-shade"},[_c('div',{staticClass:"shade-fixed"},[_c('div',{staticClass:"loading-wrap"},[_c('div',{staticClass:"img-loading"}),_vm._v(" "),_c('div',{staticClass:"text-center loading-text flex items-end justify-center"},[_vm._v(" "+_vm._s(_vm.betLang['BETTING.LBL_PROCESSING'])+"... ")])])])]),_vm._v(" "),_c('div',{staticClass:"bet-scroll-header",attrs:{"bet_flag":"true"}},[_c('hr',{staticClass:"q-separator bet-top-separator q-separator q-separator--horizontal",attrs:{"aria-orientation":"horizontal"}}),_vm._v(" "),_c('div',{staticClass:"vrow bet-back-btn yb-flex-between free-style"},[_c('div',[_c('div',{staticClass:"bet-zone-head justify-between align-items center cursor-pointer"},[_c('div',{on:{"click":function($event){return _vm.toggleMini()}}},[_c('span',{staticClass:"mr15 q-icon c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}},[(_vm.showExpandMini)?[_c('img',{attrs:{"src":"assets/images/minibet-shrink.svg"}})]:[_c('img',{attrs:{"src":"assets/images/minibet-expand.svg"}})]],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_ORDERS']))])])])]),_vm._v(" "),(_vm.hasParlay && !_vm.isParlayTab && this.selectedBettype.betTypId != '6')?_c('div',{staticClass:"bet-series-box"},[_c('span',{staticClass:"bet-series-text",class:{'actions':_vm.isMulp}},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_PARLAY']))]),_vm._v(" "),_c('div',{staticClass:"bet-series-switch",class:{'actions':_vm.isMulp},on:{"click":function($event){return _vm.updateParlay(true)}}},[_c('div',{staticClass:"bet-series-ok",class:{'actions':_vm.isMulp}})])]):_c('div',{staticClass:"col-auto bet-series bet-singlemulp yb-flex-between"},[(_vm.isMulp)?_c('span',{staticClass:"series_style"},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_PARLAY']))]):(!_vm.isMulp)?_c('span',{staticClass:"series_style"},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_SINGLE']))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"vrow bg-white"}),_vm._v(" "),_c('div',{staticClass:"bet-header-position"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showExpandMini),expression:"showExpandMini"}],staticClass:"cathectic-zone"},[_c('div',{staticClass:"bet-scroll-area q-scrollarea",staticStyle:{"height":"251px","width":"300px","max-height":"259px"},attrs:{"id":"betscrollarea"}},[_c('div',{staticClass:"q-scrollarea__container scroll relative-position fit",staticStyle:{"height":"251px !important","overflow-x":"auto"}},[_c('div',{staticClass:"q-scrollarea__content absolute bet-view",staticStyle:{"height":"251px"},attrs:{"id":"miniBetScroll"}},[(!_vm.isMulp)?_c('div',{staticClass:"bet-mode-zone",attrs:{"id":"betModeZone"}},[_c('div',{staticClass:"left"},[_c('span',[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_SINGLE']))]),_vm._v(" "),_c('span',{staticClass:"bet-single-count"},[_vm._v(_vm._s(_vm.betFormList.length))])]),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.allowComboBet && _vm.selectedBettype.betTypId!='5' && _vm.account.oneWallet!='1')?_c('label',{staticClass:"vrow check-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isBetCombo),expression:"isBetCombo"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isBetCombo)?_vm._i(_vm.isBetCombo,null)>-1:(_vm.isBetCombo)},on:{"change":function($event){var $$a=_vm.isBetCombo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isBetCombo=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isBetCombo=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isBetCombo=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.isBetCombo},staticStyle:{"margin-right":"5px"}}),_vm._v("\n                "+_vm._s(_vm.betLang['BETTING.LBL_COMBO'])+"\n              ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.isMulp)?_c('div',{staticClass:"bet-single",attrs:{"data-container":"single-container","id":"singleContainer"},on:{"touchstart":function($event){$event.stopPropagation();}}},[_vm._l((_vm.betFormList),function(data,key){return (_vm.betFormList)?[_c('div',{staticClass:"q-card q-card--flat no-shadow",class:_vm.bettingResultClass(data, key)},[_c('div',{staticClass:"q-card__section q-card__section--vert",class:{'bet-item':_vm.chkBettingSuccess(data) || _vm.chkBetPending(data)}},[_c('div',{staticClass:"vrow",class:{'first-row now-wrap':_vm.chkBettingSuccess(data)}},[_c('div',{staticClass:"col bet-league-name"},[_vm._v(_vm._s(data.league))]),_vm._v(" "),_c('div',{staticClass:"col-auto",class:{'col-delete': _vm.chkIsBetting(data, 'del'),'bet-icon-info': _vm.chkBettingSuccess(data)},on:{"click":function($event){return _vm.deleteMatch(data.eventObj.eveid, data, key)}}},[(_vm.chkIsBetting(data) && !_vm.wgNotsuccessreject.includes(data.wgStatus))?[_c('i',{staticClass:"bet-del q-icon icon-del c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]:(data.wgStatus=='2' || data.wgStatus=='0')?[_c('i',{staticClass:"q-icon icon-success c-icon",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true","role":"presentation"}})]:_vm._e(),_vm._v(" "),(data.wgStatus=='1')?[_c('span',{staticClass:"pending_wager",attrs:{"id":"dg_icon"}})]:_vm._e()],2)]),_vm._v(" "),(data.betType != '14')?_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-against"},[_c('span',{staticClass:"home-vs-away"},[_vm._v("\n                        "+_vm._s(data.ta)+"\n                        "),_c('span',{staticClass:"bet-pk"},[_vm._v("v")]),_vm._v("\n                        "+_vm._s(data.tb)+"\n                      ")]),_vm._v(" "),(data.eventObj && data.eventObj.rbinfo)?_c('span',{staticClass:"score"},[(data.sprtid=='1')?[_vm._v("\n                          ("+_vm._s(data.rbscoa)+"-"+_vm._s(data.rbscob)+")\n                        ")]:_vm._e()],2):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.chkBettingSuccess(data))?_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col match-time"},[(_vm.selectedLang == 2 || _vm.selectedLang == 3)?[_vm._v("\n                        "+_vm._s(_vm._f("date")(data.eventObj.dt,'MMMDo HH:mm'))+"\n                      ")]:[_vm._v("\n                        "+_vm._s(_vm._f("date")(data.eventObj.dt,'MM/DD HH:mm'))+"\n                      ")]],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bet-content"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-play-game"},[_c('label',{staticClass:"bet-play-text"},[(data.sprtid == 255)?[_c('span',{staticClass:"sport-name",staticStyle:{"display":"inline-flex","align-items":"center"}},[_c('label',{staticClass:"sport-img img36 SP"}),_vm._v("["+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.SPECIAL_EVENT'])+"]")]),_c('br')]:_vm._e(),_vm._v(" "),(data.eventObj && data.eventObj.rbinfo)?_c('span',{staticClass:"bet-match-playing"},[_vm._v("["+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_LIVE"])+"]")]):_vm._e(),_vm._v(" \n                          "+_vm._s(_vm.getPtBtCapt(data))+"\n                          "),_c('span',{staticClass:"bet-handicap-name",staticStyle:{"height":"15px !important"}},[_vm._v(_vm._s(_vm.getOddsTypeCap(data)))])],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"col bet-play-team yb-fontsize13"},[_c('div',{staticClass:"bet-team-handicap"},[(data.betType == '2' || data.betType == '9' || data.betType == '46' || data.betType == '47' || data.betType == '48' || data.betType == '49')?[(data.tbet == 'a')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_OVER"])+"\n                            ")]:(data.tbet == 'b')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_UNDER"])+"\n                            ")]:_vm._e()]:(data.betType == '32' || data.betType == '33'  || data.betType == '76' ||  data.betType == '79')?[(data.tbet == 'a')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_YES"])+"\n                            ")]:(data.tbet == 'b')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NO"])+"\n                            ")]:_vm._e()]:(data.betType == '21' || data.betType == '27' || data.betType == '36' || data.betType == '37' || data.betType == '38' || data.betType == '39' || data.betType == '40' || data.betType == '41' || data.betType == '42' || data.betType == '43' || data.betType == '44' || data.betType == '45')?[(data.tbet == 'a')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME"])+" \n                            ")]:(data.tbet == 'b')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY"])+"\n                            ")]:(data.tbet == 'x')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                            ")]:_vm._e(),_vm._v(" "),(data.betType == '21' || data.betType == '27')?[_vm._v("\n                              ("+_vm._s(_vm.h1x2Header(data.hdp, data.tbet))+")\n                            ")]:_vm._e()]:(data.betType == '50' || data.betType == '51')?[(data.tbet == 'h1')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1"])+"\n                            ")]:(data.tbet == 'h2')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2"])+"\n                            ")]:(data.tbet == 'h3')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3"])+"\n                            ")]:(data.tbet == 'h4')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4M"])+"\n                            ")]:(data.tbet == 'a1')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1"])+"\n                            ")]:(data.tbet == 'a2')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2"])+"\n                            ")]:(data.tbet == 'a3')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3"])+"\n                            ")]:(data.tbet == 'a4')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4M"])+"\n                            ")]:(data.tbet == 'sd')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AS"])+"\n                            ")]:(data.tbet == 'ng')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                            ")]:_vm._e()]:(data.betType == '77' || data.betType == '78')?[(data.tbet == 'h1')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1R"])+"\n                            ")]:(data.tbet == 'h2')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2R"])+"\n                            ")]:(data.tbet == 'h3')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3R"])+"\n                            ")]:(data.tbet == 'h4')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4RM"])+"\n                            ")]:(data.tbet == 'a1')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1R"])+"\n                            ")]:(data.tbet == 'a2')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2R"])+"\n                            ")]:(data.tbet == 'a3')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3R"])+"\n                            ")]:(data.tbet == 'a4')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4RM"])+"\n                            ")]:(data.tbet == 'sd')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_BB_AS"])+"\n                            ")]:(data.tbet == 'ng')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                            ")]:_vm._e()]:(data.betType == '28' || data.betType == '29' || data.betType == '30' || data.betType == '31')?[(data.tbet == 'a')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1HT"])+"\n                            ")]:(data.tbet == 'b')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2HT"])+"\n                            ")]:(data.tbet == 'x')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW2"])+"\n                            ")]:_vm._e()]:(data.betType == '25')?[(data.tbet == 'h_1_5')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                            ")]:(data.tbet == 'h_6_10')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                            ")]:(data.tbet == 'h_11_15')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                            ")]:(data.tbet == 'h_16_20')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                            ")]:(data.tbet == 'h_21_25')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                            ")]:(data.tbet == 'h_26_x')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.modifyTitle('h_26_x'))+"\n                            ")]:(data.tbet == 'a_1_5')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                            ")]:(data.tbet == 'a_6_10')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                            ")]:(data.tbet == 'a_11_15')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                            ")]:(data.tbet == 'a_16_20')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                            ")]:(data.tbet == 'a_21_25')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                            ")]:(data.tbet == 'a_26_x')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.modifyTitle('a_26_x'))+"\n                            ")]:_vm._e()]:(data.betType == '52')?[(data.tbet == 'hf')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HFG"])+"\n                            ")]:(data.tbet == 'hl')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HLG"])+"\n                            ")]:(data.tbet == 'af')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AFG"])+"\n                            ")]:(data.tbet == 'al')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_ALG"])+"\n                            ")]:(data.tbet == 'ng')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                            ")]:_vm._e()]:(data.betType == '53' || data.betType == '54' || data.betType == '55' || data.betType == '56')?[(data.tbet == '0_5')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_05"])+"\n                            ")]:(data.tbet == '1_6')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_16"])+"\n                            ")]:(data.tbet == '2_7')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_27"])+"\n                            ")]:(data.tbet == '3_8')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_38"])+"\n                            ")]:(data.tbet == '4_9')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_49"])+"\n                            ")]:_vm._e()]:(data.betType == '19' || data.betType == '20')?[(data.tbet == 'ha')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_AWAY"])+"\n                            ")]:(data.tbet == 'hd')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_DRAW"])+"\n                            ")]:[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY_OR_DRAW"])+"\n                            ")]]:(data.betType == '57' || data.betType == '58')?[(data.tbet == 'ng0')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_0"])+"\n                            ")]:(data.tbet == 'ng1')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1"])+"\n                            ")]:(data.tbet == 'ng2')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2"])+"\n                            ")]:(data.tbet == 'ng3')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_3"])+"\n                            ")]:(data.tbet == 'ng4')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_4"])+"\n                            ")]:(data.tbet == 'ng5')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_5"])+"\n                            ")]:(data.tbet == 'ng6')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_6more"])+"\n                            ")]:_vm._e()]:(data.betType == '59' || data.betType == '73')?[(data.tbet == 'ha')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                              "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                  "+_vm._s(_vm.getHdpCapt(data))+"\n                                ")])],_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                            ")]:(data.tbet == 'hb')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                              "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                  "+_vm._s(_vm.getHdpCapt(data))+"\n                                ")])],_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                            ")]:(data.tbet == 'aa')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                              "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                  "+_vm._s(_vm.getHdpCapt(data))+"\n                                ")])],_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                            ")]:(data.tbet == 'ab')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+"\n                              "),(!_vm.chkIsBetting(data))?[_vm._v(_vm._s(_vm.getHdpCapt(data)))]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                  "+_vm._s(_vm.getHdpCapt(data))+"\n                                ")])],_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                            ")]:_vm._e()]:(data.betType == '60' || data.betType == '61')?[(data.tbet == 'ha')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                              "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                  "+_vm._s(_vm.getHdpCapt(data))+"\n                                ")])],_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                            ")]:(data.tbet == 'hb')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                              "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                  "+_vm._s(_vm.getHdpCapt(data))+"\n                                ")])],_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                            ")]:(data.tbet == 'aa')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                              "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                  "+_vm._s(_vm.getHdpCapt(data))+"\n                                ")])],_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                            ")]:(data.tbet == 'ab')?[_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                              "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                  "+_vm._s(_vm.getHdpCapt(data))+"\n                                ")])],_vm._v("\n                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                            ")]:_vm._e()]:[_c('span',{domProps:{"innerHTML":_vm._s(data.tbetcapt)}})],_vm._v(" "),(data.betType=="1" || data.betType=="2" || data.betType=="8" || data.betType=="9" || data.betType=="46" || data.betType=="47" || data.betType=="48" || data.betType=="49" || data.betType=="63" || data.betType=="64" || data.betType=="68" || data.betType=="69")?[(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                "+_vm._s(_vm.getHdpCapt(data))+"\n                              ")])]]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-odds-value",class:_vm.getOddChange(data)},[_c('span',{staticClass:"odds-value yb-number-bold",staticStyle:{"float":"left","padding-left":"0px"}},[_c('span',[_vm._v("@")]),_vm._v(" "),((data.betType == _vm.csBetType || data.betType == _vm.rcsBetType) && data.odd>=10)?[_vm._v("\n                            "+_vm._s(new Number(parseFloat(data.odd)))+"\n                          ")]:[(_vm.betting.success)?[_vm._v("\n                              "+_vm._s(_vm.getDecimalDisplay(_vm.betting.success.data.betting[key].odd, _vm.betting.success.data.betting[key].sprtid))+"\n                            ")]:[_vm._v("\n                              "+_vm._s(_vm.getDecimalDisplay(data.odd, data.sprtid))+"\n                            ")]]],2)]),_vm._v(" "),_c('div',{staticClass:"auto-col"},[((_vm.betting.error && _vm.betting.error.code=='N-4000-N') || (_vm.isBetCombo && data.error && data.error.code=='N-4000-N'))?_c('span',{staticClass:"invalid"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang["ALL_BET.BET_CLOSE"])+"\n                        ")]):_vm._e(),_vm._v(" "),(data.wgStatus=='-1')?_c('span',{staticClass:"invalid"},[_vm._v("\n                          "+_vm._s(_vm.betLang["BETTING.LBL_REJECT_B"])+"\n                        ")]):_vm._e()])])]),_vm._v(" "),(_vm.chkIsBetting(data, 'input'))?_c('div',{staticClass:"vrow bet-single-input"},[_c('div',{staticClass:"col relative-position",attrs:{"data-check-money":"0"}},[((_vm.betting.error && _vm.betting.error.code=='N-4000-N') || (_vm.isBetCombo && data.error && data.error.code=='N-4000-N'))?_c('div',{staticClass:"cathectic-shade"}):_vm._e(),_vm._v(" "),(!_vm.isBetCombo)?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.betAmount),expression:"betAmount"}],ref:"betAmount",refInFor:true,staticClass:"bet-input input-border singleInput",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.betMinMaxVal,"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","size":"8","maxlength":_vm.amountMaxLength},domProps:{"value":(_vm.betAmount)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.betAmount=$event.target.value}}}),_vm._v(" "),(_vm.betAmount.length>0)?_c('div',{staticClass:"bet-input-close",on:{"click":function($event){return _vm.clearInput()}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.betComboAmount[key].value),expression:"betComboAmount[key].value"}],ref:'betAmount'+key,refInFor:true,staticClass:"bet-input input-border betComboInput",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.eventBetMinMax(data),"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","size":"8","maxlength":_vm.amountMaxLength,"disabled":data.error},domProps:{"value":(_vm.betComboAmount[key].value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.betComboAmount[key], "value", $event.target.value)},function($event){return _vm.setbetComboKeyboard(key)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)}}}),_vm._v(" "),(Object.keys(_vm.betComboAmount[key].value).length>0)?_c('div',{staticClass:"bet-input-close",on:{"click":function($event){return _vm.clearInput(key)}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()]],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vrow bet-win yb-fontsize12"},[(_vm.chkIsBetting(data))?[_c('div',{staticClass:"col df-jb"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"])+" ")]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-money yb-number-bold"},[(_vm.isBetCombo)?[_vm._v("\n                          "+_vm._s(_vm._f("decimal")(_vm.betPossiblePayout(key),2))+"\n                        ")]:[_vm._v("\n                          "+_vm._s(_vm._f("decimal")(_vm.possiblePayout,2))+"\n                        ")]],2)]:(_vm.chkBettingSuccess(data) || _vm.chkBetPending(data))?[_c('div',{staticClass:"col",staticStyle:{"height":"18px"}},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_STAKE']))]),_vm._v(" "),_c('div',{staticClass:"col-auto",staticStyle:{"height":"18px"}},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"]))])]:_vm._e()],2),_vm._v(" "),(_vm.promotionFlag && !((_vm.betting.success || (_vm.isBetCombo && _vm.wgSuccess.includes(data.wgStatus))) && !data.error) && _vm.isSportValidPromo(data.eventObj, data.betType) && !_vm.promotionBetStatus)?[_c('div',{staticClass:"promotion_join_box"},[_c('div',{staticClass:"promotion_join_img"}),_vm._v(" "),_c('div',{staticClass:"promotion_join"},[_vm._v(_vm._s(_vm.langList.promotion['promotion.promotion_join_get']))])])]:_vm._e(),_vm._v(" "),(_vm.chkBettingSuccess(data) || _vm.chkBetPending(data))?_c('div',{staticClass:"vrow bet-win2 yb-fontsize12",staticStyle:{"height":"18px"}},[_c('div',{staticClass:"col black-money-text"},[(_vm.chkBettingSuccess(data))?[(_vm.isBetCombo)?[_vm._v("\n                          "+_vm._s(_vm._f("decimal")(data.betAmt,2))+"\n                        ")]:[_vm._v("\n                          "+_vm._s(_vm._f("decimal")(_vm.betting.success.data.betAmt,2))+"\n                        ")]]:(!_vm.isBetCombo && _vm.chkBetPending(data))?[_vm._v(_vm._s(_vm._f("decimal")(_vm.betting.pending.data.betAmt,2)))]:[_vm._v(_vm._s(_vm._f("decimal")(data.betAmt,2)))]],2),_vm._v(" "),_c('div',{staticClass:"col-auto black-money-text"},[(!_vm.isBetCombo)?[_vm._v(_vm._s(_vm._f("decimal")(_vm.betSuccessPPayout(null, _vm.betting.selectedBetAllup),2)))]:[_vm._v(_vm._s(_vm._f("decimal")(_vm.betSuccessPPayout(data, _vm.betting.selectedBetAllup),2)))]],2)]):_vm._e()],2),_vm._v(" "),(_vm.chkIsBetting(data, 'keyboard'))?_c('div',{staticClass:"bet-keyboard-zone q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow bet-keyboard bet-keyboard-content"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"q-gutter-xs keyboard-zone"},[_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.min, key, 'min')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.min, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable':_vm.checkAllowKeyboard(data, _vm.keyboardAllow.min, key, 'min')}},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.min))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.med, key, 'med')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.med, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.med, key, 'med')}},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.med))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big, key, 'big')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable':_vm.checkAllowKeyboard(data, _vm.keyboardAllow.big, key, 'big')}},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big2, key, 'big2')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big2, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big2, key, 'big2')}},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big2))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big3, key, 'big3')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big3, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable': _vm.checkAllowKeyboard(data, _vm.keyboardAllow.big3, key, 'big3')}},[_vm._v("+"+_vm._s(_vm.commasAmount(_vm.betting.betAmountOption.big3)))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn':_vm.isBetCombo},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.max, key)}}},[_c('div',{staticClass:"keyboard-btn-text",class:{'text-disable':_vm.isBetCombo}},[_vm._v("\n                            "+_vm._s(_vm.langList.sportMinibetLang['SPORT_MINIBET.MAX'])+"\n                          ")])])])])])]):_vm._e()]),_vm._v(" "),(!_vm.isBetCombo && _vm.wgSts.includes(data.wgStatus) || (_vm.isBetCombo && _vm.checkShowErrMsg(data, _vm.jsError, key)))?_c('div',{staticClass:"bet-confirm-message text-center yb-fontsize12 ab",class:_vm.getBetConfirmClass(data, key)},[(data.wgStatus==1)?[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_PENDING_BET']))]:((_vm.betting.success || (_vm.isBetCombo && _vm.wgSuccess.includes(data.wgStatus))) && !data.error)?[_vm._v("\n                  "+_vm._s(_vm.betLang['BETTING.LBL_BET_CONFIRM'])+"\n                ")]:[(data.oddChg)?[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_ODDS_CHANGE"]))]:_vm._e(),_vm._v(" "),(data.hdpChg)?[(data.oddChg)?[_vm._v(",")]:_vm._e(),_vm._v("\n                    "+_vm._s(_vm.betLang["BETTING.LBL_HANDICAP_CHANGE"])+"\n                  ")]:(data.error && data.error.code!='N-4000-N')?[_vm._v("\n                    "+_vm._s(data.error.message)),_c('br'),_vm._v(_vm._s(data.error.code)+"\n                  ")]:(!_vm.isBetCombo && _vm.jsError.error)?[_vm._v("\n                    "+_vm._s(_vm.jsError.msg)+"\n                  ")]:(_vm.isBetCombo && (_vm.betCombo_jsError[key]!=undefined && _vm.betCombo_jsError[key].error))?[_vm._v("\n                    "+_vm._s(_vm.betCombo_jsError[key].msg)+"\n                  ")]:_vm._e()]],2):_vm._e()]:_vm._e()}),_vm._v(" "),(_vm.isBetCombo && _vm.betFormList.length>1 && !_vm.betting.betcombosuccess && !_vm.betting.pending)?_c('div',{staticClass:"relative-position bet-multiple bet-card q-card q-card--flat no-shadow",staticStyle:{"margin-top":"5px"},attrs:{"id":"betMultiple","is_forward":"-1"}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.MULTI_SINGLES"]))])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-multiple-input yb-flex-nowrap"},[_c('div',{staticClass:"col bet-count"},[_c('span',[_vm._v(_vm._s(_vm.betFormList.length))]),_vm._v(" "),_c('span',{staticClass:"operation-symbol"},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"col-auto right-input",attrs:{"data-check-money":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allBetComboAmount),expression:"allBetComboAmount"}],ref:"betAmount",staticClass:"bet-input input-border",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.betMinMaxVal,"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","size":"8","maxlength":_vm.amountMaxLength},domProps:{"value":(_vm.allBetComboAmount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.allBetComboAmount=$event.target.value},function($event){return _vm.setALLbetComboAmount()}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)}}}),_vm._v(" "),(_vm.allBetComboAmount!='')?_c('div',{staticClass:"bet-input-close",on:{"click":function($event){return _vm.clearInput(null, 'all')}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-win yb-fontsize12"},[_c('div',{staticClass:"col df-jb"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"])+" ")]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-money yb-number-bold"},[_vm._v("\n                    "+_vm._s(_vm._f("decimal")(_vm.betPossiblePayout(),2))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-keyboard bet-keyboard-content"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"q-gutter-xs keyboard-zone"},[_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.min, 'all', 'min') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.min)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.min))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.med, 'all', 'med') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.med)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.med))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big, 'all', 'big') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big2, 'all', 'big2') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big2)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big2))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, 'all', 'big3') },on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big3)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.commasAmount(_vm.betting.betAmountOption.big3)))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn disable-key-btn",on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.max)}}},[_c('div',{staticClass:"keyboard-btn-text text-disable"},[_vm._v("\n                          "+_vm._s(_vm.langList.sportMinibetLang['SPORT_MINIBET.MAX'])+"\n                        ")])])])])])])]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isMulp)?_c('div',{staticClass:"bet-mix height-full bet-layout"},[_c('div',{staticClass:"auto-wrap no-wrap column"},[_c('div',{staticClass:"scroll-wrap"},[(_vm.betting.success || _vm.betting.pending)?_c('div',{staticClass:"bet-mix-record"},[_vm._l((_vm.betFormList),function(data,key){return (_vm.betFormList)?[_c('div',{staticClass:"bet-mix-record-item-card q-card q-card--flat no-shadow",class:{'bet-mix-record-item-first':key==0}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-league-name"},[_vm._v(_vm._s(data.league))])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-against"},[_c('span',{staticClass:"home-vs-away"},[_vm._v(_vm._s(data.ta)),_c('span',{staticClass:"bet-pk"},[_vm._v("v")]),_vm._v(_vm._s(data.tb)+"\n                              "),(data.eventObj && data.eventObj.rbinfo)?[_vm._v("("+_vm._s(data.eventObj.rbinfo.scoa)+"-"+_vm._s(data.eventObj.rbinfo.scob)+")")]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col match-time"},[(_vm.selectedLang==2 || _vm.selectedLang==3)?[_vm._v("\n                              "+_vm._s(_vm._f("date")(data.eventObj.dt,'MMMDo HH:mm'))+"\n                            ")]:[_vm._v("\n                              "+_vm._s(_vm._f("date")(data.eventObj.dt,'MM/DD HH:mm'))+"\n                            ")]],2)]),_vm._v(" "),_c('div',{staticClass:"bet-content"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-play-game"},[_c('label',{staticClass:"bet-play-text"},[(data.eventObj && data.eventObj.rbinfo)?_c('label',{staticClass:"bet-match-playing"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_LIVE"]))]):_vm._e(),_vm._v("\n                                  "+_vm._s(_vm.getPtBtCapt(data))+"\n                                "),_c('label',{staticClass:"bet-handicap-name"},[_vm._v(_vm._s(_vm.getOddsTypeCap(data))+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-auto"})]),_vm._v(" "),_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"col bet-play-team"},[_c('label',{staticClass:"bet-team-handicap"},[(data.betType == '2' || data.betType == '9' || data.betType == '46' || data.betType == '47' || data.betType == '48' || data.betType == '49')?[(data.tbet == 'a')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_OVER"])+"\n                                  ")]:(data.tbet == 'b')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_UNDER"])+"\n                                  ")]:_vm._e()]:(data.betType == '32' || data.betType == '33' || data.betType == '76' ||  data.betType == '79')?[(data.tbet == 'a')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_YES"])+"\n                                  ")]:(data.tbet == 'b')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NO"])+"\n                                  ")]:_vm._e()]:(data.betType == '21' || data.betType == '27' || data.betType == '36' || data.betType == '37' || data.betType == '38' || data.betType == '39' || data.betType == '40' || data.betType == '41' || data.betType == '42' || data.betType == '43' || data.betType == '44' || data.betType == '45')?[(data.tbet == 'a')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME"])+" \n                                  ")]:(data.tbet == 'b')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY"])+"\n                                  ")]:(data.tbet == 'x')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                                  ")]:_vm._e(),_vm._v(" "),(data.betType == '21' || data.betType == '27')?[_vm._v("\n                                    ("+_vm._s(_vm.h1x2Header(data.hdp, data.tbet))+")\n                                  ")]:_vm._e()]:(data.betType == '50' || data.betType == '51')?[(data.tbet == 'h1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1"])+"\n                                  ")]:(data.tbet == 'h2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2"])+"\n                                  ")]:(data.tbet == 'h3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3"])+"\n                                  ")]:(data.tbet == 'h4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4M"])+"\n                                  ")]:(data.tbet == 'a1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1"])+"\n                                  ")]:(data.tbet == 'a2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2"])+"\n                                  ")]:(data.tbet == 'a3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3"])+"\n                                  ")]:(data.tbet == 'a4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4M"])+"\n                                  ")]:(data.tbet == 'sd')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AS"])+"\n                                  ")]:(data.tbet == 'ng')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                                  ")]:_vm._e()]:(data.betType == '77' || data.betType == '78')?[(data.tbet == 'h1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1R"])+"\n                                  ")]:(data.tbet == 'h2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2R"])+"\n                                  ")]:(data.tbet == 'h3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3R"])+"\n                                  ")]:(data.tbet == 'h4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4RM"])+"\n                                  ")]:(data.tbet == 'a1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1R"])+"\n                                  ")]:(data.tbet == 'a2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2R"])+"\n                                  ")]:(data.tbet == 'a3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3R"])+"\n                                  ")]:(data.tbet == 'a4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4RM"])+"\n                                  ")]:(data.tbet == 'sd')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_BB_AS"])+"\n                                  ")]:(data.tbet == 'ng')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                                  ")]:_vm._e()]:(data.betType == '28' || data.betType == '29' || data.betType == '30' || data.betType == '31')?[(data.tbet == 'a')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1HT"])+"\n                                  ")]:(data.tbet == 'b')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2HT"])+"\n                                  ")]:(data.tbet == 'x')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                                  ")]:_vm._e()]:(data.betType == '25')?[(data.tbet == 'h_1_5')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                                  ")]:(data.tbet == 'h_6_10')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                                  ")]:(data.tbet == 'h_11_15')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                                  ")]:(data.tbet == 'h_16_20')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                                  ")]:(data.tbet == 'h_21_25')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                                  ")]:(data.tbet == 'h_26_x')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.modifyTitle('h_26_x'))+"\n                                  ")]:(data.tbet == 'a_1_5')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                                  ")]:(data.tbet == 'a_6_10')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                                  ")]:(data.tbet == 'a_11_15')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                                  ")]:(data.tbet == 'a_16_20')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                                  ")]:(data.tbet == 'a_21_25')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                                  ")]:(data.tbet == 'a_26_x')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.modifyTitle('a_26_x'))+"\n                                  ")]:_vm._e()]:(data.betType == '52')?[(data.tbet == 'hf')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HFG"])+"\n                                  ")]:(data.tbet == 'hl')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HLG"])+"\n                                  ")]:(data.tbet == 'af')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AFG"])+"\n                                  ")]:(data.tbet == 'al')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_ALG"])+"\n                                  ")]:(data.tbet == 'ng')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                                  ")]:_vm._e()]:(data.betType == '53' || data.betType == '54' || data.betType == '55' || data.betType == '56')?[(data.tbet == '0_5')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_05"])+"\n                                  ")]:(data.tbet == '1_6')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_16"])+"\n                                  ")]:(data.tbet == '2_7')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_27"])+"\n                                  ")]:(data.tbet == '3_8')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_38"])+"\n                                  ")]:(data.tbet == '4_9')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_49"])+"\n                                  ")]:_vm._e()]:(data.betType == '19' || data.betType == '20')?[(data.tbet == 'ha')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_AWAY"])+"\n                                  ")]:(data.tbet == 'hd')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_DRAW"])+"\n                                  ")]:[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY_OR_DRAW"])+"\n                                  ")]]:(data.betType == '57' || data.betType == '58')?[(data.tbet == 'ng0')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_0"])+"\n                                  ")]:(data.tbet == 'ng1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1"])+"\n                                  ")]:(data.tbet == 'ng2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2"])+"\n                                  ")]:(data.tbet == 'ng3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_3"])+"\n                                  ")]:(data.tbet == 'ng4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_4"])+"\n                                  ")]:(data.tbet == 'ng5')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_5"])+"\n                                  ")]:(data.tbet == 'ng6')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_6more"])+"\n                                  ")]:_vm._e()]:(data.betType == '59' || data.betType == '73')?[(data.tbet == 'ha')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                                  ")]:(data.tbet == 'hb')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                                  ")]:(data.tbet == 'aa')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                                  ")]:(data.tbet == 'ab')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                                  ")]:_vm._e()]:(data.betType == '60' || data.betType == '61')?[(data.tbet == 'ha')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                  ")]:(data.tbet == 'hb')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                  ")]:(data.tbet == 'aa')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                                  ")]:(data.tbet == 'ab')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                                  ")]:_vm._e()]:[_vm._v("\n                                  "+_vm._s(data.tbetcapt)+"\n                                ")],_vm._v(" "),(data.betType=="1" || data.betType=="2" || data.betType=="8" || data.betType=="9" || data.betType=="46" || data.betType=="47" || data.betType=="48" || data.betType=="49" || data.betType=="63" || data.betType=="64" || data.betType=="68" || data.betType=="69")?[((data.hdp!=0 ))?_c('label',{staticClass:"handicap yb-number-bold bet-text-nowrap",class:{'bet-handicap':data.hdpChg}},[_vm._v(_vm._s(_vm.getHdpCapt(data)))]):((data.hdp==0 && (data.betType == '1' ||data.betType == '8')))?_c('label',{staticClass:"handicap yb-number-bold bet-text-nowrap",class:{'bet-handicap':data.hdpChg}},[_vm._v("0")]):_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col yb-fontsize16 bet-odds-value"},[_c('span',{staticClass:"odds-value yb-number-bold"},[_c('span',[_vm._v("@")]),_vm._v(" "),(data.betType == 7 || data.betType == 16)?[_vm._v("\n                                  "+_vm._s(new Number(parseFloat(data.odd)))+"\n                                ")]:[(_vm.betting.success)?[_vm._v("\n                                    "+_vm._s(_vm.getDecimalDisplay(_vm.betting.success.data.betting[key].odd, _vm.betting.success.data.betting[key].sprtid))+"\n                                  ")]:[_vm._v("\n                                    "+_vm._s(_vm.getDecimalDisplay(data.odd, data.sprtid))+"\n                                  ")]]],2)])])])])])]:_vm._e()}),_vm._v(" "),((_vm.betting.success && _vm.betting.success.data.mulpRes) || (_vm.betting.pending && _vm.betting.pending.data.mulpRes))?[_vm._l((((_vm.betting.success && _vm.betting.success.data.mulpRes) || (_vm.betting.pending && _vm.betting.pending.data.mulpRes))),function(data,key){return [_c('div',{staticClass:"bet-mix-result-card q-card q-card--flat no-shadow bet-mix-record-result-last"},[_c('div',{staticClass:"q-card__section q-card__section--vert bet-success-bg"},[_c('div',{staticClass:"odds-wrap vrow"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"col bet-play-info yb-fontsize13"},[_vm._v(_vm._s(_vm.getMulpCaption(_vm.betLang, data.allUp)))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-icon-info",staticStyle:{"display":"block!important"}},[(data.wgStatus && data.wgStatus == '1')?[_c('span',{staticClass:"pending_wager",attrs:{"id":"dg_icon"}})]:[_c('i',{staticClass:"q-icon c-icon",class:{'icon-failure':data.WagerID==undefined, 'icon-success':data.WagerID!=undefined},staticStyle:{"font-size":"18px"},attrs:{"data-v-082e727f":"","aria-hidden":"true","role":"presentation"}})]],2)]),_vm._v(" "),_c('div',{staticClass:"vrow bet-win-info"},[_c('div',{staticClass:"col yb-fontsize12"},[_vm._v(" "+_vm._s(_vm.betLang['BETTING.LBL_STAKE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col-auto yb-fontsize12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"])+" ")])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-win-info2 yb-fontsize12"},[_c('div',{staticClass:"col bet-win-value"},[_vm._v(_vm._s(_vm._f("decimal")(data.amount? data.amount:_vm.betMulpAmtFiltered[key].stake,2)))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-value text-right yb-fontsize12"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.betMulpAmtFiltered[key].possiblePayout,2)))])])])]),_vm._v(" "),(data.error!=undefined && data.error!='')?_c('div',{staticClass:"bet-confirm-message text-center yb-fontsize12 bet-fail-order",staticStyle:{"margin-left":"5px","margin-right":"5px","background":"rgba(255, 64, 64, 0.2)","color":"#ff4040","border-radius":"0px 0px 6px 6px"}},[_vm._v("\n                        "+_vm._s(data.error.message)),_c('br'),_vm._v(_vm._s(data.error.code)+"\n                      ")]):_vm._e()]})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"bet-mix-result-card q-card q-card--flat no-shadow bet-mix-record-result-last"},[_c('div',{staticClass:"q-card__section q-card__section--vert bet-success-bg"},[_c('div',{staticClass:"vrow bet-total",staticStyle:{"line-height":"24px"}},[_c('div',{staticClass:"col bet-total-left"},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_TOTAL_BET"])+" "+_vm._s(_vm.countTotalStakePayout('totalBet', true)))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-total-right"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.countTotalStakePayout('totalStake', true),2)))])]),_vm._v(" "),_c('div',{staticClass:"vrow bet-total",staticStyle:{"line-height":"24px"}},[_c('div',{staticClass:"col bet-total-left"},[_vm._v(_vm._s(_vm.betLang["BETTING.LBL_EST_WIN"])+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-total-right bet-gold-text"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.countTotalStakePayout('possiblePayout', true),2)))])])])])],2):_vm._e(),_vm._v(" "),(!_vm.betting.success && !_vm.betting.pending)?_c('div',{staticClass:"c-bet-mix-info",attrs:{"id":"cbetmixinfo"}},[_vm._l((_vm.betFormList),function(data,key){return (_vm.betFormList)?[_c('div',{staticClass:"relative-position bet-mix-item-card q-card q-card--flat no-shadow",class:{'bet-mix-item-first':key==0, 'bet-no-effect':(_vm.betting.minMax==undefined || Object.keys(_vm.betFormList).length < _vm.betting.minMax.minCombo || (data.error && data.error!=''))}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-league-name"},[_vm._v(_vm._s(data.league))]),_vm._v(" "),_c('div',{staticClass:"col-auto",on:{"click":function($event){return _vm.deleteMatch(data.eventObj.eveid, data)}}},[_c('i',{staticClass:"bet-del q-icon icon-del c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-against"},[_c('span',{staticClass:"home-vs-away"},[_vm._v(_vm._s(data.ta)),_c('span',{staticClass:"bet-pk"},[_vm._v("v")]),_vm._v(_vm._s(data.tb))]),_vm._v(" "),(data.eventObj && data.eventObj.rbinfo)?_c('span',[_vm._v("("+_vm._s(data.eventObj.rbinfo.scoa)+"-"+_vm._s(data.eventObj.rbinfo.scob)+")")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"bet-content"},[_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-play-game"},[_c('label',{staticClass:"bet-play-text"},[(data.eventObj && data.eventObj.rbinfo)?_c('label',{staticClass:"bet-match-playing"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_LIVE"]))]):_vm._e(),_vm._v("\n                                "+_vm._s(_vm.getPtBtCapt(data))+"\n                                "),_c('label',{staticClass:"bet-handicap-name"},[_vm._v(_vm._s(_vm.getOddsTypeCap(data))+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"col bet-play-team"},[_c('label',{staticClass:"bet-team-handicap"},[(data.betType == '2' || data.betType == '9' || data.betType == '46' || data.betType == '47' || data.betType == '48' || data.betType == '49')?[(data.tbet == 'a')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_OVER"])+"\n                                  ")]:(data.tbet == 'b')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_UNDER"])+"\n                                  ")]:_vm._e()]:(data.betType == '32' || data.betType == '33' || data.betType == '76' ||  data.betType == '79')?[(data.tbet == 'a')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_YES"])+"\n                                  ")]:(data.tbet == 'b')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NO"])+"\n                                  ")]:_vm._e()]:(data.betType == '21' || data.betType == '27' || data.betType == '36' || data.betType == '37' || data.betType == '38' || data.betType == '39' || data.betType == '40' || data.betType == '41' || data.betType == '42' || data.betType == '43' || data.betType == '44' || data.betType == '45')?[(data.tbet == 'a')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME"])+" \n                                  ")]:(data.tbet == 'b')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY"])+"\n                                  ")]:(data.tbet == 'x')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                                  ")]:_vm._e(),_vm._v(" "),(data.betType == '21' || data.betType == '27')?[_vm._v("\n                                    ("+_vm._s(_vm.h1x2Header(data.hdp, data.tbet))+")\n                                  ")]:_vm._e()]:(data.betType == '50' || data.betType == '51')?[(data.tbet == 'h1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1"])+"\n                                  ")]:(data.tbet == 'h2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2"])+"\n                                  ")]:(data.tbet == 'h3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3"])+"\n                                  ")]:(data.tbet == 'h4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4M"])+"\n                                  ")]:(data.tbet == 'a1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1"])+"\n                                  ")]:(data.tbet == 'a2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2"])+"\n                                  ")]:(data.tbet == 'a3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3"])+"\n                                  ")]:(data.tbet == 'a4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4M"])+"\n                                  ")]:(data.tbet == 'sd')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AS"])+"\n                                  ")]:(data.tbet == 'ng')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                                  ")]:_vm._e()]:(data.betType == '77' || data.betType == '78')?[(data.tbet == 'h1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB1R"])+"\n                                  ")]:(data.tbet == 'h2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB2R"])+"\n                                  ")]:(data.tbet == 'h3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB3R"])+"\n                                  ")]:(data.tbet == 'h4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HWB4RM"])+"\n                                  ")]:(data.tbet == 'a1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB1R"])+"\n                                  ")]:(data.tbet == 'a2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB2R"])+"\n                                  ")]:(data.tbet == 'a3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB3R"])+"\n                                  ")]:(data.tbet == 'a4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWB4RM"])+"\n                                  ")]:(data.tbet == 'sd')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_BB_AS"])+"\n                                  ")]:(data.tbet == 'ng')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                                  ")]:_vm._e()]:(data.betType == '28' || data.betType == '29' || data.betType == '30' || data.betType == '31')?[(data.tbet == 'a')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1HT"])+"\n                                  ")]:(data.tbet == 'b')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2HT"])+"\n                                  ")]:(data.tbet == 'x')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_DRAW"])+"\n                                  ")]:_vm._e()]:(data.betType == '25')?[(data.tbet == 'h_1_5')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                                  ")]:(data.tbet == 'h_6_10')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                                  ")]:(data.tbet == 'h_11_15')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                                  ")]:(data.tbet == 'h_16_20')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                                  ")]:(data.tbet == 'h_21_25')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                                  ")]:(data.tbet == 'h_26_x')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+" "+_vm._s(_vm.modifyTitle('h_26_x'))+"\n                                  ")]:(data.tbet == 'a_1_5')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"])+"\n                                  ")]:(data.tbet == 'a_6_10')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"])+"\n                                  ")]:(data.tbet == 'a_11_15')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"])+"\n                                  ")]:(data.tbet == 'a_16_20')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"])+"\n                                  ")]:(data.tbet == 'a_21_25')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"])+"\n                                  ")]:(data.tbet == 'a_26_x')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+" "+_vm._s(_vm.modifyTitle('a_26_x'))+"\n                                  ")]:_vm._e()]:(data.betType == '52')?[(data.tbet == 'hf')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HFG"])+"\n                                  ")]:(data.tbet == 'hl')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HLG"])+"\n                                  ")]:(data.tbet == 'af')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AFG"])+"\n                                  ")]:(data.tbet == 'al')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_ALG"])+"\n                                  ")]:(data.tbet == 'ng')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_NG"])+"\n                                  ")]:_vm._e()]:(data.betType == '53' || data.betType == '54' || data.betType == '55' || data.betType == '56')?[(data.tbet == '0_5')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_05"])+"\n                                  ")]:(data.tbet == '1_6')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_16"])+"\n                                  ")]:(data.tbet == '2_7')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_27"])+"\n                                  ")]:(data.tbet == '3_8')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_38"])+"\n                                  ")]:(data.tbet == '4_9')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_49"])+"\n                                  ")]:_vm._e()]:(data.betType == '19' || data.betType == '20')?[(data.tbet == 'ha')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_AWAY"])+"\n                                  ")]:(data.tbet == 'hd')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_HOME_OR_DRAW"])+"\n                                  ")]:[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_AWAY_OR_DRAW"])+"\n                                  ")]]:(data.betType == '57' || data.betType == '58')?[(data.tbet == 'ng0')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_0"])+"\n                                  ")]:(data.tbet == 'ng1')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_1"])+"\n                                  ")]:(data.tbet == 'ng2')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_2"])+"\n                                  ")]:(data.tbet == 'ng3')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_3"])+"\n                                  ")]:(data.tbet == 'ng4')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_4"])+"\n                                  ")]:(data.tbet == 'ng5')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_5"])+"\n                                  ")]:(data.tbet == 'ng6')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang["ALL_BET.LBL_6more"])+"\n                                  ")]:_vm._e()]:(data.betType == '59' || data.betType == '73')?[(data.tbet == 'ha')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                                  ")]:(data.tbet == 'hb')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                                  ")]:(data.tbet == 'aa')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                                  ")]:(data.tbet == 'ab')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                                  ")]:_vm._e()]:(data.betType == '60' || data.betType == '61')?[(data.tbet == 'ha')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                  ")]:(data.tbet == 'hb')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                  ")]:(data.tbet == 'aa')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                                  ")]:(data.tbet == 'ab')?[_vm._v("\n                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                                    "),(!_vm.chkIsBetting(data))?[_vm._v(" "+_vm._s(_vm.getHdpCapt(data))+" ")]:[_c('label',{staticClass:"yb-number-bold handicap",class:{'bet-handicap':data.hdpChg}},[_vm._v("\n                                        "+_vm._s(_vm.getHdpCapt(data))+"\n                                      ")])],_vm._v("\n                                     "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                                  ")]:_vm._e()]:[_vm._v("\n                                  "+_vm._s(data.tbetcapt)+"\n                                ")],_vm._v(" "),(data.betType=="1" || data.betType=="2" || data.betType=="8" || data.betType=="9" || data.betType=="46" || data.betType=="47" || data.betType=="48" || data.betType=="49" || data.betType=="63" || data.betType=="64" || data.betType=="68" || data.betType=="69")?[((data.hdp!=0 ))?_c('label',{staticClass:"handicap yb-number-bold bet-text-nowrap",class:{'bet-handicap':data.hdpChg}},[_vm._v(_vm._s(_vm.getHdpCapt(data)))]):((data.hdp==0 && (data.betType == '1' ||data.betType == '8')))?_c('label',{staticClass:"handicap yb-number-bold bet-text-nowrap",class:{'bet-handicap':data.hdpChg}},[_vm._v("0")]):_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"col bet-odds-value",class:_vm.getOddChange(data)},[_c('span',{staticClass:"odds-value yb-number-bold"},[_c('span',[_vm._v("@")]),_vm._v(" "),(data.betType == 7 || data.betType == 16)?[_vm._v("\n                                  "+_vm._s(new Number(parseFloat(data.odd)))+"\n                                ")]:[_vm._v("\n                                  "+_vm._s(_vm.getDecimalDisplay(data.odd, data.sprtid))+"\n                                ")]],2)]),_vm._v(" "),_c('div',{staticClass:"auto-col"},[(_vm.betting.error && data.error && data.error!='')?[(data.error.code && (data.error.code.indexOf('4000-N1') > -1 || data.error.code.indexOf('4031') > -1))?_c('span',{staticClass:"invalid serial-msg"},[_vm._v(_vm._s(_vm.betLang["BETTING.NOT_SUPPORT_PARLAY"]))]):_c('span',{staticClass:"invalid serial-msg"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.BET_CLOSE"]))])]:_vm._e()],2)])])])])]:_vm._e()}),_vm._v(" "),(_vm.betMulpAmount && _vm.betMulpAmount.length>0 && _vm.betting.allUpList && _vm.betting.minMax!=undefined && Object.keys(_vm.betFormList).length >= _vm.betting.minMax.minCombo && !_vm.betting.error)?_c('div',{attrs:{"id":"bet_input_defaut_one"}},[_c('div',{staticClass:"bet-mix-input-card q-card q-card--flat no-shadow bet-mix-input-last",attrs:{"id":'betmixcard_'+_vm.betting.allUpList[0].key}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"odds-wrap vrow"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"col bet-mix-info"},[_vm._v("\n                            "+_vm._s(_vm.getMulpCaption(_vm.betLang, _vm.betting.allUpList[0].key))+"\n                          ")]),_vm._v(" "),_c('span',{staticClass:"odds-value yb-number-bold"},[_vm._v("@"+_vm._s(_vm.getMULPOdds()))])]),_vm._v(" "),(_vm.checkMaxOdds(0))?[_c('div',{staticClass:"vrow bet-mix-input",attrs:{"data-check-money":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.betMulpAmount[0].value),expression:"betMulpAmount[0].value"}],ref:"betAmount0",staticClass:"bet-input input-border",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.betMinMaxMulp(0),"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","id":_vm.betting.allUpList[0].key,"size":"8","maxlength":_vm.amountMaxLength},domProps:{"value":(_vm.betMulpAmount[0].value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.betMulpAmount[0], "value", $event.target.value)},function($event){return _vm.setbetMulpKeyboard(0)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)},"focus":function($event){return _vm.showKeyboard(_vm.betting.allUpList[0].key, 0)}}}),_vm._v(" "),(Object.keys(_vm.betMulpAmount[0].value).length>0)?_c('div',{class:{'bet-input-close-1':_vm.totalBet1(_vm.betting.allUpList[0].key).toString().length==1,'bet-input-close-2':_vm.totalBet1(_vm.betting.allUpList[0].key).toString().length>1},staticStyle:{"top":"40px","right":"10px"},on:{"click":function($event){return _vm.clearInput(0)}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mulp_keyboard",class:_vm.betting.allUpList[0].key},[_c('div',{staticClass:"vrow bet-win yb-fontsize12"},[_c('div',{staticClass:"col df-jb"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"]))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-money yb-number-bold"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.displayMulpPossiblePayout(0),2)))])]),_vm._v(" "),_c('div',{staticClass:"bet-keyboard-zone q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow bet-keyboard bet-keyboard-content"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"q-gutter-xs keyboard-zone"},[_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.min, 0, 'min')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.min, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.min))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.med, 0, 'med')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.med, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.med))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big, 0, 'big')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big2, 0, 'big2')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big2, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big2))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, 0, 'big3')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big3, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.commasAmount(_vm.betting.betAmountOption.big3)))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, 0, 'big3')||_vm.betMulpAmount[0].maxPay==''||_vm.betMulpAmount[0].maxPay==0},on:{"click":function($event){return _vm.addsum(_vm.betMulpAmount[0].maxPay, 0)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v(_vm._s(_vm.langList.sportMinibetLang['SPORT_MINIBET.MAX']))])])])])])])])]:[_c('div',{staticClass:"bet-message text-center",staticStyle:{"height":"auto","line-height":"normal","margin":"15px 0px","color":"#ff4040"},attrs:{"data-v-9f62b2ae":""}},[_vm._v("\n                              "+_vm._s(_vm.betLang['BETTING.EXCEED_MAX_ODDS']+' '+_vm.betting.minMax.maxOdds)+"\n                            ")])]],2)])]):_vm._e(),_vm._v(" "),(_vm.betMulpAmount && _vm.betMulpAmount.length>0 && _vm.betting.allUpList && _vm.betting.allUpList.length>1 && _vm.betting.minMax!=undefined && Object.keys(_vm.betFormList).length >= _vm.betting.minMax.minCombo && !_vm.betting.error)?[_c('div',{staticClass:"row bet-toggle bet-toggle-up",on:{"click":function($event){return _vm.multipleBetClick()}}},[_c('div',{staticClass:"col bet-toggle-text cursor-pointer"},[_vm._v(_vm._s(_vm.betLang['BETTING.LBL_MULTIPLE_BET']))]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('span',{},[_c('i',{staticClass:"q-icon icon-triangle c-icon icon-pull-down",class:{'icon-pull-up':_vm.multipleBetToggle},staticStyle:{"font-size":"16px"},attrs:{"aria-hidden":"true","role":"presentation"}})])])]),_vm._v(" "),(_vm.multipleBetToggle)?_c('div',{},[_vm._l((_vm.betting.allUpList),function(allUp,index){return (index>=1)?[_c('div',{staticClass:"bet-mix-input-card q-card q-card--flat no-shadow bet-mix-input-last",attrs:{"id":'betmixcard_'+allUp.key}},[_c('div',{staticClass:"q-card__section q-card__section--vert"},[_c('div',{staticClass:"odds-wrap vrow"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"col bet-mix-info"},[_vm._v("\n                                "+_vm._s(_vm.getMulpCaption(_vm.betLang, allUp.key))+"\n                              ")])]),_vm._v(" "),(_vm.checkMaxOdds(index))?[_c('div',{staticClass:"vrow bet-mix-input",attrs:{"data-check-money":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.betMulpAmount[index].value),expression:"betMulpAmount[index].value"}],ref:'betAmount'+index,refInFor:true,staticClass:"bet-input input-border",class:_vm.JSErr,attrs:{"inputmode":"decimal","placeholder":_vm.betMinMaxMulp(index),"autocomplete":"off","onkeypress":"return event.charCode >= 48 && event.charCode <= 57","id":allUp.key,"size":"8","maxlength":_vm.amountMaxLength},domProps:{"value":(_vm.betMulpAmount[index].value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.betMulpAmount[index], "value", $event.target.value)},function($event){return _vm.setbetMulpKeyboard(index)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.confirmBetForm.apply(null, arguments)},"focus":function($event){return _vm.showKeyboard(allUp.key, index)}}}),_vm._v(" "),(Object.keys(_vm.betMulpAmount[index].value).length>0)?_c('div',{class:{'bet-input-close-1':_vm.totalBet1(allUp.key).toString().length==1,'bet-input-close-2':_vm.totalBet1(allUp.key).toString().length>1},staticStyle:{"top":"40px","right":"10px"},on:{"click":function($event){return _vm.clearInput(index)}}},[_c('i',{staticClass:"q-icon icon-failure c-icon",staticStyle:{"font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mulp_keyboard",class:allUp.key,staticStyle:{"display":"none"}},[_c('div',{staticClass:"vrow bet-win yb-fontsize12"},[_c('div',{staticClass:"col df-jb"},[_vm._v(_vm._s(_vm.sportAllBetLang["ALL_BET.HIGH_WIN"]))]),_vm._v(" "),_c('div',{staticClass:"col-auto bet-win-money yb-number-bold"},[_vm._v(_vm._s(_vm._f("decimal")(_vm.displayMulpPossiblePayout(index),2)))])]),_vm._v(" "),_c('div',{staticClass:"bet-keyboard-zone q-card__section q-card__section--vert"},[_c('div',{staticClass:"vrow bet-keyboard bet-keyboard-content"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"q-gutter-xs keyboard-zone"},[_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.min, index, 'min')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.min, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.min))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.med, index, 'med')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.med, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.med))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big, index, 'big')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big2, index, 'big2')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big2, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.betting.betAmountOption.big2))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, index, 'big3')},on:{"click":function($event){return _vm.addsum(_vm.betting.betAmountOption.big3, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v("+"+_vm._s(_vm.commasAmount(_vm.betting.betAmountOption.big3)))])]),_vm._v(" "),_c('div',{staticClass:"keyboard-btn",class:{' disable-key-btn': _vm.checkAllowKeyboard(null, _vm.keyboardAllow.big3, index, 'big3')||_vm.betMulpAmount[index].maxPay==''||_vm.betMulpAmount[index].maxPay==0},on:{"click":function($event){return _vm.addsum(_vm.betMulpAmount[index].maxPay, index)}}},[_c('div',{staticClass:"keyboard-btn-text"},[_vm._v(_vm._s(_vm.langList.sportMinibetLang['SPORT_MINIBET.MAX']))])])])])])])])]:[_c('div',{staticClass:"bet-message text-center",staticStyle:{"height":"auto","line-height":"normal","margin":"15px 0px","color":"#ff4040"},attrs:{"data-v-9f62b2ae":""}},[_vm._v("\n                              "+_vm._s(_vm.betLang['BETTING.EXCEED_MAX_ODDS']+' '+_vm.betting.minMax.maxOdds)+"\n                            ")])]],2)])]:_vm._e()})],2):_vm._e()]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}})])])]):_vm._e()])])]),_vm._v(" "),_c('bettingFormFooter')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.bettyp}},[_c('div',{staticClass:"wrap-template template2",attrs:{"data-template":"template2"}},[_c('div',{staticClass:"main-handicap m-hdp"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),(_vm.newAllBetEvent.sprbinfo)?_c('div',{},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.CURRENT_TOTAL'])+": "+_vm._s(_vm.newAllBetEvent.sprbinfo.scoa)+"-"+_vm._s(_vm.newAllBetEvent.sprbinfo.scob))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"55%"}},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.oritacapt ? _vm.newAllBetEvent.oritacapt : _vm.newAllBetEvent.tacapt)}})]),_vm._v(" "),_c('div',[_c('span',{staticClass:"bet_handicap yb-family-odds ellipsis vhighlight"},[_c('handicap',{attrs:{"event":_vm.newAllBetEvent,"favTeam":'a',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":subMatchKey}})],1)])])]),_vm._v(" "),_c('odd',{ref:'teamA' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamA,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":subMatchKey,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"55%"}},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.oritbcapt ? _vm.newAllBetEvent.oritbcapt : _vm.newAllBetEvent.tbcapt)}})]),_vm._v(" "),_c('div',[_c('span',{staticClass:"bet_handicap yb-family-odds ellipsis vhighlight"},[_c('handicap',{attrs:{"event":_vm.newAllBetEvent,"favTeam":'b',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":subMatchKey}})],1)])])]),_vm._v(" "),_c('odd',{ref:'teamB' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamB,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":subMatchKey,"mode":'ab'}})],1)])])])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_ou_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8441df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_ou_vue__ = __webpack_require__(347);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_ou_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8441df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_ou_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template"},[_c('div',{staticClass:"wrap-template template5",attrs:{"data-template":"template5"}},[_c('div',{staticClass:"main-handicap m-ou"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v("\n            "+_vm._s(_vm.getTitleCaption())+"\n          ")])]),_vm._v(" "),(_vm.newAllBetEvent.sprbinfo)?_c('div',{},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.CURRENT_TOTAL'])+": "+_vm._s(_vm.newAllBetEvent.sprbinfo.scoa)+"-"+_vm._s(_vm.newAllBetEvent.sprbinfo.scob))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"vrow sub-title-1"},[_c('span',{staticStyle:{"width":"25%"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"37.5%","text-align":"center"}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER']))]),_vm._v(" "),_c('span',{staticStyle:{"width":"37.5%","text-align":"center"}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER']))])]),_vm._v(" "),_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item sub-title-2 yb-family-odds"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":subMatchKey}})],1),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(1,true),_vm._v(" "),_c('odd',{ref:'teamOver' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamA,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":subMatchKey,"mode":'ab',"wdth":_vm.wdth}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(2,true),_vm._v(" "),_c('odd',{ref:'teamUnder' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamB,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":subMatchKey,"mode":'ab'}})],1)])])])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap",staticStyle:{"display":"none"}},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap",staticStyle:{"display":"none"}},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_1x2_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f0332b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_1x2_vue__ = __webpack_require__(349);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_1x2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f0332b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_1x2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template"},[_c('div',{staticClass:"wrap-template template1",attrs:{"data-template":"template1"}},[_c('div',{staticClass:"main-handicap",class:{ 'm-hdp': _vm.bettyp == _vm.mlBetType }},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v("\n            "+_vm._s(_vm.getTitleCaption())+"\n          ")])]),_vm._v(" "),(_vm.newAllBetEvent.sprbinfo)?_c('div',{},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.CURRENT_TOTAL'])+": "+_vm._s(_vm.newAllBetEvent.sprbinfo.scoa)+"-"+_vm._s(_vm.newAllBetEvent.sprbinfo.scob))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap m-1x2"},[_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.oritacapt ? _vm.newAllBetEvent.oritacapt : _vm.newAllBetEvent.tacapt)}}),_vm._v(" "),_c('span',{staticClass:"ellipsis-wrap"})])])]),_vm._v(" "),_c('odd1x2',{ref:"team1",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamHome,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),([_vm.onex2BetType,_vm.ronex2BetType].includes(_vm.bettyp))?_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW']))]),_vm._v(" "),_c('span',{staticClass:"ellipsis-wrap"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamX",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamDraw,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.oritbcapt ? _vm.newAllBetEvent.oritbcapt : _vm.newAllBetEvent.tbcapt)}}),_vm._v(" "),_c('span',{staticClass:"ellipsis-wrap"})])])]),_vm._v(" "),_c('odd1x2',{ref:"team2",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamAway,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])])])]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_cs_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727f690b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_cs_vue__ = __webpack_require__(351);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_cs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727f690b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_cs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp])?_c('div',{staticClass:"template"},_vm._l((_vm.btypes),function(btype){return (_vm.newAllBetEvent.od[_vm.plytyp][btype])?_c('div',{staticClass:"wrap-template template4",attrs:{"data-template":"template4"}},[_c('div',{staticClass:"vrow items-center template-title is_fold",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0,true)])]),_vm._v(" "),(_vm.show)?[_c('div',[_c('div',{staticClass:"handicap-sub-title",staticStyle:{"max-height":"unset"}},[_c('div',{staticClass:"flex-1 overflow-hidden part-left"},[_c('div',{staticClass:"sub-title ellipsis",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tacapt)}}),_vm._v(" "),_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(1,true),_vm._v(" "),_c('cstgftht',{ref:"teamod10",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od10',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(2,true),_vm._v(" "),_c('cstgftht',{ref:"teamod20",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od20',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(3,true),_vm._v(" "),_c('cstgftht',{ref:"teamod21",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od21',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(4,true),_vm._v(" "),_c('cstgftht',{ref:"teamod30",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od30',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(5,true),_vm._v(" "),_c('cstgftht',{ref:"teamod31",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od31',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(6,true),_vm._v(" "),_c('cstgftht',{ref:"teamod32",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od32',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(7,true),_vm._v(" "),_c('cstgftht',{ref:"teamod40",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od40',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]):_vm._e(),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(8,true),_vm._v(" "),_c('cstgftht',{ref:"teamod41",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od41',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]):_vm._e(),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(9,true),_vm._v(" "),_c('cstgftht',{ref:"teamod42",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od42',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]):_vm._e(),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(10,true),_vm._v(" "),_c('cstgftht',{ref:"teamod43",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od43',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-1 overflow-hidden part-middle"},[_c('div',{staticClass:"sub-title ellipsis"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW']))]),_vm._v(" "),_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(11,true),_vm._v(" "),_c('cstgftht',{ref:"teamod00",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od00',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(12,true),_vm._v(" "),_c('cstgftht',{ref:"teamod11",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od11',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(13,true),_vm._v(" "),_c('cstgftht',{ref:"teamod22",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od22',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(14,true),_vm._v(" "),_c('cstgftht',{ref:"teamod33",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od33',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(15,true),_vm._v(" "),_c('cstgftht',{ref:"teamod44",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od44',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-item os-undefined"}),_vm._v(" "),_c('div',{staticClass:"handicap-item os-undefined"}),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?[_c('div',{staticClass:"handicap-item os-undefined"}),_vm._v(" "),_c('div',{staticClass:"handicap-item os-undefined"}),_vm._v(" "),_c('div',{staticClass:"handicap-item os-undefined"})]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"flex-1 overflow-hidden part-right"},[_c('div',{staticClass:"sub-title ellipsis",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tbcapt)}}),_vm._v(" "),_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(16,true),_vm._v(" "),_c('cstgftht',{ref:"teamod01",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od01',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(17,true),_vm._v(" "),_c('cstgftht',{ref:"teamod02",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od02',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(18,true),_vm._v(" "),_c('cstgftht',{ref:"teamod12",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od12',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(19,true),_vm._v(" "),_c('cstgftht',{ref:"teamod03",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od03',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(20,true),_vm._v(" "),_c('cstgftht',{ref:"teamod13",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od13',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(21,true),_vm._v(" "),_c('cstgftht',{ref:"teamod23",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od23',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(22,true),_vm._v(" "),_c('cstgftht',{ref:"teamod04",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od04',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]):_vm._e(),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(23,true),_vm._v(" "),_c('cstgftht',{ref:"teamod14",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od14',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]):_vm._e(),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(24,true),_vm._v(" "),_c('cstgftht',{ref:"teamod24",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od24',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]):_vm._e(),_vm._v(" "),(_vm.plytyp != _vm.firstHtPlyType)?_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(25,true),_vm._v(" "),_c('cstgftht',{ref:"teamod34",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od34',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"other-item"},[_vm._m(26,true),_vm._v(" "),_vm._m(27,true),_vm._v(" "),_c('div',{staticClass:"placehold other no_border_bottom os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet_handicap ellipsis",staticStyle:{"margin-left":"12px"}},[_vm._v("\n                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AOS'])+"\n                  ")])]),_vm._v(" "),_c('cstgftht',{ref:"teamodaos",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'aos',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])])])])]:_vm._e()],2):_vm._e()}),0):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1 - 0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2 - 0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2 - 1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3 - 0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3 - 1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3 - 2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4 - 0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4 - 1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4 - 2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4 - 3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0 - 0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1 - 1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2 - 2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3 - 3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4 - 4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0 - 1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0 - 2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1 - 2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0 - 3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1 - 3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2 - 3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0 - 4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1 - 4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2 - 4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3 - 4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placehold"},[_c('div',{staticClass:"empty"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placehold"},[_c('div',{staticClass:"empty"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_tg_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a16490_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_tg_vue__ = __webpack_require__(353);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_tg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a16490_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_tg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp])?_c('div',{staticClass:"template"},_vm._l((_vm.btypes),function(btype){return (_vm.newAllBetEvent.od[_vm.plytyp][btype])?_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0,true)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v(_vm._s(_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][0]]))])])])]),_vm._v(" "),_c('cstgftht',{ref:"teamtg01",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'tg01',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v(_vm._s(_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][1]]))])])])]),_vm._v(" "),_c('cstgftht',{ref:"teamtg23",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'tg23',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v(_vm._s(_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][2]]))])])])]),_vm._v(" "),_c('cstgftht',{ref:"teamtg46",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'tg456',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v(_vm._s(_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][3]]))])])])]),_vm._v(" "),_c('cstgftht',{ref:"teamtg7",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'tg7',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])])])]:_vm._e()],2)]):_vm._e()}),0):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_htft_vue__ = __webpack_require__(171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6addcc45_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_htft_vue__ = __webpack_require__(355);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_htft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6addcc45_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_htft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.ftPlyType] && _vm.newAllBetEvent.od[_vm.ftPlyType][_vm.htftBetType])?_c('div',{staticClass:"template"},[_c('div',{staticClass:"wrap-template template10",attrs:{"data-template":"template10"}},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_HTFT']))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap m-htft"},[_c('div',{staticClass:"handicap-item base-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis on-text"},[_vm._v(_vm._s(_vm.newAllBetEvent.tacapt)+"/"+_vm._s(_vm.newAllBetEvent.tacapt))])])]),_vm._v(" "),_c('cstgftht',{ref:"teamhh",attrs:{"event":_vm.newAllBetEvent,"score":'hh',"plyType":_vm.ftPlyType,"betType":_vm.htftBetType}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item base-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis on-text"},[_vm._v("\n                    "+_vm._s(_vm.newAllBetEvent.tacapt)+"/"+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+"\n                  ")])])]),_vm._v(" "),_c('cstgftht',{ref:"teamhd",attrs:{"event":_vm.newAllBetEvent,"score":'hd',"plyType":_vm.ftPlyType,"betType":_vm.htftBetType}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item base-item os-1 no_border_right"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis on-text"},[_vm._v(_vm._s(_vm.newAllBetEvent.tacapt)+"/"+_vm._s(_vm.newAllBetEvent.tbcapt))])])]),_vm._v(" "),_c('cstgftht',{ref:"teamha",attrs:{"event":_vm.newAllBetEvent,"score":'ha',"plyType":_vm.ftPlyType,"betType":_vm.htftBetType}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item base-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis on-text"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+"/"+_vm._s(_vm.newAllBetEvent.tacapt))])])]),_vm._v(" "),_c('cstgftht',{ref:"teamdh",attrs:{"event":_vm.newAllBetEvent,"score":'dh',"plyType":_vm.ftPlyType,"betType":_vm.htftBetType}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item base-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis on-text"},[_vm._v("\n                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+"/"+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+"\n                  ")])])]),_vm._v(" "),_c('cstgftht',{ref:"teamdd",attrs:{"event":_vm.newAllBetEvent,"score":'dd',"plyType":_vm.ftPlyType,"betType":_vm.htftBetType}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item base-item os-1 no_border_right"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis on-text"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+"/"+_vm._s(_vm.newAllBetEvent.tbcapt))])])]),_vm._v(" "),_c('cstgftht',{ref:"teamda",attrs:{"event":_vm.newAllBetEvent,"score":'da',"plyType":_vm.ftPlyType,"betType":_vm.htftBetType}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item base-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis on-text"},[_vm._v(_vm._s(_vm.newAllBetEvent.tbcapt)+"/"+_vm._s(_vm.newAllBetEvent.tacapt))])])]),_vm._v(" "),_c('cstgftht',{ref:"teamah",attrs:{"event":_vm.newAllBetEvent,"score":'ah',"plyType":_vm.ftPlyType,"betType":_vm.htftBetType}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item base-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis on-text"},[_vm._v("\n                    "+_vm._s(_vm.newAllBetEvent.tbcapt)+"/"+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+"\n                  ")])])]),_vm._v(" "),_c('cstgftht',{ref:"teamad",attrs:{"event":_vm.newAllBetEvent,"score":'ad',"plyType":_vm.ftPlyType,"betType":_vm.htftBetType}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item base-item os-1 no_border_bottom no_border_right"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis on-text"},[_vm._v(_vm._s(_vm.newAllBetEvent.tbcapt)+"/"+_vm._s(_vm.newAllBetEvent.tbcapt))])])]),_vm._v(" "),_c('cstgftht',{ref:"teamaa",attrs:{"event":_vm.newAllBetEvent,"score":'aa',"plyType":_vm.ftPlyType,"betType":_vm.htftBetType}})],1)])])])]:_vm._e()],2)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_oe_vue__ = __webpack_require__(172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af521d60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_oe_vue__ = __webpack_require__(357);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_oe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af521d60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_oe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp])?_c('div',{staticClass:"template"},[_vm._l((_vm.btypes),function(btype){return (_vm.newAllBetEvent.od[_vm.plytyp][btype] != undefined)?[_c('div',{staticClass:"wrap-template template3",attrs:{"data-template":"template3"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption(btype)))])]),_vm._v(" "),(_vm.newAllBetEvent.sprbinfo)?_c('div',{},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.CURRENT_TOTAL'])+": "+_vm._s(_vm.newAllBetEvent.sprbinfo.scoa)+"-"+_vm._s(_vm.newAllBetEvent.sprbinfo.scob))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0,true)])]),_vm._v(" "),_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][btype]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][btype][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][btype])[subMatchKey]])?[(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD']))])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('odd',{ref:"teamOdd",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamA,"plyType":_vm.plytyp,"betType":btype,"match":subMatchKey,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN']))])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('odd',{ref:"teamEven",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamB,"plyType":_vm.plytyp,"betType":btype,"match":subMatchKey,"mode":'ab'}})],1)])])])]:_vm._e()]:_vm._e()]})],2)])]:_vm._e()})],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_atg_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4cbce6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_atg_vue__ = __webpack_require__(359);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_atg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4cbce6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_atg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType])?_c('div',{attrs:{"id":"body_ATG"}},[_c('table',{staticClass:"more_table2",attrs:{"id":"model_ATG","border":"0","cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType])[subMatchKey]])?[(_vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType])[subMatchKey]]['hdp'] != 0)?[(subMatchKey == 0)?_c('tr',[_c('th',{staticClass:"more_title4",attrs:{"colspan":"2"},on:{"click":function($event){return _vm.showLeg()}}},[_c('button',{staticClass:"trigger toggle-primary",class:_vm.show ? 'icon-open' : 'icon-close',attrs:{"id":"triggertoggle"}}),_vm._v(" "),(_vm.plytyp == _vm.gameHdpPlyType)?[_c('span',{staticClass:"btheader"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TOTAL_GAME']))])]:(_vm.plytyp == _vm.setHandicapPlyType)?[_c('span',{staticClass:"btheader"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_SET_HDP_FRONT']))])]:(_vm.plytyp == _vm.pointHdpPlyType)?[_c('span',{staticClass:"btheader"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_POINT_HDP_FRONT']))])]:_vm._e(),_vm._v(" "),_c('span',{staticClass:"btheader"},[_vm._v(_vm._s(_vm.oddsHeader())+_vm._s(_vm.sportAllBetLang['ALL_BET.ATG']))]),_vm._v(" "),(_vm.plytyp == _vm.firstHtPlyType)?[_c('span',{staticClass:"more_og2"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_1HT']))])]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.show)?[(subMatchKey == 0)?[_c('tr',[_c('th',{staticClass:"allbetheader header",attrs:{"width":"50%"}},[_c('div',{staticClass:"more_font",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_OVER']}},[_c('span',{},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" ("+_vm._s(_vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType])[subMatchKey]]['hdp'])+")")])])]),_vm._v(" "),_c('th',{staticClass:"allbetheader header",attrs:{"width":"50%"}},[_c('div',{staticClass:"more_font",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_UNDER']}},[_c('span',{},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+"  ("+_vm._s(_vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.atgBetType])[subMatchKey]]['hdp'])+")")])])])])]:_vm._e(),_vm._v(" "),_c('tr',{class:{more_white: subMatchKey % 2 == 0, more_color: subMatchKey % 2 != 0}},[_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.newAllBetEvent.event_rb==1},staticStyle:{"cursor":"pointer"},attrs:{"width":"50%"},on:{"click":function($event){return _vm.selectCell($event,'teamOver'+subMatchKey)}}},[_c('div',{staticClass:"betArea",staticStyle:{"margin":"auto","width":"200px"}},[_c('span',{attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_OVER']}},[_c('odd',{ref:'teamOver'+subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamA,"plyType":_vm.plytyp,"betType":_vm.atgBetType,"match":subMatchKey}})],1)])]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.newAllBetEvent.event_rb==1},staticStyle:{"cursor":"pointer"},attrs:{"width":"50%"},on:{"click":function($event){return _vm.selectCell($event,'teamUnder'+subMatchKey)}}},[_c('div',{staticClass:"betArea",staticStyle:{"margin":"auto","width":"200px"}},[_c('span',{attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_UNDER']}},[_c('odd',{ref:'teamUnder'+subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamB,"plyType":_vm.plytyp,"betType":_vm.atgBetType,"match":subMatchKey}})],1)])])])]:_vm._e()]:_vm._e()]:_vm._e()]})],2)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_htg_vue__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74beb538_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_htg_vue__ = __webpack_require__(361);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_htg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74beb538_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_htg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType])?_c('div',{attrs:{"id":"body_HTG"}},[_c('table',{staticClass:"more_table2",attrs:{"id":"model_HTG","border":"0","cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType])[subMatchKey]])?[(_vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType])[subMatchKey]]['hdp'] != 0)?[(subMatchKey == 0)?_c('tr',[_c('th',{staticClass:"more_title4",attrs:{"colspan":"2"},on:{"click":function($event){return _vm.showLeg()}}},[_c('button',{staticClass:"trigger toggle-primary",class:_vm.show ? 'icon-open' : 'icon-close',attrs:{"id":"triggertoggle"}}),_vm._v(" "),_c('span',{staticClass:"btheader"},[_vm._v(_vm._s(_vm.oddsHeader())+_vm._s(_vm.sportAllBetLang['ALL_BET.HTG']))]),_vm._v(" "),(_vm.plytyp == _vm.firstHtPlyType)?[_c('span',{staticClass:"more_og2"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_1HT']))])]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.show)?[(subMatchKey == 0)?[_c('tr',[_c('th',{staticClass:"allbetheader header",attrs:{"width":"50%"}},[_c('div',{staticClass:"more_font",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_OVER']}},[_c('span',{},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" ("+_vm._s(_vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType])[subMatchKey]]['hdp'])+")")])])]),_vm._v(" "),_c('th',{staticClass:"allbetheader header",attrs:{"width":"50%"}},[_c('div',{staticClass:"more_font",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_UNDER']}},[_c('span',{},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" ("+_vm._s(_vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.htgBetType])[subMatchKey]]['hdp'])+")")])])])])]:_vm._e(),_vm._v(" "),_c('tr',{class:{more_white: subMatchKey % 2 == 0, more_color: subMatchKey % 2 != 0}},[_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.newAllBetEvent.event_rb==1},staticStyle:{"cursor":"pointer"},attrs:{"width":"50%"},on:{"click":function($event){return _vm.selectCell($event,'teamOver'+subMatchKey)}}},[_c('div',{staticClass:"betArea",staticStyle:{"margin":"auto","width":"200px"}},[_c('span',{attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_OVER']}},[_c('odd',{ref:'teamOver'+subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamA,"plyType":_vm.plytyp,"betType":_vm.htgBetType,"match":subMatchKey}})],1)])]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.newAllBetEvent.event_rb==1},staticStyle:{"cursor":"pointer"},attrs:{"width":"50%"},on:{"click":function($event){return _vm.selectCell($event,'teamUnder'+subMatchKey)}}},[_c('div',{staticClass:"betArea",staticStyle:{"margin":"auto","width":"200px"}},[_c('span',{attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_UNDER']}},[_c('odd',{ref:'teamUnder'+subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamB,"plyType":_vm.plytyp,"betType":_vm.htgBetType,"match":subMatchKey}})],1)])])])]:_vm._e()]:_vm._e()]:_vm._e()]})],2)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_btts_vue__ = __webpack_require__(175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d34fa73_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_btts_vue__ = __webpack_require__(363);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_btts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d34fa73_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_btts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp])?_c('div',{staticClass:"template"},_vm._l((_vm.btypes),function(btype){return (_vm.newAllBetEvent.od[_vm.plytyp][btype])?_c('div',{staticClass:"wrap-template template3",attrs:{"data-template":"template3"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0,true)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES']))])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamHome,"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO']))])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamAway,"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])])])]:_vm._e()],2)]):_vm._e()}),0):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_dbch_vue__ = __webpack_require__(176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c63d898a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_dbch_vue__ = __webpack_require__(365);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_dbch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c63d898a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_dbch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp])?_c('div',{staticClass:"template"},[_vm._l((_vm.btypes),function(btype){return (_vm.newAllBetEvent.od[_vm.plytyp][btype])?[_c('div',{staticClass:"wrap-template template1",attrs:{"data-template":"template1"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption())+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_DBCH']))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0,true)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap m-1x2"},[_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('hd')))])])])]),_vm._v(" "),_c('oddDbch',{ref:"hd",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'hd',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ha')))])])])]),_vm._v(" "),_c('oddDbch',{ref:"ha",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'ha',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ad')))])])])]),_vm._v(" "),_c('oddDbch',{ref:"ad",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'ad',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])])])]:_vm._e()],2)])]:_vm._e()})],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_csh_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2274f1a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_csh_vue__ = __webpack_require__(367);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_csh_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2274f1a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_csh_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template"},[_c('div',{staticClass:"wrap-template template3",attrs:{"data-template":"template3"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH']))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tacapt)}})]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('odd1x2',{ref:"team1",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamHome,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tbcapt)}})]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('odd1x2',{ref:"team2",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamAway,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])])])]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_tw_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bded5a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_tw_vue__ = __webpack_require__(369);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_tw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bded5a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_tw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template"},[_c('div',{staticClass:"wrap-template template3",attrs:{"data-template":"template3"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption(_vm.bettyp)))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME']))])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('odd1x2',{ref:"team1",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamHome,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY']))])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('odd1x2',{ref:"team2",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamAway,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])])])]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_wm_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_726db2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_wm_vue__ = __webpack_require__(371);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_wm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_726db2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_wm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp])?_c('div',{staticClass:"template"},[_vm._l((_vm.btypes),function(btype){return (_vm.newAllBetEvent.od[_vm.plytyp][btype])?[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[(btype == 77 || btype == 78)?_c('span',{staticClass:"ellipsis"},[_vm._v("\n              "+_vm._s(_vm.getTitleCaption())+"\n              "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_WMR'])+"\n            ")]):_c('span',{staticClass:"ellipsis"},[_vm._v("\n              "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_WM'])+"\n            ")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0,true)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1",attrs:{"title":btype == 77 || btype == 78?_vm.sportAllBetLang['ALL_BET.LBL_HWB1R']:_vm.sportAllBetLang['ALL_BET.LBL_HWB1']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[(btype == 77 || btype == 78)?_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HWB1R'])+"\n                        ")]):_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HWB1'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamhwb1",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h1',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1",attrs:{"title":btype == 77 || btype == 78?_vm.sportAllBetLang['ALL_BET.LBL_AWB1R']:_vm.sportAllBetLang['ALL_BET.LBL_AWB1']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[(btype == 77 || btype == 78)?_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWB1R'])+"\n                        ")]):_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWB1'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamawb1",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a1',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1",attrs:{"title":btype == 77 || btype == 78?_vm.sportAllBetLang['ALL_BET.LBL_HWB2R']:_vm.sportAllBetLang['ALL_BET.LBL_HWB2']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[(btype == 77 || btype == 78)?_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HWB2R'])+"\n                        ")]):_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HWB2'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamhwb23",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h2',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1",attrs:{"title":btype == 77 || btype == 78?_vm.sportAllBetLang['ALL_BET.LBL_AWB2R']:_vm.sportAllBetLang['ALL_BET.LBL_AWB2']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[(btype == 77 || btype == 78)?_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWB2R'])+"\n                        ")]):_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWB2'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamawb2",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a2',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1",attrs:{"title":btype == 77 || btype == 78?_vm.sportAllBetLang['ALL_BET.LBL_HWB3R']:_vm.sportAllBetLang['ALL_BET.LBL_HWB3']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[(btype == 77 || btype == 78)?_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HWB3R'])+"\n                        ")]):_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HWB3'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamhwb3",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h3',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1",attrs:{"title":btype == 77 || btype == 78?_vm.sportAllBetLang['ALL_BET.LBL_AWB3R']:_vm.sportAllBetLang['ALL_BET.LBL_AWB3']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[(btype == 77 || btype == 78)?_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWB3R'])+"\n                        ")]):_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWB3'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamawb3",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a3',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1",attrs:{"title":btype == 77 || btype == 78?_vm.sportAllBetLang['ALL_BET.LBL_HWB4RM']:_vm.sportAllBetLang['ALL_BET.LBL_HWB4M']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[(btype == 77 || btype == 78)?_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HWB4RM'])+"\n                        ")]):_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HWB4M'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamhwb4m",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h4',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1",attrs:{"title":btype == 77 || btype == 78?_vm.sportAllBetLang['ALL_BET.LBL_AWB4RM']:_vm.sportAllBetLang['ALL_BET.LBL_AWB4M']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[(btype == 77 || btype == 78)?_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWB4RM'])+"\n                        ")]):_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWB4M'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamawb4m",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a4',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),(btype != 77 && btype != 78)?_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_AS']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AS'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamas",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'sd',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]):(btype == 77 || btype == 78)?_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_BB_AS']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_BB_AS'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamas",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'sd',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]):_vm._e(),_vm._v(" "),(btype != 77 && btype != 78)?_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_NG']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"82%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NG'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamng",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'ng',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]):_vm._e()])]:_vm._e()],2)])]:_vm._e()})],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_flg_vue__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4265b474_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_flg_vue__ = __webpack_require__(373);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_flg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4265b474_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_flg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp])?_c('div',{staticClass:"template"},[_vm._l((_vm.btypes),function(btype){return (_vm.newAllBetEvent.od[_vm.plytyp][btype])?[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v("\n              "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FLG'])+"\n            ")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0,true)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"85%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HFG'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamhf",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'hf',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"85%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AFG'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamaf",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'af',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"85%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HLG'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamhl",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'hl',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"85%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ALG'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamal",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'al',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"85%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NG'])+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('cstgftht',{ref:"teamng",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'ng',"plyType":_vm.plytyp,"betType":btype,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-undefined no_border_bottom"})])]:_vm._e()],2)])]:_vm._e()})],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_hmg_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6dbd560_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_hmg_vue__ = __webpack_require__(375);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_hmg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6dbd560_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_hmg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template"},[(_vm.bettyp == _vm.hmg1x2BetType || _vm.bettyp == _vm.rhmg1x2BetType)?[_c('div',{staticClass:"wrap-template template1",attrs:{"data-template":"template1"}},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption(_vm.bettyp)))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[(subMatchKey == 0)?[_c('div',{staticClass:"handicap m-1x2"},[_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_1HT']))]),_vm._v(" "),_c('span',{staticClass:"ellipsis-wrap"})])])]),_vm._v(" "),_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamHome,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_2HT']))]),_vm._v(" "),_c('span',{staticClass:"ellipsis-wrap"})])])]),_vm._v(" "),_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamAway,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW']))]),_vm._v(" "),_c('span',{staticClass:"ellipsis-wrap"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamX",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamDraw,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])])])]:_vm._e()]:_vm._e()]})]:_vm._e()],2)]:[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption(_vm.bettyp)))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(1)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[(subMatchKey == 0)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_1HT']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamHome,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_2HT']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamAway,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])])])]:_vm._e()]:_vm._e()]})]:_vm._e()],2)])]],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_ml_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a406816_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_ml_vue__ = __webpack_require__(377);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_ml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a406816_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_ml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template"},[_c('div',{staticClass:"wrap-template template1",attrs:{"data-template":"template1"}},[_c('div',{staticClass:"main-handicap m-hdp"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v("\n            "+_vm._s(_vm.getTitleCaption())+"\n          ")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tacapt)}})])])]),_vm._v(" "),_c('odd1x2',{ref:"team1",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamHome,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"70%"}},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tbcapt)}})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamX",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamAway,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])])])]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_lds_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68a124e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_lds_vue__ = __webpack_require__(379);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_lds_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68a124e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_lds_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template"},[_c('div',{staticClass:"wrap-template template3",attrs:{"data-template":"template3"}},[_c('div',{staticClass:"main-handicap m-hdp"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[(subMatchKey == 0)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_05'])+"\n                                                        ")])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('cstgftht',{ref:"0_5",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'0_5',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_16'])+"\n                                                        ")])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('cstgftht',{ref:"1_6",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'1_6',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_27'])+"\n                                                        ")])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('cstgftht',{ref:"2_7",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'2_7',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_38'])+"\n                                                        ")])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('cstgftht',{ref:"3_8",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'3_8',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v("\n                                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_49'])+"\n                                                        ")])]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('cstgftht',{ref:"4_9",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'4_9',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_vm._m(1,true)])]:_vm._e()]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"})]),_vm._v(" "),_c('span',{staticClass:"ellipsis"})])]),_vm._v(" "),_c('div',{staticClass:"odds yb-number-font"},[_c('div',{})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_wd_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b48355f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_wd_vue__ = __webpack_require__(381);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_wd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b48355f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_wd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template"},[_c('div',{staticClass:"wrap-template template5",attrs:{"data-template":"template5"}},[_c('div',[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_WD']))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[(subMatchKey == 0)?[_c('div',{staticClass:"vrow sub-title-1"},[_c('span',{staticStyle:{"width":"25%"}}),_vm._v(" "),_c('span',{staticStyle:{"width":"37.5%","text-align":"center"},domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tacapt)}}),_vm._v(" "),_c('span',{staticStyle:{"width":"37.5%","text-align":"center"},domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tbcapt)}})]),_vm._v(" "),_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item sub-title-2 yb-family-odds"},[_vm._v("\n                                        "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_WIN_BY_1T5'])+"\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 os-wd"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(1,true),_vm._v(" "),_c('cstgftht',{ref:"h_1_5",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h_1_5',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(2,true),_vm._v(" "),_c('cstgftht',{ref:"a_1_5",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a_1_5',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item sub-title-2 yb-family-odds"},[_vm._v("\n                                        "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_WIN_BY_6T10'])+"\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 os-wd"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(3,true),_vm._v(" "),_c('cstgftht',{ref:"h_6_10",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h_6_10',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(4,true),_vm._v(" "),_c('cstgftht',{ref:"a_6_10",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a_6_10',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item sub-title-2 yb-family-odds"},[_vm._v("\n                                        "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_WIN_BY_11T15'])+"\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 os-wd"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(5,true),_vm._v(" "),_c('cstgftht',{ref:"h_11_15",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h_11_15',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(6,true),_vm._v(" "),_c('cstgftht',{ref:"a_11_15",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a_11_15',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item sub-title-2 yb-family-odds"},[_vm._v("\n                                        "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_WIN_BY_16T20'])+"\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 os-wd"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(7,true),_vm._v(" "),_c('cstgftht',{ref:"h_16_20",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h_16_20',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(8,true),_vm._v(" "),_c('cstgftht',{ref:"a_16_20",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a_16_20',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item sub-title-2 yb-family-odds"},[_vm._v("\n                                        "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_WIN_BY_21T25'])+"\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 os-wd"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(9,true),_vm._v(" "),_c('cstgftht',{ref:"h_21_25",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h_21_25',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(10,true),_vm._v(" "),_c('cstgftht',{ref:"a_21_25",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a_21_25',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item sub-title-2 yb-family-odds"},[_vm._v("\n                                        "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_WIN_BY_26MORE'])+"\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 os-wd no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(11,true),_vm._v(" "),_c('cstgftht',{ref:"h_26_x",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'h_26_x',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid2"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(12,true),_vm._v(" "),_c('cstgftht',{ref:"a_26_x",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'a_26_x',"plyType":_vm.plytyp,"betType":_vm.bettyp}})],1)])])])]:_vm._e()]:_vm._e()]})]:_vm._e()],2)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"data-v-082e727f":"","aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"handicap-value yb-number-font yb-family-odds color-highlight"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fullTime_cs_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0122ee2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullTime_cs_vue__ = __webpack_require__(383);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fullTime_cs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0122ee2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullTime_cs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allBetEvent.od[_vm.plytyp])?_c('div',{attrs:{"id":"body_PD"}},[_vm._l((_vm.btypes),function(btype){return (_vm.allBetEvent.od[_vm.plytyp][btype])?[_c('table',{staticClass:"more_table2",attrs:{"id":"model_PD","border":"0","cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_vm._l(((_vm.allBetEvent.sub + 1)),function(subMatch,subMatchKey){return [(subMatchKey == 0)?_c('tr',[_c('th',{staticClass:"more_title4",attrs:{"colspan":"16"},on:{"click":function($event){return _vm.showLeg()}}},[_c('button',{staticClass:"trigger toggle-primary",class:_vm.show ? 'icon-open' : 'icon-close',attrs:{"id":"triggertoggle"}}),_vm._v(" "),_c('span',{staticClass:"btheader"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CS']))]),_vm._v(" "),(_vm.plytyp==_vm.firstHtPlyType)?_c('span',{staticClass:"more_og2"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_1HT']))]):_vm._e(),_vm._v(" "),(_vm.isSpecial)?_c('span',{staticClass:"more_og2"},[_vm._v(" ("+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SPECIALS'])+")")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.show)?[(subMatchKey == 0)?[_c('tr',[_vm._m(0,true),_vm._v(" "),_vm._m(1,true),_vm._v(" "),_vm._m(2,true),_vm._v(" "),_vm._m(3,true),_vm._v(" "),_vm._m(4,true),_vm._v(" "),_vm._m(5,true),_vm._v(" "),(_vm.plytyp=='1')?[_vm._m(6,true),_vm._v(" "),_vm._m(7,true),_vm._v(" "),_vm._m(8,true),_vm._v(" "),_vm._m(9,true)]:_vm._e(),_vm._v(" "),_vm._m(10,true),_vm._v(" "),_vm._m(11,true),_vm._v(" "),_vm._m(12,true),_vm._v(" "),_vm._m(13,true),_vm._v(" "),(_vm.plytyp=='1')?[_vm._m(14,true)]:_vm._e(),_vm._v(" "),_c('th',{staticClass:"allbetheader csheader",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_AOS']}},[_c('span',[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AOS_SHORT']))])])],2),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding-left":"0px","padding-right":"0px"},attrs:{"colspan":"16"}},[_c('table',{attrs:{"border":"0","cellpadding":"0","cellspacing":"0"}},[_c('tr',[_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod10')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod10",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od10',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod20')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod20",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od20',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod21')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod21",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od21',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod30')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod30",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od30',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod31')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod31",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od31',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod32')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod32",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od32',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),(_vm.plytyp=='1')?[_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod40')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod40",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od40',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod41')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod41",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od41',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod42')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod42",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od42',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod43')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod43",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od43',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)])]:_vm._e(),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.selectCell($event,'teamod00')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod00",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od00',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.selectCell($event,'teamod11')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod11",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od11',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.selectCell($event,'teamod22')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod22",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od22',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.selectCell($event,'teamod33')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod33",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od33',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),(_vm.plytyp=='1')?[_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.selectCell($event,'teamod44')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod44",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od44',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)])]:_vm._e(),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:( _obj = { isrb: (_vm.allBetEvent.event_rb==1)}, _obj['AOS'+_vm.plytyp] = true, _obj ),attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.selectCell($event,'teamodaos')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamodaos",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'aos',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)])],2),_vm._v(" "),_c('tr',[_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod01')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod01",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od01',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod02')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod02",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od02',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod12')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod12",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od12',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod03')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod03",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od03',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod13')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod13",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od13',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod23')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod23",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od23',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),(_vm.plytyp=='1')?[_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod04')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod04",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od04',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod14')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod14",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od14',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod24')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod24",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od24',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},on:{"click":function($event){return _vm.selectCell($event,'teamod34')}}},[_c('div',{staticClass:"betArea abcs"},[_c('cstgftht',{ref:"teamod34",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'od34',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1}})],1)])]:_vm._e()],2)])])])]:_vm._e()]:_vm._e()]
var _obj;})],2)])]:_vm._e()})],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"1 - 0"}},[_c('span',[_vm._v("1 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"2 - 0"}},[_c('span',[_vm._v("2 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"2 - 1"}},[_c('span',[_vm._v("2 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"3 - 0"}},[_c('span',[_vm._v("3 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"3 - 1"}},[_c('span',[_vm._v("3 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"3 - 2"}},[_c('span',[_vm._v("3 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"2 - 0"}},[_c('span',[_vm._v("4 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"4 - 1"}},[_c('span',[_vm._v("4 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"4 - 2"}},[_c('span',[_vm._v("4 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"4 - 4"}},[_c('span',[_vm._v("4 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"0 - 0"}},[_c('span',[_vm._v("0 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"1 - 1"}},[_c('span',[_vm._v("1 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"2 - 2"}},[_c('span',[_vm._v("2 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"3 - 3"}},[_c('span',[_vm._v("3 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"allbetheader csheader",attrs:{"title":"4 - 4"}},[_c('span',[_vm._v("4 - 4")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fullTime_tg_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48d3632_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullTime_tg_vue__ = __webpack_require__(385);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fullTime_tg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48d3632_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullTime_tg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allBetEvent.od[_vm.plytyp])?_c('div',{attrs:{"id":"body_T"}},[_vm._l((_vm.btypes),function(btype){return (_vm.allBetEvent.od[_vm.plytyp][btype])?[_c('table',{staticClass:"more_table2",attrs:{"id":"model_T","border":"0","cellpadding":"0","cellspacing":"0"}},[_c('tbody',[_vm._l(((_vm.allBetEvent.sub + 1)),function(subMatch,subMatchKey){return [(subMatchKey == 0)?_c('tr',[_c('th',{staticClass:"more_title4",staticStyle:{"padding-left":"0px","padding-top":"0px"},attrs:{"colspan":"4"},on:{"click":function($event){return _vm.showLeg()}}},[_c('button',{staticClass:"trigger toggle-primary",class:_vm.show ? 'icon-open' : 'icon-close',attrs:{"id":"triggertoggle"}}),_vm._v(" "),_c('span',{staticStyle:{"float":"left","padding-left":"5px"}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TG']))]),_vm._v(" "),(_vm.plytyp==_vm.firstHtPlyType)?_c('span',{staticClass:"more_og2"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_1HT']))]):_vm._e(),_vm._v(" "),(_vm.isSpecial)?_c('span',{staticClass:"more_og2"},[_vm._v(" ("+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SPECIALS'])+")")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.show)?[(subMatchKey == 0)?[_c('tr',[_c('th',{staticClass:"allbetheader header",class:_vm.highlight('teamtg01'),attrs:{"width":"25%","title":_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][0]]}},[_c('span',{},[_vm._v(_vm._s(_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][0]]))])]),_vm._v(" "),_c('th',{staticClass:"allbetheader header",class:_vm.highlight('teamtg23'),attrs:{"width":"25%","title":_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][2]]}},[_c('span',{},[_vm._v(_vm._s(_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][1]]))])]),_vm._v(" "),_c('th',{staticClass:"allbetheader header",class:_vm.highlight('teamtg46'),attrs:{"width":"25%","title":_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][2]]}},[_c('span',{},[_vm._v(_vm._s(_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][2]]))])]),_vm._v(" "),_c('th',{staticClass:"allbetheader header",class:_vm.highlight('teamtg7'),attrs:{"width":"25%","title":_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][3]]}},[_c('span',{},[_vm._v(_vm._s(_vm.sportAllBetLang[_vm.tgBetTitle[_vm.plytyp][3]])+"+")])])]),_vm._v(" "),_c('tr',{staticClass:"trow"},[_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},attrs:{"width":"25%"},on:{"click":function($event){return _vm.selectCell($event,'teamtg01')}}},[_c('div',{staticClass:"betArea",staticStyle:{"margin":"auto","width":"100px"}},[_c('span',{staticClass:"m_red",attrs:{"title":_vm.plytyp == '2' ? _vm.sportAllBetLang['ALL_BET.LBL_0'] : _vm.sportAllBetLang['ALL_BET.LBL_01']}},[_c('cstgftht',{ref:"teamtg01",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'tg01',"plyType":_vm.plytyp,"betType":btype}})],1)])]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},attrs:{"width":"25%"},on:{"click":function($event){return _vm.selectCell($event,'teamtg23')}}},[_c('div',{staticClass:"betArea",staticStyle:{"margin":"auto","width":"100px"}},[_c('span',{staticClass:"m_red",attrs:{"title":_vm.plytyp == '2' ? _vm.sportAllBetLang['ALL_BET.LBL_1'] : _vm.sportAllBetLang['ALL_BET.LBL_23']}},[_c('cstgftht',{ref:"teamtg23",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'tg23',"plyType":_vm.plytyp,"betType":btype}})],1)])]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},attrs:{"width":"25%"},on:{"click":function($event){return _vm.selectCell($event,'teamtg46')}}},[_c('div',{staticClass:"betArea",staticStyle:{"margin":"auto","width":"100px"}},[_c('span',{staticClass:"m_red",attrs:{"title":_vm.plytyp == '2' ? _vm.sportAllBetLang['ALL_BET.LBL_2'] : _vm.sportAllBetLang['ALL_BET.LBL_46']}},[_c('cstgftht',{ref:"teamtg46",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'tg456',"plyType":_vm.plytyp,"betType":btype}})],1)])]),_vm._v(" "),_c('td',{staticClass:"cursorcontent allbetcontent abcs",class:{isrb: _vm.allBetEvent.event_rb==1},attrs:{"width":"25%"},on:{"click":function($event){return _vm.selectCell($event,'teamtg7')}}},[_c('div',{staticClass:"betArea",staticStyle:{"margin":"auto","width":"100px"}},[_c('span',{staticClass:"m_red",attrs:{"title":_vm.plytyp == '2' ? _vm.sportAllBetLang['ALL_BET.LBL_3more'] : _vm.sportAllBetLang['ALL_BET.LBL_7more']}},[_c('cstgftht',{ref:"teamtg7",refInFor:true,attrs:{"event":_vm.allBetEvent,"score":'tg7',"plyType":_vm.plytyp,"betType":btype}})],1)])])])]:_vm._e()]:_vm._e()]})],2)])]:_vm._e()})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_h1x2_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2417e909_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_h1x2_vue__ = __webpack_require__(387);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_h1x2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2417e909_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_h1x2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template"},[_c('div',{staticClass:"wrap-template template7",attrs:{"data-template":"template7"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption())+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_H1x2']))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap m-1x2"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tacapt)}})]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds vhighlight"},[_vm._v("\n                      "+_vm._s(_vm.hdpTitle('h', _vm.newAllBetEvent))+"\n                    ")])])]),_vm._v(" "),_c('odd1x2',{ref:"team1",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamHome,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"30%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW']))])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds vhighlight",staticStyle:{"display":"flex","width":"52%","margin-left":"3px"},domProps:{"innerHTML":_vm._s(_vm.hdpTitle('x', _vm.newAllBetEvent))}})])]),_vm._v(" "),_c('odd1x2',{ref:"teamX",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamDraw,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item",staticStyle:{"width":"75%"}},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap",domProps:{"innerHTML":_vm._s(_vm.newAllBetEvent.tbcapt)}})]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds vhighlight"},[_vm._v("\n                      "+_vm._s(_vm.hdpTitle('a', _vm.newAllBetEvent))+"\n                    ")])])]),_vm._v(" "),_c('odd1x2',{ref:"team2",attrs:{"event":_vm.newAllBetEvent,"team":_vm.teamAway,"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])])])]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"data-v-082e727f":"","aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_nog_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eee32586_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_nog_vue__ = __webpack_require__(389);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet_nog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eee32586_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet_nog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.bettyp}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(1),_vm._v(" "),_c('cstgftht',{ref:"teamng0",attrs:{"event":_vm.newAllBetEvent,"score":'ng0',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(2),_vm._v(" "),_c('cstgftht',{ref:"teamng1",attrs:{"event":_vm.newAllBetEvent,"score":'ng1',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(3),_vm._v(" "),_c('cstgftht',{ref:"teamng2",attrs:{"event":_vm.newAllBetEvent,"score":'ng2',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(4),_vm._v(" "),_c('cstgftht',{ref:"teamng3",attrs:{"event":_vm.newAllBetEvent,"score":'ng3',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(5),_vm._v(" "),_c('cstgftht',{ref:"teamng4",attrs:{"event":_vm.newAllBetEvent,"score":'ng4',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(6),_vm._v(" "),_c('cstgftht',{ref:"teamng5",attrs:{"event":_vm.newAllBetEvent,"score":'ng5',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(7),_vm._v(" "),_c('cstgftht',{ref:"teamng6",attrs:{"event":_vm.newAllBetEvent,"score":'ng6',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-undefined no_border_bottom"})])]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis"},[_c('span',{staticClass:"ellipsis-wrap"}),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6+")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_1x2tgou_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_342e60b3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_1x2tgou_vue__ = __webpack_require__(391);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_1x2tgou_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_342e60b3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_1x2tgou_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.bettyp}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"65%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tacapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER']))])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])])]),_vm._v(" "),_c('odd',{ref:'teamha' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsha',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"65%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tacapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER']))])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])])]),_vm._v(" "),_c('odd',{ref:'teamhb' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddshb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"65%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER']))])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])])]),_vm._v(" "),_c('odd',{ref:'teamda' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsda',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"65%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER']))])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])])]),_vm._v(" "),_c('odd',{ref:'teamdb' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsdb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"65%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tbcapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER']))])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])])]),_vm._v(" "),_c('odd',{ref:'teamaa' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsaa',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"65%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tbcapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER']))])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])])]),_vm._v(" "),_c('odd',{ref:'teamab' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsab',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),(subMatchKey != (Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length -1))?_c('div',{staticStyle:{"padding":"0.5px","width":"100%","border":"1px solid var(--qq--yb-border-color15)"}}):_vm._e()])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_1x2btts_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b85a29_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_1x2btts_vue__ = __webpack_require__(393);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_1x2btts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b85a29_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_1x2btts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.bettyp}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tacapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamha",attrs:{"event":_vm.newAllBetEvent,"team":'ha',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tacapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamhb",attrs:{"event":_vm.newAllBetEvent,"team":'hb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamda",attrs:{"event":_vm.newAllBetEvent,"team":'da',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamdb",attrs:{"event":_vm.newAllBetEvent,"team":'db',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tbcapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamaa",attrs:{"event":_vm.newAllBetEvent,"team":'aa',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tbcapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamab",attrs:{"event":_vm.newAllBetEvent,"team":'ab',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab'}})],1)])])])]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_ouoe_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9c0d6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_ouoe_vue__ = __webpack_require__(395);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_ouoe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9c0d6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_ouoe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.bettyp}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" \n                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)]),_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                          ")])])])]),_vm._v(" "),_c('odd',{ref:'teamOver' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsha',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+"\n                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)]),_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                          ")])])])]),_vm._v(" "),_c('odd',{ref:'teamOver' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddshb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)]),_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                          ")])])])]),_vm._v(" "),_c('odd',{ref:'teamOver' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsaa',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" \n                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)]),_vm._v("\n                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                          ")])])])]),_vm._v(" "),_c('odd',{ref:'teamOver' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsab',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),(subMatchKey != (Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length -1))?_c('div',{staticStyle:{"padding":"0.5px","width":"100%","border":"1px solid var(--qq--yb-border-color15)"}}):_vm._e()])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_oubtts_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70078296_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_oubtts_vue__ = __webpack_require__(397);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_oubtts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70078296_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_oubtts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.bettyp}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+"\n                                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)]),_vm._v("\n                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                        ")])])])]),_vm._v(" "),_c('odd',{ref:'teamha' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsha',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+"\n                                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)]),_vm._v("\n                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+" \n                                        ")])])])]),_vm._v(" "),_c('odd',{ref:'teamhb' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddshb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+"\n                                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)]),_vm._v("\n                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+" \n                                        ")])])])]),_vm._v(" "),_c('odd',{ref:'teamaa' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsaa',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+"\n                                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)]),_vm._v("\n                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+" \n                                        ")])])])]),_vm._v(" "),_c('odd',{ref:'teamab' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsab',"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey],"mode":'ab'}})],1)])]),_vm._v(" "),(subMatchKey != (Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length -1))?_c('div',{staticStyle:{"padding":"0.5px","width":"100%","border":"1px solid var(--qq--yb-border-color15)"}}):_vm._e()])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_oufts_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7960c957_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_oufts_vue__ = __webpack_require__(399);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_oufts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7960c957_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_oufts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.ouftsBetType])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.ouftsBetType}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.ouftsBetType]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.ouftsBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.ouftsBetType])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+"\n                                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.ouftsBetType,"match":subMatchKey}})],1)]),_vm._v("\n                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tacapt)+"\n                                        ")])])])]),_vm._v(" "),_c('odd',{ref:'teamha' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsha',"plyType":_vm.plytyp,"betType":_vm.ouftsBetType,"match":subMatchKey,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+"\n                                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.ouftsBetType,"match":subMatchKey}})],1)]),_vm._v("\n                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tbcapt)+"\n                                        ")])])])]),_vm._v(" "),_c('odd',{ref:'teamhb' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddshb',"plyType":_vm.plytyp,"betType":_vm.ouftsBetType,"match":subMatchKey,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+"\n                                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.ouftsBetType,"match":subMatchKey}})],1)]),_vm._v("\n                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tacapt)+"\n                                        ")])])])]),_vm._v(" "),_c('odd',{ref:'teamaa' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsaa',"plyType":_vm.plytyp,"betType":_vm.ouftsBetType,"match":subMatchKey,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+"\n                                            "),_c('span',{staticClass:"bet_handicap yb-family-odds normal_color"},[_c('span',{staticClass:"color"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.ouftsBetType,"match":subMatchKey}})],1)]),_vm._v("\n                                            "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tbcapt)+"\n                                        ")])])])]),_vm._v(" "),_c('odd',{ref:'teamab' + subMatchKey,refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsab',"plyType":_vm.plytyp,"betType":_vm.ouftsBetType,"match":subMatchKey,"mode":'ab'}})],1)])]),_vm._v(" "),(subMatchKey != (Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.ouftsBetType]).length -1))?_c('div',{staticStyle:{"padding":"0.5px","width":"100%","border":"1px solid var(--qq--yb-border-color15)"}}):_vm._e()])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_1x2fts_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a89c24e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_1x2fts_vue__ = __webpack_require__(401);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_1x2fts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a89c24e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_1x2fts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.onex2ftsBetType])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.onex2ftsBetType}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.onex2ftsBetType]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.onex2ftsBetType][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.onex2ftsBetType])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tacapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tacapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamha",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'ha',"plyType":_vm.plytyp,"betType":_vm.onex2ftsBetType,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tacapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tbcapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamhb",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'hb',"plyType":_vm.plytyp,"betType":_vm.onex2ftsBetType,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tacapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamda",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'da',"plyType":_vm.plytyp,"betType":_vm.onex2ftsBetType,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tbcapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamdb",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'db',"plyType":_vm.plytyp,"betType":_vm.onex2ftsBetType,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tbcapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tacapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamaa",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'aa',"plyType":_vm.plytyp,"betType":_vm.onex2ftsBetType,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.allBetEvent.tbcapt)+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tbcapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('odd1x2',{ref:"teamab",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'ab',"plyType":_vm.plytyp,"betType":_vm.onex2ftsBetType,"mode":'ab'}})],1)])])])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_dbchou_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_794caa1f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_dbchou_vue__ = __webpack_require__(403);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_dbchou_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_794caa1f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_dbchou_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.bettyp}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"67%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('hd'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" ")])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('oddDbch',{ref:"teamha",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsha',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"67%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('hd'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" ")])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('oddDbch',{ref:"teamhb",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddshb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"67%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ha'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" ")])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('oddDbch',{ref:"teamda",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsda',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"67%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ha'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" ")])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('oddDbch',{ref:"teamdb",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsdb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"67%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ad'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OVER'])+" ")])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('oddDbch',{ref:"teamaa",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsaa',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"67%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ad'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_UNDER'])+" ")])]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"},[_c('over-under',{attrs:{"event":_vm.newAllBetEvent,"plyType":_vm.plytyp,"betType":_vm.bettyp,"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),_c('oddDbch',{ref:"teamab",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsab',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]}})],1)])]),_vm._v(" "),(subMatchKey != (Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length -1))?_c('div',{staticStyle:{"padding":"0.5px","width":"100%","border":"1px solid var(--qq--yb-border-color15)"}}):_vm._e()])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_dbchbtts_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd8dd236_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_dbchbtts_vue__ = __webpack_require__(405);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_dbchbtts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd8dd236_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_dbchbtts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.bettyp}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csidundefined normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('hd'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamha",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsha',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csidundefined normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('hd'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamhb",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddshb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csidundefined normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ha'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamda",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsda',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csidundefined normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ha'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamdb",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsdb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csidundefined normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ad'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamaa",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsaa',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csidundefined normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ad'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO']))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamab",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsab',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),(subMatchKey != (Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length -1))?_c('div',{staticStyle:{"padding":"0.5px","width":"100%","border":"1px solid var(--qq--yb-border-color15)"}}):_vm._e()])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_dbchfts_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44fad928_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_dbchfts_vue__ = __webpack_require__(407);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_dbchfts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44fad928_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_dbchfts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newAllBetEvent.od[_vm.plytyp] && _vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])?_c('div',{staticClass:"template",attrs:{"id":'test'+_vm.plytyp+'x'+_vm.bettyp}},[_c('div',{staticClass:"wrap-template template0",attrs:{"data-template":"template0"}},[_c('div',{staticClass:"main-handicap"},[_c('div',{staticClass:"vrow items-center template-title is_fold"},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.show)?[_vm._l(((Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length)),function(subMatch,subMatchKey){return [(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp][Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp])[subMatchKey]])?[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('hd'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tacapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamha",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsha',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('hd'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tbcapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamhb",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddshb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ha'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tacapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamda",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsda',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ha'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tbcapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamdb",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsdb',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ad'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tacapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamaa",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsaa',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item m-oe os-1 no_border_bottom"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position zhuanye csid1 normal"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"item-label bet-ellipsis ellipsis",staticStyle:{"width":"85%"}},[_c('span',{staticClass:"ellipsis-wrap"},[_vm._v(_vm._s(_vm.getTeamLabel('ad'))+" "+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(_vm.allBetEvent.tbcapt))]),_vm._v(" "),_c('span',{staticClass:"bet_handicap yb-family-odds"})])])]),_vm._v(" "),_c('oddDbch',{ref:"teamab",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"team":'oddsab',"plyType":_vm.plytyp,"betType":_vm.bettyp,"mode":'ab',"match":subMatchKey}})],1)])]),_vm._v(" "),(subMatchKey != (Object.keys(_vm.newAllBetEvent.od[_vm.plytyp][_vm.bettyp]).length -1))?_c('div',{staticStyle:{"padding":"0.5px","width":"100%","border":"1px solid var(--qq--yb-border-color15)"}}):_vm._e()])]:_vm._e()]})]:_vm._e()],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_eg_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f975b08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_eg_vue__ = __webpack_require__(410);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_bet_eg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f975b08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_bet_eg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('oddEdg', {
  components: {
    minibet: __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__["a" /* default */]],
  name: 'oddEdg',
  template: '\n    <div :id="getOddUniqueId(event)" class="odds" :class="[getOdCls(mode,betType,score,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);" > \n      <template v-if="event.od">\n        <template v-if="event.od[plyType]">\n          <template v-if="event.od[plyType][betType]">\n            <template v-if="event.od[plyType][betType][score] >= \'1\'">\n              <template v-if="mode == \'morebet\'">\n                <span>{{ new Number(parseFloat(event.od[plyType][betType][score])) }}</span>\n                <div class="odds-arrows-wrap">\n                  <div class="odds-icon odds-up"></div>\n                  <div class="odds-icon odds-down"></div>\n                </div>\n              </template>\n              <template v-else>\n                <span class="yb-family-odds yb-number-bold match_details">{{ new Number(parseFloat(event.od[plyType][betType][score])) }}</span>\n              </template>\n            </template>\n            <template v-else>\n              <div class="icon-lock"></div>\n            </template>\n          </template>\n          <template v-else>\n            <div class="icon-lock"></div>\n          </template>\n        </template>\n        <template v-else>\n          <div class="icon-lock"></div>\n        </template>\n      </template>\n    </div>\n  ',

  props: {
    event: null,
    score: null,
    plyType: null,
    betType: null,
    decimalNumber: null,
    mode: null },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['sportMiniBet']), {
    betForm: function betForm() {
      return this.$store.getters.betForm[0];
    }
  }),
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (typeof val.od != 'undefined') {
          if (typeof val.od[this.plyType] != 'undefined') {
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType][this.score] != 'undefined') {
                this.classNegative(val.od[this.plyType][this.betType][this.score]);

                if (oldVal && !this.isChangeTemplate) {
                  this.refreshOdd = false;
                  if (typeof oldVal.od[this.plyType] != 'undefined') {
                    if (typeof oldVal.od[this.plyType][this.betType] != 'undefined') {
                      if (typeof oldVal.od[this.plyType][this.betType][this.score] != 'undefined') {
                        this.diffOddsUpDown(val.od[this.plyType][this.betType][this.score], oldVal.od[this.plyType][this.betType][this.score]);
                        this.diffOdds(val.od[this.plyType][this.betType][this.score], oldVal.od[this.plyType][this.betType][this.score]);
                      }
                    }
                  }
                } else if (this.refreshOdd) {
                  this.refreshOdd = false;
                  this.isDiff = false;
                } else if (!oldVal) {
                  this.refreshOdd = true;
                }
              } else {
                this.isClosePause = true;
              }
            }
          }
        }
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      isNegative: false,
      isDiff: false,
      isClosePause: false,
      refreshOdd: false,
      isUp: false,
      bk: ['6', '25', '53', '54', '55', '56']
    };
  },

  methods: {
    getOdCls: function getOdCls(mode, bt, score, event) {
      var a = ' odds-default';
      if (mode == 'ab') {
        a = 'yb-number-font';
        if (score == 'aos') {
          a = a + ' aosnoflex ab-right';
        }
        a = a + ' odds-default';
        if (event.sprtid == '1') {
          a = a + ' odds-sc';
        } else {
          a = a + ' odds-os';
        }
      } else {
        if (jQuery.inArray(bt, ['25']) != '-1') {
          a += ' c-center';
        } else {
          a += ' c-right';
        }
      }

      return a;
    },
    getClass: function getClass(windowEvent, isNeg, isDif, isUp, isClosePause) {
      var classStr = '';
      var classMini = '';

      if (this.changeOdds) {
        if (!this.refreshOdd && isDif) {
          classStr = 'indicator';
        }
      } else if (isClosePause) {
        classStr = '';
      } else {
        if (!this.refreshOdd && isDif) {
          if (isUp) {
            classStr = 'up';
          } else {
            classStr = 'down';
          }
        }
      }
      return classStr + classMini;
    },
    onClickOdd: function onClickOdd() {
      var _this = this;

      var windowEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('returnBetTab');
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return;
      }
      if (!this.event.od[this.plyType][this.betType] || !this.event.od[this.plyType][this.betType][this.score]) {
        return;
      }
      if (!this.account.previewFlag) {
        if (!this.checkOddValidation(this.event.od[this.plyType][this.betType][this.score])) {
          return;
        }
        var tg = {
          "1": {
            "tg01": this.$store.getters.sportAllBetLang['ALL_BET.LBL_01'],
            "tg23": this.$store.getters.sportAllBetLang['ALL_BET.LBL_23'],
            "tg456": this.$store.getters.sportAllBetLang['ALL_BET.LBL_46'],
            "tg7": this.$store.getters.sportAllBetLang['ALL_BET.LBL_7more']
          },
          "2": {
            "tg01": this.$store.getters.sportAllBetLang['ALL_BET.LBL_0'],
            "tg23": this.$store.getters.sportAllBetLang['ALL_BET.LBL_1'],
            "tg456": this.$store.getters.sportAllBetLang['ALL_BET.LBL_2'],
            "tg7": this.$store.getters.sportAllBetLang['ALL_BET.LBL_3more']
          }
        };

        var correct_score = this.score.split("");
        var display = "";

        if (correct_score[0] === 'o' || this.score == 'aos') {
          if (this.score == 'aos') display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AOS'];else display = correct_score[2] + " - " + correct_score[3];
        } else if (correct_score[0] === 't') {
          display = tg[this.plyType][this.score];
        } else {
          if (correct_score[0] === 'h' && correct_score[1] === 'h') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'];
          } else if (correct_score[0] === 'h' && correct_score[1] === 'd') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'];
          } else if (correct_score[0] === 'h' && correct_score[1] === 'a') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'];
          } else if (correct_score[0] === 'd' && correct_score[1] === 'h') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'];
          } else if (correct_score[0] === 'd' && correct_score[1] === 'd') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'];
          } else if (correct_score[0] === 'd' && correct_score[1] === 'a') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'];
          } else if (correct_score[0] === 'a' && correct_score[1] === 'h') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'];
          } else if (correct_score[0] === 'a' && correct_score[1] === 'd') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_PUSH'];
          } else if (correct_score[0] === 'a' && correct_score[1] === 'a') {
            display = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'];
          }
        }

        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang,
          eveid: this.event.eveid,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          plyType: this.plyType,
          betType: this.betType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          tbet: this.score,
          tbetcapt: display,
          odd: this.event.od[this.plyType][this.betType][this.score],
          rbscoa: 0,
          rbscob: 0,
          dual: 'a',
          fav: '0',
          hdp: '0',
          uniqueId: this.event.eveid + this.plyType + this.betType + this.score,
          eventObj: this.event
        };

        if (this.event.rb) {
          if (this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa;
            betForm.rbscob = this.event.rbinfo.scob;
          }
        }

        if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket;
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {}

        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,

          'tbet': this.score
        });
        if (indexx > -1) {
          var obj = { eveid: this.event.eveid };
          if (this.$store.getters.isBetCombo) {
            obj = { clearType: '3', index: indexx };
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            data: obj,
            callback: function () {
              _this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: _this.event.eveid
              });
              if (_this.$store.getters.betForm.length <= 0) {
                var MID = $(windowEvent.target).closest('div[id]')[0].id;
                $("[id=" + MID + "]").closest('.c-bet-item.active').removeClass('active');
                _this.$store.commit("OPEN_BETFORM", false);
                _this.$store.commit('ODD_SELECTED', false);
                _this.$store.commit("SHOW_BETFORM_MENU", false);
                _this.$store.commit('SELECTED_TAB', 'betTab');
                return;
              }
              _this.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this.$store.getters.betForm
                  });
                }.bind(_this)
              });
            }.bind(this)
          });
        } else {
          if (this.$store.getters.isBetCombo && this.$store.getters.betForm.length == this.betComboMax) {
            var chkRes = this.checkBetComboMax(betForm);
            if (chkRes) {
              return;
            }
          }

          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: function (res) {
              _this.$store.commit('CLEAR_BET_SUCCESS');
              _this.$store.commit('ODD_SELECTED', true);
              _this.$store.commit('OPEN_BETFORM', true);
              _this.oddSelectHighlight(windowEvent, betForm);

              if (_this.$store.getters.miniNormal == 1) {
                _this.showMiniBet(windowEvent);
                if (_this.$store.getters.sportMiniBet.toggle) {
                  __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('expandMini');
                }
              }

              if (!_this.$store.getters.isBetCombo) {
                _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
              }

              _this.$store.commit('BET_FORM', {
                newBettingList: res.SYSTEM_DATA.betting,
                oldBetData: betForm
              });

              if (_this.$store.getters.isBetCombo && _this.$store.getters.betForm.length > 1) {
                __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('clearAllBetComboAmount');
                __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
              }
            }.bind(this)
          });
        }
      }
    },
    classNegative: function classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false;
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    diffOddsUpDown: function diffOddsUpDown(val, oldVal) {
      this.isUp = val > oldVal ? true : false;
    },
    getOddUniqueClass: function getOddUniqueClass(event) {
      var classStr = '';
      if (this.plyType == '2') {
        classStr += 'ht ';
      }
      classStr += this.getOddUniqueId(event);
      return classStr;
    },
    getOddUniqueId: function getOddUniqueId(event) {
      return event.eveid + this.plyType + this.betType + this.score;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on(['refreshOdd'], function (params) {
      if (params == false) {
        _this2.refreshOdd = false;
      } else {
        _this2.refreshOdd = true;
      }
    }.bind(this));
  },
  mounted: function mounted() {
    this.$store.getters.betForm.forEach(function (value) {
      var MID = value.uniqueId;
      $("[id=" + MID + "]").closest('.c-bet-item').addClass('active');
    });
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allBetEvent  && _vm.allBetEvent.od)?_c('div',{staticClass:"template"},_vm._l((_vm.btypes),function(btype){return (_vm.allBetEvent.od[_vm.plytyp] && _vm.allBetEvent.od[_vm.plytyp][btype])?_c('div',{staticClass:"wrap-template template4",attrs:{"data-template":"template4"}},[_c('div',{staticClass:"vrow items-center template-title is_fold",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"play-name col",on:{"click":function($event){return _vm.showLeg()}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.getTitleCaption()))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"37px"},on:{"click":function($event){return _vm.setToTop($event)}}},[_vm._m(0,true)])]),_vm._v(" "),[_c('div',{class:'row_'+_vm.allBetEvent.eveid},[_c('div',{staticClass:"handicap-sub-title",class:'body_EG_'+_vm.allBetEvent.eveid},[_c('div',{staticClass:"flex-1 overflow-hidden part-left"},[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(1,true),_vm._v(" "),_c('oddEdg',{ref:"teamod00",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od00',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(2,true),_vm._v(" "),_c('oddEdg',{ref:"teamod01",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od01',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(3,true),_vm._v(" "),_c('oddEdg',{ref:"teamod02",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od02',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(4,true),_vm._v(" "),_c('oddEdg',{ref:"teamod03",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od03',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(5,true),_vm._v(" "),_c('oddEdg',{ref:"teamod04",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od04',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(6,true),_vm._v(" "),_c('oddEdg',{ref:"teamod05",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od05',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(7,true),_vm._v(" "),_c('oddEdg',{ref:"teamod06",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od06',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(8,true),_vm._v(" "),_c('oddEdg',{ref:"teamod07",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od07',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(9,true),_vm._v(" "),_c('oddEdg',{ref:"teamod08",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od08',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(10,true),_vm._v(" "),_c('oddEdg',{ref:"teamod09",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od09',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(11,true),_vm._v(" "),_c('oddEdg',{ref:"teamod10",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od10',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(12,true),_vm._v(" "),_c('oddEdg',{ref:"teamod11",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od11',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(13,true),_vm._v(" "),_c('oddEdg',{ref:"teamod12",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od12',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(14,true),_vm._v(" "),_c('oddEdg',{ref:"teamod13",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od13',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(15,true),_vm._v(" "),_c('oddEdg',{ref:"teamod14",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od14',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(16,true),_vm._v(" "),_c('oddEdg',{ref:"teamod15",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od15',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(17,true),_vm._v(" "),_c('oddEdg',{ref:"teamod16",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od16',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(18,true),_vm._v(" "),_c('oddEdg',{ref:"teamod17",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od17',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(19,true),_vm._v(" "),_c('oddEdg',{ref:"teamod18",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od18',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(20,true),_vm._v(" "),_c('oddEdg',{ref:"teamod19",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od19',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(21,true),_vm._v(" "),_c('oddEdg',{ref:"teamod20",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od20',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(22,true),_vm._v(" "),_c('oddEdg',{ref:"teamod21",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od21',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(23,true),_vm._v(" "),_c('oddEdg',{ref:"teamod22",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od22',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(24,true),_vm._v(" "),_c('oddEdg',{ref:"teamod23",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od23',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(25,true),_vm._v(" "),_c('oddEdg',{ref:"teamod24",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od24',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"flex-1 overflow-hidden part-middle"},[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(26,true),_vm._v(" "),_c('oddEdg',{ref:"teamod25",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od25',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(27,true),_vm._v(" "),_c('oddEdg',{ref:"teamod26",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od26',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(28,true),_vm._v(" "),_c('oddEdg',{ref:"teamod27",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od27',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(29,true),_vm._v(" "),_c('oddEdg',{ref:"teamod28",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od28',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(30,true),_vm._v(" "),_c('oddEdg',{ref:"teamod29",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od29',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(31,true),_vm._v(" "),_c('oddEdg',{ref:"teamod30",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od30',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(32,true),_vm._v(" "),_c('oddEdg',{ref:"teamod31",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od31',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(33,true),_vm._v(" "),_c('oddEdg',{ref:"teamod32",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od32',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(34,true),_vm._v(" "),_c('oddEdg',{ref:"teamod33",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od33',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(35,true),_vm._v(" "),_c('oddEdg',{ref:"teamod34",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od34',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(36,true),_vm._v(" "),_c('oddEdg',{ref:"teamod35",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od35',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(37,true),_vm._v(" "),_c('oddEdg',{ref:"teamod36",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od36',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(38,true),_vm._v(" "),_c('oddEdg',{ref:"teamod37",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od37',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(39,true),_vm._v(" "),_c('oddEdg',{ref:"teamod38",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od38',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(40,true),_vm._v(" "),_c('oddEdg',{ref:"teamod39",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od39',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(41,true),_vm._v(" "),_c('oddEdg',{ref:"teamod40",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od40',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(42,true),_vm._v(" "),_c('oddEdg',{ref:"teamod41",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od41',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(43,true),_vm._v(" "),_c('oddEdg',{ref:"teamod42",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od42',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(44,true),_vm._v(" "),_c('oddEdg',{ref:"teamod43",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od43',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(45,true),_vm._v(" "),_c('oddEdg',{ref:"teamod44",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od44',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(46,true),_vm._v(" "),_c('oddEdg',{ref:"teamod45",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od45',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(47,true),_vm._v(" "),_c('oddEdg',{ref:"teamod46",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od46',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(48,true),_vm._v(" "),_c('oddEdg',{ref:"teamod47",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od47',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(49,true),_vm._v(" "),_c('oddEdg',{ref:"teamod48",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od48',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(50,true),_vm._v(" "),_c('oddEdg',{ref:"teamod49",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od49',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"flex-1 overflow-hidden part-middle_eg"},[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(51,true),_vm._v(" "),_c('oddEdg',{ref:"teamod50",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od50',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(52,true),_vm._v(" "),_c('oddEdg',{ref:"teamod51",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od51',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(53,true),_vm._v(" "),_c('oddEdg',{ref:"teamod52",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od52',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(54,true),_vm._v(" "),_c('oddEdg',{ref:"teamod53",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od53',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(55,true),_vm._v(" "),_c('oddEdg',{ref:"teamod54",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od54',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(56,true),_vm._v(" "),_c('oddEdg',{ref:"teamod55",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od55',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(57,true),_vm._v(" "),_c('oddEdg',{ref:"teamod56",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od56',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(58,true),_vm._v(" "),_c('oddEdg',{ref:"teamod57",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od57',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(59,true),_vm._v(" "),_c('oddEdg',{ref:"teamod58",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od58',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(60,true),_vm._v(" "),_c('oddEdg',{ref:"teamod59",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od59',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(61,true),_vm._v(" "),_c('oddEdg',{ref:"teamod60",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od60',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(62,true),_vm._v(" "),_c('oddEdg',{ref:"teamod61",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od61',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(63,true),_vm._v(" "),_c('oddEdg',{ref:"teamod62",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od62',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(64,true),_vm._v(" "),_c('oddEdg',{ref:"teamod63",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od63',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(65,true),_vm._v(" "),_c('oddEdg',{ref:"teamod64",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od64',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(66,true),_vm._v(" "),_c('oddEdg',{ref:"teamod65",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od65',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(67,true),_vm._v(" "),_c('oddEdg',{ref:"teamod66",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od66',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(68,true),_vm._v(" "),_c('oddEdg',{ref:"teamod67",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od67',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(69,true),_vm._v(" "),_c('oddEdg',{ref:"teamod68",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od68',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(70,true),_vm._v(" "),_c('oddEdg',{ref:"teamod69",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od69',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(71,true),_vm._v(" "),_c('oddEdg',{ref:"teamod70",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od70',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(72,true),_vm._v(" "),_c('oddEdg',{ref:"teamod71",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od71',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(73,true),_vm._v(" "),_c('oddEdg',{ref:"teamod72",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od72',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(74,true),_vm._v(" "),_c('oddEdg',{ref:"teamod73",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od73',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(75,true),_vm._v(" "),_c('oddEdg',{ref:"teamod74",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od74',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"flex-1 overflow-hidden part-right"},[_c('div',{staticClass:"handicap"},[_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(76,true),_vm._v(" "),_c('oddEdg',{ref:"teamod75",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od75',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(77,true),_vm._v(" "),_c('oddEdg',{ref:"teamod76",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od76',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(78,true),_vm._v(" "),_c('oddEdg',{ref:"teamod77",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od77',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(79,true),_vm._v(" "),_c('oddEdg',{ref:"teamod78",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od78',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(80,true),_vm._v(" "),_c('oddEdg',{ref:"teamod79",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od79',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(81,true),_vm._v(" "),_c('oddEdg',{ref:"teamod23",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od80',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(82,true),_vm._v(" "),_c('oddEdg',{ref:"teamod81",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od81',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(83,true),_vm._v(" "),_c('oddEdg',{ref:"teamod82",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od82',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(84,true),_vm._v(" "),_c('oddEdg',{ref:"teamod83",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od83',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(85,true),_vm._v(" "),_c('oddEdg',{ref:"teamod84",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od84',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(86,true),_vm._v(" "),_c('oddEdg',{ref:"teamod85",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od85',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(87,true),_vm._v(" "),_c('oddEdg',{ref:"teamod86",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od86',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(88,true),_vm._v(" "),_c('oddEdg',{ref:"teamod87",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od87',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(89,true),_vm._v(" "),_c('oddEdg',{ref:"teamod88",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od88',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(90,true),_vm._v(" "),_c('oddEdg',{ref:"teamod89",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od89',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(91,true),_vm._v(" "),_c('oddEdg',{ref:"teamod90",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od90',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(92,true),_vm._v(" "),_c('oddEdg',{ref:"teamod91",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od91',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(93,true),_vm._v(" "),_c('oddEdg',{ref:"teamod92",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od92',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(94,true),_vm._v(" "),_c('oddEdg',{ref:"teamod93",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od93',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(95,true),_vm._v(" "),_c('oddEdg',{ref:"teamod94",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od94',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(96,true),_vm._v(" "),_c('oddEdg',{ref:"teamod95",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od95',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(97,true),_vm._v(" "),_c('oddEdg',{ref:"teamod96",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od96',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(98,true),_vm._v(" "),_c('oddEdg',{ref:"teamod97",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od97',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(99,true),_vm._v(" "),_c('oddEdg',{ref:"teamod98",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od98',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-item os-1"},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position normal zhuanye csid1"},[_c('div',{staticClass:"bet-inner yb-flex-center fit"},[_vm._m(100,true),_vm._v(" "),_c('oddEdg',{ref:"teamod99",refInFor:true,attrs:{"event":_vm.newAllBetEvent,"score":'od99',"plyType":_vm.plytyp,"betType":btype,"decimalNumber":1,"mode":'ab'}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box_innbet_btn",on:{"click":function($event){return _vm.showMore(_vm.allBetEvent.eveid)}}},[_c('div',{staticClass:"btn_innbet_more",attrs:{"id":"pd_show_more_4861319_4987282","data-less":_vm.sportAllBetLang['ALL_BET.LBL_VIEW_LESS'],"data-more":_vm.sportAllBetLang['ALL_BET.LBL_VIEW_MORE']}},[_c('i',{staticClass:"icon-arrow q-icon c-icon"},[_c('svg',[_c('use',{attrs:{"xlink:href":"#icon_toparr"}})])])])])])]],2):_vm._e()}),0):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set_top",staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-set_top c-icon",attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("0-9")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("1-9")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("2-9")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("3-9")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("4-9")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("5-9")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("6-9")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("7-9")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("8-9")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-0")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-3")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-4")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-5")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-wrap"},[_c('div',{staticClass:"bet-item"},[_c('div',{staticClass:"bet-ellipsis ellipsis"},[_c('span',{staticClass:"bet_handicap yb-family-odds"},[_vm._v("9-9")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-template",attrs:{"id":_vm.mode+'allBetGroup'+_vm.filMarketList.eveid}},[(_vm.filMarketList && _vm.filMarketList.od && Object.keys(_vm.filMarketList.od).length>0)?[(_vm.selected_Tab == _vm.betTab.hdpou.key || _vm.selected_Tab == _vm.betTab.hot.key)?[_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),(_vm.selected_Tab == _vm.betTab.hot.key)?[_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}})]:_vm._e(),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.htgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.atgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.atgBetType)}}),_vm._v(" "),(_vm.selected_Tab == _vm.betTab.hot.key)?[_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetTG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.tgBetType)}}),_vm._v(" "),_c('allBetTG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.tgBetType)}}),_vm._v(" "),_c('allBetCS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetCS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetNOG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.nogBetType)}})]:_vm._e(),_vm._v(" "),(_vm.selectedBettype.tmpltId == '8' || (_vm.open_RBMarket && _vm.selectedSport.tmpltId == '8'))?[(_vm.selectedBettype.sprtId == 'N15' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N15'))?void 0:(_vm.selectedBettype.sprtId == 'N2' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N2'))?[_c('allBetLDS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hldsBetType)}}),_vm._v(" "),_c('allBetLDS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.aldsBetType)}}),_vm._v(" "),_c('allBetWD',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.wdBetType)}})]:(_vm.selectedBettype.sprtId == 'N20' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N20'))?[_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType}})]:(_vm.selectedBettype.sprtId == 'N23' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N23'))?[_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htrBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.atrBetType)}}),_vm._v(" "),_vm._l((_vm.bbPlaytype),function(play_type,key){return [_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.htrBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.atrBetType)}})]})]:_vm._e(),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.pointHdpPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.pointHdpPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.pointHdpPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.pointHdpPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType}})]:_vm._e(),_vm._v(" "),(_vm.selectedBettype.tmpltId == '7')?[_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType}})]:_vm._e()]:(_vm.selected_Tab == _vm.betTab.goals.key)?[_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.htgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.atgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.atgBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetTG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.tgBetType)}}),_vm._v(" "),_c('allBetTG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.tgBetType)}}),_vm._v(" "),_c('allBetNOG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.nogBetType)}}),_vm._v(" "),_c('allBet1x2tgou',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2ouBetType)}}),_vm._v(" "),_c('allBet1x2btts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2bttsBetType)}}),_vm._v(" "),_c('allBetoubtts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.oubttsBetType)}})]:(_vm.selected_Tab == _vm.betTab.cs.key)?[_c('allBetCS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetCS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}})]:(_vm.selected_Tab == _vm.betTab.ft.key)?[_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.atgBetType)}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetHTFT',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htftBetType)}}),_vm._v(" "),_c('allBetTG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.tgBetType)}}),_vm._v(" "),_c('allBetCS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetNOG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.nogBetType)}}),_vm._v(" "),_c('allBet1x2tgou',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2ouBetType)}}),_vm._v(" "),_c('allBet1x2btts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2bttsBetType)}}),_vm._v(" "),_c('allBetouoe',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouoeBetType)}}),_vm._v(" "),_c('allBetoubtts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.oubttsBetType)}}),_vm._v(" "),_c('allBetOuFts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouftsBetType)}}),_vm._v(" "),_c('allBet1x2Fts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2ftsBetType)}}),_vm._v(" "),_c('allBetDbchOu',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.dbchouBetType)}}),_vm._v(" "),_c('allBetDbchBtts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.dbchbttsBetType)}}),_vm._v(" "),_c('allBetDbchFts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.dbchftsBetType)}})]:(_vm.selected_Tab == _vm.betTab.ht.key)?[_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.htgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.atgBetType)}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetHTFT',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htftBetType)}}),_vm._v(" "),_c('allBetTG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.tgBetType)}}),_vm._v(" "),_c('allBetCS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetH1X2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.h1x2BetType)}})]:(_vm.selected_Tab == _vm.betTab.sethdp.key)?[_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType}})]:(_vm.selected_Tab == _vm.betTab.gamehdp.key)?[_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"remove-market":_vm.removeFromMyMarket,"my-market":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType}})]:(_vm.selected_Tab == _vm.betTab.special.key)?[_c('allBetNOG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.nogBetType)}}),_vm._v(" "),_c('allBet1x2tgou',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2ouBetType)}}),_vm._v(" "),_c('allBet1x2btts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2bttsBetType)}}),_vm._v(" "),_c('allBetouoe',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouoeBetType)}}),_vm._v(" "),_c('allBetoubtts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.oubttsBetType)}}),_vm._v(" "),_c('allBetOuFts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouftsBetType)}}),_vm._v(" "),_c('allBet1x2Fts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2ftsBetType)}}),_vm._v(" "),_c('allBetDbchOu',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.dbchouBetType)}}),_vm._v(" "),_c('allBetDbchBtts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.dbchbttsBetType)}}),_vm._v(" "),_c('allBetDbchFts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.dbchftsBetType)}}),_vm._v(" "),_vm._l((_vm.sortSpecialEvents(_vm.filMarketList)),function(specialEvent){return [_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.mlBetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.mlBetType),"is-special":true}}),_vm._v(" "),_c('ftCS',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"is-special":true}}),_vm._v(" "),_c('ftCS',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"is-special":true}}),_vm._v(" "),_c('ftTG',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.tgBetType),"is-special":true}}),_vm._v(" "),_c('ftTG',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.tgBetType),"is-special":true}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"is-special":true}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"is-special":true}},[_vm._v(">")]),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"is-special":true}},[_vm._v(">")]),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"is-special":true}})]})]:(_vm.selected_Tab == _vm.betTab.others.key)?[_c('allBetCSH',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.cshBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.twnBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.twfbBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.twehBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.twbhBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.tsbhBetType)}}),_vm._v(" "),_c('allBetH1X2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.h1x2BetType)}}),_vm._v(" "),_c('allBetH1X2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.h1x2BetType)}}),_vm._v(" "),_c('allBetH1X2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.h1x2BetType)}}),_vm._v(" "),_c('allBetHMG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hmgBetType)}}),_vm._v(" "),_c('allBetHMG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hmg1x2BetType)}})]:(_vm.selected_Tab == _vm.betTab.all.key)?[_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),(_vm.selectedBettype.tmpltId == '1' || (_vm.open_RBMarket && _vm.selectedSport.tmpltId == '1'))?[_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.htgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.atgBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.atgBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetHTFT',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htftBetType)}}),_vm._v(" "),_c('allBetCS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetCS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),_c('allBetTG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.tgBetType)}}),_vm._v(" "),_c('allBetTG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.tgBetType)}}),_vm._v(" "),_c('allBetCSH',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.cshBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.twnBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.twfbBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.twehBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.twbhBetType)}}),_vm._v(" "),_c('allBetTW',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.tsbhBetType)}}),_vm._v(" "),_c('allBetWM',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetFLG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetH1X2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.h1x2BetType)}}),_vm._v(" "),_c('allBetH1X2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.h1x2BetType)}}),_vm._v(" "),_c('allBetH1X2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.h1x2BetType)}}),_vm._v(" "),_c('allBetHMG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hmgBetType)}}),_vm._v(" "),_c('allBetHMG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hmg1x2BetType)}}),_vm._v(" "),_c('allBetNOG',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.nogBetType)}}),_vm._v(" "),_c('allBet1x2tgou',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2ouBetType)}}),_vm._v(" "),_c('allBet1x2btts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2bttsBetType)}}),_vm._v(" "),_c('allBetouoe',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouoeBetType)}}),_vm._v(" "),_c('allBetoubtts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.oubttsBetType)}}),_vm._v(" "),_c('allBetOuFts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouftsBetType)}}),_vm._v(" "),_c('allBet1x2Fts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2ftsBetType)}}),_vm._v(" "),_c('allBetDbchOu',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.dbchouBetType)}}),_vm._v(" "),_c('allBetDbchBtts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.dbchbttsBetType)}}),_vm._v(" "),_c('allBetDbchFts',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.dbchftsBetType)}})]:(_vm.selectedBettype.tmpltId == '8' || (_vm.open_RBMarket && _vm.selectedSport.tmpltId == '8'))?[_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstHtPlyType}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.SecondHtPlyType}}),_vm._v(" "),(_vm.selectedBettype.sprtId == 'N15' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N15'))?void 0:(_vm.selectedBettype.sprtId == 'N2' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N2'))?[_c('allBetLDS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hldsBetType)}}),_vm._v(" "),_c('allBetLDS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.aldsBetType)}}),_vm._v(" "),_c('allBetWD',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.wdBetType)}}),_vm._v(" "),_c('allBetEg',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType}})]:(_vm.selectedBettype.sprtId == 'N20' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N20'))?[_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType}})]:(_vm.selectedBettype.sprtId == 'N23' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N23'))?[_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htrBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.atrBetType)}}),_vm._v(" "),_c('allBetWM',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.wmrBetType}}),_vm._v(" "),_vm._l((_vm.bbPlaytype),function(play_type,key){return [_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.htrBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.atrBetType)}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.exiBetType}}),_vm._v(" "),_c('allBetWM',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.wmrBetType}})]})]:_vm._e(),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.gameHdpPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.setHandicapPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.pointHdpPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.pointHdpPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.pointHdpPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.pointHdpPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.firstSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.secondSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.thirdSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fourthSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.fifthSetPlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.sixthSetPlyType}})]:_vm._e(),_vm._v(" "),(_vm.selectedBettype.tmpltId == '7')?[_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game1PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game2PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game3PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game4PlyType}}),_vm._v(" "),_c('allBetML',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.mlBetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.game5PlyType}})]:_vm._e(),_vm._v(" "),_vm._l((_vm.sortSpecialEvents(_vm.filMarketList)),function(specialEvent,key){return (_vm.filMarketList.sp)?[_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.mlBetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.mlBetType),"is-special":true}}),_vm._v(" "),_c('ftCS',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"is-special":true}}),_vm._v(" "),_c('ftCS',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"is-special":true}}),_vm._v(" "),_c('ftTG',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.tgBetType),"is-special":true}}),_vm._v(" "),_c('ftTG',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.tgBetType),"is-special":true}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"is-special":true}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"is-special":true}}),_vm._v(" "),_c('allBetDBCH',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"is-special":true}})]:_vm._e()})]:(_vm.selected_Tab == _vm.betTab.innings.key)?[(_vm.selectedBettype.sprtId == 'N23' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N23'))?[_c('allBetWM',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.wmrBetType}}),_vm._v(" "),_vm._l((_vm.bbPlaytype),function(play_type,key){return [_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.onex2BetType)}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.hdpBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.ouBetType)}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.htrBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.atrBetType)}}),_vm._v(" "),_c('allBetBTTS',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.exiBetType}}),_vm._v(" "),_c('allBetWM',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.wmrBetType}})]})]:_vm._e()]:(_vm.selected_Tab == _vm.betTab.team.key)?[(_vm.selectedBettype.sprtId == 'N23' || (_vm.open_RBMarket && _vm.selectedSport.sprtId == 'N23'))?[_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.htrBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.atrBetType)}}),_vm._v(" "),_vm._l((_vm.bbPlaytype),function(play_type,key){return [_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.htrBetType)}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":_vm.filMarketList,"plytyp":play_type,"bettyp":_vm.getRB(_vm.atrBetType)}})]})]:_vm._e()]:(_vm.selected_Tab == _vm.betTab.booking.key)?[(_vm.selectedBettype.tmpltId == '1' || (_vm.open_RBMarket && _vm.selectedBettype.tmpltId == '1'))?[_vm._l((_vm.sortSpecialEvents(_vm.filMarketList)),function(specialEvent,key){return (_vm.filMarketList.sp)?[_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"is-special":true}})]:_vm._e()})]:_vm._e()]:(_vm.selected_Tab == _vm.betTab.corner.key)?[(_vm.selectedBettype.tmpltId == '1' || (_vm.open_RBMarket && _vm.selectedBettype.tmpltId == '1'))?[_vm._l((_vm.sortSpecialEvents(_vm.filMarketList)),function(specialEvent,key){return (_vm.filMarketList.sp)?[_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBet1x2',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.onex2BetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetHDP',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.hdpBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBetOU',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"bettyp":_vm.getRB(_vm.ouBetType),"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.ftPlyType,"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.firstHtPlyType,"is-special":true}}),_vm._v(" "),_c('allBetOE',{attrs:{"mode":_vm.mode,"all-bet-event":specialEvent,"plytyp":_vm.SecondHtPlyType,"is-special":true}})]:_vm._e()})]:_vm._e()]:_vm._e()]:[_c('div',{staticClass:"load-data-wrap column yb-flex-center empty",attrs:{"data-v-21f17103":""}},[_c('div',{staticClass:"list_right_empty",attrs:{"data-v-21f17103":""}},[_c('div',{staticClass:"img",attrs:{"data-v-21f17103":""}}),_vm._v(" "),_c('span',{attrs:{"data-v-21f17103":""}},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.MARKET_CLOSED']))])])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_osAllBetHeader_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6419ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_osAllBetHeader_vue__ = __webpack_require__(414);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_osAllBetHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6419ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_osAllBetHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-info",attrs:{"data-v-9d87a3d9":"","data-v-46377044":""}},[_c('div',{staticClass:"more-time",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"time-tips",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"c-match-process text-center row a-row",attrs:{"data-v-e30046ca":"","data-v-9d87a3d9":""}},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"},attrs:{"data-v-e30046ca":""}}),_vm._v(" "),_c('div',{staticClass:"time-content",attrs:{"data-v-e30046ca":""}},[_c('div',{staticClass:"process-name",attrs:{"data-v-e30046ca":""}},[(_vm.firstEvent.sptid==3 || _vm.firstEvent.sptid==12 || _vm.firstEvent.sptid==21)?_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.st=='NL'? _vm.sportTableLang.table['SPORT_TABLE.LBL_SET_S1'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_SET_'+_vm.firstEvent.rbinfo.st]))]):(_vm.firstEvent.sptid==23)?_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.st=='NL'? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_INN_'+_vm.firstEvent.rbinfo.st]))]):(_vm.firstEvent.sptid==14)?_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.st=='NL'? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_PERIOD_'+_vm.firstEvent.rbinfo.st]))]):(_vm.firstEvent.sptid==20)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.st=='NL'? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_GAME_'+_vm.firstEvent.rbinfo.st]))]):(_vm.firstEvent.sptid==15)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.st=='NL'? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_FRAME_'+_vm.firstEvent.rbinfo.st]))]):(_vm.firstEvent.sptid==13)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.st=='NL'? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_Q_'+_vm.firstEvent.rbinfo.st]))]):(_vm.firstEvent.sptid==19)?_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[(_vm.firstEvent.rbinfo.st=='NL')?[_vm._v("\n                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LIVE'])+"\n                            ")]:(_vm.firstEvent.rbinfo.st=='H1')?[_vm._v("\n                                "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_1HT'])+"\n                            ")]:(_vm.firstEvent.rbinfo.st=='H2')?[_vm._v("\n                                "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_2HT'])+"\n                            ")]:_vm._e()],2):_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[_vm._v(" "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LIVE']))])])])])]),_vm._v(" "),_c('div',{staticClass:"scorll-handel",attrs:{"data-v-9d87a3d9":""}},[(_vm.sportColLength[_vm.firstEvent.sptid]>5)?_c('span',{staticClass:"scroll-arrow",attrs:{"data-v-9d87a3d9":"","id":"prev"}},[_c('i',{staticClass:"q-icon icon-arrow arrow-left c-icon set-color",staticStyle:{"color":"rgb(109, 114, 120)","font-size":"10px","display":"none"},attrs:{"data-v-e826ac10":"","data-v-9d87a3d9":"","aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"time-node mini",attrs:{"data-v-9d87a3d9":""}},[(_vm.firstEvent.sptid==3 || _vm.firstEvent.sptid==12 || _vm.firstEvent.sptid==21)?_vm._l((_vm.sportColLength[_vm.firstEvent.sptid]),function(n){return (n==1&&_vm.firstEvent.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(n))]):_c('span',{class:_vm.firstEvent.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(n))])}):(_vm.firstEvent.sptid==13 || _vm.firstEvent.sptid==23 || _vm.firstEvent.sptid==14 || _vm.firstEvent.sptid==19 || _vm.firstEvent.sptid==7 || _vm.firstEvent.sptid==15 || _vm.firstEvent.sptid==20)?[(_vm.firstEvent.rbinfo.score['S1'] && (_vm.firstEvent.sptid==14 || _vm.firstEvent.sptid==23))?_vm._l((_vm.sportColLength[_vm.firstEvent.sptid]),function(n){return (n==1&&_vm.firstEvent.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(n))]):(n!=_vm.sportColLength[_vm.firstEvent.sptid])?_c('span',{class:_vm.firstEvent.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(n))]):_c('span',{class:_vm.firstEvent.rbinfo.st=='OT'?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.sptid==23 ? _vm.sportTableLang.table['SPORT_TABLE.LBL_OS_OT1'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_OS_OT']))])}):[_c('div',{staticClass:"result-icon-wrap"},[_c('div',{staticClass:"result-icon rs_jin_quan",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_FT']}})])]]:_vm._e()],2),_vm._v(" "),(_vm.sportColLength[_vm.firstEvent.sptid]>5)?_c('span',{staticClass:"scroll-arrow",attrs:{"data-v-9d87a3d9":"","id":"next"}},[_c('i',{staticClass:"q-icon icon-arrow arrow-right c-icon set-color",staticStyle:{"color":"rgb(109, 114, 120)","font-size":"10px"},attrs:{"data-v-e826ac10":"","data-v-9d87a3d9":"","aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==3)?[_c('div',{staticClass:"add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_TN_SET']))]),_vm._v(" "),_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_TN_P']))])]:(_vm.firstEvent.rbinfo.score['S1'] && _vm.firstEvent.sptid==23)?[_c('div',{staticClass:"add-stage score",attrs:{"data-v-9d87a3d9":""}},[_vm._v("R")])]:(_vm.firstEvent.sptid==12 || _vm.firstEvent.sptid==21)?[_c('div',{staticClass:"add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_GAME']))]),_vm._v(" "),_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.TOTAL_SCORE']))])]:(_vm.firstEvent.rbinfo.score['S1'] && _vm.firstEvent.sptid==14)?[_c('div',{staticClass:"add-stage score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.TOTAL_SCORE']))])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"more-both",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"both-item relative-position",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"both-name ellipsis",attrs:{"data-v-9d87a3d9":""}},[_c('span',{staticClass:"ellipsis",attrs:{"data-v-9d87a3d9":""},domProps:{"innerHTML":_vm._s(_vm.firstEvent.tacapt)}})]),_vm._v(" "),_c('div',{staticClass:"scorll-handel",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"time-node mini",style:(_vm.sportColLength[_vm.firstEvent.sptid]>5 ? 'margin: 0px 13px 0px 14px;':'margin: 0px;'),attrs:{"data-v-9d87a3d9":""}},[(_vm.firstEvent.sptid==3 || _vm.firstEvent.sptid==12 || _vm.firstEvent.sptid==21)?[(_vm.firstEvent.rbinfo.st!='NL')?_vm._l((_vm.sportColLength[_vm.firstEvent.sptid]),function(n){return (_vm.firstEvent.rbinfo.score['S'+n])?_c('span',{class:_vm.firstEvent.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['S'+n]['scoa']))]):_c('span',{attrs:{"data-v-9d87a3d9":""}})}):[(_vm.firstEvent.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['NL']['scoa']))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.sportColLength[_vm.firstEvent.sptid]-1)),function(n){return _c('span',{attrs:{"data-v-9d87a3d9":""}})})]]:(_vm.firstEvent.sptid==23 || _vm.firstEvent.sptid==14 || _vm.firstEvent.sptid==15 || _vm.firstEvent.sptid==19 || _vm.firstEvent.sptid==20)?[(_vm.firstEvent.rbinfo.score['S1'] && (_vm.firstEvent.sptid==14 || _vm.firstEvent.sptid==23))?[(_vm.firstEvent.rbinfo.st!='NL')?_vm._l((_vm.sportColLength[_vm.firstEvent.sptid]),function(n){return (_vm.firstEvent.rbinfo.score['S'+n]&&n!=_vm.sportColLength[_vm.firstEvent.sptid])?_c('span',{class:_vm.firstEvent.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['S'+n]['scoa']))]):(_vm.firstEvent.rbinfo.st=='OT')?_c('span',{class:_vm.firstEvent.rbinfo.st=='OT'?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['OT']['scoa']))]):_c('span',{attrs:{"data-v-9d87a3d9":""}})}):[(_vm.firstEvent.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['NL']['scoa']))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.sportColLength[_vm.firstEvent.sptid]-1)),function(n){return _c('span',{attrs:{"data-v-9d87a3d9":""}})})]]:[_c('div',{staticClass:"score add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'A')))])]]:(_vm.firstEvent.sptid==13)?[_c('div',{staticClass:"score add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'A', true)))])]:(_vm.firstEvent.sptid==7)?[_c('div',{staticClass:"score add-stage",style:((_vm.getScoreSet(_vm.firstEvent, 'A', true)).includes('/') ? 'width: 50px !important; text-align: right;':''),attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'A', true)))])]:_vm._e()],2),_vm._v(" "),(_vm.firstEvent.sptid!=13 && _vm.firstEvent.sptid!=19 && _vm.firstEvent.sptid!=23 && _vm.firstEvent.sptid!=14 && _vm.firstEvent.sptid!=15 && _vm.firstEvent.sptid!=7 && _vm.firstEvent.sptid!=20)?_c('div',{class:_vm.sportColLength[_vm.firstEvent.sptid]>5 && (_vm.firstEvent.sptid==23||_vm.firstEvent.sptid==15) ? 'score add-stage' : _vm.firstEvent.sptid==14 ? 'score add-stage':'add-stage',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'A')))]):(_vm.firstEvent.rbinfo.score['S1'] && (_vm.firstEvent.sptid==23 || _vm.firstEvent.sptid==14))?_c('div',{class:_vm.sportColLength[_vm.firstEvent.sptid]>5 && (_vm.firstEvent.sptid==23||_vm.firstEvent.sptid==15) ? 'score add-stage' : _vm.firstEvent.sptid==14 ? 'score add-stage':'add-stage',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'A')))]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==3)?[(_vm.firstEvent.rbinfo.score['PT'])?_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['PT']['scoa']))]):_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v("-")])]:(_vm.firstEvent.sptid==12 || _vm.firstEvent.sptid==21)?[_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'A', true)))])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"both-item relative-position",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"both-name ellipsis",attrs:{"data-v-9d87a3d9":""}},[_c('span',{staticClass:"ellipsis",attrs:{"data-v-9d87a3d9":""},domProps:{"innerHTML":_vm._s(_vm.firstEvent.tbcapt)}})]),_vm._v(" "),_c('div',{staticClass:"scorll-handel",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"time-node mini",style:(_vm.sportColLength[_vm.firstEvent.sptid]>5 ? 'margin: 0px 13px 0px 14px;':'margin: 0px;'),attrs:{"data-v-9d87a3d9":""}},[(_vm.firstEvent.sptid==3 || _vm.firstEvent.sptid==12 || _vm.firstEvent.sptid==21)?[(_vm.firstEvent.rbinfo.st!='NL')?_vm._l((_vm.sportColLength[_vm.firstEvent.sptid]),function(n){return (_vm.firstEvent.rbinfo.score['S'+n])?_c('span',{class:_vm.firstEvent.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['S'+n]['scob']))]):_c('span',{attrs:{"data-v-9d87a3d9":""}})}):[(_vm.firstEvent.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['NL']['scob']))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.sportColLength[_vm.firstEvent.sptid]-1)),function(n){return _c('span',{attrs:{"data-v-9d87a3d9":""}})})]]:(_vm.firstEvent.sptid==23 || _vm.firstEvent.sptid==14 || _vm.firstEvent.sptid==15 || _vm.firstEvent.sptid==19 || _vm.firstEvent.sptid==20)?[(_vm.firstEvent.rbinfo.score['S1'] && (_vm.firstEvent.sptid==14 || _vm.firstEvent.sptid==23))?[(_vm.firstEvent.rbinfo.st!='NL')?_vm._l((_vm.sportColLength[_vm.firstEvent.sptid]),function(n){return (_vm.firstEvent.rbinfo.score['S'+n]&&n!=_vm.sportColLength[_vm.firstEvent.sptid])?_c('span',{class:_vm.firstEvent.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['S'+n]['scob']))]):(_vm.firstEvent.rbinfo.st=='OT')?_c('span',{class:_vm.firstEvent.rbinfo.st=='OT'?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['OT']['scob']))]):_c('span',{attrs:{"data-v-9d87a3d9":""}})}):[(_vm.firstEvent.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['NL']['scob']))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.sportColLength[_vm.firstEvent.sptid]-1)),function(n){return _c('span',{attrs:{"data-v-9d87a3d9":""}})})]]:[_c('div',{staticClass:"score add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'B')))])]]:(_vm.firstEvent.sptid==13)?[_c('div',{staticClass:"score add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'B', true)))])]:(_vm.firstEvent.sptid==7)?[_c('div',{staticClass:"score add-stage",style:((_vm.getScoreSet(_vm.firstEvent, 'B', true)).includes('/') ? 'width: 50px !important; text-align: right;':''),attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'B', true)))])]:_vm._e()],2),_vm._v(" "),(_vm.firstEvent.sptid!=13 && _vm.firstEvent.sptid!=19 && _vm.firstEvent.sptid!=23 && _vm.firstEvent.sptid!=14 && _vm.firstEvent.sptid!=15 && _vm.firstEvent.sptid!=7 && _vm.firstEvent.sptid!=20)?_c('div',{class:_vm.sportColLength[_vm.firstEvent.sptid]>5 && (_vm.firstEvent.sptid==23||_vm.firstEvent.sptid==15) ? 'score add-stage' : _vm.firstEvent.sptid==14 ? 'score add-stage':'add-stage',attrs:{"data-v-9d87a3d9":""}},[_vm._v("\n                    "+_vm._s(_vm.getScoreSet(_vm.firstEvent, 'B'))+"\n                ")]):(_vm.firstEvent.rbinfo.score['S1'] && (_vm.firstEvent.sptid==23 || _vm.firstEvent.sptid==14))?_c('div',{class:_vm.sportColLength[_vm.firstEvent.sptid]>5 && (_vm.firstEvent.sptid==23||_vm.firstEvent.sptid==15) ? 'score add-stage' : _vm.firstEvent.sptid==14 ? 'score add-stage':'add-stage',attrs:{"data-v-9d87a3d9":""}},[_vm._v("\n                    "+_vm._s(_vm.getScoreSet(_vm.firstEvent, 'B'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==3)?[(_vm.firstEvent.rbinfo.score['PT'])?_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.score['PT']['scob']))]):_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v("-")])]:(_vm.firstEvent.sptid==12 || _vm.firstEvent.sptid==21)?[_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.firstEvent, 'B', true)))])]:_vm._e()],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-header absolute"},[_c('div',{class:{'right_details_header no-bottom-border' : _vm.mode!='ab' }},[(_vm.mode=='ab')?[_c('div',{staticClass:"wrap-title"},[_c('div',{staticClass:"group-back cursor-pointer",on:{"click":function($event){return _vm.backToMain()}}},[_c('i',{staticClass:"back q-icon icon-back c-icon set-color",staticStyle:{"color":"rgb(171, 186, 200)"},attrs:{"aria-hidden":"true","role":"presentation"}})]),_vm._v(" "),_c('div',{staticClass:"title ellipsis allow-user-select",domProps:{"innerHTML":_vm._s(_vm.sortedMatchEventList.lgecapt)}}),_vm._v(" "),_c('div',{staticClass:"right-icon"},[(!_vm.showhideBanner)?_c('span',{on:{"click":function($event){return _vm.showhide_Banner(true)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SHOWSCRBOARD']))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"refresh-icon-wrap yb-flex-center select-btn refresh-tbl-wrap yb-hover-bg",on:{"click":function($event){return _vm.refreshTbl(_vm.token.arr_5)}}},[_vm._m(0)])])]),_vm._v(" "),(_vm.showhideBanner)?_c('div',{ref:"testa",staticClass:"head-info relative-position esports-head-info-1",class:_vm.getABetSport()},[_c('div',{staticClass:"right_match_info info-upd full-width vrow justify-center"},[(_vm.sortedMatchEventList.rbinfo && _vm.sortedMatchEventList.sptid>2)?[_c('div',{staticClass:"more-info",attrs:{"data-v-9d87a3d9":"","data-v-46377044":""}},[_c('div',{staticClass:"more-time",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"time-tips",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"c-match-process text-center row a-row",attrs:{"data-v-e30046ca":"","data-v-9d87a3d9":""}},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"},attrs:{"data-v-e30046ca":""}}),_vm._v(" "),_c('div',{staticClass:"time-content",attrs:{"data-v-e30046ca":""}},[_c('div',{staticClass:"process-name",attrs:{"data-v-e30046ca":""}},[(_vm.sortedMatchEventList.sptid==3 || _vm.sortedMatchEventList.sptid==12 || _vm.sortedMatchEventList.sptid==21)?_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.st=='NL' ? _vm.sportTableLang.table['SPORT_TABLE.LBL_SET_S1'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_SET_'+_vm.firstEvent.rbinfo.st]))]):(_vm.sortedMatchEventList.sptid==23)?_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.st=='NL' ? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_INN_'+_vm.sortedMatchEventList.rbinfo.st]))]):(_vm.sortedMatchEventList.sptid==14)?_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.st=='NL' ? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_PERIOD_'+_vm.sortedMatchEventList.rbinfo.st]))]):(_vm.sortedMatchEventList.sptid==20)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.st=='NL' ? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_GAME_'+_vm.sortedMatchEventList.rbinfo.st]))]):(_vm.sortedMatchEventList.sptid==15)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.st=='NL' ? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_FRAME_'+_vm.sortedMatchEventList.rbinfo.st]))]):(_vm.sortedMatchEventList.sptid==13)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.st=='NL' ? _vm.sportTableLang.table['SPORT_TABLE.LIVE'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_Q_'+_vm.sortedMatchEventList.rbinfo.st]))]):(_vm.sortedMatchEventList.sptid==19)?_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[(_vm.sortedMatchEventList.rbinfo.st=='NL')?[_vm._v("\n                          "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LIVE'])+"\n                        ")]:(_vm.sortedMatchEventList.rbinfo.st=='H1')?[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_1HT'])+"\n                        ")]:(_vm.sortedMatchEventList.rbinfo.st=='H2')?[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_2HT'])+"\n                        ")]:_vm._e()],2):_c('div',{staticClass:"process_name",attrs:{"data-v-e30046ca":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LIVE']))])])])])]),_vm._v(" "),_c('div',{staticClass:"scorll-handel",attrs:{"data-v-9d87a3d9":""}},[(_vm.sortedMatchEventList.sptid==15)?_c('span',{staticClass:"scroll-arrow",attrs:{"data-v-9d87a3d9":"","id":"prev-sn"}},[_c('i',{staticClass:"q-icon icon-arrow arrow-left c-icon set-color",staticStyle:{"color":"rgb(109, 114, 120)","font-size":"10px","display":"none"},attrs:{"data-v-e826ac10":"","data-v-9d87a3d9":"","aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"time-node is_details",attrs:{"data-v-9d87a3d9":""}},[(_vm.sortedMatchEventList.sptid==3 || _vm.sortedMatchEventList.sptid==12 || _vm.sortedMatchEventList.sptid==21)?_vm._l((_vm.sportColLength[_vm.sortedMatchEventList.sptid]),function(n){return (n==1&&_vm.sortedMatchEventList.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(n))]):_c('span',{class:_vm.sortedMatchEventList.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(n))])}):(_vm.sortedMatchEventList.sptid==13 || _vm.sortedMatchEventList.sptid==23 || _vm.sortedMatchEventList.sptid==20 || _vm.sortedMatchEventList.sptid==15 || _vm.sortedMatchEventList.sptid==19 || _vm.sortedMatchEventList.sptid==14 || _vm.sortedMatchEventList.sptid==7)?[(_vm.sortedMatchEventList.rbinfo.score['S1'] && (_vm.sortedMatchEventList.sptid==14 || _vm.sortedMatchEventList.sptid==23))?_vm._l((_vm.sportColLength[_vm.sortedMatchEventList.sptid]),function(n){return (n==1&&_vm.sortedMatchEventList.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(n))]):(n!=_vm.sportColLength[_vm.sortedMatchEventList.sptid])?_c('span',{class:_vm.sortedMatchEventList.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(n))]):_c('span',{class:_vm.sortedMatchEventList.rbinfo.st=='OT'?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.sptid==23 ? _vm.sportTableLang.table['SPORT_TABLE.LBL_OS_OT1'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_OS_OT']))])}):[_c('div',{staticClass:"result-icon-wrap"},[_c('div',{staticClass:"result-icon rs_jin_quan",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_FT']}})])]]:_vm._e()],2),_vm._v(" "),(_vm.sortedMatchEventList.sptid==15)?_c('span',{staticClass:"scroll-arrow",attrs:{"data-v-9d87a3d9":"","id":"next-sn"}},[_c('i',{staticClass:"q-icon icon-arrow arrow-right c-icon set-color",staticStyle:{"color":"rgb(109, 114, 120)","font-size":"10px"},attrs:{"data-v-e826ac10":"","data-v-9d87a3d9":"","aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.sortedMatchEventList.sptid==3)?[_c('div',{staticClass:"add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_TN_SET']))]),_vm._v(" "),_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_TN_P']))])]:(_vm.sortedMatchEventList.rbinfo.score['S1'] && _vm.sortedMatchEventList.sptid==23)?[_c('div',{staticClass:"add-stage score",attrs:{"data-v-9d87a3d9":""}},[_vm._v("R")])]:(_vm.sortedMatchEventList.sptid==12 || _vm.sortedMatchEventList.sptid==21)?[_c('div',{staticClass:"add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_GAME']))]),_vm._v(" "),_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.TOTAL_SCORE']))])]:(_vm.sortedMatchEventList.rbinfo.score['S1'] && _vm.sortedMatchEventList.sptid==14)?[_c('div',{staticClass:"add-stage score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.TOTAL_SCORE']))])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"more-both",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"both-item relative-position",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"both-name ellipsis",attrs:{"data-v-9d87a3d9":""}},[_c('span',{staticClass:"ellipsis",attrs:{"data-v-9d87a3d9":""},domProps:{"innerHTML":_vm._s(_vm.sortedMatchEventList.tacapt)}})]),_vm._v(" "),_c('div',{staticClass:"scorll-handel",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"time-node is_details",style:(_vm.sortedMatchEventList.sptid==15 ? 'margin: 0px 13px 0px 14px;':'margin: 0px;'),attrs:{"data-v-9d87a3d9":""}},[(_vm.sortedMatchEventList.sptid==3 || _vm.sortedMatchEventList.sptid==12 || _vm.sortedMatchEventList.sptid==21)?[(_vm.sortedMatchEventList.rbinfo.st!='NL')?_vm._l((_vm.sportColLength[_vm.sortedMatchEventList.sptid]),function(n){return (_vm.sortedMatchEventList.rbinfo.score['S'+n])?_c('span',{class:_vm.sortedMatchEventList.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-90337153":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['S'+n]['scoa']))]):_c('span')}):[(_vm.sortedMatchEventList.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-90337153":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['NL']['scoa']))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.sportColLength[_vm.sortedMatchEventList.sptid]-1)),function(n){return _c('span',{attrs:{"data-v-9d87a3d9":""}})})]]:(_vm.sortedMatchEventList.sptid==23 || _vm.sortedMatchEventList.sptid==20 || _vm.sortedMatchEventList.sptid==15 || _vm.sortedMatchEventList.sptid==19 || _vm.sortedMatchEventList.sptid==14)?[(_vm.sortedMatchEventList.rbinfo.score['S1'] && (_vm.sortedMatchEventList.sptid==14 || _vm.sortedMatchEventList.sptid==23))?[(_vm.sortedMatchEventList.rbinfo.st!='NL')?_vm._l((_vm.sportColLength[_vm.sortedMatchEventList.sptid]),function(n){return (_vm.sortedMatchEventList.rbinfo.score['S'+n]&&n!=_vm.sportColLength[_vm.sortedMatchEventList.sptid])?_c('span',{class:_vm.sortedMatchEventList.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['S'+n]['scoa']))]):(_vm.sortedMatchEventList.rbinfo.st=='OT')?_c('span',{class:_vm.sortedMatchEventList.rbinfo.st=='OT'?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['OT']['scoa']))]):_c('span',{attrs:{"data-v-9d87a3d9":""}})}):[(_vm.sortedMatchEventList.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['NL']['scoa']))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.sportColLength[_vm.sortedMatchEventList.sptid]-1)),function(n){return _c('span',{attrs:{"data-v-9d87a3d9":""}})})]]:[_c('div',{staticClass:"score add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'A')))])]]:(_vm.sortedMatchEventList.sptid==13)?[_c('div',{staticClass:"score add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'A', true)))])]:(_vm.sortedMatchEventList.sptid==7)?[_c('div',{staticClass:"score add-stage",style:(_vm.getScoreSet(_vm.sortedMatchEventList, 'A', true)!=0 ? 'width: 50px !important; text-align: right;':''),attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'A', true)))])]:_vm._e()],2),_vm._v(" "),(_vm.sortedMatchEventList.sptid!=7&&_vm.sortedMatchEventList.sptid!=13&&_vm.sortedMatchEventList.sptid!=14&&_vm.sortedMatchEventList.sptid!=15&&_vm.sortedMatchEventList.sptid!=19&&_vm.sortedMatchEventList.sptid!=20&&_vm.sortedMatchEventList.sptid!=23)?_c('div',{class:_vm.sportColLength[_vm.sortedMatchEventList.sptid]>5 && (_vm.sortedMatchEventList.sptid==23||_vm.sortedMatchEventList.sptid==15) ? 'score add-stage' : _vm.sortedMatchEventList.sptid==14 ? 'score add-stage':'add-stage',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'A')))]):(_vm.sortedMatchEventList.rbinfo.score['S1']&&(_vm.sortedMatchEventList.sptid==14||_vm.sortedMatchEventList.sptid==23))?_c('div',{class:_vm.sportColLength[_vm.sortedMatchEventList.sptid]>5 && (_vm.sortedMatchEventList.sptid==23||_vm.sortedMatchEventList.sptid==15) ? 'score add-stage' : _vm.sortedMatchEventList.sptid==14 ? 'score add-stage':'add-stage',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'A')))]):_vm._e(),_vm._v(" "),(_vm.sortedMatchEventList.sptid==3)?[(_vm.sortedMatchEventList.rbinfo.score['PT'])?_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['PT']['scoa']))]):_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v("0")])]:(_vm.sortedMatchEventList.sptid==12 || _vm.sortedMatchEventList.sptid==21)?[_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'A', true)))])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"both-item relative-position",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"both-name ellipsis",attrs:{"data-v-9d87a3d9":""}},[_c('span',{staticClass:"ellipsis",attrs:{"data-v-9d87a3d9":""},domProps:{"innerHTML":_vm._s(_vm.sortedMatchEventList.tbcapt)}})]),_vm._v(" "),_c('div',{staticClass:"scorll-handel",attrs:{"data-v-9d87a3d9":""}},[_c('div',{staticClass:"time-node is_details",style:(_vm.sortedMatchEventList.sptid==15 ? 'margin: 0px 13px 0px 14px;':'margin: 0px;'),attrs:{"data-v-9d87a3d9":""}},[(_vm.sortedMatchEventList.sptid==3 || _vm.sortedMatchEventList.sptid==12 || _vm.sortedMatchEventList.sptid==21)?[(_vm.sortedMatchEventList.rbinfo.st!='NL')?_vm._l((_vm.sportColLength[_vm.sortedMatchEventList.sptid]),function(n){return (_vm.sortedMatchEventList.rbinfo.score['S'+n])?_c('span',{class:_vm.sortedMatchEventList.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-90337153":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['S'+n]['scob']))]):_c('span')}):[(_vm.sortedMatchEventList.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['NL']['scob']))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.sportColLength[_vm.sortedMatchEventList.sptid]-1)),function(n){return _c('span',{attrs:{"data-v-9d87a3d9":""}})})]]:(_vm.sortedMatchEventList.sptid==23 || _vm.sortedMatchEventList.sptid==20 || _vm.sortedMatchEventList.sptid==15 || _vm.sortedMatchEventList.sptid==19 || _vm.sortedMatchEventList.sptid==14)?[(_vm.sortedMatchEventList.rbinfo.score['S1'] && (_vm.sortedMatchEventList.sptid==14 || _vm.sortedMatchEventList.sptid==23))?[(_vm.sortedMatchEventList.rbinfo.st!='NL')?_vm._l((_vm.sportColLength[_vm.sortedMatchEventList.sptid]),function(n){return (_vm.sortedMatchEventList.rbinfo.score['S'+n]&&n!=_vm.sportColLength[_vm.sortedMatchEventList.sptid])?_c('span',{class:_vm.sortedMatchEventList.rbinfo.st=='S'+n?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['S'+n]['scob']))]):(_vm.sortedMatchEventList.rbinfo.st=='OT')?_c('span',{class:_vm.sortedMatchEventList.rbinfo.st=='OT'?'current_color':'',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['OT']['scob']))]):_c('span',{attrs:{"data-v-9d87a3d9":""}})}):[(_vm.sortedMatchEventList.rbinfo.st=='NL')?_c('span',{staticClass:"current_color",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['NL']['scob']))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.sportColLength[_vm.sortedMatchEventList.sptid]-1)),function(n){return _c('span',{attrs:{"data-v-9d87a3d9":""}})})]]:[_c('div',{staticClass:"score add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'B')))])]]:(_vm.sortedMatchEventList.sptid==13)?[_c('div',{staticClass:"score add-stage",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'B', true)))])]:(_vm.sortedMatchEventList.sptid==7)?[_c('div',{staticClass:"score add-stage",style:(_vm.getScoreSet(_vm.sortedMatchEventList, 'B', true)!=0 ? 'width: 50px !important; text-align: right;':''),attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'B', true)))])]:_vm._e()],2),_vm._v(" "),(_vm.sortedMatchEventList.sptid!=7&&_vm.sortedMatchEventList.sptid!=13&&_vm.sortedMatchEventList.sptid!=14&&_vm.sortedMatchEventList.sptid!=15&&_vm.sortedMatchEventList.sptid!=19&&_vm.sortedMatchEventList.sptid!=20&&_vm.sortedMatchEventList.sptid!=23)?_c('div',{class:_vm.sportColLength[_vm.sortedMatchEventList.sptid]>5 && (_vm.sortedMatchEventList.sptid==23||_vm.sortedMatchEventList.sptid==15) ? 'score add-stage' : _vm.sortedMatchEventList.sptid==14 ? 'score add-stage':'add-stage',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'B')))]):(_vm.sortedMatchEventList.rbinfo.score['S1']&&(_vm.sortedMatchEventList.sptid==14||_vm.sortedMatchEventList.sptid==23))?_c('div',{class:_vm.sportColLength[_vm.sortedMatchEventList.sptid]>5 && (_vm.sortedMatchEventList.sptid==23||_vm.sortedMatchEventList.sptid==15) ? 'score add-stage' : _vm.sortedMatchEventList.sptid==14 ? 'score add-stage':'add-stage',attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'B')))]):_vm._e(),_vm._v(" "),(_vm.sortedMatchEventList.sptid==3)?[(_vm.sortedMatchEventList.rbinfo.score['PT'])?_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.sortedMatchEventList.rbinfo.score['PT']['scob']))]):_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v("0")])]:(_vm.sortedMatchEventList.sptid==12 || _vm.sortedMatchEventList.sptid==21)?[_c('div',{staticClass:"score",attrs:{"data-v-9d87a3d9":""}},[_vm._v(_vm._s(_vm.getScoreSet(_vm.sortedMatchEventList, 'B', true)))])]:_vm._e()],2)])])])]:[_c('div',{staticClass:"before"},[_c('div',{staticClass:"content",staticStyle:{"box-shadow":"rgba(0, 0, 0, 0.3) 0px 1px 15px 0px"}},[_c('div',{staticClass:"team"},[_c('div',{staticClass:"home"},[_c('div',{staticClass:"team_name home-name allow-user-select",domProps:{"innerHTML":_vm._s(_vm.sortedMatchEventList.tacapt)}}),_vm._v(" "),_c('div',{staticClass:"img-wrap"})]),_vm._v(" "),_c('div',{staticClass:"match_time"},[_c('div',{staticClass:"c-match-process text-center match_time-text vrow a-row"},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"process-name",staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LBL_NOT_STARTED']))]),_vm._v(" "),_c('div',{staticClass:"c-match-date text-center date-wrap"},[(_vm.sortedMatchEventList.rbinfo)?[_c('span',{staticStyle:{"min-width":"70px","font-size":"30px"}},[_vm._v("\n                            "+_vm._s(_vm.sortedMatchEventList.rbinfo.scoa)+" - "+_vm._s(_vm.sortedMatchEventList.rbinfo.scob)),_c('br')])]:_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"min-width":"70px","display":"block"}},[(_vm.sortedMatchEventList.rbinfo && _vm.checkTimer(_vm.sortedMatchEventList) != '')?[(_vm.sortedMatchEventList.sptid==1)?[(_vm.sortedMatchEventList.rbinfo.htst == '0')?[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LBL_HT']))]:(_vm.validateRBTimer(_vm.sortedMatchEventList) == '1')?[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LBL_1HT']))]:(_vm.validateRBTimer(_vm.sortedMatchEventList) == '2')?[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LBL_2HT']))]:[_vm._v(" - ")]]:(_vm.sortedMatchEventList.sptid==2)?[(_vm.sortedMatchEventList.rbinfo.htst == '1')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q1']))]:(_vm.sortedMatchEventList.rbinfo.htst == '2')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q2']))]:(_vm.sortedMatchEventList.rbinfo.htst == '3')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q3']))]:(_vm.sortedMatchEventList.rbinfo.htst == '4')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q4']))]:(_vm.sortedMatchEventList.rbinfo.htst == "5")?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_1HT']))]:(_vm.sortedMatchEventList.rbinfo.htst == '6')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_HT']))]:(_vm.sortedMatchEventList.rbinfo.htst == '7')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_2HT']))]:(_vm.sortedMatchEventList.rbinfo.htst == '8')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_OT']))]:[_vm._v(" - ")]]:_vm._e()]:[(_vm.selectedLang == 2 || _vm.selectedLang == 3)?[_vm._v("\n                              "+_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.sortedMatchEventList.dt),'MM月DD日'))+"\n                            ")]:[_vm._v("\n                              "+_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.sortedMatchEventList.dt),'DD/MM'))+"\n                            ")]]],2),_vm._v(" "),_c('span',{staticStyle:{"min-width":"70px","display":"block"}},[(_vm.sortedMatchEventList.rbinfo && _vm.checkTimer(_vm.sortedMatchEventList) != '')?[(_vm.sortedMatchEventList.sptid==1)?[(_vm.sortedMatchEventList.rbinfo.htst == '0')?void 0:(_vm.validateRBTimer(_vm.sortedMatchEventList) == '1')?[(_vm.sortedMatchEventList.rbinfo.tlsec)?[_vm._v(_vm._s(_vm._f("rb-timer")(_vm.sortedMatchEventList,'mm:ss')))]:[_vm._v("0")],_vm._v("'")]:(_vm.validateRBTimer(_vm.sortedMatchEventList) == '2')?[_vm._v("\n                                "+_vm._s(_vm._f("rb-timer")(_vm.sortedMatchEventList,'mm:ss'))+"\n                              ")]:_vm._e()]:(_vm.sortedMatchEventList.sptid==2)?[(_vm.sortedMatchEventList.rbinfo.htst == '0' || _vm.sortedMatchEventList.rbinfo.htst == '6')?void 0:[_vm._v("\n                                  "+_vm._s(_vm._f("rb-timer")(_vm.sortedMatchEventList))+"\n                              ")]]:_vm._e()]:[_vm._v("\n                            "+_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.sortedMatchEventList.dt),'HH:mm'))+"\n                          ")]],2)],2)])]),_vm._v(" "),_c('div',{staticClass:"away"},[_c('div',{staticClass:"img-wrap"}),_vm._v(" "),_c('div',{staticClass:"team_name away-name allow-user-select",domProps:{"innerHTML":_vm._s(_vm.sortedMatchEventList.tbcapt)}})])])])])]],2),_vm._v(" "),_c('div',{staticClass:"hide-btn",on:{"click":function($event){return _vm.showhide_Banner(false)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HIDE']))])]):_vm._e()]:[_c('div',{staticClass:"c-video-ctrl"},[_c('div',{staticClass:"ctrl-wrap vrow items-center justify-between"},[_c('div',{staticClass:"unfold",class:{'open':_vm.showRightBanner},on:{"click":function($event){return _vm.showhidetvbanner()}}}),_vm._v(" "),_c('div',{staticClass:"col-center vrow full-height"},[_c('div',{staticClass:"wrap_source relative-position line",class:{ active: (Object.keys(_vm.firstEvent).length==0 || _vm.livetvEveid<=0) }},[_c('div',{staticClass:"vicon switch-icon",class:{ active: (Object.keys(_vm.firstEvent).length==0 || _vm.livetvEveid<=0) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.closeTv()}}})]),_vm._v(" "),(_vm.tvIconFlag && _vm.firstEvent.ch>0)?_c('div',{staticClass:"wrap_source relative-position",class:{ active: _vm.livetvEveid>0, 'non-rb': _vm.firstEvent.rbstatus != 1 }},[_c('div',{staticClass:"vicon video-icon",class:{ active: _vm.livetvEveid>0, 'non-rb': _vm.firstEvent.rbstatus != 1 },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.startTv(_vm.firstEvent)}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-right"},[(((_vm.open_RBMarket && _vm.selectedSport.sprtId=='N1') || !_vm.open_RBMarket) && _vm.show_Unfold && !_vm.selectedMatchAllBet && !_vm.simpleSport)?_c('div',{staticClass:"fold-btn",on:{"click":function($event){return _vm.unfoldSc()}}},[_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.FOLD']))]),_vm._v(" "),_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"12px"}})]):_vm._e(),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"vs-team-wrap relative-position"},[_c('div',{staticClass:"absolute-wrap",staticStyle:{"height":"100%"},attrs:{"data-mid":"2265945"}},[(Object.keys(_vm.firstEvent).length>0 && _vm.firstEvent.tacapt !=null && _vm.firstEvent.tbcapt !=null)?_c('div',{staticClass:"item current vs-team-container"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('span',{staticClass:"q-icon icon c-icon sport-img img36",class:_vm.getSportIcon(_vm.firstEvent.sptid),staticStyle:{"width":"18px","height":"18px"}}),_vm._v(" "),_c('div',{staticClass:"team-wrap ellipsis col allow-user-select"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.firstEvent.tacapt)}}),_vm._v(" "),_c('span',{staticClass:"separate"},[_vm._v("v")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.firstEvent.tbcapt)}})]),_vm._v(" "),_c('div',{staticClass:"yb-icon-arrow",staticStyle:{"display":"none"}})]):_vm._e(),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),(_vm.showRightBanner)?_c('div',[_c('div',{staticClass:"wrap-info relative-position"},[_c('div',{staticClass:"c-match-video relative-position",style:((Object.keys(_vm.firstEvent).length>0 && _vm.livetvEveLink!=''  && _vm.livetvEveid>0)? 'position: relative; width: 100%;':'height: 190px;')},[_c('div',{staticClass:"right-icon"},[_c('i',{staticClass:"icon q-icon icon-tips3 c-icon set-color showTip",staticStyle:{"font-size":"14px"},style:({'color': !_vm.showTip ? 'rgb(255, 255, 255)' : 'rgb(255, 255, 255, 0.7)'}),attrs:{"aria-hidden":"true","role":"presentation"},on:{"click":function($event){return _vm.toggleTip()}}}),_vm._v(" "),(_vm.showTip)?[_c('div',{staticClass:"tip-content"},[_c('div',{staticClass:"content-wrap relative-position"},[_c('div',{staticClass:"yb-icon-triangle"}),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LIVE_NOTE']))])])])]:_vm._e()],2),_vm._v(" "),(Object.keys(_vm.firstEvent).length>0 && _vm.livetvEveLink!='' && _vm.livetvEveid>0)?_c('div',{staticClass:"load-data-wrap fit video-loading loading-wrap yb-flex-center relative-position",staticStyle:{"position":"relative","width":"100%","overflow":"hidden","padding-top":"56.25%"},attrs:{"data-v-7eebf246":""}},[(_vm.livetvEveLink=='error')?[_c('div',{staticStyle:{"margin-top":"10% !important","margin-bottom":"-10% !important","border":"none","position":"absolute","top":"0","left":"0","bottom":"0","right":"0","width":"100%","height":"100%","text-align":"center"}},[_c('div',{staticClass:"err_img",staticStyle:{"height":"100px","width":"90px","margin":"auto"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.Stream_Error']))])])]:[(_vm.livetvEveLink!=true)?_c('iframe',{staticStyle:{"border":"none","position":"absolute","top":"0","left":"0","bottom":"0","right":"0","width":"100%","height":"100%"},attrs:{"id":"livetv","src":_vm.livetvEveLink}},[_vm._v(_vm._s(_vm.livetvEveLink))]):_vm._e()]],2):(Object.keys(_vm.firstEvent).length>0)?_c('div',{staticClass:"head-info",class:_vm.getABetSport()},[(_vm.firstEvent.rbinfo)?[_c('div',{staticClass:"right_match_info match-time fit vrow flex-center"},[(_vm.firstEvent.sptid<3)?_c('div',{staticClass:"football-after"},[_c('div',{staticClass:"info-time"},[_c('div',{staticClass:"match-date"},[_c('div',{staticClass:"c-match-process text-center count_down vrow a-row",staticStyle:{"flex-flow":"row"}},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"process-name"},[(_vm.firstEvent.rbinfo)?[(_vm.firstEvent.sptid==1)?[(_vm.firstEvent.rbinfo.htst == '0')?[_vm._v("\n                                  "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LBL_HT'])+"\n                                ")]:(_vm.validateRBTimer(_vm.firstEvent) == '1')?[_vm._v("\n                                  "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LBL_1HT'])+"\n                                ")]:(_vm.validateRBTimer(_vm.firstEvent) == '2')?[_vm._v("\n                                  "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LBL_2HT'])+"\n                                ")]:[_vm._v(" - ")]]:(_vm.firstEvent.sptid==2)?[(_vm.firstEvent.rbinfo.htst == '1')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q1']))]:(_vm.firstEvent.rbinfo.htst == '2')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q2']))]:(_vm.firstEvent.rbinfo.htst == '3')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q3']))]:(_vm.firstEvent.rbinfo.htst == '4')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q4']))]:(_vm.firstEvent.rbinfo.htst == "5")?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_1HT']))]:(_vm.firstEvent.rbinfo.htst == '6')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_HT']))]:(_vm.firstEvent.rbinfo.htst == '7')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_2HT']))]:(_vm.firstEvent.rbinfo.htst == '8')?[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_OT']))]:[_vm._v(" - ")]]:_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"c-match-date text-center date-wrap"},[_c('div',{staticClass:"timer-layout relative-position"},[_c('span',{staticClass:"timer-layout0"},[(_vm.selectedLang == 2 || _vm.selectedLang == 3)?[_vm._v("\n                                  "+_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.firstEvent.dt),'MM月DD日'))+"\n                                ")]:[_vm._v("\n                                  "+_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.firstEvent.dt),'DD/MM'))+"\n                                ")]],2),_vm._v(" "),_c('span',{staticClass:"timer-layout2"},[(_vm.firstEvent.sptid==1)?[(_vm.firstEvent.rbinfo.htst == '0')?void 0:(_vm.validateRBTimer(_vm.firstEvent) == '1')?[(_vm.firstEvent.rbinfo.tlsec)?[_vm._v(_vm._s(_vm._f("rb-timer")(_vm.firstEvent,'mm:ss')))]:[_vm._v("0")],_vm._v("'")]:(_vm.validateRBTimer(_vm.firstEvent) == '2')?[_vm._v("\n                                    "+_vm._s(_vm._f("rb-timer")(_vm.firstEvent,'mm:ss'))+"\n                                  ")]:[_vm._v(" 0 ")]]:(_vm.firstEvent.sptid==2)?[(_vm.firstEvent.rbinfo.htst == '0' || _vm.firstEvent.rbinfo.htst == '6')?void 0:(_vm.firstEvent.rbinfo.evetm)?[_vm._v("\n                                      "+_vm._s(_vm._f("rb-timer")(_vm.firstEvent))+"\n                                  ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),_c('span',{staticStyle:{"display":"none"}})]),_vm._v(" "),(_vm.firstEvent.ha=='N')?_c('span',{staticClass:"icon-neutral q-icon c-icon"},[_c('span',{staticClass:"path1"}),_vm._v(" "),_c('span',{staticClass:"path2"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"time-node"},[(_vm.firstEvent.sptid==1 && _vm.displayConnerBooking('c',_vm.firstEvent,'a')!='-')?_c('div',{staticClass:"result-icon-wrap"},[_c('div',{staticClass:"result-icon rs_jiao_quan",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_CORNERCORNER']}})]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==1 && _vm.displayConnerBooking('b',_vm.firstEvent,'a')!='-')?_c('div',{staticClass:"result-icon-wrap"},[_c('div',{staticClass:"result-icon yellow_card",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_YELLOWCARD']}})]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==1)?_c('div',{staticClass:"result-icon-wrap"},[_c('div',{staticClass:"result-icon red_card",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_REDCARD']}})]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==1)?_c('div',{staticClass:"result-icon-wrap"},[_c('div',{staticClass:"result-icon rs_jin_shang",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_1HT']}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"result-icon-wrap"},[_c('div',{staticClass:"result-icon rs_jin_quan",attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_FT']}})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"info-both"},[_c('div',{staticClass:"both-home"},[_c('div',{staticClass:"wrap-logo"},[_c('span',{staticClass:"ellipsis allow-user-select",staticStyle:{"font-weight":"400"},domProps:{"innerHTML":_vm._s(_vm.firstEvent.tacapt)}})]),_vm._v(" "),_c('div',{staticClass:"info-data"},[(_vm.firstEvent.sptid==1 && _vm.displayConnerBooking('c',_vm.firstEvent,'a')!='-')?_c('span',[_vm._v(_vm._s(_vm.displayConnerBooking('c',_vm.firstEvent,'a')))]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==1 && _vm.displayConnerBooking('b',_vm.firstEvent,'a')!='-')?_c('span',[_vm._v(_vm._s(_vm.displayConnerBooking('b',_vm.firstEvent,'a')))]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==1)?_c('span',[_vm._v(_vm._s(_vm.firstEvent.rbinfo.rca))]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==1)?_c('span',[(_vm.firstEvent.rbinfo.htscoa!='')?[_vm._v("\n                              "+_vm._s(_vm.firstEvent.rbinfo.htscoa)+"\n                            ")]:[_vm._v("\n                              "+_vm._s(_vm.firstEvent.rbinfo.scoa)+"\n                            ")]],2):_vm._e(),_vm._v(" "),_c('span',{staticClass:"mmp-active"},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.scoa))]),_vm._v(" "),_c('span',{staticStyle:{"display":"none"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"none"}})])]),_vm._v(" "),_c('div',{staticClass:"both-away"},[_c('div',{staticClass:"wrap-logo"},[_c('span',{staticClass:"ellipsis allow-user-select",staticStyle:{"font-weight":"400"},domProps:{"innerHTML":_vm._s(_vm.firstEvent.tbcapt)}})]),_vm._v(" "),_c('div',{staticClass:"info-data"},[(_vm.firstEvent.sptid==1 && _vm.displayConnerBooking('c',_vm.firstEvent,'a')!='-')?_c('span',[_vm._v(_vm._s(_vm.displayConnerBooking('c',_vm.firstEvent,'b')))]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==1 && _vm.displayConnerBooking('b',_vm.firstEvent,'a')!='-')?_c('span',[_vm._v(_vm._s(_vm.displayConnerBooking('b',_vm.firstEvent,'b')))]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==1)?_c('span',[_vm._v(_vm._s(_vm.firstEvent.rbinfo.rcb))]):_vm._e(),_vm._v(" "),(_vm.firstEvent.sptid==1)?_c('span',[(_vm.firstEvent.rbinfo.htscob!='')?[_vm._v("\n                              "+_vm._s(_vm.firstEvent.rbinfo.htscob)+"\n                            ")]:[_vm._v("\n                              "+_vm._s(_vm.firstEvent.rbinfo.scob)+"\n                            ")]],2):_vm._e(),_vm._v(" "),_c('span',{staticClass:"mmp-active"},[_vm._v(_vm._s(_vm.firstEvent.rbinfo.scob))]),_vm._v(" "),_c('span',{staticStyle:{"display":"none"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"none"}})])])])]):_c('osAllBetHeader',{attrs:{"sportColLength":_vm.sportColLength}})],1)]:[_c('div',{staticClass:"right_match_info match-time fit vrow flex-center"},[_c('div',{staticClass:"before"},[_c('div',{staticClass:"content",staticStyle:{"box-shadow":"rgba(0, 0, 0, 0.3) 0px 1px 15px 0px"}},[_c('div',{staticClass:"team"},[_c('div',{staticClass:"home"},[_c('div',{staticClass:"team_name home-name allow-user-select",domProps:{"innerHTML":_vm._s(_vm.firstEvent.tacapt)}}),_vm._v(" "),_c('div',{staticClass:"img-wrap"})]),_vm._v(" "),_c('div',{staticClass:"match_time"},[_c('div',{staticClass:"c-match-process text-center match_time-text vrow a-row"},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"process-name",staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LBL_NOT_STARTED']))]),_vm._v(" "),_c('div',{staticClass:"c-match-date text-center date-wrap"},[_c('span',{staticStyle:{"min-width":"70px","display":"block"}},[(_vm.selectedLang == 2 || _vm.selectedLang == 3)?[_vm._v("\n                                  "+_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.firstEvent.dt),'MM月DD日'))+"\n                                ")]:[_vm._v("\n                                  "+_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.firstEvent.dt),'DD/MM'))+"\n                                ")]],2),_vm._v(" "),_c('span',{staticStyle:{"min-width":"60px","display":"block"}},[_vm._v("\n                                "+_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.firstEvent.dt),'HH:mm'))+"\n                              ")])]),_vm._v(" "),(_vm.firstEvent.ha=='N')?_c('span',{staticClass:"icon-neutral q-icon c-icon"},[_c('span',{staticClass:"path1"}),_vm._v(" "),_c('span',{staticClass:"path2"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"away"},[_c('div',{staticClass:"img-wrap"}),_vm._v(" "),_c('div',{staticClass:"team_name away-name allow-user-select",domProps:{"innerHTML":_vm._s(_vm.firstEvent.tbcapt)}})])])])])])]],2):_c('div',{staticClass:"head-info"},[_c('div',{staticClass:"img-loading custom-format-img-loading",staticStyle:{"display":""},attrs:{"data-v-7eebf246":""}}),_vm._v(" "),_c('div',{staticClass:"loading-text",attrs:{"data-v-7eebf246":""}},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.LOADING']))])])])])]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"scroll-fixed-header wrap-tabs"},[_c('div',{staticClass:"tabs-panel relative-position"},[_c('div',{ref:"tabWrapList",staticClass:"tab-wrap fit relative-position",staticStyle:{"touch-action":"none"},attrs:{"id":'tab-wrap-list'+_vm.mode},on:{"mousedown":function($event){return _vm.startDragHandler($event)},"mousemove":function($event){return _vm.doDragHandler($event)}}},[_c('div',{ref:"itemWrapList",staticClass:"item-wrap relative-position",style:(_vm.getitemWrapStyle()),attrs:{"id":"item-wrap-list"}},[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.all.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.all)}}},[_vm._v("\n              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ALLBET'])+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.hot.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.hot)}}},[_vm._v("\n              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOT'])+"\n            ")]),_vm._v(" "),(_vm.selectedBettype.tmpltId == '1')?[(_vm.checkBTExist('hdpou'))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.hdpou.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.hdpou)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HDP_OU'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkBTExist('goals'))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.goals.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.goals)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_GOALS'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkBTExist('cs'))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.cs.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.cs)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CS'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkFTExist())?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.ft.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.ft)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_FT'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkHTExist())?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.ht.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.ht)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkSPExist())?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.special.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.special)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SPECIALS'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkBTExist('other'))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.others.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.others)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OTHERS'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkSpecialExist(_vm.betTab.booking.key))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.booking.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.booking)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_BOOKING'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkSpecialExist(_vm.betTab.corner.key))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.corner.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.corner)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_CORNER'])+"\n                ")])]:_vm._e()]:(_vm.selectedBettype.tmpltId == '8')?[(_vm.selectedBettype.sprtId == 'G1')?void 0:(_vm.otherSport1.includes(_vm.selectedBettype.sprtId))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.sethdp.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.sethdp)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SET'])+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.gamehdp.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.gamehdp)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_GAME'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkInningsExist('inning') && _vm.selectedBettype.sprtId == 'N23')?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.innings.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.innings)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_INNINGS'])+"\n                ")])]:_vm._e(),_vm._v(" "),(_vm.checkTeamExist('team') && _vm.selectedBettype.sprtId == 'N23')?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selected_Tab == _vm.betTab.team.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.team)}}},[_vm._v("\n                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_TEAMS'])+"\n                ")])]:(_vm.selectedBettype.sprtId == 'N24')?void 0:_vm._e()]:_vm._e()],2),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"right-icons",on:{"click":function($event){return _vm.foldopenAB()}}},[(_vm.mode=='ab')?_c('i',{staticClass:"q-icon c-icon set-color",class:{ 'icon-hide': _vm.foldopenAllBet, 'icon-open': !_vm.foldopenAllBet },staticStyle:{"color":"rgb(90, 96, 116)","font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation","title":_vm.foldopenAllBet?_vm.lang.sportTableLang['SPORT_TABLE.FOLD']:_vm.lang.sportTableLang['SPORT_TABLE.OPEN']}}):_vm._e(),_vm._v(" "),(_vm.mode!='ab')?_c('i',{staticClass:"q-icon c-icon set-color",class:{ 'icon-hide': _vm.foldopenFirstEvent, 'icon-open': !_vm.foldopenFirstEvent },staticStyle:{"color":"rgb(90, 96, 116)","font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation","title":_vm.foldopenFirstEvent?_vm.lang.sportTableLang['SPORT_TABLE.FOLD']:_vm.lang.sportTableLang['SPORT_TABLE.OPEN']}}):_vm._e()])])])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-refresh fit yb-flex-center cursor-pointer refresh-btn"},[_c('div',{staticClass:"icon-wrap",attrs:{"id":"tblRefresh"}},[_c('i',{staticClass:"q-icon icon-tbl_refresh c-icon",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true","role":"presentation"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('i',{staticClass:"q-icon icon-big c-icon set-color",staticStyle:{"color":"rgb(90, 96, 116)","font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-area rule-scroll-area q-scrollarea"},[_c('div',{staticClass:"q-scrollarea__container scroll relative-position fit hide-scrollbar"},[_c('div',{staticClass:"q-scrollarea__content absolute"})]),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__bar q-scrollarea__bar--v absolute-right q-scrollarea__bar--invisible",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__bar q-scrollarea__bar--h absolute-bottom q-scrollarea__bar--invisible",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom q-scrollarea__thumb--invisible",staticStyle:{"left":"0px","width":"416px"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-icon-wrap",staticStyle:{"display":"none"}},[_c('div',{staticClass:"result-icon add_time"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-icon-wrap",staticStyle:{"display":"none"}},[_c('i',{staticClass:"result-icon q-icon icon-jia-dian c-icon",staticStyle:{"font-size":"15px"},attrs:{"aria-hidden":"true","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-btn btn",staticStyle:{"display":"none"}},[_c('div',{staticClass:"yb-icon-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-btn btn",staticStyle:{"display":"none"}},[_c('div',{staticClass:"yb-icon-arrow"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fit v-scrollarea q-scrollarea"},[_c('div',{staticClass:"q-scrollarea__container scroll relative-position fit hide-scrollbar",attrs:{"id":'AllBet'+_vm.mode}},[_c('div',{staticClass:"q-scrollarea__content absolute"},[_c('div',{staticClass:"middle-content",staticStyle:{"padding-bottom":"0px"},style:(_vm.mContentPadding)},[_c('div',{staticClass:"scroll-inner-wrap fit",staticStyle:{"overflow-y":"auto"},style:({ 'height': _vm.heightPX + 'px ' })},[_c('div',{staticClass:"col wrap-scroll"},[_c('div',{staticClass:"column fit"},[_c('div',{staticClass:"wrap-handicap relative-position details-handicap",attrs:{"screen":"match-list"}},[_c('div',{staticClass:"template-handicap",attrs:{"id":"_handicap_list_wrap"}},[_c('div',{staticClass:"details_data"},[_c('div',{staticClass:"group-flex",attrs:{"id":"_handicap_list"}},[(_vm.testshow)?_c('allBetComponent',{attrs:{"betTab":_vm.betTab,"mode":_vm.mode}}):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('div',{staticStyle:{"height":"152px"}},[_c('div',{staticClass:"go-top to-top"},[_c('div',{staticClass:"go-top-btn",on:{"click":function($event){return _vm.backtoTop()}}},[_c('i',{staticClass:"q-icon icon-go_top c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"vmsg"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.BACK_TOP']))])])])])]),_vm._v(" "),_c('div',{staticClass:"null-bg",staticStyle:{"display":"none"}})])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__bar q-scrollarea__bar--v absolute-right",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__bar q-scrollarea__bar--h absolute-bottom q-scrollarea__bar--invisible",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom q-scrollarea__thumb--invisible",staticStyle:{"right":"-10.5px","left":"0px","width":"902px","cursor":"pointer"},attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details relative-position"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wrap-handicap v-scroll-area-bar"},[_c('div',{staticClass:"screen"},[_c('div',{staticClass:"v-scroll-area fit vrow relative-position"},[_c('div',{staticClass:"content-wrap fit"},[_c('allBetHeader',{attrs:{"mode":'ab'}}),_vm._v(" "),_c('allBetContent',{attrs:{"mode":'ab'}}),_vm._v(" "),_c('div',{staticClass:"scroll-footer",staticStyle:{"bottom":"0px"}})],1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allBetReloading),expression:"allBetReloading"}],staticClass:"refresh-mask absolute-full yb-flex-center",staticStyle:{"top":"36px"}},[_c('div',{staticClass:"img-loading custom-format-img-loading"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-data-wrap col is-detail details_data_load",staticStyle:{"margin-top":"266px","display":"none"}},[_c('div',{staticClass:"fit"}),_vm._v(" "),_c('div',{staticClass:"column yb-flex-center empty"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportTemplate_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8563c44e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportTemplate_vue__ = __webpack_require__(478);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8563c44e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inPlayCommon_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d8d79bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inPlayCommon_vue__ = __webpack_require__(443);
function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inPlayCommon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d8d79bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inPlayCommon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-match-process text-center column"},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"process-name",style:(_vm.timerDisplay(_vm.event))},[(_vm.event.rbinfo && _vm.event.sptid<=2)?[(_vm.event.sptid==1)?[(_vm.event.rbinfo.htst == '0')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_HT']))])]:(_vm.validateRBTimer(_vm.event) == '1' || (_vm.event.rbinfo.tlsec == -1 && _vm.event.rbinfo.htst == '1'))?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_1HT']))])]:(_vm.validateRBTimer(_vm.event) == '2' || (_vm.event.rbinfo.tlsec == -1 && _vm.event.rbinfo.htst == '2'))?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_2HT']))])]:[_vm._v(" - ")]]:(_vm.event.sptid==2)?[(_vm.event.rbinfo.htst == '1')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q1']))])]:(_vm.event.rbinfo.htst == '2')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q2']))])]:(_vm.event.rbinfo.htst == '3')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q3']))])]:(_vm.event.rbinfo.htst == '4')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_Q4']))])]:(_vm.event.rbinfo.htst == '5')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_1HT']))])]:(_vm.event.rbinfo.htst == '6')?[_c('span',{staticClass:"rb_timeHT"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_HT']))])]:(_vm.event.rbinfo.htst == '7')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_2HT']))])]:(_vm.event.rbinfo.htst == '8')?[_c('span',{staticClass:"timeInfo"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_OT']))])]:[_vm._v(" - ")]]:_vm._e()]:(_vm.event.rbinfo && _vm.event.sptid>2)?[_c('div',{staticClass:"time-content column",attrs:{"data-v-45641ae6":""}},[_c('div',{staticClass:"process-name",attrs:{"data-v-45641ae6":""}},[(_vm.event.sptid==3 || _vm.event.sptid==12 || _vm.event.sptid==21)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.event.rbinfo.st=='NL'? _vm.sportTableLang.table['SPORT_TABLE.LBL_SET_S1'] : _vm.sportTableLang.table['SPORT_TABLE.LBL_SET_'+_vm.event.rbinfo.st]))]):(_vm.event.sptid==23)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.event.rbinfo.st=='NL'?_vm.sportTableLang.table['SPORT_TABLE.LIVE']:_vm.sportTableLang.table['SPORT_TABLE.LBL_INN_'+_vm.event.rbinfo.st]))]):(_vm.event.sptid==14)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.event.rbinfo.st=='NL'?_vm.sportTableLang.table['SPORT_TABLE.LIVE']:_vm.sportTableLang.table['SPORT_TABLE.LBL_PERIOD_'+_vm.event.rbinfo.st]))]):(_vm.event.sptid==20)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.event.rbinfo.st=='NL'?_vm.sportTableLang.table['SPORT_TABLE.LIVE']:_vm.sportTableLang.table['SPORT_TABLE.LBL_GAME_'+_vm.event.rbinfo.st]))]):(_vm.event.sptid==15)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.event.rbinfo.st=='NL'?_vm.sportTableLang.table['SPORT_TABLE.LIVE']:_vm.sportTableLang.table['SPORT_TABLE.LBL_FRAME_'+_vm.event.rbinfo.st]))]):(_vm.event.sptid==13)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(_vm._s(_vm.event.rbinfo.st=='NL'?_vm.sportTableLang.table['SPORT_TABLE.LIVE']:_vm.sportTableLang.table['SPORT_TABLE.LBL_Q_'+_vm.event.rbinfo.st]))]):(_vm.event.sptid==19)?_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[(_vm.event.rbinfo.st=='NL')?[_vm._v("\n                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LIVE'])+"\n            ")]:(_vm.event.rbinfo.st=='H1')?[_vm._v("\n                "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_1HT'])+"\n            ")]:(_vm.event.rbinfo.st=='H2')?[_vm._v("\n                "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_2HT'])+"\n            ")]:_vm._e()],2):_c('div',{staticClass:"process_name",attrs:{"data-v-45641ae6":""}},[_vm._v(" "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LIVE']))])])])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"c-match-date text-center date-wrap"},[(_vm.event.rbinfo && _vm.checkTimer(_vm.event) != '')?[_c('div',{staticClass:"timer-layout relative-position"},[(_vm.event.sptid==1)?[(_vm.event.rbinfo.htst == '0')?void 0:(_vm.validateRBTimer(_vm.event) == '1')?[(_vm.event.rbinfo.tlsec)?[_vm._v(_vm._s(_vm._f("rb-timer")(_vm.event,'mm:ss')))]:[_vm._v("0")],_vm._v("'")]:(_vm.validateRBTimer(_vm.event) == '2')?[_vm._v("\n            "+_vm._s(_vm._f("rb-timer")(_vm.event,'mm:ss'))+"\n          ")]:[_vm._v(" 0 ")]]:(_vm.event.sptid==2)?[(_vm.event.rbinfo.htst == '0' || _vm.event.rbinfo.htst == '6')?void 0:[(_vm.event.rbinfo.evetm)?[_vm._v(_vm._s(_vm._f("rb-timer")(_vm.event)))]:_vm._e()]]:_vm._e()],2)]:(!_vm.event.rbinfo)?[(_vm.checkStart(_vm.event.dt)==0 && !_vm.specialEvent)?[_c('span',{class:{'timer-layout2':_vm.simpleSport==null},staticStyle:{"min-width":"65px"}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.COMMING_SOON']))])]:(_vm.checkStart(_vm.event.dt)<60 && !_vm.specialEvent)?[_c('span',{class:{'timer-layout2':_vm.simpleSport==null},staticStyle:{"min-width":"65px"}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.START_IN'].replace('{minute}',_vm.checkStart(_vm.event.dt)))+" ")])]:[(_vm.selectedLang == 2 || _vm.selectedLang == 3)?[_c('span',{staticStyle:{"min-width":"65px"}},[_vm._v(_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.event.dt),'MM月DD日'))),_c('br')])]:[_c('span',{staticStyle:{"min-width":"65px"}},[_vm._v(_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.event.dt),'DD/MM'))),_c('br')])],_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("date")(_vm.matchDateCheck(_vm.event.dt),'HH:mm')))])]]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-col",style:(_vm.subMatchKey == 0 ? { 'height': '105px !important', 'width': _vm.widthL + 'px !important'  } : { 'width': _vm.widthL + 'px !important' })},[(_vm.subMatchKey == null || _vm.subMatchKey == 0)?[_c('div',{staticClass:"basic-wrap"},[_c('div',{staticClass:"row-item team-item",on:{"click":function($event){return _vm.enterAllBet(_vm.event)}}},[_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"vrow no-wrap absolute-full"},[_c('div',{staticClass:"team-name home ellipsis allow-user-select",class:_vm.teamColor(_vm.event, 'A', _vm.plytyp),attrs:{"title":_vm.getTeamCapt(_vm.event.tacapt, _vm.selMarket)},domProps:{"innerHTML":_vm._s(_vm.getTeamCapt(_vm.event.tacapt, _vm.selMarket))}}),_vm._v(" "),_c('span',{staticClass:"red-ball",style:({ display : (_vm.mode !='morebet' && _vm.event.rbinfo && _vm.event.rbinfo.rca>0)? 'block':'none' })},[(_vm.mode !='morebet' && (_vm.event.rbinfo && _vm.event.rbinfo.rca>0))?[_vm._v("\n                "+_vm._s(_vm.event.rbinfo.rca)+"\n              ")]:_vm._e()],2)])]),_vm._v(" "),((_vm.event.sptid==3 || _vm.event.sptid == 12 || _vm.event.sptid == 21) && _vm.event.rbinfo && _vm.event.rbinfo.score['PT'])?_c('div',{staticClass:"score_game"},[_vm._v("\n          "+_vm._s(_vm.getScoreSet(_vm.event, 'A'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"score",class:(_vm.event.sptid==7)?'spwidth':''},[(_vm.mode !='morebet' && (_vm.event.rbinfo && _vm.event.rbinfo.scoa>=0) && (_vm.event.sptid == 1 || _vm.event.sptid == 2))?[_vm._v("\n            "+_vm._s(_vm.event.rbinfo.scoa)+"\n          ")]:(_vm.mode =='morebet' && (['booking','corner'].includes(_vm.selMarket)) && _vm.event.sp_rbinfo && _vm.event.sp_rbinfo[_vm.specialEveId])?[_vm._v("\n            "+_vm._s(_vm.event.sp_rbinfo[_vm.specialEveId].scoa)+"\n          ")]:(_vm.event.sptid > 2 && _vm.event.rbinfo)?[(_vm.event.sptid == 13)?[_vm._v("\n              "+_vm._s(_vm.getScoreSet(_vm.event, 'A', true))+"  \n            ")]:(_vm.event.sptid == 3 || _vm.event.sptid == 12 || _vm.event.sptid == 21)?[(_vm.event.rbinfo && _vm.event.rbinfo.score[_vm.event.rbinfo.st])?[_vm._v("\n                "+_vm._s(_vm.event.rbinfo.score[_vm.event.rbinfo.st]['scoa'])+"\n              ")]:_vm._e()]:[_vm._v("\n              "+_vm._s(_vm.getScoreSet(_vm.event, 'A'))+"\n            ")]]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"row-item team-item",on:{"click":function($event){return _vm.enterAllBet(_vm.event)}}},[_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"vrow no-wrap absolute-full"},[_c('div',{staticClass:"team-name away ellipsis allow-user-select",class:_vm.teamColor(_vm.event, 'B', _vm.plytyp),attrs:{"title":_vm.getTeamCapt(_vm.event.tbcapt, _vm.selMarket)},domProps:{"innerHTML":_vm._s(_vm.getTeamCapt(_vm.event.tbcapt, _vm.selMarket))}}),_vm._v(" "),_c('span',{staticClass:"red-ball",style:({ display : (_vm.mode !='morebet' && _vm.event.rbinfo && _vm.event.rbinfo.rcb>0) ? 'block':'none' })},[(_vm.mode !='morebet' && (_vm.event.rbinfo && _vm.event.rbinfo.rcb>0))?[_vm._v("\n                "+_vm._s(_vm.event.rbinfo.rcb)+"\n              ")]:_vm._e()],2)])]),_vm._v(" "),((_vm.event.sptid==3  || _vm.event.sptid == 12 || _vm.event.sptid == 21) &&  _vm.event.rbinfo && _vm.event.rbinfo.score['PT'])?_c('div',{staticClass:"score_game"},[_vm._v("\n          "+_vm._s(_vm.getScoreSet(_vm.event, 'B'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"score",class:(_vm.event.sptid==7)?'spwidth':''},[(_vm.mode !='morebet' && (_vm.event.rbinfo && _vm.event.rbinfo.scob>=0) && (_vm.event.sptid == 1 || _vm.event.sptid == 2))?[_vm._v("\n            "+_vm._s(_vm.event.rbinfo.scob)+"\n          ")]:(_vm.mode =='morebet' && (['booking','corner'].includes(_vm.selMarket)) && _vm.event.sp_rbinfo && _vm.event.sp_rbinfo[_vm.specialEveId])?[_vm._v("\n            "+_vm._s(_vm.event.sp_rbinfo[_vm.specialEveId].scob)+"\n          ")]:(_vm.event.sptid > 2 && _vm.event.rbinfo)?[(_vm.event.sptid == 13)?[_vm._v("\n              "+_vm._s(_vm.getScoreSet(_vm.event, 'B', true))+"  \n            ")]:(_vm.event.sptid == 3 || _vm.event.sptid == 12 || _vm.event.sptid == 21)?[(_vm.event.rbinfo && _vm.event.rbinfo.score[_vm.event.rbinfo.st])?[_vm._v("\n                "+_vm._s(_vm.event.rbinfo.score[_vm.event.rbinfo.st]['scob'])+"\n              ")]:_vm._e()]:[_vm._v("\n              "+_vm._s(_vm.getScoreSet(_vm.event, 'B'))+"\n            ")]]:_vm._e()],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selMarket == null),expression:"selMarket == null"}],staticClass:"row-item match-icon"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"more-info flex"},[_c('div',{staticClass:"neutral-wrap"},[(_vm.event.ha=='N')?_c('span',{staticClass:"icon-neutral q-icon c-icon"},[_c('span',{staticClass:"path1"}),_vm._v(" "),_c('span',{staticClass:"path2"})]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"yb-flex-center yb-hover-bg m-star-wrap-match",on:{"click":function($event){return _vm.favourite(_vm.event, _vm.isRB)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{'active': _vm.event.isFavourite},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"play-count-wrap vrow no-wrap"},[_c('span',{staticClass:"play-count",on:{"click":function($event){return _vm.enterAllBet(_vm.event)}}},[_vm._v("+"+_vm._s(_vm.countAllBet(_vm.event, _vm.selectedShow)))]),_vm._v(" "),_vm._m(0)])])])])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"yb-flex-center"},[_c('div',{staticClass:"yb-icon-arrow"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details relative-position"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wrap-handicap v-scroll-area-bar"},[_c('div',{staticClass:"screen"},[_c('div',{staticClass:"v-scroll-area fit vrow relative-position"},[_c('div',{staticClass:"content-wrap fit"},[_c('div',{staticClass:"scroll-header absolute"},[_c('div',{staticClass:"wrap-title"},[_c('div',{staticClass:"group-back cursor-pointer",on:{"click":function($event){return _vm.backToMain()}}},[_c('i',{staticClass:"back q-icon icon-back c-icon set-color",staticStyle:{"color":"rgb(171, 186, 200)"},attrs:{"aria-hidden":"true","role":"presentation"}})]),_vm._v(" "),_c('div',{staticClass:"title ellipsis allow-user-select",domProps:{"innerHTML":_vm._s(_vm.sortedMatchEventList.lgecapt)}}),_vm._v(" "),_c('div',{staticClass:"right-icon"},[(!_vm.showhideBanner)?_c('span',{on:{"click":function($event){return _vm.showhide_Banner(true)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SHOWSCRBOARD']))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"refresh"},[_c('div',{staticClass:"c-refresh fit yb-flex-center cursor-pointer"},[_c('div',{staticClass:"icon-wrap",on:{"click":function($event){return _vm.refreshTbl(_vm.token.arr_5)}}},[_vm._m(1)])])])])]),_vm._v(" "),(_vm.showhideBanner)?_c('div',{ref:"testa",staticClass:"head-info relative-position esports-head-info-1",class:_vm.getABetSport()},[_c('div',{staticClass:"right_match_info info-upd full-width vrow justify-center"},[_c('div',{staticClass:"before"},[_c('div',{staticClass:"content",staticStyle:{"box-shadow":"rgba(0, 0, 0, 0.3) 0px 1px 15px 0px"}},[_c('div',{staticClass:"team"},[_c('div',{staticClass:"home"},[_c('div',{staticClass:"team_name home-name allow-user-select",domProps:{"innerHTML":_vm._s(_vm.sortedMatchEventList.tacapt)}}),_vm._v(" "),_c('div',{staticClass:"img-wrap"})]),_vm._v(" "),_c('div',{staticClass:"match_time"},[_c('div',{staticClass:"c-match-process text-center match_time-text vrow a-row"},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"process-name",staticStyle:{"display":"none"}},[_vm._v("未开赛")]),_vm._v(" "),_c('div',{staticClass:"c-match-date text-center date-wrap"},[(_vm.sortedMatchEventList.rbinfo)?[_c('span',{staticStyle:{"min-width":"60px","font-size":"30px"}},[_vm._v("\n                                "+_vm._s(_vm.sortedMatchEventList.rbinfo.scoa)+" - "+_vm._s(_vm.sortedMatchEventList.rbinfo.scob)),_c('br')])]:_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"min-width":"60px"}},[(_vm.sortedMatchEventList.rbinfo && _vm.checkTimer(_vm.sortedMatchEventList) != '')?[(_vm.sortedMatchEventList.rbinfo.htst == '0')?[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_HT'])+"\n                                ")]:(_vm.validateRBTimer(_vm.sortedMatchEventList) == '1')?[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_1HT'])+"\n                                ")]:(_vm.validateRBTimer(_vm.sortedMatchEventList) == '2')?[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_2HT'])+"\n                                ")]:[_vm._v(" - ")]]:[(_vm.selectedLang == 2 || _vm.selectedLang == 3)?[_vm._v("\n                                  "+_vm._s(_vm.moment(_vm.sortedMatchEventList.dt).locale('cn').format("MMM Do"))+" \n                                ")]:[_vm._v("\n                                  "+_vm._s(_vm._f("date")(_vm.sortedMatchEventList.dt,'DD/MM'))+"\n                                ")],_vm._v(" "),_c('br')],_vm._v(" "),(_vm.sortedMatchEventList.rbinfo && _vm.checkTimer(_vm.sortedMatchEventList) != '')?[(_vm.sortedMatchEventList.rbinfo.htst == '0')?void 0:(_vm.validateRBTimer(_vm.sortedMatchEventList) == '1')?[(_vm.sortedMatchEventList.rbinfo.tlsec)?[_vm._v(_vm._s(_vm._f("rb-timer")(_vm.sortedMatchEventList,'mm:ss')))]:[_vm._v("0")],_vm._v("'")]:(_vm.validateRBTimer(_vm.sortedMatchEventList) == '2')?[_vm._v("\n                                  "+_vm._s(_vm._f("rb-timer")(_vm.sortedMatchEventList,'mm:ss'))+"\n                                ")]:_vm._e()]:[_vm._v("\n                                "+_vm._s(_vm._f("date")(_vm.sortedMatchEventList.dt,'HH:mm'))+"\n                              ")]],2),_vm._v(" "),_c('span',[(_vm.sortedMatchEventList.rbinfo && _vm.checkTimer(_vm.sortedMatchEventList) != '')?void 0:[_vm._v("\n                                "+_vm._s(_vm._f("date")(_vm.sortedMatchEventList.dt,'HH:mm'))+"\n                              ")]],2)],2)])]),_vm._v(" "),_c('div',{staticClass:"away"},[_c('div',{staticClass:"img-wrap"}),_vm._v(" "),_c('div',{staticClass:"team_name away-name allow-user-select",domProps:{"innerHTML":_vm._s(_vm.sortedMatchEventList.tbcapt)}})])])])])]),_vm._v(" "),_c('div',{staticClass:"hide-btn",on:{"click":function($event){return _vm.showhide_Banner(false)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HIDE']))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"scroll-fixed-header wrap-tabs"},[_c('div',{staticClass:"tabs-panel relative-position"},[_c('div',{staticClass:"tab-wrap fit relative-position"},[_c('div',{staticClass:"item-wrap relative-position",staticStyle:{"left":"0px"}},[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.hot.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.hot)}}},[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOT'])+"\n                    ")]),_vm._v(" "),(_vm.selectedBettype.tmpltId == '1')?[(_vm.checkBTExist('hdpou'))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.hdpou.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.hdpou)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HDP_OU'])+"\n                        ")])]:_vm._e(),_vm._v(" "),(_vm.checkBTExist('goals'))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.goals.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.goals)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_GOALS'])+"\n                        ")])]:_vm._e(),_vm._v(" "),(_vm.checkBTExist('cs'))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.cs.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.cs)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CS'])+"\n                        ")])]:_vm._e(),_vm._v(" "),(_vm.sortedMatchEventList.od[_vm.firstHtPlyType] && (_vm.sortedMatchEventList.sptid == 1 || _vm.sortedMatchEventList.sptid == 13))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.ht.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.ht)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT'])+"\n                        ")])]:_vm._e(),_vm._v(" "),(_vm.sortedMatchEventList.sp)?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.special.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.special)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SPECIALS'])+"\n                        ")])]:_vm._e(),_vm._v(" "),(_vm.checkBTExist('other'))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.others.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.other)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OTHERS'])+"\n                        ")])]:_vm._e()]:(_vm.selectedBettype.tmpltId == '8')?[(_vm.selectedBettype.sprtId == 'G1')?void 0:(_vm.otherSport1.includes(_vm.selectedBettype.sprtId))?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.sethdp.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.sethdp)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SET'])+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.gamehdp.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.gamehdp)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_GAME'])+"\n                        ")])]:(_vm.selectedBettype.sprtId == 'N24')?void 0:_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.all.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.all)}}},[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ALLBET'])+"\n                    ")])],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"right-icons",on:{"click":function($event){return _vm.foldopenAB()}}},[_c('i',{staticClass:"q-icon c-icon set-color",class:{ 'icon-hide': _vm.foldopenAllBet, 'icon-open': !_vm.foldopenAllBet },staticStyle:{"color":"rgb(90, 96, 116)","font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation","data-title":"dadw"}})])])])]),_vm._v(" "),_c('div',{staticClass:"fit v-scrollarea q-scrollarea"},[_c('div',{staticClass:"q-scrollarea__container scroll relative-position fit hide-scrollbar"},[_c('div',{staticClass:"q-scrollarea__content absolute"},[_c('div',{staticClass:"middle-content",staticStyle:{"padding-bottom":"0px"},style:(_vm.mContentPadding)},[_c('div',{staticClass:"scroll-inner-wrap fit",staticStyle:{"height":"572px !important","overflow":"auto"}},[_c('div',{staticClass:"col wrap-scroll"},[_c('div',{staticClass:"column fit"},[_c('div',{staticClass:"wrap-handicap relative-position details-handicap",attrs:{"screen":"match-list"}},[_c('div',{staticClass:"template-handicap",attrs:{"id":"_handicap_list_wrap"}},[_c('div',{staticClass:"details_data"},[_c('div',{staticClass:"group-flex",attrs:{"id":"_handicap_list"}},[_c('allBetComponent',{attrs:{"selTab":_vm.selectedBetTab,"betTab":_vm.betTab}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('div',{staticStyle:{"height":"152px"}},[_c('div',{staticClass:"go-top to-top"},[_c('div',{staticClass:"go-top-btn",on:{"click":function($event){return _vm.backtoTop()}}},[_c('i',{staticClass:"q-icon icon-go_top c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"vmsg"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.BACK_TOP']))])])])])]),_vm._v(" "),_c('div',{staticClass:"null-bg",staticStyle:{"display":"none"}})])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__bar q-scrollarea__bar--v absolute-right",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__bar q-scrollarea__bar--h absolute-bottom q-scrollarea__bar--invisible",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__thumb q-scrollarea__thumb--v absolute-right",staticStyle:{"right":"-10.5px","top":"0px","height":"45px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom q-scrollarea__thumb--invisible",staticStyle:{"right":"-10.5px","left":"0px","width":"902px"},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"scroll-footer",staticStyle:{"bottom":"0px"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allBetReloading),expression:"allBetReloading"}],staticClass:"refresh-mask absolute-full yb-flex-center",staticStyle:{"top":"36px"}},[_c('div',{staticClass:"img-loading custom-format-img-loading"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-data-wrap col is-detail details_data_load",staticStyle:{"margin-top":"266px","display":"none"}},[_c('div',{staticClass:"fit"}),_vm._v(" "),_c('div',{staticClass:"column yb-flex-center empty"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-balance_refresh"},[_c('span',{staticClass:"path1"}),_vm._v(" "),_c('span',{staticClass:"path2",staticStyle:{"right":"27.5px","position":"absolute"}}),_vm._v(" "),_c('span',{staticClass:"path3",staticStyle:{"right":"27.5px","position":"absolute"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-btn btn",staticStyle:{"display":"none"}},[_c('div',{staticClass:"yb-icon-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-btn btn",staticStyle:{"display":"none"}},[_c('div',{staticClass:"yb-icon-arrow"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(0);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('bttstgft', {
  components: {
    minibet: __WEBPACK_IMPORTED_MODULE_5__vue_components_mini_bet__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__vue_mixins_allBet__["a" /* default */]],
  name: 'bttstgft',
  template: '\n    <div :id="getOddUniqueId(event)" class="odds" :class="[getOdCls(mode,betType,score,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);" > \n      <template v-if="event.od">\n        <template v-if="event.od[plyType]">\n          <template v-if="event.od[plyType][betType]">\n            <template v-if="event.od[plyType][betType][dual]">\n              <template v-if="event.od[plyType][betType][dual][score]">\n                <template v-if="checkOddValidation(event.od[plyType][betType][dual][score])">\n                  <span :class="{ \'yb-family-odds yb-number-bold match_details\': (mode==\'ab\' || bk.includes(betType)) }">\n                    <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">\n                      {{ getDecimalDisplay(betForm.odd) }}\n                    </template>\n                    <template v-else>\n                      {{ getDecimalDisplay(event.od[plyType][betType][dual][score]) }}\n                    </template>\n                  </span>\n                </template>\n                <template v-else>\n                  <div class="icon-lock" style="margin-right: 14px;"></div>\n                </template>\n                \n                <div class="odds-arrows-wrap" v-if="mode!=\'ab\'">\n                  <div class="odds-icon odds-up"></div>\n                  <div class="odds-icon odds-down"></div>\n                </div>\n              </template>\n              <template v-else>\n                <div class="icon-lock" style="margin-right: 14px;"></div>\n              </template>\n              </template>\n              <template v-else>\n                <div class="icon-lock" style="margin-right: 14px;"></div>\n              </template>\n            </template>\n            <template v-else>\n              <div class="icon-lock" style="margin-right: 14px;"></div>\n            </template>\n          </template>\n        <template v-else>\n          <div class="icon-lock" style="margin-right: 14px;"></div>\n        </template>\n      </template>\n    </div>\n  ',
  props: {
    event: null,
    score: null,
    plyType: null,
    betType: null,
    mode: null,
    dual: null
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['sportMiniBet']), {
    betForm: function betForm() {
      return this.$store.getters.betForm[0];
    }
  }),
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (typeof val.od != 'undefined') {
          if (typeof val.od[this.plyType] != 'undefined') {
            if (typeof val.od[this.plyType][this.betType] != 'undefined') {
              if (typeof val.od[this.plyType][this.betType][this.dual] != 'undefined') {
                this.classNegative(val.od[this.plyType][this.betType][this.dual][this.score]);

                if (oldVal && !this.refreshOdd) {
                  this.refreshOdd = false;
                  if (typeof oldVal.od[this.plyType] != 'undefined') {
                    if (typeof oldVal.od[this.plyType][this.betType] != 'undefined') {
                      if (typeof oldVal.od[this.plyType][this.betType][this.dual][this.score] != 'undefined') {
                        this.diffOddsUpDown(val.od[this.plyType][this.betType][this.dual][this.score], oldVal.od[this.plyType][this.betType][this.dual][this.score]);
                        this.diffOdds(val.od[this.plyType][this.betType][this.dual][this.score], oldVal.od[this.plyType][this.betType][this.dual][this.score]);
                      }
                    }
                  }
                } else if (this.refreshOdd) {
                  this.refreshOdd = false;
                  this.isDiff = false;
                } else if (!oldVal) {
                  this.refreshOdd = true;
                }
              } else {
                this.isClosePause = true;
              }
            }
          }
        }
      },

      deep: true,
      immediate: true
    }

  },
  data: function data() {
    return {
      isNegative: false,
      isDiff: false,
      isClosePause: false,
      refreshOdd: false,
      isUp: false,
      bk: ['6', '25', '53', '54', '55', '56', '63', '64'] };
  },

  methods: {
    getOdCls: function getOdCls(mode, bt, score, event) {
      var a = ' odds-default';
      if (mode == 'ab') {
        a = 'yb-number-font';
        if (score == 'aos') {
          a = a + ' aosnoflex ab-right';
        }
        a = a + ' odds-default';
        if (event.sprtid == '1') {
          a = a + ' odds-sc';
        } else {
          a = a + ' odds-os';
        }
      } else {
        if (jQuery.inArray(bt, ['25']) != '-1') {
          a += ' c-center';
        } else {
          a += ' c-right';
        }
      }

      return a;
    },
    getClass: function getClass(windowEvent, isNeg, isDif, isUp, isClosePause) {
      var classStr = '';
      var classMini = '';

      if (this.changeOdds) {
        if (!this.refreshOdd && isDif) {
          classStr = 'indicator';
        }
      } else if (isClosePause) {
        classStr = '';
      } else {
        if (!this.refreshOdd && isDif) {
          if (isUp) {
            classStr = 'up';
          } else {
            classStr = 'down';
          }
        }
      }
      return classStr + classMini;
    },
    onClickOdd: function onClickOdd() {
      var _this = this;

      var windowEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('returnBetTab');
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return;
      }
      if (!this.account.previewFlag) {
        if (!this.checkOddValidation(this.event.od[this.plyType][this.betType][this.dual][this.score])) {
          return;
        }
        var langYes = this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'];
        var langNo = this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'];
        var langDraw = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'];
        var display = "";

        if (this.betType == '65' || this.betType == '66') {
          if (this.score == 'ha') {
            display = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langYes;
          } else if (this.score == 'aa') {
            display = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langYes;
          } else if (this.score == 'da') {
            display = langDraw + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langYes;
          } else if (this.score == 'hb') {
            display = this.event.tacapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langNo;
          } else if (this.score == 'ab') {
            display = this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langNo;
          } else if (this.score == 'db') {
            display = langDraw + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langNo;
          }
        } else if (this.betType == '70' || this.betType == '71') {
          if (this.score == 'ha') {
            display = this.event.tacapt + '/' + langDraw + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langYes;
          } else if (this.score == 'aa') {
            display = this.event.tbcapt + '/' + langDraw + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langYes;
          } else if (this.score == 'da') {
            display = this.event.tacapt + '/' + this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langYes;
          } else if (this.score == 'hb') {
            display = this.event.tacapt + '/' + langDraw + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langNo;
          } else if (this.score == 'ab') {
            display = this.event.tbcapt + '/' + langDraw + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langNo;
          } else if (this.score == 'db') {
            display = this.event.tacapt + '/' + this.event.tbcapt + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + langNo;
          }
        }

        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang,
          eveid: this.event.eveid,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          plyType: this.plyType,
          betType: this.betType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          tbet: this.score,
          tbetcapt: display,
          odd: this.event.od[this.plyType][this.betType][this.dual][this.score],
          rbscoa: 0,
          rbscob: 0,
          dual: 'a',
          fav: '0',
          hdp: '0',
          uniqueId: this.event.eveid + this.plyType + this.betType + this.score,
          eventObj: this.event
        };

        if (this.event.rb) {
          if (this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa;
            betForm.rbscob = this.event.rbinfo.scob;
          }
        }

        if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket;
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {}

        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,

          'tbet': this.score,
          'dual': this.dual
        });
        if (indexx > -1) {
          var obj = { eveid: this.event.eveid };
          if (this.$store.getters.isBetCombo) {
            obj = { clearType: '3', index: indexx };
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            data: obj,
            callback: function () {
              _this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: _this.event.eveid
              });
              var MID = $(windowEvent.target).closest('div[id]')[0].id;
              $("[id=" + MID + "]").closest('.c-bet-item.active').removeClass('active');
              if (_this.$store.getters.betForm.length <= 0) {
                _this.$store.commit("OPEN_BETFORM", false);
                _this.$store.commit('ODD_SELECTED', false);
                _this.$store.commit("SHOW_BETFORM_MENU", false);
                _this.$store.commit('SELECTED_TAB', 'betTab');
                return;
              }
              _this.$store.dispatch("getBettingInfo", {
                callback: function (res) {
                  _this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: _this.$store.getters.betForm
                  });
                }.bind(_this)
              });
            }.bind(this)
          });
        } else {
          if (this.$store.getters.isBetCombo && this.$store.getters.betForm.length == this.betComboMax) {
            var chkRes = this.checkBetComboMax(betForm);
            if (chkRes) {
              return;
            }
          }

          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: function (res) {
              if (_this.$store.getters.sportMiniBet.toggle) {
                __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('expandMini');
              }
              _this.oddSelectHighlight(windowEvent, betForm);

              if (res.SYSTEM_DATA.status != 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                }
                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                  __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }

                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('OPEN_BETFORM', true);
                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                });

                if (_this.$store.getters.isBetCombo && _this.$store.getters.betForm.length > 1) {
                  __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('clearAllBetComboAmount');
                  __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
                }
              } else if (res.SYSTEM_DATA.status == 'FAIL') {
                if (_this.$store.getters.miniNormal == 1) {
                  _this.showMiniBet(windowEvent);
                }
                if (!_this.$store.getters.isBetCombo) {
                  _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                }

                _this.$store.commit('ODD_SELECTED', true);

                _this.$store.commit('OPEN_BETFORM', true);
                _this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                });
              }
            }.bind(this)
          });
        }
      }
    },
    classNegative: function classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false;
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    diffOddsUpDown: function diffOddsUpDown(val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false;
    },
    getOddUniqueClass: function getOddUniqueClass(event) {
      var classStr = '';
      if (this.plyType == '2') {
        classStr += 'ht ';
      }
      classStr += this.getOddUniqueId(event);
      return classStr;
    },
    getOddUniqueId: function getOddUniqueId(event) {
      return event.eveid + this.plyType + this.betType + this.score;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on(['refreshOdd'], function (params) {
      if (params == false) {
        _this2.refreshOdd = false;
      } else {
        _this2.refreshOdd = true;
      }
    }.bind(this));
  },
  mounted: function mounted() {
    this.$store.getters.betForm.forEach(function (value) {
      var MID = value.uniqueId;
      $("[id=" + MID + "]").closest('.c-bet-item').addClass('active');
    });
  }
});

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vrow"},[(_vm.selMarket == 'cs')?[_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })},[_vm._v("\n      "+_vm._s(_vm.event.tacapt)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })},[(!_vm.simpleSport)?[_vm._v("\n        "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.DRAW'])+"\n      ")]:[_vm._v("\n        "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+"\n      ")]],2),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })},[_vm._v("\n      "+_vm._s(_vm.event.tbcapt)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t",style:({ width: _vm.widthColumn[1] + 'px !important' })},[_vm._v("\n      "+_vm._s(_vm.event.tacapt)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t",style:({ width: _vm.widthColumn[1] + 'px !important' })},[(!_vm.simpleSport)?[_vm._v("\n        "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.DRAW'])+"\n      ")]:[_vm._v("\n        "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_DRAW'])+"\n      ")]],2),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t",style:({ width: _vm.widthColumn[1] + 'px !important' })},[_vm._v("\n      "+_vm._s(_vm.event.tbcapt)+"\n    ")]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.selMarket == 'onex2btts')?[_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: (_vm.widthColumn[1] * 3) + 'px !important' })},[_vm._v("\n        "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_1X2_BTTS'])+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t",style:({ width: (_vm.widthColumn[1] * 3) + 'px !important' })},[_vm._v("\n        "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_DBCH_BTTS'])+"\n      ")]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.selMarket == 'booking' || _vm.selMarket == 'corner')?[_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })},[_vm._v("\n        "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'])+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })},[_vm._v("\n        "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'])+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })},[_vm._v("\n        "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'])+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg",staticStyle:{"line-height":"15px","padding-top":"5px"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2']))]),_vm._v(" "),_c('span',{staticClass:"highlight-t"},[_vm._v("\n          "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg",staticStyle:{"line-height":"15px","padding-top":"5px"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP']))]),_vm._v(" "),_c('span',{staticClass:"highlight-t"},[_vm._v("\n          "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg",staticStyle:{"line-height":"15px","padding-top":"5px"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U']))]),_vm._v(" "),_c('span',{staticClass:"highlight-t"},[_vm._v("\n          "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n        ")])]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moreBet_cs_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba07a4f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moreBet_cs_vue__ = __webpack_require__(433);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moreBet_cs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba07a4f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moreBet_cs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-match-handicap morebetcs",attrs:{"id":'cmatch'+_vm.event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(0),_vm._v(" "),_c('cstgftht',{ref:"teamod10",attrs:{"event":_vm.event,"score":'od10',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(1),_vm._v(" "),_c('cstgftht',{ref:"teamod20",attrs:{"event":_vm.event,"score":'od20',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(2),_vm._v(" "),_c('cstgftht',{ref:"teamod21",attrs:{"event":_vm.event,"score":'od21',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(3),_vm._v(" "),_c('cstgftht',{ref:"teamod30",attrs:{"event":_vm.event,"score":'od30',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(4),_vm._v(" "),_c('cstgftht',{ref:"teamod31",attrs:{"event":_vm.event,"score":'od31',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(5),_vm._v(" "),_c('cstgftht',{ref:"teamod32",attrs:{"event":_vm.event,"score":'od32',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(6),_vm._v(" "),_c('cstgftht',{ref:"teamod40",attrs:{"event":_vm.event,"score":'od40',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(7),_vm._v(" "),_c('cstgftht',{ref:"teamod41",attrs:{"event":_vm.event,"score":'od41',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(8),_vm._v(" "),_c('cstgftht',{ref:"teamod42",attrs:{"event":_vm.event,"score":'od42',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(9),_vm._v(" "),_c('cstgftht',{ref:"teamod43",attrs:{"event":_vm.event,"score":'od43',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap col3 absolute",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*3) + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AOS']))])]),_vm._v(" "),_c('cstgftht',{ref:"teamodaos",attrs:{"event":_vm.event,"score":'aos',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(10),_vm._v(" "),_c('cstgftht',{ref:"teamod00",attrs:{"event":_vm.event,"score":'od00',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(11),_vm._v(" "),_c('cstgftht',{ref:"teamod11",attrs:{"event":_vm.event,"score":'od11',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(12),_vm._v(" "),_c('cstgftht',{ref:"teamod22",attrs:{"event":_vm.event,"score":'od22',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(13),_vm._v(" "),_c('cstgftht',{ref:"teamod33",attrs:{"event":_vm.event,"score":'od33',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(14),_vm._v(" "),_c('cstgftht',{ref:"teamod44",attrs:{"event":_vm.event,"score":'od44',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap visibility",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(15),_vm._v(" "),_c('cstgftht',{ref:"teamod01",attrs:{"event":_vm.event,"score":'od01',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(16),_vm._v(" "),_c('cstgftht',{ref:"teamod02",attrs:{"event":_vm.event,"score":'od02',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(17),_vm._v(" "),_c('cstgftht',{ref:"teamod12",attrs:{"event":_vm.event,"score":'od12',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(18),_vm._v(" "),_c('cstgftht',{ref:"teamod03",attrs:{"event":_vm.event,"score":'od03',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(19),_vm._v(" "),_c('cstgftht',{ref:"teamod13",attrs:{"event":_vm.event,"score":'od13',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(20),_vm._v(" "),_c('cstgftht',{ref:"teamod23",attrs:{"event":_vm.event,"score":'od23',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(21),_vm._v(" "),_c('cstgftht',{ref:"teamod04",attrs:{"event":_vm.event,"score":'od04',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(22),_vm._v(" "),_c('cstgftht',{ref:"teamod14",attrs:{"event":_vm.event,"score":'od14',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(23),_vm._v(" "),_c('cstgftht',{ref:"teamod24",attrs:{"event":_vm.event,"score":'od24',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.ftPlyType},[_vm._m(24),_vm._v(" "),_c('cstgftht',{ref:"teamod34",attrs:{"event":_vm.event,"score":'od34',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap visibility",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(25),_vm._v(" "),_c('cstgftht',{ref:"teamod10",attrs:{"event":_vm.event,"score":'od10',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(26),_vm._v(" "),_c('cstgftht',{ref:"teamod20",attrs:{"event":_vm.event,"score":'od20',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(27),_vm._v(" "),_c('cstgftht',{ref:"teamod21",attrs:{"event":_vm.event,"score":'od21',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(28),_vm._v(" "),_c('cstgftht',{ref:"teamod30",attrs:{"event":_vm.event,"score":'od30',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(29),_vm._v(" "),_c('cstgftht',{ref:"teamod31",attrs:{"event":_vm.event,"score":'od31',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(30),_vm._v(" "),_c('cstgftht',{ref:"teamod32",attrs:{"event":_vm.event,"score":'od32',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap col3 absolute",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*3) + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AOS']))])]),_vm._v(" "),_c('cstgftht',{ref:"teamodaos",attrs:{"event":_vm.event,"score":'aos',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(31),_vm._v(" "),_c('cstgftht',{ref:"teamod00",attrs:{"event":_vm.event,"score":'od00',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(32),_vm._v(" "),_c('cstgftht',{ref:"teamod11",attrs:{"event":_vm.event,"score":'od11',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(33),_vm._v(" "),_c('cstgftht',{ref:"teamod22",attrs:{"event":_vm.event,"score":'od22',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(34),_vm._v(" "),_c('cstgftht',{ref:"teamod33",attrs:{"event":_vm.event,"score":'od33',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap visibility",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(35),_vm._v(" "),_c('cstgftht',{ref:"teamod01",attrs:{"event":_vm.event,"score":'od01',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(36),_vm._v(" "),_c('cstgftht',{ref:"teamod02",attrs:{"event":_vm.event,"score":'od02',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(37),_vm._v(" "),_c('cstgftht',{ref:"teamod12",attrs:{"event":_vm.event,"score":'od12',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(38),_vm._v(" "),_c('cstgftht',{ref:"teamod03",attrs:{"event":_vm.event,"score":'od03',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(39),_vm._v(" "),_c('cstgftht',{ref:"teamod13",attrs:{"event":_vm.event,"score":'od13',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-cs-'+_vm.firstHtPlyType},[_vm._m(40),_vm._v(" "),_c('cstgftht',{ref:"teamod23",attrs:{"event":_vm.event,"score":'od23',"plyType":_vm.firstHtPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap visibility",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]):_vm._e(),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})])]:_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("1 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("2 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("2 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("3 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("3 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("3 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("4 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("4 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("4 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("4 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("0 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("1 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("2 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("3 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("4 - 4")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("0 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("0 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("1 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("0 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("1 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("2 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("0 - 4")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("1 - 4")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("2 - 4")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("3 - 4")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("1 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("2 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("2 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("3 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("3 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("3 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("0 - 0")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("1 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("2 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("3 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("0 - 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("0 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("1 - 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("0 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("1 - 3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("2 - 3")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moreBet_1x2btts_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779bb9e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moreBet_1x2btts_vue__ = __webpack_require__(436);
function injectStyle (ssrContext) {
  __webpack_require__(435)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moreBet_1x2btts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779bb9e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moreBet_1x2btts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-match-handicap morebetdual",attrs:{"id":'cmatch'+_vm.event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width:(_vm.widthColumn[1]*1.5)  + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v(_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']))])]),_vm._v(" "),_c('bttstgft',{ref:"bttsoddyesha",attrs:{"event":_vm.event,"score":'ha',"dual":'a',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5) + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v(_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']))])]),_vm._v(" "),_c('bttstgft',{ref:"bttsoddyesab",attrs:{"event":_vm.event,"score":'aa',"dual":'a',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5) + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v(_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']))])]),_vm._v(" "),_c('bttstgft',{ref:"bttsoddyesaa",attrs:{"event":_vm.event,"score":'da',"dual":'a',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5)  + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v(_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']))])]),_vm._v(" "),_c('bttstgft',{ref:"bttsoddshb",attrs:{"event":_vm.event,"score":'hb',"dual":'a',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5)  + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v(_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']))])]),_vm._v(" "),_c('bttstgft',{ref:"bttsoddab",attrs:{"event":_vm.event,"score":'ab',"dual":'a',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5)  + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-1x2btts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v(_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']))])]),_vm._v(" "),_c('bttstgft',{ref:"bttsodddb",attrs:{"event":_vm.event,"score":'db',"dual":'a',"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width:(_vm.widthColumn[1]*1.5)  + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v("\n              "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_HD'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'])+"\n            ")])]),_vm._v(" "),_c('bttstgft',{ref:"ouoddyesha",attrs:{"event":_vm.event,"score":'ha',"dual":_vm.oudual,"plyType":_vm.ftPlyType,"betType":_vm.betTypedbchbtts}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5) + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v("\n              "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_AD'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'])+"\n            ")])]),_vm._v(" "),_c('bttstgft',{ref:"ouoddyesaa",attrs:{"event":_vm.event,"score":'aa',"dual":_vm.oudual,"plyType":_vm.ftPlyType,"betType":_vm.betTypedbchbtts}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5) + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v("\n              "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_HA'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES'])+"\n            ")])]),_vm._v(" "),_c('bttstgft',{ref:"ouoddyesda",attrs:{"event":_vm.event,"score":'da',"dual":_vm.oudual,"plyType":_vm.ftPlyType,"betType":_vm.betTypedbchbtts}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5)  + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v("\n              "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_HD'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'])+"\n            ")])]),_vm._v(" "),_c('bttstgft',{ref:"ouoddhb",attrs:{"event":_vm.event,"score":'hb',"dual":_vm.oudual,"plyType":_vm.ftPlyType,"betType":_vm.betTypedbchbtts}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5)  + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v("\n              "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_AD'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'])+"\n            ")])]),_vm._v(" "),_c('bttstgft',{ref:"ouoddab",attrs:{"event":_vm.event,"score":'ab',"dual":_vm.oudual,"plyType":_vm.ftPlyType,"betType":_vm.betTypedbchbtts}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*1.5)  + 'px !important' }),attrs:{"title":this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY']+' & '+this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon bet-dbchbtts"},[_c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text ellipsis"},[_vm._v("\n              "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_HA'])+"  "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.AND'])+" "+_vm._s(this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO'])+"\n            ")])]),_vm._v(" "),_c('bttstgft',{ref:"ouodddb",attrs:{"event":_vm.event,"score":'db',"dual":_vm.oudual,"plyType":_vm.ftPlyType,"betType":_vm.betTypedbchbtts}})],1)])]),_vm._v(" "),(_vm.isUnfold)?[_vm._l((5),function(n,key){return (_vm.widthColumn[3]==2)?[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})])]:_vm._e()}),_vm._v(" "),_vm._l((6),function(n,key){return (_vm.widthColumn[3]==1)?[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})])]:_vm._e()}),_vm._v(" "),_vm._l((7),function(n,key){return (_vm.widthColumn[3]==0)?[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})])]:_vm._e()})]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moreBet_special_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34716982_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moreBet_special_vue__ = __webpack_require__(439);
function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moreBet_special_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34716982_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moreBet_special_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-match-handicap",class:'morebet'+_vm.specialType,attrs:{"id":'cmatch'+_vm.event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_vm._l((_vm.playType),function(plytyp){return [_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+_vm.event.eveid+_vm.betTypeonex2+plytyp+'a'+_vm.specialType}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(_vm.event.od[plytyp] && _vm.event.od[plytyp][_vm.betTypeonex2] && _vm.event.od[plytyp][_vm.betTypeonex2]['oddsh'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("1")]:[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()],2)]),_vm._v(" "),_c('odd1x2',{attrs:{"event":_vm.event,"team":_vm.teamHome,"plyType":plytyp,"betType":_vm.betTypeonex2}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(_vm.event.od[plytyp] && _vm.event.od[plytyp][_vm.betTypeonex2] && _vm.event.od[plytyp][_vm.betTypeonex2]['oddsa'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()],2)]),_vm._v(" "),_c('odd1x2',{attrs:{"event":_vm.event,"team":_vm.teamAway,"plyType":plytyp,"betType":_vm.betTypeonex2}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(_vm.event.od[plytyp] && _vm.event.od[plytyp][_vm.betTypeonex2] && _vm.event.od[plytyp][_vm.betTypeonex2]['oddsd'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()],2)]),_vm._v(" "),_c('odd1x2',{attrs:{"event":_vm.event,"team":_vm.teamDraw,"plyType":plytyp,"betType":_vm.betTypeonex2}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+_vm.event.eveid+_vm.betTypehdp+plytyp+'a'+_vm.specialType}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":_vm.event,"favTeam":'a',"plyType":plytyp,"betType":_vm.betTypehdp,"match":_vm.subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":_vm.event,"team":_vm.teamA,"plyType":plytyp,"betType":_vm.betTypehdp,"match":_vm.subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":_vm.event,"favTeam":'b',"plyType":plytyp,"betType":_vm.betTypehdp,"match":_vm.subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":_vm.event,"team":_vm.teamB,"plyType":plytyp,"betType":_vm.betTypehdp,"match":_vm.subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+_vm.event.eveid+_vm.betTypeou+plytyp+'a'+_vm.specialType}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(_vm.event.od[plytyp] && _vm.event.od[plytyp][_vm.betTypeou] && _vm.event.od[plytyp][_vm.betTypeou][_vm.subMatchKey])?[_vm._v("\n                                    "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                ")]:_vm._e(),_vm._v(" \n                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":_vm.event,"plyType":plytyp,"betType":_vm.betTypeou,"match":_vm.subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":_vm.event,"team":_vm.teamA,"plyType":plytyp,"betType":_vm.betTypeou,"match":_vm.subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(_vm.event.od[plytyp] && _vm.event.od[plytyp][_vm.betTypeou] && _vm.event.od[plytyp][_vm.betTypeou][_vm.subMatchKey])?[_vm._v("\n                                    "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                ")]:_vm._e(),_vm._v(" \n                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":_vm.event,"plyType":plytyp,"betType":_vm.betTypeou,"match":_vm.subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":_vm.event,"team":_vm.teamB,"plyType":plytyp,"betType":_vm.betTypeou,"match":_vm.subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})])]}),_vm._v(" "),(_vm.isUnfold)?[_vm._l((5),function(n,key){return (_vm.widthColumn[3]==2)?[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})])]:_vm._e()}),_vm._v(" "),_vm._l((6),function(n,key){return (_vm.widthColumn[3]==1)?[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})])]:_vm._e()}),_vm._v(" "),_vm._l((7),function(n,key){return (_vm.widthColumn[3]==0)?[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})])]:_vm._e()})]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event.sptid=='1')?_c('div',[(_vm.hasOneX2BTTS || _vm.hasCS || _vm.hasBooking || _vm.hasCorner || _vm.simpleSport!=null)?_c('div',[_c('div',{staticClass:"other-play-tab"},[_c('div',{staticClass:"play-title col"},[((_vm.hasCS || (_vm.hasOneX2BTTS && !_vm.simpleSport) || (_vm.hasBooking && !_vm.simpleSport) || (_vm.hasCorner && !_vm.simpleSport)))?_c('div',{staticClass:"arrow-wrap yb-flex-center",on:{"click":function($event){return _vm.openMoreBetForm(_vm.event,'arrow')}}},[_c('div',{staticClass:"yb-icon-arrow",class:{ active: !_vm.showMoreBet },attrs:{"id":'moreBet' + _vm.event.eveid}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tab-wrap fit relative-position"},[_c('div',{staticClass:"item-wrap relative-position",staticStyle:{"left":"0px"},attrs:{"id":"more-tab"}},[(_vm.hasCS)?_c('div',{staticClass:"tab-item yb-flex-center",class:['cstab-' + _vm.event.eveid, { active: (_vm.selectedMarket ==  _vm.mBetTab.cs.key) }],on:{"click":function($event){return _vm.chooseMarketType(_vm.mBetTab.cs, _vm.event, '.cstab-' + _vm.event.eveid)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CS'])+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.hasOneX2BTTS && !_vm.simpleSport)?_c('div',{staticClass:"tab-item yb-flex-center",class:['mmtab-' + _vm.event.eveid, { active: (_vm.selectedMarket ==  _vm.mBetTab.onex2btts.key) }],on:{"click":function($event){return _vm.chooseMarketType(_vm.mBetTab.onex2btts, _vm.event,'.mmtab-' + _vm.event.eveid)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.MIXMARKET'])+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.hasBooking && !_vm.simpleSport)?_c('div',{staticClass:"tab-item yb-flex-center",class:['bookingtab-' + _vm.event.eveid, { active: (_vm.selectedMarket ==  _vm.mBetTab.booking.key) }],on:{"click":function($event){return _vm.chooseMarketType(_vm.mBetTab.booking, _vm.event,'.bookingtab-' + _vm.event.eveid)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_BOOKING'])+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.hasCorner && !_vm.simpleSport)?_c('div',{staticClass:"tab-item yb-flex-center",class:['cornertab-' + _vm.event.eveid, { active: (_vm.selectedMarket ==  _vm.mBetTab.corner.key) }],on:{"click":function($event){return _vm.chooseMarketType(_vm.mBetTab.corner, _vm.event,'.cornertab-' + _vm.event.eveid)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_CORNER'])+"\n            ")]):_vm._e()])])]),_vm._v(" "),(!_vm.simpleSport)?_c('div',{staticClass:"media-col",staticStyle:{"min-width":"41px !important"}}):_vm._e()]),_vm._v(" "),(_vm.showMoreBet)?[(_vm.simpleSport)?[_c('div',{staticClass:"fifteen-box"},[_c('div',{staticClass:"basic-col",style:({ width: _vm.widthColumn[0] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt",style:({ width: (_vm.widthColumn[1]*3) + 'px !important' })},[_vm._v("\n              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_FT'])+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t",staticStyle:{"flex":"1"},style:({ width: (_vm.widthColumn[1]*3) + 'px !important' })},[_vm._v("\n              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n            ")])])])]:_vm._e(),_vm._v(" "),_c('div',{ref:'showmoreBet' + _vm.event.eveid,staticClass:"fifteen-box"},[_c('div',{staticClass:"basic-col",style:({ width: _vm.widthColumn[0] + 'px !important' })}),_vm._v(" "),_c('mbHeader',{attrs:{"event":_vm.filteredMainMarketList,"selMarket":_vm.selectedMarket,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold}})],1),_vm._v(" "),_c('div',{ref:'moreBetmatches' + _vm.event.eveid,staticClass:"match-handicap-item other-handicap-item"},[(!_vm.moreBetLoading)?[_c('sportTeam',{attrs:{"event":_vm.filteredMainMarketList,"selMarket":_vm.selectedMarket,"mode":'morebet',"widthL":_vm.widthColumn[0],"specialEveId":_vm.specialEveId}}),_vm._v(" "),((_vm.selectedMarket ==  _vm.mBetTab.cs.key))?[_c('moreCS',{attrs:{"event":_vm.filteredMainMarketList,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold}})]:_vm._e(),_vm._v(" "),((_vm.selectedMarket ==  _vm.mBetTab.onex2btts.key))?[_c('more1x2btts',{attrs:{"event":_vm.filteredMainMarketList,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold}})]:_vm._e(),_vm._v(" "),((_vm.selectedMarket ==  _vm.mBetTab.booking.key))?[_c('moreSpecial',{attrs:{"event":_vm.filteredMainMarketList,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold,"specialType":_vm.mBetTab.booking.key,"specialEveId":_vm.specialEveId}})]:_vm._e(),_vm._v(" "),((_vm.selectedMarket ==  _vm.mBetTab.corner.key))?[_c('moreSpecial',{attrs:{"event":_vm.filteredMainMarketList,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold,"specialType":_vm.mBetTab.corner.key,"specialEveId":_vm.specialEveId}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-col"})]:_vm._e()],2)]:_vm._e()],2):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'eCardWrap'+_vm.event.eveid,staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",style:(_vm.eventHeight(_vm.event, 'ecw', _vm.isRB)),attrs:{"id":'eCardWrap'+_vm.event.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{ref:'eCard'+_vm.event.eveid,staticClass:"c-match-card relative-position evecard",style:(_vm.eventHeight(_vm.event, 'ec', _vm.isRB)),attrs:{"id":'eCard'+_vm.event.eveid}},[_c('div',{staticClass:"c-match-item match-tpl0-bg more-handicap csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":_vm.event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap match-handicap-item-wrap-simple"},[_vm._l(((_vm.event.sub + 1)),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, _vm.event, subMatchKey, true))?[(subMatchKey == 0)?_c('div',{staticClass:"match-handicap-item"},[_c('div',{staticClass:"c-match-handicap c-match-handicap-simple",attrs:{"id":'cmatch'+_vm.event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col handicap-col-simple",attrs:{"id":'handicapCol'+_vm.event.eveid+(_vm.isRB? _vm.ronex2BetType:_vm.onex2BetType)+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap home",staticStyle:{"width":"100% !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"vrow no-wrap absolute-full"},[_c('div',{staticClass:"team-name home ellipsis allow-user-select",attrs:{"title":_vm.getTeamCapt(_vm.event.tacapt)},domProps:{"innerHTML":_vm._s(_vm.getTeamCapt(_vm.event.tacapt))}}),_vm._v(" "),_c('span',{staticClass:"red-ball",style:({ display : (_vm.event.rbinfo && _vm.event.rbinfo.rca>0)? 'block':'none' })},[((_vm.event.rbinfo && _vm.event.rbinfo.rca>0))?[_vm._v("\n                                      "+_vm._s(_vm.event.rbinfo.rca)+"\n                                    ")]:_vm._e()],2)])]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":_vm.event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":(_vm.isRB? _vm.ronex2BetType:_vm.onex2BetType),"mode":'simple'}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"20%"}},[_c('div',{staticClass:"score"},[((_vm.event.rbinfo && _vm.event.rbinfo.scoa>=0))?[_vm._v("\n                                  "+_vm._s(_vm.event.rbinfo.scoa)+"\n                              ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap draw",staticStyle:{"width":"50% !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"justify-content":"left","margin":"0 10px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[_vm._v("\n                                                  "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW'])+"\n                                              ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":_vm.event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":(_vm.isRB? _vm.ronex2BetType:_vm.onex2BetType),"mode":'simple'}}):_vm._e()],1)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"20%"}},[_c('div',{staticClass:"score"},[((_vm.event.rbinfo && _vm.event.rbinfo.scob>=0))?[_vm._v("\n                                  "+_vm._s(_vm.event.rbinfo.scob)+"\n                              ")]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap away",staticStyle:{"width":"100% !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"vrow no-wrap absolute-full"},[_c('div',{staticClass:"team-name away ellipsis allow-user-select",attrs:{"title":_vm.getTeamCapt(_vm.event.tbcapt)},domProps:{"innerHTML":_vm._s(_vm.getTeamCapt(_vm.event.tbcapt))}}),_vm._v(" "),_c('span',{staticClass:"red-ball",style:({ display : (_vm.event.rbinfo && _vm.event.rbinfo.rcb>0) ? 'block':'none' })},[((_vm.event.rbinfo && _vm.event.rbinfo.rcb>0))?[_vm._v("\n                                      "+_vm._s(_vm.event.rbinfo.rcb)+"\n                                    ")]:_vm._e()],2)])]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":_vm.event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":(_vm.isRB? _vm.ronex2BetType:_vm.onex2BetType),"mode":'simple'}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"30%"}},[_c('div',{staticClass:"play-count-wrap vrow no-wrap"},[_c('span',{staticClass:"play-count",staticStyle:{"margin-right":"5px"},on:{"click":function($event){return _vm.enterAllBet(_vm.event,3,_vm.isRB)}}},[_vm._v("+"+_vm._s(_vm.countAllBet(_vm.event)))]),_vm._v(" "),_vm._m(0,true)])])],2)])])]):_vm._e()]:_vm._e()}),_vm._v(" "),(_vm.chkMoreBetExist(_vm.event, true))?_c('moreBetComponent',{attrs:{"event":_vm.event,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold}}):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"media-col media-col-simple"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap"},[_c('span',{staticClass:"yb-flex-center yb-hover-bg m-star-wrap-match",on:{"click":function($event){return _vm.favourite(_vm.event, true)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{'active': _vm.event.isFavourite},attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== _vm.event.eveid && _vm.livetvEveid!= _vm.event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== _vm.event.eveid && _vm.livetvEveid!= _vm.event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(_vm.event,1,_vm.isRB)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && _vm.event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== _vm.event.eveid },attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== _vm.event.eveid, 'non-rb': !(_vm.event.rbstatus && _vm.event.rbinfo) },attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.enterAllBet(_vm.event,2,_vm.isRB)}}})]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"yb-flex-center"},[_c('div',{staticClass:"yb-icon-arrow"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"showtable"}},[(!_vm.selectedMatchAllBet)?[((_vm.drawEventList && Object.keys(_vm.drawEventList).length > 0))?[_vm._l((_vm.drawEventList),function(sportObj,sportObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap matc-type-card",staticStyle:{"height":"38px !important"},style:({'top':_vm.showFavEvents ? '35.5px':'83.5px'}),on:{"click":function($event){return _vm.showSport(sportObjKey)}}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"match-type text-left yb-flex-between"},[_c('div',{staticClass:"col-left"},[_vm._v("\n                "+_vm._s(_vm.getSportLang(sportObjKey))+"\n                "),_c('span',{staticClass:"match-number"})])])])]),_vm._v(" "),(_vm.showLgeEve[sportObjKey] && !_vm.showLgeEve[sportObjKey].hide)?[_vm._l((sportObj),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important"},style:({'top':_vm.showFavEvents ? '73.5px':'121.5px'})},[_c('div',{key:eventObjKey,staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl0-bg",class:{ 'match-tpl0': !_vm.showLgeEve[sportObjKey][eventObjKey].hide, 'leagues-pack': _vm.showLgeEve[sportObjKey][eventObjKey].hide },on:{"click":function($event){return _vm.showLeg(eventObjKey, sportObjKey, false)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width: (_vm.simpleSport==null)? _vm.widthColumn[2] + 'px !important':'700px !important' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[(sportObjKey == 'N1')?[(_vm.simpleSport!='N1')?[_c('div',{staticClass:"col ellipsis bet-col0"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'])+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col1"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'])+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col2"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'])+"\n                          ")]),_vm._v(" "),(_vm.selectedLang == 1)?[_c('div',{staticClass:"col ellipsis bet-col3"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col4"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col5"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                                ")])])]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._m(0,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_c('div',{staticClass:"double-row",attrs:{"data-v-59e369b2":""}},[_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME']))]),_vm._v(" "),_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_c('div',{staticClass:"double-row",attrs:{"data-v-59e369b2":""}},[_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY']))]),_vm._v(" "),_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_vm._m(1,true),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._m(2,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]:[_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.1X2'])+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.HDP'])+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.O.U'])+"\n                            ")]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_HMG']))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.HTG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.ATG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col9"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_BTTS']))]),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TWFB'])+"  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]]:_vm._e()]:(sportObjKey == 'G1')?[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_ML']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_HDP']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OU']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE']))])]:[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('ML')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('HDP')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('OU')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('OE')))])]],2),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league",class:{ added: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) },on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '1', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) }})])])])])])]),_vm._v(" "),(!_vm.showLgeEve[sportObjKey][eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return (eventKey!='hide')?[(_vm.simpleSport==null)?_c('div',{ref:'eCardWrap'+event.eveid,refInFor:true,staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",style:(_vm.eventHeight(event, 'ecw', true)),attrs:{"id":'eCardWrap'+event.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{ref:'eCard'+event.eveid,refInFor:true,staticClass:"c-match-card relative-position evecard",style:(_vm.eventHeight(event, 'ec', true)),attrs:{"id":'eCard'+event.eveid}},[_c('div',{staticClass:"c-match-item more-handicap csid-1",class:event.sptid=='1'?'match-tpl0-bg':''},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[(sportObjKey=='N1')?[_vm._l(((event.sub + 1)),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"widthL":_vm.widthColumn[0],"plyType":_vm.ftPlyType,"isRB":true}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",class:sportObjKey!='N1'?'cmh':'',attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.onex2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.onex2BetType] && event.od[_vm.ftPlyType][_vm.onex2BetType]['oddsh'])?[(event.sptid=='1' && (_vm.selectedLang=='4' || _vm.selectedLang=='11'))?[_vm._v("1")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.onex2BetType] && event.od[_vm.ftPlyType][_vm.onex2BetType]['oddsa'])?[(event.sptid=='1' && (_vm.selectedLang=='4' || _vm.selectedLang=='11'))?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.onex2BetType] && event.od[_vm.ftPlyType][_vm.onex2BetType]['oddsd'])?[(event.sptid=='1' && (_vm.selectedLang=='4' || _vm.selectedLang=='11'))?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.hdpBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ouBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ouBetType] && event.od[_vm.ftPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ouBetType] && event.od[_vm.ftPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.onex2BetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType]['oddsh'])?[(event.sptid=='1' && (_vm.selectedLang=='4' || _vm.selectedLang=='11'))?[_vm._v("1")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.firstHtPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType]['oddsa'])?[(event.sptid=='1' && (_vm.selectedLang=='4' || _vm.selectedLang=='11'))?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.firstHtPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType]['oddsd'])?[(event.sptid=='1' && (_vm.selectedLang=='4' || _vm.selectedLang=='11'))?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.firstHtPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.hdpBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ouBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ouBetType] && event.od[_vm.firstHtPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ouBetType] && event.od[_vm.firstHtPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rhmg1x2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType]['oddsh'])?[_vm._v("\n                                                      "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_1HT'])+"\n                                                    ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rhmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType]['oddsa'])?[_vm._v("\n                                                      "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_2HT'])+"\n                                                    ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rhmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType]['oddsd'])?[_vm._v("\n                                                        "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW'])+"\n                                                      ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.rhmg1x2BetType}}):_vm._e()],1)])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.htgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.htgBetType])?[_vm._v("\n                                                    "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                  ")]:_vm._e(),_vm._v("\n                                                   \n                                                ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.htgBetType])?[_vm._v("\n                                                    "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                                  ")]:_vm._e(),_vm._v("\n                                                   \n                                                ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.atgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.atgBetType])?[_vm._v("\n                                                    "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                  ")]:_vm._e(),_vm._v("\n                                                   \n                                                ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.atgBetType])?[_vm._v("\n                                                    "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                                  ")]:_vm._e(),_vm._v("\n                                                   \n                                                ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.bttsBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.bttsBetType] && event.od[_vm.ftPlyType][_vm.bttsBetType]['oddsh'])?[_vm._v("\n                                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                                  ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.bttsBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.bttsBetType] && event.od[_vm.ftPlyType][_vm.bttsBetType]['oddsa'])?[_vm._v("\n                                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                                                  ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.bttsBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rtwfbBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType]['oddsh'])?[_vm._v("\n                                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                                  ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rtwfbBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType]['oddsa'])?[_vm._v("\n                                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                                  ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rtwfbBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.oeBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.oeBetType])?[_vm._v("\n                                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                                                  ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamOdd",refInFor:true,attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.oeBetType])?[_vm._v("\n                                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                                                  ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamEven",refInFor:true,attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rcshBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rcshBetType] && event.od[_vm.ftPlyType][_vm.rcshBetType]['oddsh'])?[_vm._v("\n                                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                                  ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rcshBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rcshBetType] && event.od[_vm.ftPlyType][_vm.rcshBetType]['oddsa'])?[_vm._v("\n                                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                                  ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rcshBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2)]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('div',{staticClass:"media-col",class:sportObjKey!='N1'?'c-os2':''},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.enterAllBet(event,2)}}})]):_vm._e()])]):_vm._e()],1)]:_vm._e()})]:[_vm._l((_vm.getSubMatchCount(event['od'][_vm.getFullTime(event['od'])])),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"widthL":_vm.widthColumn[0],"plyType":_vm.ftPlyType,"isRB":false}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap cmh",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.mlBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(3,true),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.getFullTime(event['od']),"betType":_vm.mlBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(4,true),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.getFullTime(event['od']),"betType":_vm.mlBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.hdpBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.ouBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.ouBetType])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.ouBetType])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.oeBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.oeBetType])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.ODD'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.oeBetType])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.EVEN'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"media-col c-os2"},[(subMatchKey==0)?_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""},on:{"click":function($event){return _vm.enterAllBet(event,2)}}})]):_vm._e()]):_vm._e()])],1)]:_vm._e()})],_vm._v(" "),(event.sptid=='1' && _vm.chkMoreBetExist(event, true))?_c('moreBetComponent',{attrs:{"event":event,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold}}):_vm._e()],2)])])])]):_c('simpleSoccer',{attrs:{"event":event,"isRB":true,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold,"firstEventEveid":_vm.firstEventEveid,"livetvEveid":_vm.livetvEveid}})]:_vm._e()})]:_vm._e()]})]:_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),((_vm.drawEventList && Object.keys(_vm.drawEventList).length > 0))?_c('div',{},[_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('div',{staticClass:"pager-wrap vrow justify-end"},[_c('div',{staticClass:"go-top-btn yb-flex-center",on:{"click":_vm.backtoTop}},[_c('i',{staticClass:"q-icon icon-go_top c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"vmsg"},[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.BACK_TOP']))])])])]):_vm._e(),_vm._v(" "),_vm._m(5)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row",attrs:{"data-v-59e369b2":""}},[_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v("Half With ")]),_vm._v(" "),_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v(" Most Goals")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col ellipsis bet-col9"},[_c('div',{staticClass:"double-row",attrs:{"data-v-59e369b2":""}},[_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v("Both Teams")]),_vm._v(" "),_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v(" To Scores")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row",attrs:{"data-v-59e369b2":""}},[_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v("To Win")]),_vm._v(" "),_c('div',{attrs:{"data-v-59e369b2":""}},[_vm._v(" From Behind")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute-full resize-observer-wrap"},[_c('div',{staticClass:"absolute-full expand"}),_vm._v(" "),_c('div',{staticClass:"absolute-full shrink"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerCommon_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17727d1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerCommon_vue__ = __webpack_require__(448);
function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerCommon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17727d1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerCommon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedMarket!=_vm.market.earlyMarket.key)?_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap matc-type-card",staticStyle:{"height":"38px !important"},style:(_vm.getTop()),on:{"click":function($event){return _vm.showMarketMatches(_vm.marketType)}}},[_c('div',{staticClass:"list-card-inner"},[((_vm.sortedEventList && Object.keys(_vm.sortedEventList).length > 0) || (_vm.sortedRBEventList && Object.keys(_vm.sortedRBEventList).length > 0))?_c('div',{staticClass:"match-type text-left yb-flex-between",class:[_vm.marketType==_vm.market.inPlayMarket.key ? 'match-type-odd':'match-type-even']},[_c('div',{staticClass:"col-left"},[(_vm.marketType==_vm.market.inPlayMarket.key)?[_vm._v("\n          "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_INPLAY'])+"\n          "),_c('span',{staticClass:"match-number"},[_vm._v(" "+_vm._s(_vm.sortedRBEventList.length))])]:[_vm._v("\n          "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_NOT_STARTED'])+"\n          "),_c('span',{staticClass:"match-number"},[_vm._v(" "+_vm._s(_vm.sortedEventList.length))])]],2)]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"showtable"}},[(!_vm.selectedMatchAllBet)?[((_vm.selectedMarket=='1' && _vm.sortedRBEventList && Object.keys(_vm.sortedRBEventList).length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.inPlayMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showRBhideAll)?[_vm._l((_vm.sortedRBEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important","top":"73.5px"}},[_c('div',{key:eventObjKey,staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl0-bg",class:_vm.checkClass(_vm.showRBLgeEve, eventObjKey),on:{"click":function($event){return _vm.showLeg(eventObjKey, true)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width: (_vm.simpleSport==null)? _vm.widthColumn[2] + 'px':'700px' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[(_vm.simpleSport==null)?[_c('div',{staticClass:"col ellipsis bet-col0"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'])+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col1"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'])+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col2"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'])+"\n                      ")]),_vm._v(" "),(_vm.selectedLang == 1)?[_c('div',{staticClass:"col ellipsis bet-col3"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col4"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col5"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                            ")])])]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._m(0,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME']))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY']))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_vm._m(1,true),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._m(2,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]:[_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                          "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.1X2'])+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                          "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.HDP'])+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                          "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.O.U'])+"\n                        ")]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_HMG']))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.HTG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.ATG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col9"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_BTTS']))]),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TWFB'])+"  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league",class:{ added: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) },on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '1', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) }})])])])])])]),_vm._v(" "),(_vm.showRBLgeEve[eventObjKey])?[(!_vm.showRBLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return (eventKey!='hide')?[(_vm.simpleSport==null)?_c('div',{ref:'eCardWrap'+event.eveid,refInFor:true,staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",style:(_vm.eventHeight(event, 'ecw', true)),attrs:{"id":'eCardWrap'+event.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{ref:'eCard'+event.eveid,refInFor:true,staticClass:"c-match-card relative-position evecard",style:(_vm.eventHeight(event, 'ec', true)),attrs:{"id":'eCard'+event.eveid}},[_c('div',{staticClass:"c-match-item match-tpl0-bg more-handicap csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_vm._l(((event.sub + 1)),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey, true))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"plyType":_vm.ftPlyType,"isRB":true,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ronex2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ronex2BetType] && event.od[_vm.ftPlyType][_vm.ronex2BetType]['oddsh'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("1")]:[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ronex2BetType] && event.od[_vm.ftPlyType][_vm.ronex2BetType]['oddsa'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ronex2BetType] && event.od[_vm.ftPlyType][_vm.ronex2BetType]['oddsd'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rhdpBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.ftPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.ftPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rouBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rouBetType] && event.od[_vm.ftPlyType][_vm.rouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                            "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                          ")]:_vm._e(),_vm._v("\n                                           \n                                        ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rouBetType] && event.od[_vm.ftPlyType][_vm.rouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                            "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                          ")]:_vm._e(),_vm._v("\n                                           \n                                        ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ronex2BetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType]['oddsh'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("1")]:[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.firstHtPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType]['oddsa'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.firstHtPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType]['oddsd'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.firstHtPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rhdpBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.firstHtPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.firstHtPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rouBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.rouBetType] && event.od[_vm.firstHtPlyType][_vm.rouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                            ")]:_vm._e(),_vm._v(" "),_vm._v("\n                                           \n                                        ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.rouBetType] && event.od[_vm.firstHtPlyType][_vm.rouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                            "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                          ")]:_vm._e(),_vm._v("\n                                           \n                                        ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rhmg1x2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType]['oddsh'])?[_vm._v("\n                                                "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_1HT'])+"\n                                              ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rhmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType]['oddsa'])?[_vm._v("\n                                                "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_2HT'])+"\n                                              ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rhmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType]['oddsd'])?[_vm._v("\n                                                  "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW'])+"\n                                                ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.rhmg1x2BetType}}):_vm._e()],1)])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rhtgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhtgBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.rhtgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.rhtgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhtgBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.rhtgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.rhtgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ratgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ratgBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ratgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.ratgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ratgBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ratgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.ratgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rbttsBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rbttsBetType] && event.od[_vm.ftPlyType][_vm.rbttsBetType]['oddsh'])?[_vm._v("\n                                                "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rbttsBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rbttsBetType] && event.od[_vm.ftPlyType][_vm.rbttsBetType]['oddsa'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rbttsBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rtwfbBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType]['oddsh'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rtwfbBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType]['oddsa'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rtwfbBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.roeBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.roeBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamOdd",refInFor:true,attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.roeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.roeBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamEven",refInFor:true,attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.roeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rcshBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rcshBetType] && event.od[_vm.ftPlyType][_vm.rcshBetType]['oddsh'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rcshBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rcshBetType] && event.od[_vm.ftPlyType][_vm.rcshBetType]['oddsh'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rcshBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2)]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1, true)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.enterAllBet(event,2, true)}}})]):_vm._e()])]):_vm._e()],1)]:_vm._e()}),_vm._v(" "),(_vm.chkMoreBetExist(event, true))?_c('moreBetComponent',{attrs:{"event":event,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold}}):_vm._e()],2)])])])]):_c('simpleSoccer',{attrs:{"event":event,"isRB":true,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold,"firstEventEveid":_vm.firstEventEveid,"livetvEveid":_vm.livetvEveid}})]:_vm._e()})]:_vm._e()]:_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),((_vm.sortedEventList && _vm.sortedEventList.length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.tdyMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showhideAll)?[_vm._l((_vm.sortedEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important"},style:(_vm.getTop())},[_c('div',{key:eventObjKey,staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl0-bg",class:_vm.checkClass(_vm.showLgeEve, eventObjKey),on:{"click":function($event){return _vm.showLeg(eventObjKey, false)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width: (_vm.simpleSport==null)? _vm.widthColumn[2] + 'px':'700px' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full",attrs:{"title":eventObj[0].lgecapt}},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[(_vm.simpleSport==null)?[_c('div',{staticClass:"col ellipsis bet-col0"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'])+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col1"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'])+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col2"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'])+"\n                      ")]),_vm._v(" "),(_vm.selectedLang == 1)?[_c('div',{staticClass:"col ellipsis bet-col3"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col4"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col5"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                            ")])])]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._m(3,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME']))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY']))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_vm._m(4,true),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._m(5,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]:[_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                          "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.1X2'])+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                          "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.HDP'])+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                          "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.O.U'])+"\n                        ")]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_HMG']))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.HTG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.ATG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col9"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_BTTS']))]),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TWFB'])+"  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league",class:{ added: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) },on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) }})])])])])])]),_vm._v(" "),(_vm.showLgeEve[eventObjKey])?[(!_vm.showLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [(_vm.simpleSport==null)?_c('div',{ref:'eCardWrap'+event.eveid,refInFor:true,staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",style:(_vm.eventHeight(event, 'ecw')),attrs:{"id":'eCardWrap'+event.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{ref:'eCard'+event.eveid,refInFor:true,staticClass:"c-match-card relative-position evecard",style:(_vm.eventHeight(event, 'ec')),attrs:{"id":'eCard'+event.eveid}},[_c('div',{staticClass:"c-match-item match-tpl0-bg more-handicap csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_vm._l(((event.sub + 1)),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"plyType":_vm.ftPlyType,"isRB":false,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.onex2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.onex2BetType] && event.od[_vm.ftPlyType][_vm.onex2BetType]['oddsh'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("1")]:[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.onex2BetType] && event.od[_vm.ftPlyType][_vm.onex2BetType]['oddsa'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.onex2BetType] && event.od[_vm.ftPlyType][_vm.onex2BetType]['oddsd'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.hdpBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ouBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ouBetType] && event.od[_vm.ftPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                            "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                          ")]:_vm._e(),_vm._v("\n                                           \n                                        ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ouBetType] && event.od[_vm.ftPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                            "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                          ")]:_vm._e(),_vm._v("\n                                           \n                                        ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.onex2BetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType]['oddsh'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("1")]:[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.firstHtPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType]['oddsa'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.firstHtPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType]['oddsd'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.firstHtPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.hdpBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ouBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ouBetType] && event.od[_vm.firstHtPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                            "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                          ")]:_vm._e(),_vm._v("\n                                           \n                                        ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ouBetType] && event.od[_vm.firstHtPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                            "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                          ")]:_vm._e(),_vm._v("\n                                           \n                                        ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.hmg1x2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType]['oddsh'])?[_vm._v("\n                                                "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_1HT'])+"\n                                              ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.hmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType]['oddsa'])?[_vm._v("\n                                                "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_2HT'])+"\n                                              ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.hmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType]['oddsd'])?[_vm._v("\n                                                  "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW'])+"\n                                                ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.hmg1x2BetType}}):_vm._e()],1)])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.htgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.htgBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.htgBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.atgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.atgBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.atgBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.bttsBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.bttsBetType] && event.od[_vm.ftPlyType][_vm.bttsBetType]['oddsh'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.bttsBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.bttsBetType] && event.od[_vm.ftPlyType][_vm.bttsBetType]['oddsa'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.bttsBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.twfbBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.twfbBetType] && event.od[_vm.ftPlyType][_vm.twfbBetType]['oddsh'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.twfbBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.twfbBetType] && event.od[_vm.ftPlyType][_vm.twfbBetType]['oddsa'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.twfbBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.oeBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.oeBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamOdd",refInFor:true,attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.oeBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamEven",refInFor:true,attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.cshBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.cshBetType] && event.od[_vm.ftPlyType][_vm.cshBetType]['oddsh'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.cshBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.cshBetType] && event.od[_vm.ftPlyType][_vm.cshBetType]['oddsa'])?[_vm._v("\n                                              "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.cshBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2)]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon non-rb",attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']}})]):_vm._e()])]):_vm._e()],1)]:_vm._e()}),_vm._v(" "),(_vm.chkMoreBetExist(event))?_c('moreBetComponent',{attrs:{"event":event,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold}}):_vm._e()],2)])])])]):_c('simpleSoccer',{attrs:{"event":event,"isRB":false,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold,"firstEventEveid":_vm.firstEventEveid,"livetvEveid":_vm.livetvEveid}})]})]:_vm._e()]:_vm._e()]})]:_vm._e()]:_vm._e()]:_vm._e(),_vm._v(" "),((_vm.sortedEventList && Object.keys(_vm.sortedEventList).length > 0))?_c('div',{},[_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('div',{staticClass:"pager-wrap vrow justify-end"},[_c('div',{staticClass:"go-top-btn yb-flex-center",on:{"click":_vm.backtoTop}},[_c('i',{staticClass:"q-icon icon-go_top c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"vmsg"},[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.BACK_TOP']))])])])]):_vm._e(),_vm._v(" "),_vm._m(6)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("Half With ")]),_vm._v(" "),_c('div',{},[_vm._v(" Most Goals")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col ellipsis bet-col9"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("Both Teams")]),_vm._v(" "),_c('div',{},[_vm._v(" To Scores")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("To Win")]),_vm._v(" "),_c('div',{},[_vm._v(" From Behind")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("Half With ")]),_vm._v(" "),_c('div',{},[_vm._v(" Most Goals")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col ellipsis bet-col9"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("Both Teams")]),_vm._v(" "),_c('div',{},[_vm._v(" To Scores")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("To Win")]),_vm._v(" "),_c('div',{},[_vm._v(" From Behind")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute-full resize-observer-wrap"},[_c('div',{staticClass:"absolute-full expand"}),_vm._v(" "),_c('div',{staticClass:"absolute-full shrink"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hotSportCommon_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0823abca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hotSportCommon_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hotSportCommon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0823abca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hotSportCommon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moreBet_eg_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f312da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moreBet_eg_vue__ = __webpack_require__(453);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moreBet_eg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f312da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moreBet_eg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-match-handicap morebeteg",attrs:{"id":'cmatch'+_vm.event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_vm._l((5),function(col){return [_c('div',{staticClass:"handicap-col"},[_vm._l((20),function(row){return [_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon",class:'bet-eg-'+_vm.ftPlyType},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"justify-content":"flex-start","margin-left":"25px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v(_vm._s(_vm.getCount(row, col, '-')))])]),_vm._v(" "),_c('oddEdg',{ref:_vm.getCount(row, col, 'teamod'),refInFor:true,attrs:{"event":_vm.event,"score":_vm.getCount(row, col, 'od'),"plyType":_vm.ftPlyType,"betType":_vm.bettype,"decimalNumber":1,"mode":'morebet'}})],1)])]})],2)]})],2),_vm._v(" "),_c('div',{staticClass:"box_innbet_btn",on:{"click":function($event){return _vm.moreBtnHandle(_vm.event.eveid)}}},[_c('div',{staticClass:"btn_innbet_more",attrs:{"id":'pd_show_more_'+_vm.event.eveid,"data-less":_vm.sportAllBetLang['ALL_BET.LBL_VIEW_LESS'],"data-more":_vm.sportAllBetLang['ALL_BET.LBL_VIEW_MORE']}},[_c('i',{staticClass:"icon-arrow q-icon c-icon"},[_c('svg',[_c('use',{attrs:{"xlink:href":"#icon_toparr"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.selectedBettype.tmpltId == '8' || _vm.hotSchedule == true)?[(_vm.selectedBettype.sprtId == 'N2' || ( _vm.hotSchedule == true && _vm.event.sptid == 2))?[(_vm.checkAnyExist(_vm.event))?_c('div',[_c('div',{staticClass:"other-play-tab"},[_c('div',{staticClass:"play-title col"},[_c('div',{staticClass:"arrow-wrap yb-flex-center",on:{"click":function($event){return _vm.openMoreBetForm(_vm.event,'arrow')}}},[_c('div',{staticClass:"yb-icon-arrow",class:{ active: !_vm.showMoreBet },attrs:{"id":'moreBet' + _vm.event.eveid}})]),_vm._v(" "),_c('div',{staticClass:"tab-wrap fit relative-position"},[_c('div',{staticClass:"item-wrap relative-position",staticStyle:{"left":"0px"},attrs:{"id":"more-tab"}},[_vm._l((_vm.sportTabs['N'+_vm.event.sptid]),function(tabkey){return (_vm.hotSchedule == true)?[(_vm.checkMBTexist(_vm.event, tabkey))?_c('div',{staticClass:"tab-item yb-flex-center",class:[tabkey + 'tab-' + _vm.event.eveid, { active: _vm.setTabActive(_vm.event) == 1 }],on:{"click":function($event){return _vm.chooseMarketType(_vm.mBetTab[tabkey], _vm.event, '.' + tabkey + 'tab-' + _vm.event.eveid)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_'+tabkey])+"\n                    ")]):_vm._e()]:_vm._l((_vm.sportTabs[_vm.selectedBettype.sprtId]),function(tabkey){return [(_vm.checkMBTexist(_vm.event, tabkey))?_c('div',{staticClass:"tab-item yb-flex-center",class:[tabkey + 'tab-' + _vm.event.eveid, { active: _vm.setTabActive(_vm.event) == 1 }],on:{"click":function($event){return _vm.chooseMarketType(_vm.mBetTab[tabkey], _vm.event, '.' + tabkey + 'tab-' + _vm.event.eveid)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_'+tabkey])+"\n                    ")]):_vm._e()]})})],2)])]),_vm._v(" "),_c('div',{staticClass:"media-col",staticStyle:{"min-width":"41px !important"}})]),_vm._v(" "),(_vm.showMoreBet)?[_c('div',{ref:'moreBetmatches' + _vm.event.eveid,staticClass:"match-handicap-item other-handicap-item"},[(!_vm.moreBetLoading)?[((_vm.selectedMarket ==  _vm.mBetTab.EG.key))?[_c('moreEG',{attrs:{"event":_vm.filteredMainMarketList,"widthColumn":_vm.widthColumn(false,5),"isUnfold":_vm.isUnfold}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"media-col"})]:_vm._e()],2)]:_vm._e()],2):_vm._e()]:_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"inherit"},style:({top: !_vm.showFavEvents? '45px':'0px'}),attrs:{"id":"showtable"}},[(!_vm.selectedMatchAllBet)?[((_vm.selectedMarket=='5' && _vm.sortedRBEventList && Object.keys(_vm.sortedRBEventList).length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.inPlayMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showRBhideAll)?[_vm._l((_vm.sortedRBEventList),function(sportObj,sportObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap matc-type-card",staticStyle:{"height":"40px !important"},style:({'top':_vm.showFavEvents ? '':'121.5px'}),on:{"click":function($event){return _vm.showSport(sportObjKey,_vm.market.inPlayMarket.key)}}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"match-type text-left yb-flex-between"},[_c('div',{staticClass:"col-left"},[_vm._v("\n                  "+_vm._s(_vm.getSportLang(sportObjKey))+"\n                  "),_c('span',{staticClass:"match-number"})])])])]),_vm._v(" "),(_vm.showRBLgeEve[sportObjKey] && !_vm.showRBLgeEve[sportObjKey].hide)?[_vm._l((sportObj),function(eventObj,eventObjKey){return [(eventObj[0]!=undefined)?_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important"},style:({'top':_vm.showFavEvents ? '73.5px':'157.5px'})},[_c('div',{key:eventObjKey,staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl0-bg",class:_vm.checkClass(_vm.showRBLgeEve[sportObjKey], eventObjKey),on:{"click":function($event){return _vm.showLeg(eventObjKey, true, sportObjKey)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width: (_vm.simpleSport==null)? _vm.widthColumn[2] + 'px':'700px' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0]!=undefined? eventObj[0].lgecapt:'1'},domProps:{"innerHTML":_vm._s(eventObj[0]!=undefined? eventObj[0].lgecapt:'')}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[(sportObjKey == 'N1')?[(_vm.simpleSport==null)?[_c('div',{staticClass:"col ellipsis bet-col0"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'])+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col1"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'])+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col2"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'])+"\n                          ")]),_vm._v(" "),(_vm.selectedLang == 1)?[_c('div',{staticClass:"col ellipsis bet-col3"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col4"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col5"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                                ")])])]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._m(0,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME']))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY']))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_vm._m(1,true),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._m(2,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]:[_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.1X2'])+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.HDP'])+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.O.U'])+"\n                            ")]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_HMG']))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.HTG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.ATG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col9"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_BTTS']))]),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TWFB'])+"  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]]:_vm._e()]:(sportObjKey == 'G1')?[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_ML']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_HDP']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OU']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE']))])]:[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('ML')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('HDP')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('OU')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('OE')))])]],2),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[(false)?_c('div',{staticClass:"icon-wrap m-star-wrap-league",class:{ added: _vm.lgFavorite(eventObj[0].lgeid, sportObjKey, _vm.favouriteLgeEvents) },on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '1', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, sportObjKey, _vm.favouriteLgeEvents) }})]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.showRBLgeEve[sportObjKey] != undefined && _vm.showRBLgeEve[sportObjKey][eventObjKey])?[(!_vm.showRBLgeEve[sportObjKey][eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return (eventKey!='hide')?[(_vm.simpleSport==null)?_c('div',{ref:'eCardWrap'+event.eveid,refInFor:true,staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",style:(_vm.eventHeight(event, 'ecw', true)),attrs:{"id":'eCardWrap'+event.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{ref:'eCard'+event.eveid,refInFor:true,staticClass:"c-match-card relative-position evecard",style:(_vm.eventHeight(event, 'ec', true)),attrs:{"id":'eCard'+event.eveid}},[_c('div',{staticClass:"c-match-item more-handicap csid-1",class:event.sptid=='1'?'match-tpl0-bg':''},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[(sportObjKey=='N1')?[_vm._l(((event.sub + 1)),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey, true))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"plyType":_vm.ftPlyType,"isRB":true,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ronex2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ronex2BetType] && event.od[_vm.ftPlyType][_vm.ronex2BetType]['oddsh'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("1")]:[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ronex2BetType] && event.od[_vm.ftPlyType][_vm.ronex2BetType]['oddsa'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ronex2BetType] && event.od[_vm.ftPlyType][_vm.ronex2BetType]['oddsd'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rhdpBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.ftPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.ftPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rouBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rouBetType] && event.od[_vm.ftPlyType][_vm.rouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rouBetType] && event.od[_vm.ftPlyType][_vm.rouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ronex2BetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType]['oddsh'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("1")]:[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.firstHtPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType]['oddsa'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.firstHtPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType] && event.od[_vm.firstHtPlyType][_vm.ronex2BetType]['oddsd'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.firstHtPlyType,"betType":_vm.ronex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rhdpBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.firstHtPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.firstHtPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rouBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.rouBetType] && event.od[_vm.firstHtPlyType][_vm.rouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                ")]:_vm._e(),_vm._v(" "),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.rouBetType] && event.od[_vm.firstHtPlyType][_vm.rouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rhmg1x2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType]['oddsh'])?[_vm._v("\n                                                    "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_1HT'])+"\n                                                  ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rhmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType]['oddsa'])?[_vm._v("\n                                                    "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_2HT'])+"\n                                                  ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rhmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType] && event.od[_vm.ftPlyType][_vm.rhmg1x2BetType]['oddsd'])?[_vm._v("\n                                                      "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW'])+"\n                                                    ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.rhmg1x2BetType}}):_vm._e()],1)])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rhtgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhtgBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.rhtgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.rhtgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rhtgBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.rhtgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.rhtgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ratgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ratgBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ratgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.ratgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ratgBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ratgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.ratgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rbttsBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rbttsBetType] && event.od[_vm.ftPlyType][_vm.rbttsBetType]['oddsh'])?[_vm._v("\n                                                    "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rbttsBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rbttsBetType] && event.od[_vm.ftPlyType][_vm.rbttsBetType]['oddsa'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rbttsBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rtwfbBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType]['oddsh'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rtwfbBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType] && event.od[_vm.ftPlyType][_vm.rtwfbBetType]['oddsa'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rtwfbBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.roeBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.roeBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamOdd",refInFor:true,attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.roeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.roeBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamEven",refInFor:true,attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.roeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.rcshBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rcshBetType] && event.od[_vm.ftPlyType][_vm.rcshBetType]['oddsh'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.rcshBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.rcshBetType] && event.od[_vm.ftPlyType][_vm.rcshBetType]['oddsh'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.rcshBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2)]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1, true)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.enterAllBet(event,2, true)}}})]):_vm._e()])]):_vm._e()],1)]:_vm._e()})]:[_vm._l((_vm.getSubMatchCount(event['od'][_vm.getFullTime(event['od'])])),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"widthL":_vm.widthColumn[0],"plyType":_vm.ftPlyType,"isRB":false}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap cmh",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.mlBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(3,true),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rmlBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(4,true),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rmlBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.hdpBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.getFullTime(event['od']),"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.getFullTime(event['od']),"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.ouBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.ouBetType])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.ouBetType])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.oeBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.oeBetType])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.ODD'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.roeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.oeBetType])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.EVEN'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.roeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"media-col c-os2"},[(subMatchKey==0)?_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""},on:{"click":function($event){return _vm.enterAllBet(event,2)}}})]):_vm._e()]):_vm._e()])],1)]:_vm._e()})],_vm._v(" "),(_vm.selectedBettype.tmpltId == '1' && sportObjKey == 'N1' && _vm.chkMoreBetExist(event, true))?_c('moreBetComponent',{attrs:{"event":event,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold}}):_vm._e(),_vm._v(" "),(sportObjKey != 'N1')?_c('moreBetComponent_os',{attrs:{"event":event}}):_vm._e()],2)])])])]):_c('simpleSoccer',{attrs:{"event":event,"isRB":true,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold,"firstEventEveid":_vm.firstEventEveid,"livetvEveid":_vm.livetvEveid}})]:_vm._e()})]:_vm._e()]:_vm._e()]})]:_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),((_vm.sortedEventList && Object.keys(_vm.sortedEventList).length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.tdyMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showhideAll)?[_vm._l((_vm.sortedEventList),function(sportObj,sportObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap matc-type-card",staticStyle:{"height":"40px !important"},style:({'top':_vm.showFavEvents ? '35.5px':'121.5px'}),on:{"click":function($event){return _vm.showSport(sportObjKey, _vm.market.tdyMarket.key)}}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"match-type text-left yb-flex-between"},[_c('div',{staticClass:"col-left"},[_vm._v("\n                  "+_vm._s(_vm.getSportLang(sportObjKey))+"\n                  "),_c('span',{staticClass:"match-number"})])])])]),_vm._v(" "),(_vm.showLgeEve[sportObjKey] && !_vm.showLgeEve[sportObjKey].hide)?[_vm._l((sportObj),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important"},style:(_vm.getTop())},[_c('div',{key:eventObjKey,staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl0-bg",class:_vm.checkClass(_vm.showLgeEve[sportObjKey], eventObjKey),on:{"click":function($event){return _vm.showLeg(eventObjKey, false, sportObjKey)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width: (_vm.simpleSport==null)? _vm.widthColumn[2] + 'px':'700px' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full",attrs:{"title":eventObj[0].lgecapt}},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[(sportObjKey == 'N1')?[(_vm.simpleSport==null)?[_c('div',{staticClass:"col ellipsis bet-col0"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'])+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col1"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'])+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col2"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'])+"\n                          ")]),_vm._v(" "),(_vm.selectedLang == 1)?[_c('div',{staticClass:"col ellipsis bet-col3"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col4"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col5"},[_c('div',{staticClass:"double-row"},[_c('div',[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U']))]),_vm._v(" "),_c('div',{staticClass:"highlight-t"},[_vm._v("\n                                  "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'])+"\n                                ")])])]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._m(5,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME']))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY']))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TEAMGOAL']))])])]),_vm._v(" "),_vm._m(6,true),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._m(7,true)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]:[_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.1X2'])+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.HDP'])+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col3 highlight-t"},[_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.O.U'])+"\n                            ")]),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"col ellipsis bet-col6"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_HMG']))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col7"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.HTG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col8"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.ATG'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col9"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_BTTS']))]),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"col ellipsis bet-col10"},[_vm._v("  "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_TWFB'])+"  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col11"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE'])+" ")]),_vm._v(" "),_c('div',{staticClass:"col ellipsis bet-col12"},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_CSH'])+" ")])]:_vm._e()]]:_vm._e()]:(sportObjKey == 'G1')?[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_ML']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_HDP']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OU']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SUBHEADER_FT_OE']))])]:[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('ML')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('HDP')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('OU')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('OE')))])]],2),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[(false)?_c('div',{staticClass:"icon-wrap m-star-wrap-league",class:{ added: _vm.lgFavorite(eventObj[0].lgeid, sportObjKey, _vm.favouriteLgeEvents) },on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, sportObjKey, _vm.favouriteLgeEvents) }})]):_vm._e()])])])])]),_vm._v(" "),(_vm.showLgeEve[sportObjKey][eventObjKey])?[(!_vm.showLgeEve[sportObjKey][eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [(_vm.simpleSport==null)?_c('div',{ref:'eCardWrap'+event.eveid,refInFor:true,staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",style:(_vm.eventHeight(event, 'ecw')),attrs:{"id":'eCardWrap'+event.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{ref:'eCard'+event.eveid,refInFor:true,staticClass:"c-match-card relative-position evecard",style:(_vm.eventHeight(event, 'ec')),attrs:{"id":'eCard'+event.eveid}},[_c('div',{staticClass:"c-match-item more-handicap csid-1",class:event.sptid=='1'?'match-tpl0-bg':''},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[(sportObjKey=='N1')?[_vm._l(((event.sub + 1)),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"plyType":_vm.ftPlyType,"isRB":false,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.onex2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.onex2BetType] && event.od[_vm.ftPlyType][_vm.onex2BetType]['oddsh'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("1")]:[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.onex2BetType] && event.od[_vm.ftPlyType][_vm.onex2BetType]['oddsa'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.onex2BetType] && event.od[_vm.ftPlyType][_vm.onex2BetType]['oddsd'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.hdpBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ouBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ouBetType] && event.od[_vm.ftPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.ouBetType] && event.od[_vm.ftPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.onex2BetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType]['oddsh'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("1")]:[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOMEWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.firstHtPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType]['oddsa'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("2")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AWAYWIN']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.firstHtPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType] && event.od[_vm.firstHtPlyType][_vm.onex2BetType]['oddsd'])?[(_vm.selectedLang=='4' || _vm.selectedLang=='11')?[_vm._v("X")]:[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW']))]]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.firstHtPlyType,"betType":_vm.onex2BetType}}):_vm._e()],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.hdpBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.ouBetType+_vm.firstHtPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ouBetType] && event.od[_vm.firstHtPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(event.od[_vm.firstHtPlyType] && event.od[_vm.firstHtPlyType][_vm.ouBetType] && event.od[_vm.firstHtPlyType][_vm.ouBetType][_vm.getSMKey(subMatchKey)])?[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                              ")]:_vm._e(),_vm._v("\n                                               \n                                            ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.firstHtPlyType,"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.isUnfold)?[(_vm.widthColumn[3]==0)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.hmg1x2BetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType]['oddsh'])?[_vm._v("\n                                                    "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_1HT'])+"\n                                                  ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.hmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType]['oddsa'])?[_vm._v("\n                                                    "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_2HT'])+"\n                                                  ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.hmg1x2BetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?[(event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType] && event.od[_vm.ftPlyType][_vm.hmg1x2BetType]['oddsd'])?[_vm._v("\n                                                      "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_DRAW'])+"\n                                                    ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.ftPlyType,"betType":_vm.hmg1x2BetType}}):_vm._e()],1)])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.htgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.htgBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.htgBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.htgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.atgBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.atgBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"width":"min-content"}},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.atgBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0)?_c('over-under',{attrs:{"event":event,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.atgBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.bttsBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.bttsBetType] && event.od[_vm.ftPlyType][_vm.bttsBetType]['oddsh'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_YES'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.bttsBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.bttsBetType] && event.od[_vm.ftPlyType][_vm.bttsBetType]['oddsa'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_NO'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.bttsBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),(_vm.widthColumn[3]<2)?_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.twfbBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.twfbBetType] && event.od[_vm.ftPlyType][_vm.twfbBetType]['oddsh'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.twfbBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.twfbBetType] && event.od[_vm.ftPlyType][_vm.twfbBetType]['oddsa'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.twfbBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.oeBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.oeBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ODD'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamOdd",refInFor:true,attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.oeBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_EVEN'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd',{ref:"teamEven",refInFor:true,attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col",attrs:{"id":'handicapCol'+event.eveid+_vm.cshBetType+_vm.ftPlyType+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey==0 && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.cshBetType] && event.od[_vm.ftPlyType][_vm.cshBetType]['oddsh'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOME'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team1",refInFor:true,attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.ftPlyType,"betType":_vm.cshBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(subMatchKey == 0  && event.od[_vm.ftPlyType] && event.od[_vm.ftPlyType][_vm.cshBetType] && event.od[_vm.ftPlyType][_vm.cshBetType]['oddsa'])?[_vm._v("\n                                                  "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_AWAY'])+"\n                                                ")]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('odd1x2',{ref:"team2",refInFor:true,attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.ftPlyType,"betType":_vm.cshBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()],2)]:_vm._e()],2)]),_vm._v(" "),(subMatchKey==0)?_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"})])]):_vm._e()],1)]:_vm._e()})]:[_vm._l((_vm.getSubMatchCount(event['od'][_vm.getFullTime(event['od'])])),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"widthL":_vm.widthColumn[0],"plyType":_vm.ftPlyType,"isRB":false}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap cmh",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.mlBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(8,true),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.getFullTime(event['od']),"betType":_vm.mlBetType}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(9,true),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.getFullTime(event['od']),"betType":_vm.mlBetType}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.hdpBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.ouBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.ouBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.ouBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2",attrs:{"id":'handicapCol'+event.eveid+_vm.oeBetType+_vm.getFullTime(event['od'])+_vm.subMatchKeyCap[subMatchKey]}},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.oeBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.ODD'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.oeBetType])?[_vm._v("\n                                                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.EVEN'])+"\n                                                ")]:_vm._e(),_vm._v("\n                                                 \n                                              ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"media-col c-os2"},[(subMatchKey==0)?_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""},on:{"click":function($event){return _vm.enterAllBet(event,2)}}})]):_vm._e()]):_vm._e()])],1)]:_vm._e()})],_vm._v(" "),(_vm.chkMoreBetExist(event)  && sportObjKey == 'N1')?_c('moreBetComponent',{attrs:{"event":event,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold}}):_vm._e(),_vm._v(" "),(sportObjKey != 'N1')?_c('moreBetComponent_os',{attrs:{"event":event}}):_vm._e()],2)])])])]):_c('simpleSoccer',{attrs:{"event":event,"isRB":false,"widthColumn":_vm.widthColumn,"isUnfold":_vm.isUnfold,"firstEventEveid":_vm.firstEventEveid,"livetvEveid":_vm.livetvEveid}})]})]:_vm._e()]:_vm._e()]})]:_vm._e()]})]:_vm._e()]:_vm._e()]:_vm._e(),_vm._v(" "),((_vm.sortedEventList && Object.keys(_vm.sortedEventList).length > 0))?_c('div',{},[_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('div',{staticClass:"pager-wrap vrow justify-end"},[_c('div',{staticClass:"go-top-btn yb-flex-center",on:{"click":_vm.backtoTop}},[_c('i',{staticClass:"q-icon icon-go_top c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"vmsg"},[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.BACK_TOP']))])])])]):_vm._e(),_vm._v(" "),_vm._m(10)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("Half With ")]),_vm._v(" "),_c('div',{},[_vm._v(" Most Goals")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col ellipsis bet-col9"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("Both Teams")]),_vm._v(" "),_c('div',{},[_vm._v(" To Scores")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("To Win")]),_vm._v(" "),_c('div',{},[_vm._v(" From Behind")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("Half With ")]),_vm._v(" "),_c('div',{},[_vm._v(" Most Goals")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col ellipsis bet-col9"},[_c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("Both Teams")]),_vm._v(" "),_c('div',{},[_vm._v(" To Scores")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-row"},[_c('div',{},[_vm._v("To Win")]),_vm._v(" "),_c('div',{},[_vm._v(" From Behind")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute-full resize-observer-wrap"},[_c('div',{staticClass:"absolute-full expand"}),_vm._v(" "),_c('div',{staticClass:"absolute-full shrink"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerCorrectScore_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02446c45_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerCorrectScore_vue__ = __webpack_require__(458);
function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerCorrectScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02446c45_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerCorrectScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"showtable"}},[(_vm.selectedMarket=='1' && Object.keys(_vm.sortedRBEventList).length > 0)?[_c('todayHeader',{attrs:{"marketType":_vm.market.inPlayMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showRBhideAll)?[_vm._l((_vm.sortedRBEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"top":"73.5px"},style:({'height':!_vm.showRBLgeEve[eventObjKey].hide ? '56px':'39px', 'top':_vm.selectedMarket==_vm.market.tdyMarket.key ? '76.5px':'89.5px'})},[_c('div',{key:eventObjKey,staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl21-bg",class:{ 'match-tpl21': !_vm.showRBLgeEve[eventObjKey].hide, 'leagues-pack': _vm.showRBLgeEve[eventObjKey].hide },on:{"click":function($event){return _vm.showLeg(eventObjKey, true)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width: _vm.widthColumn[2] + 'px !important' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.FULL_TIME']))]),_vm._v(" "),_c('div',{staticClass:"col bet-col4 y0-col4"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.FIRST_HALF'])+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league",class:{ added: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) },on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) }})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showRBLgeEve[eventObjKey].hide),expression:"!showRBLgeEve[eventObjKey].hide"}],staticClass:"tr-col-name"},[_c('div',{staticClass:"leagues-wrap2",style:({ width: (_vm.widthColumn[2]) + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.HOMEWIN']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.DRAW']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.AWAYWIN']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.HOMEWIN']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.DRAW']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.AWAYWIN']))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"42px !important"}})])])])]),_vm._v(" "),(!_vm.showRBLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return (eventKey!='hide')?[_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position",staticStyle:{"height":"391px !important"}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-card relative-position",staticStyle:{"height":"391px !important"}},[_c('div',{staticClass:"c-match-item tpl-21 csid-1"},[_c('div',{staticClass:"process-col"},[_c('div',{staticClass:"yb-flex-center full-width",staticStyle:{"height":"105px"}},[_c('sportTime',{attrs:{"event":event}})],1)]),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","plyType":_vm.ftPlyType,"isRB":true,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_vm._l((_vm.fthtptype),function(ptype){return [_vm._l((_vm.itemsRow),function(oddcaptData,n){return [_c('div',{staticClass:"handicap-col"},[_vm._l((oddcaptData),function(oddcapt){return [(_vm.excludeHT(oddcapt, ptype))?[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon",class:'bet-cs-'+ptype},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("\n                                              "+_vm._s(_vm.getCSLabel(oddcapt))+"\n                                            ")])]),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":oddcapt,"plyType":ptype,"betType":_vm.rbbtype,"decimalNumber":1}})],1)])]:(n == 0 && oddcapt == 'aos')?[_c('div',{staticClass:"bet-item-wrap col3 absolute aosnoflex",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*3) + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon",class:'bet-cs-'+ptype},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text AOS"},[_vm._v("\n                                              "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AOS'])+"\n                                            ")])]),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'aos',"plyType":ptype,"betType":_vm.rbbtype,"decimalNumber":1}})],1)])]:((n == 1 || n == 2) && oddcapt == 'odempty')?[_c('div',{staticClass:"bet-item-wrap e",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:((n == 1 || n == 2) && oddcapt == 'odlast')?[_c('div',{staticClass:"bet-item-wrap visibility",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:((!_vm.excludeHT(oddcapt, ptype) && oddcapt!='aos'))?[_c('div',{staticClass:"bet-item-wrap na",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()]})],2)]})]})],2)]),_vm._v(" "),_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.enterAllBet(event,2)}}})]):_vm._e()])])],1)])])])])])]:_vm._e()})]:_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),((Object.keys(_vm.sortedEventList).length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.tdyMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showhideAll)?[_vm._l((_vm.sortedEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",style:({'height':!_vm.showLgeEve[eventObjKey].hide ? '56px':'39px', 'top':_vm.selectedMarket==_vm.market.tdyMarket.key ? '73.5px':'89.5px'})},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl21-bg",class:{'match-tpl21': !_vm.showLgeEve[eventObjKey].hide, 'leagues-pack': _vm.showLgeEve[eventObjKey].hide },on:{"click":function($event){return _vm.showLeg(eventObjKey, false)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width: _vm.widthColumn[2] + 'px !important' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.FULL_TIME']))]),_vm._v(" "),_c('div',{staticClass:"col bet-col4 y0-col4"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.FIRST_HALF'])+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league",class:{ added: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) },on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) }})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLgeEve[eventObjKey].hide),expression:"!showLgeEve[eventObjKey].hide"}],staticClass:"tr-col-name"},[_c('div',{staticClass:"leagues-wrap2",style:({ width: (_vm.widthColumn[2]) + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.HOMEWIN']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.DRAW']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.AWAYWIN']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.HOMEWIN']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.DRAW']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_2.AWAYWIN']))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"42px !important"}})])])])]),_vm._v(" "),(!_vm.showLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position",staticStyle:{"height":"391px !important"}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-card relative-position",staticStyle:{"height":"391px !important"}},[_c('div',{staticClass:"c-match-item tpl-21 csid-1"},[_c('div',{staticClass:"process-col"},[_c('div',{staticClass:"yb-flex-center full-width",staticStyle:{"height":"105px"}},[_c('sportTime',{attrs:{"event":event}})],1)]),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","plyType":_vm.ftPlyType,"isRB":false,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_vm._l((_vm.fthtptype),function(ptype){return [_vm._l((_vm.itemsRow),function(oddcaptData,n){return [_c('div',{staticClass:"handicap-col"},[_vm._l((oddcaptData),function(oddcapt){return [(_vm.excludeHT(oddcapt, ptype))?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon",class:'bet-cs-'+ptype},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v("\n                                              "+_vm._s(_vm.getCSLabel(oddcapt))+"\n                                            ")])]),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":oddcapt,"plyType":ptype,"betType":_vm.btype,"decimalNumber":1}})],1)])]:(n == 0 && oddcapt == 'aos')?[(ptype == 2)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),(ptype == 2)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),(ptype == 2)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),(ptype == 2)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap col3 absolute",staticStyle:{"height":"35px !important"},style:({ width: (_vm.widthColumn[1]*3) + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon",class:'bet-cs-'+ptype},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text AOS"},[_vm._v("\n                                              "+_vm._s(_vm.lang.sportAllBet['ALL_BET.LBL_AOS'])+"\n                                            ")])]),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'aos',"plyType":ptype,"betType":_vm.btype,"decimalNumber":1}})],1)])]:((n == 1 || n == 2) && oddcapt == 'odempty')?[(ptype == 2 && n == 1)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]):_vm._e(),_vm._v(" "),(ptype == 1 && n == 1)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e()]:((n == 1 || n == 2) && oddcapt == 'odlast')?[(ptype == 2 && n == 2)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),(ptype == 2 && n == 2)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),(ptype == 2 && n == 2)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),(ptype == 2 && n == 2)?_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap visibility",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:((!_vm.excludeHT(oddcapt, ptype) && !oddcapt=='aos'))?[_c('div',{staticClass:"bet-item-wrap b",staticStyle:{"height":"35px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })})]:_vm._e()]})],2)]})]})],2)]),_vm._v(" "),_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon non-rb",attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']}})]):_vm._e()])])],1)])])])])])]})]:_vm._e()]})]:_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerTotalGoal_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e2406e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerTotalGoal_vue__ = __webpack_require__(461);
function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerTotalGoal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e2406e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerTotalGoal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"showtable"}},[(_vm.selectedMarket=='1' && (Object.keys(_vm.sortedRBEventList).length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.inPlayMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showRBhideAll)?[_vm._l((_vm.sortedRBEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"top":"73.5px"},style:({'height':!_vm.showRBLgeEve[eventObjKey].hide ? '56px':'39px'})},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl5-bg",class:{'match-tpl5': !_vm.showRBLgeEve[eventObjKey].hide, 'leagues-pack': _vm.showRBLgeEve[eventObjKey].hide },on:{"click":function($event){return _vm.showLeg(eventObjKey, true)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width: _vm.widthColumn[2] + 'px !important' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.FT_TG']))]),_vm._v(" "),_c('div',{staticClass:"col bet-col4 y0-col4"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.1H_TG']))])]),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showRBLgeEve[eventObjKey].hide),expression:"!showRBLgeEve[eventObjKey].hide"}],staticClass:"tr-col-name"},[_c('div',{style:({ width: _vm.widthColumn[2] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.0-1']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.2-3']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.4-6']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.7_ABOVE']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.0']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.1']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.2']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.3_ABOVE']))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"42px !important"}})])])])]),_vm._v(" "),(!_vm.showRBLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position",staticStyle:{"height":"111px !important"}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-card relative-position",staticStyle:{"height":"111px !important"}},[_c('div',{staticClass:"c-match-item tpl-5 csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","plyType":_vm.ftPlyType,"isRB":true,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_vm._l((_vm.fthtptype),function(ptyped){return [_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon"},[_vm._m(1,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'tg01',"plyType":ptyped,"betType":_vm.rbbettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon"},[_vm._m(2,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'tg23',"plyType":ptyped,"betType":_vm.rbbettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon"},[_vm._m(3,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'tg456',"plyType":ptyped,"betType":_vm.rbbettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon"},[_vm._m(4,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'tg7',"plyType":ptyped,"betType":_vm.rbbettype,"decimalNumber":0}})],1)])])]})],2),_vm._v(" "),_vm._m(5,true)]),_vm._v(" "),_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.enterAllBet(event,2)}}})]):_vm._e()])])],1)])])])])])]})]:_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),((Object.keys(_vm.sortedEventList).length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.tdyMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showhideAll)?[_vm._l((_vm.sortedEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",style:({'height':!_vm.showLgeEve[eventObjKey].hide ? '56px':'39px', 'top':_vm.selectedMarket==_vm.market.tdyMarket.key ? '73.5px':'89.5px'})},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl5-bg",class:{ 'match-tpl5': !_vm.showLgeEve[eventObjKey].hide, 'leagues-pack': _vm.showLgeEve[eventObjKey].hide },on:{"click":function($event){return _vm.showLeg(eventObjKey, false)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width: _vm.widthColumn[2] + 'px !important' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.FT_TG']))]),_vm._v(" "),_c('div',{staticClass:"col bet-col4 y0-col4"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.1H_TG']))])]),_vm._v(" "),_vm._m(6,true)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLgeEve[eventObjKey].hide),expression:"!showLgeEve[eventObjKey].hide"}],staticClass:"tr-col-name"},[_c('div',{style:({ width: _vm.widthColumn[2] + 'px !important' })}),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.0-1']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.2-3']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.4-6']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.7_ABOVE']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.0']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.1']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.2']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_3.3_ABOVE']))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"42px !important"}})])])])]),_vm._v(" "),(!_vm.showLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position",staticStyle:{"height":"111px !important"}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-card relative-position",staticStyle:{"height":"111px !important"}},[_c('div',{staticClass:"c-match-item tpl-5 csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","plyType":_vm.ftPlyType,"isRB":false,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_vm._l((_vm.fthtptype),function(ptyped){return [_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-tg-'+ptyped},[_vm._m(7,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'tg01',"plyType":ptyped,"betType":_vm.bettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-tg-'+ptyped},[_vm._m(8,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'tg23',"plyType":ptyped,"betType":_vm.bettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-tg-'+ptyped},[_vm._m(9,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'tg456',"plyType":ptyped,"betType":_vm.bettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-tg-'+ptyped},[_vm._m(10,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'tg7',"plyType":ptyped,"betType":_vm.bettype,"decimalNumber":0}})],1)])])]})],2),_vm._v(" "),_vm._m(11,true)]),_vm._v(" "),_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon non-rb",attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']}})]):_vm._e()])])],1)])])])])])]})]:_vm._e()]})]:_vm._e()]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league"},[_c('i',{staticClass:"icon-star q-icon c-icon"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score-more",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"mfo"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league"},[_c('i',{staticClass:"icon-star q-icon c-icon"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score-more",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"mfo"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerHTFT_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37dc7dc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerHTFT_vue__ = __webpack_require__(464);
function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_soccerHTFT_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37dc7dc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_soccerHTFT_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"showtable"}},[((Object.keys(_vm.sortedRBEventList).length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.inPlayMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showRBhideAll)?[_vm._l((_vm.sortedRBEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important","top":"73.5px"}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl2-bg",class:{ 'match-tpl2': !_vm.showRBLgeEve[eventObjKey].hide, 'leagues-pack': _vm.showRBLgeEve[eventObjKey].hide },on:{"click":function($event){return _vm.showLeg(eventObjKey, true)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width:  _vm.widthColumn[2] + 'px !important' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[[_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.H/H']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.H/D']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.H/A']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.D/H']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.D/D']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.D/A']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.A/H']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.A/D']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.A/A']))])]],2),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"42px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league",on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) }})])])])])])]),_vm._v(" "),(!_vm.showRBLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position",staticStyle:{"height":"111px !important"}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-card relative-position",staticStyle:{"height":"111px !important"}},[_c('div',{staticClass:"c-match-item tpl-2 csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","plyType":_vm.ftPlyType,"isRB":true,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(0,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'hh',"plyType":_vm.playtype,"betType":_vm.rbbettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(1,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'hd',"plyType":_vm.playtype,"betType":_vm.rbbettype,"decimalNumber":0}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(2,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'ha',"plyType":_vm.playtype,"betType":_vm.rbbettype,"decimalNumber":0}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(3,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'dh',"plyType":_vm.playtype,"betType":_vm.rbbettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(4,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'dd',"plyType":_vm.playtype,"betType":_vm.rbbettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(5,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'da',"plyType":_vm.playtype,"betType":_vm.rbbettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(6,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'ah',"plyType":_vm.playtype,"betType":_vm.rbbettype,"decimalNumber":0}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(7,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'ad',"plyType":_vm.playtype,"betType":_vm.rbbettype,"decimalNumber":0}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(8,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'aa',"plyType":_vm.playtype,"betType":_vm.rbbettype}})],1)])])]),_vm._v(" "),_vm._m(9,true)]),_vm._v(" "),_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.enterAllBet(event,2)}}})]):_vm._e()])])],1)])])])])])]})]:_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),((Object.keys(_vm.sortedEventList).length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.tdyMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showhideAll)?[_vm._l((_vm.sortedEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important"},style:({'top':_vm.selectedMarket==_vm.market.tdyMarket.key ? '76.5px':'89.5px'})},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl2-bg",class:{ 'match-tpl2': !_vm.showLgeEve[eventObjKey].hide, 'leagues-pack': _vm.showLgeEve[eventObjKey].hide },on:{"click":function($event){return _vm.showLeg(eventObjKey, false)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",style:({ width:  _vm.widthColumn[2] + 'px !important' })},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[[_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.H/H']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.H/D']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.H/A']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.D/H']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.D/D']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.D/A']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.A/H']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.A/D']))]),_vm._v(" "),_c('div',{staticClass:"col ellipsis"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_4.A/A']))])]],2),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"42px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league",on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) }})])])])])])]),_vm._v(" "),(!_vm.showLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position",staticStyle:{"height":"111px !important"}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-card relative-position",staticStyle:{"height":"111px !important"}},[_c('div',{staticClass:"c-match-item tpl-2 csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","plyType":_vm.ftPlyType,"isRB":false,"widthL":_vm.widthColumn[0]}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(10,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'hh',"plyType":_vm.playtype,"betType":_vm.bettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(11,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'hd',"plyType":_vm.playtype,"betType":_vm.bettype,"decimalNumber":0}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(12,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'ha',"plyType":_vm.playtype,"betType":_vm.bettype,"decimalNumber":0}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(13,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'dh',"plyType":_vm.playtype,"betType":_vm.bettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(14,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'dd',"plyType":_vm.playtype,"betType":_vm.bettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(15,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'da',"plyType":_vm.playtype,"betType":_vm.bettype}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(16,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'ah',"plyType":_vm.playtype,"betType":_vm.bettype,"decimalNumber":0}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(17,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'ad',"plyType":_vm.playtype,"betType":_vm.bettype,"decimalNumber":0}})],1)])]),_vm._v(" "),_c('div',{staticClass:"handicap-col"},[_c('div',{staticClass:"bet-item-wrap aosnoflex",staticStyle:{"height":"70px !important"},style:({ width: _vm.widthColumn[1] + 'px !important' })},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon",class:'bet-htft-'+_vm.playtype},[_vm._m(18,true),_vm._v(" "),_c('cstgftht',{attrs:{"event":event,"score":'aa',"plyType":_vm.playtype,"betType":_vm.bettype}})],1)])])]),_vm._v(" "),_vm._m(19,true)]),_vm._v(" "),_c('div',{staticClass:"media-col"},[_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon non-rb",attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']}})]):_vm._e()])])],1)])])])])])]})]:_vm._e()]})]:_vm._e()]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score-more",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"mfo"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value"},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score-more",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"mfo"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_otherSportCommon2_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0648f48f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_otherSportCommon2_vue__ = __webpack_require__(470);
function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_otherSportCommon2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0648f48f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_otherSportCommon2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_otherSportAllCommon2_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88f4748e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_otherSportAllCommon2_vue__ = __webpack_require__(469);
function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_otherSportAllCommon2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88f4748e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_otherSportAllCommon2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details relative-position"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wrap-handicap v-scroll-area-bar"},[_c('div',{staticClass:"screen"},[_c('div',{staticClass:"v-scroll-area fit vrow relative-position"},[_c('div',{staticClass:"content-wrap fit"},[_c('div',{staticClass:"scroll-header absolute"},[_c('div',{staticClass:"wrap-title"},[_c('div',{staticClass:"group-back cursor-pointer",on:{"click":_vm.backToMain}},[_c('i',{staticClass:"back q-icon icon-back c-icon set-color",staticStyle:{"color":"rgb(171, 186, 200)"},attrs:{"aria-hidden":"true","role":"presentation"}})]),_vm._v(" "),_c('div',{staticClass:"title ellipsis allow-user-select",domProps:{"innerHTML":_vm._s(_vm.sortedMatchEventList.lgecapt)}}),_vm._v(" "),_c('div',{staticClass:"right-icon"},[_c('div',{staticClass:"refresh"},[_c('div',{staticClass:"c-refresh fit yb-flex-center cursor-pointer"},[_c('div',{staticClass:"icon-wrap",on:{"click":function($event){return _vm.refreshTbl(_vm.token.arr_5)}}},[_vm._m(1)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"head-info relative-position esports-head-info-1",staticStyle:{"background":"url(\"/2023-02-08-15-36-19/images/football.c5dcdf96.png\") center center"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"hide-btn"},[_vm._v("隐藏")])]),_vm._v(" "),_c('div',{staticClass:"scroll-fixed-header wrap-tabs"},[_c('div',{staticClass:"tabs-panel relative-position"},[_c('div',{staticClass:"tab-wrap fit relative-position"},[_c('div',{staticClass:"item-wrap relative-position",staticStyle:{"left":"0px"}},[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.hot.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.hot)}}},[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HOT'])+"\n                    ")]),_vm._v(" "),(_vm.selectedBettype.tmpltId == '8')?[(_vm.selectedBettype.sprtId == 'G1')?void 0:(_vm.selectedBettype.sprtId == 'N3')?[_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.sethdp.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.sethdp)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SET'])+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.gamehdp.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.gamehdp)}}},[_vm._v("\n                          "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_GAME'])+"\n                        ")])]:(_vm.selectedBettype.sprtId == 'N12')?void 0:(_vm.selectedBettype.sprtId == 'N24')?void 0:(_vm.selectedBettype.sprtId == 'N15')?void 0:_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center",class:{ active: (_vm.selectedBetTab == _vm.betTab.all.key) },on:{"click":function($event){return _vm.chooseBetTab(_vm.betTab.all)}}},[_vm._v("\n                      "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_ALLBET'])+"\n                    ")])],2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"vrow"},[_c('div',{staticClass:"right-icons",on:{"click":function($event){return _vm.foldopenAB()}}},[_c('i',{staticClass:"q-icon c-icon set-color",class:{ 'icon-hide': _vm.foldopenAllBet, 'icon-open': !_vm.foldopenAllBet },staticStyle:{"color":"rgb(90, 96, 116)","font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation","data-title":"dadw"}})])])])]),_vm._v(" "),_c('div',{staticClass:"fit v-scrollarea q-scrollarea"},[_c('div',{staticClass:"q-scrollarea__container scroll relative-position fit hide-scrollbar"},[_c('div',{staticClass:"q-scrollarea__content absolute"},[_c('div',{staticClass:"middle-content",staticStyle:{"padding-top":"76px","padding-bottom":"0px"}},[_c('div',{staticClass:"scroll-inner-wrap fit"},[_c('div',{staticClass:"col wrap-scroll"},[_c('div',{staticClass:"column fit"},[_c('div',{staticClass:"wrap-handicap relative-position details-handicap",attrs:{"screen":"match-list"}},[_c('div',{staticClass:"template-handicap",attrs:{"id":"_handicap_list_wrap"}},[_c('div',{staticClass:"details_data"},[_c('div',{staticClass:"group-flex",attrs:{"id":"_handicap_list"}},[_c('allBetComponent',{attrs:{"selTab":_vm.selectedBetTab,"betTab":_vm.betTab}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('div',{staticStyle:{"height":"152px"}},[_c('div',{staticClass:"go-top to-top"},[_c('div',{staticClass:"go-top-btn",on:{"click":function($event){return _vm.backtoTop()}}},[_c('i',{staticClass:"q-icon icon-go_top c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"vmsg"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.BACK_TOP']))])])])])]),_vm._v(" "),_c('div',{staticClass:"null-bg",staticStyle:{"display":"none"}})])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__bar q-scrollarea__bar--v absolute-right",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__bar q-scrollarea__bar--h absolute-bottom q-scrollarea__bar--invisible",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__thumb q-scrollarea__thumb--v absolute-right",staticStyle:{"right":"-10.5px","top":"0px","height":"45px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom q-scrollarea__thumb--invisible",staticStyle:{"right":"-10.5px","left":"0px","width":"902px"},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"scroll-footer",staticStyle:{"bottom":"0px"}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-data-wrap col is-detail details_data_load",staticStyle:{"margin-top":"266px","display":"none"}},[_c('div',{staticClass:"fit"}),_vm._v(" "),_c('div',{staticClass:"column yb-flex-center empty"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-balance_refresh"},[_c('span',{staticClass:"path1"}),_vm._v(" "),_c('span',{staticClass:"path2"}),_vm._v(" "),_c('span',{staticClass:"path3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right_match_info info-upd full-width vrow justify-center"},[_c('div',{staticClass:"before"},[_c('div',{staticClass:"content",staticStyle:{"box-shadow":"rgba(0, 0, 0, 0.3) 0px 1px 15px 0px"}},[_c('div',{staticClass:"team"},[_c('div',{staticClass:"home"},[_c('div',{staticClass:"team_name home-name allow-user-select"},[_vm._v("阿拉尼亚体育")]),_vm._v(" "),_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"team_logo",staticStyle:{"opacity":"1"},attrs:{"src":"https://image.gredfged.com/group1/M00/00/28/CgURtV7qy6SAIokeAAAjAmZd3ko954.png","alt":"","data-team":"A","data-csid":"1"}})])]),_vm._v(" "),_c('div',{staticClass:"match_time"},[_c('div',{staticClass:"c-match-process text-center match_time-text vrow a-row"},[_c('div',{staticClass:"jingcai",staticStyle:{"display":"none"}}),_vm._v(" "),_c('div',{staticClass:"process-name",staticStyle:{"display":"none"}},[_vm._v("未开赛")]),_vm._v(" "),_c('div',{staticClass:"c-match-date text-center date-wrap"},[_c('span',{staticStyle:{"min-width":"60px"}},[_vm._v("03月04日 "),_c('br')]),_vm._v(" "),_c('span',[_vm._v("01:00")])])])]),_vm._v(" "),_c('div',{staticClass:"away"},[_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"team_logo",staticStyle:{"opacity":"1"},attrs:{"src":"https://image.gredfged.com/group1/M00/12/70/CgURtmE22ViARqGwAAAahU51FMk689.png","alt":"","data-team":"Y","data-csid":"1"}})]),_vm._v(" "),_c('div',{staticClass:"team_name away-name allow-user-select"},[_vm._v("伊斯坦布尔BFK")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-btn btn",staticStyle:{"display":"none"}},[_c('div',{staticClass:"yb-icon-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-btn btn",staticStyle:{"display":"none"}},[_c('div',{staticClass:"yb-icon-arrow"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"showtable"}},[(!_vm.selectedMatchAllBet)?[(_vm.selectedMarket=='1' && _vm.sortedRBEventList && (_vm.sortedRBEventList.length > 0 || Object.keys(_vm.sortedRBEventList).length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.inPlayMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showRBhideAll)?[_vm._l((_vm.sortedRBEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important","top":"73.5px"}},[_c('div',{key:eventObjKey,staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl0-bg",class:{ 'match-tpl0': !_vm.showRBLgeEve[eventObjKey].hide, 'leagues-pack': _vm.showRBLgeEve[eventObjKey].hide },on:{"click":function($event){return _vm.showLeg(eventObjKey, true)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",staticStyle:{"width":"315px !important"}},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[(_vm.selectedBettype.sprtId == 'G1' || _vm.selectedBettype.sprtId == 'N1')?[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.ML']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.HDP']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.OU']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.O/E']))])]:[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('ML')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('HDP')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('O/U')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('O/E')))])]],2),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league",class:{ added: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) },on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '1', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) }})])])])])])]),_vm._v(" "),(!_vm.showRBLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [(_vm.checkEventPlyTypExist2(event))?[_c('div',{ref:'eCardWrap'+event.eveid,refInFor:true,staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",style:(_vm.eventHeight(event, 'ecw')),attrs:{"id":'eCardWrap'+event.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{ref:'eCard'+event.eveid,refInFor:true,staticClass:"c-match-card relative-position evecard",style:(_vm.eventHeight(event, 'ec')),attrs:{"id":'eCard'+event.eveid}},[_c('div',{staticClass:"c-match-item more-handicap csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_vm._l((_vm.getSubMatchCount(event['od'][_vm.getFullTime(event['od'])])),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"plyType":_vm.ftPlyType,"isRB":true}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap cmh",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col hc-os2"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(0,true),_vm._v(" "),(event.sptid!=_vm.os1x2)?[(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rmlBetType}}):_vm._e()]:[(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ronex2BetType}}):_vm._e()]],2)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(1,true),_vm._v(" "),(event.sptid!=_vm.os1x2)?[(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rmlBetType}}):_vm._e()]:[(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ronex2BetType}}):_vm._e()]],2)]),_vm._v(" "),(event.sptid==_vm.os1x2 && subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(2,true),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ronex2BetType}}):_vm._e()],1)])]:_vm._e(),_vm._v(" "),(event.sptid!=_vm.os1x2 && subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.getFullTime(event['od']),"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.getFullTime(event['od']),"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rhdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.rouBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.rouBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.rouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.roeBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.ODD'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.roeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.roeBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.EVEN'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.roeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"media-col c-os2"},[(subMatchKey==0)?_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1, true)}}})]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center"}),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",class:{ active: _vm.livetvEveid== event.eveid},attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.enterAllBet(event,2, true)}}})]):_vm._e()]):_vm._e()])],1)]:_vm._e()}),_vm._v(" "),_c('moreBetComponent',{attrs:{"event":event}})],2)])])])])]:_vm._e()]})]:_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),((_vm.sortedEventList && (_vm.sortedEventList.length > 0 || Object.keys(_vm.sortedEventList).length > 0)))?[_c('todayHeader',{attrs:{"marketType":_vm.market.tdyMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showhideAll)?[_vm._l((_vm.sortedEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important"},style:(_vm.getTop())},[_c('div',{key:eventObjKey,staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl0-bg",class:{ 'match-tpl0': !_vm.showLgeEve[eventObjKey].hide, 'leagues-pack': _vm.showLgeEve[eventObjKey].hide },on:{"click":function($event){return _vm.showLeg(eventObjKey, false)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",staticStyle:{"width":"315px !important"}},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"},[(_vm.selectedBettype.sprtId == 'G1')?[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.ML']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.HDP']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.OU']))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.O/E']))])]:[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('ML')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('HDP')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('O/U')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.getBetCaption('O/E')))])]],2),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}},[_c('div',{staticClass:"icon-wrap m-star-wrap-league",class:{ added: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) },on:{"click":function($event){return _vm.favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)}}},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.lgFavorite(eventObj[0].lgeid, _vm.selectedBettype.sprtId, _vm.favouriteLgeEvents) }})])])])])])]),_vm._v(" "),(!_vm.showLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [(_vm.checkEventPlyTypExist2(event))?[_c('div',{ref:'eCardWrap'+event.eveid,refInFor:true,staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",style:(_vm.eventHeight(event, 'ecw')),attrs:{"id":'eCardWrap'+event.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{ref:'eCard'+event.eveid,refInFor:true,staticClass:"c-match-card relative-position evecard",style:(_vm.eventHeight(event, 'ec')),attrs:{"id":'eCard'+event.eveid}},[_c('div',{staticClass:"c-match-item more-handicap csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap"},[_vm._l((_vm.getSubMatchCount(event['od'][_vm.getFullTime(event['od'])])),function(subMatch,subMatchKey){return (_vm.showSubMatch(subMatch, event, subMatchKey))?[_c('div',{staticClass:"match-handicap-item"},[_c('sportTeam',{attrs:{"event":event,"issc":true,"classes":"none","subMatchKey":subMatchKey,"plyType":_vm.ftPlyType,"isRB":false}}),_vm._v(" "),_c('div',{staticClass:"c-match-handicap cmh",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col hc-os2"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(3,true),_vm._v(" "),(event.sptid!=_vm.os1x2)?[(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.getFullTime(event['od']),"betType":_vm.mlBetType}}):_vm._e()]:[(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamHome,"plyType":_vm.getFullTime(event['od']),"betType":_vm.onex2BetType}}):_vm._e()]],2)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(4,true),_vm._v(" "),(event.sptid!=_vm.os1x2)?[(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.getFullTime(event['od']),"betType":_vm.mlBetType}}):_vm._e()]:[(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamAway,"plyType":_vm.getFullTime(event['od']),"betType":_vm.onex2BetType}}):_vm._e()]],2)]),_vm._v(" "),(event.sptid==_vm.os1x2 && subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon"},[_vm._m(5,true),_vm._v(" "),(subMatchKey == 0)?_c('odd1x2',{attrs:{"event":event,"team":_vm.teamDraw,"plyType":_vm.getFullTime(event['od']),"betType":_vm.onex2BetType}}):_vm._e()],1)])]:_vm._e(),_vm._v(" "),(event.sptid!=_vm.os1x2 && subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('handicap',{attrs:{"event":event,"favTeam":'b',"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.hdpBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(_vm.chkOddCaption(event, subMatchKey, _vm.ouBetType))?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.OVER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(_vm.chkOddCaption(event, subMatchKey, _vm.ouBetType))?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.UNDER'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_c('over-under',{attrs:{"event":event,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.ouBetType,"match":subMatchKey}})],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"handicap-col hc-os2"},[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.oeBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.ODD'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.getFullTime(event['od']),"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more"},[(subMatchKey == 0 && event.od[_vm.getFullTime(event['od'])] && event.od[_vm.getFullTime(event['od'])][_vm.oeBetType])?[_vm._v("\n                                              "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.EVEN'])+"\n                                            ")]:_vm._e(),_vm._v("\n                                             \n                                          ")],2),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})]),_vm._v(" "),(subMatchKey == 0)?_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.getFullTime(event['od']),"betType":_vm.oeBetType,"match":subMatchKey}}):_vm._e()],1)]),_vm._v(" "),(subMatchKey == 0)?[_c('div',{staticClass:"bet-item-wrap",staticStyle:{"height":"35px !important"}})]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"media-col c-os2"},[(subMatchKey==0)?_c('div',{staticClass:"media-col-wrap"},[_c('div',{staticClass:"icon-wrap after_tpl0 relative-position",class:{ active: (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) }},[_c('div',{staticClass:"v-icon switch-icon",class:{ active:  (_vm.firstEventEveid== event.eveid && _vm.livetvEveid!= event.eveid) },attrs:{"title":_vm.sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']},on:{"click":function($event){return _vm.enterAllBet(event,1)}}})]),_vm._v(" "),(_vm.tvIconFlag && event.ch>0)?_c('div',{staticClass:"icon-wrap relative-position",attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon non-rb",attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']}})]):_vm._e()]):_vm._e()])],1)]:_vm._e()}),_vm._v(" "),_c('moreBetComponent',{attrs:{"event":event}})],2)])])])])]:_vm._e()]})]:_vm._e()]})]:_vm._e()]:_vm._e()]:[_c('otherSportAllCommon2')],_vm._v(" "),((_vm.sortedEventList && Object.keys(_vm.sortedEventList).length > 0))?_c('div',{},[_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('div',{staticClass:"pager-wrap vrow justify-end"},[_c('div',{staticClass:"go-top-btn yb-flex-center",on:{"click":_vm.backtoTop}},[_c('i',{staticClass:"q-icon icon-go_top c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"vmsg"},[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.BACK_TOP']))])])])]):_vm._e(),_vm._v(" "),_vm._m(6)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute-full resize-observer-wrap"},[_c('div',{staticClass:"absolute-full expand"}),_vm._v(" "),_c('div',{staticClass:"absolute-full shrink"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportOutright_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61af8f39_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportOutright_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportOutright_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61af8f39_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportOutright_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_filters_vue_filter_number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_components_mini_bet__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(0);












__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('oddOutright', {
  components: {
    minibet: __WEBPACK_IMPORTED_MODULE_6__vue_components_mini_bet__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__["a" /* default */]],
  name: 'oddOutright',
  template: '\n    <div :id="getOddUniqueId(event)" class="odds" @click="onClickOdd($event);" :class="getClass(event, isNegative, isDiff)">\n      <template v-if="checkOddValidation(event.t[team].od)">\n        <span>\n          <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkOTRMiniBetUnique(event, getOddUniqueId(event))">\n            {{  getDecimalDisplay(betForm.odd) }}\n          </template>\n          <template v-else>\n            {{  getDecimalDisplay(event.t[team].od) }}\n          </template>\n        </span>\n      </template>\n      <div class="odds-arrows-wrap">\n        <div class="odds-icon odds-up"></div>\n        <div class="odds-icon odds-down"></div>\n      </div>\n    </div>\n  ',

  props: {
    event: null,
    team: null
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['sportMiniBet']), {
    betForm: function betForm() {
      return this.$store.getters.betForm[0];
    }
  }),
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (typeof val != 'undefined') {
          this.classNegative(val.t[this.team].od);
          if (oldVal && !this.refreshOdd) {
            this.refreshOdd = false;
            this.diffOdds(val.t[this.team].od, oldVal.t[this.team].od);
          } else if (this.refreshOdd) {
            this.refreshOdd = false;
            this.isDiff = false;
          } else if (!oldVal) {
            this.refreshOdd = true;
          }
        }
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      isNegative: false,
      isDiff: false,
      refreshOdd: false
    };
  },

  methods: {
    getClass: function getClass(windowEvent, isNeg, isDif) {
      var classStr = '';
      var classMini = '';

      return classStr + classMini;
    },
    onClickOdd: function onClickOdd(windowEvent) {
      var _betForm,
          _this = this;

      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('returnBetTab');
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return;
      }
      var betForm = (_betForm = {
        eveid: this.event.eveid,
        title: this.$store.getters.selectedBettype.sprtTitleLang,
        league: this.event.lgecapt + " - " + this.event.evecapt,
        sprtid: this.event.sptid
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'eveid', this.event.eveid), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'plyType', '0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'betType', this.otrBetType), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'tbet', this.event.t[this.team].tid), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'tbetcapt', this.event.t[this.team].tcapt), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'tbetid', this.event.t[this.team].tid), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'odd', this.event.t[this.team].od), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'rbscoa', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'rbscob', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'hdp', '0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'dual', 'a'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'fav', '0'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'eventObj', this.event), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_betForm, 'uniqueId', this.event.eveid + '1' + this.otrBetType + this.team + this.event.t[this.team].tid), _betForm);

      if (this.event.rb) {
        if (this.event.rbinfo) {
          betForm.rbscoa = this.event.rbinfo.scoa;
          betForm.rbscob = this.event.rbinfo.scob;
        }
      }

      if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {}

      var indexx = _.findIndex(this.$store.getters.betForm, {
        'eveid': this.event.eveid,
        'plyType': '0',
        'betType': this.otrBetType,
        'dual': 'a',
        'tbet': this.event.t[this.team].tid
      });

      if (indexx > -1) {
        var obj = { eveid: this.event.eveid };
        if (this.$store.getters.isBetCombo) {
          obj = { clearType: '3', index: indexx };
        }
        this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
        this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

        this.$store.dispatch("removeMatch", {
          data: obj,
          callback: function () {
            _this.$store.commit("PARLAY_SELECTED", {
              remove: true,
              eveid: _this.event.eveid
            });
            var MID = $(windowEvent.target).closest('div[id]')[0].id;

            $("[id=" + MID + "]").closest('.c-bet-item.active').removeClass('active');
            if (_this.$store.getters.betForm.length <= 0) {
              _this.$store.commit("OPEN_BETFORM", false);
              _this.$store.commit('ODD_SELECTED', false);
              _this.$store.commit("SHOW_BETFORM_MENU", false);
              _this.$store.commit('SELECTED_TAB', 'betTab');
              return;
            }
            _this.$store.dispatch("getBettingInfo", {
              callback: function (res) {
                _this.$store.commit("SPORT_MAPPING_BETTING", {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBettingList: _this.$store.getters.betForm
                });
              }.bind(_this)
            });
          }.bind(this)
        });
      } else {
        if (this.$store.getters.isBetCombo && this.$store.getters.betForm.length == this.betComboMax) {
          var chkRes = this.checkBetComboMax(betForm);
          if (chkRes) {
            return;
          }
        }

        this.$store.dispatch('getLatestInfo', {
          data: betForm,
          callback: function (res) {
            if (res.SYSTEM_DATA.status != 'FAIL') {
              if (_this.$store.getters.sportMiniBet.toggle) {
                __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('expandMini');
              }
              _this.oddSelectHighlight(windowEvent, betForm);

              if (_this.$store.getters.miniNormal == 1) {
                _this.showMiniBet(windowEvent);
              }
              if (!_this.$store.getters.isBetCombo) {
                _this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0);
                __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('resetKeyboard');
              }

              _this.$store.commit('OPEN_BETFORM', true);
              _this.$store.commit('ODD_SELECTED', true);

              _this.$store.commit('BET_FORM', {
                newBettingList: res.SYSTEM_DATA.betting,
                oldBetData: betForm
              });
            }
          }.bind(this)
        });
      }
    },
    classNegative: function classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false;
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    getOddUniqueClass: function getOddUniqueClass(event) {
      var classStr = '';
      if (this.plyType == '2') {
        classStr += 'ht ';
      }
      classStr += this.getOddUniqueId(event);
      return classStr;
    },
    getOddUniqueId: function getOddUniqueId(event) {
      return event.eveid + '1' + this.otrBetType + this.team + this.event.t[this.team].tid;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on(['refreshOdd'], function (params) {
      if (params == false) {
        _this2.refreshOdd = false;
      } else {
        _this2.refreshOdd = true;
      }
    }.bind(this));
  },
  mounted: function mounted() {
    this.$store.getters.betForm.forEach(function (value) {
      var MID = value.uniqueId;
      $("[id=" + MID + "]").closest('.c-bet-item').addClass('active');
    });
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"showtable"}},[_vm._l((_vm.sportList),function(sportObj,sportObjKey){return (_vm.selectedBettype.sprtId == 'G98'  || (_vm.selectedBettype.sprtId == sportObj.sprtId && _vm.selectedBettype.sprtId !='G98' ) )?[(_vm.checkValue(sportObj.sprtId,_vm.otrSportList) == 'true')?_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap matc-type-card",staticStyle:{"height":"38px !important","width":"100% !important"},style:((!_vm.showFavEvents && _vm.selectedBettype.tmpltId==11)?' top: 85.5px;':' top: 39.5px;'),attrs:{"data-v-477f976d":""},on:{"click":function($event){return _vm.showSportMatches(sportObjKey)}}},[_c('div',{staticClass:"list-card-inner",attrs:{"data-v-4c1e5c89":""}},[_c('div',{staticClass:"match-type text-left yb-flex-between",attrs:{"data-v-40c999f5":"","data-v-4c1e5c89":""}},[_c('div',{staticClass:"col-left",attrs:{"data-v-40c999f5":""}},[_vm._v("\n                "+_vm._s(_vm.getSportLang(sportObj.sprtId))+"\n            ")])])])]):_vm._e(),_vm._v(" "),(!_vm.sportList[sportObjKey].hide)?[_vm._l((_vm.eventList),function(eventObj,eventObjKey){return [(eventObj && eventObj != 'undefined' && (!_vm.showFavEvents || _vm.otrFavorite(eventObj.eveid, 'N'+eventObj.sptid, _vm.favouriteOTREventsList) ) && sportObj.sprtId=='N'+eventObj.sptid)?[(typeof eventObj == 'object' && eventObj.t && Object.keys(eventObj.t).length > 1)?[_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important"},style:((!_vm.showFavEvents && _vm.selectedBettype.tmpltId==11)?' top: 115.5px;':' top: 39.5px;')},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league",class:{ 'leagues-pack': _vm.eventList[eventObjKey].hide }},[_c('div',{staticClass:"tr-match-headotr"},[_c('div',{staticClass:"leagues-wrap"},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"},on:{"click":function($event){return _vm.showLeg(eventObjKey, false)}}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap",on:{"click":function($event){return _vm.showLeg(eventObjKey, false)}}}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap",on:{"click":function($event){return _vm.showLeg(eventObjKey, false)}}},[_c('div',{staticClass:"absolute-full"},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj.lgecapt}},[_vm._v("\n                              "+_vm._s(eventObj.lgecapt)+" - "+_vm._s(eventObj.evecapt)+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"icon-wrap"},[_c('i',{staticClass:"icon-star q-icon c-icon",class:{ active: _vm.otrFavorite(eventObj.eveid, 'N'+eventObj.sptid, _vm.favouriteOTREventsList) },on:{"click":function($event){return _vm.favouriteOtr(eventObj.eveid,'N'+eventObj.sptid,$event)}}})])])])])])]),_vm._v(" "),(!_vm.eventList[eventObjKey].hide)?[_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",attrs:{"id":'evet' + eventObj.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-card relative-position evecard"},[_c('div',{staticClass:"c-match-item m-otr tpl-18 csid-1"},[_c('div',{staticClass:"play-wrap"},[_c('div',{staticClass:"play-info vrow items-center yb-flex-between"},[_c('div',{staticClass:"ellipsis max1"},[_vm._v(_vm._s(eventObj.evecapt))]),_vm._v(" "),_c('div',[(_vm.selectedLang == 2 || _vm.selectedLang == 3)?[_vm._v("\n                                "+_vm._s(_vm._f("date")(_vm.matchDateCheck(eventObj.evedt),'YYYY年MM月DD日 HH:mm'))+"\n                              ")]:[_vm._v("\n                                "+_vm._s(_vm._f("date")(_vm.matchDateCheck(eventObj.evedt),'DD/MM/YYYY HH:mm'))+"\n                              ")],_vm._v("\n                              "+_vm._s(_vm.sportTableLang.template_lang['SPORT_TEMPLATE_6.CUTOFFDATE'])+"\n                            ")],2)]),_vm._v(" "),_vm._l((eventObj.t),function(Team,TeamKey){return (TeamKey % 2 != 0)?[_c('div',{staticClass:"bet-list-wrap vrow"},[_c('div',{staticClass:"bet-col",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[_vm._v(_vm._s(Team.tcapt))])]),_vm._v(" "),(Team.od)?[_c('oddOutright',{attrs:{"event":eventObj,"team":TeamKey}})]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"bet-col",staticStyle:{"height":"35px !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(eventObj.t[parseInt(TeamKey) + 1])?[_vm._v("\n                                        "+_vm._s(eventObj.t[parseInt(TeamKey) + 1].tcapt)+"\n                                      ")]:_vm._e()],2)]),_vm._v(" "),(eventObj.t[parseInt(TeamKey) + 1] && eventObj.t[parseInt(TeamKey) + 1].od)?[_c('oddOutright',{attrs:{"event":eventObj,"team":parseInt(TeamKey) + 1}})]:_vm._e()],2)])])]:_vm._e()})],2)])])])])]:_vm._e()]:_vm._e()]:_vm._e()]})]:_vm._e()]:_vm._e()}),_vm._v(" "),((_vm.eventList && Object.keys(_vm.eventList).length > 0))?_c('div',{},[_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('div',{staticClass:"pager-wrap vrow justify-end"},[_c('div',{staticClass:"go-top-btn yb-flex-center",on:{"click":_vm.backtoTop}},[_c('i',{staticClass:"q-icon icon-go_top c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"vmsg"},[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.BACK_TOP']))])])])]):_vm._e(),_vm._v(" "),_vm._m(0)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute-full resize-observer-wrap"},[_c('div',{staticClass:"absolute-full expand"}),_vm._v(" "),_c('div',{staticClass:"absolute-full shrink"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_specialEventCommon_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88c89760_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_specialEventCommon_vue__ = __webpack_require__(477);
function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88c89760"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_specialEventCommon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88c89760_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_specialEventCommon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speve_tbl",attrs:{"id":"showtable"}},[(!_vm.selectedMatchAllBet)?[((_vm.sortedEventList && _vm.sortedEventList.length > 0))?[_c('todayHeader',{attrs:{"marketType":_vm.market.tdyMarket.key},on:{"updateMethod":_vm.showMarketMatches}}),_vm._v(" "),(_vm.showhideAll)?[_vm._l((_vm.sortedEventList),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-card-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"38px !important"},style:(_vm.getTop())},[_c('div',{key:eventObjKey,staticClass:"list-card-inner"},[_c('div',{staticClass:"c-match-league match-tpl0-bg",class:_vm.checkClass(_vm.showLgeEve, eventObjKey),on:{"click":function($event){return _vm.showLeg(eventObjKey, false)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap",staticStyle:{"width":"700px"}},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"league-icon-wrap"}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"absolute-full",attrs:{"title":eventObj[0].lgecapt}},[_c('span',{staticClass:"ellipsis allow-user-select",attrs:{"title":eventObj[0].lgecapt},domProps:{"innerHTML":_vm._s(eventObj[0].lgecapt)}}),_vm._v(" "),_c('span',{staticClass:"league-match-count"},[_vm._v(_vm._s(eventObj.length))])])])]),_vm._v(" "),_c('div',{staticClass:"play-name vrow col"}),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"39px !important"}})])])])]),_vm._v(" "),(_vm.showLgeEve[eventObjKey])?[(!_vm.showLgeEve[eventObjKey].hide)?[_vm._l((eventObj),function(event,eventKey){return [_c('div',{ref:'eCardWrap'+event.eveid,refInFor:true,staticClass:"list-card-wrap v-scroll-item relative-position evecardwrap",style:(_vm.eventHeight(event, 'ecw', false)),attrs:{"id":'eCardWrap'+event.eveid}},[_c('div',{staticClass:"list-card-inner"},[_c('div',{ref:'eCard'+event.eveid,refInFor:true,staticClass:"c-match-card relative-position evecard",style:(_vm.eventHeight(event, 'ec', false)),attrs:{"id":'eCard'+event.eveid}},[_c('div',{staticClass:"c-match-item match-tpl0-bg more-handicap csid-1"},[_c('div',{staticClass:"process-col yb-flex-center"},[_c('sportTime',{attrs:{"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"match-handicap-item-wrap match-handicap-item-wrap-simple"},[_c('div',{staticClass:"match-handicap-item"},[_c('div',{staticClass:"c-match-handicap c-match-handicap-simple",attrs:{"id":'cmatch'+event.eveid}},[_c('div',{staticClass:"vrow no-wrap"},[_c('div',{staticClass:"handicap-col handicap-col-simple",attrs:{"id":'handicapCol'+event.eveid+event.bettype_id+_vm.ftPlyType+_vm.subMatchKeyCap[0]}},[_c('div',{staticClass:"bet-item-wrap home",staticStyle:{"width":"100% !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"vrow no-wrap absolute-full"},[_c('div',{staticClass:"team-name home ellipsis allow-user-select",attrs:{"title":event.tacapt},domProps:{"innerHTML":_vm._s(event.tacapt)}})])]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamA,"plyType":_vm.ftPlyType,"betType":event.bettype_id,"match":0}})],1)]),_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"20%"}},[_c('div',{staticClass:"score"},[((event.score_a && event.score_a>=0))?[_vm._v("\n                                                        "+_vm._s(event.score_a)+"\n                                                    ")]:_vm._e()],2)]),_vm._v(" "),[_c('div',{staticClass:"bet-item-wrap draw",staticStyle:{"width":"50% !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value color-highlight",staticStyle:{"justify-content":"center","margin":"0 10px"}},[_c('span',{staticClass:"handicap-more",staticStyle:{"display":"none","width":"min-content"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"handicap-value-text"},[(event.bettype_id == '1')?_c('handicap',{attrs:{"event":event,"favTeam":'a',"plyType":_vm.ftPlyType,"betType":event.bettype_id,"match":0}}):_c('span',[_vm._v("VS")])],1)])])])],_vm._v(" "),_c('div',{staticClass:"yb-flex-center",staticStyle:{"width":"20%"}},[_c('div',{staticClass:"score"},[((event.score_b && event.score_b>=0))?[_vm._v("\n                                                        "+_vm._s(event.score_b)+"\n                                                    ")]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"bet-item-wrap away",staticStyle:{"width":"100% !important"}},[_c('div',{staticClass:"c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"ellipsis-wrap"},[_c('div',{staticClass:"vrow no-wrap absolute-full"},[_c('div',{staticClass:"team-name away ellipsis allow-user-select",attrs:{"title":event.tbcapt},domProps:{"innerHTML":_vm._s(event.tbcapt)}})])]),_vm._v(" "),_c('odd',{attrs:{"event":event,"team":_vm.teamB,"plyType":_vm.ftPlyType,"betType":event.bettype_id,"match":0}})],1)])],2)])])])]),_vm._v(" "),_c('div',{staticClass:"media-col media-col-simple"},[_c('div',{staticClass:"media-col-wrap",staticStyle:{"justify-content":"center !important"}},[(event.stream_url)?_c('div',{staticClass:"icon-wrap relative-position",attrs:{"data-v-5a29cfce":""}},[_c('div',{staticClass:"v-icon video-icon",attrs:{"data-v-5a29cfce":"","title":_vm.sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']},on:{"click":function($event){return _vm.openSpecialStream(event.stream_url)}}})]):_vm._e()])])])])])])]})]:_vm._e()]:_vm._e()]})]:_vm._e()]:_vm._e()]:_vm._e(),_vm._v(" "),((_vm.sortedEventList && Object.keys(_vm.sortedEventList).length > 0))?_c('div',{},[_c('div',{staticStyle:{"text-align":"right","color":"var(--qq--y0-text-color5)","font-weight":"550","font-size":"14px"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.lang.sp_alert)}})]),_vm._v(" "),_c('div',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('div',{staticClass:"pager-wrap vrow justify-end"},[_c('div',{staticClass:"go-top-btn yb-flex-center",on:{"click":_vm.backtoTop}},[_c('i',{staticClass:"q-icon icon-go_top c-icon",staticStyle:{"font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('div',{staticClass:"vmsg"},[_vm._v(_vm._s(_vm.lang.sportAllBet['ALL_BET.BACK_TOP']))])])])]):_vm._e(),_vm._v(" "),_vm._m(0)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute-full resize-observer-wrap"},[_c('div',{staticClass:"absolute-full expand"}),_vm._v(" "),_c('div',{staticClass:"absolute-full shrink"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-scroll-content relative-position"},[_c('div',[_c('div',{style:(_vm.getStyle())})]),_vm._v(" "),((!_vm.selectedAllBet && !_vm.bool_leagueToggle && !_vm.open_RBMarket && !_vm.hotSchedule))?[(_vm.specialEvent)?[_c('specialEventCommon')]:(_vm.checkTemplate('1'))?[_c('soccerCommon')]:(_vm.checkTemplate('2'))?[_c('soccerCorrectScore')]:(_vm.checkTemplate('3'))?[_c('soccerTotalGoal')]:(_vm.checkTemplate('4'))?[_c('soccerHTFT')]:(_vm.checkTemplate('6') || _vm.checkTemplate('11'))?[_c('sportOutright')]:(_vm.checkTemplate('7'))?[_c('otherSportCommon2')]:(_vm.checkTemplate('8'))?[_c('otherSportCommon2')]:void 0]:(_vm.open_RBMarket)?[_c('inPlayCommon')]:(_vm.hotSchedule)?[_c('hotSportCommon')]:_vm._e(),_vm._v(" "),((_vm.eventList && _vm.eventList.length == 0 && _vm.rbeventList && _vm.rbeventList.length==0))?_c('div',{style:(_vm.hotSchedule ? { position: 'inherit', top: '45px' } : {})},[(!_vm.showFavEvents)?[_c('div',{staticClass:"column yb-flex-center empty fit"},[_c('div',{staticClass:"wrap empty-wrap",staticStyle:{"margin-bottom":"0px"},attrs:{"data-v-31145778":""}},[_c('div',{staticClass:"img dark",staticStyle:{"width":"180px","height":"180px"}}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.langSport['SPORT_TABLE.NO_DATA']))])])])]:[(_vm.showFavEvents && Object.keys(_vm.sortedEventList).length == 0 && Object.keys(_vm.sortedFavRbEventList).length == 0)?[_c('div',{staticClass:"column yb-flex-center empty fit"},[_c('div',{staticClass:"wrap empty-wrap",staticStyle:{"margin-bottom":"0px"},attrs:{"data-v-31145778":""}},[_c('div',{staticClass:"img dark",staticStyle:{"width":"180px","height":"180px"}}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.langSport['SPORT_TABLE.NO_DATA']))])])])]:_vm._e()]],2):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leagueSelectionBox_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388455e8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leagueSelectionBox_vue__ = __webpack_require__(501);
function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-388455e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leagueSelectionBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388455e8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leagueSelectionBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-content suck_down",attrs:{"id":"filter-content"}},[_c('div',{staticClass:"load-data-wrap col full-height"},[_c('div',{staticClass:"fit"},[_c('div',{staticClass:"v-scroll-area fit vrow relative-position"},[_c('div',{staticClass:"content-wrap fit"},[_c('div',{staticClass:"scroll-header absolute"},[_c('div',{staticClass:"c-match-list-header yb-flex-between",attrs:{"load_type":"filter"}},[_c('div',{staticClass:"col-left vrow items-center"},[_c('div',{staticClass:"btn-wrap match-btn yb-flex-center cursor-pointer active",staticStyle:{"display":"none"}},[_vm._v("\n                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_SELECT_ALL'])+"\n                ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"list-title vrow items-center"},[_c('div',{staticClass:"title-text yb-font-bold ellipsis"},[(((_vm.selectedMarket == _vm.market.inPlayMarket.key) || _vm.open_RBMarket))?[_vm._v("\n                      "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.HEADER_IN_PLAY_MARKET'])+"\n                    ")]:(_vm.selectedMarket == _vm.market.tdyMarket.key)?[_vm._v("\n                      "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.HEADER_TODAY_MARKET'])+"\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.HEADER_EARLY_MARKET'])+"\n                    ")],_vm._v(" "),((_vm.subTitle == '' && _vm.selectedBettype.sprtTitleLang) && !_vm.open_RBMarket)?[_vm._v("\n                      ("+_vm._s(_vm.selectedBettype.sprtTitleLang)+")\n                    ")]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-right yb-flex-center"},[_c('div',{staticClass:"search-wrap-league"},[_c('i',{staticClass:"search-icon q-icon icon-search c-icon set-color",staticStyle:{"color":"rgb(171, 186, 200)","font-size":"12px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('input',{staticClass:"search-input search-league",attrs:{"placeholder":_vm.sportTableLang.table['SPORT_TABLE.LBL_SELECT_SEARCH'],"type":"search"},on:{"keyup":_vm.searchLg}})]),_vm._v(" "),_c('div',{staticClass:"select-btn leagues-btn yb-flex-center cursor-pointer filter-handle yb-hover-bg active l123",on:{"click":function($event){return _vm.toggleLeague()}}},[_vm._v("\n                  "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.SUBHEADER_SELECT_LEAGUE'])+"\n                  "),_c('span',{staticClass:"status yb-font-bold filter_full_all"},[(_vm.selectedLeague.length>0)?[_vm._v("\n                      "+_vm._s(_vm.selectedLeague.length)+"\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_SELECT_ALL'])+"\n                    ")]],2),_vm._v(" "),_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}})]),_vm._v(" "),_c('div',{staticClass:"flex list-sort select-btn yb-hover-bg",staticStyle:{"display":"none"},attrs:{"show_type":"sort"}},[_c('div',{staticClass:"yb-hover-bg list-sort-item"},[_vm._v("\n                    "+_vm._s(_vm.sportTableLang.table['SPORT_TABLE.SUBHEADER_SORTBY_TIME'])+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"select-btn refresh-btn yb-flex-center yb-hover-bg",staticStyle:{"display":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"fit v-scrollarea q-scrollarea"},[_c('div',{staticClass:"q-scrollarea__container scroll relative-position fit",attrs:{"id":"leagueSelection"}},[_c('div',{staticClass:"scroll-inner-wrap fit",staticStyle:{"overflow-y":"auto !important"}},[_c('div',{staticClass:"q-scrollarea__content absolute"},[_c('div',{staticClass:"middle-content",staticStyle:{"padding-top":"36px","padding-bottom":"0px"}},[_c('div',{staticClass:"scroll-inner-wrap fit"},[_c('div',{staticClass:"filter-list"},[(_vm.open_RBMarket && _vm.selectedSport.sprtId=='G98')?[_vm._l((_vm.leagueList),function(sportdataObj,sportObjKey){return [_c('div',{staticClass:"filter-title"},[_c('div',{staticClass:"yb-flex-center cursor-pointer"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLeagueSport[sportObjKey].checked),expression:"selectedLeagueSport[sportObjKey].checked"}],attrs:{"id":sportObjKey,"type":"checkbox"},domProps:{"value":_vm.selectedLeagueSport[sportObjKey].checked,"checked":Array.isArray(_vm.selectedLeagueSport[sportObjKey].checked)?_vm._i(_vm.selectedLeagueSport[sportObjKey].checked,_vm.selectedLeagueSport[sportObjKey].checked)>-1:(_vm.selectedLeagueSport[sportObjKey].checked)},on:{"change":[function($event){var $$a=_vm.selectedLeagueSport[sportObjKey].checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.selectedLeagueSport[sportObjKey].checked,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedLeagueSport[sportObjKey], "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedLeagueSport[sportObjKey], "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedLeagueSport[sportObjKey], "checked", $$c)}},function($event){return _vm.selCheckLeague(sportObjKey)}]}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.selectedLeagueSport[sportObjKey].checked}})]),_vm._v(" "),_c('div',{staticClass:"country-name"},[_vm._v(_vm._s(_vm.getSportLang(sportObjKey)))])])]),_vm._v(" "),_c('div',{staticClass:"filter-item-content allSport"},[_vm._l((sportdataObj),function(dataObj,ObjKey){return (ObjKey!=='checked')?[_vm._l((dataObj),function(data){return [(data.id != null && ((_vm.searchLeague && data.show) || !_vm.searchLeague))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLeague(data.id, _vm.selectedOnly)),expression:"showLeague(data.id, selectedOnly)"}],staticClass:"filter-item cursor-pointer"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLeague),expression:"selectedLeague"}],attrs:{"id":data.id,"type":"checkbox"},domProps:{"value":data.id,"checked":Array.isArray(_vm.selectedLeague)?_vm._i(_vm.selectedLeague,data.id)>-1:(_vm.selectedLeague)},on:{"change":[function($event){var $$a=_vm.selectedLeague,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=data.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedLeague=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedLeague=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedLeague=$$c}},function($event){return _vm.changeSelectedLeague2(sportObjKey, data.id)}]}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.selectedLeague.includes(data.id)}})]),_vm._v(" "),_c('div',{staticClass:"filter-item-title ellipsis",attrs:{"title":data.lgecapt},on:{"click":function($event){return _vm.checkLeague(sportObjKey, data.id)}}},[(_vm.selectedBettype.betTypId!='6')?[_c('span',{domProps:{"innerHTML":_vm._s(data.lgecapt)}})]:[_vm._v(_vm._s(data.capt))]],2),_vm._v(" "),_c('div',{staticClass:"filter-item-num"},[_vm._v(_vm._s(data.c))])]):_vm._e()]})]:_vm._e()})],2)]})]:(_vm.open_RBMarket)?[_c('div',{staticClass:"filter-item-content singleSport"},[_vm._l((_vm.leagueList),function(league){return [_vm._l((league),function(data){return [(data.id != null && ((_vm.searchLeague && data.show) || !_vm.searchLeague))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLeague(data.id, _vm.selectedOnly)),expression:"showLeague(data.id, selectedOnly)"}],staticClass:"filter-item cursor-pointer"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLeague),expression:"selectedLeague"}],attrs:{"id":data.id,"type":"checkbox"},domProps:{"value":data.id,"checked":Array.isArray(_vm.selectedLeague)?_vm._i(_vm.selectedLeague,data.id)>-1:(_vm.selectedLeague)},on:{"change":[function($event){var $$a=_vm.selectedLeague,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=data.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedLeague=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedLeague=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedLeague=$$c}},_vm.changeSelectedLeague]}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.selectedLeague.includes(data.id)}})]),_vm._v(" "),_c('div',{staticClass:"filter-item-title ellipsis",attrs:{"title":data.lgecapt},on:{"click":function($event){return _vm.checkLeague(null, data.id)}}},[(_vm.selectedBettype.betTypId!='6')?[_c('span',{domProps:{"innerHTML":_vm._s(data.lgecapt)}})]:[_vm._v(_vm._s(data.capt))]],2),_vm._v(" "),_c('div',{staticClass:"filter-item-num"},[_vm._v(_vm._s(data.c))])]):_vm._e()]})]})],2)]:[_vm._l((_vm.selectedLeagueState),function(stateData,stateKey){return [_c('div',{staticClass:"filter-title"},[_c('div',{staticClass:"yb-flex-center cursor-pointer"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stateData.checked),expression:"stateData.checked"}],attrs:{"id":stateKey,"type":"checkbox"},domProps:{"value":stateData.checked,"checked":Array.isArray(stateData.checked)?_vm._i(stateData.checked,stateData.checked)>-1:(stateData.checked)},on:{"change":[function($event){var $$a=stateData.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=stateData.checked,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(stateData, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(stateData, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(stateData, "checked", $$c)}},function($event){return _vm.selState(stateKey)}]}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':stateData.checked}})]),_vm._v(" "),_c('div',{staticClass:"country-name"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.STATE_'+stateData.state]))])])]),_vm._v(" "),_c('div',{staticClass:"filter-item-content allSport"},[_vm._l((stateData.leagues),function(lgedt,lgeid){return [(lgedt.id != null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLeague(lgedt.id, _vm.selectedOnly)),expression:"showLeague(lgedt.id, selectedOnly)"}],staticClass:"filter-item cursor-pointer"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLeague),expression:"selectedLeague"}],attrs:{"id":lgedt.id,"type":"checkbox"},domProps:{"value":lgedt.id,"checked":Array.isArray(_vm.selectedLeague)?_vm._i(_vm.selectedLeague,lgedt.id)>-1:(_vm.selectedLeague)},on:{"change":[function($event){var $$a=_vm.selectedLeague,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=lgedt.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedLeague=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedLeague=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedLeague=$$c}},function($event){return _vm.changeSelectedLeague3(stateKey)}]}}),_vm._v(" "),_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.selectedLeague.includes(lgedt.id)}})]),_vm._v(" "),_c('div',{staticClass:"filter-item-title ellipsis",attrs:{"title":lgedt.lgecapt},on:{"click":function($event){return _vm.checkLeague(stateKey, lgedt.id)}}},[(_vm.selectedBettype.betTypId!='6')?[_c('span',{domProps:{"innerHTML":_vm._s(lgedt.lgecapt)}})]:[_vm._v(_vm._s(lgedt.capt))]],2),_vm._v(" "),_c('div',{staticClass:"filter-item-num"},[_vm._v(_vm._s(lgedt.c))])]):_vm._e()]})],2)]})]],2)])])])])])]),_vm._v(" "),_c('div',{staticClass:"scroll-footer",staticStyle:{"bottom":"0px"}})])]),_vm._v(" "),_c('div',{staticClass:"botton-box suck_down"},[_c('div',{staticClass:"cursor-pointer width140 border1",on:{"click":function($event){return _vm.changeSelectAll()}}},[_c('div',{staticClass:"check-wrap relative-position",class:{'active':_vm.selectAll}}),_vm._v(" "),_c('div',{staticClass:"country-name"},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_SEL_ALL_MATCH']))]),_vm._v(" "),_c('div',{staticClass:"all-count"},[_vm._v(_vm._s(_vm.totalLeagues))])]),_vm._v(" "),_c('div',{staticClass:"col yb-flex-center"},[_c('div',{staticClass:"mbtn btn1",class:{'dis':Object.keys(_vm.selectedLeague).length==0},on:{"click":function($event){return _vm.filterLeague()}}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.BTN_SUBMIT'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mbtn btn2",on:{"click":function($event){return _vm.toggleLeague()}}},[_vm._v(_vm._s(_vm.sportTableLang.table['SPORT_TABLE.LBL_CANCEL'])+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"width140 border1"})])]),_vm._v(" "),_c('div',{staticClass:"column yb-flex-center empty"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-wrap collect-btn yb-flex-center cursor-pointer",staticStyle:{"display":"none"},attrs:{"title":"sportTableLang.table['SPORT_TABLE.LBL_MY_FAVOURITE']"}},[_c('i',{staticClass:"q-icon icon-star c-icon set-color",staticStyle:{"color":"rgb(171, 186, 200)","font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('span',{staticClass:"number"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerContent_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069ca0ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footerContent_vue__ = __webpack_require__(503);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069ca0ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footerContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sportsfooter",attrs:{"id":"footer"}},[_c('footer',{staticClass:"midFooter"},[_c('ul',{staticClass:"service"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_c('li',{attrs:{"id":"rnr"},on:{"click":function($event){$event.preventDefault();return _vm.viewSportRules(0)}}},[_vm._v(_vm._s(_vm.langList.rules))])]),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v("© Copyright 2021. 3 SING SPORT. All Rights Reserved.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forecast_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0c8abf6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forecast_vue__ = __webpack_require__(507);
function injectStyle (ssrContext) {
  __webpack_require__(505)
  __webpack_require__(506)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0c8abf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forecast_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0c8abf6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forecast_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"forecast"}},[_c('div',{staticClass:"container-fluid",attrs:{"id":"forecastheader"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"text-left headertxt"},[(_vm.sportForecastSelectedEvent)?[(_vm.sportForecastSelectedEvent.tacapt)?_c('span',[_vm._v(_vm._s(_vm.sportForecastSelectedEvent.tacapt))]):(_vm.sportForecastSelectedEvent.ta)?_c('span',[_vm._v(_vm._s(_vm.sportForecastSelectedEvent.ta))]):_vm._e(),_vm._v(" "),_c('span',{},[_vm._v("-vs-")]),_vm._v(" "),(_vm.sportForecastSelectedEvent.tbcapt)?_c('span',[_vm._v(_vm._s(_vm.sportForecastSelectedEvent.tbcapt))]):(_vm.sportForecastSelectedEvent.tb)?_c('span',[_vm._v(_vm._s(_vm.sportForecastSelectedEvent.tb))]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"action-button"},[_c('div',{staticClass:"glyphIcon-large secondary icon-refresh",attrs:{"title":"Refresh"},on:{"click":function($event){return _vm.getSportWager(true)}}}),_vm._v(" "),_c('div',{staticClass:"glyphIcon-large secondary icon-close",attrs:{"title":"Close"},on:{"click":_vm.closeForecast}})])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid",attrs:{"id":"forecastbody"}},[_vm._v("\n    "+_vm._s(_vm.betAmount)+"\n    "),_c('div',{staticClass:"row waiting-bet"},[_c('div',{staticClass:"col-xs-6 text-left warningtext"},[_c('span',{staticStyle:{"padding-left":"5px"}},[_c('i',{staticClass:"glyphIcon primary lineCircle-primary icon-warning"}),_vm._v("\n          "+_vm._s(_vm.sportForecastLang['FORECAST.LBL_WAIT_BET_TKT'])+" "+_vm._s(_vm.wagerCount)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('button',{staticClass:"btn btn-sm pull-right removebtn",on:{"click":_vm.removeForecastList}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_REMOVE']))])])]),_vm._v(" "),_c('div',{staticClass:"row betinfo-panel"},[_c('div',{staticClass:"col-xs-12"},[(_vm.selectedForecastEvent || _vm.sportWaitingWagerList)?[(_vm.selectedForecastEvent)?[(_vm.selectedForecastEvent[_vm.ftPlyType])?[_c('div',{staticClass:"plytyp-panel text-left",on:{"click":function($event){_vm.showFT = !_vm.showFT}}},[_c('button',{staticClass:"trigger toggle-primary",class:{'icon-open' : _vm.showFT, 'icon-close' : !_vm.showFT}}),_vm._v(" "),_c('span',{staticStyle:{"line-height":"2.2"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_FT']))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFT),expression:"showFT"}]},[_c('ul',{staticClass:"list-group betinfo-panel"},[_vm._l((_vm.selectedForecastEvent[_vm.ftPlyType]),function(bettyp,bettypKey){return _vm._l((bettyp),function(tbet,tbetKey){return _c('li',{staticClass:"list-group-item text-left"},[_c('div',{staticClass:"pull-left col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedForecastEvent[_vm.ftPlyType][bettypKey][tbetKey].check),expression:"selectedForecastEvent[ftPlyType][bettypKey][tbetKey].check"}],staticClass:"forecast-check",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedForecastEvent[_vm.ftPlyType][bettypKey][tbetKey].check)?_vm._i(_vm.selectedForecastEvent[_vm.ftPlyType][bettypKey][tbetKey].check,null)>-1:(_vm.selectedForecastEvent[_vm.ftPlyType][bettypKey][tbetKey].check)},on:{"change":[function($event){var $$a=_vm.selectedForecastEvent[_vm.ftPlyType][bettypKey][tbetKey].check,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedForecastEvent[_vm.ftPlyType][bettypKey][tbetKey], "check", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedForecastEvent[_vm.ftPlyType][bettypKey][tbetKey], "check", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedForecastEvent[_vm.ftPlyType][bettypKey][tbetKey], "check", $$c)}},_vm.chckBoxForecast]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.BetTypeLang[bettypKey]['caption']))]),_vm._v(" - "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.computeTeamBet(tbet))}}),_vm._v(" \n                        "),(_vm.selectedForecastEvent)?void 0:_vm._e(),_vm._v("\n                        @ \n                        "),_c('h5',{staticClass:"betinfo-odd"},[_vm._v(_vm._s(_vm.getDecimalDisplay(tbet.odd)))])],2),_vm._v(" "),_c('div',{staticClass:"pull-right col-sm-3"},[_c('div',{staticClass:"pull-right glyphIcon icon-close",on:{"click":function($event){return _vm.removeForecastOdds(_vm.sportForecastSelectedEvent.eveid, _vm.ftPlyType, bettypKey, tbetKey)}}}),_vm._v(" "),_c('span',{staticClass:"pull-right betinfo-amount"},[_vm._v(_vm._s(_vm._f("number")(tbet.betAmount,0)))])])])})})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFT),expression:"showFT"}],staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered forecast-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"away text-center",attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_AWAY']))]),_vm._v(" "),_c('th',{staticClass:"home text-center",attrs:{"colspan":"5"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_HOME']))])]),_vm._v(" "),_c('tr',[_vm._l((5),function(n){return [_c('th',{staticClass:"homescore text-center"},[_vm._v(_vm._s(_vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'a')))])]})],2)]),_vm._v(" "),_c('tbody',_vm._l((5),function(n){return _c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 0 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0,rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay( 0, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 0 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 1 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0,rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay( 1, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 1 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 2 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0,rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay( 2, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 2 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 3 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0,rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay( 3, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 3 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 4 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0,rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay( 4, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 4 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))])])}),0)])])]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.selectedForecastEvent)?[(_vm.selectedForecastEvent[_vm.firstHtPlyType])?[_c('div',{staticClass:"plytyp-panel text-left",on:{"click":function($event){_vm.showHT = !_vm.showHT}}},[_c('button',{staticClass:"trigger toggle-primary",class:{'icon-open' : _vm.showFT, 'icon-close' : !_vm.showFT}}),_vm._v(" "),_c('span',{staticStyle:{"line-height":"2.2"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_HT']))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHT),expression:"showHT"}]},[_c('ul',{staticClass:"list-group betinfo-panel"},[_vm._l((_vm.selectedForecastEvent[_vm.firstHtPlyType]),function(bettyp,bettypKey){return _vm._l((bettyp),function(tbet,tbetKey){return _c('li',{staticClass:"list-group-item text-left"},[_c('div',{staticClass:"pull-left col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedForecastEvent[_vm.firstHtPlyType][bettypKey][tbetKey].check),expression:"selectedForecastEvent[firstHtPlyType][bettypKey][tbetKey].check"}],staticClass:"forecast-check",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedForecastEvent[_vm.firstHtPlyType][bettypKey][tbetKey].check)?_vm._i(_vm.selectedForecastEvent[_vm.firstHtPlyType][bettypKey][tbetKey].check,null)>-1:(_vm.selectedForecastEvent[_vm.firstHtPlyType][bettypKey][tbetKey].check)},on:{"change":[function($event){var $$a=_vm.selectedForecastEvent[_vm.firstHtPlyType][bettypKey][tbetKey].check,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedForecastEvent[_vm.firstHtPlyType][bettypKey][tbetKey], "check", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedForecastEvent[_vm.firstHtPlyType][bettypKey][tbetKey], "check", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedForecastEvent[_vm.firstHtPlyType][bettypKey][tbetKey], "check", $$c)}},_vm.chckBoxForecast]}}),_c('span',[_vm._v(_vm._s(_vm.BetTypeLang[bettypKey]['caption']))]),_vm._v(" - "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.computeTeamBet(tbet))}}),_vm._v(" @ "),_c('h5',{staticClass:"betinfo-odd"},[_vm._v(_vm._s(_vm._f("number")(tbet.odd,2)))])]),_vm._v(" "),_c('div',{staticClass:"pull-right col-sm-3"},[_c('div',{staticClass:"pull-right glyphIcon icon-close",on:{"click":function($event){return _vm.removeForecastOdds(_vm.sportForecastSelectedEvent.eveid, _vm.firstHtPlyType, bettypKey, tbetKey)}}}),_vm._v(" "),_c('span',{staticClass:"pull-right betinfo-amount"},[_vm._v(_vm._s(_vm._f("number")(tbet.betAmount,0)))])])])})})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHT),expression:"showHT"}],staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered forecast-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"away text-center",attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_AWAY']))]),_vm._v(" "),_c('th',{staticClass:"home text-center",attrs:{"colspan":"5"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_HOME']))])]),_vm._v(" "),_c('tr',[_vm._l((5),function(n){return [_c('th',{staticClass:"homescore text-center"},[_vm._v(_vm._s(_vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'a')))])]})],2)]),_vm._v(" "),_c('tbody',_vm._l((5),function(n){return _c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 0 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay( 0, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 0 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 1 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay( 1, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 1 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 2 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay( 2, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 2 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 3 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay( 3, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 3 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 4 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay( 4, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 4 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))])])}),0)])])]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.sportWaitingWagerList && !_vm.selectedForecastEvent)?[(_vm.sportWaitingWagerList[1])?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFT),expression:"showFT"}],staticClass:"plytyp-panel text-left"},[_c('span',[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_FT']))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFT),expression:"showFT"}],staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered forecast-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"away text-center",attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_AWAY']))]),_vm._v(" "),_c('th',{staticClass:"home text-center",attrs:{"colspan":"5"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_HOME']))])]),_vm._v(" "),_c('tr',[_vm._l((5),function(n){return [_c('th',{staticClass:"homescore text-center"},[_vm._v(_vm._s(_vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'a')))])]})],2)]),_vm._v(" "),_c('tbody',_vm._l((5),function(n){return _c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.getScoreDisplay( n - 1, _vm.sportForecastSelectedEvent, 'b')))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 0 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay(0, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 0 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 1 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay(1, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 1 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 2 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay(2, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 2 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 3 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay(3, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 3 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 4 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.ftPlyType, _vm.getScoreDisplay(4, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.ftPlyType, _vm.getScoreDisplay( 4 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))])])}),0)])])]:_vm._e(),_vm._v(" "),(_vm.sportWaitingWagerList[2])?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHT),expression:"showHT"}],staticClass:"plytyp-panel text-left"},[_c('span',[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_HT']))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHT),expression:"showHT"}],staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered forecast-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"away text-center",attrs:{"rowspan":"2"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_AWAY']))]),_vm._v(" "),_c('th',{staticClass:"home text-center",attrs:{"colspan":"5"}},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_HOME']))])]),_vm._v(" "),_c('tr',[_vm._l((5),function(n){return [_c('th',{staticClass:"homescore text-center"},[_vm._v(_vm._s(_vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'a')))])]})],2)]),_vm._v(" "),_c('tbody',_vm._l((5),function(n){return _c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.getScoreDisplay( n - 1, _vm.sportForecastSelectedEvent, 'b')))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 0 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay(0, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 0 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 1 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay(1, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 1 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 2 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay(2, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 2 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 3 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay(3, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 3 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))]),_vm._v(" "),_c('td',{staticClass:"text-center forecast-wl",class:{ngve : _vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 4 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')) < 0, rbsco: _vm.showRBScore(_vm.firstHtPlyType, _vm.getScoreDisplay(4, _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay(n - 1, _vm.sportForecastSelectedEvent, 'b')) }},[_vm._v(_vm._s(_vm._f("number")(_vm.calcForecastWL(_vm.firstHtPlyType, _vm.getScoreDisplay( 4 , _vm.sportForecastSelectedEvent, 'a') + '_' + _vm.getScoreDisplay( n - 1 , _vm.sportForecastSelectedEvent, 'b')),2)))])])}),0)])])]:_vm._e()]:_vm._e()]:_vm._e(),_vm._v(" "),(!_vm.switchEvent || (!_vm.selectedForecastEvent))?[(_vm.sportWaitingWagerList && (!_vm.sportWaitingWagerList[1] && !_vm.sportWaitingWagerList[2]))?_c('div',{staticClass:"no-info"},[_vm._v("\n            "+_vm._s(_vm.sportForecastLang['FORECAST.LBL_NO_INFO'])+"\n          ")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-xs-12 note-info"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.sportForecastLang['FORECAST.LBL_NOTE']))]),_vm._v(" "),_c('div',{staticClass:"txt",class:{'hide-note': !_vm.showNote, 'show-note': _vm.showNote}},[_c('span',[_vm._v(_vm._s(_vm.modifyNote()))]),_vm._v(" "),_c('div',{staticClass:"smallBtn primary",class:{'icon-arrow-down': !_vm.showNote, 'icon-arrow-up': _vm.showNote},on:{"click":function($event){_vm.showNote = !_vm.showNote}}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yb-match-list column full-height relative-position match-tpl0"},[_c('div',{staticClass:"scroll-fixed-headerA"},[_c('div',{staticClass:"c-match-list-header yb-flex-between",class:{ 'today-champion': (_vm.selectedBettype.betTypId == '6') }},[(_vm.searchLeague.lid>0)?_c('div',{staticClass:"col-left vrow items-center"},[_c('div',{staticClass:"list-title vrow items-center",attrs:{"data-v-532cf2cd":""}},[_c('div',{staticClass:"title-text yb-font-bold ellipsis",attrs:{"data-v-532cf2cd":""}},[_vm._v(" "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.SEARCH_RESULTS']))]),_vm._v(" "),_c('span',{staticClass:"title-text path-icon-wrapper search",attrs:{"data-v-532cf2cd":""}},[_c('span',{staticClass:"icon-triangle3 search-path-icon",attrs:{"data-v-532cf2cd":""}}),_vm._v(" "),_c('span',{attrs:{"data-v-532cf2cd":""}},[_vm._v(_vm._s(_vm.searchLeague.lname))])])])]):_c('div',{staticClass:"col-left vrow items-center"},[(!_vm.specialEvent)?_c('div',{staticClass:"btn-wrap match-btn yb-flex-center cursor-pointer",class:{'active':!_vm.showFavEvents},style:(_vm.specialEvent? 'margin-right: 10px;':''),on:{"click":_vm.changeMain}},[_vm._v("\n          "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.ALL'])+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.specialEvent)?_c('div',{staticClass:"btn-wrap collect-btn yb-flex-center cursor-pointer",class:{'active':_vm.showFavEvents},attrs:{"title":_vm.lang.sportTableLang['SPORT_TABLE.LBL_MY_FAVOURITE']},on:{"click":_vm.changeFavorite}},[_c('i',{staticClass:"q-icon icon-star c-icon set-color",class:{ active: (_vm.countFav > 0) },staticStyle:{"color":"rgb(171, 186, 200)","font-size":"14px"},attrs:{"aria-hidden":"true","role":"presentation"}}),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v("\n            "+_vm._s(_vm.countFav)+"\n          ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-title vrow items-center"},[_c('div',{staticClass:"title-text yb-font-bold ellipsis"},[(_vm.selectedBettype.betTypId=='6')?[_vm._v("\n              "+_vm._s(_vm.lang.configLang['CONFIG_LANG.LBL_GAME_OUTRIGHT'])+"\n            ")]:((!_vm.showFavEvents && !_vm.open_RBMarket && !_vm.hotSchedule))?[(_vm.selectedMarket == _vm.market.inPlayMarket.key)?[_vm._v("\n                "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.HEADER_IN_PLAY_MARKET'])+"\n              ")]:(_vm.selectedMarket == _vm.market.tdyMarket.key)?[_vm._v("\n                "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.HEADER_TODAY_MARKET'])+"\n              ")]:[_vm._v("\n                "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.HEADER_EARLY_MARKET'])+"\n              ")],_vm._v(" "),(_vm.isGameBannerSelected && _vm.showGameBanner)?[(_vm.cookies_lang == 'zh_TW')?[_vm._v("\n                  ("+_vm._s(_vm.gameBannerImage.bannerName_tw)+")\n                ")]:(_vm.cookies_lang == 'zh_CN')?[_vm._v("\n                  ("+_vm._s(_vm.gameBannerImage.bannerName_cn)+")\n                ")]:[_vm._v("\n                  ("+_vm._s(_vm.gameBannerImage.bannerName_en)+")\n                ")]]:(_vm.specialEvent)?[_vm._v("\n                ("+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.SPECIAL_EVENT'])+")\n              ")]:(_vm.selectedBettype.sprtTitleLang)?[_vm._v("\n                ("+_vm._s(_vm.selectedBettype.sprtTitleLang)+")\n              ")]:_vm._e()]:[(_vm.open_RBMarket)?[_vm._v("\n                "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.HEADER_IN_PLAY_MARKET'])+"\n              ")]:_vm._e(),_vm._v(" "),(_vm.hotSchedule)?[_vm._v("\n                "+_vm._s(_vm.langList.hotSport)+"\n              ")]:_vm._e()],_vm._v(" "),(_vm.selectedBettype.betTypId==5 && _vm.isParlayTab)?[_vm._v("\n               - "+_vm._s(_vm.lang.configLang['CONFIG_LANG.LBL_BETTYPE_PARLAY'])+"\n            ")]:_vm._e()],2)])]),_vm._v(" "),(_vm.searchLeague.lid==0)?_c('div',{staticClass:"col-right yb-flex-center"},[_c('div',{staticClass:"select-wrap relative-position"}),_vm._v(" "),(!(_vm.isGameBannerSelected && _vm.showGameBanner) && !_vm.showFavEvents && !_vm.hotSchedule && !_vm.specialEvent)?_c('div',{staticClass:"select-btn leagues-btn yb-flex-center cursor-pointer filter-handle yb-hover-bg m123",on:{"click":function($event){return _vm.toggleLeague($event)}}},[_vm._v("\n          "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.SUBHEADER_SELECT_LEAGUE'])+"\n          "),_c('span',{staticClass:"status yb-font-bold"},[(_vm.arr_selectedLeagueList.length==0)?[_vm._v("\n              "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.SUBHEADER_SELECT_ALL_LEAGUE'])+"\n            ")]:[_vm._v("\n              "+_vm._s(_vm.arr_selectedLeagueList.length)+"\n            ")]],2),_vm._v(" "),_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}})]):_vm._e(),_vm._v(" "),(_vm.selectedBettype.betTypId!=6  && !_vm.hotSchedule)?_c('div',{staticClass:"flex list-sort select-btn yb-hover-bg",attrs:{"show_type":"sort"}},[_vm._l((_vm.sortTypes),function(sortType){return [_c('div',{staticClass:"list-sort-item",class:(sortType.key==_vm.selectedSort)?'active':'',on:{"click":function($event){return _vm.changeSort(sortType.key,$event)}}},[_vm._v(_vm._s(_vm.lang.sportTableLang[sortType.lang]))])]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"refresh-icon-wrap yb-flex-center select-btn refresh-tbl-wrap yb-hover-bg",on:{"click":function($event){return _vm.refreshTbl(_vm.token.arr_8)}}},[_vm._m(0)]),_vm._v(" "),(_vm.show_Fold)?_c('div',{staticClass:"unfold-btn",on:{"click":function($event){return _vm.foldSc()}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.OPEN']))]),_vm._v(" "),_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"12px"}})]):_vm._e()]):_vm._e()]),_vm._v(" "),(!_vm.showFavEvents && ((_vm.open_RBMarket && !_vm.hotSchedule) || _vm.selectedBettype.tmpltId == '11'))?[_c('div',{staticClass:"c-match-list-filter"},[_c('div',{staticClass:"drag-scroll relative-position filter-sports"},[_c('div',{staticClass:"hide-scrollbar",attrs:{"id":"rb-sport-scroll"}},[_c('div',{staticClass:"content",attrs:{"id":"rb-scroll-content"}},[_c('div',{staticClass:"item column yb-flex-center",class:_vm.getActive(_vm.rbAllSport),on:{"click":function($event){return _vm.selectRBSport(_vm.rbAllSport,false)}}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.ALL'])+" "+_vm._s(_vm.getCountAllSport())+" ")])]),_vm._v(" "),_vm._l((_vm.sportList),function(sport){return [(sport.sprtId == 'N1')?[(_vm.selectedBettype.betTypId!='6')?_c('div',{staticClass:"item column yb-flex-center",class:_vm.simpleSport == _vm.sportList[0].sprtId? 'active':'no-active',on:{"click":function($event){return _vm.selectRBSport(_vm.sportList[0],true)}}},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.SIMPLE_SOCCER'])+" "+_vm._s(_vm.countSport('N1'))+" ")])]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"item column yb-flex-center",class:_vm.getActive(sport),style:(_vm.countSport(sport.sprtId)==0?'display: none   ':''),on:{"click":function($event){$event.preventDefault();return _vm.selectRBSport(sport,false)}}},[_c('div',{staticClass:"icon-wrap list-filter"},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon",staticStyle:{"width":"20px","height":"20px"},style:(_vm.getBGPos(sport.sprtId))})]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(sport.sprtLang)+" "+_vm._s(_vm.countSport(sport.sprtId))+" ")])])]}),_vm._v(" "),_c('div',{staticStyle:{"min-width":"84px"}}),_vm._v(" "),_vm._m(3)],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLarrowRB),expression:"showLarrowRB"}],staticClass:"more-btn left",on:{"click":function($event){return _vm.clickMove($event, 'left')}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRarrowRB),expression:"showRarrowRB"}],staticClass:"more-btn right",on:{"click":function($event){return _vm.clickMove($event, 'right')}}})])])]:_vm._e(),_vm._v(" "),(!_vm.showFavEvents && _vm.hotSchedule)?[_c('div',{staticClass:"c-match-list-filter"},[_c('div',{staticClass:"drag-scroll relative-position filter-sports"},[_c('div',{staticClass:"hide-scrollbar",attrs:{"id":"rb-sport-scroll"}},[_c('div',{staticClass:"content",attrs:{"id":"rb-scroll-content"}},[_c('div',{staticClass:"item column yb-flex-center",class:_vm.getActive(_vm.rbAllSport),on:{"click":function($event){return _vm.selectRBSport(_vm.rbAllSport,false)}}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.ALL'])+" ")])]),_vm._v(" "),_vm._l((_vm.hot_sportList),function(sport){return [_c('div',{staticClass:"item column yb-flex-center",class:_vm.getActive(sport),on:{"click":function($event){$event.preventDefault();return _vm.selectRBSport(sport,false)}}},[_c('div',{staticClass:"icon-wrap list-filter"},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon",staticStyle:{"width":"20px","height":"20px"},style:(_vm.getBGPos(sport.sprtId))})]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(sport.sprtLang))])])]}),_vm._v(" "),_c('div',{staticStyle:{"min-width":"84px"}}),_vm._v(" "),_vm._m(5)],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLarrowRB),expression:"showLarrowRB"}],staticClass:"more-btn left",on:{"click":function($event){return _vm.clickMove($event, 'left')}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRarrowRB),expression:"showRarrowRB"}],staticClass:"more-btn right",on:{"click":function($event){return _vm.clickMove($event, 'right')}}})])])]:_vm._e(),_vm._v(" "),((_vm.selectedMarket==_vm.market.earlyMarket.key || (_vm.selectedBettype.betTypId=='5' && _vm.isParlayTab)) && _vm.selectedBettype.betTypId != '6')?[(!_vm.isGameBannerSelected && !_vm.specialEvent)?_c('div',{staticClass:"c-match-list-filter date-filter early"},[_c('div',{staticClass:"tab-wrap fit relative-position",attrs:{"id":"tabWrap"}},[_c('div',{staticClass:"item-wrap relative-position",style:({'left':_vm.dateLeft+'px'}),attrs:{"id":"earlyDateScroll"}},[_c('div',{staticClass:"tab-item yb-flex-center",class:{'active': _vm.allDate==_vm.selectedEarlyParlayDate },attrs:{"id":'tabDate-'+_vm.allDate},on:{"mouseover":function($event){return _vm.highlightLine(_vm.allDate)},"mouseleave":function($event){return _vm.highlightLine(_vm.selectedEarlyParlayDate)},"click":function($event){return _vm.changeEarlyParlayDate(_vm.allDate)}}},[_vm._v("\n              "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.ALL_DATES'])+"\n              "),_c('span',{staticClass:"match-count"},[_vm._v(" ("+_vm._s(_vm.totalCountByDate('ttl','all'))+")")])]),_vm._v(" "),_vm._l((_vm.earlyParlayDateList),function(date,key){return [((_vm.selectedBettype.betTypId == '5' && _vm.isParlayTab && key =='0') || key!='0')?_c('div',{staticClass:"tab-item yb-flex-center",class:{'active': key==_vm.selectedEarlyParlayDate},attrs:{"id":'tabDate-'+key},on:{"click":function($event){return _vm.changeEarlyParlayDate(key)},"mouseover":function($event){return _vm.highlightLine(key)},"mouseleave":function($event){return _vm.highlightLine(_vm.selectedEarlyParlayDate)}}},[(_vm.selectedBettype.betTypId=='5' && key=='0')?[_vm._v("\n                  "+_vm._s(_vm._f("date")(date,'MMMDo'))+"\n                ")]:[(_vm.selectedLang != '1')?[(_vm.selectedLang == '6')?[_vm._v("\n                      "+_vm._s(_vm._f("date")(date,'Do MMMM(ddd)'))+"\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm._f("date")(date,'MMMDo'))+"\n                    ")]]:[_vm._v("\n                    "+_vm._s(_vm._f("date")(date,'DD/MM'))+"\n                  ")]],_vm._v(" "),_c('span',{staticClass:"match-count"},[_vm._v(" ("+_vm._s(_vm.totalCountByDate(key))+")")])],2):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center",class:{'active': 8==_vm.selectedEarlyParlayDate},attrs:{"id":'tabDate-8'},on:{"mouseover":function($event){return _vm.highlightLine('8')},"mouseleave":function($event){return _vm.highlightLine('8')},"click":function($event){return _vm.changeEarlyParlayDate(8)}}},[_vm._v("\n              "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.FUTURE'])+" \n              "),_c('span',{staticClass:"match-count"},[_vm._v(" ("+_vm._s(_vm.totalCountByDate(8))+")")])]),_vm._v(" "),_vm._m(6)],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLarrowEarly),expression:"showLarrowEarly"}],staticClass:"left-btn btn",on:{"click":function($event){return _vm.setDateArrow('L')}}},[_c('div',{staticClass:"yb-icon-arrow"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRarrowEarly),expression:"showRarrowEarly"}],staticClass:"right-btn btn",on:{"click":function($event){return _vm.setDateArrow('R')}}},[_c('div',{staticClass:"yb-icon-arrow"})])])]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"load-data-wrap sport-table-scroll col"},[_c('div',{staticClass:"fit"},[_c('div',{staticClass:"v-scroll-list relative-position"},[_c('div',{staticClass:"list-scrollbar router_scroll_layout"},[_c('sportTemplate',{directives:[{name:"show",rawName:"v-show",value:(!_vm.reloading),expression:"!reloading"}]})],1)])])]),_vm._v(" "),(_vm.leagueToggle)?_c('leagueSelectionBox'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reloading),expression:"reloading"}],staticClass:"refresh-mask absolute-full yb-flex-center",staticStyle:{"top":"36px"}},[_c('div',{staticClass:"img-loading custom-format-img-loading"})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-refresh fit yb-flex-center cursor-pointer refresh-btn"},[_c('div',{staticClass:"icon-wrap",attrs:{"id":"tblRefresh"}},[_c('i',{staticClass:"q-icon icon-tbl_refresh c-icon",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true","role":"presentation"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrap list-filter"},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon",staticStyle:{"width":"20px","height":"20px","background-position":"0px 0px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrap list-filter"},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon icon_simple_N1"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute-full resize-observer-wrap"},[_c('div',{staticClass:"absolute-full expand"}),_vm._v(" "),_c('div',{staticClass:"absolute-full shrink"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrap list-filter"},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon",staticStyle:{"width":"20px","height":"20px","background-position":"0px 0px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute-full resize-observer-wrap"},[_c('div',{staticClass:"absolute-full expand"}),_vm._v(" "),_c('div',{staticClass:"absolute-full shrink"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-wrap"},[_c('div',{staticClass:"line",staticStyle:{"width":"50px"},attrs:{"id":"earlyLine"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_livetvEventsList_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52566c5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_livetvEventsList_vue__ = __webpack_require__(515);
function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_livetvEventsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52566c5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_livetvEventsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yb-match-list column full-height relative-position match-tpl0"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reloading),expression:"reloading"}],staticClass:"refresh-mask absolute-full yb-flex-center",staticStyle:{"top":"36px"}},[_c('div',{staticClass:"img-loading custom-format-img-loading"})]),_vm._v(" "),_c('div',{staticClass:"scroll-fixed-headerA",staticStyle:{"z-index":"210"}},[_c('div',{staticClass:"c-match-list-header yb-flex-between"},[_c('div',{staticClass:"col-left vrow items-center"},[_c('div',{staticClass:"list-title vrow items-center",attrs:{"data-v-532cf2cd":""}},[_c('div',{staticClass:"title-text yb-font-bold ellipsis",attrs:{"data-v-532cf2cd":""}},[_vm._v(" "+_vm._s(_vm.lang.LivetvLang['LIVETV.SCHEDULE2'])+" ("+_vm._s(_vm.selectedSportName)+")")])])]),_vm._v(" "),_c('div',{staticClass:"col-right yb-flex-center"},[_c('div',{staticClass:"select-wrap relative-position"}),_vm._v(" "),_c('div',{staticClass:"refresh-icon-wrap yb-flex-center select-btn refresh-tbl-wrap yb-hover-bg"},[_c('div',{staticClass:"c-refresh fit yb-flex-center cursor-pointer refresh-btn"},[_c('div',{staticClass:"icon-wrap",attrs:{"id":"tblRefresh"}},[_c('i',{staticClass:"q-icon icon-tbl_refresh c-icon",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true","role":"presentation"},on:{"click":function($event){return _vm.refreshTbl()}}})])])]),_vm._v(" "),(_vm.show_Fold)?_c('div',{staticClass:"unfold-btn",on:{"click":function($event){return _vm.foldSc()}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.OPEN']))]),_vm._v(" "),_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"12px"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"c-match-list-filter"},[_c('div',{staticClass:"drag-scroll relative-position filter-sports"},[_c('div',{staticClass:"hide-scrollbar",attrs:{"id":"rb-sport-scroll"}},[_c('div',{staticClass:"content",attrs:{"id":"rb-scroll-content"}},[_vm._l((_vm.sportList),function(sport){return [_c('div',{staticClass:"item column yb-flex-center",class:_vm.getActive(sport),on:{"click":function($event){$event.preventDefault();return _vm.selectRBSport(sport)}}},[_c('div',{staticClass:"icon-wrap list-filter"},[_c('span',{staticClass:"q-icon icon c-icon sport-img icon",staticStyle:{"width":"20px","height":"20px"},style:(_vm.getBGPos(sport.sprtId))})]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(sport.sprtLang)+" ")])])]}),_vm._v(" "),_c('div',{staticStyle:{"min-width":"84px"}}),_vm._v(" "),_vm._m(0)],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLarrowRB),expression:"showLarrowRB"}],staticClass:"more-btn left",on:{"click":function($event){return _vm.clickMove($event, 'left')}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRarrowRB),expression:"showRarrowRB"}],staticClass:"more-btn right",on:{"click":function($event){return _vm.clickMove($event, 'right')}}})])]),_vm._v(" "),_c('div',{staticClass:"c-match-list-filter date-filter early"},[_c('div',{staticClass:"tab-wrap fit relative-position",attrs:{"id":"tabWrap"}},[_c('div',{staticClass:"item-wrap relative-position",style:({'left':_vm.dateLeft+'px'}),attrs:{"id":"earlyDateScroll"}},[_c('div',{staticClass:"tab-item yb-flex-center",class:{'active': _vm.allDate==_vm.selectedEarlyParlayDate },attrs:{"id":'tabDate-'+_vm.allDate},on:{"mouseover":function($event){return _vm.highlightLine(_vm.allDate)},"mouseleave":function($event){return _vm.highlightLine(_vm.selectedEarlyParlayDate)},"click":function($event){return _vm.changeEarlyParlayDate(_vm.allDate)}}},[_vm._v("\n              "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.ALL_DATES'])+"\n            ")]),_vm._v(" "),_vm._l((_vm.earlyParlayDateList),function(date,key){return [_c('div',{staticClass:"tab-item yb-flex-center",class:{'active': key ==_vm.selectedEarlyParlayDate},attrs:{"id":'tabDate-'+key},on:{"click":function($event){return _vm.changeEarlyParlayDate(key)},"mouseover":function($event){return _vm.highlightLine(key)},"mouseleave":function($event){return _vm.highlightLine(_vm.selectedEarlyParlayDate)}}},[(_vm.selectedBettype.betTypId=='5')?[_vm._v("\n                  "+_vm._s(_vm._f("date")(date,'MMMDo'))+"\n                ")]:[(_vm.selectedLang != '1')?[(_vm.selectedLang == '6')?[_vm._v("\n                      "+_vm._s(_vm._f("date")(date,'Do MMMM(ddd)'))+"\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm._f("date")(date,'MMMDo'))+"\n                    ")]]:[_vm._v("\n                    "+_vm._s(_vm._f("date")(date,'DD/MM'))+"\n                  ")]]],2)]}),_vm._v(" "),_c('div',{staticClass:"tab-item yb-flex-center",class:{'active': 8==_vm.selectedEarlyParlayDate},attrs:{"id":'tabDate-8'},on:{"mouseover":function($event){return _vm.highlightLine('8')},"mouseleave":function($event){return _vm.highlightLine('8')},"click":function($event){return _vm.changeEarlyParlayDate(8)}}},[_vm._v("\n              "+_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.FUTURE'])+" \n            ")]),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLarrowEarly),expression:"showLarrowEarly"}],staticClass:"left-btn btn",on:{"click":function($event){return _vm.setDateArrow('L')}}},[_c('div',{staticClass:"yb-icon-arrow"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRarrowEarly),expression:"showRarrowEarly"}],staticClass:"right-btn btn",on:{"click":function($event){return _vm.setDateArrow('R')}}},[_c('div',{staticClass:"yb-icon-arrow"})])])])]),_vm._v(" "),_c('div',{staticClass:"load-data-wrap sport-table-scroll col"},[_c('div',{staticStyle:{"height":"141px"}}),_vm._v(" "),(_vm.liveEvent && (_vm.liveEvent.length > 0 || Object.keys(_vm.liveEvent).length > 0))?_c('div',{staticStyle:{"width":"99.5%"},attrs:{"id":"div_show","name":"div_show"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reloading),expression:"reloading"}],staticClass:"refresh-mask absolute-full yb-flex-center",staticStyle:{"top":"36px"}},[_c('div',{staticClass:"img-loading custom-format-img-loading"})]),_vm._v(" "),_vm._l((_vm.sortDate(_vm.liveEvent)),function(eventObj,eventObjKey){return [_c('div',{staticClass:"list-live-wrap v-scroll-item relative-position sticky-wrap",staticStyle:{"height":"fit-content !important","top":"138.5px"}},[_c('div',{staticClass:"list-card-inner"},[(_vm.selectAllDate == true || _vm.selectFuture == true)?_c('div',{staticClass:"c-match-league match-tpl0-bg",staticStyle:{"margin-bottom":"5px"},attrs:{"id":'title_wrap_'+eventObjKey},on:{"click":function($event){return _vm.showLeg(eventObjKey, true)}}},[_c('div',{staticClass:"tr-match-head"},[_c('div',{staticClass:"leagues-wrap"},[_c('i',{staticClass:"icon-arrow q-icon c-icon",attrs:{"size":"14px"}}),_vm._v(" "),_c('div',{staticClass:"ellipsis-wrap",staticStyle:{"width":"122px"}},[_c('div',{staticClass:"absolute-full"},[(_vm.selectedDate == 99 || _vm.selectedDate == 8 )?[_c('span',{staticClass:"ellipsis allow-user-select"},[_vm._v(" "+_vm._s(_vm.getWeekdays(eventObj.date))+" "+_vm._s(_vm.getFilterDate(eventObj.date)))])]:_vm._e()],2)])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"c-match-card relative-position evecard",staticStyle:{"padding-bottom":"5px"},attrs:{"id":'list_wrap_'+eventObjKey}},[_c('div',{staticClass:"c-match-item m-otr tpl-18 csid-1"},[_c('div',{staticClass:"play-wrap"},[_vm._l((_vm.sortEvent(eventObj.event)),function(event,eventKey){return [_c('div',{staticClass:"bet-list-wrap vrow"},[_c('div',{staticClass:"bet-col schedule-list-col",staticStyle:{"width":"100% !important"}},[_c('div',{staticClass:"c-bet-item c-schedule-row yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon"},[_c('div',{staticClass:"handicap-value",staticStyle:{"position":"absolute","margin-right":"40px"}},[_c('div',{staticClass:"timetableBox",class:event.rbstatus=='1' ? 'nowPlay' : '',staticStyle:{"width":"100% !important"},attrs:{"id":'tv_FT_'+event.eveid,"name":"live_tv"},on:{"click":function($event){return _vm.enterAllBet(event,2, true,event.rbstatus)}}},[(event.rbstatus=='1')?_c('div',{staticClass:"live_tv_icon"}):_c('div',{staticClass:"live_tv_time"},[_vm._v(_vm._s(_vm.getFilterTime(event.dt)))]),_vm._v(" "),_c('div',{class:_vm.drawclass(event.sptid)}),_vm._v(" "),_c('div',{staticClass:"tv_game_name"},[_c('span',[_c('span',{domProps:{"innerHTML":_vm._s(event.tacapt)}}),_vm._v(" vs "),_c('span',{domProps:{"innerHTML":_vm._s(event.tbcapt)}})])])])])])])])]})],2)])])]})],2):_c('div',{staticClass:"column empty fit",attrs:{"data-v-21f17103":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reloading),expression:"reloading"}],staticClass:"refresh-mask absolute-full yb-flex-center",staticStyle:{"top":"36px"}},[_c('div',{staticClass:"img-loading custom-format-img-loading"})]),_vm._v(" "),_c('div',{staticClass:"wrap empty-wrap",staticStyle:{"margin-bottom":"0px"},attrs:{"data-v-31145778":"","data-v-21f17103":""}},[_c('div',{staticClass:"img light",staticStyle:{"width":"180px","height":"180px","margin":"auto"},attrs:{"data-v-31145778":""}}),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"data-v-31145778":""}},[_vm._v(_vm._s(_vm.lang.configLang['CONFIG_LANG.LBL_NO_LIVE']))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute-full resize-observer-wrap"},[_c('div',{staticClass:"absolute-full expand"}),_vm._v(" "),_c('div',{staticClass:"absolute-full shrink"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-wrap"},[_c('div',{staticClass:"line",staticStyle:{"width":"50px"},attrs:{"id":"earlyLine"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-center screen-medium",class:{ details_layout: _vm.selectedMatchAllBet },staticStyle:{"min-width":"775px","z-index":"45"},style:({ 'width': _vm.center_widthPX + 'px' ,'height': _vm.LeftMenu_heightPX + 'px' })},[(!_vm.selectedMatchAllBet && !_vm.liveSchedule)?[_c('sportTable')]:(_vm.selectedMatchAllBet && !_vm.liveSchedule)?[_c('allBetCommon')]:(_vm.selectedMatchAllBet && _vm.liveSchedule)?[_c('livetvEventsList')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555abdaf_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(519);
function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-555abdaf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555abdaf_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.specialEvent)?_c('div',{staticClass:"page-right",style:({ 'width': _vm.right_widthPX + 'px' ,'height': _vm.LeftMenu_heightPX + 'px' })},[_c('div',{staticClass:"right_details_wrap relative-position page-match-detail fit"},[_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.right_allBetReloading),expression:"right_allBetReloading"}],staticClass:"cathectic-shade-right"},[_c('div',{staticClass:"shade-fixed"},[_c('div',{staticClass:"load-data-wrap col is-detail details_data_load",staticStyle:{"margin-top":"113px"}},[_c('div',{staticClass:"fit"}),_vm._v(" "),_c('div',{staticClass:"column yb-flex-center empty"},[_c('div',{staticClass:"loading-wrap right_details_loading",class:{'cs-en':_vm.selectedLang== '1'}},[_c('div',{staticClass:"img-loading custom-format-img-loading"}),_vm._v(" "),_c('div',{staticClass:"text-center loading-text flex items-end justify-center"},[_c('span',[_vm._v(_vm._s(_vm.langList.sportTableLang['SPORT_TABLE.LOADING']))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"screen"},[_c('div',{staticClass:"v-scroll-area fit vrow relative-position right_details_wrap"},[_c('div',{staticClass:"content-wrap fit"},[_c('allBetHeader',{attrs:{"mode":'firstEvent'}}),_vm._v(" "),_c('allBetContent',{attrs:{"mode":'firstEvent'}}),_vm._v(" "),_c('div',{staticClass:"scroll-footer",staticStyle:{"bottom":"0px"}})],1)])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-data-wrap col is-detail details_data_load",staticStyle:{"display":"none","margin-top":"113px"}},[_c('div',{staticClass:"fit"}),_vm._v(" "),_c('div',{staticClass:"column yb-flex-center empty"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-main-content c-content-bg",style:({'width': _vm.widthPX + 'px'}),attrs:{"id":"cMainContent"}},[_c('leftMenu'),_vm._v(" "),_c('centerContent'),_vm._v(" "),((_vm.showRightMenu))?_c('rightMenu'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-main-scroll window-width window-height",style:('height:'+_vm.heightPX+'px !important'),attrs:{"id":"home"}},[_c('div',{staticClass:"main overflow-hidden relative-position",staticStyle:{"width":"100%","min-width":"1440px"}},[_c('searchLeagueTeam'),_vm._v(" "),_c('myheader'),_vm._v(" "),_c('contentsBody'),_vm._v(" "),(_vm.sportMiniBet.toggle && _vm.miniNormal=='1')?_c('minibet'):_vm._e(),_vm._v(" "),(_vm.comboBetExceedLimit)?_c('div',{staticClass:"q-dialog fullscreen no-pointer-events q-dialog--seamless",attrs:{"role":"dialog","aria-modal":"false"}},[_c('div',{staticClass:"q-dialog__inner flex no-pointer-events q-dialog__inner--minimized q-dialog__inner--standard fixed-full flex-center",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"dialog_content q-card"},[_c('div',{staticClass:"q-card__section-dialog q-card__section--vert"},[_vm._m(0),_vm._v(_vm._s(_vm.lang.home['HOME.HIT_MAX_COMBO'])+"\n                    ")])])])]):_vm._e(),_vm._v(" "),(_vm.dialogToggle.show)?_c('div',{staticClass:"q-dialog fullscreen no-pointer-events q-dialog--seamless",attrs:{"role":"dialog","aria-modal":"false"}},[_c('div',{staticClass:"q-dialog__inner flex no-pointer-events q-dialog__inner--minimized q-dialog__inner--standard fixed-full flex-center",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"dialog_content q-card"},[_c('div',{staticClass:"q-card__section-dialog q-card__section--vert"},[_vm._m(1),_vm._v(_vm._s(_vm.dialogToggle.msg)+"\n                    ")])])])]):_vm._e(),_vm._v(" "),(_vm.bettingModeAlert)?_c('div',{staticClass:"fullscreen bet_mode_dialog",staticStyle:{"z-index":"1000 !important"}},[_c('div',{staticClass:"popmask"},[_c('div',[_c('div',{staticClass:"uiimg_bg"},[_c('div',{staticClass:"iselect-title"},[_vm._v(_vm._s(_vm.lang.home['HOME.BETTING_MODE']))]),_vm._v(" "),_c('div',{staticClass:"iselect_area"},[_c('div',{staticClass:"am_ed iselect",class:{ on: _vm.bettingMode==null },attrs:{"href":"#"},on:{"click":function($event){return _vm.betMode(null)}}},[_c('font',{staticClass:"iselect-title-s"},[_vm._v(_vm._s(_vm.lang.home['HOME.STANDARD']))]),_c('br'),_vm._v(" "),_c('img',{staticClass:"iselect-img",attrs:{"src":"","alt":""}})],1),_vm._v(" "),_c('div',{staticClass:"am_i iselect",class:{ on: _vm.bettingMode=='N1' },attrs:{"href":"#"},on:{"click":function($event){return _vm.betMode('N1')}}},[_c('font',{staticClass:"iselect-title-s"},[_vm._v(_vm._s(_vm.lang.sportTableLang['SPORT_TABLE.SIMPLE_SOCCER']))]),_c('br'),_vm._v(" "),_c('img',{staticClass:"iselect-img",attrs:{"src":"","alt":""}})],1)]),_vm._v(" "),_c('div',[_c('div',{staticClass:"sbtn",on:{"click":function($event){return _vm.confirmBetMode()}}},[_vm._v(_vm._s(_vm.lang.home['HOME.GET_STARTED']))])])])])])]):_vm._e(),_vm._v(" "),(_vm.hasRedirect)?_c('div',{staticClass:"fullscreen login-redirect-dialog",staticStyle:{"z-index":"1000px !important","display":"none"}},[_c('div',{staticClass:"dialog"},[_c('div',[_c('div',{staticClass:"dialog-content"},[_c('div',{staticClass:"dialog-title"},[_vm._v(_vm._s(_vm.lang.to_login))]),_vm._v(" "),_c('div',{staticClass:"dialog-message"},[_vm._v(_vm._s(_vm.lang.to_login_message))]),_vm._v(" "),_c('div',{staticClass:"dialog-button"},[_c('button',{staticClass:"btn btn-cancel",attrs:{"type":"submit","tabindex":"3"},on:{"click":function($event){$event.preventDefault();return _vm.redirectDialogAction('cancel')}}},[_vm._v(_vm._s(((_vm.loginRedirectUrl) ? _vm.lang.cancel : _vm.lang.ok)))]),_vm._v(" "),(_vm.loginRedirectUrl)?_c('button',{staticClass:"btn btn-submit",attrs:{"type":"submit","tabindex":"3"},on:{"click":function($event){$event.preventDefault();return _vm.redirectDialogAction('login')}}},[_vm._v(_vm._s(_vm.lang.login))]):_vm._e()])])])])]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-h6"},[_c('img',{attrs:{"src":"assets/images/warn.svg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-h6"},[_c('img',{attrs:{"src":"assets/images/warn.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[266]);


// WEBPACK FOOTER //
// js/home/home.2760e0fecbadea9c1002.js